(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/backend.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
var eventbuilder_1 = _dereq_("./eventbuilder");
var transports_1 = _dereq_("./transports");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventbuilder_1.eventFromException(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = types_1.Severity.Info; }
        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (utils_1.supportsFetch()) {
            return new transports_1.FetchTransport(transportOptions);
        }
        return new transports_1.XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(core_1.BaseBackend));
exports.BrowserBackend = BrowserBackend;

},{"./eventbuilder":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/eventbuilder.js","./transports":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/index.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/client.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var backend_1 = _dereq_("./backend");
var helpers_1 = _dereq_("./helpers");
var integrations_1 = _dereq_("./integrations");
var version_1 = _dereq_("./version");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, backend_1.BrowserBackend, options) || this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = utils_1.getGlobalObject().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: version_1.SDK_VERSION,
                },
            ]), version: version_1.SDK_VERSION });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(integrations_1.Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(core_1.BaseClient));
exports.BrowserClient = BrowserClient;

},{"./backend":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/backend.js","./helpers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js","./integrations":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/index.js","./version":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/version.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/eventbuilder.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
var parsers_1 = _dereq_("./parsers");
var tracekit_1 = _dereq_("./tracekit");
/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    utils_1.addExceptionMechanism(event, {
        handled: true,
        type: 'generic',
    });
    event.level = types_1.Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return utils_1.SyncPromise.resolve(event);
}
exports.eventFromException = eventFromException;
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = types_1.Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return utils_1.SyncPromise.resolve(event);
}
exports.eventFromMessage = eventFromMessage;
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (utils_1.isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
        return event;
    }
    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name, code, and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        utils_1.addExceptionTypeValue(event, message);
        if ('code' in domException) {
            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (utils_1.isError(exception)) {
        // we have a real Error object, do nothing
        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
        return event;
    }
    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
        utils_1.addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
    utils_1.addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
exports.eventFromUnknownInput = eventFromUnknownInput;
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
exports.eventFromString = eventFromString;

},{"./parsers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/parsers.js","./tracekit":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/tracekit.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/exports.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = _dereq_("@sentry/types");
exports.Severity = types_1.Severity;
exports.Status = types_1.Status;
var core_1 = _dereq_("@sentry/core");
exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
exports.addBreadcrumb = core_1.addBreadcrumb;
exports.captureException = core_1.captureException;
exports.captureEvent = core_1.captureEvent;
exports.captureMessage = core_1.captureMessage;
exports.configureScope = core_1.configureScope;
exports.getHubFromCarrier = core_1.getHubFromCarrier;
exports.getCurrentHub = core_1.getCurrentHub;
exports.Hub = core_1.Hub;
exports.makeMain = core_1.makeMain;
exports.Scope = core_1.Scope;
exports.startTransaction = core_1.startTransaction;
exports.setContext = core_1.setContext;
exports.setExtra = core_1.setExtra;
exports.setExtras = core_1.setExtras;
exports.setTag = core_1.setTag;
exports.setTags = core_1.setTags;
exports.setUser = core_1.setUser;
exports.withScope = core_1.withScope;
var client_1 = _dereq_("./client");
exports.BrowserClient = client_1.BrowserClient;
var helpers_1 = _dereq_("./helpers");
exports.injectReportDialog = helpers_1.injectReportDialog;
var eventbuilder_1 = _dereq_("./eventbuilder");
exports.eventFromException = eventbuilder_1.eventFromException;
exports.eventFromMessage = eventbuilder_1.eventFromMessage;
var sdk_1 = _dereq_("./sdk");
exports.defaultIntegrations = sdk_1.defaultIntegrations;
exports.forceLoad = sdk_1.forceLoad;
exports.init = sdk_1.init;
exports.lastEventId = sdk_1.lastEventId;
exports.onLoad = sdk_1.onLoad;
exports.showReportDialog = sdk_1.showReportDialog;
exports.flush = sdk_1.flush;
exports.close = sdk_1.close;
exports.wrap = sdk_1.wrap;
var version_1 = _dereq_("./version");
exports.SDK_NAME = version_1.SDK_NAME;
exports.SDK_VERSION = version_1.SDK_VERSION;

},{"./client":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/client.js","./eventbuilder":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/eventbuilder.js","./helpers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js","./sdk":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/sdk.js","./version":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/version.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
exports.shouldIgnoreOnError = shouldIgnoreOnError;
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
exports.ignoreNextOnError = ignoreNextOnError;
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            core_1.withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = tslib_1.__assign({}, event);
                    if (options.mechanism) {
                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
                    return processedEvent;
                });
                core_1.captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
exports.wrap = wrap;
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        utils_1.logger.error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        utils_1.logger.error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    (document.head || document.body).appendChild(script);
}
exports.injectReportDialog = injectReportDialog;

},{"@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
tslib_1.__exportStar(_dereq_("./exports"), exports);
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var BrowserIntegrations = _dereq_("./integrations");
var Transports = _dereq_("./transports");
exports.Transports = Transports;
var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = utils_1.getGlobalObject();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
exports.Integrations = INTEGRATIONS;

},{"./exports":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/exports.js","./integrations":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/index.js","./transports":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/index.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/breadcrumbs.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */
var core_1 = _dereq_("@sentry/core");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        core_1.getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: utils_1.getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            utils_1.addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            utils_1.addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            utils_1.addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            utils_1.addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            utils_1.addInstrumentationHandler({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
                },
                type: 'history',
            });
        }
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: types_1.Severity.fromString(handlerData.level),
            message: utils_1.safeJoin(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? utils_1.htmlTreeAsString(handlerData.event.target)
                : utils_1.htmlTreeAsString(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        core_1.getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            core_1.getCurrentHub().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code,
                },
                type: 'http',
            }, {
                xhr: handlerData.xhr,
                input: body,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            core_1.getCurrentHub().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: types_1.Severity.Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            core_1.getCurrentHub().addBreadcrumb({
                category: 'fetch',
                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = utils_1.getGlobalObject();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = utils_1.parseUrl(global.location.href);
        var parsedFrom = utils_1.parseUrl(from);
        var parsedTo = utils_1.parseUrl(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        core_1.getCurrentHub().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());
exports.Breadcrumbs = Breadcrumbs;

},{"@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/globalhandlers.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var core_1 = _dereq_("@sentry/core");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
var eventbuilder_1 = _dereq_("../eventbuilder");
var helpers_1 = _dereq_("../helpers");
/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            utils_1.logger.log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            utils_1.logger.log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        utils_1.addInstrumentationHandler({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (data) {
                var error = data.error;
                var currentHub = core_1.getCurrentHub();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = utils_1.isPrimitive(error)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                utils_1.addExceptionMechanism(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        utils_1.addInstrumentationHandler({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = core_1.getCurrentHub();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = utils_1.isPrimitive(error)
                    ? _this._eventFromRejectionWithPrimitive(error)
                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = types_1.Severity.Error;
                utils_1.addExceptionMechanism(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
        var name;
        if (utils_1.isString(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * Create an event from a promise rejection where the `reason` is a primitive.
     *
     * @param reason: The `reason` property of the promise rejection
     * @returns An Event object with an appropriate `exception` value
     */
    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                        value: "Non-Error promise rejection captured with value: " + String(reason),
                    },
                ],
            },
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());
exports.GlobalHandlers = GlobalHandlers;

},{"../eventbuilder":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/eventbuilder.js","../helpers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var globalhandlers_1 = _dereq_("./globalhandlers");
exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
var trycatch_1 = _dereq_("./trycatch");
exports.TryCatch = trycatch_1.TryCatch;
var breadcrumbs_1 = _dereq_("./breadcrumbs");
exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
var linkederrors_1 = _dereq_("./linkederrors");
exports.LinkedErrors = linkederrors_1.LinkedErrors;
var useragent_1 = _dereq_("./useragent");
exports.UserAgent = useragent_1.UserAgent;

},{"./breadcrumbs":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/breadcrumbs.js","./globalhandlers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/globalhandlers.js","./linkederrors":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/linkederrors.js","./trycatch":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/trycatch.js","./useragent":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/useragent.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/linkederrors.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var parsers_1 = _dereq_("../parsers");
var tracekit_1 = _dereq_("../tracekit");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        core_1.addGlobalEventProcessor(function (event, hint) {
            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = tracekit_1.computeStackTrace(error[key]);
        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());
exports.LinkedErrors = LinkedErrors;

},{"../parsers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/parsers.js","../tracekit":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/tracekit.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/trycatch.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var utils_1 = _dereq_("@sentry/utils");
var helpers_1 = _dereq_("../helpers");
var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = utils_1.getGlobalObject();
        if (this._options.setTimeout) {
            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = helpers_1.wrap(originalCallback, {
                mechanism: {
                    data: { function: utils_1.getFunctionName(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, helpers_1.wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: utils_1.getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = utils_1.getGlobalObject();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        utils_1.fill(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: utils_1.getFunctionName(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                helpers_1.wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: utils_1.getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (eventName, fn, options) {
                var _a;
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */
                var wrappedEventHandler = fn;
                try {
                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
                    if (originalEventHandler) {
                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                    }
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    utils_1.fill(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: utils_1.getFunctionName(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return helpers_1.wrap(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());
exports.TryCatch = TryCatch;

},{"../helpers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/useragent.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var global = utils_1.getGlobalObject();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        core_1.addGlobalEventProcessor(function (event) {
            var _a, _b, _c;
            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());
exports.UserAgent = UserAgent;

},{"@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/parsers.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = _dereq_("@sentry/utils");
var tracekit_1 = _dereq_("./tracekit");
var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
exports.exceptionFromStacktrace = exceptionFromStacktrace;
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
                },
            ],
        },
        extra: {
            __serialized__: utils_1.normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
exports.eventFromPlainObject = eventFromPlainObject;
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
exports.eventFromStacktrace = eventFromStacktrace;
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
exports.prepareFramesForEvent = prepareFramesForEvent;

},{"./tracekit":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/tracekit.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/sdk.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var client_1 = _dereq_("./client");
var helpers_1 = _dereq_("./helpers");
var integrations_1 = _dereq_("./integrations");
exports.defaultIntegrations = [
    new core_1.Integrations.InboundFilters(),
    new core_1.Integrations.FunctionToString(),
    new integrations_1.TryCatch(),
    new integrations_1.Breadcrumbs(),
    new integrations_1.GlobalHandlers(),
    new integrations_1.LinkedErrors(),
    new integrations_1.UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = exports.defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = utils_1.getGlobalObject();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = false;
    }
    core_1.initAndBind(client_1.BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
exports.init = init;
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = core_1.getCurrentHub().lastEventId();
    }
    var client = core_1.getCurrentHub().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
exports.showReportDialog = showReportDialog;
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return core_1.getCurrentHub().lastEventId();
}
exports.lastEventId = lastEventId;
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
exports.forceLoad = forceLoad;
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
exports.onLoad = onLoad;
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = core_1.getCurrentHub().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return utils_1.SyncPromise.reject(false);
}
exports.flush = flush;
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = core_1.getCurrentHub().getClient();
    if (client) {
        return client.close(timeout);
    }
    return utils_1.SyncPromise.reject(false);
}
exports.close = close;
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return helpers_1.wrap(fn)();
}
exports.wrap = wrap;
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = utils_1.getGlobalObject();
    var hub = core_1.getCurrentHub();
    /**
     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
     * but, as always, it's not available in the IE10-11. Thanks IE.
     */
    var loadResolved = document.readyState === 'complete';
    var fcpResolved = false;
    var possiblyEndSession = function () {
        if (fcpResolved && loadResolved) {
            hub.endSession();
        }
    };
    var resolveWindowLoaded = function () {
        loadResolved = true;
        possiblyEndSession();
        window.removeEventListener('load', resolveWindowLoaded);
    };
    hub.startSession();
    if (!loadResolved) {
        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
        // attach and then detach it once completed.
        window.addEventListener('load', resolveWindowLoaded);
    }
    try {
        var po = new PerformanceObserver(function (entryList, po) {
            entryList.getEntries().forEach(function (entry) {
                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
                    po.disconnect();
                    fcpResolved = true;
                    possiblyEndSession();
                }
            });
        });
        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
        // so we do it below here.
        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
        document.addEventListener('visibilitychange', function (event) {
            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
        }, { once: true });
        po.observe({
            type: 'paint',
            buffered: true,
        });
    }
    catch (e) {
        fcpResolved = true;
        possiblyEndSession();
    }
}

},{"./client":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/client.js","./helpers":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/helpers.js","./integrations":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/integrations/index.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/tracekit.js":[function(_dereq_,module,exports){
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            popSize = ex.framesToPop;
        }
        else if (reactMinifiedRegexp.test(ex.message)) {
            popSize = 1;
        }
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
exports.computeStackTrace = computeStackTrace;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}

},{"tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/base.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new utils_1.PromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._api = new core_1.API(this.options.dsn);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = types_1.Status.fromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited)
            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
        if (status === types_1.Status.Success) {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (category) {
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (category) {
        return this._disabledUntil(category) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());
exports.BaseTransport = BaseTransport;

},{"@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/fetch.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var base_1 = _dereq_("./base");
var global = utils_1.getGlobalObject();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    tslib_1.__extends(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendSession = function (session) {
        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
            global
                .fetch(sentryRequest.url, options)
                .then(function (response) {
                var headers = {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                };
                _this._handleResponse({
                    requestType: sentryRequest.type,
                    response: response,
                    headers: headers,
                    resolve: resolve,
                    reject: reject,
                });
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(base_1.BaseTransport));
exports.FetchTransport = FetchTransport;

},{"./base":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/base.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = _dereq_("./base");
exports.BaseTransport = base_1.BaseTransport;
var fetch_1 = _dereq_("./fetch");
exports.FetchTransport = fetch_1.FetchTransport;
var xhr_1 = _dereq_("./xhr");
exports.XHRTransport = xhr_1.XHRTransport;

},{"./base":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/base.js","./fetch":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/fetch.js","./xhr":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/xhr.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/xhr.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var core_1 = _dereq_("@sentry/core");
var utils_1 = _dereq_("@sentry/utils");
var base_1 = _dereq_("./base");
/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    tslib_1.__extends(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendSession = function (session) {
        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    var headers = {
                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': request.getResponseHeader('Retry-After'),
                    };
                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                }
            };
            request.open('POST', sentryRequest.url);
            for (var header in _this.options.headers) {
                if (_this.options.headers.hasOwnProperty(header)) {
                    request.setRequestHeader(header, _this.options.headers[header]);
                }
            }
            request.send(sentryRequest.body);
        }));
    };
    return XHRTransport;
}(base_1.BaseTransport));
exports.XHRTransport = XHRTransport;

},{"./base":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/transports/base.js","@sentry/core":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/version.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_NAME = 'sentry.javascript.browser';
exports.SDK_VERSION = '5.30.0';

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js":[function(_dereq_,module,exports){
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global global, define, System, Reflect, Promise */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __metadata;
var __awaiter;
var __generator;
var __exportStar;
var __values;
var __read;
var __spread;
var __spreadArrays;
var __await;
var __asyncGenerator;
var __asyncDelegator;
var __asyncValues;
var __makeTemplateObject;
var __importStar;
var __importDefault;
var __classPrivateFieldGet;
var __classPrivateFieldSet;
var __createBinding;
(function (factory) {
    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
    if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function (exports) { factory(createExporter(root, createExporter(exports))); });
    }
    else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
    }
    else {
        factory(createExporter(root));
    }
    function createExporter(exports, previous) {
        if (exports !== root) {
            if (typeof Object.create === "function") {
                Object.defineProperty(exports, "__esModule", { value: true });
            }
            else {
                exports.__esModule = true;
            }
        }
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

    __extends = function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    __createBinding = function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    };

    __exportStar = function (m, exports) {
        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
    };

    __values = function (o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };

    __read = function (o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    };

    __spread = function () {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    };

    __spreadArrays = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    __await = function (v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    };

    __asyncGenerator = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    };

    __asyncDelegator = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    };

    __asyncValues = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    };

    __makeTemplateObject = function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    __importStar = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result["default"] = mod;
        return result;
    };

    __importDefault = function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };

    __classPrivateFieldGet = function (receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    };

    __classPrivateFieldSet = function (receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
});

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/api.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = _dereq_("@sentry/utils");
var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new utils_1.Dsn(dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'dsn') {
                continue;
            }
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        return utils_1.urlEncode(auth);
    };
    return API;
}());
exports.API = API;

},{"@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/basebackend.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = _dereq_("@sentry/utils");
var noop_1 = _dereq_("./transports/noop");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            utils_1.logger.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            utils_1.logger.error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        this._transport.sendSession(session).then(null, function (reason) {
            utils_1.logger.error("Error while sending session: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new noop_1.NoopTransport();
    };
    return BaseBackend;
}());
exports.BaseBackend = BaseBackend;

},{"./transports/noop":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/transports/noop.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/baseclient.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
/* eslint-disable max-lines */
var hub_1 = _dereq_("@sentry/hub");
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
var integration_1 = _dereq_("./integration");
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of call being processed */
        this._processing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new utils_1.Dsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = utils_1.isPrimitive(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!session.release) {
            utils_1.logger.warn('Discarded session because of missing release');
        }
        else {
            this._sendSession(session);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (ready) {
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled()) {
            this._integrations = integration_1.setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var userAgent;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var user = event.user;
        if (!session.userAgent) {
            var headers = event.request ? event.request.headers : {};
            for (var key in headers) {
                if (key.toLowerCase() === 'user-agent') {
                    userAgent = headers[key];
                    break;
                }
            }
        }
        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new utils_1.SyncPromise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._processing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = utils_1.SyncPromise.resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
                data: utils_1.normalize(b.data, depth),
            }))); }),
        })), (event.user && {
            user: utils_1.normalize(event.user, depth),
        })), (event.contexts && {
            contexts: utils_1.normalize(event.contexts, depth),
        })), (event.extra && {
            extra: utils_1.normalize(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = utils_1.truncate(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = utils_1.truncate(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = utils_1.truncate(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            utils_1.logger.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                throw new utils_1.SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            if (typeof beforeSendResult === 'undefined') {
                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
            }
            else if (utils_1.isThenable(beforeSendResult)) {
                return beforeSendResult.then(function (event) { return event; }, function (e) {
                    throw new utils_1.SentryError("beforeSend rejected with " + e);
                });
            }
            return beforeSendResult;
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof utils_1.SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._processing += 1;
        promise.then(function (value) {
            _this._processing -= 1;
            return value;
        }, function (reason) {
            _this._processing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());
exports.BaseClient = BaseClient;

},{"./integration":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integration.js","@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var minimal_1 = _dereq_("@sentry/minimal");
exports.addBreadcrumb = minimal_1.addBreadcrumb;
exports.captureException = minimal_1.captureException;
exports.captureEvent = minimal_1.captureEvent;
exports.captureMessage = minimal_1.captureMessage;
exports.configureScope = minimal_1.configureScope;
exports.startTransaction = minimal_1.startTransaction;
exports.setContext = minimal_1.setContext;
exports.setExtra = minimal_1.setExtra;
exports.setExtras = minimal_1.setExtras;
exports.setTag = minimal_1.setTag;
exports.setTags = minimal_1.setTags;
exports.setUser = minimal_1.setUser;
exports.withScope = minimal_1.withScope;
var hub_1 = _dereq_("@sentry/hub");
exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
exports.getCurrentHub = hub_1.getCurrentHub;
exports.getHubFromCarrier = hub_1.getHubFromCarrier;
exports.Hub = hub_1.Hub;
exports.makeMain = hub_1.makeMain;
exports.Scope = hub_1.Scope;
var api_1 = _dereq_("./api");
exports.API = api_1.API;
var baseclient_1 = _dereq_("./baseclient");
exports.BaseClient = baseclient_1.BaseClient;
var basebackend_1 = _dereq_("./basebackend");
exports.BaseBackend = basebackend_1.BaseBackend;
var request_1 = _dereq_("./request");
exports.eventToSentryRequest = request_1.eventToSentryRequest;
exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
var sdk_1 = _dereq_("./sdk");
exports.initAndBind = sdk_1.initAndBind;
var noop_1 = _dereq_("./transports/noop");
exports.NoopTransport = noop_1.NoopTransport;
var Integrations = _dereq_("./integrations");
exports.Integrations = Integrations;

},{"./api":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/api.js","./basebackend":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/basebackend.js","./baseclient":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/baseclient.js","./integrations":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/index.js","./request":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/request.js","./sdk":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/sdk.js","./transports/noop":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/transports/noop.js","@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","@sentry/minimal":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/minimal/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integration.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var hub_1 = _dereq_("@sentry/hub");
var utils_1 = _dereq_("@sentry/utils");
exports.installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = tslib_1.__spread(defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
exports.getIntegrationsToSetup = getIntegrationsToSetup;
/** Setup given integration */
function setupIntegration(integration) {
    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
    exports.installedIntegrations.push(integration.name);
    utils_1.logger.log("Integration installed: " + integration.name);
}
exports.setupIntegration = setupIntegration;
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
exports.setupIntegrations = setupIntegrations;

},{"@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/functiontostring.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());
exports.FunctionToString = FunctionToString;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/inboundfilters.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var hub_1 = _dereq_("@sentry/hub");
var utils_1 = _dereq_("@sentry/utils");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        hub_1.addGlobalEventProcessor(function (event) {
            var hub = hub_1.getCurrentHub();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());
exports.InboundFilters = InboundFilters;

},{"@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var functiontostring_1 = _dereq_("./functiontostring");
exports.FunctionToString = functiontostring_1.FunctionToString;
var inboundfilters_1 = _dereq_("./inboundfilters");
exports.InboundFilters = inboundfilters_1.InboundFilters;

},{"./functiontostring":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/functiontostring.js","./inboundfilters":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/integrations/inboundfilters.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/request.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
/** Creates a SentryRequest from an event. */
function sessionToSentryRequest(session, api) {
    var envelopeHeaders = JSON.stringify({
        sent_at: new Date().toISOString(),
    });
    var itemHeaders = JSON.stringify({
        type: 'session',
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: 'session',
        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
    };
}
exports.sessionToSentryRequest = sessionToSentryRequest;
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    // since JS has no Object.prototype.pop()
    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
    event.tags = otherTags;
    var useEnvelope = event.type === 'transaction';
    var req = {
        body: JSON.stringify(event),
        type: event.type || 'event',
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            sent_at: new Date().toISOString(),
        });
        var itemHeaders = JSON.stringify({
            type: event.type,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
exports.eventToSentryRequest = eventToSentryRequest;

},{"tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/sdk.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var hub_1 = _dereq_("@sentry/hub");
var utils_1 = _dereq_("@sentry/utils");
/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        utils_1.logger.enable();
    }
    var hub = hub_1.getCurrentHub();
    var client = new clientClass(options);
    hub.bindClient(client);
}
exports.initAndBind = initAndBind;

},{"@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/dist/transports/noop.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return utils_1.SyncPromise.resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: types_1.Status.Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return utils_1.SyncPromise.resolve(true);
    };
    return NoopTransport;
}());
exports.NoopTransport = NoopTransport;

},{"@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/core/node_modules/tslib/tslib.js":[function(_dereq_,module,exports){
arguments[4]["/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"][0].apply(exports,arguments)
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/hub.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var utils_1 = _dereq_("@sentry/utils");
var scope_1 = _dereq_("./scope");
var session_1 = _dereq_("./session");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
exports.API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new scope_1.Scope(); }
        if (_version === void 0) { _version = exports.API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = scope_1.Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = utils_1.uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = utils_1.uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = utils_1.uuid4());
        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = utils_1.dateTimestampInSeconds();
        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        // End existing session if there's one
        this.endSession();
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), context));
        if (scope) {
            scope.setSession(session);
        }
        return session;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            session.close();
            if (client && client.captureSession) {
                client.captureSession(session);
            }
            scope.setSession();
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());
exports.Hub = Hub;
/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = utils_1.getGlobalObject();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
exports.getMainCarrier = getMainCarrier;
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
exports.makeMain = makeMain;
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (utils_1.isNodeEnv()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
exports.getCurrentHub = getCurrentHub;
/**
 * Returns the active domain, if one exists
 *
 * @returns The domain, or undefined if there is no active domain
 */
function getActiveDomain() {
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
exports.getActiveDomain = getActiveDomain;
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var activeDomain = getActiveDomain();
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
exports.getHubFromCarrier = getHubFromCarrier;
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
exports.setHubOnCarrier = setHubOnCarrier;

},{"./scope":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/scope.js","./session":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/session.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var scope_1 = _dereq_("./scope");
exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
exports.Scope = scope_1.Scope;
var session_1 = _dereq_("./session");
exports.Session = session_1.Session;
var hub_1 = _dereq_("./hub");
exports.getActiveDomain = hub_1.getActiveDomain;
exports.getCurrentHub = hub_1.getCurrentHub;
exports.getHubFromCarrier = hub_1.getHubFromCarrier;
exports.getMainCarrier = hub_1.getMainCarrier;
exports.Hub = hub_1.Hub;
exports.makeMain = hub_1.makeMain;
exports.setHubOnCarrier = hub_1.setHubOnCarrier;

},{"./hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/hub.js","./scope":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/scope.js","./session":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/session.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/scope.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var utils_1 = _dereq_("@sentry/utils");
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
            newScope._tags = tslib_1.__assign({}, scope._tags);
            newScope._extra = tslib_1.__assign({}, scope._extra);
            newScope._contexts = tslib_1.__assign({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        }
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
        }
        else if (utils_1.isPlainObject(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        var _a;
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
            if (transactionName) {
                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new utils_1.SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(tslib_1.__assign({}, event), hint);
                if (utils_1.isThenable(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());
exports.Scope = Scope;
/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = utils_1.getGlobalObject();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
exports.addGlobalEventProcessor = addGlobalEventProcessor;

},{"@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/session.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = _dereq_("@sentry/types");
var utils_1 = _dereq_("@sentry/utils");
/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = utils_1.uuid4();
        this.timestamp = Date.now();
        this.started = Date.now();
        this.duration = 0;
        this.status = types_1.SessionStatus.Ok;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || Date.now();
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
        }
        if (context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            this.duration = this.timestamp - this.started;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === types_1.SessionStatus.Ok) {
            this.update({ status: types_1.SessionStatus.Exited });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return utils_1.dropUndefinedKeys({
            sid: "" + this.sid,
            init: true,
            started: new Date(this.started).toISOString(),
            timestamp: new Date(this.timestamp).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: utils_1.dropUndefinedKeys({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            }),
        });
    };
    return Session;
}());
exports.Session = Session;

},{"@sentry/types":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js","@sentry/utils":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/node_modules/tslib/tslib.js":[function(_dereq_,module,exports){
arguments[4]["/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"][0].apply(exports,arguments)
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/minimal/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var hub_1 = _dereq_("@sentry/hub");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = hub_1.getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, tslib_1.__spread(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
exports.captureException = captureException;
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
}
exports.captureMessage = captureMessage;
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
exports.captureEvent = captureEvent;
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
exports.configureScope = configureScope;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
exports.addBreadcrumb = addBreadcrumb;
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
exports.setContext = setContext;
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
exports.setExtras = setExtras;
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
exports.setTags = setTags;
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
exports.setExtra = setExtra;
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
exports.setTag = setTag;
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
exports.setUser = setUser;
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
exports.withScope = withScope;
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
}
exports._callOnClient = _callOnClient;
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
}
exports.startTransaction = startTransaction;

},{"@sentry/hub":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/hub/dist/index.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/minimal/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/minimal/node_modules/tslib/tslib.js":[function(_dereq_,module,exports){
arguments[4]["/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"][0].apply(exports,arguments)
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var loglevel_1 = _dereq_("./loglevel");
exports.LogLevel = loglevel_1.LogLevel;
var session_1 = _dereq_("./session");
exports.SessionStatus = session_1.SessionStatus;
var severity_1 = _dereq_("./severity");
exports.Severity = severity_1.Severity;
var status_1 = _dereq_("./status");
exports.Status = status_1.Status;
var transaction_1 = _dereq_("./transaction");
exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;

},{"./loglevel":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/loglevel.js","./session":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/session.js","./severity":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/severity.js","./status":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/status.js","./transaction":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/transaction.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/loglevel.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/session.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Session Status
 */
var SessionStatus;
(function (SessionStatus) {
    /** JSDoc */
    SessionStatus["Ok"] = "ok";
    /** JSDoc */
    SessionStatus["Exited"] = "exited";
    /** JSDoc */
    SessionStatus["Crashed"] = "crashed";
    /** JSDoc */
    SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/severity.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/** JSDoc */
// eslint-disable-next-line import/export
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity = exports.Severity || (exports.Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity = exports.Severity || (exports.Severity = {}));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/status.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/** The status of an event. */
// eslint-disable-next-line import/export
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status = exports.Status || (exports.Status = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status = exports.Status || (exports.Status = {}));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/types/dist/transaction.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var TransactionSamplingMethod;
(function (TransactionSamplingMethod) {
    TransactionSamplingMethod["Explicit"] = "explicitly_set";
    TransactionSamplingMethod["Sampler"] = "client_sampler";
    TransactionSamplingMethod["Rate"] = "client_rate";
    TransactionSamplingMethod["Inheritance"] = "inheritance";
})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/async.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
exports.forget = forget;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/browser.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = _dereq_("./is");
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
exports.htmlTreeAsString = htmlTreeAsString;
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && is_1.isString(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}

},{"./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/dsn.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var error_1 = _dereq_("./error");
/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new error_1.SentryError(ERROR_MESSAGE);
        }
        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());
exports.Dsn = Dsn;

},{"./error":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/error.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/error.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var polyfill_1 = _dereq_("./polyfill");
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    tslib_1.__extends(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));
exports.SentryError = SentryError;

},{"./polyfill":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/polyfill.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/index.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
tslib_1.__exportStar(_dereq_("./async"), exports);
tslib_1.__exportStar(_dereq_("./browser"), exports);
tslib_1.__exportStar(_dereq_("./dsn"), exports);
tslib_1.__exportStar(_dereq_("./error"), exports);
tslib_1.__exportStar(_dereq_("./instrument"), exports);
tslib_1.__exportStar(_dereq_("./is"), exports);
tslib_1.__exportStar(_dereq_("./logger"), exports);
tslib_1.__exportStar(_dereq_("./memo"), exports);
tslib_1.__exportStar(_dereq_("./misc"), exports);
tslib_1.__exportStar(_dereq_("./node"), exports);
tslib_1.__exportStar(_dereq_("./object"), exports);
tslib_1.__exportStar(_dereq_("./path"), exports);
tslib_1.__exportStar(_dereq_("./promisebuffer"), exports);
tslib_1.__exportStar(_dereq_("./stacktrace"), exports);
tslib_1.__exportStar(_dereq_("./string"), exports);
tslib_1.__exportStar(_dereq_("./supports"), exports);
tslib_1.__exportStar(_dereq_("./syncpromise"), exports);
tslib_1.__exportStar(_dereq_("./time"), exports);

},{"./async":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/async.js","./browser":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/browser.js","./dsn":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/dsn.js","./error":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/error.js","./instrument":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/instrument.js","./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js","./logger":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/logger.js","./memo":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/memo.js","./misc":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js","./node":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/node.js","./object":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/object.js","./path":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/path.js","./promisebuffer":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/promisebuffer.js","./stacktrace":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/stacktrace.js","./string":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/string.js","./supports":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/supports.js","./syncpromise":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/syncpromise.js","./time":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/time.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/instrument.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var is_1 = _dereq_("./is");
var logger_1 = _dereq_("./logger");
var misc_1 = _dereq_("./misc");
var object_1 = _dereq_("./object");
var stacktrace_1 = _dereq_("./stacktrace");
var supports_1 = _dereq_("./supports");
var global = misc_1.getGlobalObject();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            logger_1.logger.warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
exports.addInstrumentationHandler = addInstrumentationHandler;
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        object_1.fill(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supports_1.supportsNativeFetch()) {
        return;
    }
    object_1.fill(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    object_1.fill(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
                                xhr.__sentry_xhr__.body = args_1[0];
                            }
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                object_1.fill(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    object_1.fill(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            requestKeys.push(this);
            requestValues.push(args);
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supports_1.supportsHistory()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    object_1.fill(global.history, 'pushState', historyReplacementFunction);
    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
        object_1.fill(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                }
                else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        object_1.fill(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        }
        else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}

},{"./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js","./logger":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/logger.js","./misc":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js","./object":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/object.js","./stacktrace":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/stacktrace.js","./supports":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/supports.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js":[function(_dereq_,module,exports){
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
exports.isError = isError;
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
exports.isErrorEvent = isErrorEvent;
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
exports.isDOMError = isDOMError;
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
exports.isDOMException = isDOMException;
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
exports.isString = isString;
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
exports.isPrimitive = isPrimitive;
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
exports.isPlainObject = isPlainObject;
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
exports.isEvent = isEvent;
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
exports.isElement = isElement;
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
exports.isThenable = isThenable;
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
exports.isSyntheticEvent = isSyntheticEvent;
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
exports.isInstanceOf = isInstanceOf;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/logger.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var misc_1 = _dereq_("./misc");
// TODO: Implement different loggers for different environments
var global = misc_1.getGlobalObject();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        misc_1.consoleSandbox(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
exports.logger = logger;

},{"./misc":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/memo.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());
exports.Memo = Memo;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var node_1 = _dereq_("./node");
var string_1 = _dereq_("./string");
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (node_1.isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
exports.getGlobalObject = getGlobalObject;
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.uuid4 = uuid4;
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
exports.parseUrl = parseUrl;
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
exports.getEventDescription = getEventDescription;
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
exports.consoleSandbox = consoleSandbox;
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
exports.addExceptionTypeValue = addExceptionTypeValue;
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
exports.addExceptionMechanism = addExceptionMechanism;
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
exports.getLocationHref = getLocationHref;
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
exports.parseSemver = parseSemver;
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
exports.parseRetryAfterHeader = parseRetryAfterHeader;
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return string_1.snipLine(line, 0); });
    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return string_1.snipLine(line, 0); });
}
exports.addContextToFrame = addContextToFrame;
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;

},{"./node":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/node.js","./string":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/string.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/node.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = _dereq_("./is");
var object_1 = _dereq_("./object");
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
exports.isNodeEnv = isNodeEnv;
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
exports.dynamicRequire = dynamicRequire;
/** Default request keys that'll be used to extract data from the request */
var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
/**
 * Normalizes data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
 * provided.
 * @returns An object containing normalized request data
 */
function extractNodeRequestData(req, keys) {
    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
    // make sure we can safely use dynamicRequire below
    if (!isNodeEnv()) {
        throw new Error("Can't get node request data outside of a node environment");
    }
    var requestData = {};
    // headers:
    //   node, express: req.headers
    //   koa: req.header
    var headers = (req.headers || req.header || {});
    // method:
    //   node, express, koa: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node: req.headers.host
    var host = req.hostname || req.host || headers.host || '<no host>';
    // protocol:
    //   node: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
        ? 'https'
        : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa: req.url
    var originalUrl = (req.originalUrl || req.url || '');
    // absolute url
    var absoluteUrl = protocol + "://" + host + originalUrl;
    keys.forEach(function (key) {
        switch (key) {
            case 'headers':
                requestData.headers = headers;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') {
                    break;
                }
                // body data:
                //   node, express, koa: req.body
                if (req.body !== undefined) {
                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
                }
                break;
            default:
                if ({}.hasOwnProperty.call(req, key)) {
                    requestData[key] = req[key];
                }
        }
    });
    return requestData;
}
exports.extractNodeRequestData = extractNodeRequestData;

},{"./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js","./object":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/object.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/object.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = _dereq_("tslib");
var browser_1 = _dereq_("./browser");
var is_1 = _dereq_("./is");
var memo_1 = _dereq_("./memo");
var stacktrace_1 = _dereq_("./stacktrace");
var string_1 = _dereq_("./string");
/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
 * will be substituted in for `source[name]`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
exports.fill = fill;
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
exports.urlEncode = urlEncode;
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if (is_1.isError(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (is_1.isEvent(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = is_1.isElement(event_1.target)
                ? browser_1.htmlTreeAsString(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = is_1.isElement(event_1.currentTarget)
                ? browser_1.htmlTreeAsString(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
exports.normalizeToSize = normalizeToSize;
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return is_1.isPrimitive(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (is_1.isSyntheticEvent(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new memo_1.Memo(); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (is_1.isPrimitive(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
exports.walk = walk;
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
exports.normalize = normalize;
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return string_1.truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return string_1.truncate(serialized, maxLength);
    }
    return '';
}
exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (is_1.isPlainObject(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
exports.dropUndefinedKeys = dropUndefinedKeys;

},{"./browser":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/browser.js","./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js","./memo":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/memo.js","./stacktrace":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/stacktrace.js","./string":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/string.js","tslib":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/path.js":[function(_dereq_,module,exports){
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
Object.defineProperty(exports, "__esModule", { value: true });
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        // eslint-disable-next-line no-plusplus
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
exports.resolve = resolve;
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    /* eslint-disable no-param-reassign */
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    /* eslint-enable no-param-reassign */
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
exports.relative = relative;
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
exports.normalizePath = normalizePath;
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
exports.isAbsolute = isAbsolute;
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
exports.join = join;
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
exports.dirname = dirname;
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
exports.basename = basename;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/polyfill.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/promisebuffer.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = _dereq_("./error");
var syncpromise_1 = _dereq_("./syncpromise");
/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new syncpromise_1.SyncPromise(function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            syncpromise_1.SyncPromise.all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());
exports.PromiseBuffer = PromiseBuffer;

},{"./error":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/error.js","./syncpromise":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/syncpromise.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/stacktrace.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
exports.getFunctionName = getFunctionName;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/string.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var is_1 = _dereq_("./is");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
exports.truncate = truncate;
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        // eslint-disable-next-line no-param-reassign
        colno = ll;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
exports.snipLine = snipLine;
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
exports.safeJoin = safeJoin;
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!is_1.isString(value)) {
        return false;
    }
    if (is_1.isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
exports.isMatchingPattern = isMatchingPattern;

},{"./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/supports.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = _dereq_("./logger");
var misc_1 = _dereq_("./misc");
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsErrorEvent = supportsErrorEvent;
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsDOMError = supportsDOMError;
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsDOMException = supportsDOMException;
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in misc_1.getGlobalObject())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsFetch = supportsFetch;
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = misc_1.getGlobalObject();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
exports.supportsNativeFetch = supportsNativeFetch;
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in misc_1.getGlobalObject();
}
exports.supportsReportingObserver = supportsReportingObserver;
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.supportsReferrerPolicy = supportsReferrerPolicy;
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = misc_1.getGlobalObject();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
exports.supportsHistory = supportsHistory;

},{"./logger":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/logger.js","./misc":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/syncpromise.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
var is_1 = _dereq_("./is");
/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (is_1.isThenable(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    return SyncPromise;
}());
exports.SyncPromise = SyncPromise;

},{"./is":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/is.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/time.js":[function(_dereq_,module,exports){
Object.defineProperty(exports, "__esModule", { value: true });
var misc_1 = _dereq_("./misc");
var node_1 = _dereq_("./node");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = misc_1.getGlobalObject().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
exports.timestampWithMs = exports.timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
exports.usingPerformanceAPI = platformPerformance !== undefined;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
exports.browserPerformanceTimeOrigin = (function () {
    var performance = misc_1.getGlobalObject().performance;
    if (!performance) {
        return undefined;
    }
    if (performance.timeOrigin) {
        return performance.timeOrigin;
    }
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    return (performance.timing && performance.timing.navigationStart) || Date.now();
})();

},{"./misc":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/misc.js","./node":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/dist/node.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/utils/node_modules/tslib/tslib.js":[function(_dereq_,module,exports){
arguments[4]["/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/node_modules/tslib/tslib.js"][0].apply(exports,arguments)
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-carousel/dist/angular-carousel.js":[function(_dereq_,module,exports){
/**
 * Angular Carousel - Mobile friendly touch carousel for AngularJS
 * @version v1.0.2 - 2017-08-03
 * @link http://revolunet.github.com/angular-carousel
 * @author Julien Bouquillon <julien@revolunet.com>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
/*global angular */

/*
Angular touch carousel with CSS GPU accel and slide buffering
http://github.com/revolunet/angular-carousel

*/

angular.module('angular-carousel', [
    'ngTouch',
    'angular-carousel.shifty'
]);

angular.module('angular-carousel')

.directive('rnCarouselAutoSlide', ['$interval', function($interval) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
        var stopAutoPlay = function() {
            if (scope.autoSlider) {
                $interval.cancel(scope.autoSlider);
                scope.autoSlider = null;
            }
        };
        var restartTimer = function() {
            scope.autoSlide();
        };

        scope.$watch('carouselIndex', restartTimer);

        if (attrs.hasOwnProperty('rnCarouselPauseOnHover') && attrs.rnCarouselPauseOnHover !== 'false'){
            element.on('mouseenter', stopAutoPlay);
            element.on('mouseleave', restartTimer);
        }

        scope.$on('$destroy', function(){
            stopAutoPlay();
            element.off('mouseenter', stopAutoPlay);
            element.off('mouseleave', restartTimer);
        });
    }
  };
}]);

angular.module('angular-carousel')

.directive('rnCarouselIndicators', ['$parse', function($parse) {
  return {
    restrict: 'A',
    scope: {
      slides: '=',
      index: '=rnCarouselIndex'
    },
    templateUrl: 'carousel-indicators.html',
    link: function(scope, iElement, iAttributes) {
      var indexModel = $parse(iAttributes.rnCarouselIndex);
      scope.goToSlide = function(index) {
        indexModel.assign(scope.$parent.$parent, index);
      };
    }
  };
}]);

angular.module('angular-carousel').run(['$templateCache', function($templateCache) {
  $templateCache.put('carousel-indicators.html',
      '<div class="rn-carousel-indicator">\n' +
        '<span ng-repeat="slide in slides" ng-class="{active: $index==index}" ng-click="goToSlide($index)">●</span>' +
      '</div>'
  );
}]);

(function() {
    "use strict";

    angular.module('angular-carousel')

    .service('DeviceCapabilities', function() {

        // TODO: merge in a single function

        // detect supported CSS property
        function detectTransformProperty() {
            var transformProperty = 'transform',
                safariPropertyHack = 'webkitTransform';
            if (typeof document.body.style[transformProperty] !== 'undefined') {

                ['webkit', 'moz', 'o', 'ms'].every(function (prefix) {
                    var e = '-' + prefix + '-transform';
                    if (typeof document.body.style[e] !== 'undefined') {
                        transformProperty = e;
                        return false;
                    }
                    return true;
                });
            } else if (typeof document.body.style[safariPropertyHack] !== 'undefined') {
                transformProperty = '-webkit-transform';
            } else {
                transformProperty = undefined;
            }
            return transformProperty;
        }

        //Detect support of translate3d
        function detect3dSupport() {
            var el = document.createElement('p'),
                has3d,
                transforms = {
                    'webkitTransform': '-webkit-transform',
                    'msTransform': '-ms-transform',
                    'transform': 'transform'
                };
            // Add it to the body to get the computed style
            document.body.insertBefore(el, null);
            for (var t in transforms) {
                if (el.style[t] !== undefined) {
                    el.style[t] = 'translate3d(1px,1px,1px)';
                    has3d = window.getComputedStyle(el).getPropertyValue(transforms[t]);
                }
            }
            document.body.removeChild(el);
            return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
        }

        return {
            has3d: detect3dSupport(),
            transformProperty: detectTransformProperty()
        };

    })

    .service('computeCarouselSlideStyle', ["DeviceCapabilities", function(DeviceCapabilities) {
        // compute transition transform properties for a given slide and global offset
        return function(slideIndex, offset, transitionType) {
            var style = {
                    display: 'inline-block'
                },
                opacity,
                absoluteLeft = (slideIndex * 100) + offset,
                slideTransformValue = DeviceCapabilities.has3d ? 'translate3d(' + absoluteLeft + '%, 0, 0)' : 'translate3d(' + absoluteLeft + '%, 0)',
                distance = ((100 - Math.abs(absoluteLeft)) / 100);

            if (!DeviceCapabilities.transformProperty) {
                // fallback to default slide if transformProperty is not available
                style['margin-left'] = absoluteLeft + '%';
            } else {
                if (transitionType == 'fadeAndSlide') {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                    opacity = 0;
                    if (Math.abs(absoluteLeft) < 100) {
                        opacity = 0.3 + distance * 0.7;
                    }
                    style.opacity = opacity;
                } else if (transitionType == 'hexagon') {
                    var transformFrom = 100,
                        degrees = 0,
                        maxDegrees = 60 * (distance - 1);

                    transformFrom = offset < (slideIndex * -100) ? 100 : 0;
                    degrees = offset < (slideIndex * -100) ? maxDegrees : -maxDegrees;
                    style[DeviceCapabilities.transformProperty] = slideTransformValue + ' ' + 'rotateY(' + degrees + 'deg)';
                    style[DeviceCapabilities.transformProperty + '-origin'] = transformFrom + '% 50%';
                } else if (transitionType == 'zoom') {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                    var scale = 1;
                    if (Math.abs(absoluteLeft) < 100) {
                        scale = 1 + ((1 - distance) * 2);
                    }
                    style[DeviceCapabilities.transformProperty] += ' scale(' + scale + ')';
                    style[DeviceCapabilities.transformProperty + '-origin'] = '50% 50%';
                    opacity = 0;
                    if (Math.abs(absoluteLeft) < 100) {
                        opacity = 0.3 + distance * 0.7;
                    }
                    style.opacity = opacity;
                } else {
                    style[DeviceCapabilities.transformProperty] = slideTransformValue;
                }
            }
            return style;
        };
    }])

    .service('createStyleString', function() {
        return function(object) {
            var styles = [];
            angular.forEach(object, function(value, key) {
                styles.push(key + ':' + value);
            });
            return styles.join(';');
        };
    })

    .directive('rnCarousel', ['$swipe', '$window', '$document', '$parse', '$compile', '$timeout', '$interval', 'computeCarouselSlideStyle', 'createStyleString', 'Tweenable',
        function($swipe, $window, $document, $parse, $compile, $timeout, $interval, computeCarouselSlideStyle, createStyleString, Tweenable) {
            // internal ids to allow multiple instances
            var carouselId = 0,
                // in absolute pixels, at which distance the slide stick to the edge on release
                rubberTreshold = 3;

            var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;

            function getItemIndex(collection, target, defaultIndex) {
                var result = defaultIndex;
                collection.every(function(item, index) {
                    if (angular.equals(item, target)) {
                        result = index;
                        return false;
                    }
                    return true;
                });
                return result;
            }

            return {
                restrict: 'A',
                scope: true,
                compile: function(tElement, tAttributes) {
                    // use the compile phase to customize the DOM
                    var firstChild = tElement[0].querySelector('li'),
                        firstChildAttributes = (firstChild) ? firstChild.attributes : [],
                        isRepeatBased = false,
                        isBuffered = false,
                        repeatItem,
                        repeatCollection;

                    // try to find an ngRepeat expression
                    // at this point, the attributes are not yet normalized so we need to try various syntax
                    ['ng-repeat', 'data-ng-repeat', 'ng:repeat', 'x-ng-repeat'].every(function(attr) {
                        var repeatAttribute = firstChildAttributes[attr];
                        if (angular.isDefined(repeatAttribute)) {
                            // ngRepeat regexp extracted from angular 1.2.7 src
                            var exprMatch = repeatAttribute.value.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/),
                                trackProperty = exprMatch[3];

                            repeatItem = exprMatch[1];
                            repeatCollection = exprMatch[2];

                            if (repeatItem) {
                                if (angular.isDefined(tAttributes['rnCarouselBuffered'])) {
                                    // update the current ngRepeat expression and add a slice operator if buffered
                                    isBuffered = true;
                                    repeatAttribute.value = repeatItem + ' in ' + repeatCollection + '|carouselSlice:carouselBufferIndex:carouselBufferSize';
                                    if (trackProperty) {
                                        repeatAttribute.value += ' track by ' + trackProperty;
                                    }
                                }
                                isRepeatBased = true;
                                return false;
                            }
                        }
                        return true;
                    });

                    return function(scope, iElement, iAttributes, containerCtrl) {

                        carouselId++;

                        var defaultOptions = {
                            transitionType: iAttributes.rnCarouselTransition || 'slide',
                            transitionEasing: iAttributes.rnCarouselEasing || 'easeTo',
                            transitionDuration: parseInt(iAttributes.rnCarouselDuration, 10) || 300,
                            isSequential: true,
                            autoSlideDuration: 3,
                            bufferSize: 5,
                            /* in container % how much we need to drag to trigger the slide change */
                            moveTreshold: 0.1,
                            defaultIndex: 0
                        };

                        // TODO
                        var options = angular.extend({}, defaultOptions);

                        var pressed,
                            startX,
                            isIndexBound = false,
                            offset = 0,
                            destination,
                            swipeMoved = false,
                            //animOnIndexChange = true,
                            currentSlides = [],
                            elWidth = null,
                            elX = null,
                            animateTransitions = true,
                            intialState = true,
                            animating = false,
                            mouseUpBound = false,
                            locked = false;

                        //rn-swipe-disabled =true will only disable swipe events
                        if(iAttributes.rnSwipeDisabled !== "true") {
                            $swipe.bind(iElement, {
                                start: swipeStart,
                                move: swipeMove,
                                end: swipeEnd,
                                cancel: function(event) {
                                    swipeEnd({}, event);
                                }
                            });
                        }

                        function getSlidesDOM() {
                            var nodes = iElement[0].childNodes;
                            var slides = [];
                            for(var i=0; i<nodes.length ;i++){
                                if(nodes[i].tagName === "LI"){
                                    slides.push(nodes[i]);
                                }
                            }
                            return slides;
                        }

                        function documentMouseUpEvent(event) {
                            // in case we click outside the carousel, trigger a fake swipeEnd
                            swipeMoved = true;
                            swipeEnd({
                                x: event.clientX,
                                y: event.clientY
                            }, event);
                        }

                        function updateSlidesPosition(offset) {
                            // manually apply transformation to carousel childrens
                            // todo : optim : apply only to visible items
                            var x = scope.carouselBufferIndex * 100 + offset;
                            angular.forEach(getSlidesDOM(), function(child, index) {
                                child.style.cssText = createStyleString(computeCarouselSlideStyle(index, x, options.transitionType));
                            });
                        }

                        scope.nextSlide = function(slideOptions) {
                            var index = scope.carouselIndex + 1;
                            if (index > currentSlides.length - 1) {
                                index = 0;
                            }
                            if (!locked) {
                                goToSlide(index, slideOptions);
                            }
                        };

                        scope.prevSlide = function(slideOptions) {
                            var index = scope.carouselIndex - 1;
                            if (index < 0) {
                                index = currentSlides.length - 1;
                            }
                            goToSlide(index, slideOptions);
                        };

                        function goToSlide(index, slideOptions) {
                            //console.log('goToSlide', arguments);
                            // move a to the given slide index
                            if (index === undefined) {
                                index = scope.carouselIndex;
                            }

                            slideOptions = slideOptions || {};
                            if (slideOptions.animate === false || options.transitionType === 'none') {
                                locked = false;
                                offset = index * -100;
                                scope.carouselIndex = index;
                                updateBufferIndex();
                                return;
                            }

                            locked = true;
                            var tweenable = new Tweenable();
                            tweenable.tween({
                                from: {
                                    'x': offset
                                },
                                to: {
                                    'x': index * -100
                                },
                                duration: options.transitionDuration,
                                easing: options.transitionEasing,
                                step: function(state) {
                                    if (isFinite(state.x)) {
                                      updateSlidesPosition(state.x);
                                    }
                                },
                                finish: function() {
                                    scope.$apply(function() {
                                        scope.carouselIndex = index;
                                        offset = index * -100;
                                        updateBufferIndex();
                                        $timeout(function () {
                                          locked = false;
                                        }, 0, false);
                                    });
                                }
                            });
                        }

                        function getContainerWidth() {
                            var rect = iElement[0].getBoundingClientRect();
                            return rect.width ? rect.width : rect.right - rect.left;
                        }

                        function updateContainerWidth() {
                            elWidth = getContainerWidth();
                        }

                        function bindMouseUpEvent() {
                            if (!mouseUpBound) {
                              mouseUpBound = true;
                              $document.bind('mouseup', documentMouseUpEvent);
                            }
                        }

                        function unbindMouseUpEvent() {
                            if (mouseUpBound) {
                              mouseUpBound = false;
                              $document.unbind('mouseup', documentMouseUpEvent);
                            }
                        }

                        function swipeStart(coords, event) {
                            // console.log('swipeStart', coords, event);
                            if (locked || currentSlides.length <= 1) {
                                return;
                            }
                            updateContainerWidth();
                            elX = iElement[0].querySelector('li').getBoundingClientRect().left;
                            pressed = true;
                            startX = coords.x;
                            return false;
                        }

                        function swipeMove(coords, event) {
                            //console.log('swipeMove', coords, event);
                            var x, delta;
                            bindMouseUpEvent();
                            if (pressed) {
                                x = coords.x;
                                delta = startX - x;
                                if (delta > 2 || delta < -2) {
                                    swipeMoved = true;
                                    var moveOffset = offset + (-delta * 100 / elWidth);
                                    updateSlidesPosition(moveOffset);
                                }
                            }
                            return false;
                        }

                        var init = true;
                        scope.carouselIndex = 0;

                        if (!isRepeatBased) {
                            // fake array when no ng-repeat
                            currentSlides = [];
                            angular.forEach(getSlidesDOM(), function(node, index) {
                                currentSlides.push({id: index});
                            });
                            if (iAttributes.rnCarouselHtmlSlides) {
                                var updateParentSlides = function(value) {
                                    slidesModel.assign(scope.$parent, value);
                                };
                                var slidesModel = $parse(iAttributes.rnCarouselHtmlSlides);
                                if (angular.isFunction(slidesModel.assign)) {
                                    /* check if this property is assignable then watch it */
                                    scope.$watch('htmlSlides', function(newValue) {
                                        updateParentSlides(newValue);
                                    });
                                    scope.$parent.$watch(slidesModel, function(newValue, oldValue) {
                                        if (newValue !== undefined && newValue !== null) {
                                            newValue = 0;
                                            updateParentIndex(newValue);
                                        }
                                    });
                                }
                                scope.htmlSlides = currentSlides;
                            }
                        }

                        if (iAttributes.rnCarouselControls!==undefined) {
                            // dont use a directive for this
                            var canloop = ((isRepeatBased ? scope.$eval(repeatCollection.replace('::', '')).length : currentSlides.length) > 1) ? angular.isDefined(tAttributes['rnCarouselControlsAllowLoop']) : false;
                            var nextSlideIndexCompareValue = isRepeatBased ? '(' + repeatCollection.replace('::', '') + ').length - 1' : currentSlides.length - 1;
                            var tpl = '<div class="rn-carousel-controls">\n' +
                                '  <span class="rn-carousel-control rn-carousel-control-prev" ng-click="prevSlide()" ng-if="carouselIndex > 0 || ' + canloop + '"></span>\n' +
                                '  <span class="rn-carousel-control rn-carousel-control-next" ng-click="nextSlide()" ng-if="carouselIndex < ' + nextSlideIndexCompareValue + ' || ' + canloop + '"></span>\n' +
                                '</div>';
                            iElement.parent().append($compile(angular.element(tpl))(scope));
                        }

                        if (iAttributes.rnCarouselAutoSlide!==undefined) {
                            var duration = parseInt(iAttributes.rnCarouselAutoSlide, 10) || options.autoSlideDuration;
                            scope.autoSlide = function() {
                                if (scope.autoSlider) {
                                    $interval.cancel(scope.autoSlider);
                                    scope.autoSlider = null;
                                }
                                scope.autoSlider = $interval(function() {
                                    if (!locked && !pressed) {
                                        scope.nextSlide();
                                    }
                                }, duration * 1000);
                            };
                        }

                        if (iAttributes.rnCarouselDefaultIndex) {
                            var defaultIndexModel = $parse(iAttributes.rnCarouselDefaultIndex);
                            options.defaultIndex = defaultIndexModel(scope.$parent) || 0;
                        }

                        if (iAttributes.rnCarouselIndex) {
                            var updateParentIndex = function(value) {
                                indexModel.assign(scope.$parent, value);
                            };
                            var indexModel = $parse(iAttributes.rnCarouselIndex);
                            if (angular.isFunction(indexModel.assign)) {
                                /* check if this property is assignable then watch it */
                                scope.$watch('carouselIndex', function(newValue) {
                                    updateParentIndex(newValue);
                                });
                                scope.$parent.$watch(indexModel, function(newValue, oldValue) {

                                    if (newValue !== undefined && newValue !== null) {
                                        if (currentSlides && currentSlides.length > 0 && newValue >= currentSlides.length) {
                                            newValue = currentSlides.length - 1;
                                            updateParentIndex(newValue);
                                        } else if (currentSlides && newValue < 0) {
                                            newValue = 0;
                                            updateParentIndex(newValue);
                                        }
                                        if (!locked) {
                                            goToSlide(newValue, {
                                                animate: !init
                                            });
                                        }
                                        init = false;
                                    }
                                });
                                isIndexBound = true;

                                if (options.defaultIndex) {
                                    goToSlide(options.defaultIndex, {
                                        animate: !init
                                    });
                                }
                            } else if (!isNaN(iAttributes.rnCarouselIndex)) {
                                /* if user just set an initial number, set it */
                                goToSlide(parseInt(iAttributes.rnCarouselIndex, 10), {
                                    animate: false
                                });
                            }
                        } else {
                            goToSlide(options.defaultIndex, {
                                animate: !init
                            });
                            init = false;
                        }

                        if (iAttributes.rnCarouselLocked) {
                            scope.$watch(iAttributes.rnCarouselLocked, function(newValue, oldValue) {
                                // only bind swipe when it's not switched off
                                if(newValue === true) {
                                    locked = true;
                                } else {
                                    locked = false;
                                }
                            });
                        }

                        if (isRepeatBased) {
                            // use rn-carousel-deep-watch to fight the Angular $watchCollection weakness : https://github.com/angular/angular.js/issues/2621
                            // optional because it have some performance impacts (deep watch)
                            var deepWatch = (iAttributes.rnCarouselDeepWatch!==undefined);

                            scope[deepWatch?'$watch':'$watchCollection'](repeatCollection, function(newValue, oldValue) {
                                //console.log('repeatCollection', currentSlides);
                                currentSlides = newValue;
                                // if deepWatch ON ,manually compare objects to guess the new position
                                if (!angular.isArray(currentSlides)) {
                                  throw Error('the slides collection must be an Array');
                                }
                                if (deepWatch && angular.isArray(newValue)) {
                                    var activeElement = oldValue[scope.carouselIndex];
                                    var newIndex = getItemIndex(newValue, activeElement, scope.carouselIndex);
                                    goToSlide(newIndex, {animate: false});
                                } else {
                                    goToSlide(scope.carouselIndex, {animate: false});
                                }
                            }, true);
                        }

                        function swipeEnd(coords, event, forceAnimation) {
                            //  console.log('swipeEnd', 'scope.carouselIndex', scope.carouselIndex);
                            // Prevent clicks on buttons inside slider to trigger "swipeEnd" event on touchend/mouseup
                            // console.log(iAttributes.rnCarouselOnInfiniteScroll);
                            if (event && !swipeMoved) {
                                return;
                            }
                            unbindMouseUpEvent();
                            pressed = false;
                            swipeMoved = false;
                            destination = startX - coords.x;
                            if (destination===0) {
                                return;
                            }
                            if (locked) {
                                return;
                            }
                            offset += (-destination * 100 / elWidth);
                            if (options.isSequential) {
                                var minMove = options.moveTreshold * elWidth,
                                    absMove = -destination,
                                    slidesMove = -Math[absMove >= 0 ? 'ceil' : 'floor'](absMove / elWidth),
                                    shouldMove = Math.abs(absMove) > minMove;

                                if (currentSlides && (slidesMove + scope.carouselIndex) >= currentSlides.length) {
                                    slidesMove = currentSlides.length - 1 - scope.carouselIndex;
                                }
                                if ((slidesMove + scope.carouselIndex) < 0) {
                                    slidesMove = -scope.carouselIndex;
                                }
                                var moveOffset = shouldMove ? slidesMove : 0;

                                destination = (scope.carouselIndex + moveOffset);

                                goToSlide(destination);
                                if(iAttributes.rnCarouselOnInfiniteScrollRight!==undefined && slidesMove === 0 && scope.carouselIndex !== 0) {
                                    $parse(iAttributes.rnCarouselOnInfiniteScrollRight)(scope)
                                    goToSlide(0);
                                }
                                if(iAttributes.rnCarouselOnInfiniteScrollLeft!==undefined && slidesMove === 0 && scope.carouselIndex === 0 && moveOffset === 0) {
                                    $parse(iAttributes.rnCarouselOnInfiniteScrollLeft)(scope)
                                    goToSlide(currentSlides.length);
                                }

                            } else {
                                scope.$apply(function() {
                                    scope.carouselIndex = parseInt(-offset / 100, 10);
                                    updateBufferIndex();
                                });

                            }

                        }

                        scope.$on('$destroy', function() {
                            unbindMouseUpEvent();
                        });

                        scope.carouselBufferIndex = 0;
                        scope.carouselBufferSize = options.bufferSize;

                        function updateBufferIndex() {
                            // update and cap te buffer index
                            var bufferIndex = 0;
                            var bufferEdgeSize = (scope.carouselBufferSize - 1) / 2;
                            if (isBuffered) {
                                if (scope.carouselIndex <= bufferEdgeSize) {
                                    // first buffer part
                                    bufferIndex = 0;
                                } else if (currentSlides && currentSlides.length < scope.carouselBufferSize) {
                                    // smaller than buffer
                                    bufferIndex = 0;
                                } else if (currentSlides && scope.carouselIndex > currentSlides.length - scope.carouselBufferSize) {
                                    // last buffer part
                                    bufferIndex = currentSlides.length - scope.carouselBufferSize;
                                } else {
                                    // compute buffer start
                                    bufferIndex = scope.carouselIndex - bufferEdgeSize;
                                }

                                scope.carouselBufferIndex = bufferIndex;
                                $timeout(function() {
                                    updateSlidesPosition(offset);
                                }, 0, false);
                            } else {
                                $timeout(function() {
                                    updateSlidesPosition(offset);
                                }, 0, false);
                            }
                        }

                        function onOrientationChange() {
                            updateContainerWidth();
                            goToSlide();
                        }

                        // handle orientation change
                        var winEl = angular.element($window);
                        winEl.bind('orientationchange', onOrientationChange);
                        winEl.bind('resize', onOrientationChange);

                        scope.$on('$destroy', function() {
                            unbindMouseUpEvent();
                            winEl.unbind('orientationchange', onOrientationChange);
                            winEl.unbind('resize', onOrientationChange);
                        });
                    };
                }
            };
        }
    ]);
})();



angular.module('angular-carousel.shifty', [])

.factory('Tweenable', function() {

    /*! shifty - v1.3.4 - 2014-10-29 - http://jeremyckahn.github.io/shifty */
  ;(function (root) {

  /*!
   * Shifty Core
   * By Jeremy Kahn - jeremyckahn@gmail.com
   */

  var Tweenable = (function () {

    'use strict';

    // Aliases that get defined later in this function
    var formula;

    // CONSTANTS
    var DEFAULT_SCHEDULE_FUNCTION;
    var DEFAULT_EASING = 'linear';
    var DEFAULT_DURATION = 500;
    var UPDATE_TIME = 1000 / 60;

    var _now = Date.now
         ? Date.now
         : function () {return +new Date();};

    var now = typeof SHIFTY_DEBUG_NOW !== 'undefined' ? SHIFTY_DEBUG_NOW : _now;

    if (typeof window !== 'undefined') {
      // requestAnimationFrame() shim by Paul Irish (modified for Shifty)
      // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
      DEFAULT_SCHEDULE_FUNCTION = window.requestAnimationFrame
         || window.webkitRequestAnimationFrame
         || window.oRequestAnimationFrame
         || window.msRequestAnimationFrame
         || (window.mozCancelRequestAnimationFrame
         && window.mozRequestAnimationFrame)
         || setTimeout;
    } else {
      DEFAULT_SCHEDULE_FUNCTION = setTimeout;
    }

    function noop () {
      // NOOP!
    }

    /*!
     * Handy shortcut for doing a for-in loop. This is not a "normal" each
     * function, it is optimized for Shifty.  The iterator function only receives
     * the property name, not the value.
     * @param {Object} obj
     * @param {Function(string)} fn
     */
    function each (obj, fn) {
      var key;
      for (key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          fn(key);
        }
      }
    }

    /*!
     * Perform a shallow copy of Object properties.
     * @param {Object} targetObject The object to copy into
     * @param {Object} srcObject The object to copy from
     * @return {Object} A reference to the augmented `targetObj` Object
     */
    function shallowCopy (targetObj, srcObj) {
      each(srcObj, function (prop) {
        targetObj[prop] = srcObj[prop];
      });

      return targetObj;
    }

    /*!
     * Copies each property from src onto target, but only if the property to
     * copy to target is undefined.
     * @param {Object} target Missing properties in this Object are filled in
     * @param {Object} src
     */
    function defaults (target, src) {
      each(src, function (prop) {
        if (typeof target[prop] === 'undefined') {
          target[prop] = src[prop];
        }
      });
    }

    /*!
     * Calculates the interpolated tween values of an Object for a given
     * timestamp.
     * @param {Number} forPosition The position to compute the state for.
     * @param {Object} currentState Current state properties.
     * @param {Object} originalState: The original state properties the Object is
     * tweening from.
     * @param {Object} targetState: The destination state properties the Object
     * is tweening to.
     * @param {number} duration: The length of the tween in milliseconds.
     * @param {number} timestamp: The UNIX epoch time at which the tween began.
     * @param {Object} easing: This Object's keys must correspond to the keys in
     * targetState.
     */
    function tweenProps (forPosition, currentState, originalState, targetState,
      duration, timestamp, easing) {
      var normalizedPosition = (forPosition - timestamp) / duration;

      var prop;
      for (prop in currentState) {
        if (currentState.hasOwnProperty(prop)) {
          currentState[prop] = tweenProp(originalState[prop],
            targetState[prop], formula[easing[prop]], normalizedPosition);
        }
      }

      return currentState;
    }

    /*!
     * Tweens a single property.
     * @param {number} start The value that the tween started from.
     * @param {number} end The value that the tween should end at.
     * @param {Function} easingFunc The easing curve to apply to the tween.
     * @param {number} position The normalized position (between 0.0 and 1.0) to
     * calculate the midpoint of 'start' and 'end' against.
     * @return {number} The tweened value.
     */
    function tweenProp (start, end, easingFunc, position) {
      return start + (end - start) * easingFunc(position);
    }

    /*!
     * Applies a filter to Tweenable instance.
     * @param {Tweenable} tweenable The `Tweenable` instance to call the filter
     * upon.
     * @param {String} filterName The name of the filter to apply.
     */
    function applyFilter (tweenable, filterName) {
      var filters = Tweenable.prototype.filter;
      var args = tweenable._filterArgs;

      each(filters, function (name) {
        if (typeof filters[name][filterName] !== 'undefined') {
          filters[name][filterName].apply(tweenable, args);
        }
      });
    }

    var timeoutHandler_endTime;
    var timeoutHandler_currentTime;
    var timeoutHandler_isEnded;
    var timeoutHandler_offset;
    /*!
     * Handles the update logic for one step of a tween.
     * @param {Tweenable} tweenable
     * @param {number} timestamp
     * @param {number} duration
     * @param {Object} currentState
     * @param {Object} originalState
     * @param {Object} targetState
     * @param {Object} easing
     * @param {Function(Object, *, number)} step
     * @param {Function(Function,number)}} schedule
     */
    function timeoutHandler (tweenable, timestamp, duration, currentState,
      originalState, targetState, easing, step, schedule) {
      timeoutHandler_endTime = timestamp + duration;
      timeoutHandler_currentTime = Math.min(now(), timeoutHandler_endTime);
      timeoutHandler_isEnded =
        timeoutHandler_currentTime >= timeoutHandler_endTime;

      timeoutHandler_offset = duration - (
          timeoutHandler_endTime - timeoutHandler_currentTime);

      if (tweenable.isPlaying() && !timeoutHandler_isEnded) {
        tweenable._scheduleId = schedule(tweenable._timeoutHandler, UPDATE_TIME);

        applyFilter(tweenable, 'beforeTween');
        tweenProps(timeoutHandler_currentTime, currentState, originalState,
          targetState, duration, timestamp, easing);
        applyFilter(tweenable, 'afterTween');

        step(currentState, tweenable._attachment, timeoutHandler_offset);
      } else if (timeoutHandler_isEnded) {
        step(targetState, tweenable._attachment, timeoutHandler_offset);
        tweenable.stop(true);
      }
    }


    /*!
     * Creates a usable easing Object from either a string or another easing
     * Object.  If `easing` is an Object, then this function clones it and fills
     * in the missing properties with "linear".
     * @param {Object} fromTweenParams
     * @param {Object|string} easing
     */
    function composeEasingObject (fromTweenParams, easing) {
      var composedEasing = {};

      if (typeof easing === 'string') {
        each(fromTweenParams, function (prop) {
          composedEasing[prop] = easing;
        });
      } else {
        each(fromTweenParams, function (prop) {
          if (!composedEasing[prop]) {
            composedEasing[prop] = easing[prop] || DEFAULT_EASING;
          }
        });
      }

      return composedEasing;
    }

    /**
     * Tweenable constructor.
     * @param {Object=} opt_initialState The values that the initial tween should start at if a "from" object is not provided to Tweenable#tween.
     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
     * @constructor
     */
    function Tweenable (opt_initialState, opt_config) {
      this._currentState = opt_initialState || {};
      this._configured = false;
      this._scheduleFunction = DEFAULT_SCHEDULE_FUNCTION;

      // To prevent unnecessary calls to setConfig do not set default configuration here.
      // Only set default configuration immediately before tweening if none has been set.
      if (typeof opt_config !== 'undefined') {
        this.setConfig(opt_config);
      }
    }

    /**
     * Configure and start a tween.
     * @param {Object=} opt_config See Tweenable.prototype.setConfig()
     * @return {Tweenable}
     */
    Tweenable.prototype.tween = function (opt_config) {
      if (this._isTweening) {
        return this;
      }

      // Only set default config if no configuration has been set previously and none is provided now.
      if (opt_config !== undefined || !this._configured) {
        this.setConfig(opt_config);
      }

      this._timestamp = now();
      this._start(this.get(), this._attachment);
      return this.resume();
    };

    /**
     * Sets the tween configuration. `config` may have the following options:
     *
     * - __from__ (_Object=_): Starting position.  If omitted, the current state is used.
     * - __to__ (_Object=_): Ending position.
     * - __duration__ (_number=_): How many milliseconds to animate for.
     * - __start__ (_Function(Object)_): Function to execute when the tween begins.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
     * - __step__ (_Function(Object, *, number)_): Function to execute on every tick.  Receives the state of the tween as the first parameter. Attachment is the second parameter, and the time elapsed since the start of the tween is the third parameter. This function is not called on the final step of the animation, but `finish` is.
     * - __finish__ (_Function(Object, *)_): Function to execute upon tween completion.  Receives the state of the tween as the first parameter. Attachment is the second parameter.
     * - __easing__ (_Object|string=_): Easing curve name(s) to use for the tween.
     * - __attachment__ (_Object|string|any=_): Value that is attached to this instance and passed on to the step/start/finish methods.
     * @param {Object} config
     * @return {Tweenable}
     */
    Tweenable.prototype.setConfig = function (config) {
      config = config || {};
      this._configured = true;

      // Attach something to this Tweenable instance (e.g.: a DOM element, an object, a string, etc.);
      this._attachment = config.attachment;

      // Init the internal state
      this._pausedAtTime = null;
      this._scheduleId = null;
      this._start = config.start || noop;
      this._step = config.step || noop;
      this._finish = config.finish || noop;
      this._duration = config.duration || DEFAULT_DURATION;
      this._currentState = config.from || this.get();
      this._originalState = this.get();
      this._targetState = config.to || this.get();

      // Aliases used below
      var currentState = this._currentState;
      var targetState = this._targetState;

      // Ensure that there is always something to tween to.
      defaults(targetState, currentState);

      this._easing = composeEasingObject(
        currentState, config.easing || DEFAULT_EASING);

      this._filterArgs =
        [currentState, this._originalState, targetState, this._easing];

      applyFilter(this, 'tweenCreated');
      return this;
    };

    /**
     * Gets the current state.
     * @return {Object}
     */
    Tweenable.prototype.get = function () {
      return shallowCopy({}, this._currentState);
    };

    /**
     * Sets the current state.
     * @param {Object} state
     */
    Tweenable.prototype.set = function (state) {
      this._currentState = state;
    };

    /**
     * Pauses a tween.  Paused tweens can be resumed from the point at which they were paused.  This is different than [`stop()`](#stop), as that method causes a tween to start over when it is resumed.
     * @return {Tweenable}
     */
    Tweenable.prototype.pause = function () {
      this._pausedAtTime = now();
      this._isPaused = true;
      return this;
    };

    /**
     * Resumes a paused tween.
     * @return {Tweenable}
     */
    Tweenable.prototype.resume = function () {
      if (this._isPaused) {
        this._timestamp += now() - this._pausedAtTime;
      }

      this._isPaused = false;
      this._isTweening = true;

      var self = this;
      this._timeoutHandler = function () {
        timeoutHandler(self, self._timestamp, self._duration, self._currentState,
          self._originalState, self._targetState, self._easing, self._step,
          self._scheduleFunction);
      };

      this._timeoutHandler();

      return this;
    };

    /**
     * Move the state of the animation to a specific point in the tween's timeline.
     * If the animation is not running, this will cause the `step` handlers to be
     * called.
     * @param {millisecond} millisecond The millisecond of the animation to seek to.
     * @return {Tweenable}
     */
    Tweenable.prototype.seek = function (millisecond) {
      this._timestamp = now() - millisecond;

      if (!this.isPlaying()) {
        this._isTweening = true;
        this._isPaused = false;

        // If the animation is not running, call timeoutHandler to make sure that
        // any step handlers are run.
        timeoutHandler(this, this._timestamp, this._duration, this._currentState,
          this._originalState, this._targetState, this._easing, this._step,
          this._scheduleFunction);

        this._timeoutHandler();
        this.pause();
      }

      return this;
    };

    /**
     * Stops and cancels a tween.
     * @param {boolean=} gotoEnd If false or omitted, the tween just stops at its current state, and the "finish" handler is not invoked.  If true, the tweened object's values are instantly set to the target values, and "finish" is invoked.
     * @return {Tweenable}
     */
    Tweenable.prototype.stop = function (gotoEnd) {
      this._isTweening = false;
      this._isPaused = false;
      this._timeoutHandler = noop;

      (root.cancelAnimationFrame            ||
        root.webkitCancelAnimationFrame     ||
        root.oCancelAnimationFrame          ||
        root.msCancelAnimationFrame         ||
        root.mozCancelRequestAnimationFrame ||
        root.clearTimeout)(this._scheduleId);

      if (gotoEnd) {
        shallowCopy(this._currentState, this._targetState);
        applyFilter(this, 'afterTweenEnd');
        this._finish.call(this, this._currentState, this._attachment);
      }

      return this;
    };

    /**
     * Returns whether or not a tween is running.
     * @return {boolean}
     */
    Tweenable.prototype.isPlaying = function () {
      return this._isTweening && !this._isPaused;
    };

    /**
     * Sets a custom schedule function.
     *
     * If a custom function is not set the default one is used [`requestAnimationFrame`](https://developer.mozilla.org/en-US/docs/Web/API/window.requestAnimationFrame) if available, otherwise [`setTimeout`](https://developer.mozilla.org/en-US/docs/Web/API/Window.setTimeout)).
     *
     * @param {Function(Function,number)} scheduleFunction The function to be called to schedule the next frame to be rendered
     */
    Tweenable.prototype.setScheduleFunction = function (scheduleFunction) {
      this._scheduleFunction = scheduleFunction;
    };

    /**
     * `delete`s all "own" properties.  Call this when the `Tweenable` instance is no longer needed to free memory.
     */
    Tweenable.prototype.dispose = function () {
      var prop;
      for (prop in this) {
        if (this.hasOwnProperty(prop)) {
          delete this[prop];
        }
      }
    };

    /*!
     * Filters are used for transforming the properties of a tween at various
     * points in a Tweenable's life cycle.  See the README for more info on this.
     */
    Tweenable.prototype.filter = {};

    /*!
     * This object contains all of the tweens available to Shifty.  It is extendible - simply attach properties to the Tweenable.prototype.formula Object following the same format at linear.
     *
     * `pos` should be a normalized `number` (between 0 and 1).
     */
    Tweenable.prototype.formula = {
      linear: function (pos) {
        return pos;
      }
    };

    formula = Tweenable.prototype.formula;

    shallowCopy(Tweenable, {
      'now': now
      ,'each': each
      ,'tweenProps': tweenProps
      ,'tweenProp': tweenProp
      ,'applyFilter': applyFilter
      ,'shallowCopy': shallowCopy
      ,'defaults': defaults
      ,'composeEasingObject': composeEasingObject
    });

    root.Tweenable = Tweenable;
    return Tweenable;

  } ());

  /*!
   * All equations are adapted from Thomas Fuchs' [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/penner.js).
   *
   * Based on Easing Equations (c) 2003 [Robert Penner](http://www.robertpenner.com/), all rights reserved. This work is [subject to terms](http://www.robertpenner.com/easing_terms_of_use.html).
   */

  /*!
   *  TERMS OF USE - EASING EQUATIONS
   *  Open source under the BSD License.
   *  Easing Equations (c) 2003 Robert Penner, all rights reserved.
   */

  ;(function () {

    Tweenable.shallowCopy(Tweenable.prototype.formula, {
      easeInQuad: function (pos) {
        return Math.pow(pos, 2);
      },

      easeOutQuad: function (pos) {
        return -(Math.pow((pos - 1), 2) - 1);
      },

      easeInOutQuad: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,2);}
        return -0.5 * ((pos -= 2) * pos - 2);
      },

      easeInCubic: function (pos) {
        return Math.pow(pos, 3);
      },

      easeOutCubic: function (pos) {
        return (Math.pow((pos - 1), 3) + 1);
      },

      easeInOutCubic: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,3);}
        return 0.5 * (Math.pow((pos - 2),3) + 2);
      },

      easeInQuart: function (pos) {
        return Math.pow(pos, 4);
      },

      easeOutQuart: function (pos) {
        return -(Math.pow((pos - 1), 4) - 1);
      },

      easeInOutQuart: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
      },

      easeInQuint: function (pos) {
        return Math.pow(pos, 5);
      },

      easeOutQuint: function (pos) {
        return (Math.pow((pos - 1), 5) + 1);
      },

      easeInOutQuint: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,5);}
        return 0.5 * (Math.pow((pos - 2),5) + 2);
      },

      easeInSine: function (pos) {
        return -Math.cos(pos * (Math.PI / 2)) + 1;
      },

      easeOutSine: function (pos) {
        return Math.sin(pos * (Math.PI / 2));
      },

      easeInOutSine: function (pos) {
        return (-0.5 * (Math.cos(Math.PI * pos) - 1));
      },

      easeInExpo: function (pos) {
        return (pos === 0) ? 0 : Math.pow(2, 10 * (pos - 1));
      },

      easeOutExpo: function (pos) {
        return (pos === 1) ? 1 : -Math.pow(2, -10 * pos) + 1;
      },

      easeInOutExpo: function (pos) {
        if (pos === 0) {return 0;}
        if (pos === 1) {return 1;}
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(2,10 * (pos - 1));}
        return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
      },

      easeInCirc: function (pos) {
        return -(Math.sqrt(1 - (pos * pos)) - 1);
      },

      easeOutCirc: function (pos) {
        return Math.sqrt(1 - Math.pow((pos - 1), 2));
      },

      easeInOutCirc: function (pos) {
        if ((pos /= 0.5) < 1) {return -0.5 * (Math.sqrt(1 - pos * pos) - 1);}
        return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
      },

      easeOutBounce: function (pos) {
        if ((pos) < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      easeInBack: function (pos) {
        var s = 1.70158;
        return (pos) * pos * ((s + 1) * pos - s);
      },

      easeOutBack: function (pos) {
        var s = 1.70158;
        return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
      },

      easeInOutBack: function (pos) {
        var s = 1.70158;
        if ((pos /= 0.5) < 1) {return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));}
        return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
      },

      elastic: function (pos) {
        return -1 * Math.pow(4,-8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
      },

      swingFromTo: function (pos) {
        var s = 1.70158;
        return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
            0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
      },

      swingFrom: function (pos) {
        var s = 1.70158;
        return pos * pos * ((s + 1) * pos - s);
      },

      swingTo: function (pos) {
        var s = 1.70158;
        return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
      },

      bounce: function (pos) {
        if (pos < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      bouncePast: function (pos) {
        if (pos < (1 / 2.75)) {
          return (7.5625 * pos * pos);
        } else if (pos < (2 / 2.75)) {
          return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + 0.75);
        } else if (pos < (2.5 / 2.75)) {
          return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + 0.9375);
        } else {
          return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + 0.984375);
        }
      },

      easeFromTo: function (pos) {
        if ((pos /= 0.5) < 1) {return 0.5 * Math.pow(pos,4);}
        return -0.5 * ((pos -= 2) * Math.pow(pos,3) - 2);
      },

      easeFrom: function (pos) {
        return Math.pow(pos,4);
      },

      easeTo: function (pos) {
        return Math.pow(pos,0.25);
      }
    });

  }());

  /*!
   * The Bezier magic in this file is adapted/copied almost wholesale from
   * [Scripty2](https://github.com/madrobby/scripty2/blob/master/src/effects/transitions/cubic-bezier.js),
   * which was adapted from Apple code (which probably came from
   * [here](http://opensource.apple.com/source/WebCore/WebCore-955.66/platform/graphics/UnitBezier.h)).
   * Special thanks to Apple and Thomas Fuchs for much of this code.
   */

  /*!
   *  Copyright (c) 2006 Apple Computer, Inc. All rights reserved.
   *
   *  Redistribution and use in source and binary forms, with or without
   *  modification, are permitted provided that the following conditions are met:
   *
   *  1. Redistributions of source code must retain the above copyright notice,
   *  this list of conditions and the following disclaimer.
   *
   *  2. Redistributions in binary form must reproduce the above copyright notice,
   *  this list of conditions and the following disclaimer in the documentation
   *  and/or other materials provided with the distribution.
   *
   *  3. Neither the name of the copyright holder(s) nor the names of any
   *  contributors may be used to endorse or promote products derived from
   *  this software without specific prior written permission.
   *
   *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   *  "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
   *  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
   *  ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE
   *  FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
   *  (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
   *  LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
   *  ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
   *  (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   *  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
  ;(function () {
    // port of webkit cubic bezier handling by http://www.netzgesta.de/dev/
    function cubicBezierAtTime(t,p1x,p1y,p2x,p2y,duration) {
      var ax = 0,bx = 0,cx = 0,ay = 0,by = 0,cy = 0;
      function sampleCurveX(t) {return ((ax * t + bx) * t + cx) * t;}
      function sampleCurveY(t) {return ((ay * t + by) * t + cy) * t;}
      function sampleCurveDerivativeX(t) {return (3.0 * ax * t + 2.0 * bx) * t + cx;}
      function solveEpsilon(duration) {return 1.0 / (200.0 * duration);}
      function solve(x,epsilon) {return sampleCurveY(solveCurveX(x,epsilon));}
      function fabs(n) {if (n >= 0) {return n;}else {return 0 - n;}}
      function solveCurveX(x,epsilon) {
        var t0,t1,t2,x2,d2,i;
        for (t2 = x, i = 0; i < 8; i++) {x2 = sampleCurveX(t2) - x; if (fabs(x2) < epsilon) {return t2;} d2 = sampleCurveDerivativeX(t2); if (fabs(d2) < 1e-6) {break;} t2 = t2 - x2 / d2;}
        t0 = 0.0; t1 = 1.0; t2 = x; if (t2 < t0) {return t0;} if (t2 > t1) {return t1;}
        while (t0 < t1) {x2 = sampleCurveX(t2); if (fabs(x2 - x) < epsilon) {return t2;} if (x > x2) {t0 = t2;}else {t1 = t2;} t2 = (t1 - t0) * 0.5 + t0;}
        return t2; // Failure.
      }
      cx = 3.0 * p1x; bx = 3.0 * (p2x - p1x) - cx; ax = 1.0 - cx - bx; cy = 3.0 * p1y; by = 3.0 * (p2y - p1y) - cy; ay = 1.0 - cy - by;
      return solve(t, solveEpsilon(duration));
    }
    /*!
     *  getCubicBezierTransition(x1, y1, x2, y2) -> Function
     *
     *  Generates a transition easing function that is compatible
     *  with WebKit's CSS transitions `-webkit-transition-timing-function`
     *  CSS property.
     *
     *  The W3C has more information about
     *  <a href="http://www.w3.org/TR/css3-transitions/#transition-timing-function_tag">
     *  CSS3 transition timing functions</a>.
     *
     *  @param {number} x1
     *  @param {number} y1
     *  @param {number} x2
     *  @param {number} y2
     *  @return {function}
     */
    function getCubicBezierTransition (x1, y1, x2, y2) {
      return function (pos) {
        return cubicBezierAtTime(pos,x1,y1,x2,y2,1);
      };
    }
    // End ported code

    /**
     * Creates a Bezier easing function and attaches it to `Tweenable.prototype.formula`.  This function gives you total control over the easing curve.  Matthew Lein's [Ceaser](http://matthewlein.com/ceaser/) is a useful tool for visualizing the curves you can make with this function.
     *
     * @param {string} name The name of the easing curve.  Overwrites the old easing function on Tweenable.prototype.formula if it exists.
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @return {function} The easing function that was attached to Tweenable.prototype.formula.
     */
    Tweenable.setBezierFunction = function (name, x1, y1, x2, y2) {
      var cubicBezierTransition = getCubicBezierTransition(x1, y1, x2, y2);
      cubicBezierTransition.x1 = x1;
      cubicBezierTransition.y1 = y1;
      cubicBezierTransition.x2 = x2;
      cubicBezierTransition.y2 = y2;

      return Tweenable.prototype.formula[name] = cubicBezierTransition;
    };


    /**
     * `delete`s an easing function from `Tweenable.prototype.formula`.  Be careful with this method, as it `delete`s whatever easing formula matches `name` (which means you can delete default Shifty easing functions).
     *
     * @param {string} name The name of the easing function to delete.
     * @return {function}
     */
    Tweenable.unsetBezierFunction = function (name) {
      delete Tweenable.prototype.formula[name];
    };

  })();

  ;(function () {

    function getInterpolatedValues (
      from, current, targetState, position, easing) {
      return Tweenable.tweenProps(
        position, current, from, targetState, 1, 0, easing);
    }

    // Fake a Tweenable and patch some internals.  This approach allows us to
    // skip uneccessary processing and object recreation, cutting down on garbage
    // collection pauses.
    var mockTweenable = new Tweenable();
    mockTweenable._filterArgs = [];

    /**
     * Compute the midpoint of two Objects.  This method effectively calculates a specific frame of animation that [Tweenable#tween](shifty.core.js.html#tween) does many times over the course of a tween.
     *
     * Example:
     *
     *     var interpolatedValues = Tweenable.interpolate({
     *       width: '100px',
     *       opacity: 0,
     *       color: '#fff'
     *     }, {
     *       width: '200px',
     *       opacity: 1,
     *       color: '#000'
     *     }, 0.5);
     *
     *     console.log(interpolatedValues);
     *     // {opacity: 0.5, width: "150px", color: "rgb(127,127,127)"}
     *
     * @param {Object} from The starting values to tween from.
     * @param {Object} targetState The ending values to tween to.
     * @param {number} position The normalized position value (between 0.0 and 1.0) to interpolate the values between `from` and `to` for.  `from` represents 0 and `to` represents `1`.
     * @param {string|Object} easing The easing curve(s) to calculate the midpoint against.  You can reference any easing function attached to `Tweenable.prototype.formula`.  If omitted, this defaults to "linear".
     * @return {Object}
     */
    Tweenable.interpolate = function (from, targetState, position, easing) {
      var current = Tweenable.shallowCopy({}, from);
      var easingObject = Tweenable.composeEasingObject(
        from, easing || 'linear');

      mockTweenable.set({});

      // Alias and reuse the _filterArgs array instead of recreating it.
      var filterArgs = mockTweenable._filterArgs;
      filterArgs.length = 0;
      filterArgs[0] = current;
      filterArgs[1] = from;
      filterArgs[2] = targetState;
      filterArgs[3] = easingObject;

      // Any defined value transformation must be applied
      Tweenable.applyFilter(mockTweenable, 'tweenCreated');
      Tweenable.applyFilter(mockTweenable, 'beforeTween');

      var interpolatedValues = getInterpolatedValues(
        from, current, targetState, position, easingObject);

      // Transform values back into their original format
      Tweenable.applyFilter(mockTweenable, 'afterTween');

      return interpolatedValues;
    };

  }());

  /**
   * Adds string interpolation support to Shifty.
   *
   * The Token extension allows Shifty to tween numbers inside of strings.  Among
   * other things, this allows you to animate CSS properties.  For example, you
   * can do this:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(45px)'},
   *       to: { transform: 'translateX(90xp)'}
   *     });
   *
   * ` `
   * `translateX(45)` will be tweened to `translateX(90)`.  To demonstrate:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(45px)'},
   *       to: { transform: 'translateX(90px)'},
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet will log something like this in the console:
   *
   *     translateX(60.3px)
   *     ...
   *     translateX(76.05px)
   *     ...
   *     translateX(90px)
   *
   * ` `
   * Another use for this is animating colors:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { color: 'rgb(0,255,0)'},
   *       to: { color: 'rgb(255,0,255)'},
   *       step: function (state) {
   *         console.log(state.color);
   *       }
   *     });
   *
   * ` `
   * The above snippet will log something like this:
   *
   *     rgb(84,170,84)
   *     ...
   *     rgb(170,84,170)
   *     ...
   *     rgb(255,0,255)
   *
   * ` `
   * This extension also supports hexadecimal colors, in both long (`#ff00ff`)
   * and short (`#f0f`) forms.  Be aware that hexadecimal input values will be
   * converted into the equivalent RGB output values.  This is done to optimize
   * for performance.
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { color: '#0f0'},
   *       to: { color: '#f0f'},
   *       step: function (state) {
   *         console.log(state.color);
   *       }
   *     });
   *
   * ` `
   * This snippet will generate the same output as the one before it because
   * equivalent values were supplied (just in hexadecimal form rather than RGB):
   *
   *     rgb(84,170,84)
   *     ...
   *     rgb(170,84,170)
   *     ...
   *     rgb(255,0,255)
   *
   * ` `
   * ` `
   * ## Easing support
   *
   * Easing works somewhat differently in the Token extension.  This is because
   * some CSS properties have multiple values in them, and you might need to
   * tween each value along its own easing curve.  A basic example:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(0px) translateY(0px)'},
   *       to: { transform:   'translateX(100px) translateY(100px)'},
   *       easing: { transform: 'easeInQuad' },
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet create values like this:
   *
   *     translateX(11.560000000000002px) translateY(11.560000000000002px)
   *     ...
   *     translateX(46.24000000000001px) translateY(46.24000000000001px)
   *     ...
   *     translateX(100px) translateY(100px)
   *
   * ` `
   * In this case, the values for `translateX` and `translateY` are always the
   * same for each step of the tween, because they have the same start and end
   * points and both use the same easing curve.  We can also tween `translateX`
   * and `translateY` along independent curves:
   *
   *     var tweenable = new Tweenable();
   *     tweenable.tween({
   *       from: { transform: 'translateX(0px) translateY(0px)'},
   *       to: { transform:   'translateX(100px) translateY(100px)'},
   *       easing: { transform: 'easeInQuad bounce' },
   *       step: function (state) {
   *         console.log(state.transform);
   *       }
   *     });
   *
   * ` `
   * The above snippet create values like this:
   *
   *     translateX(10.89px) translateY(82.355625px)
   *     ...
   *     translateX(44.89000000000001px) translateY(86.73062500000002px)
   *     ...
   *     translateX(100px) translateY(100px)
   *
   * ` `
   * `translateX` and `translateY` are not in sync anymore, because `easeInQuad`
   * was specified for `translateX` and `bounce` for `translateY`.  Mixing and
   * matching easing curves can make for some interesting motion in your
   * animations.
   *
   * The order of the space-separated easing curves correspond the token values
   * they apply to.  If there are more token values than easing curves listed,
   * the last easing curve listed is used.
   */
  function token () {
    // Functionality for this extension runs implicitly if it is loaded.
  } /*!*/

  // token function is defined above only so that dox-foundation sees it as
  // documentation and renders it.  It is never used, and is optimized away at
  // build time.

  ;(function (Tweenable) {

    /*!
     * @typedef {{
     *   formatString: string
     *   chunkNames: Array.<string>
     * }}
     */
    var formatManifest;

    // CONSTANTS

    var R_NUMBER_COMPONENT = /(\d|\-|\.)/;
    var R_FORMAT_CHUNKS = /([^\-0-9\.]+)/g;
    var R_UNFORMATTED_VALUES = /[0-9.\-]+/g;
    var R_RGB = new RegExp(
      'rgb\\(' + R_UNFORMATTED_VALUES.source +
      (/,\s*/.source) + R_UNFORMATTED_VALUES.source +
      (/,\s*/.source) + R_UNFORMATTED_VALUES.source + '\\)', 'g');
    var R_RGB_PREFIX = /^.*\(/;
    var R_HEX = /#([0-9]|[a-f]){3,6}/gi;
    var VALUE_PLACEHOLDER = 'VAL';

    // HELPERS

    var getFormatChunksFrom_accumulator = [];
    /*!
     * @param {Array.number} rawValues
     * @param {string} prefix
     *
     * @return {Array.<string>}
     */
    function getFormatChunksFrom (rawValues, prefix) {
      getFormatChunksFrom_accumulator.length = 0;

      var rawValuesLength = rawValues.length;
      var i;

      for (i = 0; i < rawValuesLength; i++) {
        getFormatChunksFrom_accumulator.push('_' + prefix + '_' + i);
      }

      return getFormatChunksFrom_accumulator;
    }

    /*!
     * @param {string} formattedString
     *
     * @return {string}
     */
    function getFormatStringFrom (formattedString) {
      var chunks = formattedString.match(R_FORMAT_CHUNKS);

      if (!chunks) {
        // chunks will be null if there were no tokens to parse in
        // formattedString (for example, if formattedString is '2').  Coerce
        // chunks to be useful here.
        chunks = ['', ''];

        // If there is only one chunk, assume that the string is a number
        // followed by a token...
        // NOTE: This may be an unwise assumption.
      } else if (chunks.length === 1 ||
          // ...or if the string starts with a number component (".", "-", or a
          // digit)...
          formattedString[0].match(R_NUMBER_COMPONENT)) {
        // ...prepend an empty string here to make sure that the formatted number
        // is properly replaced by VALUE_PLACEHOLDER
        chunks.unshift('');
      }

      return chunks.join(VALUE_PLACEHOLDER);
    }

    /*!
     * Convert all hex color values within a string to an rgb string.
     *
     * @param {Object} stateObject
     *
     * @return {Object} The modified obj
     */
    function sanitizeObjectForHexProps (stateObject) {
      Tweenable.each(stateObject, function (prop) {
        var currentProp = stateObject[prop];

        if (typeof currentProp === 'string' && currentProp.match(R_HEX)) {
          stateObject[prop] = sanitizeHexChunksToRGB(currentProp);
        }
      });
    }

    /*!
     * @param {string} str
     *
     * @return {string}
     */
    function  sanitizeHexChunksToRGB (str) {
      return filterStringChunks(R_HEX, str, convertHexToRGB);
    }

    /*!
     * @param {string} hexString
     *
     * @return {string}
     */
    function convertHexToRGB (hexString) {
      var rgbArr = hexToRGBArray(hexString);
      return 'rgb(' + rgbArr[0] + ',' + rgbArr[1] + ',' + rgbArr[2] + ')';
    }

    var hexToRGBArray_returnArray = [];
    /*!
     * Convert a hexadecimal string to an array with three items, one each for
     * the red, blue, and green decimal values.
     *
     * @param {string} hex A hexadecimal string.
     *
     * @returns {Array.<number>} The converted Array of RGB values if `hex` is a
     * valid string, or an Array of three 0's.
     */
    function hexToRGBArray (hex) {

      hex = hex.replace(/#/, '');

      // If the string is a shorthand three digit hex notation, normalize it to
      // the standard six digit notation
      if (hex.length === 3) {
        hex = hex.split('');
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      hexToRGBArray_returnArray[0] = hexToDec(hex.substr(0, 2));
      hexToRGBArray_returnArray[1] = hexToDec(hex.substr(2, 2));
      hexToRGBArray_returnArray[2] = hexToDec(hex.substr(4, 2));

      return hexToRGBArray_returnArray;
    }

    /*!
     * Convert a base-16 number to base-10.
     *
     * @param {Number|String} hex The value to convert
     *
     * @returns {Number} The base-10 equivalent of `hex`.
     */
    function hexToDec (hex) {
      return parseInt(hex, 16);
    }

    /*!
     * Runs a filter operation on all chunks of a string that match a RegExp
     *
     * @param {RegExp} pattern
     * @param {string} unfilteredString
     * @param {function(string)} filter
     *
     * @return {string}
     */
    function filterStringChunks (pattern, unfilteredString, filter) {
      var pattenMatches = unfilteredString.match(pattern);
      var filteredString = unfilteredString.replace(pattern, VALUE_PLACEHOLDER);

      if (pattenMatches) {
        var pattenMatchesLength = pattenMatches.length;
        var currentChunk;

        for (var i = 0; i < pattenMatchesLength; i++) {
          currentChunk = pattenMatches.shift();
          filteredString = filteredString.replace(
            VALUE_PLACEHOLDER, filter(currentChunk));
        }
      }

      return filteredString;
    }

    /*!
     * Check for floating point values within rgb strings and rounds them.
     *
     * @param {string} formattedString
     *
     * @return {string}
     */
    function sanitizeRGBChunks (formattedString) {
      return filterStringChunks(R_RGB, formattedString, sanitizeRGBChunk);
    }

    /*!
     * @param {string} rgbChunk
     *
     * @return {string}
     */
    function sanitizeRGBChunk (rgbChunk) {
      var numbers = rgbChunk.match(R_UNFORMATTED_VALUES);
      var numbersLength = numbers.length;
      var sanitizedString = rgbChunk.match(R_RGB_PREFIX)[0];

      for (var i = 0; i < numbersLength; i++) {
        sanitizedString += parseInt(numbers[i], 10) + ',';
      }

      sanitizedString = sanitizedString.slice(0, -1) + ')';

      return sanitizedString;
    }

    /*!
     * @param {Object} stateObject
     *
     * @return {Object} An Object of formatManifests that correspond to
     * the string properties of stateObject
     */
    function getFormatManifests (stateObject) {
      var manifestAccumulator = {};

      Tweenable.each(stateObject, function (prop) {
        var currentProp = stateObject[prop];

        if (typeof currentProp === 'string') {
          var rawValues = getValuesFrom(currentProp);

          manifestAccumulator[prop] = {
            'formatString': getFormatStringFrom(currentProp)
            ,'chunkNames': getFormatChunksFrom(rawValues, prop)
          };
        }
      });

      return manifestAccumulator;
    }

    /*!
     * @param {Object} stateObject
     * @param {Object} formatManifests
     */
    function expandFormattedProperties (stateObject, formatManifests) {
      Tweenable.each(formatManifests, function (prop) {
        var currentProp = stateObject[prop];
        var rawValues = getValuesFrom(currentProp);
        var rawValuesLength = rawValues.length;

        for (var i = 0; i < rawValuesLength; i++) {
          stateObject[formatManifests[prop].chunkNames[i]] = +rawValues[i];
        }

        delete stateObject[prop];
      });
    }

    /*!
     * @param {Object} stateObject
     * @param {Object} formatManifests
     */
    function collapseFormattedProperties (stateObject, formatManifests) {
      Tweenable.each(formatManifests, function (prop) {
        var currentProp = stateObject[prop];
        var formatChunks = extractPropertyChunks(
          stateObject, formatManifests[prop].chunkNames);
        var valuesList = getValuesList(
          formatChunks, formatManifests[prop].chunkNames);
        currentProp = getFormattedValues(
          formatManifests[prop].formatString, valuesList);
        stateObject[prop] = sanitizeRGBChunks(currentProp);
      });
    }

    /*!
     * @param {Object} stateObject
     * @param {Array.<string>} chunkNames
     *
     * @return {Object} The extracted value chunks.
     */
    function extractPropertyChunks (stateObject, chunkNames) {
      var extractedValues = {};
      var currentChunkName, chunkNamesLength = chunkNames.length;

      for (var i = 0; i < chunkNamesLength; i++) {
        currentChunkName = chunkNames[i];
        extractedValues[currentChunkName] = stateObject[currentChunkName];
        delete stateObject[currentChunkName];
      }

      return extractedValues;
    }

    var getValuesList_accumulator = [];
    /*!
     * @param {Object} stateObject
     * @param {Array.<string>} chunkNames
     *
     * @return {Array.<number>}
     */
    function getValuesList (stateObject, chunkNames) {
      getValuesList_accumulator.length = 0;
      var chunkNamesLength = chunkNames.length;

      for (var i = 0; i < chunkNamesLength; i++) {
        getValuesList_accumulator.push(stateObject[chunkNames[i]]);
      }

      return getValuesList_accumulator;
    }

    /*!
     * @param {string} formatString
     * @param {Array.<number>} rawValues
     *
     * @return {string}
     */
    function getFormattedValues (formatString, rawValues) {
      var formattedValueString = formatString;
      var rawValuesLength = rawValues.length;

      for (var i = 0; i < rawValuesLength; i++) {
        formattedValueString = formattedValueString.replace(
          VALUE_PLACEHOLDER, +rawValues[i].toFixed(4));
      }

      return formattedValueString;
    }

    /*!
     * Note: It's the duty of the caller to convert the Array elements of the
     * return value into numbers.  This is a performance optimization.
     *
     * @param {string} formattedString
     *
     * @return {Array.<string>|null}
     */
    function getValuesFrom (formattedString) {
      return formattedString.match(R_UNFORMATTED_VALUES);
    }

    /*!
     * @param {Object} easingObject
     * @param {Object} tokenData
     */
    function expandEasingObject (easingObject, tokenData) {
      Tweenable.each(tokenData, function (prop) {
        var currentProp = tokenData[prop];
        var chunkNames = currentProp.chunkNames;
        var chunkLength = chunkNames.length;
        var easingChunks = easingObject[prop].split(' ');
        var lastEasingChunk = easingChunks[easingChunks.length - 1];

        for (var i = 0; i < chunkLength; i++) {
          easingObject[chunkNames[i]] = easingChunks[i] || lastEasingChunk;
        }

        delete easingObject[prop];
      });
    }

    /*!
     * @param {Object} easingObject
     * @param {Object} tokenData
     */
    function collapseEasingObject (easingObject, tokenData) {
      Tweenable.each(tokenData, function (prop) {
        var currentProp = tokenData[prop];
        var chunkNames = currentProp.chunkNames;
        var chunkLength = chunkNames.length;
        var composedEasingString = '';

        for (var i = 0; i < chunkLength; i++) {
          composedEasingString += ' ' + easingObject[chunkNames[i]];
          delete easingObject[chunkNames[i]];
        }

        easingObject[prop] = composedEasingString.substr(1);
      });
    }

    Tweenable.prototype.filter.token = {
      'tweenCreated': function (currentState, fromState, toState, easingObject) {
        sanitizeObjectForHexProps(currentState);
        sanitizeObjectForHexProps(fromState);
        sanitizeObjectForHexProps(toState);
        this._tokenData = getFormatManifests(currentState);
      },

      'beforeTween': function (currentState, fromState, toState, easingObject) {
        expandEasingObject(easingObject, this._tokenData);
        expandFormattedProperties(currentState, this._tokenData);
        expandFormattedProperties(fromState, this._tokenData);
        expandFormattedProperties(toState, this._tokenData);
      },

      'afterTween': function (currentState, fromState, toState, easingObject) {
        collapseFormattedProperties(currentState, this._tokenData);
        collapseFormattedProperties(fromState, this._tokenData);
        collapseFormattedProperties(toState, this._tokenData);
        collapseEasingObject(easingObject, this._tokenData);
      }
    };

  } (Tweenable));

  }(window));

  return window.Tweenable;
});

(function() {
    "use strict";

    angular.module('angular-carousel')

    .filter('carouselSlice', function() {
        return function(collection, start, size) {
            if (angular.isArray(collection)) {
                return collection.slice(start, start + size);
            } else if (angular.isObject(collection)) {
                // dont try to slice collections :)
                return collection;
            }
        };
    });

})();

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-sanitize/angular-sanitize.js":[function(_dereq_,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isArray;
var isDefined;
var lowercase;
var noop;
var nodeContains;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a trusted URI list) are
 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The trusted URIs for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationTrustedUrlList` and `imgSrcSanitizationTrustedUrlList` of {@link $compileProvider}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var hasBeenInstantiated = false;
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    hasBeenInstantiated = true;
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidElements
   * @kind function
   *
   * @description
   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
   * and are not stripped off during sanitization. You can extend the following lists of elements:
   *
   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
   *   elements. HTML elements considered safe will not be removed during sanitization. All other
   *   elements will be stripped off.
   *
   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
   *   "void elements" (similar to HTML
   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
   *   elements have no end tag and cannot have content.
   *
   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
   *   `$sanitize`.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the elements you add.
   * </div>
   *
   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
   *   more of the following properties:
   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     HTML elements.
   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
   *     void HTML elements; i.e. elements that do not have an end tag.
   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
   *     elements. The list of SVG elements is only taken into account if SVG is
   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
   *
   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
   *
   * @return {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidElements = function(elements) {
    if (!hasBeenInstantiated) {
      if (isArray(elements)) {
        elements = {htmlElements: elements};
      }

      addElementsTo(svgElements, elements.svgElements);
      addElementsTo(voidElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlVoidElements);
      addElementsTo(validElements, elements.htmlElements);
    }

    return this;
  };


  /**
   * @ngdoc method
   * @name $sanitizeProvider#addValidAttrs
   * @kind function
   *
   * @description
   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
   * not stripped off during sanitization.
   *
   * **Note**:
   * The new attributes will not be treated as URI attributes, which means their values will not be
   * sanitized as URIs using `$compileProvider`'s
   * {@link ng.$compileProvider#aHrefSanitizationTrustedUrlList aHrefSanitizationTrustedUrlList} and
   * {@link ng.$compileProvider#imgSrcSanitizationTrustedUrlList imgSrcSanitizationTrustedUrlList}.
   *
   * <div class="alert alert-info">
   *   This method must be called during the {@link angular.Module#config config} phase. Once the
   *   `$sanitize` service has been instantiated, this method has no effect.
   * </div>
   *
   * <div class="alert alert-warning">
   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
   *   other vulnerabilities. Be very mindful of the attributes you add.
   * </div>
   *
   * @param {Array<String>} attrs - A list of valid attributes.
   *
   * @returns {$sanitizeProvider} Returns self for chaining.
   */
  this.addValidAttrs = function(attrs) {
    if (!hasBeenInstantiated) {
      extend(validAttrs, arrayToMap(attrs, true));
    }
    return this;
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isArray = angular.isArray;
  isDefined = angular.isDefined;
  lowercase = angular.$$lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = stringToMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = stringToMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = stringToMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');

  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function stringToMap(str, lowercaseKeys) {
    return arrayToMap(str.split(','), lowercaseKeys);
  }

  function arrayToMap(items, lowercaseKeys) {
    var obj = {}, i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  function addElementsTo(elementsMap, newElements) {
    if (newElements && newElements.length) {
      extend(elementsMap, arrayToMap(newElements));
    }
  }

  /**
   * Create an inert document that contains the dirty HTML that needs sanitizing.
   * We use the DOMParser API by default and fall back to createHTMLDocument if DOMParser is not
   * available.
   */
  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
    if (isDOMParserAvailable()) {
      return getInertBodyElement_DOMParser;
    }

    if (!document || !document.implementation) {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var inertDocument = document.implementation.createHTMLDocument('inert');
    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
    return getInertBodyElement_InertDocument;

    function isDOMParserAvailable() {
      try {
        return !!getInertBodyElement_DOMParser('');
      } catch (e) {
        return false;
      }
    }

    function getInertBodyElement_DOMParser(html) {
      // We add this dummy element to ensure that the rest of the content is parsed as expected
      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
      html = '<remove></remove>' + html;
      try {
        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
        body.firstChild.remove();
        return body;
      } catch (e) {
        return undefined;
      }
    }

    function getInertBodyElement_InertDocument(html) {
      inertBodyElement.innerHTML = html;

      // Support: IE 9-11 only
      // strip custom-namespaced attributes on IE<=11
      if (document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }

      return inertBodyElement;
    }
  })(window, window.document);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }

    var inertBodyElement = getInertBodyElement(html);
    if (!inertBodyElement) return '';

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // trigger mXSS if it is going to happen by reading and writing the innerHTML
      html = inertBodyElement.innerHTML;
      inertBodyElement = getInertBodyElement(html);
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = getNonDescendant('nextSibling', node);
        if (!nextNode) {
          while (nextNode == null) {
            node = getNonDescendant('parentNode', node);
            if (node === inertBodyElement) break;
            nextNode = getNonDescendant('nextSibling', node);
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = getNonDescendant('nextSibling', node);
    }
  }

  function getNonDescendant(propName, node) {
    // An element is clobbered if its `propName` property points to one of its descendants
    var nextNode = node[propName];
    if (nextNode && nodeContains.call(node, nextNode)) {
      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
    }
    return nextNode;
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', [])
  .provider('$sanitize', $SanitizeProvider)
  .info({ angularVersion: '1.8.3' });

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-sanitize/index.js":[function(_dereq_,module,exports){
_dereq_('./angular-sanitize');
module.exports = 'ngSanitize';

},{"./angular-sanitize":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-sanitize/angular-sanitize.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-touch/angular-touch.js":[function(_dereq_,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * The `ngTouch` module provides helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)). *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * @deprecated
 * sinceVersion="1.7.0"
 * The ngTouch module with the {@link ngTouch.$swipe `$swipe`} service and
 * the {@link ngTouch.ngSwipeLeft} and {@link ngTouch.ngSwipeRight} directives are
 * deprecated. Instead, stand-alone libraries for touch handling and gesture interaction
 * should be used, for example [HammerJS](https://hammerjs.github.io/) (which is also used by
 * Angular).
 */

// define ngTouch module
/* global ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.info({ angularVersion: '1.8.3' });

function nodeName_(element) {
  return angular.$$lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @deprecated
     * sinceVersion="1.7.0"
     *
     * See the {@link ngTouch module} documentation for more information.
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        if (eventHandlers['start']) {
          eventHandlers['start'](startCoords, event);
        }
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          if (eventHandlers['move']) {
            eventHandlers['move'](coords, event);
          }
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        if (eventHandlers['end']) {
          eventHandlers['end'](getCoordinates(event), event);
        }
      });
    }
  };
}]);

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @deprecated
 * sinceVersion="1.7.0"
 *
 * See the {@link ngTouch module} documentation for more information.
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-touch/index.js":[function(_dereq_,module,exports){
_dereq_('./angular-touch');
module.exports = 'ngTouch';

},{"./angular-touch":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-touch/angular-touch.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-ui-router/release/angular-ui-router.js":[function(_dereq_,module,exports){
/**
 * State-based routing for AngularJS
 * @version v0.2.18
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = resolution.promise,
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = invocation.promise;
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
function $TemplateFactory(  $http,   $templateCache,   $injector) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else return $http
        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
        .then(function(response) { return response.data; });
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
      pattern: /\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
    var TransitionPrevented = $q.reject(new Error('transition prevented'));
    var TransitionAborted = $q.reject(new Error('transition aborted'));
    var TransitionFailed = $q.reject(new Error('transition failed'));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) return TransitionSuperseded;
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) return TransitionSuperseded;

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) return TransitionSuperseded;

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }, function (error) {
        if ($state.transition !== transition) return TransitionSuperseded;

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
            $urlRouter.update();
        }

        return $q.reject(error);
      });

      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .provider('$state', $StateProvider);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

var ngMajorVer = angular.version.major;
var ngMinorVer = angular.version.minor;
/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
 * will be applied to the ui-view)
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 * 
 * @example
 * A view can be unnamed or named. 
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div> 
 * 
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a 
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div> 
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 * 
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * But typically you'll only use the views property if you name your view or have more than one view 
 * in the same template. There's not really a compelling reason to name a view if its the only one, 
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre> 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 * 
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div> 
 * <div ui-view="data"></div> 
 * </pre>
 * 
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = {
      enter: function (element, target, cb) { target.after(element); cb(); },
      leave: function (element, cb) { element.remove(); cb(); }
    };

    if (!!attrs.noanimation) return statics;

    function animEnabled(element) {
      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
      return (!!$animator);
    }

    // ng 1.2+
    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (!animEnabled(element)) {
            statics.enter(element, target, cb);
          } else if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (!animEnabled(element)) {
            statics.leave(element, cb);
          } else if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    // ng 1.1.5
    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics;
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope);

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          var _previousEl = previousEl;
          var _currentScope = currentScope;

          if (_currentScope) {
            _currentScope._willBeDestroyed = true;
          }

          function cleanOld() {
            if (_previousEl) {
              _previousEl.remove();
            }

            if (_currentScope) {
              _currentScope.$destroy();
            }
          }

          if (currentEl) {
            renderer.leave(currentEl, function() {
              cleanOld();
              previousEl = null;
            });

            previousEl = currentEl;
          } else {
            cleanOld();
            previousEl = null;
          }

          currentEl = null;
          currentScope = null;
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            renderer.enter(clone, $element, function onUiViewEnter() {
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
          }
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var inherited = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (active) active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (active) active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        addState(newState, newParams, uiSrefActive);
        update();
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        states.push({
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        });

        activeClasses[stateHash] = activeClass;
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular/angular.js":[function(_dereq_,module,exports){
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

var minErrConfig = {
  objectMaxDepth: 5,
  urlErrorParamsEnabled: true
};

/**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 *
 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
 *   generated error url is very long.
 *
 *   Default: true. When used without argument, it returns the current value.
 */
function errorHandlingConfig(config) {
  if (isObject(config)) {
    if (isDefined(config.objectMaxDepth)) {
      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
    }
    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
    }
  } else {
    return minErrConfig;
  }
}

/**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
function isValidObjectMaxDepth(maxDepth) {
  return isNumber(maxDepth) && maxDepth > 0;
}


/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace'). Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;

  var url = 'https://errors.angularjs.org/1.8.3/';
  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
  var errRegExp = new RegExp(regex, 'g');

  return function() {
    var code = arguments[0],
      template = arguments[1],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
      paramPrefix, i;

    // A minErr message has two parts: the message itself and the url that contains the
    // encoded message.
    // The message's parameters can contain other error messages which also include error urls.
    // To prevent the messages from getting too long, we strip the error urls from the parameters.

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1);

      if (index < templateArgs.length) {
        return templateArgs[index].replace(errRegExp, '');
      }

      return match;
    });

    message += '\n' + url + (module ? module + '/' : '') + code;

    if (minErrConfig.urlErrorParamsEnabled) {
      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
      }
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  addDateMinutes,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,
  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @private
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @private
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (key !== '__proto__') {
            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
            baseExtend(dst[key], [src], true);
          }
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest using another, similar library for all-purpose merging,
* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* `angular.merge` also does not support merging objects with circular references.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
function isArray(arr) {
  return Array.isArray(arr) || arr instanceof Array;
}

/**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
function isError(value) {
  var tag = toString.call(value);
  switch (tag) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
 * function, and has several limitations (see below).
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 *
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * <div class="alert alert-warning">
 *   `angular.copy` does not check if destination and source are of the same type. It's the
 *   developer's responsibility to make sure they are compatible.
 * </div>
 *
 * @knownIssue
 * This is a non-exhaustive list of object types / features that are not handled correctly by
 * `angular.copy`. Note that since this functions is used by the change detection code, this
 * means binding or watching objects of these types (or that include these types) might not work
 * correctly.
 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
 *
 * @param {*} source The source that will be used to make a copy. Can be any type, including
 *     primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
 *     must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination, maxDepth) {
  var stackSource = [];
  var stackDest = [];
  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination, maxDepth);
  }

  return copyElement(source, maxDepth);

  function copyRecurse(source, destination, maxDepth) {
    maxDepth--;
    if (maxDepth < 0) {
      return '...';
    }
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i], maxDepth));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key], maxDepth);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source, maxDepth) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination, maxDepth)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


// eslint-disable-next-line no-self-compare
function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone().empty();
  var elemHtml = jqLite('<div></div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;

  if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
    return true;
  }

  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
    return false;
  }

  var attributes = script.attributes;
  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

  return srcs.every(function(src) {
    if (!src) {
      return true;
    }
    if (!src.value) {
      return false;
    }

    var link = document.createElement('a');
    link.href = src.value;

    if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for banned URL schemes.
      return true;
    }
    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
    // content security policy in web pages and other browser extensions.
    switch (link.protocol) {
      case 'http:':
      case 'https:':
      case 'ftp:':
      case 'blob:':
      case 'file:':
      case 'data:':
        return true;
      default:
        return false;
    }
  });
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: /** @type {?} */ (JQLitePrototype).controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });
  } else {
    jqLite = JQLite;
  }

  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
  // the $destroy event on all removed nodes.
  originalCleanData = jqLite.cleanData;
  jqLite.cleanData = function(elems) {
    var events;
    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
      events = (jqLite._data(elem) || {}).events;
      if (events && events.$destroy) {
        jqLite(elem).triggerHandler('$destroy');
      }
    }
    originalCleanData(elems);
  };

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * @ngdoc function
 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
 * @module ng
 * @kind function
 *
 * @description
 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
 * your code for this change and remove your use of this function as soon as possible.

 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 */
function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
  JQLite.legacyXHTMLReplacement = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {

      var info = {};

      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
          info: function(value) {
            if (isDefined(value)) {
              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
              info = value;
              return this;
            }
            return info;
          },

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
           *    or an object map of components where the keys are the names and the values are the component definition objects.
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* exported toDebugString */

function serializeObject(obj, maxDepth) {
  var seen = [];

  // There is no direct way to stringify object until reaching a specific depth
  // and a very deep object can cause a performance issue, so we copy the object
  // based on this specific depth and then stringify it.
  if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
    obj = angular.copy(obj, null, maxDepth);
  }
  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj, maxDepth) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj, maxDepth);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  hiddenInputBrowserCacheDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRefDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $$IntervalFactoryProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $$TaskTrackerFactoryProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.8.3',
  major: 1,
  minor: 8,
  dot: 3,
  codeName: 'ultimate-farewell'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'errorHandlingConfig': errorHandlingConfig,
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$lowercase': lowercase,
    '$$stringify': stringify,
    '$$uppercase': uppercase
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRef: ngRefDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective,
          input: hiddenInputBrowserCacheDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $$intervalFactory: $$IntervalFactoryProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ])
  .info({ angularVersion: '1.8.3' });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
 * ```js
 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
 * ```
 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
 * about the workarounds.
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

// Table parts need to be wrapped with `<table>` or they're
// stripped to their contents when put in a div.
// XHTML parsers do not magically insert elements in the
// same way that tag soup parsers do, so we cannot shorten
// this by omitting <tbody> or other required elements.
var wrapMap = {
  thead: ['table'],
  col: ['colgroup', 'table'],
  tr: ['tbody', 'table'],
  td: ['tr', 'tbody', 'table']
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <10 only
// IE 9 requires an option wrapper & it needs to have the whole table structure
// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
var wrapMapIE9 = {
  option: [1, '<select multiple="multiple">', '</select>'],
  _default: [0, '', '']
};

for (var key in wrapMap) {
  var wrapMapValueClosing = wrapMap[key];
  var wrapMapValue = wrapMapValueClosing.slice().reverse();
  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
}

wrapMapIE9.optgroup = wrapMapIE9.option;

function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap, finalHtml,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    finalHtml = JQLite.legacyXHTMLReplacement ?
      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
      html;

    if (msie < 10) {
      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];

      // Descend through wrappers to the right content
      i = wrap[0];
      while (i--) {
        tmp = tmp.firstChild;
      }
    } else {
      wrap = wrapMap[tag] || [];

      // Create wrappers & descend into them
      i = wrap.length;
      while (--i > -1) {
        tmp.appendChild(window.document.createElement(wrap[i]));
        tmp = tmp.firstChild;
      }

      tmp.innerHTML = finalHtml;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

  if (element.querySelectorAll) {
    jqLite.cleanData(element.querySelectorAll('*'));
  }
}

function isEmptyObject(obj) {
  var name;

  for (name in obj) {
    return false;
  }
  return true;
}

function removeIfEmptyData(element) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  var events = expandoStore && expandoStore.events;
  var data = expandoStore && expandoStore.data;

  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }

  removeIfEmptyData(element);
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
    } else {
      expandoStore.data = {};
    }

    removeIfEmptyData(element);
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
        newClasses += cssClass + ' ';
      }
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: function jqLiteCleanData(nodes) {
    for (var i = 0, ii = nodes.length; i < ii; i++) {
      jqLiteRemoveData(nodes[i]);
      jqLiteOff(nodes[i]);
    }
  }
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

// A minimal ES2015 Map implementation.
// Should be bug/feature equivalent to the native implementations of supported browsers
// (for the features required in Angular).
// See https://kangax.github.io/compat-table/es6/#test-Map
var nanKey = Object.create(null);
function NgMapShim() {
  this._keys = [];
  this._values = [];
  this._lastKey = NaN;
  this._lastIndex = -1;
}
NgMapShim.prototype = {
  _idx: function(key) {
    if (key !== this._lastKey) {
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
    }
    return this._lastIndex;
  },
  _transformKey: function(key) {
    return isNumberNaN(key) ? nanKey : key;
  },
  get: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx !== -1) {
      return this._values[idx];
    }
  },
  has: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    return idx !== -1;
  },
  set: function(key, value) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      idx = this._lastIndex = this._keys.length;
    }
    this._keys[idx] = key;
    this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
  },
  delete: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      return false;
    }
    this._keys.splice(idx, 1);
    this._values.splice(idx, 1);
    this._lastKey = NaN;
    this._lastIndex = -1;
    return true;
  }
};

// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
// implementations get more stable, we can reconsider switching to `window.Map` (when available).
var NgMap = NgMapShim;

var $$MapProvider = [/** @this */function() {
  this.$get = [function() {
    return NgMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  return Function.prototype.toString.call(fn);
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */


/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
/**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */


/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  instanceInjector.modules = providerInjector.modules = createMap();
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  instanceInjector.loadNewModules = function(mods) {
    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
  };


  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.set(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          instanceInjector.modules[module] = moduleFn;
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new NgMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.delete(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.set(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;
  var classNameFilter = null;
  var customFilter = null;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
  this.customFilter = function(filterFn) {
    if (arguments.length === 1) {
      customFilter = isFunction(filterFn) ? filterFn : null;
    }

    return customFilter;
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (classNameFilter) {
        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
        if (reservedRegex.test(classNameFilter.toString())) {
          classNameFilter = null;
          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * <div class="alert alert-warning">
       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
       * However, there are two exceptions:
       *
       * <ul>
       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
       *   the `setClass` event, but if it either removes or adds classes,
       *   it will fire `animate` instead.</li>
       * </ul>
       *
       * </div>
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered.
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       * * `data` - an object with these properties:
       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
       *
       * Note that the callback does not trigger a scope digest. Wrap your call into a
       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation and applies the end state of the animation.
       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
       * adding the element to the DOM.
       *
       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
       *
       * @example
        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
          <file name="app.js">
            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
              templateUrl: 'template.html',
              controller: function($element, $animate) {
                this.runner = null;

                this.addClass = function() {
                  this.runner = $animate.addClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.removeClass = function() {
                  this.runner = $animate.removeClass($element.find('div'), 'red');
                  var ctrl = this;
                  this.runner.finally(function() {
                    ctrl.runner = null;
                  });
                };

                this.cancel = function() {
                  $animate.cancel(this.runner);
                };
              }
            });
          </file>
          <file name="template.html">
            <p>
              <button id="add" ng-click="$ctrl.addClass()">Add</button>
              <button ng-click="$ctrl.removeClass()">Remove</button>
              <br>
              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
              <br>
              <div id="target">CSS-Animated Text</div>
            </p>
          </file>
          <file name="index.html">
            <cancel-example></cancel-example>
          </file>
          <file name="style.css">
            .red-add, .red-remove {
              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
            }

            .red,
            .red-add.red-add-active {
              color: #FF0000;
              font-size: 40px;
            }

            .red-remove.red-remove-active {
              font-size: 10px;
              color: black;
            }

          </file>
        </example>
       */
      cancel: function(runner) {
        if (runner.cancel) {
          runner.cancel();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} animationRunner the animation runner
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Runner} the animation runner
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global getHash: true, stripHash: false */

function getHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? '' : url.substr(index);
}

function trimEmptyHash(url) {
  return url.replace(/#$/, '');
}

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {},
      taskTracker = $$taskTrackerFactory($log);

  self.isMock = false;

  //////////////////////////////////////////////////////////////
  // Task-tracking API
  //////////////////////////////////////////////////////////////

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = taskTracker.completeTask;
  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;

  // TODO(vojta): prefix this method with $$ ?
  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of `location.href` (with a
   * trailing `#` stripped of if the hash is empty).
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
   * `location.href`/`location.replace` is used.
   * Returns its own instance to allow chaining.
   *
   * NOTE: this api is intended for use only by the `$location` service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state State object to use with `pushState`/`replaceState`
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Normalize the inputted URL
      url = urlResolve(url).href;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      return trimEmptyHash(pendingLocation || location.href);
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    fireStateOrUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }

    lastCachedState = cachedState;
    lastHistoryState = cachedState;
  }

  function fireStateOrUrlChange() {
    var prevLastHistoryState = lastHistoryState;
    cacheState();

    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireStateOrUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay, taskType) {
    var timeoutId;

    delay = delay || 0;
    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;

    taskTracker.incTaskCount(taskType);
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      taskTracker.completeTask(fn, taskType);
    }, delay);
    pendingDeferIds[timeoutId] = taskType;

    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds.hasOwnProperty(deferId)) {
      var taskType = pendingDeferIds[deferId];
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      taskTracker.completeTask(noop, taskType);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
  }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance.)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
 *   isn't  optional and doesn't exist, an exception
 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
 *   to the local value, since it will be impossible to sync them back to the parent scope.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr`
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   It's also possible to watch the evaluated value shallowly with
 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
 * The marker must come after the mode and before the attribute name.
 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
 * This is useful to refine the interface directives provide.
 * One subtle difference between optional and non-optional happens **when the binding attribute is not
 * set**:
 * - the binding is optional: the property will not be defined
 * - the binding is not optional: the property is defined
 *
 * ```js
 *app.directive('testDir', function() {
    return {
      scope: {
        notoptional: '=',
        optional: '=?',
      },
      bindToController: true,
      controller: function() {
        this.$onInit = function() {
          console.log(this.hasOwnProperty('notoptional')) // true
          console.log(this.hasOwnProperty('optional')) // false
        }
      }
    }
  })
 *```
 *
 *
 * ##### Combining directives with different scope defintions
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace`
 * <div class="alert alert-danger">
 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
 * </div>
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that are defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // Configure new 'compile' directive by passing a directive
        // factory function. The factory function injects '$compile'.
        $compileProvider.directive('compile', function($compile) {
          // The directive factory creates a link function.
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                // Watch the 'compile' expression for changes.
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // When the 'compile' expression changes
                // assign it into the current DOM.
                element.html(value);

                // Compile the new DOM and link it to the current scope.
                // NOTE: we only compile '.childNodes' so that we
                // don't get into an infinite loop compiling ourselves.
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
 *        elements (e.g. SVG elements). See also the `directive.controller` property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to `$digest`, which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = angular.element('<p>{{total}}</p>');
 *     $compile(element)(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
 *   linking function:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>');
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       // Attach the clone to DOM document at the right place.
 *     });
 *
 *     // Now we have reference to the cloned DOM via `clonedElement`.
 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
 *     //       `clonedElement` passed to `cloneAttachFn`.
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.

 * @knownIssue

   ### Issues with `replace: true`
 *
 * <div class="alert alert-danger">
 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
 * </div>
 *
 * #### Attribute values are not merged
 *
 * When a `replace` directive encounters the same attribute on the original and the replace node,
 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
 * the `style` attribute.
 * ```html
 * Original Node: <span class="original" style="color: red;"></span>
 * Replace Template: <span class="replaced" style="background: blue;"></span>
 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
 * ```
 *
 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
 *
 * ```html
 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
 * ```
 *
 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
 *
 * #### Directives are not deduplicated before compilation
 *
 * When the original node and the replace template declare the same directive(s), they will be
 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
 * attach `$formatters` and `$parsers` twice.
 *
 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
 *
 * #### `transclude: element` in the replace template root can have unexpected effects
 *
 * When the replace template has a directive at the root node that uses
 * {@link $compile#-transclude- `transclude: element`}, e.g.
 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
 * See the following issues:
 *
 * - Incorrect scope on replaced element:
 * [#9837](https://github.com/angular/angular.js/issues/9837)
 * - Different DOM between `template` and `templateUrl`:
 * [#10612](https://github.com/angular/angular.js/issues/14326)
 *
 */

/**
 * @ngdoc directive
 * @name ngProp
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-prop-propname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "propName"):
 *
 *
 * ```html
 * <ANY ng-prop-prop_name="expression">
 * </ANY>
 * ```
 *
 *
 * @description
 * The `ngProp` directive binds an expression to a DOM element property.
 * `ngProp` allows writing to arbitrary properties by including
 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
 * the `value` property.
 *
 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
 *
 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
 * custom elements.
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
 * example, and for binding HTML {@link ngBindHtml} should be used.
 *
 * ## Security
 *
 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
 * malicious code.
 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
 * This means vulnerable properties require their content to be "trusted", based on the
 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
 * this property are trusted as a `RESOURCE_URL`.
 *
 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
 *
 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
 *
 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
 *
 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
 *
 * ### HTML Sanitization
 *
 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
 * content.
 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
 * `innerHTML`.
 *
 * @example
 * ### Binding to different contexts
 *
 * <example name="ngProp" module="exampleNgProp">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         Binding to a property without security context:
 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerText</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... so that actually dangerous content cannot be executed:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Binding to innerHTML with ngSanitize
 *
 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
 *   <file name="app.js">
 *     angular.module('exampleNgProp', ['ngSanitize'])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function($sce) {
 *           this.safeContent = '<strong>Safe content</strong>';
 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       <div class="prop-unit">
 *         "Safe" content will be sanitized ...
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
 *         <span class="prop-note">innerHTML</span> (safeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... as will dangerous content:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (unsafeContent)
 *       </div>
 *
 *       <div class="prop-unit">
 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 *   <file name="styles.css">
 *     .prop-unit {
 *       margin-bottom: 10px;
 *     }
 *
 *     .prop-binding {
 *       min-height: 30px;
 *       border: 1px solid blue;
 *     }
 *
 *     .prop-note {
 *       font-family: Monospace;
 *     }
 *   </file>
 * </example>
 *
 */

/** @ngdoc directive
 * @name ngOn
 * @restrict A
 * @element ANY
 *
 * @usage
 *
 * ```html
 * <ANY ng-on-eventname="expression">
 * </ANY>
 * ```
 *
 * or with uppercase letters in property (e.g. "eventName"):
 *
 *
 * ```html
 * <ANY ng-on-event_name="expression">
 * </ANY>
 * ```
 *
 * @description
 * The `ngOn` directive adds an event listener to a DOM element via
 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
 * fired.
 * `ngOn` allows adding listeners for arbitrary events by including
 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
 * when the `drop` event is fired.
 *
 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
 * standards.
 *
 * Another use-case for `ngOn` is listening to
 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
 * fired by
 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
 *
 * ## Binding to camelCase properties
 *
 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
 * `myEvent` must be written as `ng-on-my_event="expression"`.
 *
 * @example
 * ### Bind to built-in DOM events
 *
 * <example name="ngOn" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.clickCount = 0;
 *           this.mouseoverCount = 0;
 *
 *           this.loadingState = 0;
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <div>
 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
 *       <button
 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
 *       clickCount: {{$ctrl.clickCount}}<br>
 *       mouseover: {{$ctrl.mouseoverCount}}
 *
 *       <hr>
 *
 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
 *       <div ng-switch="$ctrl.loadingState">
 *         <span ng-switch-when="0">Image is loading</span>
 *         <span ng-switch-when="-1">Image load error</span>
 *         <span ng-switch-when="1">Image loaded successfully</span>
 *       </div>
 *     </div>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 *
 *
 * @example
 * ### Bind to custom DOM events
 *
 * <example name="ngOnCustom" module="exampleNgOn">
 *   <file name="app.js">
 *     angular.module('exampleNgOn', [])
 *       .component('main', {
 *         templateUrl: 'main.html',
 *         controller: function() {
 *           this.eventLog = '';
 *
 *           this.listener = function($event) {
 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
 *           };
 *         }
 *       })
 *       .component('childComponent', {
 *         templateUrl: 'child.html',
 *         controller: function($element) {
 *           this.fireEvent = function() {
 *             var event = new CustomEvent('customtype', { detail: new Date()});
 *
 *             $element[0].dispatchEvent(event);
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="main.html">
 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
 *     <span>Event log: {{$ctrl.eventLog}}</span>
 *   </file>
 *   <file name="child.html">
      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
 *   </file>
 *   <file name="index.html">
 *     <main></main>
 *   </file>
 * </example>
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      definition = definition.trim();

      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var _dereq_ = directive.require || (directive.controller && directive.name);

    if (!isArray(_dereq_) && isObject(_dereq_)) {
      forEach(_dereq_, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) _dereq_[key] = match[0] + key;
      });
    }

    return _dereq_;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
   *    are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    if (!isString(name)) {
      forEach(name, reverseParams(bind(this, registerComponent)));
      return this;
    }

    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
   * aHrefSanitizationTrustedUrlList} instead.
   */
  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
    get: function() {
      return this.aHrefSanitizationTrustedUrlList;
    },
    set: function(value) {
      this.aHrefSanitizationTrustedUrlList = value;
    }
  });


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
   * imgSrcSanitizationTrustedUrlList} instead.
   */
  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
    get: function() {
      return this.imgSrcSanitizationTrustedUrlList;
    },
    set: function(value) {
      this.imgSrcSanitizationTrustedUrlList = value;
    }
  });

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
   * otherwise return the current strictComponentBindingsEnabled state.
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable / disable the strict component bindings check. If enabled, the
   * compiler will enforce that all scope / controller bindings of a
   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
   * that are not set as optional with `?`, must be provided when the directive is instantiated.
   * If not provided, the compiler will throw the
   * {@link error/$compile/missingattr $compile:missingattr error}.
   *
   * The default value is false.
   */
  var strictComponentBindingsEnabled = false;
  this.strictComponentBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      strictComponentBindingsEnabled = enabled;
      return this;
    }
    return strictComponentBindingsEnabled;
  };

  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };


  /**
   * The security context of DOM Properties.
   * @private
   */
  var PROP_CONTEXTS = createMap();

  /**
   * @ngdoc method
   * @name $compileProvider#addPropertySecurityContext
   * @description
   *
   * Defines the security context for DOM properties bound by ng-prop-*.
   *
   * @param {string} elementName The element name or '*' to match any element.
   * @param {string} propertyName The DOM property name.
   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
   * @returns {object} `this` for chaining
   */
  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());

    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
    }

    PROP_CONTEXTS[key] = ctx;
    return this;
  };

  /* Default property contexts.
   *
   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
   * Changing:
   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
   * - STYLE => CSS
   * - various URL => MEDIA_URL
   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
   */
  (function registerNativePropertyContexts() {
    function registerContext(ctx, values) {
      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
    }

    registerContext(SCE_CONTEXTS.HTML, [
      'iframe|srcdoc',
      '*|innerHTML',
      '*|outerHTML'
    ]);
    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
    registerContext(SCE_CONTEXTS.URL, [
      'area|href',       'area|ping',
      'a|href',          'a|ping',
      'blockquote|cite',
      'body|background',
      'del|cite',
      'input|src',
      'ins|cite',
      'q|cite'
    ]);
    registerContext(SCE_CONTEXTS.MEDIA_URL, [
      'audio|src',
      'img|src',    'img|srcset',
      'source|src', 'source|srcset',
      'track|src',
      'video|src',  'video|poster'
    ]);
    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
      '*|formAction',
      'applet|code',      'applet|codebase',
      'base|href',
      'embed|src',
      'frame|src',
      'form|action',
      'head|profile',
      'html|manifest',
      'iframe|src',
      'link|href',
      'media|src',
      'object|codebase',  'object|data',
      'script|src'
    ]);
  })();


  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
        });
      } finally {
        onChangesTtl++;
      }
    }


    function sanitizeSrcset(value, invokeType) {
      if (!value) {
        return value;
      }
      if (!isString(value)) {
        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
      }

      // Such values are a bit too complex to handle automatically inside $sce.
      // Instead, we sanitize each of the URIs individually, which works, even dynamically.

      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
      // `ng-bind-html` directive.

      var result = '';

      // first check if there are spaces because it's not the same pattern
      var trimmedSrcset = trim(value);
      //                (   999x   ,|   999w   ,|   ,|,   )
      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

      // split srcset into tuple of uri and descriptor except for the last item
      var rawUris = trimmedSrcset.split(pattern);

      // for each tuples
      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
      for (var i = 0; i < nbrUrisWith2parts; i++) {
        var innerIdx = i * 2;
        // sanitize the uri
        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
        // add the descriptor
        result += ' ' + trim(rawUris[innerIdx + 1]);
      }

      // split the last item into uri and descriptor
      var lastTuple = trim(rawUris[i * 2]).split(/\s/);

      // sanitize the last uri
      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));

      // and add the last descriptor if any
      if (lastTuple.length === 2) {
        result += (' ' + trim(lastTuple[1]));
      }
      return result;
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        // is set through this function since it may cause $updateClass to
        // become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        // Sanitize img[srcset] values.
        if (nodeName === 'img' && key === 'srcset') {
          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              // jQuery skips special boolean attrs treatment in XML nodes for
              // historical reasons and hence AngularJS cannot freely call
              // `.attr(attrName, false) with such attributes. To avoid issues
              // in XHTML, call `removeAttr` in such cases instead.
              // See https://github.com/jquery/jquery/issues/4249
              if (booleanKey && value === false) {
                this.$$element.removeAttr(attrName);
              } else {
                this.$$element.attr(attrName, value);
              }
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            var isNgAttr = false, isNgProp = false, isNgEvent = false;
            var multiElementMatch;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            nName = directiveNormalize(name.toLowerCase());

            // Support ng-attr-*, ng-prop-* and ng-on-*
            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
              isNgAttr = ngPrefixMatch[1] === 'Attr';
              isNgProp = ngPrefixMatch[1] === 'Prop';
              isNgEvent = ngPrefixMatch[1] === 'On';

              // Normalize the non-prefixed name
              name = name.replace(PREFIX_REGEXP, '')
                .toLowerCase()
                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });

            // Support *-start / *-end multi element directives
            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            if (isNgProp || isNgEvent) {
              attrs[nName] = value;
              attrsMap[nName] = attr.name;

              if (isNgProp) {
                addPropertyDirective(node, directives, nName, name);
              } else {
                addEventDirective(directives, nName, name);
              }
            } else {
              // Update nName for cases where a prefix was removed
              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
              nName = directiveNormalize(name.toLowerCase());
              attrsMap[nName] = name;

              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
              }

              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                            attrEndName);
            }
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = window.document.createDocumentFragment();

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
                  slots[slotName].appendChild(node);
                } else {
                  $template.appendChild(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                }
              }

              $template = jqLite($template.childNodes);
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          controller.instance = controller();
          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
          controller.bindingInfo =
            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var _dereq_ = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(_dereq_) && isObject(_dereq_)) {
            extend(elementControllers[name].instance, getControllers(name, _dereq_, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, _dereq_, $element, elementControllers) {
      var value;

      if (isString(_dereq_)) {
        var match = _dereq_.match(REQUIRE_PREFIX_REGEXP);
        var name = _dereq_.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';

          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
            // inheritedData() uses the documentElement when it finds the document, so we would
            // require from the element itself.
            value = null;
          } else {
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(_dereq_)) {
        value = [];
        for (var i = 0, ii = _dereq_.length; i < ii; i++) {
          value[i] = getControllers(directiveName, _dereq_[i], $element, elementControllers);
        }
      } else if (isObject(_dereq_)) {
        value = {};
        forEach(_dereq_, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedAttrContext(nodeName, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      // All nodes with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media nodes, which require the MEDIA_URL context.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
          return $sce.RESOURCE_URL;
        }
        return $sce.MEDIA_URL;
      } else if (attrNormalizedName === 'xlinkHref') {
        // Some xlink:href are okay, most aren't
        if (nodeName === 'image') return $sce.MEDIA_URL;
        if (nodeName === 'a') return $sce.URL;
        return $sce.RESOURCE_URL;
      } else if (
          // Formaction
          (nodeName === 'form' && attrNormalizedName === 'action') ||
          // If relative URLs can go where they are not expected to, then
          // all sorts of trust issues can arise.
          (nodeName === 'base' && attrNormalizedName === 'href') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (nodeName === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
                                 attrNormalizedName === 'ngHref')) {
        return $sce.URL;
      }
    }

    function getTrustedPropContext(nodeName, propNormalizedName) {
      var prop = propNormalizedName.toLowerCase();
      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
    }

    function sanitizeSrcsetPropertyValue(value) {
      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
    }
    function addPropertyDirective(node, directives, attrName, propName) {
      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
      }

      var nodeName = nodeName_(node);
      var trustedContext = getTrustedPropContext(nodeName, propName);

      var sanitizer = identity;
      // Sanitize img[srcset] + source[srcset] values.
      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
        sanitizer = sanitizeSrcsetPropertyValue;
      } else if (trustedContext) {
        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
      }

      directives.push({
        priority: 100,
        compile: function ngPropCompileFn(_, attr) {
          var ngPropGetter = $parse(attr[attrName]);
          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
            return $sce.valueOf(val);
          });

          return {
            pre: function ngPropPreLinkFn(scope, $element) {
              function applyPropValue() {
                var propValue = ngPropGetter(scope);
                $element[0][propName] = sanitizer(propValue);
              }

              applyPropValue();
              scope.$watch(ngPropWatch, applyPropValue);
            }
          };
        }
      });
    }

    function addEventDirective(directives, attrName, eventName) {
      directives.push(
        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
      );
    }

    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var nodeName = nodeName_(node);
      var trustedContext = getTrustedAttrContext(nodeName, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }

    function strictBindingsCheck(attrName, directiveName) {
      if (strictComponentBindingsEnabled) {
        throw $compileMinErr('missingattr',
          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
          attrName, directiveName);
      }
    }

    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;

      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
              destination[scopeName] = attrs[attrName] = undefined;

            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = simpleCompare;
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var isLiteral = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            });

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
            }
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {};

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  this.$get = ['$injector', function($injector) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value) || isFunction(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          if (isFunction(toSerialize)) {
            toSerialize = toSerialize();
          }
          parts.push(encodeUriQuery(prefix) + '=' +
              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

      if (hasJsonContentType || isJsonLike(tempData)) {
        try {
          data = fromJson(tempData);
        } catch (e) {
          if (!hasJsonContentType) {
            return data;
          }
          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
          'Parse error: "{1}"', data, e);
        }
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   */
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   */
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   */
  var interceptorFactories = this.interceptors = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfTrustedOrigins
   * @description
   *
   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
   * XSRF.
   *
   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
   * Examples: `http://example.com`, `https://api.example.com:9876`
   *
   * <div class="alert alert-warning">
   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
   *   `https://foo.com/` will include the XSRF token.
   * </div>
   *
   * @example
   *
   * ```js
   * // App served from `https://example.com/`.
   * angular.
   *   module('xsrfTrustedOriginsExample', []).
   *   config(['$httpProvider', function($httpProvider) {
   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
   *   }]).
   *   run(['$http', function($http) {
   *     // The XSRF token will be sent.
   *     $http.get('https://api.example.com/preferences').then(...);
   *
   *     // The XSRF token will NOT be sent.
   *     $http.get('https://stats.example.com/activity').then(...);
   *   }]);
   * ```
   */
  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];

  /**
   * @ngdoc property
   * @name $httpProvider#xsrfWhitelistedOrigins
   * @description
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
   * instead.
   */
  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
    get: function() {
      return this.xsrfTrustedOrigins;
    },
    set: function(origins) {
      this.xsrfTrustedOrigins = origins;
    }
  });

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * A function to check request URLs against a list of allowed origins.
     */
    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
     * resolved (request success) or rejected (request failure) with a
     * {@link ng.$http#$http-returns response} object.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
     * the cookie, your server can be assured that the XHR came from JavaScript running on your
     * domain.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
     * sure that only JavaScript running on your domain could have sent the request. The token must
     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
     * want to, you can trust additional origins to also receive the XSRF token, by adding them
     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
     * useful, for example, if your application, served from `example.com`, needs to access your API
     * at `api.example.com`.
     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
     * more details.
     *
     * <div class="alert alert-danger">
     *   **Warning**<br />
     *   Only trusted origins that you have control over and make sure you understand the
     *   implications of doing so.
     * </div>
     *
     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
     * `$http.defaults` at run-time, or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses a unique cookie name.
     *
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *
     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
     *
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
     *   or rejected (request failure) with a response object.
     *
     *   The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with
     *     the transform functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used
     *     to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
     *     (`complete`, `error`, `timeout` or `abort`).
     *
     *
     *   A response status code between 200 and 299 is considered a success status
     *   and will result in the success callback being called. Any response status
     *   code outside of that range is considered an error status and will result
     *   in the error callback being called.
     *   Also, status codes less than -1 are normalized to zero. -1 usually means
     *   the request was aborted, e.g. using a `config.timeout`. More information
     *   about the status might be available in the `xhrStatus` property.
     *
     *   Note that if the response is a redirect, XMLHttpRequest will transparently
     *   follow it, meaning that the outcome (success or error) will be determined
     *   by the final response status code.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
      $sceDelegateProvider.trustedResourceUrlList([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount('$http');

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop, '$http');
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the trusted resource URL list via
     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
     * See {@link ng.$http#$http-returns `$http()` return value}.
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
      * See {@link ng.$http#$http-returns `$http()` return value}.
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
            : isObject(/** @type {?} */ (defaults).cache)
              ? /** @type {?} */ (defaults).cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsAllowedOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText, xhrStatus) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText, xhrStatus);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText, xhrStatus) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText,
          xhrStatus: xhrStatus
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, cbKey) {
      var parts = url.split('?');
      if (parts.length > 2) {
        // Throw if the url contains more than one `?` query indicator
        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
      }
      var params = parseKeyValue(parts[1]);
      forEach(params, function(value, key) {
        if (value === 'JSON_CALLBACK') {
          // Throw if the url already contains a reference to JSON_CALLBACK
          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
        }
        if (key === cbKey) {
          // Throw if the callback param was already provided
          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
        }
      });

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text, 'complete');
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);
      var abortedByTimeout = false;

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            'complete');
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'error');
      };

      var requestAborted = function() {
        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
      };

      var requestTimeout = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'timeout');
      };

      xhr.onerror = requestError;
      xhr.ontimeout = requestTimeout;
      xhr.onabort = requestAborted;

      forEach(eventHandlers, function(value, key) {
        xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    // Since we are using xhr.abort() when a request times out, we have to set a flag that
    // indicates to requestAborted if the request timed out or was aborted.
    //
    // http.timeout = numerical timeout   timeout
    // http.timeout = $timeout            timeout
    // http.timeout = promise             abort
    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
    //                                    can be exposed with the xhrFactory)
    if (timeout > 0) {
      var timeoutId = $browserDefer(function() {
        timeoutRequest('timeout');
      }, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(function() {
        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
      });
    }

    function timeoutRequest(reason) {
      abortedByTimeout = reason === 'timeout';
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText, xhrStatus);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    }
    return startSymbol;
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    }
    return endSymbol;
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;

      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        if (mustHaveExpression) return;

        var unescapedText = unescapeText(text);
        if (contextAllowsConcatenation) {
          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
        }
        var constantInterp = valueFn(unescapedText);
        constantInterp.exp = text;
        constantInterp.expressions = [];
        constantInterp.$$watchDelegate = constantWatchDelegate;

        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns,
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [],
          singleExpression;


      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      singleExpression = concat.length === 1 && expressionPositions.length === 1;
      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
      // objects rather than simple strings
      // (we don't modify the expression if the input consists of only a single trusted input)
      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
      // that is more testable or make it obvious that you bound the value to some user controlled
      // value.  This helps reduce the load when auditing for XSS issues.

      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
      // or on the overall concatenated string (losing trusted types used in the mix, by design).
      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
      // only used in srcdoc attributes, this would not be very useful.

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }

          if (contextAllowsConcatenation) {
            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
          } else if (trustedContext && concat.length > 1) {
            // This context does not allow more than one part, e.g. expr + string or exp + exp.
            $interpolateMinErr.throwNoconcat(text);
          }
          // In an unprivileged context or only one part: just concatenate and return.
          return concat.join('');
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
          // parts of a full URL. We don't care about losing the trustedness here.
          // In non-concatenable contexts, where there is only one expression, this interceptor is
          // not applied to the expression.
          value = (trustedContext && !contextAllowsConcatenation) ?
                    $sce.getTrusted(trustedContext, value) :
                    $sce.valueOf(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

var $intervalMinErr = minErr('$interval');

/** @this */
function $IntervalProvider() {
  this.$get = ['$$intervalFactory', '$window',
       function($$intervalFactory,   $window) {
    var intervals = {};
    var setIntervalFn = function(tick, delay, deferred) {
      var id = $window.setInterval(tick, delay);
      intervals[id] = deferred;
      return id;
    };
    var clearIntervalFn = function(id) {
      $window.clearInterval(id);
      delete intervals[id];
    };

    /**
     * @ngdoc service
     * @name $interval
     *
     * @description
     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
     * milliseconds.
     *
     * The return value of registering an interval function is a promise. This promise will be
     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
     * run indefinitely if `count` is not defined. The value of the notification will be the
     * number of iterations that have run.
     * To cancel an interval, call `$interval.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
     * time.
     *
     * <div class="alert alert-warning">
     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
     * with them.  In particular they are not automatically destroyed when a controller's scope or a
     * directive's element are destroyed.
     * You should take this into consideration and make sure to always cancel the interval at the
     * appropriate moment.  See the example below for more details on how and when to do this.
     * </div>
     *
     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
     *   are passed (see below), the function is called with the current iteration count.
     * @param {number} delay Number of milliseconds between each function call.
     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
     *   indefinitely.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
     *
     * @example
     * <example module="intervalExample" name="interval-service">
     * <file name="index.html">
     *   <script>
     *     angular.module('intervalExample', [])
     *       .controller('ExampleController', ['$scope', '$interval',
     *         function($scope, $interval) {
     *           $scope.format = 'M/d/yy h:mm:ss a';
     *           $scope.blood_1 = 100;
     *           $scope.blood_2 = 120;
     *
     *           var stop;
     *           $scope.fight = function() {
     *             // Don't start a new fight if we are already fighting
     *             if ( angular.isDefined(stop) ) return;
     *
     *             stop = $interval(function() {
     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
     *                 $scope.blood_1 = $scope.blood_1 - 3;
     *                 $scope.blood_2 = $scope.blood_2 - 4;
     *               } else {
     *                 $scope.stopFight();
     *               }
     *             }, 100);
     *           };
     *
     *           $scope.stopFight = function() {
     *             if (angular.isDefined(stop)) {
     *               $interval.cancel(stop);
     *               stop = undefined;
     *             }
     *           };
     *
     *           $scope.resetFight = function() {
     *             $scope.blood_1 = 100;
     *             $scope.blood_2 = 120;
     *           };
     *
     *           $scope.$on('$destroy', function() {
     *             // Make sure that the interval is destroyed too
     *             $scope.stopFight();
     *           });
     *         }])
     *       // Register the 'myCurrentTime' directive factory method.
     *       // We inject $interval and dateFilter service since the factory method is DI.
     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
     *         function($interval, dateFilter) {
     *           // return the directive link function. (compile function not needed)
     *           return function(scope, element, attrs) {
     *             var format,  // date format
     *                 stopTime; // so that we can cancel the time updates
     *
     *             // used to update the UI
     *             function updateTime() {
     *               element.text(dateFilter(new Date(), format));
     *             }
     *
     *             // watch the expression, and update the UI on change.
     *             scope.$watch(attrs.myCurrentTime, function(value) {
     *               format = value;
     *               updateTime();
     *             });
     *
     *             stopTime = $interval(updateTime, 1000);
     *
     *             // listen on DOM destroy (removal) event, and cancel the next UI update
     *             // to prevent updating time after the DOM element was removed.
     *             element.on('$destroy', function() {
     *               $interval.cancel(stopTime);
     *             });
     *           }
     *         }]);
     *   </script>
     *
     *   <div>
     *     <div ng-controller="ExampleController">
     *       <label>Date format: <input ng-model="format"></label> <hr/>
     *       Current time is: <span my-current-time="format"></span>
     *       <hr/>
     *       Blood 1 : <font color='red'>{{blood_1}}</font>
     *       Blood 2 : <font color='red'>{{blood_2}}</font>
     *       <button type="button" data-ng-click="fight()">Fight</button>
     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
     *     </div>
     *   </div>
     *
     * </file>
     * </example>
     */
    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);

    /**
     * @ngdoc method
     * @name $interval#cancel
     *
     * @description
     * Cancels a task associated with the `promise`.
     *
     * @param {Promise=} promise returned by the `$interval` function.
     * @returns {boolean} Returns `true` if the task was successfully canceled.
     */
    interval.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$intervalId')) {
        throw $intervalMinErr('badprom',
            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
      }

      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;

      var id = promise.$$intervalId;
      var deferred = intervals[id];

      // Interval cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      clearIntervalFn(id);

      return true;
    };

    return interval;
  }];
}

/** @this */
function $$IntervalFactoryProvider() {
  this.$get = ['$browser', '$q', '$$q', '$rootScope',
       function($browser,   $q,   $$q,   $rootScope) {
    return function intervalFactory(setIntervalFn, clearIntervalFn) {
      return function intervalFn(fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

        count = isDefined(count) ? count : 0;

        function callback() {
          if (!hasParams) {
            fn(iteration);
          } else {
            fn.apply(null, args);
          }
        }

        function tick() {
          if (skipApply) {
            $browser.defer(callback);
          } else {
            $rootScope.$evalAsync(callback);
          }
          deferred.notify(iteration++);

          if (count > 0 && iteration >= count) {
            deferred.resolve(iteration);
            clearIntervalFn(promise.$$intervalId);
          }

          if (!skipApply) $rootScope.$apply();
        }

        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);

        return promise;
      };
    };
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = function() {
    var callbacks = angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  };
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

/* global stripHash: true */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    // decode forward slashes to prevent them from being double encoded
    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
  }

  return segments.join('/');
}

function decodePath(path, html5Mode) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = decodeURIComponent(segments[i]);
    if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
      segments[i] = segments[i].replace(/\//g, '%2F');
    }
  }

  return segments.join('/');
}

function normalizePath(pathValue, searchValue, hashValue) {
  var search = toKeyValue(searchValue),
    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
    path = encodePath(pathValue);

  return path + (search ? '?' + search : '') + hash;
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj, html5Mode) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
  locationObj.$$path = decodePath(path, html5Mode);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}

function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, true);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  this.$$normalizeUrl = function(url) {
    return appBaseNoFile + url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          /** @type {?} */ (this).replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this, false);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  this.$$normalizeUrl = function(url) {
    return appBase + (url ? hashPrefix + url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$normalizeUrl = function(url) {
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    return appBase + hashPrefix + url;
  };
}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * Compose url and update `url` and `absUrl` property
   * @private
   */
  $$compose: function() {
    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
    this.$$absUrl = this.$$normalizeUrl(this.$$url);
    this.$$urlUpdatedByLocation = true;
  },

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;
    this.$$urlUpdatedByLocation = true;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    // Determine if two URLs are equal despite potentially having different encoding/normalizing
    //  such as $location.absUrl() vs $browser.url()
    // See https://github.com/angular/angular.js/issues/16592
    function urlsEqual(a, b) {
      return a === b || urlResolve(a).href === urlResolve(b).href;
    }

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the AngularJS application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if ($location.absUrl() !== initialUrl) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      if (initializing || $location.$$urlUpdatedByLocation) {
        $location.$$urlUpdatedByLocation = false;

        var oldUrl = $browser.url();
        var newUrl = $location.absUrl();
        var oldState = $browser.state();
        var currentReplace = $location.$$replace;
        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

        if (initializing || urlOrStateChanged) {
          initializing = false;

          $rootScope.$evalAsync(function() {
            var newUrl = $location.absUrl();
            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
                $location.$$state, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
            } else {
              if (urlOrStateChanged) {
                setBrowserUrlWithFallback(newUrl, currentReplace,
                                          oldState === $location.$$state ? null : $location.$$state);
              }
              afterLocationChange(oldUrl, oldState);
            }
          });
        }
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (isError(arg)) {
        if (arg.stack && formatStackTrace) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop;

      return function() {
        var args = [];
        forEach(arguments, function(arg) {
          args.push(formatError(arg));
        });
        // Support: IE 9 only
        // console methods don't inherit from Function.prototype in IE 9 so we can't
        // call `logFn.apply(console, args)` directly.
        return Function.prototype.apply.call(logFn, console, args);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing AngularJS Expressions
// ------------------------------
// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following AngularJS expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

var PURITY_ABSOLUTE = 1;
var PURITY_RELATIVE = 2;

// Detect nodes which could depend on non-shallow state of objects
function isPure(node, parentIsPure) {
  switch (node.type) {
    // Computed members might invoke a stateful toString()
    case AST.MemberExpression:
      if (node.computed) {
        return false;
      }
      break;

    // Unary always convert to primative
    case AST.UnaryExpression:
      return PURITY_ABSOLUTE;

    // The binary + operator can invoke a stateful toString().
    case AST.BinaryExpression:
      return node.operator !== '+' ? PURITY_ABSOLUTE : false;

    // Functions / filters probably read state from within objects
    case AST.CallExpression:
      return false;
  }

  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
}

function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;

  var astIsPure = ast.isPure = isPure(ast, parentIsPure);

  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
      allConstants = allConstants && property.value.constant;
      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      if (property.computed) {
        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
        allConstants = allConstants && property.key.constant;
        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler($filter) {
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(ast) {
    var self = this;
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var inputs = this.state.inputs;
    var self = this;
    forEach(inputs, function(input) {
      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
      if (input.isPure) {
        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
      }
    });
    if (inputs.length) {
      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter($filter) {
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(ast) {
    var self = this;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        input.isPure = watch.isPure;
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
function Parser(lexer, $filter, options) {
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
                                   new ASTCompiler($filter);
}

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    var ast = this.getAst(text);
    var fn = this.astCompiler.compile(ast.ast);
    fn.literal = isLiteral(ast.ast);
    fn.constant = isConstant(ast.ast);
    fn.oneTime = ast.oneTime;
    return fn;
  },

  getAst: function(exp) {
    var oneTime = false;
    exp = exp.trim();

    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
      oneTime = true;
      exp = exp.substring(2);
    }
    return {
      ast: this.ast.ast(exp),
      oneTime: oneTime
    };
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    $parse.$$getAst = $$getAst;
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);

            cache[cacheKey] = addWatchDelegate(parsedExpression);
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function $$getAst(exp) {
      var lexer = new Lexer($parseOptions);
      var parser = new Parser(lexer, $filter, $parseOptions);
      return parser.getAst(exp).ast;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object' && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
      var unwatch, lastValue;

      var exp = parsedExpression.$$intercepted || parsedExpression;
      var post = parsedExpression.$$interceptor || identity;

      var useInputs = parsedExpression.inputs && !exp.inputs;

      // Propagate the literal/inputs/constant attributes
      // ... but not oneTime since we are handling it
      oneTimeWatch.literal = parsedExpression.literal;
      oneTimeWatch.constant = parsedExpression.constant;
      oneTimeWatch.inputs = parsedExpression.inputs;

      // Allow other delegates to run on this wrapped expression
      addWatchDelegate(oneTimeWatch);

      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);

      return unwatch;

      function unwatchIfDone() {
        if (isDone(lastValue)) {
          unwatch();
        }
      }

      function oneTimeWatch(scope, locals, assign, inputs) {
        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
        if (isDone(lastValue)) {
          scope.$$postDigest(unwatchIfDone);
        }
        return post(lastValue);
      }
    }

    function isAllDefined(value) {
      var allDefined = true;
      forEach(value, function(val) {
        if (!isDefined(val)) allDefined = false;
      });
      return allDefined;
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addWatchDelegate(parsedExpression) {
      if (parsedExpression.constant) {
        parsedExpression.$$watchDelegate = constantWatchDelegate;
      } else if (parsedExpression.oneTime) {
        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
      } else if (parsedExpression.inputs) {
        parsedExpression.$$watchDelegate = inputsWatchDelegate;
      }

      return parsedExpression;
    }

    function chainInterceptors(first, second) {
      function chainedInterceptor(value) {
        return second(first(value));
      }
      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
      chainedInterceptor.$$pure = first.$$pure && second.$$pure;

      return chainedInterceptor;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;

      // Extract any existing interceptors out of the parsedExpression
      // to ensure the original parsedExpression is always the $$intercepted
      if (parsedExpression.$$interceptor) {
        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
        parsedExpression = parsedExpression.$$intercepted;
      }

      var useInputs = false;

      var fn = function interceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value);
      };

      // Maintain references to the interceptor/intercepted
      fn.$$intercepted = parsedExpression;
      fn.$$interceptor = interceptorFn;

      // Propagate the literal/oneTime/constant attributes
      fn.literal = parsedExpression.literal;
      fn.oneTime = parsedExpression.oneTime;
      fn.constant = parsedExpression.constant;

      // Treat the interceptor like filters.
      // If it is not $stateful then only watch its inputs.
      // If the expression itself has no inputs then use the full expression as an input.
      if (!interceptorFn.$stateful) {
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];

        if (!interceptorFn.$$pure) {
          fn.inputs = fn.inputs.map(function(e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) { return e(s); };
              }
              return e;
            });
        }
      }

      return addWatchDelegate(fn);
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        markQStateExceptionHandled(state);
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
          // This error is explicitly marked for being passed to the $exceptionHandler
          if (e && e.$$passToExceptionHandler === true) {
            exceptionHandler(e);
          }
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!isStateExceptionHandled(toCheck)) {
        markQStateExceptionHandled(toCheck);
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (isError(toCheck.value)) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function isStateExceptionHandled(state) {
  return !!state.pur;
}
function markQStateExceptionHandled(state) {
  state.pur = true;
}
function markQExceptionHandled(q) {
  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
  // (Currently, this is the only method that might be called with a promise, even if it is not
  // created by the built-in `$q`.)
  if (q.$$state) {
    markQStateExceptionHandled(q.$$state);
  }
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
      this.$$suspended = false;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$suspended = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are (or contain)
       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);
        var fn = isFunction(listener) ? listener : noop;

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
            newValues[i] = value;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          try {
            if (firstRun) {
              firstRun = false;
              listener(newValues, newValues, self);
            } else {
              listener(newValues, oldValues, self);
            }
          } finally {
            for (var i = 0; i < watchExpressions.length; i++) {
              oldValues[i] = newValues[i];
            }
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        // Mark the interceptor as
        // ... $$pure when literal since the instance will change when any input changes
        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
        // ... $stateful when non-literal since we must read the state of the collection
        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = asyncQueue.length ? $rootScope : this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              fn = asyncTask.fn;
              fn(asyncTask.scope, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = !current.$$suspended && current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            // (though it differs due to having the extra check for $$suspended and does not
            // check $$listenerCount)
            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;

        // Check for changes to browser url that happened during the $digest
        // (for which no event is fired; e.g. via `history.pushState()`)
        $browser.$$checkUrlChange();
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$suspend
       * @kind function
       *
       * @description
       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
       *
       * This can be used to optimize your application when you know that running those watchers
       * is redundant.
       *
       * **Warning**
       *
       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
       * Only use this approach if you are confident that you know what you are doing and have
       * ample tests to ensure that bindings get updated as you expect.
       *
       * Some of the things to consider are:
       *
       * * Any external event on a directive/component will not trigger a digest while the hosting
       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
       * * Transcluded content exists on a scope that inherits from outside a directive but exists
       *   as a child of the directive's containing scope. If the containing scope is suspended the
       *   transcluded scope will also be suspended, even if the scope from which the transcluded
       *   scope inherits is not suspended.
       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
       *    * A call to `$suspend()` on an already suspended scope is a no-op.
       *    * A call to `$resume()` on a non-suspended scope is a no-op.
       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
       *      longer be suspended. This could result in the other directive believing a scope to be
       *      suspended when it is not.
       * * If a parent scope is suspended then all its descendants will be also excluded from future
       *   digests whether or not they have been suspended themselves. Note that this also applies to
       *   isolate child scopes.
       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
       *   for that scope and its descendants. When digesting we only check whether the current scope is
       *   locally suspended, rather than checking whether it has a suspended ancestor.
       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
       *   included in future digests until all its ancestors have been resumed.
       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
       *   initiated by a component that lives on a suspended scope.
       */
      $suspend: function() {
        this.$$suspended = true;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$isSuspended
       * @kind function
       *
       * @description
       * Call this method to determine if this scope has been explicitly suspended. It will not
       * tell you whether an ancestor has been suspended.
       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
       * for example, you must check all its ancestors:
       *
       * ```
       * function isExcludedFromDigest(scope) {
       *   while(scope) {
       *     if (scope.$isSuspended()) return true;
       *     scope = scope.$parent;
       *   }
       *   return false;
       * ```
       *
       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
       * even if `$isSuspended()` returns false.
       *
       * @returns true if the current scope has been suspended.
       */
      $isSuspended: function() {
        return this.$$suspended;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$resume
       * @kind function
       *
       * @description
       * Resume watchers of this scope subtree in case it was suspended.
       *
       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
       */
      $resume: function() {
        this.$$suspended = false;
      },

      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          }, null, '$evalAsync');
        }

        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            // Use delete in the hope of the browser deallocating the memory for the array entry,
            // while not shifting the array indexes of other listeners.
            // See issue https://github.com/angular/angular.js/issues/16135
            delete namedListeners[indexOfListener];
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            break;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount and
          // does not check $$suspended)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        }, null, '$applyAsync');
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {

  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
   *
   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
   *
   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationTrustedUrlList = regexp;
      return this;
    }
    return aHrefSanitizationTrustedUrlList;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for determining trusted safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
   *
   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
   * the potentially malicious URL.
   *
   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
   * unchanged.
   *
   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
   * to the DOM it is inactive and potentially malicious code will not be executed.
   *
   * @param {RegExp=} regexp New regexp to trust urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationTrustedUrlList = regexp;
      return this;
    }
    return imgSrcSanitizationTrustedUrlList;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isMediaUrl) {
      // if (!uri) return uri;
      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
      var normalizedVal = urlResolve(uri && uri.trim()).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
  HTML: 'html',

  // Style statements or stylesheets. Currently unused in AngularJS.
  CSS: 'css',

  // An URL used in a context where it refers to the source of media, which are not expected to be run
  // as scripts, such as an image, audio, video, etc.
  MEDIA_URL: 'mediaUrl',

  // An URL used in a context where it does not refer to a resource that loads code.
  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
  URL: 'url',

  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
  // code. (e.g. ng-include, script src binding, templateUrl)
  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
  RESOURCE_URL: 'resourceUrl',

  // Script. Currently unused in AngularJS.
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * $sceDelegateProvider.trustedResourceUrlList} and
 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.trustedResourceUrlList([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
 *    // here is blocked.
 *    $sceDelegateProvider.bannedResourceUrlList([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
 * of issues, like for instance attacker-controlled `ng-includes`.
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var trustedResourceUrlList = ['self'],
      bannedResourceUrlList = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#trustedResourceUrlList
   * @kind function
   *
   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
   *     further changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set trusted resource URL array.
   *
   * @description
   * Sets/Gets the list trusted of resource URLs.
   *
   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
   * allowing only same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
   * its origin with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
  this.trustedResourceUrlList = function(value) {
    if (arguments.length) {
      trustedResourceUrlList = adjustMatchers(value);
    }
    return trustedResourceUrlList;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
   * trustedResourceUrlList} instead.
   */
  Object.defineProperty(this, 'resourceUrlWhitelist', {
    get: function() {
      return this.trustedResourceUrlList;
    },
    set: function(value) {
      this.trustedResourceUrlList = value;
    }
  });

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#bannedResourceUrlList
   * @kind function
   *
   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
   *     the value provided. This must be an array or null. A snapshot of this array is used so
   *     further changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the `bannedResourceUrlList` is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
   *     the final say.
   *
   * @return {Array} The currently set `bannedResourceUrlList` array.
   *
   * @description
   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
   *
   * The **default value** when no trusted resource URL list has been explicitly set is the empty
   * array (i.e. there is no `bannedResourceUrlList`.)
   */
  this.bannedResourceUrlList = function(value) {
    if (arguments.length) {
      bannedResourceUrlList = adjustMatchers(value);
    }
    return bannedResourceUrlList;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.8.1"
   *
   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
   * bannedResourceUrlList} instead.
   */
  Object.defineProperty(this, 'resourceUrlBlacklist', {
    get: function() {
      return this.bannedResourceUrlList;
    },
    set: function(value) {
      this.bannedResourceUrlList = value;
    }
  });

  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the trusted resource URL list allows this url.
      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the banned resource URL list has blocked this url.
        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Given an object and a security context in which to assign it, returns a value that's safe to
     * use in this context, which was represented by the parameter. To do so, this function either
     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
     * the context and sanitizer availablility.
     *
     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
     *
     * This function will throw if the safe type isn't appropriate for this context, or if the
     * value given cannot be accepted in the context (which might be caused by sanitization not
     * being available, or the value not being recognized as safe).
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
      // as-is.
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }

      // If maybeTrusted is a trusted class instance but not of the correct trusted type
      // then unwrap it and allow it to pass through to the rest of the checks
      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
      }

      // If we get here, then we will either sanitize the value or throw an exception.
      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
        // we attempt to sanitize non-resource URLs
        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
        return htmlSanitizer(maybeTrusted);
      }
      // Default error when the $sce service has no way to make the input safe.
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
 * HTML can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
 * when binding untrusted values to `$sce.HTML` context.
 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 *
 * <div class="alert alert-warning">
 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
 *
 * **As of 1.7.0, this is no longer the case.**
 *
 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
 * service evaluates the expressions.
 * </div>
 *
 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
 * functions aren't useful yet. This might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      for matching resource URL lists.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

/**
 * ! This is a private undocumented service !
 *
 * @name $$taskTrackerFactory
 * @description
 * A function to create `TaskTracker` instances.
 *
 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
 * parties when all pending tasks (or tasks of a specific type) have been completed.
 *
 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
 *     execution.
 *
 * @this
 */
function $$TaskTrackerFactoryProvider() {
  this.$get = valueFn(function(log) { return new TaskTracker(log); });
}

function TaskTracker(log) {
  var self = this;
  var taskCounts = {};
  var taskCallbacks = [];

  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';

  /**
   * Execute the specified function and decrement the appropriate `taskCounts` counter.
   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
   *
   * @param {Function} fn - The function to execute.
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
   */
  self.completeTask = completeTask;

  /**
   * Increase the task count for the specified task type (or the default task type if non is
   * specified).
   *
   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
   */
  self.incTaskCount = incTaskCount;

  /**
   * Execute the specified callback when all pending tasks have been completed.
   *
   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
   * the tasks that will be waited for to a specific type, by passing a `taskType`.
   *
   * @param {function} callback - The function to call when there are no pending tasks.
   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
   */
  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;

  function completeTask(fn, taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;

    try {
      fn();
    } finally {
      decTaskCount(taskType);

      var countForType = taskCounts[taskType];
      var countForAll = taskCounts[ALL_TASKS_TYPE];

      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
      if (!countForAll || !countForType) {
        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
        var nextCb;

        while ((nextCb = getNextCallback(taskType))) {
          try {
            nextCb();
          } catch (e) {
            log.error(e);
          }
        }
      }
    }
  }

  function decTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    if (taskCounts[taskType]) {
      taskCounts[taskType]--;
      taskCounts[ALL_TASKS_TYPE]--;
    }
  }

  function getLastCallback() {
    var cbInfo = taskCallbacks.pop();
    return cbInfo && cbInfo.cb;
  }

  function getLastCallbackForType(taskType) {
    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
      var cbInfo = taskCallbacks[i];
      if (cbInfo.type === taskType) {
        taskCallbacks.splice(i, 1);
        return cbInfo.cb;
      }
    }
  }

  function incTaskCount(taskType) {
    taskType = taskType || DEFAULT_TASK_TYPE;
    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
  }

  function notifyWhenNoPendingTasks(callback, taskType) {
    taskType = taskType || ALL_TASKS_TYPE;
    if (!taskCounts[taskType]) {
      callback();
    } else {
      taskCallbacks.push({type: taskType, cb: callback});
    }
  }
}

var $templateRequestMinErr = minErr('$templateRequest');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through adding the template again to the trusted
        // resources for keys that already are included in there. This also makes
        // AngularJS accept any script directive, no matter its name. However, we
        // still need to unwrap trusted types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            return $templateCache.put(tpl, response.data);
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when all pending tasks are completed.
     *
     * Types of tasks waited for include:
     * - Pending timeouts (via {@link $timeout}).
     * - Pending HTTP requests (via {@link $http}).
     * - In-progress route transitions (via {@link $route}).
     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

var $timeoutMinErr = minErr('$timeout');

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


    /**
     * @ngdoc service
     * @name $timeout
     *
     * @description
     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
     * block and delegates any exceptions to
     * {@link ng.$exceptionHandler $exceptionHandler} service.
     *
     * The return value of calling `$timeout` is a promise, which will be resolved when
     * the delay has passed and the timeout function, if provided, is executed.
     *
     * To cancel a timeout request, call `$timeout.cancel(promise)`.
     *
     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
     * synchronously flush the queue of deferred functions.
     *
     * If you only want a promise that will be resolved after some specified delay
     * then you can call `$timeout` without the `fn` function.
     *
     * @param {function()=} fn A function, whose execution should be delayed.
     * @param {number=} [delay=0] Delay in milliseconds.
     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
     * @param {...*=} Pass additional parameters to the executed function.
     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
     *   will be resolved with the return value of the `fn` function.
     *
     */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay, '$timeout');

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


    /**
     * @ngdoc method
     * @name $timeout#cancel
     *
     * @description
     * Cancels a task associated with the `promise`. As a result of this, the promise will be
     * resolved with a rejection.
     *
     * @param {Promise=} promise Promise returned by the `$timeout` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *   canceled.
     */
    timeout.cancel = function(promise) {
      if (!promise) return false;

      if (!promise.hasOwnProperty('$$timeoutId')) {
        throw $timeoutMinErr('badprom',
            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
      }

      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;

      var id = promise.$$timeoutId;
      var deferred = deferreds[id];

      // Timeout cancels should not report an unhandled promise.
      markQExceptionHandled(deferred.promise);
      deferred.reject('canceled');
      delete deferreds[id];

      return $browser.defer.cancel(id);
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);
var baseUrlParsingNode;

urlParsingNode.href = 'http://[::1]';

// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
// when parsed out of an anchor element.
var ipv6InBrackets = urlParsingNode.hostname === '[::1]';

/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
 *     unchanged.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description                                                            |
 *   |---------------|------------------------------------------------------------------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol without the trailing colon                                |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol                                 |
 *   | hostname      | The hostname                                                           |
 *   | port          | The port, without ":"                                                  |
 *   | pathname      | The pathname, beginning with "/"                                       |
 *
 */
function urlResolve(url) {
  if (!isString(url)) return url;

  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  var hostname = urlParsingNode.hostname;

  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
    hostname = '[' + hostname + ']';
  }

  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application
 * document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  return urlsAreSameOrigin(requestUrl, originUrl);
}

/**
 * Parse a request URL and determine whether it is same-origin as the current document base URL.
 *
 * Note: The base URL is usually the same as the document location (`location.href`) but can
 * be overriden by using the `<base>` tag.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the URL is same-origin as the document base URL.
 */
function urlIsSameOriginAsBaseUrl(requestUrl) {
  return urlsAreSameOrigin(requestUrl, getBaseUrl());
}

/**
 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
 * The current location's origin is implicitly trusted.
 *
 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
 *
 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
 *     whether it is of an allowed origin.
 */
function urlIsAllowedOriginFactory(trustedOriginUrls) {
  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));

  /**
   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
   * based on a list of trusted-origin URLs. The current location's origin is implicitly
   * trusted.
   *
   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
   *     resolved or a parsed URL object).
   *
   * @returns {boolean} - Whether the specified URL is of an allowed origin.
   */
  return function urlIsAllowedOrigin(requestUrl) {
    var parsedUrl = urlResolve(requestUrl);
    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
  };
}

/**
 * Determine if two URLs share the same origin.
 *
 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
 *     a dictionary object returned by `urlResolve()`.
 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
 *     of a dictionary object returned by `urlResolve()`.
 *
 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
 */
function urlsAreSameOrigin(url1, url2) {
  url1 = urlResolve(url1);
  url2 = urlResolve(url2);

  return (url1.protocol === url2.protocol &&
          url1.host === url2.host);
}

/**
 * Returns the current document base URL.
 * @returns {string}
 */
function getBaseUrl() {
  if (window.document.baseURI) {
    return window.document.baseURI;
  }

  // `document.baseURI` is available everywhere except IE
  if (!baseUrlParsingNode) {
    baseUrlParsingNode = window.document.createElement('a');
    baseUrlParsingNode.href = '.';

    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
    // suitable here because we need to track changes to the base URL.
    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
  }
  return baseUrlParsingNode.href;
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
          if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // If the currency symbol is empty, trim whitespace around the symbol
    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(currencySymbolRe, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 *    **Note:** `null` values use `'null'` as their type.
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, sorts values of different types by type and puts
 * `undefined` and `null` values at the end of the sorted list.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types:
 *    - If one of the values is undefined, consider it "greater than" the other.
 *    - Else if one of the values is null, consider it "greater than" the other.
 *    - Else compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
 *           any other value (with undefined "greater than" null). This effectively means that `null`
 *           and `undefined` values end up at the end of a list sorted in ascending order.
 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = (type1 === 'undefined') ? 1 :
        (type2 === 'undefined') ? -1 :
        (type1 === 'null') ? 1 :
        (type2 === 'null') ? -1 :
        (type1 < type2) ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        // We need to sanitize the url at least once, in case it is a constant
        // non-interpolated attribute.
        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set might have sanitized the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  }];
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $getControls: valueFn([]),
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop,
  $$setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$getControls
   * @returns {Array} the controls that are currently part of this form
   *
   * @description
   * This method returns a **shallow copy** of the controls that are currently part of this form.
   * The controls can be instances of {@link form.FormController `FormController`}
   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
   * If you need access to the controls of child-forms, you have to call `$getControls()`
   * recursively on them.
   * This can be used for example to iterate over all controls to validate them.
   *
   * The controls can be accessed normally, but adding to, or removing controls from the array has
   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
   * Likewise, adding a control to, or removing a control from the form is not reflected
   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
   * you need access to the controls.
   */
  $getControls: function() {
    return shallowCopy(this.$$controls);
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
   * parent forms of the form.
   */
  $setSubmitted: function() {
    var rootForm = this;
    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
      rootForm = rootForm.$$parentForm;
    }
    rootForm.$$setSubmitted();
  },

  $$setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    forEach(this.$$controls, function(control) {
      if (control.$$setSubmitted) {
        control.$$setSubmitted();
      }
    });
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Helper directive that makes it possible to create control groups inside a
 * {@link ng.directive:form `form`} directive.
 * These "child forms" can be used, for example, to determine the validity of a sub-group of
 * controls.
 *
 * <div class="alert alert-danger">
 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
 * you cannot send data to the server with `ngForm`, or integrate it with
 * {@link ng.directive:ngSubmit `ngSubmit`}.
 * </div>
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
 *                              be published into the related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * The format of the displayed time can be adjusted with the
    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
    * and `timeStripZeroSeconds`.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
   * this is the timezone of the browser.
   *
   * The format of the displayed time can be adjusted with the
   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
   * and `timeStripZeroSeconds`.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   *
   *
   * @knownIssue
   *
   * ### HTML5 constraint validation and `allowInvalid`
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   * @knownIssue
   *
   * ### Large numbers and `step` validation
   *
   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
   * point for both implementations.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium, which may not fulfill your app's requirements.
   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
   * modify the built-in validators (see the {@link guide/forms Forms guide}).
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * **Note:**<br>
   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
   * value of their `name` attribute to determine the property under which their
   * {@link ngModel.NgModelController NgModelController} will be published on the parent
   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
   * published on the parent `FormController` under that name. The rest of the controllers will
   * continue to work as expected, but you won't be able to access them as properties on the parent
   * `FormController`.
   *
   * <div class="alert alert-info">
   *   <p>
   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
   *     that the browser can manage their state (checked/unchecked) based on the state of other
   *     inputs in the same group.
   *   </p>
   *   <p>
   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
   *     value of the underlying model data.
   *   </p>
   * </div>
   *
   * <div class="alert alert-success">
   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
   *   unique name.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                      to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    // Support: IE9+
    element.on('compositionupdate', function(ev) {
      // End composition when ev.data is empty string on 'compositionupdate' event.
      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
      // instead of 'compositionend'.
      if (isUndefined(ev.data) || ev.data === '') {
        composing = false;
      }
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut drop', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, previousDate) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (previousDate) {
          map = {
            yyyy: previousDate.getFullYear(),
            MM: previousDate.getMonth() + 1,
            dd: previousDate.getDate(),
            HH: previousDate.getHours(),
            mm: previousDate.getMinutes(),
            ss: previousDate.getSeconds(),
            sss: previousDate.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });

        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        if (map.yyyy < 100) {
          // In the constructor, 2-digit years map to 1900-1999.
          // Use `setFullYear()` to set the correct year.
          date.setFullYear(map.yyyy);
        }

        return date;
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    badInputChecker(scope, element, attr, ctrl, type);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var isTimeType = type === 'time' || type === 'datetimelocal';
    var previousDate;
    var previousTimezone;

    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;

      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
      }
      ctrl.$$parserName = type;
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        var timezone = ctrl.$options.getOption('timezone');

        if (timezone) {
          previousTimezone = timezone;
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }

        return formatter(value, timezone);
      } else {
        previousDate = null;
        previousTimezone = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal = attr.min || $parse(attr.ngMin)(scope);
      var parsedMinVal = parseObservedDateValue(minVal);

      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
      };
      attr.$observe('min', function(val) {
        if (val !== minVal) {
          parsedMinVal = parseObservedDateValue(val);
          minVal = val;
          ctrl.$validate();
        }
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal = attr.max || $parse(attr.ngMax)(scope);
      var parsedMaxVal = parseObservedDateValue(maxVal);

      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
      };
      attr.$observe('max', function(val) {
        if (val !== maxVal) {
          parsedMaxVal = parseObservedDateValue(val);
          maxVal = val;
          ctrl.$validate();
        }
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
    }

    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
      var timezone = ctrl.$options.getOption('timezone');

      if (previousTimezone && previousTimezone !== timezone) {
        // If the timezone has changed, adjust the previousDate to the default timezone
        // so that the new date is converted with the correct timezone offset
        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
      }

      var parsedDate = parseDate(value, previousDate);

      if (!isNaN(parsedDate) && timezone) {
        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
      }
      return parsedDate;
    }

    function formatter(value, timezone) {
      var targetFormat = format;

      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
        targetFormat = format
          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
          .replace(/:$/, '');
      }

      var formatted =  $filter('date')(value, targetFormat, timezone);

      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
      }

      return formatted;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl, parserName) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      if (validity.badInput || validity.typeMismatch) {
        ctrl.$$parserName = parserName;
        return undefined;
      }

      return value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);

    ctrl.$$parserName = 'number';
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  var isNonIntegerValue = !isNumberInteger(value);
  var isNonIntegerStepBase = !isNumberInteger(stepBase);
  var isNonIntegerStep = !isNumberInteger(step);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;

    if (isNonIntegerValue) value = Math.round(value);
    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
    if (isNonIntegerStep) step = Math.round(step);
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  badInputChecker(scope, element, attr, ctrl, 'number');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var parsedMinVal;

  if (isDefined(attr.min) || attr.ngMin) {
    var minVal = attr.min || $parse(attr.ngMin)(scope);
    parsedMinVal = parseNumberAttrVal(minVal);

    ctrl.$validators.min = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
    };

    attr.$observe('min', function(val) {
      if (val !== minVal) {
        parsedMinVal = parseNumberAttrVal(val);
        minVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    var maxVal = attr.max || $parse(attr.ngMax)(scope);
    var parsedMaxVal = parseNumberAttrVal(maxVal);

    ctrl.$validators.max = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
    };

    attr.$observe('max', function(val) {
      if (val !== maxVal) {
        parsedMaxVal = parseNumberAttrVal(val);
        maxVal = val;
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal = attr.step || $parse(attr.ngStep)(scope);
    var parsedStepVal = parseNumberAttrVal(stepVal);

    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
    };

    attr.$observe('step', function(val) {
      // TODO(matsko): implement validateLater to reduce number of validations
      if (val !== stepVal) {
        parsedStepVal = parseNumberAttrVal(val);
        stepVal = val;
        ctrl.$validate();
      }

    });

  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl, 'range');
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    minVal = parseNumberAttrVal(attr.min);

    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    maxVal = parseNumberAttrVal(attr.max);

    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    stepVal = parseNumberAttrVal(attr.step);

    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    var oldVal = attr[htmlAttrName];
    attr.$observe(htmlAttrName, function wrappedObserver(val) {
      if (val !== oldVal) {
        oldVal = val;
        changeFn(val);
      }
    });
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (!supportsRange) {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    } else if (ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('change', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('change', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];


var hiddenInputBrowserCacheDirective = function() {
  var valueProperty = {
    configurable: true,
    enumerable: false,
    get: function() {
      return this.getAttribute('value') || '';
    },
    set: function(val) {
      this.setAttribute('value', val);
    }
  };

  return {
    restrict: 'E',
    priority: 200,
    compile: function(_, attr) {
      if (lowercase(attr.type) !== 'hidden') {
        return;
      }

      return {
        pre: function(scope, element, attr, ctrls) {
          var node = element[0];

          // Support: Edge
          // Moving the DOM around prevents autofillling
          if (node.parentNode) {
            node.parentNode.insertBefore(node, node.nextSibling);
          }

          // Support: FF, IE
          // Avoiding direct assignment to .value prevents autofillling
          if (Object.defineProperty) {
            Object.defineProperty(node, 'value', valueProperty);
          }
        }
      };
    }
  };
};



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
    element.prop('value', propValue);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClassWatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClassWatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    if (!classValue) return classValue;

    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    } else if (!isString(classValue)) {
      classString = classValue + '';
    }

    return classString;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassOdd`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-odd="'odd'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .odd {
         background: rgba(255, 255, 0, 0.25);
       }

       .odd-add, .odd-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add odd class to odd entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);

         button.click();

         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 *
 * <hr />
 * @example
 * An example on how to implement animations using `ngClassEven`:
 *
   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
     <file name="index.html">
       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
         <hr />
         <table>
           <tr ng-repeat="item in items" ng-class-even="'even'">
             <td>{{ item }}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="style.css">
       .even {
         background: rgba(255, 255, 0, 0.25);
       }

       .even-add, .even-remove {
         transition: 1.5s;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should add new entries to the beginning of the list', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.count()).toBe(4);
         expect(rows.get(0).getText()).toBe('Item 3');
         expect(rows.get(1).getText()).toBe('Item 2');

         button.click();

         expect(rows.count()).toBe(5);
         expect(rows.get(0).getText()).toBe('Item 4');
         expect(rows.get(1).getText()).toBe('Item 3');
       });

       it('should add even class to even entries', function() {
         var button = element(by.buttonText('Add item'));
         var rows = element.all(by.repeater('item in items'));

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);

         button.click();

         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
    }];
  }
);

function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
  return {
    restrict: 'A',
    compile: function($element, attr) {
      // NOTE:
      // We expose the powerful `$event` object on the scope that provides access to the Window,
      // etc. This is OK, because expressions are not sandboxed any more (and the expression
      // sandbox was never meant to be a security feature anyway).
      var fn = $parse(attr[directiveName]);
      return function ngEventHandler(scope, element) {
        element.on(eventName, function(event) {
          var callback = function() {
            fn(scope, {$event: event});
          };

          if (!$rootScope.$$phase) {
            scope.$apply(callback);
          } else if (forceAsync) {
            scope.$evalAsync(callback);
          } else {
            try {
              callback();
            } catch (error) {
              $exceptionHandler(error);
            }
          }
        });
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;
  this.$$updateEvents = '';
  // Attach the correct context to the event handler function for updateOn
  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;
  this.$$parserName = 'parse';

  this.$$currentValidationRunId = 0;

  this.$$scope = $scope;
  this.$$rootScope = $scope.$root;
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {

    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName;

      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }

        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    // Reset any previous parse error
    this.$setValidity(this.$$parserName, null);
    this.$$parserName = 'parse';

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default']) &&
      this.$options.getOption('updateOn').indexOf(trigger) === -1
    ) {
      debounceDelay = debounceDelay['default'];
    } else if (isNumber(debounceDelay['*'])) {
      debounceDelay = debounceDelay['*'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$rootScope.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  },

  /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
  $overrideModelOptions: function(options) {
    this.$options = this.$options.createChild(options);
    this.$$setUpdateOnEvents();
  },

  /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
  $processModelValue: function() {
    var viewValue = this.$$format();

    if (this.$viewValue !== viewValue) {
      this.$$updateEmptyClasses(viewValue);
      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
      this.$render();
      // It is possible that model and view value have been updated during render
      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
    }
  },

  /**
   * This method is called internally to run the $formatters on the $modelValue
   */
  $$format: function() {
    var formatters = this.$formatters,
        idx = formatters.length;

    var viewValue = this.$modelValue;
    while (idx--) {
      viewValue = formatters[idx](viewValue);
    }

    return viewValue;
  },

  /**
   * This method is called internally when the bound scope value changes.
   */
  $$setModelValue: function(modelValue) {
    this.$modelValue = this.$$rawModelValue = modelValue;
    this.$$parserValid = undefined;
    this.$processModelValue();
  },

  $$setUpdateOnEvents: function() {
    if (this.$$updateEvents) {
      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
    }

    this.$$updateEvents = this.$options.getOption('updateOn');
    if (this.$$updateEvents) {
      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    }
  },

  $$updateEventHandler: function(ev) {
    this.$$debounceViewValueCommit(ev && ev.type);
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch(scope) {
    var modelValue = ctrl.$$ngModelGet(scope);

    // if scope model value and ngModel value are out of sync
    // This cannot be moved to the action function, because it would not catch the
    // case where the model is changed in the ngChange function or the model setter
    if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$$setModelValue(modelValue);
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          modelCtrl.$$setUpdateOnEvents();

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /** @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ### Default events, extra triggers, and catch-all debounce values
 *
 * This example shows the relationship between "default" update events and
 * additional `updateOn` triggers.
 *
 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
 * in `updateOn` is considered a "default" event, since different control types have different
 * default events.
 *
 * The control in this example updates by "default", "click", and "blur", with different `debounce`
 * values. You can see that "click" doesn't have an individual `debounce` value -
 * therefore it uses the `*` debounce value.
 *
 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
 * it is considered a "default" event and will update the
 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
 *
 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
 *
  <example name="ngModelOptions-advanced" module="optionsExample">
    <file name="index.html">
       <model-update-demo></model-update-demo>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .component('modelUpdateDemo', {
          templateUrl: 'template.html',
          controller: function() {
            this.name = 'Chinua';

            this.options = {
              updateOn: 'default blur click',
              debounce: {
                default: 2000,
                blur: 0,
                '*': 1000
              }
            };

            this.updateEvents = function() {
              var eventList = this.options.updateOn.split(' ');
              eventList.push('*');
              var events = {};

              for (var i = 0; i < eventList.length; i++) {
                events[eventList[i]] = this.options.debounce[eventList[i]];
              }

              this.events = events;
            };

            this.updateOptions = function() {
              var options = angular.extend(this.options, {
                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                debounce: this.events
              });

              this.form.input.$overrideModelOptions(options);
            };

            // Initialize the event form
            this.updateEvents();
          }
        });
    </file>
    <file name="template.html">
      <form name="$ctrl.form">
        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
      </form>
      Model: <tt>{{$ctrl.name}}</tt>
      <hr>
      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>

      <hr>
      <form ng-submit="$ctrl.updateOptions()">
        <b>updateOn</b><br>
        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">

        <table>
          <tr>
            <th>Option</th>
            <th>Debounce value</th>
          </tr>
          <tr ng-repeat="(key, value) in $ctrl.events">
            <td>{{key}}</td>
            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
          </tr>
        </table>

        <br>
        <input type="submit" value="Update options">
      </form>
    </file>
  </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 * See also the example for
 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
 * Default events, extra triggers, and catch-all debounce values}.
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Formatting the value of `time` and `datetime-local`
 *
 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
 * that is displayed in the control. Note that browsers may apply their own formatting
 * in the user interface.
 *
   <example name="ngModelOptions-time-format" module="timeExample">
     <file name="index.html">
       <time-example></time-example>
     </file>
     <file name="script.js">
        angular.module('timeExample', [])
          .component('timeExample', {
            templateUrl: 'timeExample.html',
            controller: function() {
              this.time = new Date(1970, 0, 1, 14, 57, 0);

              this.options = {
                timeSecondsFormat: 'ss',
                timeStripZeroSeconds: true
              };

              this.optionChange = function() {
                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                this.time = new Date(this.time);
              };
            }
          });
     </file>
     <file name="timeExample.html">
       <form name="$ctrl.timeForm">
         <strong>Default</strong>:
         <input type="time" ng-model="$ctrl.time" step="any" /><br>
         <strong>With options</strong>:
         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
         <br>

         Options:<br>
         <code>timeSecondsFormat</code>:
         <input
           type="text"
           ng-model="$ctrl.options.timeSecondsFormat"
           ng-change="$ctrl.optionChange()">
         <br>
         <code>timeStripZeroSeconds</code>:
         <input
           type="checkbox"
           ng-model="$ctrl.options.timeStripZeroSeconds"
           ng-change="$ctrl.optionChange()">
        </form>
      </file>
 *  </example>
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents.
 *
 * **General options**:
 *
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *     You can use the `*` key to specify a debounce value that applies to all events that are not
 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur mouseup',
 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *
 *
 *  **Input-type specific options**:
 *
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *     Note that changing the timezone will have no effect on the current date, and is only applied after
 *     the next input / model change.
 *
 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
 *     milliseconds. The option follows the format string of {@link date date filter}.
 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
 *     seconds and milliseconds.
 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
 *     part of the time string, and may show the value differently in the user interface.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
 *     after `timeSecondsFormat`.
 *     This option can be used to make the formatting consistent over different browsers, as some
 *     browsers with support for `time` will natively hide the milliseconds and
 *     seconds if they are zero, but others won't, and browsers that don't implement these input
 *     types will always show the full string.
 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRef
 * @restrict A
 *
 * @description
 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
 * element to the scope.
 *
 * If the element with `ngRef` is destroyed `null` is assigned to the property.
 *
 * Note that if you want to assign from a child into the parent scope, you must initialize the
 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
 * {@link ngRepeat}. See the second example below.
 *
 *
 * @element ANY
 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
 *                       controller or jqlite-wrapped DOM element will be bound.
 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
 *                            or the special string `$element`. If a name is provided, `ngRef` will
 *                            assign the matching controller. If `$element` is provided, the element
 *                            itself is assigned (even if a controller is available).
 *
 *
 * @example
 * ### Simple toggle
 * This example shows how the controller of the component toggle
 * is reused in the template through the scope to use its logic.
 * <example name="ng-ref-component" module="myApp">
 *   <file name="index.html">
 *     <my-toggle ng-ref="myToggle"></my-toggle>
 *     <button ng-click="myToggle.toggle()">Toggle</button>
 *     <div ng-show="myToggle.isOpen()">
 *       You are using a component in the same template to show it.
 *     </div>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myToggle', {
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should publish the toggle into the scope', function() {
 *        var toggle = element(by.buttonText('Toggle'));
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
 *        toggle.click();
 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### ngRef inside scopes
 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
 * because the target property has not been initialized on the `myRoot` component controller.
 *
 * <example name="ng-ref-scopes" module="myApp">
 *   <file name="index.html">
 *     <my-root></my-root>
 *   </file>
 *   <file name="index.js">
 *     angular.module('myApp', [])
 *     .component('myRoot', {
 *       templateUrl: 'root.html',
 *       controller: function() {
 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
 *       }
 *     })
 *     .component('myToggle', {
 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
 *       transclude: true,
 *       controller: function ToggleController() {
 *         var opened = false;
 *         this.isOpen = function() { return opened; };
 *         this.toggle = function() { opened = !opened; };
 *       }
 *     })
 *     .component('myWrapper', {
 *       transclude: true,
 *       template: '<strong>myWrapper</strong>' +
 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
 *     });
 *   </file>
 *   <file name="root.html">
 *     <strong>myRoot</strong>
 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     <div><em>wrappers assigned to root</em><br>
 *     <div ng-repeat="wrapper in $ctrl.wrappers">
 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
 *     </div>
 *
 *     <ul>
 *       <li ng-repeat="(index, value) in [1,2,3]">
 *         <strong>ngRepeat</strong>
 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
 *       </li>
 *     </ul>
 *
 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
 *       assigned to the child scope created by ngIf.
 *     </div>
 *     <div ng-if="true">
          <strong>ngIf</strong>
 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
 *     </div>
 *   </file>
 *   <file name="styles.css">
 *     ul {
 *       list-style: none;
 *       padding-left: 0;
 *     }
 *
 *     li[ng-repeat] {
 *       background: lightgreen;
 *       padding: 8px;
 *       margin: 8px;
 *     }
 *
 *     [ng-if] {
 *       background: lightgrey;
 *       padding: 8px;
 *     }
 *
 *     my-root {
 *       background: lightgoldenrodyellow;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-wrapper {
 *       background: lightsalmon;
 *       padding: 8px;
 *       display: block;
 *     }
 *
 *     my-toggle {
 *       background: lightblue;
 *       padding: 8px;
 *       display: block;
 *     }
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      var OuterToggle = function() {
 *        this.toggle = function() {
 *          element(by.buttonText('Outer Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
 *        };
 *      };
 *      var NgRepeatToggle = function(i) {
 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
 *        this.toggle = function() {
 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
 *        };
 *        this.isOpen = function() {
 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *      var NgRepeatToggles = function() {
 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
 *        this.forEach = function(fn) {
 *          toggles.forEach(fn);
 *        };
 *        this.isOuterOpen = function(i) {
 *          return toggles[i - 1].isOuterOpen();
 *        };
 *      };
 *      var NgIfToggle = function() {
 *        var parent = element(by.css('[ng-if]'));
 *        this.toggle = function() {
 *          element(by.buttonText('ngIf Toggle')).click();
 *        };
 *        this.isOpen = function() {
 *          return by.binding('ngIfToggle.isOpen() | json').getText();
 *        };
 *        this.isOuterOpen = function() {
 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
 *        };
 *      };
 *
 *      it('should toggle the outer toggle', function() {
 *        var outerToggle = new OuterToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle all outer toggles', function() {
 *        var outerToggle = new OuterToggle();
 *        var repeatToggles = new NgRepeatToggles();
 *        var ifToggle = new NgIfToggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        outerToggle.toggle();
 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
 *      });
 *
 *      it('should toggle each repeat iteration separately', function() {
 *        var repeatToggles = new NgRepeatToggles();
 *
 *        repeatToggles.forEach(function(repeatToggle) {
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *          repeatToggle.toggle();
 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
 *        });
 *      });
 *   </file>
 * </example>
 *
 */

var ngRefMinErr = minErr('ngRef');

var ngRefDirective = ['$parse', function($parse) {
  return {
    priority: -1, // Needed for compatibility with element transclusion on the same element
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      // Get the expected controller name, converts <data-some-thing> into "someThing"
      var controllerName = directiveNormalize(nodeName_(tElement));

      // Get the expression for value binding
      var getter = $parse(tAttrs.ngRef);
      var setter = getter.assign || function() {
        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
      };

      return function(scope, element, attrs) {
        var refValue;

        if (attrs.hasOwnProperty('ngRefRead')) {
          if (attrs.ngRefRead === '$element') {
            refValue = element;
          } else {
            refValue = element.data('$' + attrs.ngRefRead + 'Controller');

            if (!refValue) {
              throw ngRefMinErr(
                'noctrl',
                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
                attrs.ngRefRead,
                tAttrs.ngRef
              );
            }
          }
        } else {
          refValue = element.data('$' + controllerName + 'Controller');
        }

        refValue = refValue || element;

        setter(scope, refValue);

        // when the element is removed, remove it (nullify it)
        element.on('$destroy', function() {
          // only remove it if value has not changed,
          // because animations (and other procedures) may duplicate elements
          if (getter(scope) === refValue) {
            setter(scope, null);
          }
        });
      };
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };

  var trackByIdArrayFn = function($scope, key, value) {
    return hashKey(value);
  };

  var trackByIdObjFn = function($scope, key) {
    return key;
  };

  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByIdExpFn;

      if (trackByExp) {
        var hashFnLocals = {$id: hashKey};
        var trackByExpGetter = $parse(trackByExp);

        trackByIdExpFn = function($scope, key, value, index) {
          // assign key, value, and $index to the locals so that they can be used in hash functions
          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
          hashFnLocals[valueIdentifier] = value;
          hashFnLocals.$index = index;
          return trackByExpGetter($scope, hashFnLocals);
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - clone: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn($scope, key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
          // being leaked into the ngRepeatCompile function scope
          if (hashFnLocals) {
            hashFnLocals[valueIdentifier] = undefined;
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngShow to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * @knownIssue
 *
 * ### Flickering when using ngHide to toggle between elements
 *
 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
 * happen that both the element to show and the element to hide are visible for a very short time.
 *
 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
 * other browsers.
 *
 * There are several way to mitigate this problem:
 *
 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
 * - Define an animation on the affected elements.
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, ''); });
    }
    if (newStyles) element.css(newStyles);
  });
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function setOptionSelectedStatus(optionEl, value) {
  optionEl.prop('selected', value);
  /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
  optionEl.attr('selected', value);
}

/**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new NgMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that the application developer can
  // provide inside the select. It is always selectable and indicates that a "null" selection has
  // been made by the user.
  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
  // the empty option is selected.
  // If the model is set to a different unmatched value, the unknown option is rendered and
  // selected, i.e both are present, because a "null" selection and an unknown value are different.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionSelectedStatus(self.emptyOption, true);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      setOptionSelectedStatus(self.emptyOption, false);
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionSelectedStatus(jqLite(selectedOption), true);
    } else {
      self.selectUnknownOrEmptyOption(value);
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.set(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.delete(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.set(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
  self.$hasEmptyOption = function() {
    return self.hasEmptyOption;
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
  self.$isUnknownOptionSelected = function() {
    // Presence of the unknown option means it is selected
    return $element[0].options[0] === self.unknownOption[0];
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
  self.$isEmptyOptionSelected = function() {
    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
  };

  self.selectUnknownOrEmptyOption = function(value) {
    if (value == null && self.emptyOption) {
      self.removeUnknownOption();
      self.selectEmptyOption();
    } else if (self.unknownOption.parent().length) {
      self.updateUnknownOption(value);
    } else {
      self.renderUnknownOption(value);
    }
  };

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      scheduleRender();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function(option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      // For boolean attributes like required, presence means true
      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);

      if (!attr.ngRequired) {
        // force truthy in case we are on non input element
        // (input elements do this automatically for boolean attributes like required)
        attr.required = true;
      }

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !value || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function(newVal) {

        if (value !== newVal) {
          value = newVal;
          ctrl.$validate();
        }
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    compile: function(tElm, tAttr) {
      var patternExp;
      var parseFn;

      if (tAttr.ngPattern) {
        patternExp = tAttr.ngPattern;

        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
        // We get value of the attribute here, so we can compare the old and the new value
        // in the observer to avoid unnecessary validations
        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
          parseFn = function() { return tAttr.ngPattern; };
        } else {
          parseFn = $parse(tAttr.ngPattern);
        }
      }

      return function(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var attrVal = attr.pattern;

        if (attr.ngPattern) {
          attrVal = parseFn(scope);
        } else {
          patternExp = attr.pattern;
        }

        var regexp = parsePatternAttr(attrVal, patternExp, elm);

        attr.$observe('pattern', function(newVal) {
          var oldRegexp = regexp;

          regexp = parsePatternAttr(newVal, patternExp, elm);

          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
            ctrl.$validate();
          }
        });

        ctrl.$validators.pattern = function(modelValue, viewValue) {
          // HTML5 pattern constraint validates the input value, so we validate the viewValue
          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
        };
      };
    }

  };
}];

/**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
      var maxlengthParsed = parseLength(maxlength);

      attr.$observe('maxlength', function(value) {
        if (maxlength !== value) {
          maxlengthParsed = parseLength(value);
          maxlength = value;
          ctrl.$validate();
        }
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = ['$parse', function($parse) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
      var minlengthParsed = parseLength(minlength) || -1;

      attr.$observe('minlength', function(value) {
        if (minlength !== value) {
          minlengthParsed = parseLength(value) || -1;
          minlength = value;
          ctrl.$validate();
        }

      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
      };
    }
  };
}];


function parsePatternAttr(regex, patternExp, elm) {
  if (!regex) return undefined;

  if (isString(regex)) {
    regex = new RegExp('^' + regex + '$');
  }

  if (!regex.test) {
    throw minErr('ngPattern')('noregexp',
      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
      regex, startingTag(elm));
  }

  return regex;
}

function parseLength(val) {
  var intVal = toInt(val);
  return isNumberNaN(intVal) ? -1 : intVal;
}

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load AngularJS more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular/index.js":[function(_dereq_,module,exports){
_dereq_('./angular');
module.exports = angular;

},{"./angular":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular/angular.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/lazysizes/lazysizes.js":[function(_dereq_,module,exports){
(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/lz-string/libs/lz-string.js":[function(_dereq_,module,exports){
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (typeof define === 'function' && define.amd) {
  define(function () { return LZString; });
} else if( typeof module !== 'undefined' && module != null ) {
  module.exports = LZString
} else if( typeof angular !== 'undefined' && angular != null ) {
  angular.module('LZString', [])
  .factory('LZString', function () {
    return LZString;
  });
}

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/polyfill-object.fromentries/index.js":[function(_dereq_,module,exports){
/*
    Copyright 2018  Alfredo Mungo <alfredo.mungo@protonmail.ch>

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
*/
if (!Object.fromEntries) {
  Object.defineProperty(Object, 'fromEntries', {
    value(entries) {
      if (!entries || !entries[Symbol.iterator]) { throw new Error('Object.fromEntries() requires a single iterable argument'); }

      const o = {};

      Object.keys(entries).forEach((key) => {
        const [k, v] = entries[key];

        o[k] = v;
      });

      return o;
    },
  });
}

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/print-js/dist/print.js":[function(_dereq_,module,exports){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["printJS"] = factory();
	else
		root["printJS"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _sass_index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./sass/index.scss */ "./src/sass/index.scss");
/* harmony import */ var _sass_index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_sass_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _js_init__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./js/init */ "./src/js/init.js");


var printJS = _js_init__WEBPACK_IMPORTED_MODULE_1__["default"].init;

if (typeof window !== 'undefined') {
  window.printJS = printJS;
}

/* harmony default export */ __webpack_exports__["default"] = (printJS);

/***/ }),

/***/ "./src/js/browser.js":
/*!***************************!*\
  !*** ./src/js/browser.js ***!
  \***************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var Browser = {
  // Firefox 1.0+
  isFirefox: function isFirefox() {
    return typeof InstallTrigger !== 'undefined';
  },
  // Internet Explorer 6-11
  isIE: function isIE() {
    return navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode;
  },
  // Edge 20+
  isEdge: function isEdge() {
    return !Browser.isIE() && !!window.StyleMedia;
  },
  // Chrome 1+
  isChrome: function isChrome() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
    return !!context.chrome;
  },
  // At least Safari 3+: "[object HTMLElementConstructor]"
  isSafari: function isSafari() {
    return Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.toLowerCase().indexOf('safari') !== -1;
  },
  // IOS Chrome
  isIOSChrome: function isIOSChrome() {
    return navigator.userAgent.toLowerCase().indexOf('crios') !== -1;
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Browser);

/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/*! exports provided: addWrapper, capitalizePrint, collectStyles, addHeader, cleanUp, isRawHTML */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addWrapper", function() { return addWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalizePrint", function() { return capitalizePrint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "collectStyles", function() { return collectStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHeader", function() { return addHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanUp", function() { return cleanUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRawHTML", function() { return isRawHTML; });
/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modal */ "./src/js/modal.js");
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



function addWrapper(htmlData, params) {
  var bodyStyle = 'font-family:' + params.font + ' !important; font-size: ' + params.font_size + ' !important; width:100%;';
  return '<div style="' + bodyStyle + '">' + htmlData + '</div>';
}
function capitalizePrint(obj) {
  return obj.charAt(0).toUpperCase() + obj.slice(1);
}
function collectStyles(element, params) {
  var win = document.defaultView || window; // String variable to hold styling for each element

  var elementStyle = ''; // Loop over computed styles

  var styles = win.getComputedStyle(element, '');

  for (var key = 0; key < styles.length; key++) {
    // Check if style should be processed
    if (params.targetStyles.indexOf('*') !== -1 || params.targetStyle.indexOf(styles[key]) !== -1 || targetStylesMatch(params.targetStyles, styles[key])) {
      if (styles.getPropertyValue(styles[key])) elementStyle += styles[key] + ':' + styles.getPropertyValue(styles[key]) + ';';
    }
  } // Print friendly defaults (deprecated)


  elementStyle += 'max-width: ' + params.maxWidth + 'px !important; font-size: ' + params.font_size + ' !important;';
  return elementStyle;
}

function targetStylesMatch(styles, value) {
  for (var i = 0; i < styles.length; i++) {
    if (_typeof(value) === 'object' && value.indexOf(styles[i]) !== -1) return true;
  }

  return false;
}

function addHeader(printElement, params) {
  // Create the header container div
  var headerContainer = document.createElement('div'); // Check if the header is text or raw html

  if (isRawHTML(params.header)) {
    headerContainer.innerHTML = params.header;
  } else {
    // Create header element
    var headerElement = document.createElement('h1'); // Create header text node

    var headerNode = document.createTextNode(params.header); // Build and style

    headerElement.appendChild(headerNode);
    headerElement.setAttribute('style', params.headerStyle);
    headerContainer.appendChild(headerElement);
  }

  printElement.insertBefore(headerContainer, printElement.childNodes[0]);
}
function cleanUp(params) {
  // If we are showing a feedback message to user, remove it
  if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_0__["default"].close(); // Check for a finished loading hook function

  if (params.onLoadingEnd) params.onLoadingEnd(); // If preloading pdf files, clean blob url

  if (params.showModal || params.onLoadingStart) window.URL.revokeObjectURL(params.printable); // Run onPrintDialogClose callback

  var event = 'mouseover';

  if (_browser__WEBPACK_IMPORTED_MODULE_1__["default"].isChrome() || _browser__WEBPACK_IMPORTED_MODULE_1__["default"].isFirefox()) {
    // Ps.: Firefox will require an extra click in the document to fire the focus event.
    event = 'focus';
  }

  var handler = function handler() {
    // Make sure the event only happens once.
    window.removeEventListener(event, handler);
    params.onPrintDialogClose(); // Remove iframe from the DOM

    var iframe = document.getElementById(params.frameId);

    if (iframe) {
      iframe.remove();
    }
  };

  window.addEventListener(event, handler);
}
function isRawHTML(raw) {
  var regexHtml = new RegExp('<([A-Za-z][A-Za-z0-9]*)\\b[^>]*>(.*?)</\\1>');
  return regexHtml.test(raw);
}

/***/ }),

/***/ "./src/js/html.js":
/*!************************!*\
  !*** ./src/js/html.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/* harmony default export */ __webpack_exports__["default"] = ({
  print: function print(params, printFrame) {
    // Get the DOM printable element
    var printElement = isHtmlElement(params.printable) ? params.printable : document.getElementById(params.printable); // Check if the element exists

    if (!printElement) {
      window.console.error('Invalid HTML element id: ' + params.printable);
      return;
    } // Clone the target element including its children (if available)


    params.printableElement = cloneElement(printElement, params); // Add header

    if (params.header) {
      Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params);
    } // Print html element contents


    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
  }
});

function cloneElement(element, params) {
  // Clone the main node (if not already inside the recursion process)
  var clone = element.cloneNode(); // Loop over and process the children elements / nodes (including text nodes)

  var childNodesArray = Array.prototype.slice.call(element.childNodes);

  for (var i = 0; i < childNodesArray.length; i++) {
    // Check if we are skipping the current element
    if (params.ignoreElements.indexOf(childNodesArray[i].id) !== -1) {
      continue;
    } // Clone the child element


    var clonedChild = cloneElement(childNodesArray[i], params); // Attach the cloned child to the cloned parent node

    clone.appendChild(clonedChild);
  } // Get all styling for print element (for nodes of type element only)


  if (params.scanStyles && element.nodeType === 1) {
    clone.setAttribute('style', Object(_functions__WEBPACK_IMPORTED_MODULE_0__["collectStyles"])(element, params));
  } // Check if the element needs any state processing (copy user input data)


  switch (element.tagName) {
    case 'SELECT':
      // Copy the current selection value to its clone
      clone.value = element.value;
      break;

    case 'CANVAS':
      // Copy the canvas content to its clone
      clone.getContext('2d').drawImage(element, 0, 0);
      break;
  }

  return clone;
}

function isHtmlElement(printable) {
  // Check if element is instance of HTMLElement or has nodeType === 1 (for elements in iframe)
  return _typeof(printable) === 'object' && printable && (printable instanceof HTMLElement || printable.nodeType === 1);
}

/***/ }),

/***/ "./src/js/image.js":
/*!*************************!*\
  !*** ./src/js/image.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");



/* harmony default export */ __webpack_exports__["default"] = ({
  print: function print(params, printFrame) {
    // Check if we are printing one image or multiple images
    if (params.printable.constructor !== Array) {
      // Create array with one image
      params.printable = [params.printable];
    } // Create printable element (container)


    params.printableElement = document.createElement('div'); // Create all image elements and append them to the printable container

    params.printable.forEach(function (src) {
      // Create the image element
      var img = document.createElement('img');
      img.setAttribute('style', params.imageStyle); // Set image src with the file url

      img.src = src; // The following block is for Firefox, which for some reason requires the image's src to be fully qualified in
      // order to print it

      if (_browser__WEBPACK_IMPORTED_MODULE_2__["default"].isFirefox()) {
        var fullyQualifiedSrc = img.src;
        img.src = fullyQualifiedSrc;
      } // Create the image wrapper


      var imageWrapper = document.createElement('div'); // Append image to the wrapper element

      imageWrapper.appendChild(img); // Append wrapper to the printable element

      params.printableElement.appendChild(imageWrapper);
    }); // Check if we are adding a print header

    if (params.header) Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params); // Print image

    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
  }
});

/***/ }),

/***/ "./src/js/init.js":
/*!************************!*\
  !*** ./src/js/init.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modal */ "./src/js/modal.js");
/* harmony import */ var _pdf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pdf */ "./src/js/pdf.js");
/* harmony import */ var _html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./html */ "./src/js/html.js");
/* harmony import */ var _raw_html__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./raw-html */ "./src/js/raw-html.js");
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./image */ "./src/js/image.js");
/* harmony import */ var _json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./json */ "./src/js/json.js");


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }








var printTypes = ['pdf', 'html', 'image', 'json', 'raw-html'];
/* harmony default export */ __webpack_exports__["default"] = ({
  init: function init() {
    var params = {
      printable: null,
      fallbackPrintable: null,
      type: 'pdf',
      header: null,
      headerStyle: 'font-weight: 300;',
      maxWidth: 800,
      properties: null,
      gridHeaderStyle: 'font-weight: bold; padding: 5px; border: 1px solid #dddddd;',
      gridStyle: 'border: 1px solid lightgray; margin-bottom: -1px;',
      showModal: false,
      onError: function onError(error) {
        throw error;
      },
      onLoadingStart: null,
      onLoadingEnd: null,
      onPrintDialogClose: function onPrintDialogClose() {},
      onIncompatibleBrowser: function onIncompatibleBrowser() {},
      modalMessage: 'Retrieving Document...',
      frameId: 'printJS',
      printableElement: null,
      documentTitle: 'Document',
      targetStyle: ['clear', 'display', 'width', 'min-width', 'height', 'min-height', 'max-height'],
      targetStyles: ['border', 'box', 'break', 'text-decoration'],
      ignoreElements: [],
      repeatTableHeader: true,
      css: null,
      style: null,
      scanStyles: true,
      base64: false,
      // Deprecated
      onPdfOpen: null,
      font: 'TimesNewRoman',
      font_size: '12pt',
      honorMarginPadding: true,
      honorColor: false,
      imageStyle: 'max-width: 100%;'
    }; // Check if a printable document or object was supplied

    var args = arguments[0];

    if (args === undefined) {
      throw new Error('printJS expects at least 1 attribute.');
    } // Process parameters


    switch (_typeof(args)) {
      case 'string':
        params.printable = encodeURI(args);
        params.fallbackPrintable = params.printable;
        params.type = arguments[1] || params.type;
        break;

      case 'object':
        params.printable = args.printable;
        params.fallbackPrintable = typeof args.fallbackPrintable !== 'undefined' ? args.fallbackPrintable : params.printable;
        params.fallbackPrintable = params.base64 ? "data:application/pdf;base64,".concat(params.fallbackPrintable) : params.fallbackPrintable;

        for (var k in params) {
          if (k === 'printable' || k === 'fallbackPrintable') continue;
          params[k] = typeof args[k] !== 'undefined' ? args[k] : params[k];
        }

        break;

      default:
        throw new Error('Unexpected argument type! Expected "string" or "object", got ' + _typeof(args));
    } // Validate printable


    if (!params.printable) throw new Error('Missing printable information.'); // Validate type

    if (!params.type || typeof params.type !== 'string' || printTypes.indexOf(params.type.toLowerCase()) === -1) {
      throw new Error('Invalid print type. Available types are: pdf, html, image and json.');
    } // Check if we are showing a feedback message to the user (useful for large files)


    if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_1__["default"].show(params); // Check for a print start hook function

    if (params.onLoadingStart) params.onLoadingStart(); // To prevent duplication and issues, remove any used printFrame from the DOM

    var usedFrame = document.getElementById(params.frameId);
    if (usedFrame) usedFrame.parentNode.removeChild(usedFrame); // Create a new iframe for the print job

    var printFrame = document.createElement('iframe');

    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) {
      // Set the iframe to be is visible on the page (guaranteed by fixed position) but hidden using opacity 0, because
      // this works in Firefox. The height needs to be sufficient for some part of the document other than the PDF
      // viewer's toolbar to be visible in the page
      printFrame.setAttribute('style', 'width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0');
    } else {
      // Hide the iframe in other browsers
      printFrame.setAttribute('style', 'visibility: hidden; height: 0; width: 0; position: absolute; border: 0');
    } // Set iframe element id


    printFrame.setAttribute('id', params.frameId); // For non pdf printing, pass an html document string to srcdoc (force onload callback)

    if (params.type !== 'pdf') {
      printFrame.srcdoc = '<html><head><title>' + params.documentTitle + '</title>'; // Attach css files

      if (params.css) {
        // Add support for single file
        if (!Array.isArray(params.css)) params.css = [params.css]; // Create link tags for each css file

        params.css.forEach(function (file) {
          printFrame.srcdoc += '<link rel="stylesheet" href="' + file + '">';
        });
      }

      printFrame.srcdoc += '</head><body></body></html>';
    } // Check printable type


    switch (params.type) {
      case 'pdf':
        // Check browser support for pdf and if not supported we will just open the pdf file instead
        if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isIE()) {
          try {
            console.info('Print.js doesn\'t support PDF printing in Internet Explorer.');
            var win = window.open(params.fallbackPrintable, '_blank');
            win.focus();
            params.onIncompatibleBrowser();
          } catch (error) {
            params.onError(error);
          } finally {
            // Make sure there is no loading modal opened
            if (params.showModal) _modal__WEBPACK_IMPORTED_MODULE_1__["default"].close();
            if (params.onLoadingEnd) params.onLoadingEnd();
          }
        } else {
          _pdf__WEBPACK_IMPORTED_MODULE_2__["default"].print(params, printFrame);
        }

        break;

      case 'image':
        _image__WEBPACK_IMPORTED_MODULE_5__["default"].print(params, printFrame);
        break;

      case 'html':
        _html__WEBPACK_IMPORTED_MODULE_3__["default"].print(params, printFrame);
        break;

      case 'raw-html':
        _raw_html__WEBPACK_IMPORTED_MODULE_4__["default"].print(params, printFrame);
        break;

      case 'json':
        _json__WEBPACK_IMPORTED_MODULE_6__["default"].print(params, printFrame);
        break;
    }
  }
});

/***/ }),

/***/ "./src/js/json.js":
/*!************************!*\
  !*** ./src/js/json.js ***!
  \************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



/* harmony default export */ __webpack_exports__["default"] = ({
  print: function print(params, printFrame) {
    // Check if we received proper data
    if (_typeof(params.printable) !== 'object') {
      throw new Error('Invalid javascript data object (JSON).');
    } // Validate repeatTableHeader


    if (typeof params.repeatTableHeader !== 'boolean') {
      throw new Error('Invalid value for repeatTableHeader attribute (JSON).');
    } // Validate properties


    if (!params.properties || !Array.isArray(params.properties)) {
      throw new Error('Invalid properties array for your JSON data.');
    } // We will format the property objects to keep the JSON api compatible with older releases


    params.properties = params.properties.map(function (property) {
      return {
        field: _typeof(property) === 'object' ? property.field : property,
        displayName: _typeof(property) === 'object' ? property.displayName : property,
        columnSize: _typeof(property) === 'object' && property.columnSize ? property.columnSize + ';' : 100 / params.properties.length + '%;'
      };
    }); // Create a print container element

    params.printableElement = document.createElement('div'); // Check if we are adding a print header

    if (params.header) {
      Object(_functions__WEBPACK_IMPORTED_MODULE_0__["addHeader"])(params.printableElement, params);
    } // Build the printable html data


    params.printableElement.innerHTML += jsonToHTML(params); // Print the json data

    _print__WEBPACK_IMPORTED_MODULE_1__["default"].send(params, printFrame);
  }
});

function jsonToHTML(params) {
  // Get the row and column data
  var data = params.printable;
  var properties = params.properties; // Create a html table

  var htmlData = '<table style="border-collapse: collapse; width: 100%;">'; // Check if the header should be repeated

  if (params.repeatTableHeader) {
    htmlData += '<thead>';
  } // Add the table header row


  htmlData += '<tr>'; // Add the table header columns

  for (var a = 0; a < properties.length; a++) {
    htmlData += '<th style="width:' + properties[a].columnSize + ';' + params.gridHeaderStyle + '">' + Object(_functions__WEBPACK_IMPORTED_MODULE_0__["capitalizePrint"])(properties[a].displayName) + '</th>';
  } // Add the closing tag for the table header row


  htmlData += '</tr>'; // If the table header is marked as repeated, add the closing tag

  if (params.repeatTableHeader) {
    htmlData += '</thead>';
  } // Create the table body


  htmlData += '<tbody>'; // Add the table data rows

  for (var i = 0; i < data.length; i++) {
    // Add the row starting tag
    htmlData += '<tr>'; // Print selected properties only

    for (var n = 0; n < properties.length; n++) {
      var stringData = data[i]; // Support nested objects

      var property = properties[n].field.split('.');

      if (property.length > 1) {
        for (var p = 0; p < property.length; p++) {
          stringData = stringData[property[p]];
        }
      } else {
        stringData = stringData[properties[n].field];
      } // Add the row contents and styles


      htmlData += '<td style="width:' + properties[n].columnSize + params.gridStyle + '">' + stringData + '</td>';
    } // Add the row closing tag


    htmlData += '</tr>';
  } // Add the table and body closing tags


  htmlData += '</tbody></table>';
  return htmlData;
}

/***/ }),

/***/ "./src/js/modal.js":
/*!*************************!*\
  !*** ./src/js/modal.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var Modal = {
  show: function show(params) {
    // Build modal
    var modalStyle = 'font-family:sans-serif; ' + 'display:table; ' + 'text-align:center; ' + 'font-weight:300; ' + 'font-size:30px; ' + 'left:0; top:0;' + 'position:fixed; ' + 'z-index: 9990;' + 'color: #0460B5; ' + 'width: 100%; ' + 'height: 100%; ' + 'background-color:rgba(255,255,255,.9);' + 'transition: opacity .3s ease;'; // Create wrapper

    var printModal = document.createElement('div');
    printModal.setAttribute('style', modalStyle);
    printModal.setAttribute('id', 'printJS-Modal'); // Create content div

    var contentDiv = document.createElement('div');
    contentDiv.setAttribute('style', 'display:table-cell; vertical-align:middle; padding-bottom:100px;'); // Add close button (requires print.css)

    var closeButton = document.createElement('div');
    closeButton.setAttribute('class', 'printClose');
    closeButton.setAttribute('id', 'printClose');
    contentDiv.appendChild(closeButton); // Add spinner (requires print.css)

    var spinner = document.createElement('span');
    spinner.setAttribute('class', 'printSpinner');
    contentDiv.appendChild(spinner); // Add message

    var messageNode = document.createTextNode(params.modalMessage);
    contentDiv.appendChild(messageNode); // Add contentDiv to printModal

    printModal.appendChild(contentDiv); // Append print modal element to document body

    document.getElementsByTagName('body')[0].appendChild(printModal); // Add event listener to close button

    document.getElementById('printClose').addEventListener('click', function () {
      Modal.close();
    });
  },
  close: function close() {
    var printModal = document.getElementById('printJS-Modal');

    if (printModal) {
      printModal.parentNode.removeChild(printModal);
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),

/***/ "./src/js/pdf.js":
/*!***********************!*\
  !*** ./src/js/pdf.js ***!
  \***********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./print */ "./src/js/print.js");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");


/* harmony default export */ __webpack_exports__["default"] = ({
  print: function print(params, printFrame) {
    // Check if we have base64 data
    if (params.base64) {
      var bytesArray = Uint8Array.from(atob(params.printable), function (c) {
        return c.charCodeAt(0);
      });
      createBlobAndPrint(params, printFrame, bytesArray);
      return;
    } // Format pdf url


    params.printable = /^(blob|http|\/\/)/i.test(params.printable) ? params.printable : window.location.origin + (params.printable.charAt(0) !== '/' ? '/' + params.printable : params.printable); // Get the file through a http request (Preload)

    var req = new window.XMLHttpRequest();
    req.responseType = 'arraybuffer';
    req.addEventListener('error', function () {
      Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
      params.onError(req.statusText, req); // Since we don't have a pdf document available, we will stop the print job
    });
    req.addEventListener('load', function () {
      // Check for errors
      if ([200, 201].indexOf(req.status) === -1) {
        Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
        params.onError(req.statusText, req); // Since we don't have a pdf document available, we will stop the print job

        return;
      } // Print requested document


      createBlobAndPrint(params, printFrame, req.response);
    });
    req.open('GET', params.printable, true);
    req.send();
  }
});

function createBlobAndPrint(params, printFrame, data) {
  // Pass response or base64 data to a blob and create a local object url
  var localPdf = new window.Blob([data], {
    type: 'application/pdf'
  });
  localPdf = window.URL.createObjectURL(localPdf); // Set iframe src with pdf document url

  printFrame.setAttribute('src', localPdf);
  _print__WEBPACK_IMPORTED_MODULE_0__["default"].send(params, printFrame);
}

/***/ }),

/***/ "./src/js/print.js":
/*!*************************!*\
  !*** ./src/js/print.js ***!
  \*************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./browser */ "./src/js/browser.js");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");


var Print = {
  send: function send(params, printFrame) {
    // Append iframe element to document body
    document.getElementsByTagName('body')[0].appendChild(printFrame); // Get iframe element

    var iframeElement = document.getElementById(params.frameId); // Wait for iframe to load all content

    iframeElement.onload = function () {
      if (params.type === 'pdf') {
        // Add a delay for Firefox. In my tests, 1000ms was sufficient but 100ms was not
        if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) {
          setTimeout(function () {
            return performPrint(iframeElement, params);
          }, 1000);
        } else {
          performPrint(iframeElement, params);
        }

        return;
      } // Get iframe element document


      var printDocument = iframeElement.contentWindow || iframeElement.contentDocument;
      if (printDocument.document) printDocument = printDocument.document; // Append printable element to the iframe body

      printDocument.body.appendChild(params.printableElement); // Add custom style

      if (params.type !== 'pdf' && params.style) {
        // Create style element
        var style = document.createElement('style');
        style.innerHTML = params.style; // Append style element to iframe's head

        printDocument.head.appendChild(style);
      } // If printing images, wait for them to load inside the iframe


      var images = printDocument.getElementsByTagName('img');

      if (images.length > 0) {
        loadIframeImages(Array.from(images)).then(function () {
          return performPrint(iframeElement, params);
        });
      } else {
        performPrint(iframeElement, params);
      }
    };
  }
};

function performPrint(iframeElement, params) {
  try {
    iframeElement.focus(); // If Edge or IE, try catch with execCommand

    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isEdge() || _browser__WEBPACK_IMPORTED_MODULE_0__["default"].isIE()) {
      try {
        iframeElement.contentWindow.document.execCommand('print', false, null);
      } catch (e) {
        iframeElement.contentWindow.print();
      }
    } else {
      // Other browsers
      iframeElement.contentWindow.print();
    }
  } catch (error) {
    params.onError(error);
  } finally {
    if (_browser__WEBPACK_IMPORTED_MODULE_0__["default"].isFirefox()) {
      // Move the iframe element off-screen and make it invisible
      iframeElement.style.visibility = 'hidden';
      iframeElement.style.left = '-1px';
    }

    Object(_functions__WEBPACK_IMPORTED_MODULE_1__["cleanUp"])(params);
  }
}

function loadIframeImages(images) {
  var promises = images.map(function (image) {
    if (image.src && image.src !== window.location.href) {
      return loadIframeImage(image);
    }
  });
  return Promise.all(promises);
}

function loadIframeImage(image) {
  return new Promise(function (resolve) {
    var pollImage = function pollImage() {
      !image || typeof image.naturalWidth === 'undefined' || image.naturalWidth === 0 || !image.complete ? setTimeout(pollImage, 500) : resolve();
    };

    pollImage();
  });
}

/* harmony default export */ __webpack_exports__["default"] = (Print);

/***/ }),

/***/ "./src/js/raw-html.js":
/*!****************************!*\
  !*** ./src/js/raw-html.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _print__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./print */ "./src/js/print.js");

/* harmony default export */ __webpack_exports__["default"] = ({
  print: function print(params, printFrame) {
    // Create printable element (container)
    params.printableElement = document.createElement('div');
    params.printableElement.setAttribute('style', 'width:100%'); // Set our raw html as the printable element inner html content

    params.printableElement.innerHTML = params.printable; // Print html contents

    _print__WEBPACK_IMPORTED_MODULE_0__["default"].send(params, printFrame);
  }
});

/***/ }),

/***/ "./src/sass/index.scss":
/*!*****************************!*\
  !*** ./src/sass/index.scss ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/index.js */"./src/index.js");


/***/ })

/******/ })["default"];
});

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/promise-any-polyfill/js/implementation.js":[function(_dereq_,module,exports){
Promise.any=o=>new Promise(((i,l)=>{var n,t,v,d,e;let u=!1,c=[],h=0,f=[];function a(o){u||(u=!0,i(o))}function r(o){f.push(o),f.length>=h&&l(f)}for(let i of o)h++,c.push(i);for(let o of c)void 0!==(null===(n=o)||void 0===n?void 0:n.then)||void 0!==(null===(t=o)||void 0===t?void 0:t.catch)?(null===(d=null===(v=o)||void 0===v?void 0:v.then((o=>a(o))))||void 0===d||d.catch((o=>{})),null===(e=o)||void 0===e||e.catch((o=>r(o)))):a(o)}));


},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/pym.js/dist/pym.v1.js":[function(_dereq_,module,exports){
/*! pym.js - v1.3.2 - 2018-02-13 */
/*
* Pym.js is library that resizes an iframe based on the width of the parent and the resulting height of the child.
* Check out the docs at http://blog.apps.npr.org/pym.js/ or the readme at README.md for usage.
*/

/** @module pym */
(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    }
    else if (typeof module !== 'undefined' && module.exports) {
        module.exports = factory();
    } else {
        window.pym = factory.call(this);
    }
})(function() {
    var MESSAGE_DELIMITER = 'xPYMx';

    var lib = {};

    /**
    * Create and dispatch a custom pym event
    *
    * @method _raiseCustomEvent
    * @inner
    *
    * @param {String} eventName
    */
   var _raiseCustomEvent = function(eventName) {
     var event = document.createEvent('Event');
     event.initEvent('pym:' + eventName, true, true);
     document.dispatchEvent(event);
   };

    /**
    * Generic function for parsing URL params.
    * Via http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    *
    * @method _getParameterByName
    * @inner
    *
    * @param {String} name The name of the paramter to get from the URL.
    */
    var _getParameterByName = function(name) {
        var regex = new RegExp("[\\?&]" + name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') + '=([^&#]*)');
        var results = regex.exec(location.search);

        if (results === null) {
            return '';
        }

        return decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    /**
     * Check the message to make sure it comes from an acceptable xdomain.
     * Defaults to '*' but can be overriden in config.
     *
     * @method _isSafeMessage
     * @inner
     *
     * @param {Event} e The message event.
     * @param {Object} settings Configuration.
     */
    var _isSafeMessage = function(e, settings) {
        if (settings.xdomain !== '*') {
            // If origin doesn't match our xdomain, return.
            if (!e.origin.match(new RegExp(settings.xdomain + '$'))) { return; }
        }

        // Ignore events that do not carry string data #151
        if (typeof e.data !== 'string') { return; }

        return true;
    };

    var _isSafeUrl = function(url) {
        // Adapted from angular 2 url sanitizer
        var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/gi;
        if (!url.match(SAFE_URL_PATTERN)) { return; }
        
        return true;
    };

    /**
     * Construct a message to send between frames.
     *
     * NB: We use string-building here because JSON message passing is
     * not supported in all browsers.
     *
     * @method _makeMessage
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     * @param {String} messageType The type of message to send.
     * @param {String} message The message to send.
     */
    var _makeMessage = function(id, messageType, message) {
        var bits = ['pym', id, messageType, message];

        return bits.join(MESSAGE_DELIMITER);
    };

    /**
     * Construct a regex to validate and parse messages.
     *
     * @method _makeMessageRegex
     * @inner
     *
     * @param {String} id The unique id of the message recipient.
     */
    var _makeMessageRegex = function(id) {
        var bits = ['pym', id, '(\\S+)', '(.*)'];

        return new RegExp('^' + bits.join(MESSAGE_DELIMITER) + '$');
    };

    /**
    * Underscore implementation of getNow
    *
    * @method _getNow
    * @inner
    *
    */
    var _getNow = Date.now || function() {
        return new Date().getTime();
    };

    /**
    * Underscore implementation of throttle
    *
    * @method _throttle
    * @inner
    *
    * @param {function} func Throttled function
    * @param {number} wait Throttle wait time
    * @param {object} options Throttle settings
    */

    var _throttle = function(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) {options = {};}
        var later = function() {
            previous = options.leading === false ? 0 : _getNow();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) {context = args = null;}
        };
        return function() {
            var now = _getNow();
            if (!previous && options.leading === false) {previous = now;}
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) {context = args = null;}
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    /**
     * Clean autoInit Instances: those that point to contentless iframes
     * @method _cleanAutoInitInstances
     * @inner
     */
    var _cleanAutoInitInstances = function() {
        var length = lib.autoInitInstances.length;

        // Loop backwards to avoid index issues
        for (var idx = length - 1; idx >= 0; idx--) {
            var instance = lib.autoInitInstances[idx];
            // If instance has been removed or is contentless then remove it
            if (instance.el.getElementsByTagName('iframe').length &&
                instance.el.getElementsByTagName('iframe')[0].contentWindow) {
                continue;
            }
            else {
                // Remove the reference to the removed or orphan instance
                lib.autoInitInstances.splice(idx,1);
            }
        }
    };

    /**
     * Store auto initialized Pym instances for further reference
     * @name module:pym#autoInitInstances
     * @type Array
     * @default []
     */
    lib.autoInitInstances = [];

    /**
     * Initialize Pym for elements on page that have data-pym attributes.
     * Expose autoinit in case we need to call it from the outside
     * @instance
     * @method autoInit
     * @param {Boolean} doNotRaiseEvents flag to avoid sending custom events
     */
    lib.autoInit = function(doNotRaiseEvents) {
        var elements = document.querySelectorAll('[data-pym-src]:not([data-pym-auto-initialized])');
        var length = elements.length;

        // Clean stored instances in case needed
        _cleanAutoInitInstances();
        for (var idx = 0; idx < length; ++idx) {
            var element = elements[idx];
            /*
            * Mark automatically-initialized elements so they are not
            * re-initialized if the user includes pym.js more than once in the
            * same document.
            */
            element.setAttribute('data-pym-auto-initialized', '');

            // Ensure elements have an id
            if (element.id === '') {
                element.id = 'pym-' + idx + "-" + Math.random().toString(36).substr(2,5);
            }

            var src = element.getAttribute('data-pym-src');

            // List of data attributes to configure the component
            // structure: {'attribute name': 'type'}
            var settings = {'xdomain': 'string', 'title': 'string', 'name': 'string', 'id': 'string',
                            'sandbox': 'string', 'allowfullscreen': 'boolean',
                            'parenturlparam': 'string', 'parenturlvalue': 'string',
                            'optionalparams': 'boolean', 'trackscroll': 'boolean',
                            'scrollwait': 'number'};

            var config = {};

            for (var attribute in settings) {
                // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute#Notes
               if (element.getAttribute('data-pym-'+attribute) !== null) {
                  switch (settings[attribute]) {
                    case 'boolean':
                       config[attribute] = !(element.getAttribute('data-pym-'+attribute) === 'false'); // jshint ignore:line
                       break;
                    case 'string':
                       config[attribute] = element.getAttribute('data-pym-'+attribute);
                       break;
                    case 'number':
                        var n = Number(element.getAttribute('data-pym-'+attribute));
                        if (!isNaN(n)) {
                            config[attribute] = n;
                        }
                        break;
                    default:
                       console.err('unrecognized attribute type');
                  }
               }
            }

            // Store references to autoinitialized pym instances
            var parent = new lib.Parent(element.id, src, config);
            lib.autoInitInstances.push(parent);
        }

        // Fire customEvent
        if (!doNotRaiseEvents) {
            _raiseCustomEvent("pym-initialized");
        }
        // Return stored autoinitalized pym instances
        return lib.autoInitInstances;
    };

    /**
     * The Parent half of a response iframe.
     *
     * @memberof module:pym
     * @class Parent
     * @param {String} id The id of the div into which the iframe will be rendered. sets {@link module:pym.Parent~id}
     * @param {String} url The url of the iframe source. sets {@link module:pym.Parent~url}
     * @param {Object} [config] Configuration for the parent instance. sets {@link module:pym.Parent~settings}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {string} [config.title] - if passed it will be assigned to the iframe title attribute
     * @param {string} [config.name] - if passed it will be assigned to the iframe name attribute
     * @param {string} [config.id] - if passed it will be assigned to the iframe id attribute
     * @param {boolean} [config.allowfullscreen] - if passed and different than false it will be assigned to the iframe allowfullscreen attribute
     * @param {string} [config.sandbox] - if passed it will be assigned to the iframe sandbox attribute (we do not validate the syntax so be careful!!)
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name passed to the iframe src
     * @param {string} [config.parenturlvalue] - if passed it will be override the default parentUrl query string parameter value passed to the iframe src
     * @param {string} [config.optionalparams] - if passed and different than false it will strip the querystring params parentUrl and parentTitle passed to the iframe src
     * @param {boolean} [config.trackscroll] - if passed it will activate scroll tracking on the parent
     * @param {number} [config.scrollwait] - if passed it will set the throttle wait in order to fire scroll messaging. Defaults to 100 ms.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe iFrame}
     */
    lib.Parent = function(id, url, config) {
        /**
         * The id of the container element
         *
         * @memberof module:pym.Parent
         * @member {string} id
         * @inner
         */
        this.id = id;
        /**
         * The url that will be set as the iframe's src
         *
         * @memberof module:pym.Parent
         * @member {String} url
         * @inner
         */
        this.url = url;

        /**
         * The container DOM object
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} el
         * @inner
         */
        this.el = document.getElementById(id);
        /**
         * The contained child iframe
         *
         * @memberof module:pym.Parent
         * @member {HTMLElement} iframe
         * @inner
         * @default null
         */
        this.iframe = null;
        /**
         * The parent instance settings, updated by the values passed in the config object
         *
         * @memberof module:pym.Parent
         * @member {Object} settings
         * @inner
         */
        this.settings = {
            xdomain: '*',
            optionalparams: true,
            parenturlparam: 'parentUrl',
            parenturlvalue: window.location.href,
            trackscroll: false,
            scrollwait: 100,
        };
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Parent
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = _makeMessageRegex(this.id);
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Parent
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // ensure a config object
        config = (config || {});

        /**
         * Construct the iframe.
         *
         * @memberof module:pym.Parent
         * @method _constructIframe
         * @inner
         */
        this._constructIframe = function() {
            // Calculate the width of this element.
            var width = this.el.offsetWidth.toString();

            // Create an iframe element attached to the document.
            this.iframe = document.createElement('iframe');

            // Save fragment id
            var hash = '';
            var hashIndex = this.url.indexOf('#');

            if (hashIndex > -1) {
                hash = this.url.substring(hashIndex, this.url.length);
                this.url = this.url.substring(0, hashIndex);
            }

            // If the URL contains querystring bits, use them.
            // Otherwise, just create a set of valid params.
            if (this.url.indexOf('?') < 0) {
                this.url += '?';
            } else {
                this.url += '&';
            }

            // Append the initial width as a querystring parameter
            // and optional params if configured to do so
            this.iframe.src = this.url + 'initialWidth=' + width +
                                         '&childId=' + this.id;

            if (this.settings.optionalparams) {
                this.iframe.src += '&parentTitle=' + encodeURIComponent(document.title);
                this.iframe.src += '&'+ this.settings.parenturlparam + '=' + encodeURIComponent(this.settings.parenturlvalue);
            }
            this.iframe.src +=hash;

            // Set some attributes to this proto-iframe.
            this.iframe.setAttribute('width', '100%');
            this.iframe.setAttribute('scrolling', 'no');
            this.iframe.setAttribute('marginheight', '0');
            this.iframe.setAttribute('frameborder', '0');

            if (this.settings.title) {
                this.iframe.setAttribute('title', this.settings.title);
            }

            if (this.settings.allowfullscreen !== undefined && this.settings.allowfullscreen !== false) {
                this.iframe.setAttribute('allowfullscreen','');
            }

            if (this.settings.sandbox !== undefined && typeof this.settings.sandbox === 'string') {
                this.iframe.setAttribute('sandbox', this.settings.sandbox);
            }

            if (this.settings.id) {
                if (!document.getElementById(this.settings.id)) {
                    this.iframe.setAttribute('id', this.settings.id);
                }
            }

            if (this.settings.name) {
                this.iframe.setAttribute('name', this.settings.name);
            }

            // Replace the child content if needed
            // (some CMSs might strip out empty elements)
            while(this.el.firstChild) { this.el.removeChild(this.el.firstChild); }
            // Append the iframe to our element.
            this.el.appendChild(this.iframe);

            // Add an event listener that will handle redrawing the child on resize.
            window.addEventListener('resize', this._onResize);

            // Add an event listener that will send the child the viewport.
            if (this.settings.trackscroll) {
                window.addEventListener('scroll', this._throttleOnScroll);
            }
        };

        /**
         * Send width on resize.
         *
         * @memberof module:pym.Parent
         * @method _onResize
         * @inner
         */
        this._onResize = function() {
            this.sendWidth();
            if (this.settings.trackscroll) {
                this.sendViewportAndIFramePosition();
            }
        }.bind(this);

        /**
         * Send viewport and iframe info on scroll.
         *
         * @memberof module:pym.Parent
         * @method _onScroll
         * @inner
         */
        this._onScroll = function() {
            this.sendViewportAndIFramePosition();
        }.bind(this);

        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Parent
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Remove this parent from the page and unbind it's event handlers.
         *
         * @memberof module:pym.Parent
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            window.removeEventListener('resize', this._onResize);

            this.el.removeChild(this.iframe);
            // _cleanAutoInitInstances in case this parent was autoInitialized
            _cleanAutoInitInstances();
        };

        /**
         * Process a new message from the child.
         *
         * @memberof module:pym.Parent
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Grab the message from the child and parse it.
            var match = e.data.match(this.messageRegex);

            // If there's no match or too many matches in the message, punt.
            if (!match || match.length !== 3) {
                return false;
            }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new height message from child.
         *
         * @memberof module:pym.Parent
         * @method _onHeightMessage
         * @inner
         *
         * @param {String} message The new height.
         */
        this._onHeightMessage = function(message) {
            /*
             * Handle parent height message from child.
             */
            var height = parseInt(message);

            this.iframe.setAttribute('height', height + 'px');
        };

        /**
         * Navigate parent to a new url.
         *
         * @memberof module:pym.Parent
         * @method _onNavigateToMessage
         * @inner
         *
         * @param {String} message The url to navigate to.
         */
        this._onNavigateToMessage = function(message) {
            /*
             * Handle parent scroll message from child.
             */
             if (!_isSafeUrl(message)) {return;}
            document.location.href = message;
        };

        /**
         * Scroll parent to a given child position.
         *
         * @memberof module:pym.Parent
         * @method _onScrollToChildPosMessage
         * @inner
         *
         * @param {String} message The offset inside the child page.
         */
        this._onScrollToChildPosMessage = function(message) {
            // Get the child container position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var iframePos = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset;

            var totalOffset = iframePos + parseInt(message);
            window.scrollTo(0, totalOffset);
        };

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "height", "scrollTo" and "navigateTo".
         *
         * @memberof module:pym.Parent
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Parent~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {
            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Parent~onMessageCallback
         * @param {String} message The message data.
         */

        /**
         * Send a message to the the child.
         *
         * @memberof module:pym.Parent
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            // When used alongside with pjax some references are lost
            if (this.el.getElementsByTagName('iframe').length) {
                if (this.el.getElementsByTagName('iframe')[0].contentWindow) {
                    this.el.getElementsByTagName('iframe')[0].contentWindow
                        .postMessage(_makeMessage(this.id, messageType, message), '*');
                }
                else {
                    // Contentless child detected remove listeners and iframe
                    this.remove();
                }
            }
        };

        /**
         * Transmit the current iframe width to the child.
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendWidth
         * @instance
         */
        this.sendWidth = function() {
            var width = this.el.offsetWidth.toString();
            this.sendMessage('width', width);
        };

        /**
         * Transmit the current viewport and iframe position to the child.
         * Sends viewport width, viewport height
         * and iframe bounding rect top-left-bottom-right
         * all separated by spaces
         *
         * You shouldn't need to call this directly.
         *
         * @memberof module:pym.Parent
         * @method sendViewportAndIFramePosition
         * @instance
         */
        this.sendViewportAndIFramePosition = function() {
            var iframeRect = this.iframe.getBoundingClientRect();
            var vWidth   = window.innerWidth || document.documentElement.clientWidth;
            var vHeight  = window.innerHeight || document.documentElement.clientHeight;
            var payload = vWidth + ' ' + vHeight;
            payload += ' ' + iframeRect.top + ' ' + iframeRect.left;
            payload += ' ' + iframeRect.bottom + ' ' + iframeRect.right;
            this.sendMessage('viewport-iframe-position', payload);
        };

        // Add any overrides to settings coming from config.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        /**
         * Throttled scroll function.
         *
         * @memberof module:pym.Parent
         * @method _throttleOnScroll
         * @inner
         */
        this._throttleOnScroll = _throttle(this._onScroll.bind(this), this.settings.scrollwait);

        // Bind required message handlers
        this.onMessage('height', this._onHeightMessage);
        this.onMessage('navigateTo', this._onNavigateToMessage);
        this.onMessage('scrollToChildPos', this._onScrollToChildPosMessage);
        this.onMessage('parentPositionInfo', this.sendViewportAndIFramePosition);

        // Add a listener for processing messages from the child.
        window.addEventListener('message', this._processMessage, false);

        // Construct the iframe in the container element.
        this._constructIframe();

        return this;
    };

    /**
     * The Child half of a responsive iframe.
     *
     * @memberof module:pym
     * @class Child
     * @param {Object} [config] Configuration for the child instance. sets {@link module:pym.Child~settings}
     * @param {function} [config.renderCallback=null] Callback invoked after receiving a resize event from the parent, sets {@link module:pym.Child#settings.renderCallback}
     * @param {string} [config.xdomain='*'] - xdomain to validate messages received
     * @param {number} [config.polling=0] - polling frequency in milliseconds to send height to parent
     * @param {number} [config.id] - parent container id used when navigating the child iframe to a new page but we want to keep it responsive.
     * @param {string} [config.parenturlparam] - if passed it will be override the default parentUrl query string parameter name expected on the iframe src
     */
    lib.Child = function(config) {
        /**
         * The initial width of the parent page
         *
         * @memberof module:pym.Child
         * @member {string} parentWidth
         * @inner
         */
        this.parentWidth = null;
        /**
         * The id of the parent container
         *
         * @memberof module:pym.Child
         * @member {String} id
         * @inner
         */
        this.id = null;
        /**
         * The title of the parent page from document.title.
         *
         * @memberof module:pym.Child
         * @member {String} parentTitle
         * @inner
         */
        this.parentTitle = null;
        /**
         * The URL of the parent page from window.location.href.
         *
         * @memberof module:pym.Child
         * @member {String} parentUrl
         * @inner
         */
        this.parentUrl = null;
        /**
         * The settings for the child instance. Can be overriden by passing a config object to the child constructor
         * i.e.: var pymChild = new pym.Child({renderCallback: render, xdomain: "\\*\.npr\.org"})
         *
         * @memberof module:pym.Child.settings
         * @member {Object} settings - default settings for the child instance
         * @inner
         */
        this.settings = {
            renderCallback: null,
            xdomain: '*',
            polling: 0,
            parenturlparam: 'parentUrl'
        };

        /**
         * The timerId in order to be able to stop when polling is enabled
         *
         * @memberof module:pym.Child
         * @member {String} timerId
         * @inner
         */
        this.timerId = null;
        /**
         * RegularExpression to validate the received messages
         *
         * @memberof module:pym.Child
         * @member {String} messageRegex
         * @inner
         */
        this.messageRegex = null;
        /**
         * Stores the registered messageHandlers for each messageType
         *
         * @memberof module:pym.Child
         * @member {Object} messageHandlers
         * @inner
         */
        this.messageHandlers = {};

        // Ensure a config object
        config = (config || {});

        /**
         * Bind a callback to a given messageType from the child.
         *
         * Reserved message names are: "width".
         *
         * @memberof module:pym.Child
         * @method onMessage
         * @instance
         *
         * @param {String} messageType The type of message being listened for.
         * @param {module:pym.Child~onMessageCallback} callback The callback to invoke when a message of the given type is received.
         */
        this.onMessage = function(messageType, callback) {

            if (!(messageType in this.messageHandlers)) {
                this.messageHandlers[messageType] = [];
            }

            this.messageHandlers[messageType].push(callback);
        };

        /**
         * @callback module:pym.Child~onMessageCallback
         * @param {String} message The message data.
         */


        /**
         * Fire all event handlers for a given message type.
         *
         * @memberof module:pym.Child
         * @method _fire
         * @inner
         *
         * @param {String} messageType The type of message.
         * @param {String} message The message data.
         */
        this._fire = function(messageType, message) {
            /*
             * Fire all event handlers for a given message type.
             */
            if (messageType in this.messageHandlers) {
                for (var i = 0; i < this.messageHandlers[messageType].length; i++) {
                   this.messageHandlers[messageType][i].call(this, message);
                }
            }
        };

        /**
         * Process a new message from the parent.
         *
         * @memberof module:pym.Child
         * @method _processMessage
         * @inner
         *
         * @param {Event} e A message event.
         */
        this._processMessage = function(e) {
            /*
            * Process a new message from parent frame.
            */
            // First, punt if this isn't from an acceptable xdomain.
            if (!_isSafeMessage(e, this.settings)) {
                return;
            }

            // Discard object messages, we only care about strings
            if (typeof e.data !== 'string') {
                return;
            }

            // Get the message from the parent.
            var match = e.data.match(this.messageRegex);

            // If there's no match or it's a bad format, punt.
            if (!match || match.length !== 3) { return; }

            var messageType = match[1];
            var message = match[2];

            this._fire(messageType, message);
        }.bind(this);

        /**
         * Resize iframe in response to new width message from parent.
         *
         * @memberof module:pym.Child
         * @method _onWidthMessage
         * @inner
         *
         * @param {String} message The new width.
         */
        this._onWidthMessage = function(message) {
            /*
             * Handle width message from the child.
             */
            var width = parseInt(message);

            // Change the width if it's different.
            if (width !== this.parentWidth) {
                this.parentWidth = width;

                // Call the callback function if it exists.
                if (this.settings.renderCallback) {
                    this.settings.renderCallback(width);
                }

                // Send the height back to the parent.
                this.sendHeight();
            }
        };

        /**
         * Send a message to the the Parent.
         *
         * @memberof module:pym.Child
         * @method sendMessage
         * @instance
         *
         * @param {String} messageType The type of message to send.
         * @param {String} message The message data to send.
         */
        this.sendMessage = function(messageType, message) {
            /*
             * Send a message to the parent.
             */
            window.parent.postMessage(_makeMessage(this.id, messageType, message), '*');
        };

        /**
         * Transmit the current iframe height to the parent.
         *
         * Call this directly in cases where you manually alter the height of the iframe contents.
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.sendHeight = function() {
            // Get the child's height.
            var height = document.getElementsByTagName('body')[0].offsetHeight.toString();

            // Send the height to the parent.
            this.sendMessage('height', height);

            return height;
        }.bind(this);

        /**
         * Ask parent to send the current viewport and iframe position information
         *
         * @memberof module:pym.Child
         * @method sendHeight
         * @instance
         */
        this.getParentPositionInfo = function() {
            // Send the height to the parent.
            this.sendMessage('parentPositionInfo');
        };

        /**
         * Scroll parent to a given element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentTo
         * @instance
         *
         * @param {String} hash The id of the element to scroll to.
         */
        this.scrollParentTo = function(hash) {
            this.sendMessage('navigateTo', '#' + hash);
        };

        /**
         * Navigate parent to a given url.
         *
         * @memberof module:pym.Child
         * @method navigateParentTo
         * @instance
         *
         * @param {String} url The url to navigate to.
         */
        this.navigateParentTo = function(url) {
            this.sendMessage('navigateTo', url);
        };

        /**
         * Scroll parent to a given child element id.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildEl
         * @instance
         *
         * @param {String} id The id of the child element to scroll to.
         */
        this.scrollParentToChildEl = function(id) {
            // Get the child element position using getBoundingClientRect + pageYOffset
            // via https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
            var topPos = document.getElementById(id).getBoundingClientRect().top + window.pageYOffset;
            this.scrollParentToChildPos(topPos);
        };

        /**
         * Scroll parent to a particular child offset.
         *
         * @memberof module:pym.Child
         * @method scrollParentToChildPos
         * @instance
         *
         * @param {Number} pos The offset of the child element to scroll to.
         */
        this.scrollParentToChildPos = function(pos) {
            this.sendMessage('scrollToChildPos', pos.toString());
        };

        /**
         * Mark Whether the child is embedded or not
         * executes a callback in case it was passed to the config
         *
         * @memberof module:pym.Child
         * @method _markWhetherEmbedded
         * @inner
         *
         * @param {module:pym.Child~onMarkedEmbeddedStatus} The callback to execute after determining whether embedded or not.
         */
        var _markWhetherEmbedded = function(onMarkedEmbeddedStatus) {
          var htmlElement = document.getElementsByTagName('html')[0],
              newClassForHtml,
              originalHtmlClasses = htmlElement.className;
          try {
            if(window.self !== window.top) {
              newClassForHtml = "embedded";
            }else{
              newClassForHtml = "not-embedded";
            }
          }catch(e) {
            newClassForHtml = "embedded";
          }
          if(originalHtmlClasses.indexOf(newClassForHtml) < 0) {
            htmlElement.className = originalHtmlClasses ? originalHtmlClasses + ' ' + newClassForHtml : newClassForHtml;
            if(onMarkedEmbeddedStatus){
              onMarkedEmbeddedStatus(newClassForHtml);
            }
            _raiseCustomEvent("marked-embedded");
          }
        };

        /**
         * @callback module:pym.Child~onMarkedEmbeddedStatus
         * @param {String} classname "embedded" or "not-embedded".
         */

        /**
         * Unbind child event handlers and timers.
         *
         * @memberof module:pym.Child
         * @method remove
         * @instance
         */
        this.remove = function() {
            window.removeEventListener('message', this._processMessage);
            if (this.timerId) {
                clearInterval(this.timerId);
            }
        };

        // Initialize settings with overrides.
        for (var key in config) {
            this.settings[key] = config[key];
        }

        // Identify what ID the parent knows this child as.
        this.id = _getParameterByName('childId') || config.id;
        this.messageRegex = new RegExp('^pym' + MESSAGE_DELIMITER + this.id + MESSAGE_DELIMITER + '(\\S+)' + MESSAGE_DELIMITER + '(.*)$');

        // Get the initial width from a URL parameter.
        var width = parseInt(_getParameterByName('initialWidth'));

        // Get the url of the parent frame
        this.parentUrl = _getParameterByName(this.settings.parenturlparam);

        // Get the title of the parent frame
        this.parentTitle = _getParameterByName('parentTitle');

        // Bind the required message handlers
        this.onMessage('width', this._onWidthMessage);

        // Set up a listener to handle any incoming messages.
        window.addEventListener('message', this._processMessage, false);

        // If there's a callback function, call it.
        if (this.settings.renderCallback) {
            this.settings.renderCallback(width);
        }

        // Send the initial height to the parent.
        this.sendHeight();

        // If we're configured to poll, create a setInterval to handle that.
        if (this.settings.polling) {
            this.timerId = window.setInterval(this.sendHeight, this.settings.polling);
        }

        _markWhetherEmbedded(config.onMarkedEmbeddedStatus);

        return this;
    };

    // Initialize elements with pym data attributes
    // if we are not in server configuration
    if(typeof document !== "undefined") {
        lib.autoInit(true);
    }

    return lib;
});


},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/storage-factory/lib/index.js":[function(_dereq_,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storageFactory = void 0;
function storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) {
            getStorage().clear();
        }
        else {
            inMemoryStorage = {};
        }
    }
    function getItem(name) {
        if (isSupported()) {
            return getStorage().getItem(name);
        }
        if (inMemoryStorage.hasOwnProperty(name)) {
            return inMemoryStorage[name];
        }
        return null;
    }
    function key(index) {
        if (isSupported()) {
            return getStorage().key(index);
        }
        else {
            return Object.keys(inMemoryStorage)[index] || null;
        }
    }
    function removeItem(name) {
        if (isSupported()) {
            getStorage().removeItem(name);
        }
        else {
            delete inMemoryStorage[name];
        }
    }
    function setItem(name, value) {
        if (isSupported()) {
            getStorage().setItem(name, value);
        }
        else {
            inMemoryStorage[name] = String(value);
        }
    }
    function length() {
        if (isSupported()) {
            return getStorage().length;
        }
        else {
            return Object.keys(inMemoryStorage).length;
        }
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length() {
            return length();
        },
    };
}
exports.storageFactory = storageFactory;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/string.prototype.endswith/endswith.js":[function(_dereq_,module,exports){
/*! http://mths.be/endswith v0.2.0 by @mathias */
if (!String.prototype.endsWith) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var toString = {}.toString;
		var endsWith = function(search) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			if (search && toString.call(search) == '[object RegExp]') {
				throw TypeError();
			}
			var stringLength = string.length;
			var searchString = String(search);
			var searchLength = searchString.length;
			var pos = stringLength;
			if (arguments.length > 1) {
				var position = arguments[1];
				if (position !== undefined) {
					// `ToInteger`
					pos = position ? Number(position) : 0;
					if (pos != pos) { // better `isNaN`
						pos = 0;
					}
				}
			}
			var end = Math.min(Math.max(pos, 0), stringLength);
			var start = end - searchLength;
			if (start < 0) {
				return false;
			}
			var index = -1;
			while (++index < searchLength) {
				if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
					return false;
				}
			}
			return true;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'endsWith', {
				'value': endsWith,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.endsWith = endsWith;
		}
	}());
}

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/webstorage-polyfill/index.js":[function(_dereq_,module,exports){
(function() {
  'use strict';
  try {
    // Test webstorage existence.
    if (!window.localStorage || !window.sessionStorage) throw "exception";
    // Test webstorage accessibility - Needed for Safari private browsing.
    window.localStorage.setItem('storage_test', 1);
    window.localStorage.removeItem('storage_test');
  } catch (e) {
    (function() {
      function createCookie(name, value, days) {
        var expires;
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toGMTString();
        } else {
          expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
      }

      function readCookie(name) {
        var results = document.cookie.match('(^|;) ?'+encodeURIComponent(name)+'=([^;]*)(;|$)');
        return results ? decodeURIComponent(results[2]) : null;
      }

      function Storage(type) {
        function setData(data) {
          data = JSON.stringify(data);
          if (type === 'session') {
            createCookie(getSessionName(), data);
          } else {
            createCookie('localStorage', data, 365);
          }
        }

        function clearData() {
          if (type === 'session') {
            createCookie(getSessionName(), '');
          } else {
            createCookie('localStorage', '', 365);
          }
        }

        function getData() {
          var data = readCookie(type === 'session' ? getSessionName() : 'localStorage');
          return data ? JSON.parse(data) : {};
        }

        function getSessionName() {
          if (!window.name) {
            window.name = Math.random()+'-'+(new Date().getTime());
          }
          return 'sessionStorage-' + window.name;
        }

        // Initialize if there's already data.
        var data = getData();

        var obj = {
          POLYFILLED: true,
          length: 0,
          clear: function() {
            data = {};
            this.length = 0;
            clearData();
          },
          getItem: function(key) {
            return Object.prototype.hasOwnProperty.call(data, key) ? data[key] : null;
          },
          key: function(i) {
            var ctr = 0;
            for (var k in data) {
              if (ctr++ == i)
                return k;
            }
            return null;
          },
          removeItem: function(key) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              delete data[key];
              this.length--;
              setData(data);
            }
          },
          setItem: function(key, value) {
            if (!Object.prototype.hasOwnProperty.call(data, key)) {
              this.length++;
            }
            data[key] = ''+value;
            setData(data);
          }
        };
        return obj;
      }

      var localStorage = new Storage('local');
      var sessionStorage = new Storage('session');
      try {
        window.localStorage = localStorage;
        window.sessionStorage = sessionStorage;
      } catch(e) {}
      try {
        // For Safari private browsing need to also set the proto value.
        window.localStorage.__proto__ = localStorage;
        window.sessionStorage.__proto__ = sessionStorage;
      } catch(e) {}
    })();
  }
})();

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/analytics-events.js":[function(_dereq_,module,exports){
const Util = _dereq_('./utilities.js');
const storage = _dereq_('./storage.js');
const client = Util.memoize(() => {
  return _dereq_('./sdk/sentry-client.js');
});
const Config = _dereq_('./config.js');

const facebookPixelId = '2434689970104116';
const googleAnalyticsId = 'UA-124656779-3';
const googleAdsId = 'AW-711284525';

const initializeEventListener = function () {
  const batchEventsToPear = true;
  let events = [];

  const getEventsBody = () => {
    return btoa(JSON.stringify(events));
  };

  if (batchEventsToPear) {
    window.addEventListener('beforeunload', (event) => {
      // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon
      if (!navigator.sendBeacon || events.length == 0) return;

      const url = Config.API_URL + '/v1/e';
      const data = getEventsBody();

      // Send the beacon
      navigator.sendBeacon(url, data);
    });

    setInterval(() => {
      if (events.length > 0) {
        Util.postJson(Config.API_URL + '/v1/e', getEventsBody());
        events = [];
      }
    }, 5000);
  }
  try {
    window.addEventListener('message', function (event) {
      if ('pear-event' == event.data.action) {
        const name = event.data.name;
        const params = event.data.params ? event.data.params : {};
        if (params.pearSession) {
          Util.addPearSession(params.pearSession);
        } else {
          params.pearSession = Util.getPearSession();
        }
        if (!params.href) {
          params.href = window.location.href;
        }
        if (Config.env != 'production') {
          console.log('Recording event: ' + name + ': ' + (params ? JSON.stringify(params) : null));
        }
        if (window.fbq) {
          if (params.fbDefault) {
            window.fbq('trackSingle', facebookPixelId, name, params);
          } else {
            window.fbq('trackSingleCustom', facebookPixelId, name, params);
          }
        }
        if (window.gtag && !params.fbOnly) {
          window.gtag('event', name, Object.assign({
            send_to: [googleAnalyticsId, googleAdsId],
          }, params));
        }
        if (window.pearFS && !params.fbOnly) {
          window.pearFS.event(name, params);
        }
        if (!params.fbOnly) {
          const e = {
            name: name,
            value: params,
            epoch: Date.now(),
          };
          if (!batchEventsToPear) {
            Util.postJson(Config.API_URL + '/v1/event', e);
          } else {
            events.push(e);
          }
        }
      }
    }, false);
  } catch (e) {
    client().captureException(e);
  }
};

const sendEvent = module.exports.sendEvent = function (name, params) {
  try {
    if (!params) {
      params = {};
    }
    if (Util.inIframe()) {
      if (!params.iframeHref) {
        params.iframeHref = window.location.href;
      }
    } else {
      if (!params.href) {
        params.href = window.location.href;
      }
    }

    if (!params.pearSession && Util.getPearSession()) {
      params.pearSession = Util.getPearSession();
    }

    const target = Util.inIframe() ? window.parent : window;
    target.postMessage({
      action: 'pear-event',
      name: name,
      params: params,
    }, '*');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.identifyConsumer = function (id, name, email) {
  try {
    const extraData = {};
    if (name) {
      extraData.displayName = name;
    }
    if (email) {
      extraData.email = email;
    }

    if (window.pearFS) {
      window.pearFS.identify(id + '', extraData);
    }
    if (window.fbq) {
      window.fbq('init', facebookPixelId, {
        uid: id + '',
      });
      window.fbq('setUserProperties', facebookPixelId, extraData);
    }
    if (window.gtag) {
      window.gtag('config', googleAnalyticsId, {
        'user_id': id + '',
      });
    }
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPearOfferUnavailable = function () {
  try {
    sendEvent('PearOfferUnavailable', {});
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPearLoginEvent = function (userId, name, email, offerId) {
  try {
    const params = {};
    if (userId) {
      params.userId = userId;
    }
    if (name) {
      params.name = name;
    }
    if (email) {
      params.email = email;
    }
    if (offerId) {
      params.offerId = offerId;
    }
    sendEvent('PearLogin', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPearRegisterEvent = function (userId, name, email, offerId) {
  try {
    const params = {};
    if (userId) {
      params.userId = userId;
    }
    if (name) {
      params.name = name;
    }
    if (email) {
      params.email = email;
    }
    if (offerId) {
      params.offerId = offerId;
    }
    sendEvent('PearRegister', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPearAddToCartEvent = function (userId, name, email, offerId) {
  try {
    const params = {};
    if (userId) {
      params.userId = userId;
    }
    if (name) {
      params.name = name;
    }
    if (email) {
      params.email = email;
    }
    if (offerId) {
      params.offerId = offerId;
    }
    sendEvent('PearAddToCart', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendRegisterEvent = function (userId, name, email, offerId) {
  try {
    const params = { fbDefault: true };
    if (userId) {
      params.userId = userId;
    }
    if (name) {
      params.name = name;
    }
    if (email) {
      params.email = email;
    }
    if (offerId) {
      params.offerId = offerId;
    }
    sendEvent('CompleteRegistration', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendLoginEvent = function (userId, name, email, offerId) {
  try {
    const params = {};
    if (userId) {
      params.userId = userId;
    }
    if (name) {
      params.name = name;
    }
    if (email) {
      params.email = email;
    }
    if (offerId) {
      params.offerId = offerId;
    }
    sendEvent('Login', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendDirectPurchaseEvent = function (amount, offerId) {
  try {
    const params = {};
    if (offerId) {
      params.offerId = offerId;
    }
    if (amount) {
      params.currency = 'USD';
      params.value = amount;
    }
    sendEvent('PearDirectPurchase', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendBrandPurchaseEvent = function (brand, amount) {
  try {
    if (brand == 'PostConsumerBrands') {
      brand = '';
    }
    const params = {};
    if (amount) {
      params.currency = 'USD';
      params.value = amount;
    }
    sendEvent(brand + 'PearPurchase', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendLeadEvent = function (email, phone) {
  try {
    const params = {};
    if (email) {
      params.email = email;
    }
    if (phone) {
      params.phone = phone;
    }
    sendEvent('PearLead', params);
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendModalOpenEvent = function () {
  try {
    sendEvent('PearModalOpen');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPageviewEvent = function () {
  try {
    sendEvent('PearPageView');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendModalCancelledEvent = function () {
  try {
    sendEvent('PearModalCancelled');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendCheckoutEvent = function () {
  try {
    sendEvent('PearCheckout');
  } catch (e) {
    client().captureException(e);
  }
};


module.exports.sendPushDisplayed = function (message) {
  try {
    sendEvent('PearPushDisplayed', { message: message });
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPushClicked = function (message) {
  try {
    sendEvent('PearPushClicked', { message: message });
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendStepClicked = function (message) {
  try {
    sendEvent('PearStepClicked', { message: message });
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendHelpClosedEvent = function () {
  try {
    sendEvent('PearHelpClosed');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPushClosedEvent = function () {
  try {
    sendEvent('PearPushClosed');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendPushOpenedEvent = function () {
  try {
    sendEvent('PearPushOpened');
  } catch (e) {
    client().captureException(e);
  }
};

module.exports.sendHelpOpenedEvent = function () {
  try {
    sendEvent('PearHelpOpened');
  } catch (e) {
    client().captureException(e);
  }
};

// eslint-disable-next-line no-unused-vars
module.exports.sendPearSessionStartEvent = function () {
  try {
    if (storage.session.getItem('pearSessionStartEventSent') != 'true') {
      sendEvent('PearSessionStart');
      storage.session.setItem('pearSessionStartEventSent', 'true');
    }
  } catch (e) {
    client().captureException(e);
  }
};

const installFS = function () {/* eslint-disable */
  window['_fs_debug'] = false;
  window['_fs_is_outer_script'] = true;
  window['_fs_host'] = 'fullstory.com';
  window['_fs_org'] = 'J4CH7';
  window['_fs_namespace'] = 'pearFS';
  (function (m, n, e, t, l, o, g, y) {
    if (e in m) {
      if (m.console && m.console.log) {
        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      }
      return;
    }
    g = m[e] = function (a, b, s) {
      g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
    };
    g.q = [];
    o = n.createElement(t);
    o.async = 1;
    o.src = 'https://' + _fs_host + '/s/fs.js';
    y = n.getElementsByTagName(t)[0];
    y.parentNode.insertBefore(o, y);
    g.identify = function (i, v, s) {
      g(l, {
        uid: i
      }, s);
      if (v)
        g(l, v, s);
    };
    g.setUserVars = function (v, s) {
      g(l, v, s);
    };
    g.event = function (i, v, s) {
      g('event', {
        n: i,
        p: v
      }, s);
    };
    g.shutdown = function () {
      g('rec', !1);
    };
    g.restart = function () {
      g('rec', !0);
    };
    g.consent = function (a) {
      g('consent', !arguments.length || a);
    };
    g.identifyAccount = function (i, v) {
      o = 'account';
      v = v || {};
      v.acctId = i;
      g(o, v);
    };
    g.clearUserCookie = function () {
    };
  })(window, document, window['_fs_namespace'], 'script', 'user');
};

const installGtag = function () {
  var element = document.querySelector("script[src^='https://www.googletagmanager.com/gtag/js']");
  if (!element) {
    var newScript = document.createElement("script");
    newScript.type = "text/javascript";
    newScript.setAttribute("async", "true");
    newScript.setAttribute("src", "https://www.googletagmanager.com/gtag/js?id=UA-124656779-3");
    document.documentElement.firstChild.appendChild(newScript);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
  }
}
const installGA = function () {
  window.gtag('config', googleAnalyticsId);
}

const installAds = function () {
  window.gtag('config', googleAdsId);
}

const installFacbookPixel = module.exports.installFacbookPixel = function () {
  !function (f, b, e, v, n, t, s) {/* eslint-disable */
    if (f.fbq)
      return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq)
      f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', facebookPixelId);
  window.fbq('trackSingle', facebookPixelId, 'PageView');
}

module.exports.initialize = function (shouldInstallFS) {
  try {
    if (shouldInstallFS && Config.INSTALL_FS) {
      installFS();
    }

    installGtag();
    installGA();
    installAds();
    installFacbookPixel();
    initializeEventListener();
  } catch (e) {
    client().captureException(e);
  }
}
},{"./config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","./sdk/sentry-client.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/sdk/sentry-client.js","./storage.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js","./utilities.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/base64.js":[function(_dereq_,module,exports){
// eslint-disable-next-line  no-unused-vars
const base64Decode = (module.exports.base64Decode = function (base64String) {
  try {
        // Decode the Base64 string into a Buffer
    const decodedBuffer = Buffer.from(base64String, 'base64');

    // If you need the decoded data as a string, you can convert the Buffer
    const decodedString = decodedBuffer.toString('utf8');

    const thing = JSON.parse(decodedString);

    return thing;
  } catch (e) {
    return null;
  }
});

const base64Encode = (module.exports.base64Encode = function (thing) {
  try {
    const parsedStr = JSON.stringify(thing);
    const base64String = Buffer.from(parsedStr, 'utf8').toString('base64');
    return base64String;
  } catch (e) {
    return null;
  }
});


},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js":[function(_dereq_,module,exports){
// Made this its own module to reduce the amount of unresolve variable warnings.  This gets injected by gulp.
module.exports = {"API_URL":"https://api.pearcommerce.com","OFFERS_URL":"https://offers.pearcommerce.com","bucket":"offers-pearcommerce-com","cloudfronts":["EIHBZL08C67V4"],"STADIA_MAPS_API_KEY":"e5bf83f8-ad04-4fd6-84ac-5b56fe445e2b","MAPBOX_API_KEY":"pk.eyJ1IjoicGVhcmNvbW1lcmNlIiwiYSI6ImNtODRyMTg2MzIycTIybHExanBlNDY0aWkifQ.G6pP_wO2FVepkdb_62JcHw","productionResources":true,"production":true,"WIDGET_PREFIX":"","env":"production","apiTarget":"production","revisionShort":"745f3ae","revision":"745f3aea78"};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/debounce.js":[function(_dereq_,module,exports){

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after N milliseconds. If `immediate`
// is passed, trigger the function on the leading edge, instead of the trailing.
// eslint-disable-next-line  no-unused-vars
const debounce = (module.exports = (func, wait, immediate) => {
    let timeout;

    return function executedFunction(...args) {
        const context = this;

        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        if (!timeout) {
            timeout = setTimeout(later, wait);
        }

        if (callNow) func.apply(context, args);
    };
});
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/bang_category_map.js":[function(_dereq_,module,exports){
const BANG_CATEGORY_IMAGE_MAPPING = {
    "ANY MEANS ORANGE": "https://image-processor.pearcommerce.com/OfferImage/2705964430614369.png",
    "BLACK CHERRY VANILLA": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366701.png",
    "BLUE RAZZ": "https://demos-cf-1.pearcommerce.com/OfferImage/2481757526556054.png",
    "CANDY APPLE CRISP": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366738.png",
    "COTTON CANDY": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366714.png",
    "DELISH STRAWBERRY KISS": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366726.png",
    "PEACH MANGO": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366692.png",
    "PURPLE HAZE": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366709.png",
    "RADICAL SKADATTLE": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366734.png",
    "RAINBOW UNICORN": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366730.png",
    "SOUR HEADS": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366722.png",
    "SOUR ROPES": "https://demos-cf-1.pearcommerce.com/OfferImage/2658323675990806.png",
    "STAR BLAST": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366705.png",
    "WYLDIN WATERMELON": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187366718.png",
};

const UPC_TO_CATEGORY_MAP = {};

const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return BANG_CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: {},
    defaultCategory: 'Any Means Orange',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/blue_buffalo_category_map.js":[function(_dereq_,module,exports){
const CATEGORY_IMAGE_MAPPING = {
    "Dry Dog Food": "https://assets.pearcommerce.com/2642807847861803.png",
    "Wet Dog Food": "https://assets.pearcommerce.com/2900443940010079.png",
    "Dog Treats": "https://assets.pearcommerce.com/2255584498873392.png",
    "Dry Cat Food": "https://assets.pearcommerce.com/2920925011956547.png",
    "Wet Cat Food": "https://assets.pearcommerce.com/840243151233.png",
};

const CATEGORY_SORT = {
    "Dog Treats": 1,
    "Dry Dog Food": 2,
    "Dry Cat Food": 3,
    "Wet Dog Food": 4,
    "Wet Cat Food": 5,
};

const UPC_TO_CATEGORY_CSV = [
    ['840243105618', 'Dog Treats'],
    ['840243136742', 'Dog Treats'],
    ['840243105632', 'Dry Cat Food'],
    ['840243105823', 'Dry Cat Food'],
    ['840243144075', 'Dry Dog Food'],
    ['840243148547', 'Dry Dog Food'],
    ['840243121267', 'Wet Cat Food'],
    ['840243140749', 'Wet Cat Food'],
    ['840243151233', 'Wet Cat Food'],
    ['840243158096', 'Wet Dog Food'],
];

const UPC_TO_CATEGORY_MAP = UPC_TO_CATEGORY_CSV.reduce((prev, next) => {
    const [upc, category] = next;
    prev[upc] = category;
    prev[`0${upc}`] = category;
    return prev;
}, {});

const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    if (!categoryName) return PLACEHOLDER_IMG;
    const nameToSearch = categoryName
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    return CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: CATEGORY_SORT,
    defaultCategory: 'Dog Treats',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/enriched_category.js":[function(_dereq_,module,exports){
const bangCategory = _dereq_('./bang_category_map.js');
const fullThrottleCategory = _dereq_('./full_throttle_category_map.js');
const monsterCategory = _dereq_('./monster_category_map.js');
const nosCategory = _dereq_('./nos_category_map.js');
const reignCategory = _dereq_('./reign_category_map.js');
const reignStormCategory = _dereq_('./reign_storm_category_map.js');
const blueBuffaloCategory = _dereq_('./blue_buffalo_category_map.js');

module.exports = {
  2449900187366688: {
    default: bangCategory.defaultCategory,
    images: bangCategory.getImageFromCategory,
    mapper: bangCategory.getCategoryFromUPC,
    sortOrder: bangCategory.categorySort,
  },
  2449900187366761: {
    default: fullThrottleCategory.defaultCategory,
    images: fullThrottleCategory.getImageFromCategory,
    mapper: fullThrottleCategory.getCategoryFromUPC,
    sortOrder: fullThrottleCategory.categorySort,
  },
  1957556405640544: {
    default: monsterCategory.defaultCategory,
    images: monsterCategory.getImageFromCategory,
    mapper: monsterCategory.getCategoryFromUPC,
    sortOrder: monsterCategory.categorySort,
  },
  2449900187366770: {
    default: nosCategory.defaultCategory,
    images: nosCategory.getImageFromCategory,
    mapper: nosCategory.getCategoryFromUPC,
    sortOrder: nosCategory.categorySort,
  },
  2449900187374861: {
    default: reignCategory.defaultCategory,
    images: reignCategory.getImageFromCategory,
    mapper: reignCategory.getCategoryFromUPC,
    sortOrder: reignCategory.categorySort,
  },
  2462837481357782: {
    default: reignStormCategory.defaultCategory,
    images: reignStormCategory.getImageFromCategory,
    mapper: reignStormCategory.getCategoryFromUPC,
    sortOrder: reignStormCategory.categorySort,
  },
  1740607387970560: {
    default: blueBuffaloCategory.defaultCategory,
    images: blueBuffaloCategory.getImageFromCategory,
    mapper: blueBuffaloCategory.getCategoryFromUPC,
    sortOrder: blueBuffaloCategory.categorySort,
  },
};

},{"./bang_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/bang_category_map.js","./blue_buffalo_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/blue_buffalo_category_map.js","./full_throttle_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/full_throttle_category_map.js","./monster_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/monster_category_map.js","./nos_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/nos_category_map.js","./reign_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/reign_category_map.js","./reign_storm_category_map.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/reign_storm_category_map.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/full_throttle_category_map.js":[function(_dereq_,module,exports){
const CATEGORY_IMAGE_MAPPING = {
    "ORIGINAL CITRUS": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482349043.png",
    "TRUE BLUE": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482414530.png",
};

const UPC_TO_CATEGORY_MAP = {};
const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: {},
    defaultCategory: 'Original Citrus',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/monster_category_map.js":[function(_dereq_,module,exports){
const MONSTER_CATEGORY_IMAGE_MAPPING = {
    "MONSTER ULTRA": "https://image-processor.pearcommerce.com/OfferImage/2449900187358482.png?height=104",
    "MONSTER GREEN": "https://image-processor.pearcommerce.com/OfferImage/2449900187358476.png?height=104",
    "JAVA MONSTER": "https://image-processor.pearcommerce.com/OfferImage/2449900187358553.png?height=104",
    "JAVA MONSTER 300": "https://image-processor.pearcommerce.com/OfferImage/2449900187333918.png?height=104",
    "JAVA MONSTER NITRO COLD BREW": "https://image-processor.pearcommerce.com/OfferImage/2449900187333915.png?height=104",
    "JUICE MONSTER": "https://image-processor.pearcommerce.com/OfferImage/2449900187268467.png?height=104",
    "MONSTER REHAB": "https://image-processor.pearcommerce.com/OfferImage/2449900187276625.png?height=104",
    "MONSTER ZERO SUGAR": "https://image-processor.pearcommerce.com/OfferImage/2449900187342097.png?height=104",
    "MONSTER RESERVE": "https://image-processor.pearcommerce.com/OfferImage/2449900187276653.png?height=104",
    "MONSTER IMPORT": "https://image-processor.pearcommerce.com/OfferImage/2449900187284812.png?height=104",
    "MONSTER LO-CARB": "https://image-processor.pearcommerce.com/OfferImage/2449900187358479.png?height=104",
    "MONSTER NITRO": "https://image-processor.pearcommerce.com/OfferImage/2449900187276610.png?height=104",
};

const MONSTER_CATEGORY_SORT = {
    "MONSTER ULTRA": 1,
    "MONSTER GREEN": 2,
    "JUICE MONSTER": 3,
    "JAVA MONSTER": 4,
    "JAVA MONSTER 300": 5,
    "JAVA MONSTER NITRO COLD BREW": 6,
    "MONSTER REHAB": 7,
    "MONSTER ZERO SUGAR": 8,
    "MONSTER LO-CARB": 9,
    "MONSTER RESERVE": 10,
    "MONSTER IMPORT": 11,
    "MONSTER NITRO": 12,
};

const MONSTER_UPC_TO_CATEGORY_CSV = [
   ['70847035107','JAVA MONSTER'],
   ['70847034780','JAVA MONSTER'],
   ['70847891994','JAVA MONSTER'],
   ['70847831013','JAVA MONSTER'],
   ['70847812517','JAVA MONSTER'],
   ['70847812715','JAVA MONSTER'],
   ['70847029045','JAVA MONSTER'],
   ['70847812609','JAVA MONSTER'],
   ['970847812609','JAVA MONSTER'],
   ['70847029120','JAVA MONSTER'],
   ['70847039044','JAVA MONSTER'],
   ['70847039136','JAVA MONSTER'],
   ['70847024026','JAVA MONSTER'],
   ['70847895947','JAVA MONSTER'],
   ['70847014430','JAVA MONSTER'],
   ['70847028147','JUICE MONSTER'],
   ['70847891932','JUICE MONSTER'],
   ['70847892687','JUICE MONSTER'],
   ['70847036944','JUICE MONSTER'],
   ['70847892694','JUICE MONSTER'],
   ['70847029014','JUICE MONSTER'],
   ['70847892380','JUICE MONSTER'],
   ['70847892700','JUICE MONSTER'],
   ['70847031918','JUICE MONSTER'],
   ['70847892717','JUICE MONSTER'],
   ['70847036920','JUICE MONSTER'],
   ['70847892724','JUICE MONSTER'],
   ['70847022909','JUICE MONSTER'],
   ['70847892731','JUICE MONSTER'],
   ['70847896159','JUICE MONSTER'],
   ['70847896951','JUICE MONSTER'],
   ['70847892311','JUICE MONSTER'],
   ['70847895121','JUICE MONSTER'],
   ['70847896074','JUICE MONSTER'],
   ['70847895961','JUICE MONSTER'],
   ['70847896685','MONSTER GREEN'],
   ['70847000303','MONSTER GREEN'],
   ['70847037569','MONSTER GREEN'],
   ['70847811169','MONSTER GREEN'],
   ['70847892359','MONSTER GREEN'],
   ['70847811244','MONSTER GREEN'],
   ['708478112446','MONSTER GREEN'],
   ['70847811176','MONSTER GREEN'],
   ['70847028291','MONSTER GREEN'],
   ['70847811985','MONSTER GREEN'],
   ['70847811237','MONSTER GREEN'],
   ['70847891628','MONSTER GREEN'],
   ['70847819509','MONSTER IMPORT'],
   ['70847037866','MONSTER LO-CARB'],
   ['70847811268','MONSTER LO-CARB'],
   ['70847811213','MONSTER LO-CARB'],
   ['70847811275','MONSTER LO-CARB'],
   ['70847891642','MONSTER LO-CARB'],
   ['70847891963','MONSTER NITRO'],
   ['70847037750','MONSTER NITRO'],
   ['70847891703','MONSTER NITRO'],
   ['70847891468','MONSTER ULTRA'],
   ['70847891604','MONSTER ULTRA'],
   ['70847896210','MONSTER ULTRA'],
   ['70847896180','MONSTER ULTRA'],
   ['70847896890','MONSTER ULTRA'],
   ['70847034629','MONSTER ULTRA'],
   ['70847037736','MONSTER ULTRA'],
   ['70847036500','MONSTER ULTRA'],
   ['70847891482','MONSTER ULTRA'],
   ['70847037804','MONSTER ULTRA'],
   ['70847891543','MONSTER ULTRA'],
   ['70847033080','MONSTER ULTRA'],
   ['70847033738','MONSTER ULTRA'],
   ['70847891581','MONSTER ULTRA'],
   ['70847029090','MONSTER ULTRA'],
   ['70847029427','MONSTER ULTRA'],
   ['70847896777','MONSTER ULTRA'],
   ['70847029311','MONSTER ULTRA'],
   ['70847891529','MONSTER ULTRA'],
   ['70847017554','MONSTER ULTRA'],
   ['70847891505','MONSTER ULTRA'],
   ['70847034643','MONSTER ULTRA'],
   ['70847891444','MONSTER ULTRA'],
   ['70847891833','MONSTER ULTRA'],
   ['70847891857','MONSTER ULTRA'],
   ['70847891871','MONSTER ULTRA'],
   ['70847892571','MONSTER ULTRA'],
   ['70847895299','MONSTER ULTRA'],
   ['70847037934','MONSTER ULTRA'],
   ['70847020905','MONSTER ULTRA'],
   ['70847896128','MONSTER ULTRA'],
   ['70847021841','MONSTER ULTRA'],
   ['70847891567','MONSTER ULTRA'],
   ['70847892403','MONSTER ULTRA'],
   ['70847894971','MONSTER ULTRA'],
   ['70847894964','MONSTER ULTRA'],
   ['70847897859','MONSTER ULTRA'],
   ['70847029809','MONSTER ULTRA'],
   ['70847897651','MONSTER ULTRA'],
   ['708478960122','MONSTER ULTRA'],
   ['70847895565','MONSTER ULTRA'],
   ['70847896043','MONSTER ULTRA'],
   ['70847897484','MONSTER ULTRA'],
   ['70847894117','MONSTER ULTRA'],
   ['70847895589','MONSTER ULTRA'],
   ['70847036524','MONSTER ULTRA'],
   ['70847897446','MONSTER ULTRA'],
   ['70847019060','MONSTER ULTRA'],
   ['70847893325','MONSTER ULTRA'],
   ['70847028420','MONSTER ULTRA'],
   ['70847029083','MONSTER ULTRA'],
   ['70847027324','MONSTER ULTRA'],
   ['70847030546','MONSTER ULTRA'],
   ['70847891406','MONSTER ULTRA'],
   ['70847029069','MONSTER ULTRA'],
   ['70847037989','MONSTER ULTRA'],
   ['70847891420','MONSTER ULTRA'],
   ['70847037545','MONSTER ULTRA'],
   ['70847037965','MONSTER ULTRA'],
   ['70847012474','MONSTER ULTRA'],
   ['70847892519','MONSTER ULTRA'],
   ['70847017707','MONSTER ULTRA'],
   ['70847013242','MONSTER ULTRA'],
   ['70847028345','MONSTER ULTRA'],
   ['70847015543','MONSTER ULTRA'],
   ['70847891291','MONSTER ULTRA'],
   ['70847037958','MONSTER ZERO SUGAR'],
   ['70847000037','MONSTER ZERO SUGAR'],
   ['70847000051','MONSTER ZERO SUGAR'],
   ['70847003403','MONSTER ZERO SUGAR'],
   ['70847891666','MONSTER ZERO SUGAR'],
   ['70847891901','MONSTER RESERVE'],
   ['70847890805','MONSTER RESERVE'],
   ['70847891796','MONSTER RESERVE'],
   ['70847896272','MONSTER RESERVE'],
   ['70847896999','MONSTER RESERVE'],
   ['70847038306','MONSTER RESERVE'],
   ['70847037828','MONSTER RESERVE'],
   ['70847891772','MONSTER RESERVE'],
   ['70847898191','MONSTER ULTRA'],
   ['70847898146','MONSTER ULTRA'],
   ['70847003229','MONSTER REHAB'],
   ['70847892540','MONSTER REHAB'],
   ['70847003342','MONSTER REHAB'],
   ['70847896678','MONSTER REHAB'],
   ['70847896920','MONSTER REHAB'],
   ['70847892205','MONSTER REHAB'],
   ['70847021520','MONSTER REHAB'],
   ['70847892137','MONSTER REHAB'],
   ['70847038436','MONSTER REHAB'],
   ['70847892144','MONSTER REHAB'],
   ['70847038528','MONSTER REHAB'],
   ['70847896104','MONSTER REHAB'],
   ['70847897828','MONSTER REHAB'],
   ['70847895985','MONSTER REHAB'],
   ['70847028253','MONSTER REHAB'],
   ['70847892168','MONSTER REHAB'],
   ['70847894087','MONSTER REHAB'],
   ['70847894735','MONSTER REHAB'],
   ['70847898245','MONSTER ULTRA'],
];

const MONSTER_UPC_TO_CATEGORY_MAP = MONSTER_UPC_TO_CATEGORY_CSV.reduce((prev, next) => {
    const [upc, category] = next;
    prev[upc] = category;
    prev[`0${upc}`] = category;
    return prev;
}, {});

const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return MONSTER_CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return MONSTER_UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: MONSTER_CATEGORY_SORT,
    defaultCategory: 'MONSTER ULTRA',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/nos_category_map.js":[function(_dereq_,module,exports){
const CATEGORY_IMAGE_MAPPING = {
    "GT GRAPE": "https://demos-cf-1.pearcommerce.com/OfferImage/2534522675115471.png",
    "ORIGINAL": "https://demos-cf-1.pearcommerce.com/OfferImage/2534523547166993.png",
    "SONIC SOUR": "https://demos-cf-1.pearcommerce.com/OfferImage/2534523547167046.png",
    "ZERO SUGAR": "https://demos-cf-1.pearcommerce.com/OfferImage/2534523547167049.png",
};

const UPC_TO_CATEGORY_MAP = {};
const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: {},
    defaultCategory: 'GT Grape',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/reign_category_map.js":[function(_dereq_,module,exports){
const CATEGORY_IMAGE_MAPPING = {
    "CHERRY LIMEADE": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482766830.png",
    "MELON MANIA": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374868.png",
    "ORANGE DREAMSICLE": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374875.png",
    "RAZZLE BERRY": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837483078092.png",
    "RED DRAGON": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374907.png",
    "REIGNBOW SHERBET": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374887.png",
    "SOUR GUMMY WORM": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374895.png",
    "TROPICAL STORM": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837483192827.png",
    "WATERMELON WARLORD": "https://demos-cf-1.pearcommerce.com/OfferImage/2449900187374911.png",
    "WHITE GUMMY BEAR": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837483258285.png",
    "LILIKOI LYCHEE": "https://demos-cf-1.pearcommerce.com/OfferImage/2521563395278549.png",
    "WHITE HAZE": "https://demos-cf-1.pearcommerce.com/OfferImage/2678360089103269.png",
};

const UPC_TO_CATEGORY_MAP = {};
const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: {},
    defaultCategory: Object.keys(CATEGORY_IMAGE_MAPPING)[0],
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/reign_storm_category_map.js":[function(_dereq_,module,exports){
const CATEGORY_IMAGE_MAPPING = {
    "CITRUS ZEST": "https://demos-cf-1.pearcommerce.com/OfferImage/2688809011929985.png",
    "GUAVA STRAWBERRY": "https://demos-cf-1.pearcommerce.com/OfferImage/2688809011921918.png",
    "HARVEST GRAPE": "https://demos-cf-1.pearcommerce.com/OfferImage/2688810510280086.png",
    "KIWI BLEND": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482553778.png",
    "MANGO": "https://demos-cf-1.pearcommerce.com/OfferImage/2690276101343192.png",
    "PEACH NECTARINE": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482611148.png",
    "STRAWBERRY APRICOT": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482611152.png",
    "TROPICAL": "https://demos-cf-1.pearcommerce.com/OfferImage/2658323675990832.png",
    "VALENCIA ORANGE": "https://demos-cf-1.pearcommerce.com/OfferImage/2462837482668530.png",
};

const UPC_TO_CATEGORY_MAP = {};
const PLACEHOLDER_IMG = 'https://assets.pearcommerce.com/comingsoon.png';

function getImageFromCategory(categoryName) {
    const nameToSearch = categoryName?.toUpperCase();
    return CATEGORY_IMAGE_MAPPING[nameToSearch] || PLACEHOLDER_IMG;
}

function getCategoryFromUPC(upc) {
    return UPC_TO_CATEGORY_MAP[upc];
}

module.exports = {
    categorySort: {},
    defaultCategory: 'Citrus Zest',
    getImageFromCategory,
    getCategoryFromUPC,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/geocoding-cache.js":[function(_dereq_,module,exports){
/**
 * Geocoding Cache Utility
 * Provides caching for Stadia Maps API calls to reduce API usage and improve performance
 */

class GeocodingCache {
  constructor() {
    this.cache = new Map();
    this.maxSize = 1000; // Maximum number of cached items
    this.stats = {
      hits: 0,
      misses: 0,
      saves: 0
    };
    
    // Load existing cache from localStorage
    this.loadFromStorage();
  }

  /**
   * Generate a cache key from the API endpoint and parameters
   */
  generateKey(endpoint, params) {
    const sortedParams = Object.keys(params)
      .sort()
      .map(key => `${key}=${params[key]}`)
      .join('&');
    return `${endpoint}?${sortedParams}`;
  }

  /**
   * Get cached result if available
   */
  get(endpoint, params) {
    const key = this.generateKey(endpoint, params);
    const cached = this.cache.get(key);
    
    if (!cached) {
      this.stats.misses++;
      return null;
    }
    
    this.stats.hits++;
    return cached.data;
  }

  /**
   * Cache a result
   */
  set(endpoint, params, data) {
    const key = this.generateKey(endpoint, params);
    
    // Implement LRU eviction if cache is full
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }
    
    this.cache.set(key, {
      data: data,
      createdAt: Date.now()
    });
    
    // Save to localStorage
    this.saveToStorage();
    
    this.stats.saves++;
  }

  /**
   * Get cache statistics
   */
  getStats() {
    return {
      ...this.stats,
      size: this.cache.size,
      maxSize: this.maxSize,
      hitRate: this.stats.hits / (this.stats.hits + this.stats.misses) || 0
    };
  }

  /**
   * Clear all cache
   */
  clear() {
    this.cache.clear();
    this.stats.hits = 0;
    this.stats.misses = 0;
    this.stats.saves = 0;
    
    // Clear from localStorage
    localStorage.removeItem('geocodingCache');
  }

  /**
   * Cache map styles specifically
   */
  cacheMapStyle(stylePath, styleData) {
    const key = `mapstyle:${stylePath}`;
    
    // Implement LRU eviction if cache is full
    if (this.cache.size >= this.maxSize) {
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }
    
    this.cache.set(key, {
      data: styleData,
      createdAt: Date.now()
    });
    
    // Save to localStorage
    this.saveToStorage();
    this.stats.saves++;
  }

  /**
   * Get cached map style
   */
  getMapStyle(stylePath) {
    const key = `mapstyle:${stylePath}`;
    const cached = this.cache.get(key);
    
    if (!cached) {
      this.stats.misses++;
      return null;
    }
    
    this.stats.hits++;
    return cached.data;
  }
  
  /**
   * Save cache to localStorage
   */
  saveToStorage() {
    try {
      const cacheData = {
        entries: Array.from(this.cache.entries()),
        stats: this.stats,
        timestamp: Date.now()
      };
      localStorage.setItem('geocodingCache', JSON.stringify(cacheData));
    } catch (error) {
      console.warn('Failed to save cache to localStorage:', error);
    }
  }
  
  /**
   * Load cache from localStorage
   */
  loadFromStorage() {
    try {
      const cached = localStorage.getItem('geocodingCache');
      if (cached) {
        const cacheData = JSON.parse(cached);
        
        if (cacheData.entries) {
          this.cache = new Map(cacheData.entries);
          this.stats = cacheData.stats || this.stats;
        }
      }
    } catch (error) {
      console.warn('Failed to load cache from localStorage:', error);
      localStorage.removeItem('geocodingCache');
    }
  }
}

// Create a singleton instance
const geocodingCache = new GeocodingCache();



// Export the cache instance
module.exports = geocodingCache; 
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/index.js":[function(_dereq_,module,exports){
window.printJS = _dereq_('print-js');
window.pym = _dereq_('pym.js');
_dereq_('string.prototype.endswith');
_dereq_('polyfill-object.fromentries');
_dereq_('./offers_app.js');
_dereq_('./productLocatorController.js');
_dereq_('./picker.js');
_dereq_('promise-any-polyfill');

},{"./offers_app.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/offers_app.js","./picker.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/picker.js","./productLocatorController.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/productLocatorController.js","polyfill-object.fromentries":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/polyfill-object.fromentries/index.js","print-js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/print-js/dist/print.js","promise-any-polyfill":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/promise-any-polyfill/js/implementation.js","pym.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/pym.js/dist/pym.v1.js","string.prototype.endswith":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/string.prototype.endswith/endswith.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/map-utils.js":[function(_dereq_,module,exports){
const PEAR_GEOCODING_PERCENT = 1;
const CACHE_KEYS = { SEARCH: '/search', REVERSE: '/reverse' };

/**
 * Get current location using geolocation and Stadia Maps
 * @param {Object} STADIA_MAPS_CONFIG - Stadia Maps configuration
 * @param {boolean} includeCountry - Whether to include country in the location string
 * @returns {Promise<Object>} Location data with city, state, country, coordinates, and zip
 */
const getCurrentLocation = async (STADIA_MAPS_CONFIG, includeCountry = true) => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation || true) {
      reject(new Error('Geolocation not supported'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async function (position) {
        const { latitude, longitude } = position.coords;
        
          try {
          const data = await fetchWithFallback(getReverseGeocodingUrls, STADIA_MAPS_CONFIG, latitude, longitude);
          
          if (data.features && data.features.length > 0) {
            const feature = data.features[0];
            const properties = feature.properties;
            
            // Extract location components
            const city = properties.city || properties.town || properties.village || properties.locality || 'Unknown City';
            const state = properties.state || properties.region || properties.province || '';
            const country = properties.country || properties.country_code || '';
            const zip = properties.postcode || '';
            
            // Normalize country code
            const normalizedCountry = ['US', 'USA', 'United States'].includes(country) ? 'USA' : country;
            
            // Create location string based on preference
            let locationString;
            if (includeCountry && normalizedCountry) {
              locationString = state ? `${city}, ${state}, ${normalizedCountry}` : `${city}, ${normalizedCountry}`;
            } else {
              locationString = state ? `${city}, ${state}` : city;
            }
            
            resolve({
              city,
              state,
              country: normalizedCountry,
              latitude,
              longitude,
              zip,
              locationString
            });
          } else {
            reject(new Error('No location data found'));
          }
        } catch (error) {
          reject(error);
        }
      },
      function (error) {
        reject(error);
      }
    );
  });
};

/**
 * Update location with zip code and navigate
 * @param {string} zip - Zip code to update with
 * @param {Object} $scope - Angular scope object
 * @param {Object} $state - Angular state object
 */
const updateLocationWithZip = (zip, $scope, $state) => {
  const params = {
    zip: ($scope.location.countryCode && $scope.location.countryCode == 'AU' ? 'AU' : '') + zip,
    latitude: $scope.location.latitude,
    longitude: $scope.location.longitude,
    address: $scope.location.location,
    countryCode: $scope.location.countryCode,
  };
  
  if (!window.requestKillswitch) {
    $state.go($state.current, params, { location: true, reload: false });
  } else {
    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');
    window.location = window.location.href.split('?')[0] + '?' + queryString;
  }
};

/**
 * Get zip code from coordinates using multiple geocoding methods
 * @param {Object} location - Location object with coordinates and address
 * @param {Function} getZipFromForwardGeocoding - Function to get zip from forward geocoding
 * @param {Function} getZipFromLocationSearch - Function to get zip from location search
 * @returns {Promise<string|null>} Zip code or null
 */
const getZipFromCoordinates = async (location, getZipFromForwardGeocoding, getZipFromLocationSearch) => {
  if (!location.location || !location.coordinatesLocation) {
    return null;
  }
  if (!location.latitude || !location.longitude) {
    return null;
  }

  // Try to extract zip from location string first
  const zipMatch = location.location.match(/\b\d{5}\b/);
  if (zipMatch) {
    return zipMatch[0];
  }
  
  // Only try location search if forward geocoding failed
  const zipFromSearch = await getZipFromLocationSearch(location.location);
  if (zipFromSearch) {
    return zipFromSearch;
  }

  // Try forward geocoding + place details first (more comprehensive)
  const zip = await getZipFromForwardGeocoding(location.location);
  if (zip) {
    return zip;
  }

  return null;
};
/**
 * Get postal code from coordinates using Mapbox reverse geocoding
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {Object} STADIA_MAPS_CONFIG - Configuration object containing Mapbox API key and geocoding URL
 * @returns {Promise<string|null>} Postal code or null
 */
const getZipFromMapboxReverse = async (lat, lng, STADIA_MAPS_CONFIG) => {
  try {
    const mapboxUrl = `${STADIA_MAPS_CONFIG.MAPBOX_GEOCODING_URL}/mapbox.places/${lng},${lat}.json?access_token=${STADIA_MAPS_CONFIG.MAPBOX_API_KEY}&types=address,poi`;
    const response = await fetch(mapboxUrl);
    if (!response.ok) return null;

    const mapboxData = await response.json();
    if (!mapboxData.features?.length) return null;

    for (const feature of mapboxData.features) {
      if (!feature.context) continue;
      const postcodeContext = feature.context.find((c) => c.id.startsWith("postcode"));
      if (postcodeContext?.text) {
        return postcodeContext.text
          .replace(/^(\d{5}).*/, "$1") // normalize ZIP+4
          .replace(/\s/g, "")
          .toUpperCase();
      }
    }
    return null;
  } catch (error) {
    if (STADIA_MAPS_CONFIG.DEBUG)
      console.warn("Error fetching postal code from Mapbox reverse geocoding:", error);
    return null;
  }
};

/**
 * Get postal code from location text using Mapbox forward geocoding
 * @param {string} locationText - Location text to geocode
 * @param {Object} STADIA_MAPS_CONFIG - Configuration object containing Mapbox API key and geocoding URL
 * @returns {Promise<string|null>} Postal code or null
 */
const getZipFromMapboxForward = async (locationText, STADIA_MAPS_CONFIG) => {
  try {
    const mapboxUrl = `${STADIA_MAPS_CONFIG.MAPBOX_GEOCODING_URL}/mapbox.places/${encodeURIComponent(
      locationText
    )}.json?access_token=${STADIA_MAPS_CONFIG.MAPBOX_API_KEY}&country=US,CA,GB,AU,IE,NZ,PR,FR,DE&types=place,postcode,address,poi&limit=5`;
    const response = await fetch(mapboxUrl);
    if (!response.ok) return null;

    const mapboxData = await response.json();
    if (!mapboxData.features?.length) return null;

    for (const feature of mapboxData.features) {
      // If it's a postcode feature type, use the place_name or text
      if (feature.place_type?.includes('postcode')) {
        const postcode = feature.text || feature.place_name?.split(',')[0];
        if (postcode) {
          return postcode
            .replace(/^(\d{5}).*/, "$1")
            .replace(/\s/g, "")
            .toUpperCase();
        }
      }
      
      // Check context for postcode
      if (feature.context) {
        const postcodeContext = feature.context.find((c) => c.id.startsWith("postcode"));
        if (postcodeContext?.text) {
          return postcodeContext.text
            .replace(/^(\d{5}).*/, "$1")
            .replace(/\s/g, "")
            .toUpperCase();
        }
      }
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching postal code from Mapbox forward geocoding:', error);
    return null;
  }
};

/**
 * Try Mapbox fallback helper (handles caching)
 */
const tryMapboxFallback = async (
  type,
  args,
  cacheKey,
  cacheParams,
  geocodingCache,
  STADIA_MAPS_CONFIG
) => {
  const fn = type === "reverse" ? getZipFromMapboxReverse : getZipFromMapboxForward;
  const zip = await fn(...args, STADIA_MAPS_CONFIG);
  if (zip) geocodingCache.set(cacheKey, cacheParams, zip);
  return zip;
};

/**
 * Get zip code using forward geocoding approach
 */
const getZipFromForwardGeocoding = async (locationText, STADIA_MAPS_CONFIG, geocodingCache) => {
  const cacheParams = {
    text: locationText,
    boundary_country: STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES,
    limit: 1,
  };
  const cached = geocodingCache.get(CACHE_KEYS.SEARCH, cacheParams);
  if (cached) return cached;

  try {
    const searchData = await fetchWithFallback(getGeocodingUrls, STADIA_MAPS_CONFIG, locationText);
    if (!searchData?.features?.length) {
      return await tryMapboxFallback(
        "forward",
        [locationText],
        CACHE_KEYS.SEARCH,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    const feature = grabHighestConfidenceProperty(searchData.features);
    const gid = feature.properties.gid;
    if (!gid) {
      return await tryMapboxFallback(
        "forward",
        [locationText],
        CACHE_KEYS.SEARCH,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    const detailsResponse = await fetch(
      `${STADIA_MAPS_CONFIG.BASE_URL}/place?ids=${encodeURIComponent(
        gid
      )}&format=json&key=${STADIA_MAPS_CONFIG.API_KEY}`
    );

    if (!detailsResponse.ok) {
      return await tryMapboxFallback(
        "forward",
        [locationText],
        CACHE_KEYS.SEARCH,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    const detailsData = await detailsResponse.json();
    if (!detailsData.features?.length) {
      return await tryMapboxFallback(
        "forward",
        [locationText],
        CACHE_KEYS.SEARCH,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    const properties = grabHighestConfidenceProperty(detailsData.features).properties;
    const zipCode =
      properties.postalcode || properties.postcode || properties.postal_code || properties.zip;

    if (typeof zipCode === "string") {
      geocodingCache.set(CACHE_KEYS.SEARCH, cacheParams, zipCode);
      return zipCode;
    }

    return await tryMapboxFallback(
      "forward",
      [locationText],
      CACHE_KEYS.SEARCH,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  } catch {
    return await tryMapboxFallback(
      "forward",
      [locationText],
      CACHE_KEYS.SEARCH,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  }
};

/**
 * Get zip code using location search approach
 */
const getZipFromLocationSearch = async (
  locationText,
  STADIA_MAPS_CONFIG,
  geocodingCache,
  getZipFromReverseGeocoding
) => {
  const cacheParams = {
    text: locationText,
    boundary_country: STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES,
    limit: STADIA_MAPS_CONFIG.DEFAULT_LIMIT
  };
  
  const cached = geocodingCache.get(CACHE_KEYS.SEARCH, cacheParams);
  if (cached) return cached;

  try {
    const data = await fetchWithFallback(getGeocodingUrls, STADIA_MAPS_CONFIG, locationText);
    if (!data?.features?.length) {
      return await tryMapboxFallback(
        "forward",
        [locationText],
        CACHE_KEYS.SEARCH,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    for (const feature of data.features) {
      const properties = feature.properties;
      const zip =
        properties.postalcode ||
        properties.postcode ||
        properties.address_components?.postal_code ||
        (properties.layer === "postcode" ? properties.postcode || properties.name : null);
      if (typeof zip === "string") {
        geocodingCache.set(CACHE_KEYS.SEARCH, cacheParams, zip);
        return zip;
      }
    }

    const highestConfidenceFeature = grabHighestConfidenceProperty(data.features);
    if (highestConfidenceFeature?.geometry?.coordinates) {
      const [lng, lat] = highestConfidenceFeature.geometry.coordinates;
      const zipFromReverse = await getZipFromReverseGeocoding(
        lat,
        lng,
        STADIA_MAPS_CONFIG,
        geocodingCache
      );
      if (typeof zipFromReverse === "string") {
        geocodingCache.set(CACHE_KEYS.SEARCH, cacheParams, zipFromReverse);
        return zipFromReverse;
      }
    }

    return await tryMapboxFallback(
      "forward",
      [locationText],
      CACHE_KEYS.SEARCH,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  } catch {
    return await tryMapboxFallback(
      "forward",
      [locationText],
      CACHE_KEYS.SEARCH,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  }
};

/**
 * Get zip code using reverse geocoding
 */
const getZipFromReverseGeocoding = async (lat, lng, STADIA_MAPS_CONFIG, geocodingCache) => {
  const cacheParams = { point_lat: lat, point_lon: lng };
  const cached = geocodingCache.get(CACHE_KEYS.REVERSE, cacheParams);
  if (cached) return cached;

  try {
    const data = await fetchWithFallback(getReverseGeocodingUrls, STADIA_MAPS_CONFIG, lat, lng);
    if (!data?.features?.length) {
      return await tryMapboxFallback(
        "reverse",
        [lat, lng],
        CACHE_KEYS.REVERSE,
        cacheParams,
        geocodingCache,
        STADIA_MAPS_CONFIG
      );
    }

    for (const feature of data.features) {
      const properties = feature.properties;
      const zip =
        properties.postalcode ||
        properties.postcode ||
        properties.address_components?.postal_code ||
        (properties.layer === "postcode" ? properties.postcode || properties.name : null);

      if (typeof zip === "string") {
        geocodingCache.set(CACHE_KEYS.REVERSE, cacheParams, zip);
        return zip;
      }
    }

    return await tryMapboxFallback(
      "reverse",
      [lat, lng],
      CACHE_KEYS.REVERSE,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  } catch {
    return await tryMapboxFallback(
      "reverse",
      [lat, lng],
      CACHE_KEYS.REVERSE,
      cacheParams,
      geocodingCache,
      STADIA_MAPS_CONFIG
    );
  }
};


/**
 * Get location data from text using Stadia Maps forward geocoding
 * @param {Object} STADIA_MAPS_CONFIG - Stadia Maps configuration
 * @param {string} locationText - The location text to geocode
 * @returns {Promise<Object>} Location data with city, state, country, coordinates
 */
const getLocationFromText = async (STADIA_MAPS_CONFIG, locationText) => {
  try {
    const data = await fetchWithFallback(getGeocodingUrls, STADIA_MAPS_CONFIG, locationText);
    
    if (data.features && data.features.length > 0) {
      const feature = grabHighestConfidenceProperty(data.features);
      const properties = feature.properties;
      
      // Extract location components
      const city = properties.city || properties.town || properties.village || properties.locality || 'Unknown City';
      const state = properties.state || properties.region || properties.province || '';
      const country = properties.country || properties.country_code || '';
      const latitude = feature.geometry.coordinates[1];
      const longitude = feature.geometry.coordinates[0];
      
      // Normalize country code
      const normalizedCountry = ['US', 'USA', 'United States'].includes(country) ? 'USA' : country;
      
      return {
        city,
        state,
        country: normalizedCountry,
        latitude,
        longitude
      };
    } else {
      throw new Error('No location data found');
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Get country code from coordinates using reverse geocoding
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {Object} STADIA_MAPS_CONFIG - Stadia Maps configuration
 * @param {Object} geocodingCache - Geocoding cache instance
 * @returns {Promise<string|null>} Country code or null
 */
const getCountryCodeFromCoordinates = async (lat, lng, STADIA_MAPS_CONFIG, geocodingCache) => {
  // Check cache first
  const cacheParams = {
    point_lat: lat,
    point_lon: lng,
    type: 'countryCode'
  };
  
  const cached = geocodingCache.get(CACHE_KEYS.REVERSE, cacheParams);
  if (cached) {
    return cached;
  }
  
  try {
    const data = await fetchWithFallback(
      getReverseGeocodingUrls, STADIA_MAPS_CONFIG, lat, lng
    );
    
    if (!data || !data.features?.length) {
      return null;
    }

    for (const feature of data.features) {
      const properties = feature.properties;
      const countryCode = properties.country_code || properties.country_a;
      
      if (countryCode) {
        const normalizedCountryCode = countryCode.toUpperCase();
        geocodingCache.set(CACHE_KEYS.REVERSE, cacheParams, normalizedCountryCode);
        return normalizedCountryCode;
      }
    }

    return null;
  } catch (error) {
    console.error('Error getting country code from coordinates:', error);
    return null;
  }
};

/**
 * Get full location details for a zip code using reverse geocoding
 * @param {Object} STADIA_MAPS_CONFIG - Stadia Maps configuration
 * @param {number} latitude - Latitude coordinate
 * @param {number} longitude - Longitude coordinate
 * @param {string} zipCode - The zip code
 * @returns {Promise<Object>} Location data with city, state, country
 */
const getLocationDetailsForZip = async (STADIA_MAPS_CONFIG, latitude, longitude, zipCode) => {
  try {
    // Use reverse geocoding to get full location details for this zip code
    const data = await fetchWithFallback(getReverseGeocodingUrls, STADIA_MAPS_CONFIG, latitude, longitude);
  
    if (data.features && data.features.length > 0) {
      const feature = grabHighestConfidenceProperty(data.features);
      const properties = feature.properties;
      
      // Extract city and state from the properties
      const city = properties.city || properties.town || properties.village || properties.locality || 'Unknown City';
      const state = properties.state || properties.region || properties.province || '';
      
      // Create location string with just city and state
      const locationString = state ? `${city}, ${state}` : city;
      
      const result = {
        city,
        state,
        locationString
      };
      
      return result;
    }
  } catch (error) {
    console.error('Error getting location details for zip:', error);
    throw error;
  }
};


const hasMapboxRefs = (style) => {
  if (!style || !style.sources) {
    return false;
  }
  return Object.values(style.sources).some((src) =>
    (src.url && String(src.url).startsWith('mapbox://')) ||
    (Array.isArray(src.tiles) && src.tiles.some((t) => String(t).startsWith('mapbox://')))
  );
};

const isVectorStyle = (style) => {
  if (!style || !style.sources) {
    return false;
  }
  return Object.values(style.sources).every((src) => src.type === 'vector');
};

const stadiaStyleFor = (theme, apiKey) => {
  const id = theme === 'dark' ? 'alidade_smooth_dark' : 'osm_bright';
  return `https://tiles.stadiamaps.com/styles/${id}.json?api_key=${encodeURIComponent(apiKey)}`;
};

// Accepts either a promise-like MapStylesJson or a plain object; returns the plain object or null
const getServerStyleObject = async (MapStylesJson) => {
  try {
    if (!MapStylesJson) {
      return null;
    }
    if (typeof MapStylesJson.then === 'function') {
      return (await MapStylesJson) || null;
    }
    if (MapStylesJson.data) {
      return MapStylesJson.data;
    }
    return MapStylesJson; // already a style object
  } catch (e) {
    console.warn('[map] server style fetch failed:', e);
    return null;
  }
};

// Prefer server vector if compatible; else Stadia vector by theme
const resolveVectorStyle = async ({ MapStylesJson, theme, apiKey }) => {
  const server = await getServerStyleObject(MapStylesJson);
  if (server && !hasMapboxRefs(server) && isVectorStyle(server)) {
    return server; // good MapLibre vector style from server
  }
  return stadiaStyleFor(theme, apiKey);
};

// apply a CSS filter to the actual MapLibre canvas and keep it applied
const applyMapCanvasFilter = (map, cssFilter) => {
  const set = () => {
    const c = map && map.getCanvas && map.getCanvas();
    if (c) c.style.filter = cssFilter || '';
  };
  set(); // now
  map.on('load', set);
  map.on('style.load', set);
  const container = map.getContainer();
  const mo = new MutationObserver(set);
  mo.observe(container, { childList: true, subtree: true });
  map.on('remove', () => mo.disconnect());
};

// Apply light-mode tweaks: hide ferry/wave layers, recolor roads/water/greens/beige.
const applyLightModeMapTweaks = (map) => {
  if (!map || map.__lightTweaksBound) {
    return;
  }
  map.__lightTweaksBound = true;

  const run = () => {
    const style = map.getStyle && map.getStyle();
    const layers = (style && style.layers) ? style.layers.slice() : [];
    if (!layers.length) {
      return;
    }

    const hide   = (id) => { if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', 'none'); };
    const getL   = (id) => layers.find((x) => x.id === id);
    const setFill= (id, color) => { const l = getL(id); if (l && l.type === 'fill') map.setPaintProperty(id, 'fill-color', color); };
    const setLine= (id, color) => { const l = getL(id); if (l && l.type === 'line') map.setPaintProperty(id, 'line-color', color); };
    const setBg  = (color) => { const bg = layers.find((l) => l.type === 'background'); if (bg) map.setPaintProperty(bg.id, 'background-color', color); };

    // 1) Hide ferry routes (and their labels)
    layers
      .filter((l) =>
        l.type === 'line' &&
        l['source-layer'] === 'transportation' &&
        /"class"\s*,\s*"ferry"/.test(JSON.stringify(l.filter || {}))
      )
      .forEach((l) => hide(l.id));

    layers
      .filter((l) =>
        l.type === 'symbol' &&
        l['source-layer'] === 'transportation_name' &&
        /ferry/i.test((l.id || '') + ' ' + JSON.stringify(l.filter || {}))
      )
      .forEach((l) => hide(l.id));

    // 2) Hide water “patterns” (waves/hatching/stipple icons)
    layers.forEach((l) => {
      const p = l.paint || {};
      const hasPattern = p['fill-pattern'] || p['line-pattern'] || p['icon-image'];
      const watery = /wave|water.*pattern|marine|sea.*pattern|hatch|stipple/i.test(
        (l.id || '') + ' ' + JSON.stringify(p)
      );
      if (hasPattern && watery) hide(l.id);
    });

    // 3) hide any remaining marine/sea lanes overlays
    layers
      .filter((l) => /marine|sea_lane|searoute|ocean.*overlay|water.*pattern/i.test(l.id || ''))
      .forEach((l) => hide(l.id));

    // 4) Recolor for light vibe
    const white = '#ffffff';
    const lightGray = '#f5f5f5';
    const lightBlue = '#79c6ec';
    const lightGreen = '#cce1bf';
    const lightBeige = '#f0e3d0';

    // roads
    layers
      .filter((l) => l.type === 'line' && l['source-layer'] === 'transportation')
      .forEach((l) => setLine(l.id, white));
    // casings
    layers
      .filter((l) => l.type === 'line' && /-casing$/.test(l.id || ''))
      .forEach((l) => setLine(l.id, lightGray));
    // water
    layers
      .filter((l) => l.type === 'fill' && l['source-layer'] === 'water')
      .forEach((l) => setFill(l.id, lightBlue));
    layers
      .filter((l) => l.type === 'line' && l['source-layer'] === 'waterway')
      .forEach((l) => setLine(l.id, lightBlue));
    // greens
    layers
      .filter((l) => l.type === 'fill' && (l['source-layer'] === 'landcover' || l['source-layer'] === 'landuse'))
      .forEach((l) => setFill(l.id, lightGreen));
    // beige base
    setBg(lightBeige);
    layers
      .filter((l) => l.type === 'fill' && (l['source-layer'] === 'land' || /land.*(base|bg)/i.test(l.id || '')))
      .forEach((l) => setFill(l.id, lightBeige));
  };

  // run on every style load (and now if already loaded)
  map.on('style.load', run);
  if (map.isStyleLoaded && map.isStyleLoaded()) run();
};

// Make the basemap less granular (without killing greens).
// Delays minor/tertiary streets & labels, and beige blocks (buildings + non-green landuse).
//
// Usage:
// applyGranularityTweaks(map, {
//   minorRoadsMinZoom: 13.6,
//   tertiaryMinZoom:   13.0,
//   buildingsMinZoom:  14.8,
//   labelBump:         0.25,
// });
const applyGranularityTweaks = (map, opts = {}) => {
  if (!map || map.__granularityTweaksBound) {
    return;
  }
  map.__granularityTweaksBound = true;

  const minorRoadsMinZoom = Number.isFinite(opts.minorRoadsMinZoom) ? opts.minorRoadsMinZoom : 13.3;
  const tertiaryMinZoom   = Number.isFinite(opts.tertiaryMinZoom)   ? opts.tertiaryMinZoom   : 12.9;
  const buildingsMinZoom  = Number.isFinite(opts.buildingsMinZoom)  ? opts.buildingsMinZoom  : 14.8;
  const labelBump         = Number.isFinite(opts.labelBump)         ? opts.labelBump         : 0.25;

  // Helpers
  const isMinorRoad = (fJSON = '') =>
    /"class"\s*,\s*"(residential|living_street|service|unclassified|minor|track|path|cycleway|footway|bridleway|steps)"/.test(fJSON);
  const isTertiary  = (fJSON = '') => /"class"\s*,\s*"tertiary"/.test(fJSON);
  const isMajorRoad = (fJSON = '') => /"class"\s*,\s*"(motorway|trunk|primary|secondary)"/.test(fJSON);

  // Greens we don't want to delay
  const looksGreenById = (id = '') =>
    /(park|village_green|green\b|grass|meadow|garden|wood|forest|nature_reserve)/i.test(id);
  const looksGreenByFilter = (fJSON = '') =>
    /"class"\s*,\s*"(park|recreation_ground|village_green|grass|meadow|garden|wood|forest|nature_reserve|pitch)"/i.test(fJSON);

  // Beige-ish landuse we do want to delay
  const looksBeigeUseById = (id = '') =>
    /(residential|commercial|industrial|retail|brownfield|farmyard|construction|parking)/i.test(id);
  const looksBeigeUseByFilter = (fJSON = '') =>
    /"class"\s*,\s*"(residential|commercial|industrial|retail|brownfield|farmyard|construction|parking)"/i.test(fJSON);

  const setRange = (id, minz, maxz = 24) => {
    try {
      map.setLayerZoomRange(id, minz, maxz);
    } catch (e) {
      console.warn('[granularity] setRange failed', id, e);
    }
  };

  const run = () => {
    const style  = map.getStyle && map.getStyle();
    const layers = (style && style.layers) ? style.layers.slice() : [];
    if (!layers.length) {
      return;
    }

    // 1) Streets geometry: delay minor + tertiary only
    layers
      .filter(l => l.type === 'line' && l['source-layer'] === 'transportation')
      .forEach(l => {
        const f = JSON.stringify(l.filter || {});
        if (isMinorRoad(f)) {
          setRange(l.id, minorRoadsMinZoom);
        }
        if (isTertiary(f)) {
          setRange(l.id, tertiaryMinZoom);
        }
      });

    // 2) Street labels: delay minor/tertiary labels; keep major labels (avoid blank shields)
    layers
      .filter(l => l.type === 'symbol' && l['source-layer'] === 'transportation_name')
      .forEach(l => {
        const f = JSON.stringify(l.filter || {});
        if (isMajorRoad(f)) {
          return;
        }
        if (isMinorRoad(f)) { 
          setRange(l.id, minorRoadsMinZoom + labelBump); 
          return; 
        }
        if (isTertiary(f)) {
          setRange(l.id, tertiaryMinZoom + labelBump);
          return;
        }
      });

    // 3) Beige landuse (NOT greens): delay
    layers
      .filter(l => l.type === 'fill' && (l['source-layer'] === 'landuse' || l['source-layer'] === 'landcover' || l['source-layer'] === 'landuse-residential'))
      .forEach(l => {
        const id = l.id || '';
        const f  = JSON.stringify(l.filter || {});
        if (looksGreenById(id) || looksGreenByFilter(f)) {
          return;
        }
        if (looksBeigeUseById(id) || looksBeigeUseByFilter(f)) {
          setRange(id, buildingsMinZoom);
          const outlineId = id + '-outline';
          if (map.getLayer(outlineId)) {
            setRange(outlineId, buildingsMinZoom);
          }
        }
      });

    // 4) Buildings (true building layers): delay
    layers
      .filter(l => l['source-layer'] === 'building' && (l.type === 'fill' || l.type === 'fill-extrusion' || l.type === 'line'))
      .forEach(l => setRange(l.id, buildingsMinZoom));
  };

  map.on('style.load', run);
  if (map.isStyleLoaded && map.isStyleLoaded()) run();
};

const shouldUsePearUrl = (useStadia) => Math.random() < PEAR_GEOCODING_PERCENT && !useStadia;

const getGeocodingUrls = (STADIA_MAPS_CONFIG, locationText, useStadia = false) => {
  const pearUrl = `${STADIA_MAPS_CONFIG.PEAR_GEOCODING_URL}/search?text=${encodeURIComponent(locationText)}`;
  const stadiaUrl = `${STADIA_MAPS_CONFIG.BASE_URL}/search?text=${encodeURIComponent(locationText)}&boundary.country=${STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES}&limit=1&format=json&key=${STADIA_MAPS_CONFIG.API_KEY}`;
  if (shouldUsePearUrl(useStadia)) {
    return [pearUrl, stadiaUrl];
  }
  return [stadiaUrl];
};

const getReverseGeocodingUrls = (STADIA_MAPS_CONFIG, lat, lng, useStadia = false) => {
  const pearUrl = `${STADIA_MAPS_CONFIG.PEAR_GEOCODING_URL}/reverse?lat=${lat}&lng=${lng}`;
  //request address layer specifically for postal codes
  const stadiaUrl = `${STADIA_MAPS_CONFIG.BASE_URL}/reverse?point.lat=${lat}&point.lon=${lng}&boundary.country=${STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES}&layers=address&limit=10&format=json&key=${STADIA_MAPS_CONFIG.API_KEY}`;
  if (shouldUsePearUrl(useStadia)) {
    return [pearUrl, stadiaUrl];
  }
  return [stadiaUrl];
};

const getAutocompleteUrls = (STADIA_MAPS_CONFIG, locationText, useStadia = false) => {
  const pearUrl = `${STADIA_MAPS_CONFIG.PEAR_GEOCODING_URL}/autocomplete?text=${encodeURIComponent(locationText)}`;
  const stadiaUrl = `${STADIA_MAPS_CONFIG.BASE_URL}/autocomplete?text=${encodeURIComponent(locationText)}&limit=${STADIA_MAPS_CONFIG.DEFAULT_LIMIT}&format=json&key=${STADIA_MAPS_CONFIG.API_KEY}&boundary.country=${STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES}&layers=locality,postalcode`;
  if (shouldUsePearUrl(useStadia)) {
    return [pearUrl, stadiaUrl];
  }
  return [stadiaUrl];
};

const getMapboxAutocompleteUrl = (STADIA_MAPS_CONFIG, locationText) => {
  return `${STADIA_MAPS_CONFIG.MAPBOX_GEOCODING_URL}/mapbox.places/${encodeURIComponent(locationText)}.json?access_token=${STADIA_MAPS_CONFIG.MAPBOX_API_KEY}&types=place,postcode&country=US,CA,GB,AU,IE,NZ,PR,FR,DE&limit=${STADIA_MAPS_CONFIG.DEFAULT_LIMIT}`;
};

const fetchMapboxAutocomplete = async (STADIA_MAPS_CONFIG, query) => {
  try {
    const mapboxUrl = getMapboxAutocompleteUrl(STADIA_MAPS_CONFIG, query);
    const response = await fetch(mapboxUrl);
    if (!response.ok) {
      console.error(`Mapbox request failed for "${query}": ${response.status}`);
      return null;
    }

    const mapboxData = await response.json();
    if (!mapboxData.features?.length) return null;

    // Convert Mapbox response to a format similar to Stadia
    return {
      features: mapboxData.features.map((feature) => ({
        geometry: feature.geometry,
        properties: {
          name: feature.place_name,
          label: feature.place_name,
          layer: feature.place_type?.[0] || "place",
          confidence: 1,
          country: feature.context?.find((c) => c.id.startsWith("country"))?.text,
          region: feature.context?.find((c) => c.id.startsWith("region"))?.text,
          locality: feature.context?.find((c) => c.id.startsWith("place"))?.text,
          postcode: feature.context?.find((c) => c.id.startsWith("postcode"))?.text,
        },
      })),
    };
  } catch (err) {
    console.error("Error fetching from Mapbox:", err);
    return null;
  }
}

/**
 * Fetch with fallback - tries Pear URL first (if randomly selected), then falls back to Stadia URL if it fails
 * @param {Function} urlGenerator - Function to generate URLs
 * @param {Object} STADIA_MAPS_CONFIG - Stadia Maps configuration
 * @param {...any} args - Arguments to pass to urlGenerator
 * @returns {Promise<Object|null>} Parsed JSON data or null if failed
 */
const fetchWithFallback = async (urlGenerator, STADIA_MAPS_CONFIG, ...args) => {
  const urls = urlGenerator(STADIA_MAPS_CONFIG, ...args);

  for (const [index, url] of urls.entries()) {
    try {
      const response = await fetch(url);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      if (index === urls.length - 1) {
        console.error('fetchWithFallback failed', error);
        throw error; // Last URL failed
      }
      // Otherwise, continue to next URL
    }
  }
  
  throw new Error('All URLs failed');
};

const grabHighestConfidenceProperty = (features) => {
  const firstFeature = features[0];
  if (firstFeature.properties.confidence === 1) {
    return firstFeature; // if the first feature has a confidence of 1, return it
  }
  const sortedFeatures = features.sort((a, b) => b.properties.confidence - a.properties.confidence); // sort the features by confidence
  return sortedFeatures[0]; // return the feature with the highest confidence
};


module.exports = {
  updateLocationWithZip,
  getZipFromCoordinates,
  getZipFromForwardGeocoding,
  getZipFromLocationSearch,
  getZipFromReverseGeocoding,
  getCurrentLocation,
  getLocationFromText,
  getLocationDetailsForZip,
  resolveVectorStyle,
  applyMapCanvasFilter,
  getServerStyleObject,
  applyLightModeMapTweaks,
  getGeocodingUrls,
  getReverseGeocodingUrls,
  getAutocompleteUrls,
  getMapboxAutocompleteUrl,
  fetchWithFallback,
  grabHighestConfidenceProperty,
  applyGranularityTweaks,
  fetchMapboxAutocomplete,
  getCountryCodeFromCoordinates
}; 

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/molson.js":[function(_dereq_,module,exports){
const molsonOfferIds = [
  1740377034682336, 1901717303274560, 1902460628249696, 1902461202107552, 2197503613845600, 2197505428226144,
  2197555701616064, 2202625867518880, 2202627527668640, 2202629821584288, 2230837915421608, 2230842973113256,
  2230843458718632, 2231489617569304, 2232196510961080, 2232202116533688, 2232211605999037, 2232217925571384,
  2288793967729688, 1820141826550016, 1872725875886720, 1872748334770688, 2051661448682624, 2157320916031136,
  2175748074767936, 2230871472860464, 2232161676815806, 2232178696703416, 2235887209907480, 2236381533500776,
  2236412887881368, 2236417921676952, 2236419649517208, 2236421659031192, 2236424096487064, 2279669857428688,
  2315681985443256, 2362917004638083, 2362917004908502, 2404197885270858, 2410674781027504, 2410674781150381,
  2434595347781277, 2462837483381204, 2474320966891086, 2474320966891099, 2513381497426990, 2513381497427000,
  2522066030028567, 2527026508773834, 2527026508790166, 2531638666715833, 2547488497655533, 2551492673253808,
  1939818422383872, 1939821434238208, 1940044242144672, 2051663903087744, 2068106959190944, 2190412462409312,
  2224427388195120, 2235142523325307, 2235143631530872, 2235157116939528, 2235696823155264, 2235822532034944,
  2239921154878208, 2239929535875840, 2304345494880824, 2304345494880880, 2304345494897178, 2362917004638095,
  2362917004638112, 2472874224021929, 2472874224021971, 2472874224021979, 2474320966891074, 2499125522526396,
  2503702701648930, 2511952013666857, 2547488497655542, 2548693557261104, 2551491765784882, 2207404407726672,
  2207406101160528, 2207415858127560, 2209508617421888, 2334254389131963, 2334254389131975, 2334685308676983,
  2428785434401606, 2566373396107420, 2566373396107429, 2210317755177384, 2210318915361224, 2210320144808448,
  2237159108152784, 2241538660762627, 2250546974065144, 2434595347863252, 2434595347863253, 2434595347945181,
  2457583808711558, 2477977179939148, 2503134057129918, 2531257597113122, 2319320392789423, 2008517696724992,
  2230869802306868, 2230879724563856, 2235671373519416, 2235673692387902, 2235695561325112, 2235703353859088,
  2291188383370032, 2291526956748176, 2293836428500005, 2355372661948020, 2355407976039381, 2526715228709173,
  2527026508642815, 2532475842486385, 2532475842494546, 2232222656975792, 2232227949810608, 2232230913586096,
  2235745841929656, 2235746659032504, 2453859776847053, 2473043856722213, 2526715228709128, 2526715228709132,
  2526715228709144, 2526729363785861, 2527026508650926, 2245052797213328, 2245054153980560, 2245082164575352,
  2245084445564024, 2245605333835072, 2355407976096682, 2359665052221743, 2368826912740178, 2522066030020435,
  2522066030036838, 2522066030069568, 2522066030069624, 2221593910149104, 2221615352872992, 2237196584791632,
  2542423063351457, 2542423063359667, 2542423063359693, 2542990821538696, 2542990821538698, 2542990822226858,
  2547488497655509, 2547488497655518, 2563526474510807, 2355407976047570, 2355407976047578, 2360503145046741,
  2348170877484561, 2348170877484606, 2349101053396881, 2008502802505728, 2008515928391680, 2142380729893984,
  2170767612947104, 2170782306848448, 2231553256458259, 2235814686302456, 2355751254146101, 2397322187971906,
  2397353712901446, 2397356069657867, 2397362902695235, 2397388963568966, 2397421546905483, 2397431278625036,
  2397775792957712, 2397808219548018, 2397809258490191, 2397809258654079, 2397811240798498, 2397815426257188,
  2397818277491187, 2397826301440397, 2397827963163061, 2397828249891279, 2397831435628993, 2397832426353025,
  2397833029652955, 2405627248274542, 2405627248274543, 2407613412372805, 2453685217234171, 2462837483381196,
  2464928557704700, 2466565232934307, 2474320966891059, 2477044961999967, 2477132905468085, 2492077202521301,
  2499125522509996, 2503134057129910, 2506887674579652, 2507263967737119, 2507263967737129, 2507263967737144,
  2511952013617790, 2547488497655462, 2547488497655479, 2454683559675231, 2568683784317913, 2568683784317950,
  2457190521429511, 2459178115663638, 2462837481619849, 2494294019258144, 2499125522518261, 2527538477697817,
  2534084112540225, 2534084112540229, 2586886948586119, 2586784893278701, 2592784484169179, 2592784484169139, 
  2592784484177351, 2592784484177356, 2605266150537572, 2647981267314535, 2647981267314512, 2647981267314501, 
  2658322576931590, 2665470038085036, 2665470038076812, 2666300418464875, 2666300418464880, 2666300418464887, 
  2678358972066631, 2681627336065154, 2686798009873516, 2686798009881721, 2686798009889853, 2686798009897988, 
  2687559700345050, 2695875809760217, 2705963091205576, 2705963091205571, 2705963091205592, 2712139309423520,
  2712139309423493, 2721260839032485, 2721260839032514, 2721260839032531, 2721318227516378, 2721318227532713, 
  2726208970826096, 2726208970834179, 2726208970834217, 2731934317705896, 2732024422106043, 2732024420287373, 
  2736999001474469, 2736999001474482, 2742583973013074, 2742583973013088, 2742583973013095, 2742583973013099, 
  2742583973013109, 2742583973013116, 2742583973021193, 2742583973021201, 2742583973021209, 2745532628082481, 
  2745532628082508, 2745532628082527, 2745532628090650, 2745532628090679, 2745532628090695, 2745532628090715, 
  2745532628090725, 2745532628090737, 2752340287259901, 2752340287325351, 2752340287325406, 2754772536411710, 
  2754772536411716, 2756743377499105, 2756743377499118, 2756743377499105, 2756743377499118, 2761515504210832, 
  2761515506021278, 2766582539743505, 2767457679874305, 2767457679874384, 2767457679874416, 2767457679882499, 
  2771564858092207, 2771564858092228, 2771564858092243, 2774575064902683, 2775793456933128, 2775793456933148, 
  2775793456933171, 2775793456933186, 2784464034557218, 2794090664257736, 2794090664257754, 2794090664265861, 
  2794090664265909, 2800765345793487, 2800765345793507, 2806167593565754, 2806167593565816, 2806167593573952, 
  2806167593582141, 2815376040155563, 2815376040155589, 2815376040155601, 2815376040155613, 2816177360933184, 
  2830559515152152, 2835312886537749, 2835312886537762, 2835312886537789, 2835312886537803, 2835312886537852, 
  2835312886545935, 2838946792326213, 2848725971479779, 2848725971487879, 2875586610917157, 2875586610908991, 
  2875586610917185, 2875586610917208, 2875586610917228, 2879378290103227, 2879184646565103, 2914155179790686, 
  2914155180224854, 2914155180290419, 2914155180364114, 2903385793702821, 2904686620060864, 2906193951010823, 
  2906193951002705, 2904686619946198, 2914155180527971, 2918094226286489, 2918094226352090, 2919584862691718, 
  2919584862691817, 2929451851657430
];

module.exports = molsonOfferIds;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/ng-async.js":[function(_dereq_,module,exports){
var rootScope;
const $async = module.exports = fn => {
    return async (...args) => {
        // Doing the global injection trick so we can use $async anywhere
        rootScope = rootScope || angular.element(document.querySelector('*[ng-app]')).injector().get('$rootScope');
        try {
            await fn.apply(null, args);
        } finally {
            rootScope.$apply();
        }
    }
};


},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/offers_app.js":[function(_dereq_,module,exports){
const storage = _dereq_('../storage.js');
const lzString = _dereq_('lz-string');
const Util = _dereq_('../utilities');
  const molsonOfferIds = _dereq_('./molson.js');
  const parseUri = _dereq_("../parseuri");
  
  // Distance calculation function using Haversine formula
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // Distance in kilometers
  }


const newBelgiumLandingPageOfferIds = ['2382910378166323', '2382910378027101', '2383002944820061', '2379213823842673'];

(function () {
  const RetailerShared = _dereq_('./retailer/retailer-shared.js');

  const Config = _dereq_('../config.js');
  const STADIA_MAPS_CONFIG = _dereq_('./stadia-maps-config.js');
  const geocodingCache = _dereq_('./geocoding-cache.js');
  const { 
    getCurrentLocation, 
    getLocationFromText, 
    getLocationDetailsForZip, 
    getGeocodingUrls, 
    grabHighestConfidenceProperty,
    getReverseGeocodingUrls, 
    getAutocompleteUrls, 
    fetchWithFallback,
    fetchMapboxAutocomplete
  } = _dereq_('./map-utils.js');
  const parseUri = _dereq_('../parseuri.js');

  const parsedURI = parseUri(window.location.href);
  const isProductLocator = (window.__isProductLocator = parsedURI.path.indexOf('product-locator') != -1);
  window.__disableCaches = !!parsedURI.queryKey['disableCaches'];
  window.__ioLog = !!parsedURI.queryKey['logIO'];

  if (Config.env == 'development') {
    window.admin = true;
  }
  const Util = _dereq_('../utilities.js');
  const analytics = _dereq_('../analytics-events.js');
  window.angular = _dereq_('angular');
  const pearConsole = _dereq_('../pear-console.js');
  console = pearConsole.PearConsole;

  _dereq_('angular-sanitize');
  _dereq_('angular-ui-router');
  const telephone = _dereq_('./telephone.js');
  const resetCss = _dereq_('./reset_css.js');
  const sentryParams = {};

  _dereq_('angular-carousel');

  if (Config['revisionShort'] && Config['env'] != 'development') {
    sentryParams['release'] = Config['env'] + '-' + Config['revisionShort'];
  }

  sentryParams['environment'] = Config['env'];

  _dereq_('angular-touch');


  const app = angular.module('pearApp', ['ui.router', 'ngSanitize', 'ngTouch','angular-carousel']);

  const $async = _dereq_('./ng-async.js');
  app.factory('$async', () => $async);
  /*
   * ROUTES
   */
  app.config(function ($stateProvider) {
    $stateProvider.state({
      parent: 'CenterBox',
      name: 'mockup1',
      url: '/offer_mockup1/{offerId}',
      templateUrl: '/html/mockup1.html',
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $stateParams.offerId && $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
      },
      controller: 'OfferMockupController as ctrl',
    });

    $stateProvider.state({
      parent: 'CenterBox',
      name: 'mockup2',
      url: '/offer_mockup2/{offerId}',
      templateUrl: '/html/mockup2.html',
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
      },
      controller: 'OfferMockupController as ctrl',
    });

    $stateProvider.state({
      parent: 'CenterBox',
      name: 'mockup3',
      url: '/offer_mockup3/{offerId}',
      templateUrl: '/html/mockup3.html',
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
      },
      controller: 'OfferMockupController as ctrl',
    });

    $stateProvider.state({
      parent: 'Base',
      name: 'full_mockup1',
      url: '/fullpage_offer_mockup1/{offerId}',
      templateUrl: '/html/fullpage-mockup1.html',
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
      },
      controller: 'OfferMockupController as ctrl',
    });

    $stateProvider.state({
      parent: 'Base',
      name: 'full_mockup2',
      url: '/fullpage_offer_mockup2/{offerId}',
      templateUrl: '/html/fullpage-mockup2.html',
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
      },
      controller: 'OfferMockupController as ctrl',
    });

    $stateProvider.state({
      name: 'ProductLocatorGPDemo',
      url: '/product-locator-gp-demo/',
      templateUrl: '/html/product-locator-gp-demo.html',
      resolve: {
        UPCsAndVendor: function ($stateParams, $api) {
          return $api.getUpcsAndVendor(1853489981342273);
        },
      },
      controller: function (UPCsAndVendor, $scope, $config) {
        // $scope.vendor = UPCsAndVendor.vendor;
        // console.log($scope.vendor);

        $scope.vendor = (UPCsAndVendor && UPCsAndVendor.vendor) || {};
        var vendorId = ($scope.vendor && $scope.vendor.id) || 1853489981342273;
        window.PEAR_WIDGET_CONFIG = window.PEAR_WIDGET_CONFIG || {};
        window.PEAR_WIDGET_CONFIGS = window.PEAR_WIDGET_CONFIGS || {};
        Object.assign(window.PEAR_WIDGET_CONFIG, {
          height: 800,
          containerId: 'pear-widget-container',
        });
        const node = document.createElement('script');
        node.src = $config.OFFERS_URL + 'js/sdk.js?vendorId=' + vendorId + '&widget=product-locator';
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      },
    });

    $stateProvider.state({
      name: 'ProductLocatorDemo',
      url: '/product-locator-demo/{vendorId}?productLocatorTemplate&v&theme&fullScreen',
      templateUrl: '/html/product-locator-demo.html',
      resolve: {
        UPCsAndVendor: function ($stateParams, $api) {
          return $api.getUpcsAndVendor($stateParams.vendorId);
        },
        PixelConfig: function ($stateParams, $api) {
          return $api.get(`/v1/loaded?vendorId=${$stateParams.vendorId}&filename=product-locator.js`);
        },
      },
      controller: function (UPCsAndVendor, $scope, $config, $stateParams, $rootScope, isMobile, PixelConfig) {
        const mobile = isMobile();
        $scope.vendor = (UPCsAndVendor && UPCsAndVendor.vendor) || {};
        var vendorId = ($scope.vendor && $scope.vendor.id) || 1853489981342273;
        const node = document.createElement('script');

        let v = null;
        const TEMPLATE_VERSIONS = {
          1: '/html/product-locator.html',
          2: '/html/product-locator-22-07.html',
        };
        PixelConfig = PixelConfig || {};
        PixelConfig.placeholder = {};
        const widgetConfig = PixelConfig.widgetConfig || {};

        if (!$stateParams.v) {
          $stateParams.v =
            $stateParams.productLocatorTemplate && $stateParams.productLocatorTemplate == TEMPLATE_VERSIONS[1] ? 1 : 2;
        }

        v = $stateParams.v || widgetConfig.version;
        const fullScreen = $stateParams.fullScreen || widgetConfig.fullScreen;
        if (fullScreen) {
          document.body.className = 'full-screen-demo';
        }

        const containerId = 'pear-widget-container';
        window.PEAR_WIDGET_CONFIG = window.PEAR_WIDGET_CONFIG || {};
        window.PEAR_WIDGET_CONFIG = Object.assign(
          window.PEAR_WIDGET_CONFIG,
          // demo defaults
          {
            height: v == 1 ? '1000px' : mobile ? '836px' : '820px',
            vendorId: vendorId,
            version: v,
            widget: 'product-locator.js',
            containerId: containerId,
          },
          // vendor config
          Util.keepTruthy(widgetConfig),
          // parameter overrides
          Util.keepTruthy({
            version: $stateParams.v,
            theme: $stateParams.theme,
          })
        );

        window.PEAR_WIDGET_CONFIGS = window.PEAR_WIDGET_CONFIGS || {};
        Object.assign(window.PEAR_WIDGET_CONFIGS, PixelConfig.widgetConfigsByLabel || {}, window.PEAR_WIDGET_CONFIGS);
        const container = document.getElementById(containerId);

        console.log('Widget Configs:', window.PEAR_WIDGET_CONFIGS);
        console.log('container:', container);
        [...Object.entries(window.PEAR_WIDGET_CONFIGS), ['0', window.PEAR_WIDGET_CONFIG]].forEach(
          ([label, _widgetConfig]) => {
            console.log('Adding widget config for label:', label, _widgetConfig);
            if (_widgetConfig.displayType == 'POPUP') {
              const popupButtonContainer = document.createElement('div');
              const buttonId = 'pear-demo-popup-button-' + label;
              popupButtonContainer.id = buttonId;
              popupButtonContainer.className = 'pear-demo-popup-button';
              popupButtonContainer.innerText = label + ' button';
              container.appendChild(popupButtonContainer);
              _widgetConfig.containerId = buttonId;
            }
          }
        );

        const pld = document.querySelector('.pld');
        pld.className = pld.className + ' ' + $stateParams.theme || '';

        if (v == 1) {
          container.style.width = `${1100 / 0.85}px`;
        }

        $scope.pearWidgetConfig = window.PEAR_WIDGET_CONFIG;

        if ($scope.pearWidgetConfig.ACCENT_BG_COLOR_1) {
          document.querySelector('.header').style.backgroundColor = $scope.pearWidgetConfig.ACCENT_BG_COLOR_1;
        }

        $scope.pearWidgetConfig.overridePlaceholder = true;

        node.src = `/js/sdk.js?vendorId=${vendorId}&widget=product-locator&productLocatorTemplate=${
          $stateParams.productLocatorTemplate || ''
        }&v=${v}&config=${encodeURIComponent(JSON.stringify($scope.pearWidgetConfig))}`;
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      },
    });

    $stateProvider.state({
      name: 'Offer',
      parent: 'CenterBox',
      url: '/offer/{offerId}?utm_source&utm_medium&utm_campaign&utm_term&utm_content&pear_transaction_id&pearclid&srcpearclid&text_page&parentUrl',
      templateUrl: '/html/ui-view.html',
      controller: function ($timeout, $state, CreatedTransaction, $experiment, $stateParams) {
        if ($stateParams.parentUrl && !storage.session.getItem('parentUrl')) {
          storage.session.setItem('parentUrl', $stateParams.parentUrl);
        }
        storage.session.setItem('allParameters', JSON.stringify(parseUri(window.location.href).queryKey));

        $timeout(function () {
          if (window.location.href.indexOf('send_link_for_later') < 0) {
            $state.go(
              'NewTransactionSplashState',
              {
                txnId: CreatedTransaction.id,
              },
              {
                location: false,
                reload: true,
              }
            );
          }
        });
      },
      resolve: {
        UPCSAndOffer: function ($api, $stateParams) {
          return $stateParams.offerId && $api.getUpcsAndOffer($stateParams.offerId);
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
        CreatedTransaction: function ($api, UPCSAndOffer, $stateParams, $state, $timeout, $location) {
          let txnId = $stateParams.pear_transaction_id;
          const offerId = UPCSAndOffer.offer.id;
          if (!txnId) {
            txnId = storage.session.getItem('txnId');
          }
          if (txnId && offerId == storage.session.getItem('offerId')) {
            return $api.getTransaction(txnId);
          } else if (UPCSAndOffer.offer.limitToValidSource) {
            throw new Error('No pear_transaction_id specified.');
          }

          const params = {
            offerId: UPCSAndOffer.offer.id,
          };

          if (UPCSAndOffer.UPCs.length == 1) {
            params.UPC = UPCSAndOffer.UPCs[0].UPC;
          }

          if ($stateParams.utm_source) {
            params.utm_source = $stateParams.utm_source;
          }
          if ($stateParams.utm_medium) {
            params.utm_medium = $stateParams.utm_medium;
          }
          if ($stateParams.utm_campaign) {
            params.utm_campaign = $stateParams.utm_campaign;
          }
          if ($stateParams.utm_term) {
            params.utm_term = $stateParams.utm_term;
          }
          if ($stateParams.utm_content) {
            params.utm_content = $stateParams.utm_content;
          }

          let url = '/v1/create_transaction';

          const baseUrl = $location.search()['baseUrl'];
          params.baseUrl = baseUrl;
          url += `?baseUrl=${baseUrl}`;

          if ($stateParams.pearclid) {
            params.pearclid = parseInt($stateParams.pearclid + '');
            url += '&pearclid=' + $stateParams.pearclid;
          }

          if ($stateParams.srcpearclid) {
            params.srcpearclid = parseInt($stateParams.srcpearclid + '');
            url += '&srcpearclid=' + $stateParams.srcpearclid;
          }

          if (window.location.search) {
            params.allParameters = window.location.search;
          }

          return $api.post(url, params).then(function (txn) {
            storage.session.setItem('txnId', txn.id);
            storage.session.setItem('offerId', offerId);
            return txn;
          });
        },
      },
    });

    const locationResolve = {
      PublicIp: function ($http, Session) {
        if (Session.ip) {
          return Session.ip;
        }

        return $http.get('https://ipinfo.io').then(
          function (successResp) {
            return (Session.ip = successResp.data.ip);
          },
          function (failResp) {
            console.log(failResp);
          }
        );
      },
      IpLocationData: function ($api, PublicIp, Session) {
        // A little bit of optimization. If we already have a
        // location in session, let's skip until the user
        // presses the button
        if (!Session.location) {
          let config = null;
          if (PublicIp) {
            config = {
              params: { ip: PublicIp },
            };
          }
          return $api.getIpLocationData(config);
        }
      },
    };

    $stateProvider.state({
      name: 'FullPageVertical',
      parent: 'TransactionBase',
      templateUrl: '/html/full-page-vertical.html',
      resolve: locationResolve,
      controller: 'FullPageTransactionCtrl',
      url: 'info/2',
    });

    $stateProvider.state({
      name: 'FullPageHorizontal',
      parent: 'TransactionBase',
      templateUrl: '/html/full-page-horizontal.html',
      resolve: locationResolve,
      controller: 'FullPageTransactionCtrl',
      url: 'info/1',
    });

    $stateProvider.state({
      name: 'LocationState',
      parent: 'TransactionStep',
      url: 'location',
      templateUrl: '/html/location.html',
      controller: 'LocationCtrl as ctrl',
      resolve: locationResolve,
    });

    $stateProvider.state({
      name: 'NewTransactionSplashState',
      parent: 'TransactionBase',
      url: 'splash',
      templateUrl: '/html/splash.html',
      controller: 'NewTransactionSplashCtrl as ctrl',
    });

    $stateProvider.state({
      name: 'SendLinkForLaterState',
      parent: 'Offer',
      url: '/send_link_for_later?parentUrl',
      templateUrl: '/html/send_for_later.html',
      controller: 'SendLinkForLaterCtrl as ctrl',
    });

    $stateProvider.state({
      name: 'ConsumerNameState',
      parent: 'TransactionStep',
      url: 'name',
      templateUrl: '/html/name.html',
      controller: 'ConsumerNameController as ctrl',
    });

    $stateProvider.state({
      name: 'ConsumerEmailState',
      parent: 'TransactionStep',
      url: 'email',
      templateUrl: '/html/email.html',
      controller: 'ConsumerEmailController as ctrl',
    });

    $stateProvider.state({
      name: 'ConsumerPhoneState',
      parent: 'TransactionStep',
      url: 'phone',
      templateUrl: '/html/phone.html',
      controller: 'ConsumerPhoneController as ctrl',
    });

    $stateProvider.state({
      name: 'VerifyPhoneState',
      parent: 'TransactionStep',
      url: 'verify-phone',
      templateUrl: '/html/verify-phone.html',
      controller: 'VerifyPhoneController as ctrl',
      resolve: {
        Verification: function ($api, RetailPartnerTransaction) {
          return $api.getVerification(RetailPartnerTransaction.verificationId);
        },
      },
    });

    $stateProvider.state({
      name: 'SuccessState',
      parent: 'TransactionBase',
      url: 'success',
      templateUrl: '/html/success.html',
      controller: function (
        $scope,
        $state,
        $sce,
        RetailPartner,
        RetailPartnerTransaction,
        $api,
        $experiment,
        SelectedUPC
      ) {
        if (!RetailPartnerTransaction.registeredWithGoogleAnalytics) {
          // gtag('event', 'Success', { label: RetailPartnerTransaction.id + '' });
          $experiment.convert('Full Page Questions -- March 2019');
          $api.post('/v1/registered_with_google', { id: RetailPartnerTransaction.id });
        }
        RetailPartner.programNameHtml = $sce.trustAsHtml(RetailPartner.programName);
        $scope.retailPartner = RetailPartner;
        if ($scope.retailPartner) {
          $scope.retailPartner.logoUrl = Util.patchImageUrl($scope.retailPartner.logoUrl);
        }
        $scope.selectedUPC = SelectedUPC;
        if ($scope.selectUPC) {
          $scope.selectUPC.imageUrl = Util.patchImageUrl($scope.selectUPC.imageUrl);
        }
        $scope.claimOffer = function () {
          if ($scope.retailPartner.claimInWidget) {
            $state.go($scope.retailPartner.claimUrl, { txnId: $scope.retailPartnerTransaction.id }, { reload: true });
          } else {
            window.open($scope.retailPartner.claimUrl, '_blank');
          }
        };
      },
      resolve: {
        RetailPartner: function (RetailPartnerTransaction, $api) {
          return $api.getRetailPartner(RetailPartnerTransaction.retailPartnerId);
        },
      },
    });

    $stateProvider.state({
      name: 'TransactionStep',
      parent: 'TransactionBase',
      templateUrl: '/html/transaction-step.html',
      abstract: true,
    });

    $stateProvider.state({
      name: 'RetailerAuthenticate',
      parent: 'TransactionBase',
      templateUrl: '/html/retailer-authenticate.html',
      abstract: true,
      controller: function ($scope, RetailPartner, UPCSAndOffer) {
        $scope.retailPartner = RetailPartner;
        if ($scope.retailPartner) {
          $scope.retailPartner.logoUrl = Util.patchImageUrl($scope.retailPartner.logoUrl);
        }
        $scope.offer = UPCSAndOffer.offer;
      },
      resolve: {
        BaseUrl: function ($location) {
          return $location.search()['baseUrl'];
        },
      },
    });

    $stateProvider.state({
      name: 'TransactionBase',
      parent: 'CenterBox',
      url: '/transact/{txnId}/',
      templateUrl: '/html/ui-view.html',
      abstract: true,
      resolve: {
        RetailPartnerTransaction: function ($stateParams, $api) {
          return $api.getTransaction($stateParams.txnId);
        },
        UPCSAndOffer: function (RetailPartnerTransaction, $api, $stateParams) {
          return $api.getUpcsAndOffer(RetailPartnerTransaction.offerId);
        },
        RetailPartner: function (RetailPartnerTransaction, $api) {
          if (RetailPartnerTransaction.retailPartnerId) {
            return $api.getRetailPartner(RetailPartnerTransaction.retailPartnerId);
          }
        },
        UpdateColor: function ($dynamicColors, UPCSAndOffer) {
          $dynamicColors.insert(UPCSAndOffer);
        },
        SelectedUPC: function (RetailPartnerTransaction, UPCSAndOffer) {
          if (!RetailPartnerTransaction.UPC) {
            return null;
          }
          for (let i = 0; i < UPCSAndOffer.UPCs.length; i++) {
            const UPC = UPCSAndOffer.UPCs[i];
            if (UPC.UPC == RetailPartnerTransaction.UPC) {
              return UPC;
            }
          }
          return null;
        },
      },
      controller: function (
        Session,
        $scope,
        UPCSAndOffer,
        RetailPartnerTransaction,
        $sce,
        $experiment,
        RetailPartner,
        SelectedUPC,
        $state,
        $rootScope
      ) {
        $scope.offer = UPCSAndOffer.offer;
        $scope.selectedUPC = SelectedUPC;
        $scope.landingPageDescription = $sce.trustAsHtml($scope.offer.landingPageDescription);
        $scope.retailPartnerTransaction = RetailPartnerTransaction;
        $scope.session.offerId = $scope.offer.id;
        $scope.session.retailPartnerTransactionId = RetailPartnerTransaction.id;

        $scope.nextStep = function (retailPartnerTransaction, stateAnimate) {
          if (!retailPartnerTransaction.UPC) {
            stateAnimate.go('ChooseUPC');
          } else if (
            storage.session.getItem('allParameters') &&
            JSON.parse(storage.session.getItem('allParameters')).logged_in
          ) {
            RetailerShared.messageLoginSuccess($rootScope.pymChild, JSON.stringify({}));
            return;
          } else if (retailPartnerTransaction.retailPartnerId && UPCSAndOffer.offer.singleSubmit) {
            stateAnimate.go(RetailPartner.claimUrl, { txnId: retailPartnerTransaction.id }, { reload: true });
          } else {
            $experiment.get('Full Page Questions -- March 2019').then(
              function (value) {
                if (value == 'Original' && (window.location + '').indexOf('full') < 0) {
                  stateAnimate.go(
                    'LocationState',
                    {
                      txnId: retailPartnerTransaction.id,
                    },
                    {
                      reload: true,
                    }
                  );
                } else if (value == 'Full Page Vertical') {
                  stateAnimate.go(
                    'FullPageVertical',
                    {
                      txnId: retailPartnerTransaction.id,
                    },
                    {
                      reload: true,
                    }
                  );
                } else {
                  // if (value == "Full Page Horizontal")
                  stateAnimate.go(
                    'FullPageHorizontal',
                    {
                      txnId: retailPartnerTransaction.id,
                    },
                    {
                      reload: true,
                    }
                  );
                }
              },
              function (error) {
                if (!(error instanceof Error)) {
                  error = new Error(e);
                }
                throw error;
              }
            );
          }
        };

        $scope.redeemLater = function () {
          $state.go(
            'SendLinkForLaterState',
            {
              offerId: $scope.offer.id,
            },
            {
              reload: true,
            }
          );
        };
      },
    });

    $stateProvider.state({
      name: 'ChooseUPC',
      parent: 'TransactionBase',
      url: 'choose/',
      templateUrl: '/html/choose-upc.html',
      controller: function ($scope, $api, UPCSAndOffer, RetailPartnerTransaction, $state) {
        $scope.upcs = UPCSAndOffer.UPCs;
        $scope.data = {
          selectedUpc: {
            ...$scope.upcs[0],
            imageUrl: Util.patchImageUrl($scope.upcs[0].imageUrl)
          },
        };
        $scope.selectUPC = function () {
          $api
            .post('/v1/submit_upc', {
              retailPartnerTransactionId: RetailPartnerTransaction.id,
              UPC: $scope.data.selectedUpc.UPC,
            })
            .then(function (txn) {
              $scope.nextStep(txn, $state);
            });
        };
      },
    });

    $stateProvider.state({
      name: 'Home',
      parent: 'Base',
      url: '/',
      controller: function () {
        let redirectParts = window.location.hostname.split('.');
        window.location =
          'http://' + redirectParts[redirectParts.length - 2] + '.' + redirectParts[redirectParts.length - 1];
      },
    });

    $stateProvider.state({
      name: 'CenterBox',
      parent: 'ThemedBase',
      abstract: true,
      templateUrl: '/html/center-box-body.html',
      controller: function ($rootScope) {
        if (!$rootScope.inIframe) {
          document.getElementById('hero').classList.add('is-fullheight');
        }
      },
    });

    $stateProvider.state({
      name: 'Base',
      templateUrl: '/html/reset-css.html',
      abstract: true,
      resolve: {
        Session: function ($location, SessionService) {
          // reset session if ?reset is provided
          if ($location.search().reset) {
            SessionService.set({});
          }
          return SessionService.get();
        },
      },
      controller: function (
        Session,
        $scope,
        $rootScope,
        $location,
        $timeout,
        $state,
        $element,
        $experiment,
        $debounce
      ) {
        $scope.formDebounceInstances = {};
        $scope.formDebounce = function (func, waitForResolve, timeout) {
          if (!waitForResolve) {
            waitForResolve = false;
          }
          const key = [func, waitForResolve, timeout];
          if (!$scope.formDebounceInstances[key]) {
            $scope.formDebounceInstances[key] = $debounce(func, waitForResolve, timeout ? timeout : 1000);
          }
          return $scope.formDebounceInstances[key]();
        };

        $scope.session = Session;

        // if (window.gtag) {
        //   const params = {
        //     page_path: $location.path(),
        //     custom_map: {
        //       dimension1: 'clientId',
        //     },
        //   };

        //   if ($scope.session.email) {
        //     params.user_id = $scope.session.email;
        //   }
        //   gtag('config', 'UA-124656779-2', params);
        // }

        analytics.sendPageviewEvent();

        if ($rootScope.pymChild) {
          setTimeout(function () {
            $rootScope.pymChild.sendHeight();
            $rootScope.pymChild.sendMessage('page-change', window.location.pathname + '');
          }, 0);
        }
      },
      onEnter: function ($rootScope, $timeout, $state) {
        if ($rootScope.pymChild) {
          setTimeout(function () {
            $rootScope.pymChild.sendHeight();
          }, 0);
        }
      },
    });

    $stateProvider.state({
      name: 'ThemedBase',
      parent: 'Base',
      abstract: true,
      resolve: {
        BaseTemplate: function ($api, $rootScope) {
          if ($rootScope.inIframe) {
            return false;
          }
          const location = window.location + '';
          if (location.indexOf('offer/') > -1) {
            const offerId = location.split('offer/')[1].split('/')[0].split('?')[0].split('#')[0].split(';')[0];
            return $api.get('/v1/base_template?offerId=' + offerId).then(function (result) {
              return result.baseTemplate;
            });
          } else if (location.indexOf('transact/') > -1) {
            const txnId = location.split('transact/')[1].split('/')[0];
            return $api.get('/v1/base_template?txnId=' + txnId).then(function (result) {
              return result.baseTemplate;
            });
          } else {
            return false;
          }
        },
      },
      templateProvider: function (BaseTemplate, $http, $config) {
        if ($config.env == 'development') {
          const url = new URL(window.location.href);
          const baseTemplate = url.searchParams.get('base_template');
          if (baseTemplate) {
            BaseTemplate = baseTemplate;
          }
        }
        if (!BaseTemplate) {
          BaseTemplate = '/html/base-templates/generic-base.html';
        }

        return $http.get(BaseTemplate + '?rev=' + $config['revision']).then(function (data) {
          return data.data;
        });
      },
    });

    $stateProvider.state({
      name: 'OfferViolation',
      parent: 'CenterBox',
      templateUrl: '/html/offer_violation.html',
    });

    $stateProvider.state({
      name: '404',
      url: '/404?message',
      parent: 'CenterBox',
      templateUrl: '/html/404.html',
      controller: function ($stateParams, $scope, UPCAndVendor) {
        if (UPCAndVendor && UPCAndVendor.vendor) {
          $scope.header = 'Welcome to ' + UPCAndVendor.vendor.name;
        } else {
          $scope.header = 'Not found';
        }

        $scope.message = $stateParams.message;
      },
      resolve: {
        UPCAndVendor: function ($api) {
          let lastHalf = window.location.pathname.split('?')[0];
          if (lastHalf.length > 0 && lastHalf.startsWith('/')) {
            lastHalf = lastHalf.substring(1);
          }
          if (lastHalf.endsWith('/')) {
            lastHalf = lastHalf.substring(0, lastHalf.length - 1);
          }
          if (!isNaN(lastHalf)) {
            return $api.getUpcsAndVendor(lastHalf);
          }

          return false;
        },
      },
    });

    $stateProvider.state({
      name: '500',
      parent: 'CenterBox',
      templateUrl: '/html/500.html',
    });

    $stateProvider.state({
      name: 'Unsubscribe',
      parent: 'CenterBox',
      templateUrl: '/html/unsubscribe.html',
      url: '/unsubscribe',
    });
  });

  app.service('isMobile', function () {
    return function () {
      let check = false;
      const params = parseUri(window.location.href).queryKey;
      if (params['m'] || params['mobile']) {
        check = true;
      }

      (function (a) {
        // eslint-disable-next-line max-len
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          // eslint-disable-next-line max-len
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        ) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };
  });


  app.service('isMobile', function () {
    return function () {
      let check = false;
      const params = parseUri(window.location.href).queryKey;
      if (params['m'] || params['mobile']) {
        check = true;
      }

      (function (a) {
        // eslint-disable-next-line max-len
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            // eslint-disable-next-line max-len
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        ) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };
  });

  app.controller(
    'FullPageTransactionCtrl',
    function (
      $locationService,
      $nameService,
      $scope,
      IpLocationData,
      $q,
      $api,
      $state,
      $emailService,
      $rootScope,
      $timeout,
      UPCSAndOffer,
      RetailPartner,
      SelectedUPC
    ) {
      $scope.singlePage = true;
      $scope.selectedUPC = SelectedUPC;
      if ($scope.selectedUPC) {
        $scope.selectedUPC.imageUrl = Util.patchImageUrl($scope.selectedUPC.imageUrl);
      }
      $scope.offer = UPCSAndOffer.offer;
      if ($scope.offer) {
        $scope.offer.imageUrl = Util.patchImageUrl($scope.offer.imageUrl);
      }
      $scope.retailPartner = RetailPartner;
      if ($scope.retailPartner) {
        $scope.retailPartner.logoUrl = Util.patchImageUrl($scope.retailPartner.logoUrl);
      }
      $locationService.initializeScope($scope, IpLocationData);
      $nameService.initializeScope($scope);
      $emailService.initializeScope($scope);

      $scope.submit = function () {
        const deferred = $q.defer();
        $scope.prepareLocation().then(function () {
          $scope.session.rawPhone = ($scope.session.phone || '').replace(/\D/g, '');
          if (!$scope.session.name) {
            $scope.nameError = 'Please provide your name.';
            deferred.reject('Please provide your name.');
          } else if (!$scope.validateEmail($scope.session.email)) {
            $scope.emailError = 'Please provide a valid email.';
            deferred.reject('Please provide a valid email.');
          } else if (!$scope.session.phone && $scope.offer.requireVerification) {
            $scope.phoneError = 'Please provide a valid cell phone number.';
            deferred.reject('Please provide a valid cell phone number.');
          } else {
            $api.post('/v1/submit_all_transaction_data', $scope.session).then(
              function (txn) {
                if ($scope.offer.requireVerification) {
                  $state.go(
                    'VerifyPhoneState',
                    {
                      txnId: txn.id,
                    },
                    {
                      reload: true,
                    }
                  );
                } else {
                  $state.go('SuccessState', { txnId: txn.id }, { reload: true });
                }
                deferred.resolve(txn);
              },
              function (failResponse) {
                alert(failResponse.error);
                deferred.reject(failResponse);
              }
            );
          }
        });
        return deferred.promise;
      };

      $scope.parentSubmitFacebookAndTransition = function () {
        $scope.submitLocation().then($scope.submitFacebookAndTransition);
      };

      $scope.parentSubmitGoogleAndTransition = function () {
        $scope.submitLocation().then($scope.submitGoogleAndTransition);
      };

      $scope.action = $scope.submit;
      if ($rootScope.pymChild) {
        setTimeout(function () {
          $rootScope.pymChild.sendHeight();
        }, 100);
      }
    }
  );

  app.controller(
    'NewTransactionSplashCtrl',
    function (
      $scope,
      isMobile,
      RetailPartnerTransaction,
      UPCSAndOffer,
      $api,
      $rootScope,
      RetailPartner,
      $state,
      $timeout,
      $experiment
    ) {
      // TODO: Handle retailer-less txn start.

      $scope.retailPartner = RetailPartner;
      if ($scope.retailPartner) {
        $scope.retailPartner = Util.patchImageUrl($scope.retailPartner.logoUrl);
      }
      $scope.offer = UPCSAndOffer?.offer;
      if ($scope.offer) {
        $scope.offer.imageUrl = Util.patchImageUrl($scope.offer.imageUrl);
      }
      $scope.txn = RetailPartnerTransaction;
      $scope.startTransaction = function () {
        $scope.nextStep(RetailPartnerTransaction, $state);
      };

      if (navigator.share && storage.session.getItem('parentUrl') && isMobile()) {
        $scope.share = function () {
          navigator
            .share({
              title: 'A Great Deal from ' + $scope.retailPartner.name,
              text: 'Get ' + $scope.offer.name + '!',
              url: storage.session.getItem('parentUrl') + '&ref=share',
            })
            .then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing:', error));
        };
      }

      // Hack: since we can get here from a non-reload, we need to manually send the height updates
      if ($rootScope.pymChild) {
        setTimeout(function () {
          $rootScope.pymChild.sendHeight();
        }, 0);
      }
    }
  );

  app.controller(
    'SendLinkForLaterCtrl',
    function ($scope, $api, $state, $rootScope, $timeout, UPCSAndOffer, $stateParams) {
      if ($stateParams.parentUrl) {
        storage.session.setItem('parentUrl', $stateParams.parentUrl);
      }
      $scope.offer = UPCSAndOffer.offer;
      if ($scope.offer) {
        $scope.offer.imageUrl = Util.patchImageUrl($scope.offer.imageUrl);
      }
      let url = storage.session.getItem('parentUrl');
      if (!url) {
        url = Config.API_URL + '/v1/click?pear_offer_id=' + $scope.offer.id;
      }
      $scope.submitPhone = function () {
        const phone = ($scope.phone || '').replace(/\D/g, '');
        if (!phone) {
          $scope.phoneError = 'Please provide a valid cell phone number.';
        } else {
          $scope.phoneError = false;
          $scope.phoneSuccess = false;
          $scope.emailError = false;
          $scope.emailSuccess = false;
          document.getElementById('textLink').innerHTML =
            "<img style='height:40px' class='spinner' src='/img/spinner.gif'/>";
          $api
            .post('/v1/send_link_for_later', {
              phone: phone,
              url: url,
              offerId: $scope.offer.id,
            })
            .then(
              function (txn) {
                document.getElementById('textLink').innerHTML = 'Text Link';
                if (txn.error) {
                  $scope.phoneError = 'Please provide a valid 10 digit cell phone number.';
                  return;
                } else {
                  $scope.phoneSuccess = true;
                  if ($rootScope.inIframe) {
                    analytics.sendLeadEvent(null, true);
                  }
                }
              },
              function (failResponse) {
                $scope.phoneError = 'Please provide a valid cell phone number.';
              }
            );
        }
      };

      $scope.submitEmail = function () {
        const email = $scope.email;
        if (!email) {
          $scope.emailError = 'Please provide a valid email address.';
        } else {
          $scope.phoneError = false;
          $scope.phoneSuccess = false;
          $scope.emailError = false;
          $scope.emailSuccess = false;
          document.getElementById('emailLink').innerHTML =
            "<img style='height:40px' class='spinner' src='/img/spinner.gif'/>";
          $api
            .post('/v1/send_link_for_later', {
              email: email,
              url: url,
              offerId: $scope.offer.id,
            })
            .then(
              function (txn) {
                document.getElementById('emailLink').innerHTML = 'Email Link';
                if (txn.error) {
                  $scope.emailError = 'Please provide a valid email address.';
                  return;
                } else {
                  $scope.emailSuccess = true;
                  if ($rootScope.inIframe) {
                    analytics.sendLeadEvent(true, null);
                  }
                }
              },
              function (failResponse) {
                $scope.emailError = 'Please provide a valid email address.';
              }
            );
        }
      };

      $scope.goBack = function () {
        $state.go('Offer', { offerId: $scope.offer.id }, { reload: true });
      };

      if ($rootScope.pymChild) {
        setTimeout(function () {
          $rootScope.pymChild.sendHeight();
        }, 0);
        // Iphone Bug fix?
        setTimeout(function () {
          $rootScope.pymChild.sendHeight();
        }, 500);
      }
    }
  );

  app.controller('OfferMockupController', function ($scope, UPCSAndOffer) {
    $scope.offer = UPCSAndOffer.offer;
    if ($scope.offer) {
      $scope.offer.imageUrl = Util.patchImageUrl($scope.offer.imageUrl);
    }
  });

  // eslint-disable-next-line  max-len
  app.controller(
    'LocationCtrl',
    function (
      $scope,
      $http,
      $sce,
      $location,
      $state,
      IpLocationData,
      UPCSAndOffer,
      $api,
      $stateParams,
      isMobile,
      $q,
      $rootScope,
      $timeout,
      $locationService
    ) {
      $locationService.initializeScope($scope, IpLocationData);
      // Hack: since we can get here from a non-reload, we need to manually send the height updates
      if ($rootScope.pymChild) {
        setTimeout(function () {
          $rootScope.pymChild.sendHeight();
        }, 0);
      }
    }
  );

  app.controller('ConsumerNameController', function ($scope, $nameService) {
    $nameService.initializeScope($scope);
  });

  app.controller('ConsumerEmailController', function ($scope, $state, $api, $q, $emailService, UPCSAndOffer) {
    $scope.offer = UPCSAndOffer.offer;
    $emailService.initializeScope($scope);
  });

  app.controller('ConsumerPhoneController', function ($scope, $state, $api, $q) {
    $scope.submitPhone = function () {
      const deferred = $q.defer();
      if (!$scope.session.phone) {
        $scope.phoneError = 'Please provide a valid cell phone number.';
        deferred.reject('Please provide a valid cell phone number.');
      } else {
        $scope.session.rawPhone = ($scope.session.phone || '').replace(/\D/g, '');
        $api
          .post('/v1/submit_phone', {
            rawPhone: $scope.session.rawPhone,
            retailPartnerTransactionId: $scope.session.retailPartnerTransactionId,
          })
          .then(
            function (txn) {
              if (txn.error) {
                $scope.phoneError = 'Please provide a valid cell phone number.';
                deferred.reject('Please provide a valid cell phone number.');
                return;
              }
              if (!txn.violation) {
                deferred.resolve(txn);
              } else {
                $state.go('OfferViolation', null, {
                  location: false,
                });
                deferred.reject('OfferViolation');
              }
            },
            function (failResponse) {
              $scope.phoneError = 'Please provide a valid cell phone number.';
              deferred.reject('Please provide a valid cell phone number.');
            }
          );
      }
      return deferred.promise;
    };

    $scope.submitPhoneAndTransition = function () {
      $scope.submitPhone().then(function (txn) {
        $state.go(
          'VerifyPhoneState',
          {
            txnId: txn.id,
          },
          {
            reload: true,
          }
        );
      });
    };

    if ($scope.singlePage) {
      $scope.$parent.submitPhone = $scope.submitPhone;
      $scope.action = $scope.submit;
    } else {
      $scope.action = $scope.submitPhoneAndTransition;
    }

    telephone.applyMaskToAllInputsOfTypeTel();
  });

  app.controller('VerifyPhoneController', function ($scope, $state, Verification, $api) {
    $scope.code = { code: '' };
    $scope.verification = Verification;

    $scope.submitCode = function () {
      $api
        .post('/v1/verify', {
          code: $scope.code.code,
          verification: $scope.verification.id,
        })
        .then(function (verification) {
          if (!verification.verified) {
            $scope.verifyError = 'The code you entered was incorrect.';
          } else {
            $state.go(
              'SuccessState',
              {
                txnId: verification.retailPartnerTransactionId,
              },
              {
                reload: true,
              }
            );
          }
        });
    };
  });

  app.service('$locationService', function ($api, $q, isMobile, $state) {
    const html5GeolocateAndGeocodePromise = function () {
      return $q(function (resolve, reject) {
        getCurrentLocation(STADIA_MAPS_CONFIG) 
          .then(locationData => {
            resolve({
              city: locationData.city,
              state: locationData.state,
              country: locationData.country,
              latitude: locationData.latitude,
              longitude: locationData.longitude
            });
          })
          .catch(error => {
            reject(error);
          });
      });
    };


    const $locationService = {
      initializeScope: function (scope, IpLocationData) {
        scope.types = ['(cities)'];
        scope.locateMe = function () {
          scope.findMeSpinner = '/img/spinner.gif';
          html5GeolocateAndGeocodePromise().then(
            function (parsed) {
              scope.session.location = parsed.city + ', ' + parsed.state + ', ' + parsed.country;
              scope.session.coordinatesLocation = scope.session.location;
              scope.session.latitude = parsed.latitude;
              scope.session.longitude = parsed.longitude;
              scope.findMeSpinner = null;
            },
            function (error) {
              scope.geolocationError = 'Geolocation Failed';
              scope.findMeSpinner = null;
            }
          );
        };

        scope.prepareLocation = function () {
          const deferred = $q.defer();
          if (scope.session.location != scope.session.coordinatesLocation) {
            getLocationFromText(STADIA_MAPS_CONFIG, scope.session.location)
              .then(result => {
                scope.$apply(function () {
                  scope.session.location = result.city + ', ' + result.state + ', USA';
                  scope.session.coordinatesLocation = result.city + ', ' + result.state + ', USA';
                  scope.session.latitude = result.latitude;
                  scope.session.longitude = result.longitude;
                });
                deferred.resolve();
              })
              .catch(error => {
                scope.$apply(function () {
                  deferred.reject('We could not locate your city.');
                  scope.geolocationError = 'We could not locate your city.';
                });
                deferred.reject();
              });
          } else {
            deferred.resolve();
          }
          return deferred.promise;
        };

        const submitData = function () {
          const deferred = $q.defer();
          $api
            .post('/v1/submit_location', {
              retailPartnerTransactionId: scope.session.retailPartnerTransactionId,
              coordinatesLocation: scope.session.coordinatesLocation,
              ip: scope.session.ip,
              latitude: scope.session.latitude,
              longitude: scope.session.longitude,
              location: scope.session.location,
              offerId: scope.session.offerId,
            })
            .then(
              function (txn) {
                deferred.resolve(txn);
              },
              function (failResponse) {
                deferred.reject(failResponse);
              }
            );
          return deferred.promise;
        };

        scope.submitLocation = function () {
          return scope.prepareLocation().then(submitData);
        };

        scope.submitLocationAndTransition = function () {
          return scope.submitLocation().then(
            function (txn) {
              $state.go(
                'ConsumerNameState',
                {
                  txnId: txn.id,
                },
                {
                  reload: true,
                }
              );
            },
            function (failResponse) {
              console.log(failResponse);
            }
          );
        };
        if (scope.singlePage) {
          scope.$parent.submitLocation = scope.submitLocation;
          scope.action = scope.submit;
        } else {
          scope.action = scope.submitLocationAndTransition;
        }

        let shouldTriggerLocateMe = false;
        // Prefer URL params first; if none present, try HTML5 geolocation on initial load
        const params = ($state && $state.params) || {};
        const hasUrlLocation = !!(params.zip || params.address || (params.latitude && params.longitude));
        if (!hasUrlLocation) {
          shouldTriggerLocateMe = true;
        }

        // Seed session from IP-based data if available and session is empty
        if (!scope.session.location && IpLocationData && IpLocationData.city) {
          scope.session.location = IpLocationData.city + ', ' + IpLocationData.region_code + ', USA';
          scope.session.coordinatesLocation = IpLocationData.city + ', ' + IpLocationData.region_code + ', USA';
          scope.session.countryCode = IpLocationData.countryCode;

          scope.session.latitude = IpLocationData.latitude;
          scope.session.longitude = IpLocationData.longitude;
        }

        if (shouldTriggerLocateMe) {
          scope.locateMe();
        }

        scope.geolocationError = null;
        scope.$watch('session.location', function (newVal) {
          if (newVal) {
            scope.geolocationError = null;
          }
        });
      },
    };

    return $locationService;
  });

  app.service('$nameService', function ($api, $state, $q) {
    return {
      initializeScope: function (scope) {
        scope.submitFacebook = function () {
          const deferred = $q.defer();
          FB.login(
            function (response) {
              if (response.authResponse) {
                const authResponse = response.authResponse;
                FB.api('/me?fields=name,email', function (response) {
                  scope.$apply(function () {
                    $api
                      .post('/v1/submit_offer_facebook', {
                        facebookToken: authResponse.accessToken,
                        retailPartnerTransactionId: scope.session.retailPartnerTransactionId,
                      })
                      .then(function (txn) {
                        if (!txn.violation) {
                          deferred.resolve(txn);
                        } else {
                          $state.go('OfferViolation', null, {
                            location: false,
                          });
                          deferred.reject('OfferViolation');
                        }
                      });
                  });
                });
              } else {
                console.log('User cancelled login or did not fully authorize.');
                deferred.reject('User cancelled login or did not fully authorize.');
              }
            },
            {
              scope: 'email',
            }
          );
          return deferred.promise;
        };

        scope.submitFacebookAndTransition = function () {
          scope.submitFacebook().then(function (txn) {
            $state.go(
              'SuccessState',
              {
                txnId: txn.id,
              },
              {
                reload: true,
              }
            );
          });
        };
        scope.$parent.submitFacebookAndTransition = scope.submitFacebookAndTransition;

        scope.submitGoogle = function () {
          const deferred = $q.defer();
          const auth2 = gapi.auth2.getAuthInstance();
          auth2
            .signIn({
              scope: 'profile email',
            })
            .then(function (googleUser) {
              const token = googleUser.getAuthResponse().id_token;
              scope.$apply(function () {
                $api
                  .post('/v1/submit_offer_google', {
                    googleToken: token,
                    retailPartnerTransactionId: scope.session.retailPartnerTransactionId,
                  })
                  .then(function (txn) {
                    if (!txn.violation) {
                      deferred.resolve(txn);
                    } else {
                      deferred.reject('OfferViolation');
                      $state.go('OfferViolation', null, {
                        location: false,
                      });
                    }
                  });
              });
            });
          return deferred.promise;
        };

        scope.submitGoogleAndTransition = function () {
          scope.submitGoogle().then(function (txn) {
            $state.go(
              'SuccessState',
              {
                txnId: txn.id,
              },
              {
                reload: true,
              }
            );
          });
        };

        scope.$parent.submitGoogleAndTransition = scope.submitGoogleAndTransition;

        scope.submitName = function () {
          const deferred = $q.defer();
          if (!scope.session.name) {
            scope.nameError = 'Please provide your name.';
            deferred.reject('Please provide your name.');
          } else {
            $api
              .post('/v1/submit_name', {
                name: scope.session.name,
                retailPartnerTransactionId: scope.session.retailPartnerTransactionId,
              })
              .then(
                function (txn) {
                  deferred.resolve(txn);
                },
                function (failResponse) {
                  console.log(failResponse);
                  deferred.reject(failResponse);
                }
              );
          }

          return deferred.promise;
        };

        scope.submitNameAndTransition = function () {
          scope.submitName().then(function (txn) {
            $state.go(
              'ConsumerEmailState',
              {
                txnId: txn.id,
              },
              {
                reload: true,
              }
            );
          });
        };

        if (scope.singlePage) {
          scope.$parent.submitName = scope.submitName;
          scope.action = scope.submit;
          scope.facebookAction = scope.$parent.parentSubmitFacebookAndTransition;
          scope.googleAction = scope.$parent.parentSubmitGoogleAndTransition;
        } else {
          scope.action = scope.submitNameAndTransition;
          scope.facebookAction = scope.submitFacebookAndTransition;
          scope.googleAction = scope.submitGoogleAndTransition;
        }
      },
    };
  });

  app.service('$emailService', function ($api, $state, $q) {
    return {
      initializeScope: function (scope) {
        const validateEmail = (scope.validateEmail = function (email) {
          if (!email) {
            return false;
          }
          const re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(email.toLowerCase());
        });

        scope.submitEmail = function () {
          const deferred = $q.defer();
          if (!validateEmail(scope.session.email)) {
            scope.emailError = 'Please provide a valid email.';
            deferred.reject('Please provide a valid email.');
          } else {
            $api
              .post('/v1/submit_email', {
                email: scope.session.email,
                retailPartnerTransactionId: scope.session.retailPartnerTransactionId,
              })
              .then(
                function (txn) {
                  if (!txn.violation) {
                    // if (gtag) {
                    //   gtag('set', { dimension3: scope.session.email });
                    // }
                    deferred.resolve(txn);
                  } else {
                    deferred.reject('OfferViolation');
                    $state.go('OfferViolation', null, {
                      location: false,
                    });
                  }
                },
                function (failResponse) {
                  console.log(failResponse);
                }
              );
          }
          return deferred.promise;
        };

        scope.submitEmailAndTransition = function (txn) {
          scope.submitEmail().then(function (txn) {
            if (scope.offer.requireVerification) {
              $state.go(
                'ConsumerPhoneState',
                {
                  txnId: txn.id,
                },
                {
                  reload: true,
                }
              );
            } else {
              $state.go(
                'SuccessState',
                {
                  txnId: txn.id,
                },
                {
                  reload: true,
                }
              );
            }
          });
        };
        if (scope.singlePage) {
          scope.$parent.submitEmail = scope.submitLocation;
          scope.action = scope.submit;
        } else {
          scope.action = scope.submitEmailAndTransition;
        }
      },
    };
  });

  app.service('$dynamicColors', function () {
    let ctaColor = null;
    return {
      insert: function (UPCSAndOffer) {
        if (ctaColor !== UPCSAndOffer.offer.ctaColor) {
          ctaColor = UPCSAndOffer.offer.ctaColor;

          const style = document.createElement('style');
          // WebKit hack :(
          style.appendChild(document.createTextNode(''));
          document.head.appendChild(style);
          const sheet = style.sheet;

          const darkTextColor = getComputedStyle(document.head).getPropertyValue('--content-text-color');
          const colorInt = parseInt(ctaColor.substring(1), 16);
          const red = colorInt >> 16;
          const green = (colorInt & 65280) >> 8;
          const blue = colorInt & 255;
          const brightness = red * 0.299 + green * 0.587 + blue * 0.114;

          const inputTextColor = brightness > 160 ? darkTextColor : ctaColor;
          sheet.insertRule('form input { color: ' + inputTextColor + '; }', sheet.cssRules.length);

          const ctaTextColor = brightness > 160 ? darkTextColor : '#FFF';
          sheet.insertRule(
            `
              input[type=submit].dynamic-color, button[type=submit].dynamic-color, button.submit.dynamic-color {
                  background-color: ${ctaColor} !important;
                  color: ${ctaTextColor} !important; 
              }`,
            sheet.cssRules.length
          );

          const textColor = UPCSAndOffer.offer.textColor || darkTextColor;
          // also add generic color rule that anyone can use
          sheet.insertRule(`.offer-color { color: ${textColor} !important; }`, sheet.cssRules.length);

          const rgbToHexStr = function (r, g, b) {
            return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
          };

          const lighterCta = rgbToHexStr(Math.min(255, red + 10), Math.min(255, green + 10), Math.min(255, blue + 10));
          sheet.insertRule(
            'input[type=submit].dynamic-color:hover, button[type=submit].dynamic-color:hover, button.submit.dynamic-color:hover { background-color: ' +
              lighterCta +
              ' !important; }',
            sheet.cssRules.length
          );
        }
      },
    };
  });

  app.config(function ($stateProvider, $locationProvider, $urlRouterProvider, $provide, $httpProvider) {
    $httpProvider.defaults.transformResponse.unshift((data, headers) => {
      if (headers && headers('x-pear-lz-encoded')) {
        data = lzString.decompressFromUTF16(data);
      }

      return data;
    });

    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false,
    });

    $urlRouterProvider.otherwise(function ($injector) {
      const state = $injector.get('$state');
      if (state) {
        state.go('404', null, {
          location: false,
        });
      }
    });
  });

  app.config(function ($httpProvider, $qProvider) {
    $httpProvider.interceptors.push(function ($q, $rootScope) {
      const endLoading = function (response) {
        if (!response.config || !response.config.suppressLoadingIndicator) {
          $rootScope.$broadcast('loading-complete', 'http');
        }
        return response || $q.when(response);
      };
      return {
        request: function (config) {
          if (!config || !config.suppressLoadingIndicator) {
            $rootScope.$broadcast('loading-started', 'http');
          }
          return config || $q.when(config);
        },
        response: endLoading,
        responseError: endLoading,
        requestError: endLoading,
      };
    });

    $qProvider.errorOnUnhandledRejections(false);
  });

  // app.config(['$compileProvider', function ($compileProvider) {
  //   $compileProvider.directive('img', function () {
  //     return {
  //       restrict: 'E',
  //       link: function (scope, element, attrs) {
  //         /* This is just adding an attribute not directive, we will find a solution
  //         But we need to decide if we want to apply this directive to all images by default. */
  //         element.attr('cf-image', '');
  //       }
  //     };
  //   });
  // }])

  // This is directive to load cloudfront images for image optimization
  app.directive('cfImage', [
    '$window',
    function ($window) {
      return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
          let defaultWidth = Math.round($window.innerWidth * 0.6);

          let width = defaultWidth > 320 ? defaultWidth : 320;
          let quality = 75;
          let format = 'webp';

          if (attrs.cfImageWidth) {
            width = attrs.cfImageWidth;
          }
          if (attrs.cfImageQuality) {
            quality = attrs.cfImageQuality;
          }
          if (attrs.cfImageFormat) {
            format = attrs.cfImageFormat;
          }

          let pathName = '';
          let oldSrc = attrs.ngSrc || attrs.src || '';
          
          try {
            pathName = new URL(oldSrc).pathname;

            if (pathName && (pathName.startsWith('/assets.pearcommerce.com') || pathName.startsWith('/demos.pearcommerce.com'))) {
              pathName = pathName.replace('/assets.pearcommerce.com', '').replace('/demos.pearcommerce.com', '');
            }
          } catch (error) {
            console.debug('Error when getting url', error);
          }

          if (
            oldSrc.includes('demos.pearcommerce.com') ||
            oldSrc.includes('demos-cf-1.pearcommerce.com') ||
            oldSrc.includes('assets.pearcommerce.com') ||
            oldSrc.includes('assets-cf.pearcommerce.com') ||
            oldSrc.includes('d1jp0lglzqw86v.cloudfront.net')
          ) {
            let newSrc = `https://image-processor.pearcommerce.com${pathName}?width=${width}&quality=${quality}&format=${format}`;

            // TODO - Need to remove setTimeout
            if (attrs.ngSrc) {
              setTimeout(() => {
                attrs.$set('ngSrc', newSrc);
              }, 1);
            } else {
              setTimeout(() => {
                attrs.$set('src', newSrc);
              }, 1);
            }
          }
        },
      };
    },
  ]);

  app.directive('hideOnError', function () {
    return {
      link: function (scope, element, attrs) {
        if (!attrs['src'] && !attrs['ngSrc']) {
          element[0].style.display = 'none';
        }
        element[0].addEventListener('error', function () {
          element[0].style.display = 'none';
        });
      },
    };
  });

  let cleanupCookies = function (cookiePolicy) {
    try {
      if (!cookiePolicy.analytics) {
        localStorage.removeItem('pear-session');
        localStorage.removeItem('session');
        Util.deleteCookie('pear-session', '/', '.pearcommerce.com');
        Util.deleteCookie('pear-session', '/', 'offers.pearcommerce.com');
      }

      if (!cookiePolicy.functional) {
        localStorage.removeItem('ip_location_v5');
        let zipLocations = [];
        Object.keys(localStorage).forEach(function (key) {
          if (key.startsWith('zip_location_')) {
            zipLocations.push(key);
          }
        });
        for (let i = 0; i < zipLocations.length; i++) {
          localStorage.removeItem(zipLocations[i]);
        }
      }

      if (!cookiePolicy.targeting) {
        Util.deleteCookie('_fbp', '/', 'pearcommerce.com');
        Util.deleteCookie('_fbc', '/', 'pearcommerce.com');
        Util.deleteCookie('_derived_epik', '/', 'offers.pearcommerce.com');
        Util.deleteCookie('_ttp', '/', 'pearcommerce.com');
      }
    } catch (e) {}
  };
  app.run(function (SessionService, $rootScope, $state, $location, $timeout, $document, $debounce, $api) {
    let cookieManager = '';
    let cookiePolicyName = '';
    // Molson offers
    for (let i = 0; i < molsonOfferIds.length; i++) {
      if (window.location.href.indexOf(molsonOfferIds[i]) > -1) {
        cookieManager = 'trustarc';
        cookiePolicyName = 'molsoncoors';
        break;
      }
    }

    // New Belgium offers
    if (newBelgiumLandingPageOfferIds.some(item => window.location.href.indexOf(item) > -1)) {
      cookieManager = 'onetrust';
      cookiePolicyName = 'allow-all';
    }

    let cookiePolicy;
    if (Util.getUrlVars()['cookiePolicy']) {
      cookiePolicy = JSON.parse(decodeURIComponent(Util.getUrlVars()['cookiePolicy']));
    } else if (Util.getCookiePolicy(cookieManager, cookiePolicyName)) {
      cookiePolicy = Util.getCookiePolicy(cookieManager, cookiePolicyName);
    } else if (storage.local.getItem('pear-privacy-v2')) {
      //TODO: make this offer specific, but we dont get offer ids this low in the stack, so screw it.  -EM
      cookiePolicy = JSON.parse(storage.local.getItem('pear-privacy-v2'));
    } else {
      cookiePolicy = {
        analytics: true,
        functional: true,
        targeting: true,
      };
    }

    $rootScope.cookiePolicy = cookiePolicy;
    storage.local.setItem('pear-privacy-v2', JSON.stringify(cookiePolicy));
    cleanupCookies(cookiePolicy);

    if (window.pearPageLoad && Util.getCookiePreferences().analytics && window.pearPageLoad.sessionId) {
      storage.local.setItem('pear-session', window.pearPageLoad.sessionId);
    }
    SessionService.init();
    $rootScope.admin = window.admin;
    $rootScope.hideDebug = false;

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      console.error(error);
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, error) {
      setTimeout(() => {
        $api.post('/v1/client_request_log?timeout=2000', {
          url: window.location.href,
          toState: toState.name,
          fromState: fromState.name,
        });
      }, 2500);
    });

    const inIframe = function () {
      try {
        const url = new URL(window.location.href);
        if (url.searchParams.get('in_iframe')) {
          return true;
        }
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };

    // Register with pym as a child
    if (window.pym && inIframe()) {
      $rootScope.pymChild = new window.pym.Child({ polling: 50 });
      $document[0].body.className = 'in-iframe';
      $rootScope.inIframe = true;

      const setIframeHeightToInnerContentHeight = (...args) => {
        if (window.location.href.indexOf('/picker') == -1) {
          const contentElem = $document[0].getElementsByClassName('pear-app-content');
          if (contentElem && contentElem.offsetHeight !== 0) {
            $document[0].body.setAttribute('style', `height: ${contentElem.offsetHeight}px !important;`);
            $rootScope.pymChild.sendMessage('state-change', contentElem.offsetHeight);
          }
        }
      };

      const observer = new MutationObserver(setIframeHeightToInnerContentHeight);
      observer.observe($document[0].body, { childList: true });

      $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        $rootScope.current = toState;
        if (toState.name.toLowerCase().indexOf('signup') >= 0) {
          $rootScope.loginType = 'signup';
        } else if (toState.name.toLowerCase().indexOf('login') >= 0) {
          $rootScope.loginType = 'login';
        } else {
          $rootScope.loginType = null;
        }
      });

      $rootScope.$on('$stateChangeSuccess', setIframeHeightToInnerContentHeight, false, 1);

      $rootScope.$on('$viewContentLoading', setIframeHeightToInnerContentHeight, false, 1);

      $rootScope.pymChild.onMessage('state-change-resize-complete', (...args) => {
        $document[0].body.setAttribute('style', '');
        $rootScope.pymChild.sendHeight();
      });

      $rootScope.pymChild.onMessage('cookie-policy', function (cookiePolicyStr) {
        let cookiePolicy = JSON.parse(cookiePolicyStr);
        let needsRefresh = !cookiePolicy.targeting && $rootScope.cookiePolicy.targeting;
        $rootScope.cookiePolicy = cookiePolicy;
        cleanupCookies(cookiePolicy);
        if (needsRefresh) {
          let newUrl = window.location.pathname + '?';
          Object.keys(Util.getUrlVars()).forEach(function (key) {
            if (key != 'cookiePolicy') {
              newUrl += key + '=' + Util.getUrlVars()[key] + '&';
            }
            newUrl += 'cookiePolicy=' + encodeURIComponent(JSON.stringify(cookiePolicy));
            window.location = newUrl;
          });
        }
      });
    } else {
      Util.syncCookieManager(cookieManager, cookiePolicyName);
      $rootScope.inIframe = false;
    }

    const userAgent = navigator.userAgent + '';
    if (userAgent.indexOf('Headless') < 0 && !storage.local.getItem('admin')) {
      let referrer = document.referrer;
      if (referrer && referrer.indexOf('http') == 0) {
        referrer = new URL(referrer).hostname;
      }

      // Dangerous to make it so any domain can iframe us and read dom, so we only do this when we're 100% confident its a pear domain.
      const whitelistIframes = ['grocerkeystaging.com', 'shopwoodmans.com'];
      const iframeMode = $rootScope.inIframe && whitelistIframes.indexOf(referrer) > -1;

      if (Config.INSTALL_FS) {
        window['_fs_debug'] = false;
        window['_fs_run_in_iframe'] = iframeMode;
        window['_fs_is_outer_script'] = !iframeMode;
        window['_fs_host'] = 'fullstory.com';
        window['_fs_org'] = 'J4CH7';
        window['_fs_namespace'] = 'pear-FS';
        (function (m, n, e, t, l, o, g, y) {
          if (e in m) {
            if (m.console && m.console.log) {
              m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            }
            return;
          }
          g = m[e] = function (a, b, s) {
            g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
          };
          g.q = [];

          // eslint-disable-next-line camelcase
          try {
            o = n.createElement(t);
            o.async = 1;
            o.src = 'https://' + _fs_host + '/s/fs.js';
            y = n.getElementsByTagName(t)[0];
            y.parentNode.insertBefore(o, y);
          } catch (error) {
            console.log(error);
          }
          g.identify = function (i, v, s) {
            g(l, { uid: i }, s);
            if (v) g(l, v, s);
          };
          g.setUserVars = function (v, s) {
            g(l, v, s);
          };
          g.event = function (i, v, s) {
            g('event', { n: i, p: v }, s);
          };
          g.shutdown = function () {
            g('rec', !1);
          };
          g.restart = function () {
            g('rec', !0);
          };
          g.consent = function (a) {
            g('consent', !arguments.length || a);
          };
          g.identifyAccount = function (i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
          };
          g.clearUserCookie = function () {};
        })(window, document, window['_fs_namespace'], 'script', 'user');
      }
    }

    const addStyles = function () {
      let element = document.getElementById('hero');
      if (!element) {
        setTimeout(addStyles, 100);
      } else {
        while (element) {
          if (element.className.split(' ').indexOf('pear_auto_height') < 0) {
            element.className += ' pear_auto_height';
          }
          element = element.parentElement;
        }
      }
    };
    addStyles();

    $rootScope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
      addStyles();
    });
  });

  window.includeLocationHeaders = false;

  app.service('$api', function ($http, $rootScope, $config, $state, $async) {
    const $api = {};

    let defaultErrorHandler = function (response) {
      let error = (response.data && response.data.error) || 'An unexpected error has occurred.';
      if (typeof error === 'object' && !Array.isArray(error) && error !== null) {
        try {
          error = JSON.stringify(error);
        } catch (e2) {
          // ignore errors here
        }
      }

      console.error(new Error(error));
      if (response.status == 401) {
        try {
          logout($api, $state);
        } catch (e2) {
          console.error(e2);
        }
      }
    };
    let totalTimeouts = 0;
    let totalRequests = 0;
    // simple promise wrapper to insert API_URL and pull data out

    const getFallbackJson = async function (url) {
      let path = url.split('v1/')[1].split('?')[0];
      let params = {};
      if (url.indexOf('?') > -1) {
        const urlParams = new URLSearchParams(url.split('?')[1]);
        params = Object.fromEntries(urlParams);
      }

      let paramsList = [];
      for (const [key, value] of Object.entries(params)) {
        if (key != 'headers' && key != 'timeout') {
          paramsList.push([key, value]);
        }
      }
      paramsList.sort(function (a, b) {
        return a[0].localeCompare(b[0]);
      });

      let fallbackUrl = 'https://assets-cf.pearcommerce.com/' + path;
      if (paramsList.length > 0) {
        fallbackUrl += '/';
      }
      for (let i = 0; i < paramsList.length; i++) {
        fallbackUrl += encodeURIComponent(paramsList[i][0]) + '/' + encodeURIComponent(paramsList[i][1]);
        if (i != paramsList.length - 1) {
          fallbackUrl += '/';
        }
      }
      fallbackUrl += '?' + new Date().getTime();

      let responseJson = await (await fetch(fallbackUrl)).json();
      return responseJson;
    };

    const get = async function (path, config, baseUrl) {
      let url = `${baseUrl || $config.API_URL}${path}`;

      if (totalRequests >= 5 && (totalTimeouts + 0.0) / totalRequests > 0.5) {
        window.requestKillswitch = true;
        try {
          return {
            status: 200,
            data: await getFallbackJson(url),
          };
        } catch (e) {
          if (!config || !config.failure) {
            return null;
          }
          if (typeof config.failure === 'function') {
            return await config.failure();
          } else {
            return config.failure;
          }
        }
      }
      totalRequests++;

      // apply api url
      if (window.initialLocationHeaders && window.includeLocationHeaders) {
        const headersParam = encodeURIComponent(JSON.stringify(Util.keepTruthy(window.initialLocationHeaders)));
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}headers=${headersParam}`;
      }
      if (window.__disableCaches) {
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}disableCaches=1`;
      }
      if (window.__ioLog) {
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}logIO=1`;
      }
      config = config || {};

      if (Util.getPearSession()) {
        config.headers = config.headers || {};
        config.headers['Pear-Session'] = Util.getPearSession();
      }
      config.withCredentials = true;
      const promise = $http.get(url, config).then(async function (resp) {
        if (resp.status != 200 && url.indexOf('/v1/') > -1) {
          totalTimeouts++;
          try {
            let responseJson = await getFallbackJson(url);
            resp.status = 200;
            resp.data = responseJson;
          } catch (e) {}
        }
        if (resp.status != 200 && config.failure) {
          if (typeof config.failure === 'function') {
            return await config.failure();
          } else {
            return config.failure;
          }
        }
        const pearSession = resp && resp.headers && resp.headers('Pear-Session');
        if (pearSession) {
          Util.addPearSession(pearSession);
          // if (gtag) {
          //   gtag('set', { dimension2: pearSession });
          // }
        }

        return resp.data;
      });

      const _then = promise.then;
      promise.then = function (success, failure) {
        return _then.apply(this, [success, failure || defaultErrorHandler]);
      };

      return promise;
    };

    const post = async function (path, data, config, baseUrl) {
      if (totalRequests >= 5 && (totalTimeouts + 0.0) / totalRequests > 0.5) {
        window.requestKillswitch = true;
        if (!config || !config.failure) {
          return null;
        }
        if (typeof config.failure === 'function') {
          return await config.failure();
        } else {
          return config.failure;
        }
      }
      totalRequests++;

      // apply api url
      let url = `${baseUrl || $config.API_URL}${path}`;
      if (window.initialLocationHeaders && window.includeLocationHeaders) {
        const headersParam = encodeURIComponent(JSON.stringify(Util.keepTruthy(window.initialLocationHeaders)));
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}headers=${headersParam}`;
      }
      if (window.__disableCaches) {
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}disableCaches=1`;
      }
      if (window.__ioLog) {
        url += `${url.indexOf('?') >= 0 ? '&' : '?'}logIO=1`;
      }
      config = config || {};
      if (Util.getPearSession()) {
        config.headers = config.headers || {};
        config.headers['Pear-Session'] = Util.getPearSession();
      }

      config.withCredentials = config.withCredentials === false ? config.withCredentials : true;

      const promise = $http.post(url, data, config).then(async function (resp) {
        if (resp.status != 200) {
          totalTimeouts++;
        }
        if (resp.status != 200 && config.failure) {
          if (typeof config.failure === 'function') {
            return await config.failure();
          } else {
            return config.failure;
          }
        }
        const pearSession = resp && resp.headers && resp.headers('Pear-Session');
        if (pearSession) {
          Util.addPearSession(pearSession);
          // if (gtag) {
          //   gtag('set', { dimension2: pearSession });
          // }
        }
        return resp.data;
      });

      const _then = promise.then;
      promise.then = function (success, failure) {
        return _then.apply(this, [success, failure || defaultErrorHandler]);
      };

      return promise;
    };
    let getIpLocationData = function (options) {
      let storedIpLocationRaw = null;
      const key = 'ip_location_v5';
      try {
        storedIpLocationRaw = localStorage.getItem(key);
      } catch (e) {
        console.debug(e);
      }
      let storedIpLocation = null;
      try {
        storedIpLocation = storedIpLocationRaw && JSON.parse(storedIpLocationRaw);
      } catch (e) {
        console.debug(e);
      }
      const fourHourMillis = 1000 * 60 * 60 * 4;
      // Validate cached result before returning it
      const isValidCachedResult = storedIpLocation &&
        storedIpLocation.result &&
        !storedIpLocation.result.error &&
        storedIpLocation.date &&
        new Date().getTime() - storedIpLocation.date < fourHourMillis &&
        storedIpLocation.result.latitude != null &&
        storedIpLocation.result.longitude != null &&
        (storedIpLocation.result.city || storedIpLocation.result.region_code || storedIpLocation.result.country_name || storedIpLocation.result.countryCode);
      
      if (isValidCachedResult) {
        return storedIpLocation.result;
      }
      if (!options) {
        options = {};
      }
      options.failure = async function () {
        return await (await fetch('https://8a5tcqwjuh.execute-api.us-east-1.amazonaws.com/ip')).json();
      };
      return get('/v1/ip_location_data?moreAccurateGeo=' + options.moreAccurateGeo, options).then((result) => {
        // Only cache if result is valid (has coordinates and location data)
        const isValidResult = result && 
          !result.error && 
          (result.latitude != null && result.longitude != null) &&
          (result.city || result.region_code || result.country_name || result.countryCode);
        
        if (isValidResult) {
          const toStore = {
            date: new Date().getTime(),
            result: result,
          };
          try {
            if (Util.getCookiePreferences().functional) {
              localStorage.setItem(key, JSON.stringify(toStore));
            }
          } catch (e) {}
        }
        return result;
      });
    };
    let getZipLocationData = function (zip, countryCode) { 
      // Don't cache if zip is null, undefined, or empty string
      const shouldCache = zip != null && zip !== '';
      
      // If zip is invalid, return early without making API call
      if (!shouldCache) {
        return Promise.resolve({});
      }

      const failureHandler = async function () {
        try {
          const results = await fetchWithFallback(
            getGeocodingUrls, STADIA_MAPS_CONFIG, zip
          );
          
          if (!results) return {};
          if (!results.features?.length) return {};
          
          const place = grabHighestConfidenceProperty(results.features);
          const lat = place.geometry.coordinates[1];
          const lng = place.geometry.coordinates[0];
          const placeDetails = await fetchWithFallback(
            getReverseGeocodingUrls, STADIA_MAPS_CONFIG, lat, lng
          );
          
          if (!placeDetails) return {};
          const address = grabHighestConfidenceProperty(placeDetails.features)?.properties;
          
          return {
            country_name: address.country_code?.toUpperCase() || 'US',
            region_code: address.state || address.province || '',
            city: address.city || address.town || address.village || '',
            zip: zip,
            latitude: place.geometry.coordinates[1],
            longitude: place.geometry.coordinates[0],
          };
        } catch (error) {
          return {};
        }
      };
      const key = `zip_location_v5_${zip}_${countryCode || 'default'}`;
      let storedLocation = null;
      try {
        const storedLocationRaw = localStorage.getItem(key);
        storedLocation = storedLocationRaw && JSON.parse(storedLocationRaw);
      } catch (e) {
        console.warn(e);
      }
      const oneDayMillis = 1000 * 60 * 60 * 24;
      // Validate cached result before returning it
      const isValidCachedResult = storedLocation &&
        storedLocation.result &&
        !storedLocation.result.error &&
        storedLocation.date &&
        new Date().getTime() - storedLocation.date < oneDayMillis &&
        storedLocation.result.latitude != null &&
        storedLocation.result.longitude != null &&
        (storedLocation.result.city || storedLocation.result.region_code || storedLocation.result.country_name || storedLocation.result.countryCode);
      
      if (isValidCachedResult) {
        return storedLocation.result;
      }

      return get('/v1/zip_location_data?zip=' + zip + (countryCode ? '&countryCode=' + countryCode : ''), {
        failure: failureHandler,
      }).then(
        (result) => {
          // Only cache if zip is valid and result is valid (has coordinates and location data)
          const isValidResult = result && 
            !result.error && 
            (result.latitude != null && result.longitude != null) &&
            (result.city || result.region_code || result.country_name || result.countryCode);
          
          if (isValidResult) {
            const toStore = {
              date: new Date().getTime(),
              result: result,
            };
            if (Util.getCookiePreferences().functional) {
              try {
                localStorage.setItem(key, JSON.stringify(toStore));
              } catch (e) {
                console.warn(e);
              }
            }
          }
          return result;
        },
        (result) => {
          return {
            result: {
              result,
            },
          };
        }
      );
    };
    angular.extend($api, {
      API_URL: $config.API_URL,
      get: get,
      post: post,
      setDefaultErrorHandler: function (_defaultErrorHandler) {
        defaultErrorHandler = _defaultErrorHandler;
      },
      getTransaction: function (id) {
        return get('/v1/retail_partner_transaction?id=' + id);
      },
      getRetailPartner: function (id) {
        return get('/v1/retail_partner?retail_partner=' + id);
      },
      getUpcsAndOffer: function (offerId) {
        return get('/v1/upcs_and_offer/' + offerId + '?timeout=2000');
      },
      getUpcsAndVendor: function (vendorId) {
        return get('/v1/upcs_and_vendor/' + vendorId + '?timeout=2000');
      },
      getUpcsOfferRetailer: function (offerId) {
        return get('/v1/upcs_offer_retailer/' + offerId);
      },
      getVerification: function (id) {
        return get('/v1/verification?verification=' + id);
      },
      getIpLocationData: getIpLocationData,
      getZipLocationData: getZipLocationData,
      getStoresForZip: function (zip) {
        return get('/v1/stores-for-zip?zip=' + zip);
      },
      getStoresForLocation: function (
        lat1,
        lng1,
        lat2,
        lng2,
        vendorId,
        firstLoad,
        zip,
        availabilities,
        storeIds,
        maxZips,
        selectedUPCs,
        constrainZips,
        offerId,
        countryCode
      ) {
        if (!vendorId) {
          vendorId = 0;
        }
        if (typeof firstLoad == 'undefined') {
          firstLoad = false;
        }

        selectedUPCs = selectedUPCs || null;

        const body = {
          retailerListsByZip: availabilities || null,
          storePearIds: storeIds || [],
        };

        return post(
          '/v1/stores-for-location-with-upcs' +
            '?lat1=' +
            lat1 +
            '&lng1=' +
            lng1 +
            '&lat2=' +
            lat2 +
            '&lng2=' +
            lng2 +
            '&vendorId=' +
            vendorId +
            '&firstLoad=' +
            !!firstLoad +
            // '&logIO=' + !firstLoad + '&stacks=' + !firstLoad +
            '&zip=' +
            zip +
            (offerId ? '&offerId=' + offerId : '') +
            '&maxZips=' +
            (!!firstLoad ? 1 : maxZips || 10) +
            `&selectedUPCs=${encodeURIComponent(JSON.stringify(selectedUPCs))}` +
            `&constrainZips=${encodeURIComponent(JSON.stringify(constrainZips))}` +
            (countryCode ? '&countryCode=' + countryCode : '') +
            '',
          body,
          {
            credentials: constrainZips ? 'omit' : 'include',
            withCredentials: !constrainZips,
            failure: async function () {
              let LocationData = await getZipLocationData(zip);
              return await (
                await fetch(
                  'https://assets.pearcommerce.com/stores-for-location-with-upcs/' +
                    offerId +
                    '/' +
                    LocationData.region_code +
                    '?' +
                    new Date().getTime()
                )
              ).json();
            },
          },
          $config.STORES_URL
        );
      },
    });
    return $api;
  });

  /**
   * Automatic storage.local session tracking and persistence using $rootScope
   */
  app.service('SessionService', function ($rootScope) {
    return {
      init: function () {
        $rootScope.$watch(
          'session',
          function (newVal, oldVal) {
            const session = $rootScope.session;

            // we set latest in here, so we don't want recursive watch calls by resetting it
            if (!newVal.latest || oldVal.latest == newVal.latest) {
              session.latest = Date.now();
            }
            storage.memory.setItem(LS_SESSION_KEY, JSON.stringify(session));
          },
          true
        );

        const LS_SESSION_KEY = 'session';

        const storedSessionStr = storage.memory.getItem(LS_SESSION_KEY);

        let storedSession;
        if (storedSessionStr) {
          storedSession = JSON.parse(storedSessionStr);
        } else {
          storedSession = {};
        }

        if (storedSession.latest && storedSession.latest < Date.now() - 1000 * 60 * 60) {
          $rootScope.session = {};
        } else {
          $rootScope.session = storedSession;
        }
      },
      get: function () {
        return $rootScope.session;
      },
      set: function (newSession) {
        $rootScope.session = newSession;
      },
    };
  });


  app.directive('googleplace', function () {
    return {
      scope: {
        session: '=',
        submit: '&',
        types: '=?',
      },
      require: ['ngModel', '^form'],
      link: $async(async function (scope, element, attrs, ctrls) {
        const model = ctrls[0];
        const form = ctrls[1];
        let options;

        if (!scope.types) {
          options = {
            types: ['address'],
          };
        } else {
          options = {
            types: scope.types,
          };
        }
        if (attrs.googleplace) {
          const googleplace = attrs.googleplace.trim().replace(/\s/g, '').split(',');
          if (googleplace.length > 0) {
            options = {
              ...options,
              componentRestrictions: { country: googleplace },
            };
          }
        }

        const googleplace = (attrs.googleplace || '').trim().replace(/\s/g, '').toLowerCase();

        let language = window.navigator.language;
        if (typeof Weglot != 'undefined') {
          language = Weglot.getCurrentLang() || language;
        }

        let autofill = null;

        const ZIPCODES_TO_SKIP_STADIA = ['47240', '4724'];

        const initialize = () => {
          autofill = {
            addEventListener: (event, callback) => {
              if (!autofill.callbacks) autofill.callbacks = {};
              autofill.callbacks[event] = callback;
            },
        
            // Custom geocoding function using Stadia Maps with caching
            search: async (query) => {
              const normalizedQuery = (query || '').trim();
              if (!normalizedQuery || normalizedQuery.length < 3) return [];
        
              // Check cache first
              const cacheParams = {
                text: normalizedQuery,
                limit: STADIA_MAPS_CONFIG.DEFAULT_LIMIT,
                boundary_country: STADIA_MAPS_CONFIG.DEFAULT_COUNTRIES,
                layers: 'locality,postalcode'
              };
        
              const cached = geocodingCache.get('/autocomplete', cacheParams);
              if (cached) return cached;
        
              let data = null;
        
              try {
                // Skip Stadia entirely if the query matches known bad zipcodes
                if (ZIPCODES_TO_SKIP_STADIA.includes(normalizedQuery)) {
                  data = await fetchMapboxAutocomplete(STADIA_MAPS_CONFIG, normalizedQuery);
                } else {
                  // Try Stadia first
                  data = await fetchWithFallback(getAutocompleteUrls, STADIA_MAPS_CONFIG, normalizedQuery);
        
                  // Fallback to Mapbox if Stadia returned nothing or no features
                  if (!data?.features?.length) {
                    data = await fetchMapboxAutocomplete(STADIA_MAPS_CONFIG, normalizedQuery);
                  }
                }
        
                if (!data?.features?.length) return [];
        
                // Sort by confidence
                const hasUserLocation = scope?.session?.latitude && scope?.session?.longitude;
                const { latitude: userLat, longitude: userLng } = scope?.session || {};
        
                data.features.sort((a, b) => {
                  const confidenceA = a.properties.confidence || 0;
                  const confidenceB = b.properties.confidence || 0;
        
                  // If we have a user location, sort primarily by distance, then confidence
                  if (hasUserLocation) {
                    const distA = calculateDistance(userLat, userLng, a.geometry.coordinates[1], a.geometry.coordinates[0]);
                    const distB = calculateDistance(userLat, userLng, b.geometry.coordinates[1], b.geometry.coordinates[0]);
        
                    if (distA !== distB) return distA - distB; // closer first
                    return confidenceB - confidenceA;         // higher confidence first
                  }
        
                  // Otherwise, sort only by confidence
                  return confidenceB - confidenceA;
                });
                
                // Format results
                const formattedResults = data.features.map((place) => {
                  const isPostalcode = place.properties.layer === 'postalcode';
                  
                  // Create a description that will work with the two-line dropdown display
                  let description;
                  
                  if (isPostalcode) {
                    // For zip codes, create a description like "11213, Brooklyn, NY, USA"
                    const parts = [place.properties.name]; // Start with zip code
                    
                    const city = place.properties.borough || place.properties.locality || place.properties.city;
                    const state = place.properties.region_a || place.properties.region || place.properties.state;
                    
                    if (city) {
                      parts.push(city);
                    }
                    if (state) {
                      parts.push(state);
                    }
                    if (city && state && place.properties.country) {
                      parts.push(place.properties.country);
                    }
                    description = parts.join(', ');
                  } else {
                    // For cities/places, use the full label
                    description = place.properties.label || place.properties.display_name || place.properties.name;
                  }
                  
                  return {
                    detail: {
                      features: [{
                        geometry: {
                          coordinates: place.geometry.coordinates
                        },
                        properties: {
                          description: description,
                          country_code: (place.properties.country_code || place.properties.country_a)?.toUpperCase(),
                          place_type: [place.properties.layer || 'place'],
                          feature_name: '', // Will be filled when selected
                          postcode: isPostalcode ? place.properties.name : '', // Include zip if it's a postalcode result
                          lat: place.geometry.coordinates[1],
                          lon: place.geometry.coordinates[0]
                        }
                      }]
                    }
                  };
                });
                
                // Cache the results
                geocodingCache.set('/autocomplete', cacheParams, formattedResults);
                
                return formattedResults;
              } catch (error) {
                console.error('Geocoding error:', error);
                return [];
              }
            }
          };
        };

        initialize();

        const observerHack = new MutationObserver(function () {
          observerHack.disconnect();
          element[0].setAttribute('autocomplete', 'unbreak');
        });

        observerHack.observe(element[0], {
          attributes: true,
          attributeFilter: ['autocomplete'],
        });

        let officialLocation = scope.session.location;
        scope.$watch('session.location', function (newLocation) {
          if (newLocation != officialLocation) {
            scope.session.zip = null;
            scope.session.latitude = null;
            scope.session.longitude = null;
          }
        });

        let retrieveFired = false;
        let inputTimeout = null;
        
        // Create autocomplete dropdown functionality
        const inputElement = element[0];
        let dropdown = null;
        let currentResults = [];
        let selectedIndex = -1;
        

        const updateSelection = (items, index) => {
          if (!items?.length) return;
          
          // Clear previous selection
          items.forEach(item => {
            if (item?.style) {
              item.style.backgroundColor = 'white';
              item.style.color = '#333';
              item.setAttribute('aria-selected', 'false');
            }
          });
          
          // Apply new selection
          if (index >= 0 && index < items.length && items[index]?.style) {
            const selectedItem = items[index];
            selectedItem.style.backgroundColor = '#f8f9fa';
            selectedItem.style.color = '#333';
            selectedItem.setAttribute('aria-selected', 'true');
            selectedItem.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
          }
          
          selectedIndex = index;
        };
        
        const createDropdown = () => {
          if (dropdown && typeof dropdown.remove === 'function') {
            dropdown.remove();
          }
          
          dropdown = document.createElement('div');
          dropdown.className = 'autocomplete-dropdown';
          dropdown.setAttribute('role', 'listbox');
          dropdown.setAttribute('aria-label', 'Location suggestions');
          
          const rect = inputElement.getBoundingClientRect();
          dropdown.style.cssText = `
            position: absolute;
            top: ${rect.bottom + window.scrollY}px;
            left: ${rect.left}px;
            width: ${rect.width}px;
            background: white;
            border: 1px solid #ccc;
            border-top: none;
            max-height: 200px;
            overflow-y: auto;
            z-index: 1000;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          `;
          
          document.body.appendChild(dropdown);
        };
        
        const createDropdownItem = (result, index) => {
          const item = document.createElement('div');
          item.className = 'autocomplete-item';
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          item.setAttribute('tabindex', '-1');
          
          const description = result.detail.features[0].properties.description;
          const [cityName, ...locationParts] = description.includes(',') ? description.split(',') : [description];
          const locationDetails = locationParts.join(',').trim();
          
          item.innerHTML = `
            <div style="font-weight: 600; color: #333; font-size: 14px; line-height: 1.2;">${cityName.trim()}</div>
            ${locationDetails ? `<div style="font-size: 12px; color: #666; margin-top: 2px; line-height: 1.2;">${locationDetails}</div>` : ''}
          `;
          
          item.style.cssText = `
            padding: 12px 16px;
            cursor: pointer;
            border-bottom: 1px solid #e9ecef;
            transition: background-color 0.15s ease;
            outline: none;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          `;
          
          // Event listeners
          item.addEventListener('mouseenter', () => updateSelection(dropdown._items, index));
          item.addEventListener('mouseleave', () => updateSelection(dropdown._items, -1));
          item.addEventListener('click', () => selectResult(result));
          item.addEventListener('keydown', (event) => {
            if (['Enter', ' '].includes(event.key)) {
              event.preventDefault();
              selectResult(result);
            } else if (event.key === 'Escape') {
              hideDropdown();
              inputElement.focus();
            }
          });
          
          return item;
        };
        
        const showDropdown = (results) => {
          if (!dropdown) createDropdown();
          
          dropdown.innerHTML = '';
          currentResults = results;
          selectedIndex = -1;
          
          if (results.length === 0) {
            dropdown.innerHTML = '<div style="padding: 10px; color: #666;" role="option" aria-selected="false">No results found</div>';
            return;
          }
          
          const items = results.map((result, index) => createDropdownItem(result, index));
          items.forEach(item => dropdown.appendChild(item));
          
          // Store items for keyboard navigation
          dropdown._items = items;
          dropdown._selectedIndex = selectedIndex;
          
          inputElement.focus();
        };
        
        const hideDropdown = () => {
          if (dropdown && typeof dropdown.remove === 'function') {
            dropdown.remove();
            dropdown = null;
          }
          selectedIndex = -1;
        };
        
        const centerMapOnLocation = (lat, lng) => {
          const mapInstance = window.currentMap || 
          document.querySelector('#map')?._maplibreMap;
          
          if (!mapInstance) return;
          
          try {
            mapInstance.flyTo({ center: [lng, lat], zoom: 12, duration: 1000 });
          } catch (error) {
            console.error('Error centering map:', error);
          }
        };
        
        const updatePickerLocation = (pickerScope) => {
          if (!pickerScope?.submitLocation) return;
          
          // Update the picker scope's location data
          pickerScope.location = {
            location: scope.session.location,
            latitude: scope.session.latitude,
            longitude: scope.session.longitude,
            coordinatesLocation: scope.session.coordinatesLocation,
            countryCode: scope.session.countryCode
          };
          
          // Update the input field immediately for instant feedback
          const storedOfficialLocation = officialLocation;
          inputElement.value = storedOfficialLocation;
          model.$setViewValue(storedOfficialLocation);
          
          // Call submitLocation in the background
          setTimeout(() => pickerScope.submitLocation(), 0);
        };
        
        const selectResult = (result) => {
          if (!result?.detail) return;
          
          const place = result.detail.features[0];
          
          // Update session data
          if (place.geometry) {
            scope.session.latitude = place.geometry.coordinates[1];
            scope.session.longitude = place.geometry.coordinates[0];
            scope.session.coordinatesLocation = place.properties.description;
            scope.session.countryCode = place.properties.country_code?.toUpperCase();
            scope.session.location = place.properties.description;
            
            // Handle zip code results - get full location details
            if (place.properties.place_type?.includes('postalcode')) {
              scope.session.zip = place.properties.name; // Use name for postal codes
              
               // Get full location details for this zip code
               getLocationDetailsForZip(STADIA_MAPS_CONFIG, place.geometry.coordinates[1], place.geometry.coordinates[0], place.properties.name)
                .then(locationData => {
                  if (locationData) {
                    // Update the location with full details
                    scope.session.location = locationData.locationString;
                    scope.session.coordinatesLocation = locationData.locationString;
                    
                    // Update the input field to show the full location
                    inputElement.value = locationData.locationString;
                    
                    // Apply the changes
                    scope.$apply();
                  }
                })
                .catch(error => {
                  console.error('Error getting location details for zip:', error);
                });
            }
          } else {
            scope.session = { location: place.properties.description };
          }
          
          officialLocation = scope.session.location;
          inputElement.value = officialLocation;
          
          // Visual feedback
          inputElement.style.borderColor = '#28a745';
          setTimeout(() => inputElement.style.borderColor = '', 1000);
          
          // Center map if available
          if (place.geometry?.coordinates) {
            centerMapOnLocation(place.geometry.coordinates[1], place.geometry.coordinates[0]);
          }
          
          // Clear seller cache
          if (scope.pickerListDisplayCache) {
            scope.pickerListDisplayCache = {};
          }
          
          // Handle different submission scenarios
          if (scope.$parent?.submitLocation && scope.$parent.location) {
            if (!scope.session.latitude || !scope.session.longitude) return;
            
            // Find picker scope
            let pickerScope = scope.$parent;
            while (pickerScope && !pickerScope.submitLocation) {
              pickerScope = pickerScope.$parent;
            }
            
            if (pickerScope?.submitLocation) {
              updatePickerLocation(pickerScope);
            }
          } else if (scope.submit) {
            scope.submit({
              location: scope.session.location,
              latitude: scope.session.latitude,
              longitude: scope.session.longitude,
              coordinatesLocation: scope.session.coordinatesLocation,
              countryCode: scope.session.countryCode
            })();
          } else if (scope.submitLocation) {
            scope.submitLocation();
          } else if (scope.$parent?.submitLocation) {
            scope.$parent.submitLocation();
          } else {
            console.error('No submit function found!');
          }
          
          form.$setSubmitted();
          hideDropdown();
          inputElement.focus();
        };
        
        const handleKeyboardNavigation = (event, items) => {
          if (!items?.length) return;
          
          switch(event.key) {
            case 'ArrowDown':
              event.preventDefault();
              event.stopPropagation();
              selectedIndex = Math.min(selectedIndex + 1, items.length - 1);
              updateSelection(items, selectedIndex);
              break;
            case 'ArrowUp':
              event.preventDefault();
              event.stopPropagation();
              selectedIndex = Math.max(selectedIndex - 1, -1);
              updateSelection(items, selectedIndex);
              break;
            case 'Enter':
              event.preventDefault();
              event.stopPropagation();
              if (selectedIndex >= 0 && selectedIndex < items.length) {
                selectResult(currentResults[selectedIndex]);
              } else if (currentResults.length > 0) {
                selectResult(currentResults[0]);
              }
              break;
            case 'Escape':
              event.preventDefault();
              event.stopPropagation();
              hideDropdown();
              inputElement.focus();
              break;
            case 'Tab':
              if (selectedIndex >= 0 && selectedIndex < items.length) {
                event.preventDefault();
                selectResult(currentResults[selectedIndex]);
              }
              break;
          }
          
          if (dropdown) {
            dropdown._selectedIndex = selectedIndex;
          }
        };
        
        // Event listeners
        inputElement.addEventListener('input', async (event) => {
          const query = event.target.value.trim();
          
          if (inputTimeout) clearTimeout(inputTimeout);
          
          if (query.length < 3) {
            hideDropdown();
            return;
          }
          
          inputTimeout = setTimeout(async () => {
            try {
              const results = await autofill.search(query);
              showDropdown(results);
            } catch (error) {
              console.error('Geocoding error:', error);
              hideDropdown();
            }
          }, 300);
        });
        
        inputElement.addEventListener('keydown', (event) => {
          if (dropdown?._items) {
            handleKeyboardNavigation(event, dropdown._items);
          }
        });
        

        
        // Click outside to hide
        document.addEventListener('click', (event) => {
          if (!inputElement.contains(event.target) && (!dropdown || !dropdown.contains(event.target))) {
            hideDropdown();
          }
        });
        
        // Focus/blur handling
        inputElement.addEventListener('focus', () => {
          if (currentResults.length > 0 && !dropdown) {
            showDropdown(currentResults);
          }
        });
        
        inputElement.addEventListener('blur', (event) => {
          setTimeout(() => {
            if (!dropdown || !dropdown.contains(event.relatedTarget)) {
              hideDropdown();
              
              // If input is empty after blur, restore the original location
              if (!inputElement.value.trim()) {
                scope.session.location = officialLocation || scope.session.location || '';
                scope.$apply();
              }
            }
          }, 0);
        });
        
        // Debug function to show geocoding cache statistics
        window.showGeocodingCacheStats = () => {
          const stats = geocodingCache.getStats();
          console.log('Geocoding Cache Statistics:', stats);
          return stats;
        };
        
        // Clear geocoding cache if needed
        window.clearGeocodingCache = () => {
          geocodingCache.clear();
          console.log('Geocoding cache cleared');
        };
      }),
    };
  });

  app.directive('autofocus', [
    '$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        link: function ($scope, $element) {
          $timeout(function () {
            $element[0].focus();
          });
        },
      };
    },
  ]);

  app.directive('loadingIndicator', function ($rootScope, $timeout) {
    return {
      restrict: 'A',
      link: function ($scope, element, attributes) {
        $scope.count = 0;
        const contents = element.html();
        $scope.$on('loading-started', function (event, task) {
          $scope.count++;
          element.html("<img class='spinner' src='/img/spinner.gif'/>");
          if (!element[0].className || element[0].className.split(' ').indexOf('spinner') < 0) {
            element[0].className += ' spinner';
          }
        });

        $scope.$on('loading-complete', function (event, task) {
          $timeout(function () {
            $scope.count--;
            if ($scope.count == 0) {
              element[0].className = element[0].className.replace(/spinner/g, '');
              element.html(contents);
            }
          }, 250);
        });
      },
    };
  });

  app.directive('cssReset', function ($rootScope, $config) {
    return {
      restrict: 'A',
      link: function ($scope, el, attributes) {
        if ($config.productionResources) {
          return;
        }
        const element = el[0];

        const depth = resetCss.getDepth(element);

        resetCss.label(element, depth, false);

        $scope.$watch(function () {
          $scope.$$postDigest(function () {
            resetCss.label(document.getElementById(element.id), depth, false);
          });
          return true;
        });

        const selector = '.css-reset' + depth;
        resetCss.modifyStyles(selector, document);
      },
    };
  });

  app.service('$config', function () {
    return Config;
  });

  app.service('$experiment', function ($q, $rootScope, $api) {
    const resolveValue = function (name, deferred) {
      if (
        window.google_optimize &&
        $rootScope.experiments[name] &&
        google_optimize.get($rootScope.experiments[name].googleId)
      ) {
        let ret = $rootScope.experiments[name].variants[google_optimize.get($rootScope.experiments[name].googleId)];
        if (!ret || ret == '') {
          ret = 'Original';
        }
        $api.post('/v1/impress', { googleExperimentId: $rootScope.experiments[name].googleId, variant: ret });

        deferred.resolve(ret);
      } else {
        deferred.resolve('Original');
      }
    };

    this.get = function (name) {
      const deferred = $q.defer();
      if ($rootScope.experiments) {
        resolveValue(name, deferred);
      } else {
        $api.get('/v1/experiments').then(function (experiments) {
          $rootScope.experiments = experiments;
          resolveValue(name, deferred);
        });
      }
      return deferred.promise;
    };

    this.convert = function (name) {
      const postConvert = function () {
        if (
          window.google_optimize &&
          $rootScope.experiments[name] &&
          google_optimize.get($rootScope.experiments[name].googleId)
        ) {
          $api.post('/v1/convert', { googleExperimentId: $rootScope.experiments[name].googleId });
        }
      };

      if ($rootScope.experiments) {
        postConvert(name);
      } else {
        $api.get('/v1/experiments').then(function (experiments) {
          $rootScope.experiments = experiments;
          postConvert(name);
        });
      }
    };
  });

  app.directive('script', function () {
    return {
      restrict: 'E',
      scope: false,
      link: function (scope, elem, attr) {
        if (attr.type == 'text/javascript-lazy') {
          var code = elem.text();
          var f = new Function(code);
          f();
        }
      },
    };
  });

  // angular app bootstrap
  app.directive('pearStoreLocator', function () {
    return {
      restrict: 'E',
      scope: {
        products: '=',
        stores: '=',
        vendor: '=',
        offer: '=',
        MapStylesJson: '=',
        strings: '=',
        buyOnlineTabActive: '=',
        hideBuyOnlineTab: '=',
        pageSize: '=',
        showStoreTypes: '=',
        enableRetailerFilter: '=',
        showPhoneNumInStoreLst: '=',
      },
      link: (scope, el) => {
        const node = el[0];
  
        // robust setter: setProp → setProps → direct property
        const set = (k, v) => {
          if (typeof node.setProp === 'function') return node.setProp(k, v);
          if (typeof node.setProps === 'function') return node.setProps({ [k]: v });
          node[k] = v;
        };
  
        const pushAll = () => {
          set('products', scope.products);
          // Don't push stores - React now fetches all stores independently
          // set('stores', scope.stores);
          set('vendor', scope.vendor);
          set('offer', scope.offer);
          set('MapStylesJson', scope.MapStylesJson);
          // Extract widgetConfig from the nested structure, or use the root if widgetConfig doesn't exist
          const fullConfig = scope.$root.WIDGET_CONFIG;
          const widgetConfig = fullConfig?.widgetConfig || fullConfig;
          set('config', widgetConfig);
          set('strings', scope.strings);
          set('buyOnlineTabActive', scope.buyOnlineTabActive);
          set('hideBuyOnlineTab', scope.hideBuyOnlineTab);
          set('pageSize', scope.pageSize);
          set('showStoreTypes', scope.showStoreTypes);
          set('enableRetailerFilter', scope.enableRetailerFilter);
          set('showPhoneNumInStoreLst', scope.showPhoneNumInStoreLst);
        };
  
        setTimeout(pushAll, 0);
        // Watch WIDGET_CONFIG on $rootScope separately
        const unwatchConfig = scope.$root.$watch('WIDGET_CONFIG', () => {
          const fullConfig = scope.$root.WIDGET_CONFIG;
          const widgetConfig = fullConfig?.widgetConfig || fullConfig;
          set('config', widgetConfig);
        }, true);
  
        // Watch other properties together (excluding 'stores' - React manages stores independently)
        scope.$watchGroup([
          'products','vendor','offer',
          'MapStylesJson','strings','buyOnlineTabActive','hideBuyOnlineTab',
          'pageSize','showStoreTypes','enableRetailerFilter','showPhoneNumInStoreLst'
        ], pushAll, /* deep */ true);
        
        // Don't watch stores at all - React now fetches all stores independently
        // AngularJS can still manage $scope.stores for its own purposes, but React doesn't need it
  
        // Cleanup watcher on destroy
        scope.$on('$destroy', () => {
          if (unwatchConfig) unwatchConfig();
        });
      }
    };
  });
  

  app.factory('$debounce', function ($timeout, $q) {
    // The service is actually this function, which we call with the func
    // that should be debounced and how long to wait in between calls
    return function debounce(func, waitForResolve, wait) {
      let running = false;
      let timeout = null;
      // Create a deferred object that will be resolved when we need to
      // actually call the func
      let deferred = $q.defer();

      const ret = function (...args) {
        const context = this;
        const _args = args;
        const later = function () {
          timeout = null;
          running = false;
        };

        if (!timeout && !waitForResolve) {
          timeout = $timeout(later, wait);
        }

        if (!running) {
          running = true;
          const functRet = func.apply(context, _args);

          if (functRet && typeof functRet.then == 'function') {
            Promise.resolve(functRet).then(later);
          } else if (waitForResolve) {
            throw new Error('Specified to wait for resolve, but did not get a Promise.');
          }

          deferred.resolve(functRet);
          deferred = $q.defer();
        }

        return deferred.promise;
      };

      return ret;
    };
  });
})();

},{"../analytics-events.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/analytics-events.js","../config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","../parseuri":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js","../parseuri.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js","../pear-console.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js","../storage.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js","../utilities":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","../utilities.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","./geocoding-cache.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/geocoding-cache.js","./map-utils.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/map-utils.js","./molson.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/molson.js","./ng-async.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/ng-async.js","./reset_css.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/reset_css.js","./retailer/retailer-shared.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/retailer/retailer-shared.js","./stadia-maps-config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/stadia-maps-config.js","./telephone.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/telephone.js","angular":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular/index.js","angular-carousel":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-carousel/dist/angular-carousel.js","angular-sanitize":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-sanitize/index.js","angular-touch":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-touch/index.js","angular-ui-router":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/angular-ui-router/release/angular-ui-router.js","lz-string":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/lz-string/libs/lz-string.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/picker.js":[function(_dereq_,module,exports){
const console = _dereq_('../pear-console.js').PearConsole;
const parseUri = _dereq_('../parseuri.js');
const lazysizes = _dereq_('lazysizes');
const molsonOfferIds = _dereq_('./molson.js');
const pickerTemplateProvider = _dereq_('./templateProvider/pickerTemplateProvider.js');
const ENRICHED_CATEGORY_CONFIG = _dereq_('../../js/offers/brand/enriched_category.js');
const STADIA_MAPS_CONFIG = _dereq_('./stadia-maps-config.js');
const geocodingCache = _dereq_('./geocoding-cache.js');
const { 
  updateLocationWithZip,
  getZipFromCoordinates,
  getZipFromForwardGeocoding,
  getZipFromLocationSearch,
  getZipFromReverseGeocoding,
  getCurrentLocation,
  resolveVectorStyle,
  getServerStyleObject,
  applyMapCanvasFilter,
  applyLightModeMapTweaks,
  applyGranularityTweaks,
  getReverseGeocodingUrls,
  fetchWithFallback,
  getCountryCodeFromCoordinates
} = _dereq_('./map-utils.js');

const NATURAL_BALANCE_VENDOR_ID = 2800767187420977;
const CANIDAE_VENDOR_ID = 2800767187421016;
const ELANCO_VENDOR_ID = 2667515212593122;
const ELANCO_TRUST_ARC = 'https://consent.trustarc.com/notice?domain=elanco-new.de&c=teconsent&country=us&state=ca&js=nj&noticeType=bb&pcookie&text=true&gtm=1';

setInterval(function () {
  if (!document.querySelector('body')) {
    return;
  }
  if (document.querySelector('.modal')) {
    document.querySelector('body').style.overflowY = 'hidden';
  } else {
    document.querySelector('body').style.overflowY = 'auto';
  }
}, 500);

const storage = _dereq_('../storage.js');

let maplibregl;

const app = angular.module('pearApp');
const $async = _dereq_('./ng-async.js');
app.factory('$async', () => $async);

let videojs;

const millsFontCSS = [
  2017704786302912, 2017706295875520, 2017717273409504, 2017718499178464, 2017719674697696, 2017720669083584,
];

const Util = _dereq_('../utilities.js');
const { nonBlankStr, phoneLink } = _dereq_('../utilities');

const USE_FIRST_UPC_ON_BIG_LIST = false;
const inProductLocator = window.location.href.indexOf('/product-locator/') != -1;
const addFB = function () {
  try {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  } catch (e) {}
};

const STANDARD_PIXEL_EVENTS = {
  google: {
    filter: (html) => html.indexOf('googleanalytics') != -1,
    page_load: () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'PageLoad',
      });
    },
    add_to_cart: () => {
      var retailer = window.RETAILER_NAME;
      var product = window.PRODUCT_NAME;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'AddToCart',
        retailer_name: retailer,
        product_name: product,
      });
    },
    purchase: () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Purchase',
      });
    },
  },
  meta: {
    filter: (html) => html.indexOf('fbq') != -1,
    page_load: () => {
      // TODO
    },
    add_to_cart: () => {
      // TODO
    },
    purchase: () => {
      // TODO
    },
  },
};

const fireStandardPixelEvents = function (html, event) {
  Object.entries(STANDARD_PIXEL_EVENTS)
    .filter((e) => e[event] && e[1].filter && e[1].filter(html))
    .map((e) => e[event])
    .forEach((inject) => {
      try {
        inject();
      } catch (e) {
        console.error(e);
      }
    });
};

let pixelNum = 0;
const setInnerHTML = async function ($api, elm, html, rewriteImg, pearclid, event) {
  const preFirePromise = (async () => {
    try {
      // in the background, tell the server that we're about to fire pixels
      await $api.post(`/v1/on_pixel_status_update?pearclid=${pearclid || 0}&event=${event}&fireStatus=pre_fire`, {});
    } catch (e) {
      console.error(e);
    }
  })();

  const initialResources = [...performance.getEntriesByType('resource')];
  window.dataLayer = window.dataLayer || [];
  initialResources.push(...window.dataLayer);

  let tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  let children = [];
  for (let i = 0; i < tempDiv.children.length; i++) {
    children.push(tempDiv.children[i]);
  }
  // Need to reverse to keep children elements sequence
  children.reverse();
  for (let i = 0; i < children.length; i++) {
    children[i].setAttribute('pear-injected', 'true');
    elm.insertBefore(children[i], elm.firstChild);
  }

  let elements = elm.querySelectorAll('script[pear-injected]:not([event])');
  
  if (window.pear_debug) {
    console.log('Installing ' + elements.length + ' pixels...');
  }
  window['pixelElements'] = elements;

  let innerHTMLs = [...elements].map((e) => e.innerHTML);
  let promises = [];
  for (let i = 0; i < elements.length; i++) {
    let oldScript = elements[i];
    let newScript = null;

    const rejectHolder = {};

    newScript = document.createElement('script');

    const onErrorName = `onError_${++pixelNum}`;
    const onLoadName = `onLoad_${pixelNum}`;

    window[onErrorName] = console.error;
    window[onLoadName] = () => {
      if (event) {
        try {
          fireStandardPixelEvents(html, event);
        } catch (e) {
          console.error(e);
        }
      }
    };

    let loaded = new Promise(function (resolve, reject) {
      // set a default rejection handler after 10s
      let errTimeout = setTimeout(() => {
        reject(new Error(`No onload from pixel #${pixelNum} after 10s`, pixel));
      }, 10000);

      let _resolve = (e) => {
        if (window.pear_debug) {
          console.log(`Successfully installed pixel #${pixelNum}`, pixel);
        }
        clearTimeout(errTimeout);
        resolve(e);
      };

      const onload = window[onLoadName];
      window[onLoadName] = () => {
        try {
          onload();
        } finally {
          _resolve();
        }
      };

      let pixel = window['pixelElements'][pixelNum - 1];
      window[onErrorName] = (e) => {
        if (window.pear_debug) {
          console.error(`Error loading pixel #${pixelNum}`, newScript, pixel, e);
        }
        clearTimeout(errTimeout);
        reject(e);
      };
      newScript.onload = _resolve;
      newScript.onerror = window[onErrorName];
      oldScript.onerror = window[onErrorName];
    });

    promises.push(loaded);

    try {
      Array.from(oldScript.attributes).forEach((attr) => {
        try {
          newScript.setAttribute(attr.name, attr.value);
        } catch (e) {
          console.error(e);
        }
      });

      newScript.addEventListener('error', window[onErrorName]);
      newScript.addEventListener('abort', window[onErrorName]);
      oldScript.addEventListener('error', window[onErrorName]);
      oldScript.addEventListener('abort', window[onErrorName]);
      oldScript.parentNode.addEventListener('error', window[onErrorName]);
      oldScript.parentNode.addEventListener('abort', window[onErrorName]);

      if (oldScript && !oldScript.src && oldScript.innerHTML) {
        newNode = document.createTextNode(
          `
                     
    try {
  // VENDOR PIXEL BELOW THIS LINE
  /////////////////////////////////////////////////
            
  
            ${oldScript.innerHTML}


  /////////////////////////////////////////////////
  // VENDOR PIXEL ABOVE THIS LINE
        window['${onLoadName}']();
      } catch (_e) {
        window['${onErrorName}'](_e);
      }
  `
        );
        newNode.addEventListener('error', window[onErrorName]);
        newNode.addEventListener('abort', window[onErrorName]);
        newNode.onerror = window[onErrorName];
        newScript.appendChild(newNode);
      }

      let waitForSrc = oldScript && oldScript.getAttribute('src');
      if (oldScript && oldScript.parentNode) {
        oldScript.parentNode.replaceChild(newScript, oldScript);
      }
      if (waitForSrc) {
        try {
          await loaded;
        } catch (e) {
          console.error(`Failed to install pixel #${pixelNum}`, oldScript, e);
        }
      }
    } catch (e) {
      console.error(e);
      window[onErrorName](e);
    }
  }

  // Adding event attribute to all the children of the script tag 
  // to avoid duplicate events in datalayer 

  Array.from(elm.children).forEach(child => {
    if (!child.hasAttribute('event')) {
      child.setAttribute('event', event);
    }
  });

  // Ping the server with 'post_fire' when any of our pixels get injected successfully.
  // After a timeout of 3 seconds of no succesful injects, instead ping the server with 'fire_fail'.
  // Do all of this in the background.
  (async () => {
    try {
      if (promises.length > 0) {
        if (preFirePromise) {
          await preFirePromise;
        }
        const TIMEOUT_SENTINEL = 'TIMEOUT';
        const timeout = new Promise((r) => setTimeout(() => r(TIMEOUT_SENTINEL), 3000));

        const resolved = await Promise.any([timeout, ...promises]);

        var fireStatus = null;
        if (resolved == TIMEOUT_SENTINEL) {
          fireStatus = 'fire_fail';
        } else {
          fireStatus = 'post_fire';
        }
        // Tell the server that we either fired the pixels or failed

        await $api.post(`/v1/on_pixel_status_update?pearclid=${pearclid || 0}&event=${event}&fireStatus=${fireStatus}`, {});
      }
    } catch (e) {
      console.error(e);
    }
  })();

  promises.forEach(async (t) => {
    try {
      await t[0];
      if (window.pear_debug) {
        console.log(`Successfully installed pixel #${t[3]}`, window['pixelElements'][pixelNum - 1]);
      }
    } catch (e) {
      if (window.pear_debug) {
        console.error(`Failed to install pixel #${t[3]}`, window['pixelElements'][pixelNum - 1], e);
      }
    }
  });

  let images = elm.querySelectorAll('img[pear-injected]');
  for (let i = 0; i < images.length; i++) {
    //debugger;
    let image = images[i];
    let j = 0;

    while (!image.loaded) {
      await Util.timeout(20);
      j++;
      if (j >= 50) {
        break;
      }
    }
  }

  // Accessibility
  document.querySelectorAll('img[pear-injected][src*="LIVERAMP"]').forEach(img => {
    img.setAttribute('alt', '');
    img.setAttribute('role', 'presentation');
  });

  let pixelActivity = [];
  (async () => {
    let maxWait = 30000;
    let k = 0;
    while (++k < maxWait / 100) {
      const endingResources = [...performance.getEntriesByType('resource')];

      newResources = endingResources
        .filter((r) => initialResources.indexOf(r) == -1)
        .filter((r) => pixelActivity.indexOf(r) == -1)
        .filter((r) => {
          const host = parseUri(r.name).host;
          if (host) {
            let pixelSources = [...elements].filter((e) => e.innerText.indexOf(host) != -1);

            if (pixelSources.length) {
              if (window.pear_debug) {
                console.log('Detected activity from pixel:', host, r.initiatorType, r.name);
              }
              pixelActivity.push(r);
              return true;
            }
          }
          return false;
        });

      [...window.dataLayer]
        .filter((r) => initialResources.indexOf(r) == -1)
        .filter((r) => pixelActivity.indexOf(r) == -1)
        .forEach((r) => {
          if (window.pear_debug) {
            console.log('Detected window.dataLayer activity from pixel: ', r);
          }
          pixelActivity.push(r);
        });

      await Util.timeout(window.pear_debug ? 200 : 100);
    }
  })();
};

const addTagsToBody = async function ($api, html, rewriteImg, pearclid, event) {
  rewriteImg = false;
  if (!html) {
    return;
  }
  await setInnerHTML($api, document.body, html, rewriteImg, pearclid, event);
};

if (window.location.href.indexOf('&') > -1 && window.location.href.indexOf('?') < 0) {
  //bad data.
  window.location.href = window.location.href.replace('&', '?');
}

// pull down admin cookie from dashboard
try {
  const cookieAdmin = ((name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  })('admin');
  if (typeof cookieAdmin != 'undefined') {
    window.PEAR_COMMERCE_ADMIN = !!cookieAdmin;
  }
} catch (err) {
  console.debug(err);
}

app.filter('startFrom', function () {
  return function (input, start) {
    start = +start; //parse to in
    return input.slice(start);
  };
});

const MOBILE_WIDTH = 736;


const EVENT_RETAILER_VISIT = 'retailer_visit';
const EVENT_ADD_TO_CART = 'add_to_cart';
const EVENT_PAGE_LOAD = 'page_load';
const EVENT_PURCHASE = 'purchase';
app.config(function ($stateProvider) {
  const pickerController = function (
    $scope,
    UPCS,
    UPCSAndOffer,
    $stateParams,
    RetailerListInit,
    $timeout,
    $api,
    $rootScope,
    LocationData,
    $state,
    isMobile,
    PageLoad,
    $interval,
    OfferDomInsertions,
    ReimbursementInfo,
    $sce,
    MapStylesJson,
    $config,
    PixelConfig,
    $q,
    FirstStoresForLocationPromiseWrapper,
    MapLibrariesPreInject,
    ParallelStoresForLocationPromiseWrapper,
    PotentialStoreZipsForLocation,
    $config,
    AppConfig
  ) {
    if ($state.current.name != 'product-locator') {
      $scope.renderImages = true;
      $scope.renderLowPriImages = true;
    } else {
      $timeout(() => {
        $scope.renderImages = true;
        $scope.renderLowPriImages = true;
      }, 5000);
    }
    if ($stateParams.debug || window.location.href.indexOf('debug') != -1) {
      window.pear_debug = true;
    }
    $scope.isMobileFn = isMobile;
    $scope.isMobileWidth = function() {
      return window.innerWidth <= 768;
    }
    $scope.privacyClosed = {};
    $scope.pickerList = [];
    UPCSAndOffer = UPCSAndOffer || {};
    $rootScope.$config = $config;
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    $scope.$sce = $sce;
    if ($stateParams.stylesheetHref) {
      $stateParams.stylesheet = $stateParams.stylesheetHref;
    }
    if ($stateParams.stylesheet) {
      const whitelist = ['localhost', 'offers.pearcommerce.com', 'cdn.shopify.com'];
      let stylesheetUrl = new URL($stateParams.stylesheet);
      if (whitelist.indexOf(stylesheetUrl.hostname) < 0) {
        alert(
          'This widget uses a stylesheet hosted at ' +
            $stateParams.stylesheet +
            ".  A third party stylesheet can lead to XSS security vunerabilities.  If you are not a developer working on this widget, please close your browser.  To get rid of this warning, please contact Pear Commerce to whitelist your stylesheet's domain."
        );
      }
      let link = document.createElement('link');
      link.setAttribute('href', $stateParams.stylesheet);
      link.setAttribute('rel', 'stylesheet');
      document.body.prepend(link);
    }
    if (UPCSAndOffer && $stateParams.open_products) {
      UPCSAndOffer.UPCs.forEach((item) => {
        window.open('https://admin.pearcommerce.com/product_approve/' + item.id, '_blank');
      });
    }

    // Klayvio Test
    $scope.showKlayvio = false;
    $scope.showKlayvioForm = () => {
      $scope.showKlayvio = true;
    }
    $scope.closeKlayvioForm = () => {
      $scope.showKlayvio = false;
    }

    $scope.time = Date.now();
    // addFB();
    const offer = UPCSAndOffer.offer;

    $scope.offer = UPCSAndOffer.offer;
    
    $scope.shouldShowPrice = function () {
      const offerIdsWithPricePills = [2796484880466870, 2796484880466874, 2796484880466875, 2811462896418440, 2811462896418450];
      const offer = $scope.offer;
      if (!offer || !offer.id) return false;
      return offerIdsWithPricePills.includes(offer.id);
    };

    var completeAddPixelsPromise;
    $scope.addPixelsPromise = new Promise((onFulfilled, onRejected) => {
      completeAddPixelsPromise = async () => {
        // wait 500ms for any cookies to be laid down after the pixels are injected
        await new Promise((r) => setTimeout(r, 500));
        onFulfilled();
      };
    });

    $scope.PageLoad = PageLoad;
    $scope.pageLoadPromise = null;
    if (offer) {
      $scope.pageLoadPromise = pageLoadPromise = (async function () {
        // Wait for pixels to be added, or 3s to elapse
        await Promise.any([new Promise((r) => setTimeout(r, 3000)), $scope.addPixelsPromise]);

        let params = {
          admin: !!window.PEAR_COMMERCE_ADMIN,
          offerId: offer.id,
          params: window.location.search,
          bundleId: $stateParams.bundleId,
          cookie: document.cookie,
          hostname: window.location.hostname,
          notAsync: true,
        };
        if ($scope.pearclid) {
          params.id = $scope.pearclid;
        }
        const pageloadResp = await $api.post('/v1/page_load?timeout=2000', params, {
          failure: { id: -1, sessionId: -1 },
        });
        PageLoad = PageLoad || {};
        PageLoad.id = pageloadResp.id;

        window.PRODUCT_NAME = window.PRODUCT_NAME || '';
        window.RETAILER_NAME = window.RETAILER_NAME || '';
        window.PEARCLID = window.PEARCLID || PageLoad.id;
        $scope.$apply();
      })();

      if (typeof Weglot != 'undefined') {
        let initialized = false;
        let initializing = false;

        let hideLanguageSwitcher = offer.hideLanguageSwitcher;
        let languageTranslation = offer.languageTranslation;

        /*
          We want auto detect and switch to default browser or device language on some offers, e.g., minis canada.
          In this case, we use 'auto' for languageTranslation value.
          'auto', 'en', 'fr', ...
          */
        if (languageTranslation === 'auto') {
          const deviceLanguage = window.navigator.language || '';
          if (deviceLanguage.startsWith('en')) {
            languageTranslation = 'en';
          } else if (deviceLanguage.startsWith('fr')) {
            languageTranslation = 'fr';
          } else if (deviceLanguage.startsWith('es')) {
            languageTranslation = 'es';
          } else {
            languageTranslation = 'en';
          }
        }
        if (!!languageTranslation) {
          window.navigator.language = languageTranslation;
        }

        const switchLanguages = () => {
          /*
        Language Translation: directly set offer.languageTranslation in the database, and utilize it on the frontend.
        Updated API: https://github.com/Pear-Commerce/api.pearcommerce.com/pull/578
        */

          if (!!languageTranslation) {
            if (Weglot.initialized) {
              Weglot.switchTo(languageTranslation);
            } else if (initializing) {
              Weglot.on('initialized', () => {
                initialized = true;
                initializing = false;
                Weglot.switchTo(languageTranslation);
                $scope.$apply();
              });
            } else {
              Weglot.initialize({
                api_key: 'wg_1ecf050fb94882e0b6607643b16501899',
                hide_switcher: !!hideLanguageSwitcher,
                auto_switch: true,
                auto_switch_fallback: languageTranslation,
              });
              initializing = true;
            }
          }
        };

        switchLanguages();

        $scope.$on('$viewContentLoaded', function (event, toState, toParams, fromState, fromParams) {
          $timeout(() => {
            switchLanguages();
          }, 0);
        });
      }

      if (molsonOfferIds.includes(offer.id)) {
        setInnerHTML(
          $api,
          document.body,
          '<script src="https://assets.adobedtm.com/284fab1c816f/f6cbc4236afa/launch-ba57286307d7.min.js"></script>',
          null,
          null,
          null
        );
      }

      try {
        if (
          offer.offerType === 'PDP_PLUS' && 
          [CANIDAE_VENDOR_ID, NATURAL_BALANCE_VENDOR_ID].includes(offer.vendorId) && 
          !document.querySelector('link[href="/css/ethos_pet_pdp.css"]')
        ) {
          const ethosPetCSS = document.createElement('link');
          ethosPetCSS.rel = 'stylesheet';
          ethosPetCSS.href = '/css/ethos_pet_pdp.css';
          document.head.appendChild(ethosPetCSS);
        }

        // Elanco landing page offers should include their TrustArc script
        if (offer.vendorId === ELANCO_VENDOR_ID && offer.offerType === 'LANDING_PAGE' && !document.querySelector(`script[src="${ELANCO_TRUST_ARC}"]`)) {
          const elancoTrustArcScript = document.createElement('script');
          elancoTrustArcScript.src = ELANCO_TRUST_ARC;
          elancoTrustArcScript.async = true;
          
          document.head.insertBefore(elancoTrustArcScript, document.head.firstChild);
        }
      } catch (e) {
        console.error(e);
      }
    }

    window.addEventListener(
      'focus',
      function (e) {
        if (e.target.id == 'floatingInput' && $scope.vistedMapElements == false) {
          $scope.focuseInStoreTab = true;
        }
      },
      true
    );

    $scope.isMobileLayout = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 992;
    $scope.molsonOfferIds = molsonOfferIds;

    $scope.calculateMobileLayout = () => {
      return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 992;
    }

    $scope.getMobileLayoutTabIndex = () => {
      return $scope.isMobileLayout ? 0 : -1;
    }


    $scope.shouldShowProductsForFilter = function () {
      let shouldShowProducts = $scope.productsOpen;

      if ($scope.categories.length > 0 && $scope.selectedCategories.length < 1) {
        shouldShowProducts = false;
      }

      return shouldShowProducts;
    };

    document.addEventListener('keydown', async (event) => {
      var buyOnlineTab = document.querySelector('#buy-online-tab');
      var inStoreTab = document.querySelector('#in-store-tab');
      var mapTab = document.querySelector('#map-tab');
      var vistedMapContainer = document.querySelector('#map');
      var vistedFilterBtn = document.querySelector('.back-to-products');
      if (
        document.activeElement === inStoreTab ||
        document.activeElement === vistedMapContainer ||
        document.activeElement === vistedFilterBtn
      ) {
        $scope.vistedMapElements = true;
      }

      if (event.key === 'Escape' || event.keyCode === 27) {
        // Catch 'Esc' to close modal from parent window
        window.parent.postMessage('pear-modal-close', '*');
        if ($scope.productsOpen && $scope.productsOpen == true && document.querySelector('.back-to-products')) {
          document.querySelector('.back-to-products').click();
          await Util.timeout(200);
          document.querySelector('.back-to-products').focus();
        }
      } else if (event.key === 'ArrowRight') {
        // Catch 'ArrowRight' to navigate tabs in store locator for a11y
        let nextTabId = '';
        if (document.activeElement === inStoreTab) {
          nextTabId = '#buy-online-tab';
        } else if (document.activeElement === buyOnlineTab) {
          if (!!$scope.isMobileLayout) nextTabId = '#map-tab';
          else nextTabId = '#in-store-tab';
        } else if (document.activeElement === mapTab && !!$scope.isMobileLayout) {
          nextTabId = '#in-store-tab';
        }

        if (nextTabId) {
          document.querySelector(nextTabId).click();
          await Util.timeout(200);
          document.querySelector(nextTabId).focus();
        }
      } else if (event.key === 'ArrowLeft') {
        // Catch 'ArrowRight' to navigate tabs in store locator for a11y
        let nextTabId = '';
        if (document.activeElement === inStoreTab) {
          if (!!$scope.isMobileLayout) nextTabId = '#map-tab';
          else nextTabId = '#buy-online-tab';
        } else if (document.activeElement === buyOnlineTab) {
          nextTabId = '#in-store-tab';
        } else if (document.activeElement === mapTab && !!$scope.isMobileLayout) {
          nextTabId = '#buy-online-tab';
        }

        if (nextTabId) {
          document.querySelector(nextTabId).click();
          await Util.timeout(200);
          document.querySelector(nextTabId).focus();
        }
      }
    });

    // Handle Shift + Tab keydown for off map focus element
    const offMapFocusSpanEl = document.querySelector('#off-map-focus');
    if (offMapFocusSpanEl) {
      offMapFocusSpanEl.addEventListener('keydown', async (event) => {
        if (event.key === 'Tab' && event.shiftKey) {
          event.preventDefault();

          const searchButtonEl = document.querySelector('#search-button');
          const navTabsEl = document.querySelector('.nav-tabs .nav-item.active');

          if ($scope.isMobileLayout && navTabsEl) {
            navTabsEl.focus();
          } else if (searchButtonEl) {
            searchButtonEl.focus();
          }
        }
      });
    }

    if (PageLoad && PageLoad.id) {
      $scope.pearclid = (PageLoad && PageLoad.id) || 0;
      window.PEARCLID = $scope.pearclid + '';
    } else {
      const loadPageLoad = $async(async () => {
        if (window.pearPageLoad) {
          return window.pearPageLoad;
        }
        const offerId = (offer && offer.id) || ($stateParams.offerId || '0').replace(/\D/g, '');
        return await $api.post(
          '/v1/page_load?timeout=2000',
          {
            admin: !!window.PEAR_COMMERCE_ADMIN,
            offerId: offerId,
            params: window.location.search,
            bundleId: $stateParams.bundleId,
            cookie: document.cookie,
            hostname: window.location.hostname,
            notAsync: true,
          },
          { failure: { id: -1, sessionId: -1 } }
        );
      });
      setTimeout(
        $async(async () => {
          if ($scope.pageLoadPromise != null) {
            PageLoad = await $scope.pageLoadPromise;
          } else {
            PageLoad = await loadPageLoad();
          }
          if (PageLoad && PageLoad.id) {
            $scope.pearclid = (PageLoad && PageLoad.id) || 0;
            window.PEARCLID = $scope.pearclid + '';
          }
        }),
        1
      );
    }

    $scope.reimbursementInfo = ReimbursementInfo;
    if (ReimbursementInfo) {
      $scope.claimOfferModal = {
        claimOfferModal: false,
        email: ReimbursementInfo.email,
        method: ReimbursementInfo.method,
      };
      if (!$scope.claimOfferModal.method) {
        $scope.claimOfferModal.method = 'PayPal';
      }
    }
    $scope.saveReimbursementInfo = function () {
      return $api.post('/v1/reimbusement', $scope.reimbursementInfo).then(function () {
        return true;
      });
    };

    $scope.claimOffer = function () {
      $scope.claimOfferModal.retailer = false;
      $scope.claimOfferModal.claimOfferModal = true;
    };

    $scope.submitClaim = function () {
      $scope.reimbursementInfo.email = $scope.claimOfferModal.email;
      $scope.reimbursementInfo.method = $scope.claimOfferModal.method;
      $api.post('/v1/reimbusement?timeout=2000', $scope.reimbursementInfo).then(function () {
        $scope.claimOfferModal.claimOfferModal = false;

        if ($scope.claimOfferModal.retailer) {
          $scope.clickRetailer($scope.claimOfferModal.retailer, $scope.selectedPearLogicalUPC, null, null, true);
        }
      });
    };

    $scope.selectedShortName = null;
    $scope.pdpShortNames = [];
    $scope.pdpShortNameSummary = {};
    $scope.pickerListFilteredByShortName = {};

    if (Array.isArray(UPCSAndOffer.UPCs)) {
      $scope.pdpShortNameSummary = UPCSAndOffer.UPCs.reduce((prev, aUpc) => {
        const {
          id,
          pdpShortName,
          UPC,
          upcIds,
          sortOrder,
        } = aUpc;

        return Object.assign({}, prev, { [pdpShortName]: { id, pdpShortName, sortOrder, UPC, upcIds }});
      }, {});

      $scope.pdpShortNames = Object.keys($scope.pdpShortNameSummary).sort((a, b) => {
        const aSortOrder = $scope.pdpShortNameSummary[a].sortOrder || 0;
        const bSortOrder = $scope.pdpShortNameSummary[b].sortOrder || 0;

        return b - a;
      });

      $scope.selectedShortName = $scope.pdpShortNames[0];
    }

    $scope.getDefaultPdpShortName = function () {
      return $scope.pdpShortNames[0];
    };

    $scope.getCurrentPdpShortName = function () {
      return $scope.selectedShortName || $scope.getDefaultPdpShortName();
    }

    $scope.shortNameSelectChanged = function () {
      const selectMenuValue = document.getElementById('available-size')?.value;
      $scope.selectShortName(selectMenuValue);
    }

    $scope.selectShortName = function (shortName) {
      if ($scope.pdpShortNames.indexOf(shortName) >= 0) {
        $scope.selectedShortName = shortName;
      } else {
        console.error('Tried selecting a short name that does not exist');
      }
    };

    $scope.getPickerList = function () {
      // Do not memoize anything until we have results
      // And if we never have results, net affect is
      // the same. Returning anything dynamic here results
      // in AngularJS digest issues *rolls eyes*
      if ($scope.pickerList.length < 1 || !$scope.showPdpShortNameAsDropdown) {
        return $scope.pickerList;
      }

      const selectedPdpShortName = $scope.getCurrentPdpShortName();

      if (Array.isArray($scope.pickerListFilteredByShortName[selectedPdpShortName])) {
        return $scope.pickerListFilteredByShortName[selectedPdpShortName];
      }

      const filteredPickerList = $scope.pickerList.reduce((prev, retailerDef) => {
        if (Array.isArray(retailerDef.upcs)) {
          const upcsToInclude = retailerDef.upcs.filter(upc => upc.pdpShortName === selectedPdpShortName);
          if (upcsToInclude.length > 0) {
            const filteredRetailerObject = Object.assign({ }, { ...retailerDef}, { upcs: upcsToInclude });
            prev.push(filteredRetailerObject);
          }

          return prev;
        }
      }, []);

      $scope.pickerListFilteredByShortName[selectedPdpShortName] = filteredPickerList;

      return $scope.pickerListFilteredByShortName[selectedPdpShortName];
    }

    $scope.toggleElem = function (array, elem) {
      $scope.selectedCategories = [];
      const idx = array.indexOf(elem);
      if (idx >= 0) {
        array.splice(idx, 1);
      } else {
        array.push(elem);
      }
    };

    $scope.getLogicalUPCDisplayName = (logicalUPC) => {
      const { name, shortName } = logicalUPC;
      return logicalUPC.name.length > 65 && logicalUPC.shortName ? logicalUPC.shortName : logicalUPC.name;
    };

    $scope.getLogicalUPCImage = (logicalUPC) => {
      return Util.patchImageUrl(logicalUPC.imageUrl || 'https://assets-cf.pearcommerce.com/comingsoon.png');
    };

    $scope.onDesktopInStoreButtonClick = (e, onFocus) => {
      e.stopPropagation();
      e.preventDefault();

      // Turn everything off by default
      $scope.findOnline = 0;
      $scope.productsOpen = false;
      $scope.showDesktopBuyOnlineTab = false;

      // Toggle the In Store setting
      if (!onFocus) {
        $scope.showDesktopInStoreListing = !$scope.showDesktopInStoreListing;

        // "Hide" the scroll indicator for product by setting the width to 0;
        // Reset the scroll width of the scroll indicator for stores
        document.getElementById('scroll-progress-product').style.width = 0;
        document.getElementById('scroll-progress-stores').style.width = $scope.scrollProgressStoresWidth || 0;
      }
    };

    $scope.onDesktopBuyOnlineButtonClick = (e) => {
      e.stopPropagation();
      e.preventDefault();

      // Turn everything off by default
      $scope.findOnline = 0;
      $scope.productsOpen = false;
      $scope.showDesktopInStoreListing = false;

      // Toggle the Buy Online setting
      $scope.showDesktopBuyOnlineTab = !$scope.showDesktopBuyOnlineTab;
    }

    $scope.onProductFilterClick = (e) => {
      e.stopPropagation();
      e.preventDefault();

      // Toggle that div.
      $scope.productsOpen = !$scope.productsOpen;
      $scope.mapOnly = 0;
      $scope.setOpenPanelFocus();
    };

    $scope.onProductFilterClickV2 = (e) => {
      e.stopPropagation();
      e.preventDefault();
      document.activeElement?.blur();

      // Toggle that div.
      $scope.productsOpen = !$scope.productsOpen;
      $scope.showDesktopInStoreListing = false;
      $scope.showDesktopBuyOnlineTab = false;
      $scope.setOpenPanelFocus();

      // "Hide" the scroll indicator for store by setting the width to 0;
      // Reset the scroll width of the scroll indicator for products
      const scrollProgressStores = document.getElementById('scroll-progress-stores');
      if (scrollProgressStores) {
        scrollProgressStores.style.width = 0;
      }
      const scrollProgressProduct = document.getElementById('scroll-progress-product');
      if (scrollProgressProduct) {
        scrollProgressProduct.style.width = $scope.scrollProgressProductWidth || 0;
      }

      const vendorId = $scope.vendor.id;

      if (
        $scope.selectedCategories.length < 1 &&
        $scope.singleItemSelect === true &&
        $scope.selectedUPCs.length === 1
      ) {
        const logicalUPCDefinition = $scope.pearLogicalUPCs.find(element => element.id === $scope.selectedUPCs[0]);
        if (typeof logicalUPCDefinition !== 'undefined' && Array.isArray(logicalUPCDefinition.categories)) {
          $scope.selectedCategories = [...logicalUPCDefinition.categories];
        }
      }
      
      if (
        $scope.selectedCategories.length < 1 &&
        typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.default !== 'undefined'
      ) {
        $scope.selectCategory(ENRICHED_CATEGORY_CONFIG[vendorId].default)
      }
    };

    $scope.shouldShowControlMenu = () => {
      return $scope.productsOpen ||
      (Array.isArray($scope.selectedUPCsForBuyOnline) && $scope.selectedUPCsForBuyOnline.length) ||
      $scope.showDesktopInStoreListing ||
      $scope.showDesktopBuyOnlineTab;
    }
    $scope.getSelectedProduct = function() {
      let ret = $scope.upcIdsToLogicalUPC[$scope.selectedUPCs[0]];
      return ret;
    }

    // Flag to prevent map clicks from closing products panel during selection
    $scope.preventMapClick = false;

    $scope.getNumberOfAvailableRetailers = function () {
      // Single-item mode
      if ($scope.singleItemSelect) {
        const retailers = $scope.pickerListDisplayCached($scope.getSelectedProduct(), true);
        return retailers.length;
      }
    
      // Multi-product mode - use the pre-calculated retailer array if available
      if ($scope.availableRetailersForMultiSelect?.length) {
        const uniqueRetailers = [...new Set($scope.availableRetailersForMultiSelect.map(r => r.id))]
        return uniqueRetailers.length;
      }
      
      return 0;
    };
    

    $scope.productCarouselIndex = {
      productCarouselIndex : 0
    };

    $scope.$watch('productCarouselIndex.productCarouselIndex', function (newVal, oldVal) {
      if ($scope.singleItemSelect) {

        if (oldVal != newVal) {
          $scope.toggleProductFilter($scope.getProductsToDisplay()[$scope.productCarouselIndex.productCarouselIndex])
        }
      }
    });


    $scope.toggleProductFilter = function (logicalUpc) {
      let index = $scope.getProductsToDisplay().indexOf(logicalUpc);
      $scope.productCarouselIndex.productCarouselIndex = index;
      const logicalUpcId = logicalUpc.id;
      
      if ($scope.singleItemSelect) {
        // For single item select, always replace the selection
        $scope.selectedUPCs = [logicalUpcId];
        $scope.selectedUPCsForBuyOnline = [logicalUpcId];
        return;
      }
      
      // For multi-select, toggle the selection
      if ($scope.selectedUPCsForBuyOnline.indexOf(logicalUpcId) >= 0) {
        // Remove from both arrays
        $scope.selectedUPCs = $scope.selectedUPCs.filter(item => item != logicalUpcId);
        $scope.selectedUPCsForBuyOnline = $scope.selectedUPCsForBuyOnline.filter(item => item != logicalUpcId);
        
        // Remove retailers for this product from availableRetailersForMultiSelect
        const retailersForThisProduct = $scope.pickerListDisplayCached(logicalUpc, true);
        
        // Remove only the first occurrence of each retailer
        retailersForThisProduct.forEach(retailerToRemove => {
          const indexToRemove = $scope.availableRetailersForMultiSelect.findIndex(retailer => 
            retailer.id === retailerToRemove.id
          );
          if (indexToRemove !== -1) {
            $scope.availableRetailersForMultiSelect.splice(indexToRemove, 1);
          }
        });
      } else {
        // Add to both arrays
        $scope.selectedUPCs.push(logicalUpcId);
        $scope.selectedUPCsForBuyOnline.push(logicalUpcId);

        
        // Add retailers for this product to availableRetailersForMultiSelect
        const retailersForThisProduct = $scope.pickerListDisplayCached(logicalUpc, true);
        retailersForThisProduct.forEach(retailer => {
            $scope.availableRetailersForMultiSelect.push(retailer);
        });
      }
    };
   
    $scope.toggleProduct = function (array, product) {
      $scope.selectedCategories = [];
      const idx = array.indexOf(product.id);

      const remove = idx >= 0;
      if ($scope.singleItemSelect && remove) {
        return;
      }

      if (remove) {
        array.splice(idx, 1);
      } else {
        if ($scope.singleItemSelect) {
          array.splice(0, array.length);
        }
        array.push(product.id);
      }

      (($scope.upcsByName || {})[product.name] || [])
        .filter((upc) => upc.id != product.id)
        .forEach((otherUPC) => {
          let otherIdx = array.indexOf(otherUPC.id);
          if (remove && otherIdx >= 0) {
            array.splice(otherIdx, 1);
          } else if (!remove && otherIdx == -1) {
            array.push(otherUPC.id);
          }
        });
    };

    $scope.productSearchQuery = '';

    $scope.productFilter = function(product) {
      // Filter by product search query
      if ($scope.productSearchQuery) {
        const searchQuery = $scope.productSearchQuery.toLowerCase();
        
        // Search in name
        if (product.name && product.name.toLowerCase().includes(searchQuery)) {
          // Continue to other filters
        } else if (product.UPC && product.UPC.includes(searchQuery)) {
          // Continue to other filters
        } else {
          return false; // Doesn't match search query
        }
      }
      
      // Filter by product category
      if ($scope.shouldIncludeUpcBasedOnCategory && !$scope.shouldIncludeUpcBasedOnCategory(product)) {
        return false;
      }
      
      return true;
    };

    $scope.isMobile = isMobile();

    $scope.stores = [];
    $scope.location = $scope.location || {};
    if ($stateParams.address) {
      $scope.location.location = $stateParams.address;
      $scope.freezeLocation = $scope.location.location;
    }
    if ($stateParams.countryCode) {
      $scope.location.countryCode = $stateParams.countryCode;
    } else if (!$stateParams.zip && !$stateParams.latitude && !$stateParams.longitude) {
      // No location in URL, get current location
      getCurrentLocation(STADIA_MAPS_CONFIG) 
        .then(locationData => {
          $scope.location.location = locationData.locationString;
          $scope.location.latitude = locationData.latitude;
          $scope.location.longitude = locationData.longitude;
          $scope.location.zip = locationData.zip;
          $scope.freezeLocation = locationData.locationString;
          $scope.$apply();
        })
        .catch(error => {
          console.error('Error getting current location:', error);
        });
    }

    //Address input config related configuration
    $scope.blurInputPlaceholder = false;
    $scope.clearAddressInput = () => {
      if ($scope.addressInputTextBehavior == 'TRANSPARENT_PLACEHOLDER') {
        $scope.blurInputPlaceholder = true;
      } else if ($scope.addressInputTextBehavior == 'EDITABLE') {
        $scope.location.location = '';
      }
    };

    $scope.blurAddressInput = () => {
      if ($scope.addressInputTextBehavior == 'TRANSPARENT_PLACEHOLDER') {
        $scope.blurInputPlaceholder = false;
      }
    };

    if (LocationData) {
      if (LocationData.success == false && LocationData.error && $state.current.name == 'product-locator') {
        LocationData.city = 'Milwaukee';
        LocationData.zip = '53202';
        LocationData.country_name = 'USA';
        LocationData.country_code = 'US';
        LocationData.latitude = 43.05;
        LocationData.longitude = -87.9;
      }

      if (!$scope.location.location || $scope.location.location.indexOf('undefined') != -1) {
        $scope.location.location =
          (LocationData.city || '') +
          ', ' +
          (LocationData.region_code ? LocationData.region_code + ' ' : '') +
          (LocationData.zip || '') +
          ', ' +
          (LocationData.country_name || '');
        $scope.freezeLocation = $scope.location.location;
      }
      if ($stateParams.latitude) {
        $scope.location.latitude = parseFloat($stateParams.latitude + '');
        $scope.location.longitude = parseFloat($stateParams.longitude + '');
      } else {
        $scope.location.latitude = LocationData.latitude;
        $scope.location.longitude = LocationData.longitude;
      }

      $scope.location.zip = LocationData.zip;
      // Extract countryCode from IP-based LocationData if available
      if (LocationData.country_code && !$stateParams.countryCode && !$scope.location.countryCode) {
        $scope.location.countryCode = LocationData.country_code;
      }
    } else if (!$scope.freezeLocation) {
      $scope.location.freezeLocation = 'Please enter your address.';
    }

    // Fetch countryCode if we have coordinates but no countryCode
    if ($scope.location.latitude && $scope.location.longitude && !$scope.location.countryCode && !$stateParams.countryCode) {
      (async () => {
        try {
          const countryCode = await getCountryCodeFromCoordinates($scope.location.latitude, $scope.location.longitude, STADIA_MAPS_CONFIG, geocodingCache);
          if (countryCode) {
            $scope.location.countryCode = countryCode;
            $scope.$apply();
            
            // Update URL with countryCode if we have other location params
            if ($stateParams.latitude || $stateParams.longitude || $stateParams.address) {
              const params = Object.assign({}, $stateParams, {
                countryCode: countryCode
              });
              $state.go($state.current, params, { location: true, reload: false });
            }
          }
        } catch (error) {
          console.error('Error fetching countryCode from coordinates:', error);
        }
      })();
    }

    const scrollboxContainer = document.querySelector('.input-button-el.scrollbox');
    if (scrollboxContainer) {
      scrollboxContainer.onscroll = function () {
        this.previousElementSibling.classList[this.scrollTop > 20 ? 'add' : 'remove']('shadow-bottom');
      };
    }

    $scope.mapTypes = ['address'];

    $scope.upcs = UPCS.UPCs;
    $scope.getSelectedProductNames = function() {
      if ($scope.selectedUPCsForBuyOnline.length > 1) {
        return "";
      }
      let items = $scope.upcs.filter(u => {
        return $scope.selectedUPCsForBuyOnline.indexOf(u.id) >= 0
      }).map(u=>{
        return u.name;
      });

      return items[0];
    }
    if (PixelConfig) {
      injectWidgetConfig(PixelConfig);
    }
    if (UPCSAndOffer) {
      $scope.offer = UPCSAndOffer.offer || {};
      if ($scope.offer) {
        $scope.offer.imageUrl = Util.patchImageUrl($scope.offer.imageUrl);
      }

      // TODO: This kinda stinks BUT so does AngularJS
      $scope.offer.isGMIVendor = () => {
        var offerVendorId = $scope.offer?.vendor?.id || 0;

        var GMIVendorIDs = [
          '1696427556640128',
          '1696468199249344',
          '1734042825103840',
          '1734083929103520',
          '1740123881433056',
          '1740596604848896',
          '1740598946860032',
          '1740599912803520',
          '1740601367923712',
          '1740604570364704',
          '1740604867136384',
          '1740605269248864',
          '1740606418308064',
          '1740607387970560',
          '1740607793810208',
          '1740610128669664',
          '1748914295165152',
          '1748990756802720',
          '2007163631280128',
          '2046799198901792',
          '2131078367895392',
          '2210278491650128',
          '2251373106939032',
          '2257040074721984',
          '2260578612657120',
          '2265511185853328',
          '2283837574305960',
          '2289484587179496',
          '2294432439173344',
          '2298702421233579',
          '2304775165551595',
          '2308568875449886',
          '2383772055925774',
          '2413428860527454',
          '2562248684474433',
        ];

        return GMIVendorIDs.indexOf(`${offerVendorId}`) >= 0;
      };

      // TODO - molson footer
      $scope.isMolsonFooter = molsonOfferIds.includes($scope.offer.id);

      document.querySelector('title').innerHTML = $scope.offer.name;
      if ($scope.offer.faviconUrl != null) {
        document.querySelector('link').href = $scope.offer.faviconUrl;
      }
      if ($scope.offer && $scope.offer.pickerStylesheet) {
        $timeout(() => {
          const sibling = document.querySelector('#picker-container div');
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = $scope.offer.pickerStylesheet;
          link.media = 'all';
          sibling.parentNode.insertBefore(link, sibling);
        }, 0);
      }

      $scope.vendor = UPCSAndOffer.vendor;
      if ($scope.vendor) {
        document.querySelector('title').innerHTML = $scope.vendor.name;
        $scope.categories = [];
        $scope.categoryMetaData = {};
        $scope.enrichedCategories = false;

        const vendorId = $scope.vendor.id;

        const categoryToUPCs = {};
        let uniqueCategories = new Set();

        UPCSAndOffer.UPCs.forEach((upc) => {
          let categoryName;
          if (typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.mapper === 'function') {
            categoryName = ENRICHED_CATEGORY_CONFIG[vendorId].mapper(upc.UPC);
          }

          if (upc.name && upc.UPC && ((upc.categories && Array.isArray(upc.categories) && upc.categories.length > 0) || categoryName)) {
            let upcCategoryList = upc.categories != null ? upc.categories : [];
            if (!Array.isArray(upc.categories) || upc.categories.length === 0) {
              upcCategoryList = [categoryName];
              upc.categories = [categoryName];
            }
            upcCategoryList.forEach((category) => {

              categoryToUPCs[category] = categoryToUPCs[category] || [];
              categoryToUPCs[category].push(upc);
              uniqueCategories.add(category);
            });
          }
        });

        // Sort using order found in the database on UPC.categories, then alphabetically unless
        // a custom sort on a per-vendor basis is specified.
        $scope.categories = Array.from(uniqueCategories)
          .filter((category) => Array.isArray(categoryToUPCs[category]) && categoryToUPCs[category].length > 0);
        
        if (
          $scope.categories.length > 0 &&
          typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.sortOrder === 'object'
        ) {
          $scope.categories = $scope.categories.sort((a, b) => {
            const aSortOrder = ENRICHED_CATEGORY_CONFIG[vendorId].sortOrder[a] || 100;
            const bSortOrder = ENRICHED_CATEGORY_CONFIG[vendorId].sortOrder[b] || 100;

            return aSortOrder - bSortOrder;
          });
        } else {
          $scope.categories = $scope.categories.sort((a, b) => {
            let idxA, 
                idxB = null;

            UPCSAndOffer.UPCs.forEach((upc, i) => {
              if (Array.isArray(upc.categories)) {
                if (upc.categories.indexOf(a) >= 0 && idxA === null) {
                  idxA = i;
                }

                if (upc.categories.indexOf(b) >= 0 && idxB === null) {
                  idxB = i;
                }
              }
            });

            let result;
            if (idxA === null && idxB === idxA) {
              result = a.localeCompare(b);
            } else {
              result = (idxA !== null ? idxA : 1000) - (idxB !== null ? idxB : 1000);
            }

            return result;
          });

          // TODO make this configurable
          // Sort by first word then length
          $scope.categories = $scope.categories.sort((a, b) => {
            const firstWordA = a.split(' ')[0];
            const firstWordB = b.split(' ')[0];
            return firstWordA === firstWordB ? 0 : firstWordA.localeCompare(firstWordB);
          });
        }

        if (
          $scope.categories.length > 0 &&
          typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.images === 'function'
        ) {
          $scope.enrichedCategories = true;

          $scope.categories.forEach((categoryName) => {
            $scope.categoryMetaData[categoryName] =
            ENRICHED_CATEGORY_CONFIG[vendorId].images(categoryName);
          });
        }

        $scope.selectedCategories = [];
        $scope.filterSelectedRetailerIds = [];
        $scope.selectedUPCs = [];
        $scope.selectedUPCsForBuyOnline = [];
        $scope.availableRetailersForMultiSelect = [];

        $scope.isProductSelected = function(logicalUpc) {
          return $scope.selectedUPCs.indexOf(logicalUpc.id) >= 0;
        };

        $scope.selectCategory = function (category) {
          if ($scope.selectedCategories.indexOf(category) === -1) {
            $scope.selectedCategories.push(category);

            if (Array.isArray($scope.pearLogicalUPCs)) {
              // We've selected a category, we only want one item to start selected
              // and we've not selected any product yet so we want to add just the
              // first product for the given category.
              if ($scope.singleItemSelect) {
                const firstMatchingUpc = $scope.pearLogicalUPCs.find(item => Array.isArray(item.categories) && item.categories.indexOf(category) >= 0);
                if (typeof firstMatchingUpc !== 'undefined') {
                  const firstMatchingUpcId = firstMatchingUpc.id;

                  if ($scope.selectedUPCs.length < 1) {
                    $scope.selectedUPCs = [firstMatchingUpc.id];
                  }

                  if ($scope.selectedUPCsForBuyOnline.length < 1) {
                    $scope.selectedUPCsForBuyOnline = $scope.selectedUPCs = [firstMatchingUpc.id];
                  }
                }
              } else {
                $scope.pearLogicalUPCs.forEach((logicalUPC) => {
                  if (Array.isArray(logicalUPC.categories) && logicalUPC.categories.indexOf(category) >= 0) {
                    $scope.selectedUPCs.push(logicalUPC.id);
                    $scope.selectedUPCsForBuyOnline = $scope.selectedUPCsForBuyOnline.concat($scope.upcIdsToLogicalUPC[logicalUPC.id].upcIds);
                  }
                });
              }
            }
          }
        };

        $scope.deselectCategory = function (category) {
          if (Array.isArray($scope.selectedCategories) && $scope.selectedCategories.indexOf(category) >= 0) {
            $scope.selectedCategories = $scope.selectedCategories.filter(cat => cat !== category);
            if (Array.isArray($scope.pearLogicalUPCs)) {
              $scope.pearLogicalUPCs.forEach((logicalUPC) => {
                if (Array.isArray(logicalUPC.categories) && logicalUPC.categories.indexOf(category) >= 0) {
                  $scope.selectedUPCs = $scope.selectedUPCs.filter(upc => upc !== logicalUPC.id);
                  $scope.selectedUPCsForBuyOnline = $scope.selectedUPCsForBuyOnline.filter(buyOnlineUPC => $scope.upcIdsToLogicalUPC[logicalUPC.id].upcIds.indexOf(buyOnlineUPC) === -1);
                }
              });
            }
          }
        };

        $scope.getDefaultCategoryDropDownText = function() {
          return $scope.selectedCategories.length > 0 ? $scope.selectedCategories[0] : 'Select a Category';
        };

        $scope.toggleCategory = function (category) {
          $scope.productCarouselIndex.productCarouselIndex = 0;
          if (Array.isArray($scope.selectedCategories) && $scope.selectedCategories.indexOf(category) === -1) {
            if ($scope.selectedCategories.length === 1) {
              $scope.deselectCategory($scope.selectedCategories[0]);
            }
            $scope.selectCategory(category);
          } else {
            $scope.deselectCategory(category);
          }
        };

        $scope.filterSelectedRetailerId = function (id) {
          if (Array.isArray($scope.filterSelectedRetailerIds) && $scope.filterSelectedRetailerIds.indexOf(id) === -1) {
            $scope.filterSelectedRetailerIds.push(id);
          } else {
            $scope.filterSelectedRetailerIds = [id];
          }
        };

        $scope.validLogicalUPC = function (logicalUpc) {
          return logicalUpc?.name?.length > 0;
        }

        $scope.shouldIncludeUpcBasedOnCategory = function (logicalUpc) {
          const logicalUpcCategories = new Set(Array.isArray(logicalUpc.categories) ? logicalUpc.categories : []);
          const selectedCategories = new Set(Array.isArray($scope.selectedCategories) ? $scope.selectedCategories : []);
          let shouldIncludeUpc = true;
          //console.log(selectedCategories);
          let test = [...selectedCategories].filter(value => [...logicalUpcCategories].indexOf(value) > -1);
          if (logicalUpcCategories.has('IGNORE')) {
            shouldIncludeUpc = false;
          } else if (selectedCategories.size > 0 && [...selectedCategories].filter(value => [...logicalUpcCategories].indexOf(value) > -1).length == 0) {
            shouldIncludeUpc = false;
          }
        

          return shouldIncludeUpc;
        };

        $scope.getProductsToDisplay = function () {
          const domainsToMatch = [
            'assets.pearcommerce.com',
            'demos.pearcommerce.com',
            'assets-cf.pearcommerce.com',
            'demos-cf-1.pearcommerce.com',
          ];

          return $scope.pearLogicalUPCsForDisplay.reduce((prev, logicalUPC) => {
            if ($scope.validLogicalUPC(logicalUPC) && $scope.shouldIncludeUpcBasedOnCategory(logicalUPC) && $scope.checkProductBrand(logicalUPC) && $scope.hideProduct(logicalUPC)) {
              prev.push(logicalUPC);
            }
            return prev.map((upc) => {
              if (window.resizeImages && upc.imageUrl?.length && domainsToMatch.some(str => str.includes(upc.imageUrl))) {
                upc.imageUrl = upc.imageUrl
                  .replace('s3.amazonaws.com/', '')
                  .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
                  .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
                  .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
                  .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
              }
              
              return upc;
            }, []);
          }, []);
        };
      }
    }

    async function failureRetailerList() {
      try {
        return await (
          await fetch(
            'https://assets.pearcommerce.com/retailer-list/' +
              $scope.offer.id +
              '/' +
              LocationData.region_code +
              '?' +
              new Date().getTime()
          )
        ).json();
      } catch {
        return [];
      }
    }

    // Send content loaded event to parent window
    window.parent.postMessage('pear-modal-loaded', '*');
    const mobileContainer = document.querySelector('.pear-attrib');
    if (mobileContainer) {
      mobileContainer.addEventListener('focus', (event) => {
        window.parent.postMessage('pear-modal-close-focus', '*');
      });
    }

    const getBottomTrapElement = () => {
      const seeMoreRetailersElement = document.querySelector('#see-more-retailers');
      const pickerElements = document.querySelectorAll('a.pear-button-el[id*="-picker"]');
      let bottomTrapElement = null;
      if (seeMoreRetailersElement) bottomTrapElement = seeMoreRetailersElement;
      else if (pickerElements.length > 0) {
        bottomTrapElement = pickerElements[pickerElements.length - 1];
      }
      return bottomTrapElement;
    };

    $scope.ageGateConfirmed = { ageGateConfirmed: false };

    $scope.inWidget = $stateParams.inWidget;
    $scope.hideCreative = $stateParams.hideCreative == 'true' || $scope.offer.hideCreative;
    $scope.hideAddress = $stateParams.hideAddress == 'true' || ($scope.offer && $scope.offer.noAddress);
    $scope.hideCarousel = $stateParams.hideCarousel == 'true' || ($scope.offer && $scope.offer.hideCarousel);
    $scope.removeMobileCarousel = ($scope.offer && $scope.offer.removeMobileCarousel) || false;
    $scope.offerBlockPearFooter = ($scope.offer && $scope.offer.blockPearFooter) || false;
    $scope.showDesktopInStoreListing = false;
    $scope.showDesktopBuyOnlineTab = false;

    if ($scope.offer) {
      if ($scope.offer.id + '' == '1809066080428224') {
        $scope.fosterFarms = true;
      }
    }

    //https://irxcm.com/RevTrax/cpn?parent=mydiv&merchantId=40033318&programId=107388139&affiliateId=4045214&rx_channel=brand&channel=brand&claim_on_page=true
    //https://irxcm.com/RevTrax/cpn?parent=mydiv&merchantId=40033318&programId=107388139&affiliateId=40452149&rx_channel=brand&channel=brand&null
    $scope.claimFosterFarmsOffer = function () {
      if (window.fbq) {
        window.fbq('track', 'StartTrial');
      }
      let img = document.createElement('img');
      img.src = 'https://insight.adsrvr.org/track/pxl/?adv=s40jl80&ct=0:37gnh4l&fmt=3';
      img.style.height = '1px';
      img.style.width = '1px';
      img.style.borderStyle = 'none';
      document.body.appendChild(img);
      const offerId = $scope.offer ? $scope.offer.id : 0;
      const vendorId = $scope.vendor ? $scope.vendor.id : 0;
      $api
        .post('/v1/custom_event', {
          offerId: offerId,
          vendorId: vendorId,
        })
        .then(() => {
          const open = window.open(
            'https://www.fosterfarms.com/coupons/take-out-crispy-chicken-sandwich-fillets-kabobs/?utm_source=pear&utm_medium=referral&utm_campaign=to-fil-q4-2021&utm_term=e29&utm_content=get',
            '_blank'
          );
          if (open == null || typeof open == 'undefined') {
            window.location =
              'https://www.fosterfarms.com/coupons/take-out-crispy-chicken-sandwich-fillets-kabobs/?utm_source=pear&utm_medium=referral&utm_campaign=to-fil-q4-2021&utm_term=e29&utm_content=get';
          }
        });
    };

    $scope.showPrintModal = { showPrintModal: false };
    $scope.claimCantuOffer = function () {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      $scope.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      $scope.android = !!ua.match(/Android/i);
      let fb = ($scope.fb = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1);
      let instagram = ($scope.instagram = ua.indexOf('Instagram') > -1);
      if ((fb || instagram) && !$stateParams.print) {
        $state.go('picker', { offerId: $stateParams.offerId, print: true });
        return;
      } else if (fb || instagram) {
        $scope.showPrintModal.showPrintModal = true;
      } else {
        const offerId = $scope.offer ? $scope.offer.id : 0;
        $api
          .post('/v1/custom_event', {
            offerId: offerId,
          })
          .then(() => {
            window.printJS('/img/Cantu_Coupon_Digital.jpg', 'image');
          });
      }
    };

    if ($stateParams.print) {
      $scope.claimCantuOffer();
    }

    $scope.googleMaps = function (location) {
      const offerId = $scope.offer ? $scope.offer.id : 0;
      const vendorId = $scope.vendor ? $scope.vendor.id : 0;
      $api
        .post('/v1/custom_event', {
          offerId: offerId,
          vendorId: vendorId,
        })
        .then(() => {
          const open = window.open(location, '_blank');
          if (open == null || typeof open == 'undefined') {
            window.location = location;
          }
        });
    };

    let pickerListDisplayCache = {};
    const retailerListsByZipAndSelectedUPCs = {};
    let injectedAfterRetailerList = false;
    let storeSelectRetailerListPromise = null;

    const initRetailerList = $async(async function (
      ResolveRetailerListInit,
      storeFinderListUpdate,
      zip,
      selectedUPCs,
      asyncResolveFalse,
      store
    ) {
      const triggerRenderImages = () => {
        $scope.renderImages = true;
        $timeout(() => {
          $scope.renderLowPriImages = true;
        }, 2500);
      };

      // wait for any async retailer list calls that have been triggered
      if (storeSelectRetailerListPromise) {
        await storeSelectRetailerListPromise;
      }

      let RetailerListInit = null;
      if (!zip && $scope.location && $scope.location.zip) {
        zip = $scope.location.zip;
      }

      $scope.retailerListDebugURL = `https://admin.pearcommerce.com/availability-inspector?vendorId=${
        ($scope.vendor && $scope.vendor.id) || ''
      }&offerId=${($scope.offer && $scope.offer.id) || ''}&postalCode=${zip}`;
      selectedUPCs = selectedUPCs && selectedUPCs.length ? selectedUPCs : null;
      const retailerListsBySelectedUPCs = (retailerListsByZipAndSelectedUPCs[zip] =
        retailerListsByZipAndSelectedUPCs[zip] || {});
      let cachedRetailerList = null;
      if (retailerListsBySelectedUPCs['null']) {
        cachedRetailerList = retailerListsBySelectedUPCs['null'];
      } else if (selectedUPCs) {
        Object.entries(retailerListsBySelectedUPCs).forEach(([upcs, retailerList]) => {
          if (selectedUPCs.filter((selectedUPC) => upcs.indexOf(selectedUPC) == -1).length == 0) {
            cachedRetailerList = retailerList;
          }
        });
      }

      let selectedUPCsForRetailerListInit = selectedUPCs;
      let retailerListFullFetchPromise = storeFinderListUpdate
        ? memoizedGetRetailerListPromise(
            $scope,
            $api,
            $stateParams,
            null,
            zip,
            selectedUPCsForRetailerListInit,
            asyncResolveFalse,
            $scope.pearclid,
            UPCSAndOffer
          )
        : null;

      $scope.renderImages = true;
      if (cachedRetailerList) {
        RetailerListInit = cachedRetailerList;

        if (
          USE_FIRST_UPC_ON_BIG_LIST &&
          selectedUPCsForRetailerListInit == null &&
          $state.current.name == 'product-locator' &&
          UPCS.UPCs.length > 30
        ) {
          selectedUPCsForRetailerListInit = [UPCS.UPCs[0].id];
        }
      } else if (ResolveRetailerListInit) {
        RetailerListInit = ResolveRetailerListInit;
      } else {
        if (
          USE_FIRST_UPC_ON_BIG_LIST &&
          selectedUPCsForRetailerListInit == null &&
          $state.current.name == 'product-locator' &&
          UPCS.UPCs.length > 30
        ) {
          selectedUPCsForRetailerListInit = [UPCS.UPCs[0].id];
        }

        $timeout(triggerRenderImages, 1000);
        RetailerListInit = await (retailerListFullFetchPromise ||
          memoizedGetRetailerListPromise(
            $scope,
            $api,
            $stateParams,
            null,
            zip,
            selectedUPCsForRetailerListInit,
            asyncResolveFalse,
            $scope.pearclid,
            UPCSAndOffer
          ));
      }
      try {
        let toMerge = await (retailerListFullFetchPromise ||
          memoizedGetRetailerListPromise(
            $scope,
            $api,
            $stateParams,
            null,
            zip,
            selectedUPCsForRetailerListInit,
            asyncResolveFalse,
            $scope.pearclid,
            UPCSAndOffer
          ));
        for (let i = 0; i < toMerge.length; i++) {
          let foundRetailerEnum = false;
          for (let j = 0; j < RetailerListInit.length; j++) {
            if (RetailerListInit[j].nameEnum == toMerge[i].nameEnum) {
              if (!RetailerListInit[j].style) {
                RetailerListInit[j].style = {};
              }
              RetailerListInit[j].style.sortOrder = toMerge[i].style.sortOrder;
              foundRetailerEnum = true;
            }
            if (!RetailerListInit[j].style) {
              RetailerListInit[j].style = {};
            }
            if (!RetailerListInit[j].style.sortOrder) {
              let maxSort = 0;
              for (let k = 0; k < toMerge.length; k++) {
                if (toMerge[k].style.sortOrder > maxSort) {
                  maxSort = toMerge[k].style.sortOrder;
                }
              }
              RetailerListInit[j].style.sortOrder = maxSort + 1;
            }
          }
          if (!foundRetailerEnum) {
            RetailerListInit.push(toMerge[i]);
          }
        }
      } catch (e) {
        console.error(e);
      }

      triggerRenderImages();

      if (zip) {
        retailerListsBySelectedUPCs[`${selectedUPCsForRetailerListInit}`] = RetailerListInit;
      }
      let retailerList = RetailerListInit;

      if ($scope.offer.offerType == 'RECIPE') {
        $scope.toggleAllRecipeProducts(0);
      } else {
        setTimeout(() => $scope.$apply(), 0);
      }

      // RetailerListInit = [];

      if (
        $scope.offer &&
        ($scope.offer.id + '' == '1826617134374081' ||
          $scope.offer.id + '' == '1699976141042688' ||
          $scope.offer.id + '' == '1699976141042689' ||
          (parseInt($scope.offer.id) >= 1699976141042690 && parseInt($scope.offer.id) <= 1699976141042696) ||
          $scope.offer.id + '' == '1833240034027009' ||
          $scope.offer.id + '' == '1833240034027010' ||
          $scope.offer.id + '' == '1833240034027011' ||
          $scope.offer.id + '' == '1699976141042698')
      ) {
        $scope.littmannMessage = true;
        try {
          retailerList.sort((a, b) => {
            return ((a && a.style && a.style.sortOrder) || 0) - ((b && b.style && b.style.sortOrder) || 0);
          });

          let firstRetailer = retailerList[0];
          retailerList.splice(0, 1);
          function shuffle(array) {
            var currentIndex = array.length,
              randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex != 0) {
              // Pick a remaining element...
              randomIndex = Math.floor(Math.random() * currentIndex);
              currentIndex--;

              // And swap it with the current element.
              [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
            }

            return array;
          }

          retailerList = shuffle(retailerList);
          retailerList.splice(0, 0, firstRetailer);
        } catch (e) {}
      }
      removeUnavailableRetailers(retailerList, $scope.selectedPearLogicalUPC);
      $scope.pickerList = retailerList || [];
      if ($scope.filterOutVendor) {
        $scope.pickerList = $scope.pickerList.filter((retailer) => !retailer.isVendor);
      }
      pickerListDisplayCache = {};
      if (!storeFinderListUpdate && $scope.map) {
        if (updateMapPins) {
          updateMapPins();
        }
      }
      $scope.pickerMapByRetailer = mapListByRetailer($scope.pickerList);

      resolvePendingStatusesIfNeeded($scope.pickerList);

      if ($stateParams.debug || window.location.href.indexOf('debug') != -1) {
        window.pear_debug = true;
        for (let i = 0; i < $scope.pickerList.length; i++) {
          for (let j = 0; j < $scope.pickerList[i].upcs.length; j++) {
            if (
              $scope.pickerList[i].upcs[j].computing ||
              $scope.pickerList[i].upcs[j].replacedId ||
              $scope.pickerList[i].upcs[j].status == 'PENDING'
            ) {
              $scope.showDebug = true;
              $scope.pickerList[i].showDebug = true;
            }
          }
        }
      }

      // re-sort the list now that availabilities have come in
      $scope.setPearLogicalUPCs($scope.upcs);

      if (!injectedAfterRetailerList && PixelConfig && injectWidgetConfig) {
        injectedAfterRetailerList = true;
        injectWidgetConfig(PixelConfig.widgetConfig);
      }
    });

    const mobileView = $scope.isMobileLayout;

    setInterval(() => {
      let container = document.querySelector('#retailer-list-container');
      if (container) {
        if (!$scope.isMobile) {
          container.style.height = "window.innerHeight - container.offsetTop + 'px'";
        } else {
          container.style.height = 'auto';
        }
      }

      if ($scope.offer && !$scope.offer.noMute && !$stateParams.vendorId) {
        document.querySelector('body').style.height = 'auto';
        if (!document.querySelector('div[title="Mute"]') && document.querySelector('.vjs-control-bar')) {
          const temp = document.createElement('div');
          temp.innerHTML = `<div class="vjs-mute-control vjs-control vjs-button css-reset1 vjs-vol-3 vjs-vol-0" type="button" title="Mute" aria-disabled="false" disabled=""><span aria-hidden="${
            mobileView ? false : true
          }" class="vjs-icon-placeholder css-reset1"></span><span class="vjs-control-text css-reset1" aria-live="polite">Unmute</span></div>`;
          document.querySelector('.vjs-control-bar').appendChild(temp.firstElementChild);
        }
      }
    }, 500);

    /*
     * Start location filter a11y logic here
     */

    // Function to handle mutations and start observing for location filter a11y
    const handleMutations = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          for (const addedNode of mutation.addedNodes) {
            if (
              addedNode.nodeType === Node.ELEMENT_NODE &&
              addedNode.classList.contains('pac-container') &&
              addedNode.classList.contains('pac-logo')
            ) {
              // New target element found, start observing its child elements
              const targetElement = addedNode;
              targetElement.setAttribute('role', 'list');

              const inputElement = document.getElementById('floatingInput');
              const additionalInfoElement = document.getElementById('floatingInput-additionalInfo');
              if (inputElement) {
                inputElement.addEventListener('blur', function () {
                  inputElement.setAttribute('aria-expanded', 'false');
                  if (additionalInfoElement) {
                    additionalInfoElement.textContent = '';
                  }
                });
              }

              const childCountObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                  if (mutation.target === targetElement && mutation.type === 'childList') {
                    // Get the current count of child elements
                    const childCount = targetElement.childElementCount;
                    const pacItemSelectedElements = targetElement.querySelectorAll('.pac-item-selected');
                    if (inputElement && pacItemSelectedElements.length < 1) {
                      if (
                        childCount > 0 &&
                        $scope.freezeLocation != $scope.location.location &&
                        $scope.location.location.length
                      ) {
                        inputElement.setAttribute('aria-expanded', 'true');
                        let textContent = `List of ${childCount} items: `;

                        targetElement.querySelectorAll('.pac-item').forEach((element) => {
                          textContent += element.textContent;
                          textContent += ', ';
                        });

                        textContent += 'Use the up and down arrow keys to navigate and select items.';

                        if (additionalInfoElement) {
                          additionalInfoElement.textContent = textContent;
                        }
                      } else {
                        inputElement.setAttribute('aria-expanded', 'false');
                        if (additionalInfoElement) {
                          additionalInfoElement.textContent = '';
                        }
                      }
                    }

                    // Perform desired actions on child elements here
                    targetElement.querySelectorAll('.pac-item').forEach((element, index) => {
                      if (element.classList.contains('pac-item-selected')) {
                        element.setAttribute('aria-selected', 'true');
                      } else {
                        element.setAttribute('aria-selected', 'false');
                      }
                      element.setAttribute('role', 'listitem');
                      element.setAttribute('id', 'ex-list-item-' + index);
                    });
                  } else if (
                    mutation.target.parentNode === targetElement &&
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'class'
                  ) {
                    // Perform desired actions on child elements here
                    const pacItemElements = targetElement.querySelectorAll('.pac-item');
                    pacItemElements.forEach((element, index) => {
                      if (element.classList.contains('pac-item-selected')) {
                        element.setAttribute('aria-selected', 'true');
                        if (inputElement) {
                          inputElement.removeAttribute('aria-expanded');
                          if (additionalInfoElement) {
                            additionalInfoElement.textContent = `${index + 1} of ${pacItemElements.length} selected`;
                          }
                        }
                      } else {
                        element.setAttribute('aria-selected', 'false');
                      }
                      element.setAttribute('role', 'listitem');
                      element.setAttribute('id', 'ex-list-item-' + index);
                    });
                  }
                }
              });
              childCountObserver.observe(targetElement, { attributes: true, childList: true, subtree: true });
            }
          }
        }
      }
    };

    // Create a new MutationObserver instance to watch for target element additions
    const observer = new MutationObserver(handleMutations);

    // Start observing the document body for new target elements
    observer.observe(document.body, { childList: true });

    /*
     * End location filter a11y logic here
     */

    $scope.heroImage = Util.patchImageUrl($scope.offer && $scope.offer.imageUrl
      ? $scope.offer.imageUrl
      : $scope.upcs && $scope.upcs[0]
      ? $scope.upcs[0].imageUrl
      : null
    );

    $scope.heroDescription =
      $scope.offer && $scope.offer.altImageText
        ? $scope.offer.altImageText
        : $scope.upcs && $scope.upcs[0]
        ? $scope.upcs[0].name
        : $scope.offer && $scope.offer.name
        ? $scope.offer.name
        : '';

    $scope.heroMobileImage = Util.patchImageUrl($scope.offer
      ? $scope.offer.mobileImageUrl
        ? $scope.offer.mobileImageUrl
        : $scope.heroImage
      : $scope.heroImage);

    if ($scope.offer && $scope.offer.id == '1627371787152544') {
      $scope.offer.verb = 'Add all';
    }

    if ($scope.offer && $scope.offer.background) {
      const background = $scope.offer.background;
      for (const key in background) {
        if (!background[key]) {
          delete background[key];
        }
      }
      $scope.background = background;
    } else {
      $scope.background = { backgroundColor: 'rgb(234,234,234)' };
    }

    if ($scope.offer && $scope.offer.background && $scope.offer.background.backgroundPanelColor) {
      $scope.panelColor = $scope.offer.background.backgroundPanelColor;
    } else if (!$scope.isMobile) {
      $scope.panelColor = 'rgba(242, 242, 242, 0.85)';
    }

    if ($scope.inWidget) {
      $scope.background = { backgroundColor: 'transparent' };
    }

    $scope.query = window.location.search;
    $scope.showMore = { value: !!$stateParams.show_more };

    $scope.toggleShowMore = (e) => {
      e.stopPropagation();
      e.preventDefault();

      $scope.showMore.value = !$scope.showMore.value;
    };

    if ($stateParams.pb || $stateParams.mode || $stateParams.show_more) {
      const style = document.createElement('style');
      style.innerHTML = `
        .input-button-el.productVariants.showMore, .input-button-el.showMore {
          height: auto !important;
          max-height: unset !important;
          
        }
        #see-more-retailers {
          height: 50px !important;
          width: 100% !important;
        }
      `;
      document.body.appendChild(style);
    }
    if ($scope.offer && $scope.offer.backgroundColor) {
      $scope.backgroundColor = $scope.offer.backgroundColor;
    } else if ($scope.upcs && $scope.upcs[0] && $scope.upcs[0].tallImgBotColor) {
      $scope.backgroundColor = $scope.upcs[0].tallImgBotColor;
    } else {
      $scope.backgroundColor = 'black';
    }

    if ($scope.offer && $scope.offer.id == '1627391369342112') {
      $scope.backgroundColor = '#d18548';
      $scope.offer.seeMoreColor = '#ffffff';
    }

    const mapListByRetailer = (pickerList) => {
      return Object.fromEntries(
        Object.values(pickerList || []).map((e) => {
          e.upcMap = Object.fromEntries((e.upcs || []).map((upc) => [upc.UPC, upc]));
          return [e.nameEnum, e];
        })
      );
    };

    $scope.seeMoreColor = $scope.offer ? $scope.offer.seeMoreColor : false;
    if (!$scope.seeMoreColor) {
      $scope.seeMoreColor = 'white';
    }

    const mergePickerMapData = (oldPickerMap, newPickerMap) => {
      Object.keys(oldPickerMap).forEach((retailerName) => {
        const oldRetailerListItem = oldPickerMap[retailerName];
        const newRetailerListItem = newPickerMap[retailerName];
        if (newRetailerListItem) {
          Object.keys(oldRetailerListItem.upcMap).forEach((upc) => {
            const oldUPC = oldRetailerListItem.upcMap[upc];
            const newUPC = newRetailerListItem.upcMap[upc];
            if (newUPC && oldUPC.status !== newUPC.status && oldUPC.status == 'PENDING') {
              Object.assign(oldUPC, newUPC);
            }
          });
          if (oldRetailerListItem && oldRetailerListItem.style.sortOrder) {
            newRetailerListItem.style.sortOrder = oldRetailerListItem.style.sortOrder;
          }
          Object.assign(oldRetailerListItem, newRetailerListItem);
        }
      });
    };

    let elapsedPollTime = 0;
    const basePollTime = 1500;
    let pollTimeout = basePollTime;
    const resolvePendingStatusesIfNeeded = (pickerList) => {
      const getPendingList = (pickerList) => {
        const pendingList = [];
        for (let i = 0; i < pickerList.length; i++) {
          for (let j = 0; j < pickerList[i].upcs.length; j++) {
            if (pickerList[i].upcs[j].status == 'PENDING') {
              pendingList.push(pickerList[i]);
              break;
            }
          }
        }
        return pendingList;
      };

      const containsPendingStatus = (pickerList) => {
        const pendingList = getPendingList(pickerList);
        return pendingList.length > 0;
      };

      const ENABLE_PENDING_POLL = false;
      const checkPendingsAndPollStatus = (pickerList) => {
        if (!ENABLE_PENDING_POLL) {
          return;
        }
        const pendingList = getPendingList(pickerList);
        if (pendingList.length > 0) {
          const constrainRetailerEnums = pendingList.map((item) => item.nameEnum).join(',');
          $timeout(() => {
            elapsedPollTime += pollTimeout;
            pollTimeout = Math.min(
              Math.trunc(
                elapsedPollTime > 30 * 1000
                  ? // after 30s mark, decay polling to [10 + # minutes on-site] seconds
                    10000 + elapsedPollTime / 60
                  : // minor decay up to the 30s mark
                    basePollTime + (10000 - basePollTime) * (elapsedPollTime / (30 * 1000))
              ),
              // up to a max of 10 minutes
              10 * 60 * 1000
            );
            const t = new Date().getTime();
            let resolve;
            if ($scope.offer) {
              resolve = $api.get(
                '/v1/retailer-list/' +
                  $scope.offer.id +
                  '?asyncResolveDeep=false&t=' +
                  t +
                  ($stateParams.pb || $stateParams.mode
                    ? '&zip=55408'
                    : $stateParams.zip
                    ? '&zip=' + $stateParams.zip
                    : '') +
                  ('&constrain=' + constrainRetailerEnums) +
                  ($stateParams.include ? '&include=' + $stateParams.include : '') +
                  ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                  ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                  ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                  ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                  ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : '') +
                  ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                  ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                  `&pollTimeout=${pollTimeout}`,
                { credentials: 'include', withCredentials: true, failure: failureRetailerList }
              );
            } else if ($scope.vendor) {
              resolve = $api.get(
                '/v1/retailer-list-by-vendor/' +
                  $stateParams.vendorId +
                  '?asyncResolveDeep=false&t=' +
                  t +
                  ($stateParams.pb || $stateParams.mode
                    ? '&zip=55408'
                    : $stateParams.zip
                    ? '&zip=' + $stateParams.zip
                    : '') +
                  ('&constrain=' + constrainRetailerEnums) +
                  ($stateParams.include ? '&include=' + $stateParams.include : '') +
                  ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                  ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                  ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                  ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                  ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : '') +
                  ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                  ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                  `&pollTimeout=${pollTimeout}`,
                { credentials: 'include', withCredentials: true, failure: failureRetailerList }
              );
            } else {
              resolve = $api.get(
                '/v1/retailer-list-by-upc/' +
                  $stateParams.upcs +
                  '?asyncResolveDeep=false&t=' +
                  t +
                  ($stateParams.pb || $stateParams.mode
                    ? '&zip=55408'
                    : $stateParams.zip
                    ? '&zip=' + $stateParams.zip
                    : '') +
                  ('&constrain=' + constrainRetailerEnums) +
                  ($stateParams.include ? '&include=' + $stateParams.include : '') +
                  ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                  ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                  ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                  ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                  ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : '') +
                  ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                  ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                  `&pollTimeout=${pollTimeout}`,
                { credentials: 'include', withCredentials: true }
              );
            }

            resolve.then((newPickerList) => {
              newPickerList = newPickerList || [];
              $scope.resolveTime = new Date().getTime();
              const newPickerMap = mapListByRetailer(newPickerList);
              mergePickerMapData($scope.pickerMapByRetailer, newPickerMap);
              resolvePendingStatusesIfNeeded($scope.pickerList);
            });
          }, pollTimeout);
        }
      };
      if ($scope.offer) {
        checkPendingsAndPollStatus(pickerList);
      }
    };

    $scope.retailerStatusPending = (status) => {
      return status == 'PENDING';
    };

    $scope.retailerStatusUnusable = (status) => {
      return status == null || status == 'UNKNOWN' || status == 'UNAVAILABLE';
    };

    $scope.getRetailerStatus = (retailer, upc) => {
      if (typeof retailer == 'undefined' || !retailer) {
        return 'UNAVAILABLE';
      }
      let requireInstore =
        retailer.nameEnum == 'walmart' && $scope.offer && !$scope.offer.allowOnlineOnlyForWalmart && false;
      let foundPending = false;
      for (let i = 0; i < retailer.upcs.length; i++) {
        if (
          retailer.upcs[i].pearLogicalUPCId == upc.pearLogicalUPCId ||
          (inProductLocator && retailer.upcs[i].UPC == upc.UPC)
        ) {
          if (
            (!requireInstore && retailer.upcs[i].status == 'AVAILABLE') ||
            retailer.upcs[i].inStoreStatus == 'AVAILABLE'
          ) {
            return 'AVAILABLE';
          } else if (retailer.upcs[i].status == 'PENDING') {
            foundPending = true;
          }
        }
      }
      upc.multiSelected = false;
      return foundPending ? 'PENDING' : 'UNAVAILABLE';
    };

    $scope.clickGlobalRetailer = (retailer) => {
      if (retailer.url) {
        $rootScope.pymChild.sendMessage(
          'buy-now-clicked',
          JSON.stringify({
            url: retailer.url || retailer.ecommerceUrl,
            searchPath: retailer.searchPath,
            ecommerceUrl: retailer.ecommerceUrl,
            source: 'glickGlobalRetailer, retailer.url',
          })
        );
        return;
      }
      const found = false;
      for (let i = 0; i < $scope.pickerList.length; i++) {
        if ($scope.pickerList[i].name == retailer.name) {
          $scope.clickRetailer($scope.pickerList[i]);
          return;
        }
      }
      if (!found) {
        const mapsUrl = `http://maps.google.co.in/maps?q=${encodeURIComponent(retailer.address)}`;
        $rootScope.pymChild.sendMessage(
          'buy-now-clicked',
          JSON.stringify({
            url: mapsUrl || retailer.ecommerceUrl,
            searchPath: retailer.searchPath,
            ecommerceUrl: retailer.ecommerceUrl,
            source: 'clickGlobalRetailer, !found',
          })
        );
      }
    };

    let addingToCart = false;

    $scope.olipopDirect = function (upc) {
      window.open(upc.hostPageURL);
    };

    $scope.urlTester = (retailer, logicalUPC, testerFunction) => {
      let urlTestResult = false;

      if (Array.isArray(retailer.upcs)) {
        const upcMatch = retailer.upcs.find((upcDef) => upcDef.pearLogicalUPCId === logicalUPC.pearLogicalUPCId);
        if (typeof upcMatch !== 'undefined') {
          urlTestResult = testerFunction(upcMatch.url);
        }
      }

      return urlTestResult;
    }


    $scope.isInstcartRetailer = (retailer, logicalUPC) => {
      return $scope.urlTester(retailer, logicalUPC, $scope.isInstacartLink);
    };

    $scope.isDoorDashRetailer = (retailer, logicalUPC) => {
      return $scope.urlTester(retailer, logicalUPC, $scope.isDoorDashLink);
    }

    $scope.lastLocation = null;
    $scope.editingLocation = false;
    
    $scope.activelyEditingLocation = ($event) => {
      if ($event.keyCode === 9) { // 9 is the keyCode for Tab
        return;
      }
      if ($scope.editingLocation === false) {
        $scope.editingLocation = true;
        $scope.lastLocation = Object.assign({}, $scope.location);
        $scope.location.location = '';
      }
    }
    let eric2= 1;
    $scope.doneEditingLocation = () => {
      $scope.editingLocation = false;
      if ($scope.location.location === '') {
        console.log('Here?', $scope.lastLocation);
        $scope.location = $scope.lastLocation;
      }
    }

    $scope.keyPressRetailer = (retailer, logicalUPC, $event) => {
      if ([13, 32].includes($event.keyCode)) {
        $event.stopPropagation();
        $event.preventDefault();
        $scope.clickRetailer(retailer, logicalUPC, $event);
      }
    };

    $scope.clickedRetailer = (retailer, logicalUPC, $event) => {
      $event.stopPropagation();
      $event.preventDefault();
      $scope.clickRetailer(retailer, logicalUPC, $event);
    };

    $scope.clickRetailer = (retailer, logicalUPC, $event, idx, skipOffer) => {
      if (addingToCart) {
        return;
      }

      addingToCart = true;
      setTimeout(function () {
        addingToCart = false;
      }, 500);

      try {
        if (window.location.href.indexOf('picker-for-modification') > -1) {
          return;
        }
        if ($state.current.name == 'old-dutch-wtb') {
          $scope.scrollCarousel(idx - $scope.selectedCarouselIndex);
        }

        let upc;
        let found = false;
        if (retailer && retailer.upcs) {
          for (let i = 0; i < retailer.upcs.length; i++) {
            upc = null;
            if (logicalUPC) {
              if (retailer.upcs[i].pearLogicalUPCId == logicalUPC.pearLogicalUPCId) {
                upc = retailer.upcs[i];
              } else if (inProductLocator && retailer.upcs[i].UPC == logicalUPC.UPC) {
                upc = retailer.upcs[i];
              }
            } else {
              upc = retailer.upcs[i];
            }

            if (
              upc &&
              ($scope.getRetailerStatus(retailer, upc) == 'AVAILABLE' || $state.current.name == 'old-dutch-wtb')
            ) {
              found = true;
              break;
            }
          }
        }
        
        if ($scope.offer && $scope.offer.multiSelect) {
          let itemIds = '';
          for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
            if ($scope.pearLogicalUPCs[i].multiSelected) {
              itemIds += $scope.pearLogicalUPCs[i].pearLogicalUPCId + ',';
            }
          }
          itemIds = itemIds.substring(0, itemIds.length - 1);
          let url =
            $config.API_URL +
            '/v1/direct_atc?item_ids=' +
            encodeURIComponent(itemIds) +
            '&pearclid=' +
            $scope.pearclid +
            '&retailer=' +
            retailer.nameEnum +
            '&fast=true&cookie=' +
            encodeURIComponent(document.cookie); 
          if ($stateParams.zip) {
            url += '&zip=' + $stateParams.zip;
          }
          
          if ($stateParams.countryCode) {
            url += '&countryCode=' + $stateParams.countryCode;
          }

          if ($scope.offer) {
            url += '&offerId=' + $scope.offer.id;
          }
          
          const open = window.open(url, '_blank');
          if (open == null || typeof open == 'undefined') {
            window.location = url;
          }
        } else if (!found) {
          if ($state.current.name == 'product-locator') {
            $rootScope.pymChild.sendMessage(
              'buy-now-clicked',
              JSON.stringify({
                searchPath: retailer.searchPath,
                ecommerceUrl: retailer.ecommerceUrl,
                source: '!found, product-locator',
              })
            );
          }
          return;
        } else if (
          logicalUPC &&
          $scope.getRetailerStatus(retailer, logicalUPC) != 'AVAILABLE' &&
          $state.current.name != 'old-dutch-wtb'
        ) {
          return;
        } else if (upc) {
          if (
            $scope.claimOfferModal &&
            !$scope.claimOfferModal.leavePagePromptShown &&
            $scope.reimbursementInfo &&
            $scope.reimbursementInfo.amount &&
            !$scope.reimbursementInfo.email &&
            !skipOffer
          ) {
            $scope.claimOfferModal.leavePagePromptShown = true;
            $scope.claimOfferModal.leavePagePrompt = true;
            $scope.claimOfferModal.retailer = retailer;

            return;
          }

          upc = upc || (retailer && retailer.upcs && retailer.upcs[0]);

          const offerId = $scope.offer ? $scope.offer.id : 0;
          const vendorId = $scope.vendor ? $scope.vendor.id : 0;
          let talksToParent = false;
          if ($rootScope.inIframe && $rootScope.pymChild) {
            $rootScope.pymChild.onMessage('talk-to-child', () => {
              talksToParent = true;
            });
            $rootScope.pymChild.sendMessage('talk-to-parent', JSON.stringify({ source: 'parent ping' }));
          }

          (async () => {
            const zip = $scope.selectedStore ? $scope.selectedStore?.zip : $scope.location?.zip;
            if (inProductLocator) {
              var retailerList = await memoizedGetRetailerListPromise(
                $scope,
                $api,
                $stateParams,
                null,
                zip,
                null,
                false,
                $scope.pearclid,
                UPCSAndOffer
              );

              if (retailerList) {
                const _retailer = retailerList.filter((r) => r.nameEnum == retailer.nameEnum)[0];
                if (_retailer) {
                  retailer = _retailer;
                  const _upc = retailer.upcs.filter((u) => upc.pearLogicalUPCId == u.pearLogicalUPCId)[0];
                  if (_upc) {
                    upc = _upc;
                  }
                }
              }
            }

            const atcParams = {
              vendorId: vendorId,
              offerId: offerId,
              retailer: retailer.nameEnum,
              itemId: upc.pearLogicalUPCId,
              UPC: upc.UPC,
              params: window.location.search,
              cookie: document.cookie,
              availabilityId: upc.availabilityId,
              directAtc: !!upc.directAtc,
              upcId: upc.id,
              calculateUrl: !$stateParams.sold_at,
              notAsync: true,
              pearclid: $scope.pearclid || 0,
              zip: zip,
              selectedUrl: upc.url,
              countryCode: $stateParams.countryCode,
            };
            $api.post('/v1/add_to_cart', atcParams, { failure: { url: upc.url } }).then((resp) => {
              if (resp.url) {
                let url = resp.url;

                if ($stateParams.pb || $stateParams.mode) {
                  //window.location = url;
                } else {
                  let vendorId = 0;
                  if ($scope.vendor) {
                    vendorId = $scope.vendor.id;
                  } else if ($scope.offer && $scope.offer.vendor) {
                    vendorId = $scope.offer?.vendor?.id;
                  }

                  let redirectUrl = window.location.origin +
                    '/' +
                    vendorId +
                    '/picker/' +
                    ($scope.offer ? $scope.offer.id : 0) +
                    '/add_to_cart?redirect=' +
                    encodeURIComponent(url) +
                    (resp.pearclid ? '&pearclid=' + resp.pearclid : '') +
                    '&product_name=' +
                    encodeURIComponent(upc.name) +
                    '&retailer_name=' +
                    encodeURIComponent(retailer.name) +
                    '&upcId=' +
                    upc.id +
                    '&retailerId=' +
                    retailer.id +
                    '&fireEvents=' +
                    Util.getCookiePreferences().targeting;
                  let query = window.location.search;
                  if (query.length > 0 && query.startsWith('?')) {
                    query = query.replace('?', '&');
                  }
                  if (query) {
                    redirectUrl += query;
                  }

                  /* 
                    HD-395
                    When pear is in iframe, send buy now button click event to parent window,
                    so the parent window utilize this data within its other page-level events.

                    If we need to send more events to parent within iframe, we can create a util function.
                   */
                  if ($rootScope.inIframe) {
                    $rootScope.pymChild.sendMessage(
                      'buy_click',
                      JSON.stringify({
                        retailer_name: retailer.name,
                        product_name: upc.name,
                      })
                    );
                  }

                  const href = window.location.href;
                  const liquidDeathGushersRatioEric =
                    href.indexOf('liquiddeath') > -1 ||
                    href.indexOf('gushers') > -1 ||
                    href.indexOf('epicprovisions') > -1 ||
                    href.indexOf('ratiofood') > -1 ||
                    href.indexOf('product-locator') > -1 ||
                    href.indexOf('snowdays') > -1 ||
                    href.indexOf('annies');
                  if ($rootScope.inIframe && liquidDeathGushersRatioEric) {
                    let redirected = false;
                    $rootScope.pymChild.onMessage('redirected', () => {
                      redirected = true;
                    });
                    $rootScope.pymChild.sendMessage(
                      'buy-now-clicked',
                      JSON.stringify({ url: redirectUrl, source: 'liquiddeath et al.' })
                    );
                    if (!talksToParent) {
                      setTimeout(() => {
                        if (!redirected) {
                          const open = window.open(redirectUrl, '_blank');
                          if (open == null || typeof open == 'undefined') {
                            top.window.location.href = redirectUrl;
                          }
                        }
                      }, 500);
                    }
                  } else if ($rootScope.inIframe) {
                    top.window.location.href = redirectUrl;
                  } else {
                    const open = window.open(redirectUrl, '_blank');
                    if (open == null || typeof open == 'undefined') {
                      window.location = redirectUrl;
                    }
                  }
                }
              } else if ($stateParams.sold_at) {
                const searchPath = retailer.searchPath;
                let ecommerceUrl = retailer.ecommerceUrl;
                if (ecommerceUrl == 'https://www.hy-vee.com/grocery/') {
                  if (offerId == 1593756182233408) {
                    window.open(
                      'https://www.hy-vee.com/grocery/PD47538454/Old-Dutch-Rip-L-Triple-Pack-Potato-Chips-Triple-Pack?squID=335359700&sreID=0&rank=1&index=1&hash=391913007',
                      '_blank'
                    );
                  }
                  return;
                } else if (ecommerceUrl && ecommerceUrl.indexOf('walmart') > 0 && offerId != 1593756182233408) {
                  return;
                }
                if (searchPath && searchPath.indexOf('search_v3') >= 0 && !ecommerceUrl) {
                  ecommerceUrl = 'https://www.instacart.com';
                }
                let searchUrl;

                let searchTerms;
                if ($scope.offer.id == 1593756205605184) {
                  searchTerms = "Barrel O' Fun";
                } else if ($scope.offer.id == 1593756215812416) {
                  searchTerms = 'Humpty Dumpty';
                } else if ($scope.offer.id == 1593756182233408) {
                  searchTerms = 'Old Dutch';
                }

                if (searchPath != null) {
                  let searchPathCombined;
                  if (searchPath.indexOf('__SEARCH__') >= 0) {
                    searchPathCombined = searchPath.replaceAll('__SEARCH__', encodeURIComponent(searchTerms));
                  } else {
                    searchPathCombined = searchPath + encodeURIComponent(searchTerms);
                  }
                  if (ecommerceUrl != null) {
                    searchUrl = `${ecommerceUrl}${searchPathCombined}`;
                  }
                } else if (ecommerceUrl != null) {
                  searchUrl = `${ecommerceUrl}`;
                }
                if (searchUrl) {
                  window.open(searchUrl, '_blank');
                }
              }
            });
          })();
        } else {
          $scope.upcChoices = (retailer && retailer.upcs) || [];
        }

        if ($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      } finally {
      }
    };

    $scope.clickUPC = (UPC) => {
      if ($rootScope.inIframe) {
        $rootScope.pymChild.sendMessage('buy-now-clicked', JSON.stringify({ url: UPC.url, source: 'clickUPC' }));
      } else {
        const open = window.open(UPC.url, '_blank');
        if (open == null || typeof open == 'undefined') {
          window.location = UPC.url;
        }
      }
    };

    $scope.dismiss = () => {
      $scope.upcChoices = false;
    };

    const removeUnavailableRetailers = (retailerList, logicalUPC) => {
      if (!retailerList) {
        return;
      }
      for (let i = 0; i < retailerList.length; i++) {
        const retailer = retailerList[i];

        let allFailed = true;
        if (retailer && retailer.upcs != null) {
          for (let j = 0; j < retailer.upcs.length; j++) {
            if ($scope.getRetailerStatus(retailer, retailer.upcs[j]) != 'UNAVAILABLE') {
              allFailed = false;
              break;
            }
          }
        }
        if (allFailed) {
          retailerList.splice(i, 1);
          i--;
        }
      }
    };

    // eslint-disable-next-line  no-unused-vars
    const FALLBACK_STYLE = {
      logo: 'https://assets-cf.pearcommerce.com/retailer/generic-grocery.jpeg',
      preposition: 'at',
      sortOrder: 1000,
    };

    // eslint-disable-next-line  no-unused-vars
    const randomPastel = () => {
      const idx1 = Math.floor(Math.random() * 3);
      const big1 = Math.random() > 0.5;
      let idx2 = Math.floor(Math.random() * 3);
      if (big1 && idx1 == idx2) {
        idx2 = (idx2 + Math.floor(Math.random() * 2)) % 3;
      }
      const big2 = Math.random() > 0.5;
      const rgb = [200, 200, 200];
      rgb[idx1] -= big1 ? 70 : 45;
      rgb[idx2] -= big2 ? 70 : 45;
      return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
    };

    $scope.upcsByName = {};

    $scope.setPearLogicalUPCs = (pickerUPCs) => {
      pickerUPCs = pickerUPCs.map((upc) => {
        if (
            window.resizeImages &&
            upc.imageUrl &&
            (upc.imageUrl.indexOf('assets.pearcommerce.com') != -1 ||
                upc.imageUrl.indexOf('demos.pearcommerce.com') != -1 ||
              upc.imageUrl.indexOf('assets-cf.pearcommerce.com') != -1 ||
            upc.imageUrl.indexOf('demos-cf-1.pearcommerce.com') != -1)
        ) {
          upc.imageUrl = upc.imageUrl
              .replace('s3.amazonaws.com/', '')
              .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
        }
        return upc;
      })
      $scope.upcIdsToLogicalUPC = {};
      for (let i = 0; i < pickerUPCs.length; i++) {
        for (let j = 0; j < pickerUPCs[i].upcIds.length; j++) {
          $scope.upcIdsToLogicalUPC[pickerUPCs[i].upcIds[j]] = pickerUPCs[i];
        }
      }
      let upcsByName = ($scope.upcsByName = {});

      const currentMultiSelectedState = {};
      if ($scope.pearLogicalUPCs) {
        $scope.pearLogicalUPCs.forEach(logicalUPC => {
          currentMultiSelectedState[logicalUPC.pearLogicalUPCId] = logicalUPC.multiSelected;
        });
      }

      $scope.pearLogicalUPCs = (pickerUPCs || [])
        .map(pickerUPCs => {
          const newLogicalUPC = {
            ...pickerUPCs,
            imageUrl: Util.patchImageUrl(pickerUPCs.imageUrl)
          };
          // Restore the multiSelected state if it existed
          if (currentMultiSelectedState?.hasOwnProperty(newLogicalUPC.pearLogicalUPCId)) {
            newLogicalUPC.multiSelected = currentMultiSelectedState?.[newLogicalUPC.pearLogicalUPCId];
          }
          
          return newLogicalUPC;
        })
        .filter((upc) => !upc.hidden)
        .sort((a, b) => {
          if ($scope.offer && $scope.offer.productSortType == 'MANUAL' && a.sortOrder != b.sortOrder) {
            return a.sortOrder - b.sortOrder;
          }

          if (!!a.name != !!b.name) {
            return !!a.name ? -1 : 1;
          }

          if (!!a.imageUrl != !!b.imageUrl) {
            return !!a.imageUrl ? -1 : 1;
          }

          if (a.name != b.name) {
            return a.name.localeCompare(b.name);
          }

          if (a.UPC != b.UPC) {
            return a.UPC.localeCompare(b.UPC);
          }

          return a.id - b.id;
        });

      $scope.pearLogicalUPCsForDisplay = $scope.pearLogicalUPCs
        .filter((upc) => upc.name)
        .filter((upc) => {
          const upcs = (upcsByName[upc.name] = upcsByName[upc.name] || []);
          upc.categories = upc.categories || [];
          upcs.forEach((otherUPC) => {
            otherUPC.categories = otherUPC.categories || [];
            otherUPC.categories.forEach((otherCategory) => {
              if (otherCategory && upc.categories.indexOf(otherCategory) == -1) {
                upc.categories.push(otherCategory);
              }
            });

            upc.categories.forEach((category) => {
              if (category && otherUPC.categories.indexOf(category) == -1) {
                otherUPC.categories.push(category);
              }
            });
          });
          upcs.push(upc);
          return upcs.length == 1;
        })
        .map((upc) => {
          if (
            window.resizeImages &&
            upc.imageUrl &&
            (upc.imageUrl.indexOf('assets.pearcommerce.com') != -1 ||
              upc.imageUrl.indexOf('demos.pearcommerce.com') != -1 ||
            upc.imageUrl.indexOf('assets-cf.pearcommerce.com') != -1 ||
            upc.imageUrl.indexOf('demos-cf-1.pearcommerce.com') != -1
          )
          ) {
            upc.imageUrl = upc.imageUrl
              .replace('s3.amazonaws.com/', '')
              .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
          }
          return upc;
        });
      if ($scope.singleItemSelect && $scope.selectedUPCs.length != 1) {
        $scope.toggleProduct($scope.selectedUPCs, $scope.pearLogicalUPCsForDisplay[0]);
        $scope.toggleProduct($scope.selectedUPCsForBuyOnline, $scope.pearLogicalUPCsForDisplay[0]);
      }

      // move unavailable UPCs to the bottom, then look at sort order followed by number of availabilities
      const selectedRetailerId = $scope.selectedStore && $scope.selectedStore.retailerId;

      //Drives Buy Online UPCs List

      $scope.pearLogicalUPCsByAvailability = [...$scope.pearLogicalUPCs]
        .sort((a, b) => {
          let numAvailableA = 0;
          let numAvailableB = 0;

          let hasSelectedStoreA = false;
          let hasSelectedStoreB = false;

          if ($scope.pickerList && $scope.pickerList.length && $scope.pickerListDisplay) {
            let pickerListDisplayA = $scope.pickerListDisplay && $scope.pickerListDisplay(a);
            let pickerListDisplayB = $scope.pickerListDisplay(b);
            for (let i = 0; i < pickerListDisplayA.length; i++) {
              let retailer = pickerListDisplayA[i];
              for (let j = 0; j < retailer.upcs.length; j++) {
                if (retailer.upcs[j].pearLogicalUPCId == a.pearLogicalUPCId && retailer.upcs[j].status == 'AVAILABLE') {
                  numAvailableA++;
                  if (selectedRetailerId == retailer.id) {
                    hasSelectedStoreA = true;
                  }
                }
              }
            }

            for (let i = 0; i < pickerListDisplayB.length; i++) {
              let retailer = pickerListDisplayB[i];
              for (let j = 0; j < retailer.upcs.length; j++) {
                if (retailer.upcs[j].pearLogicalUPCId == b.pearLogicalUPCId) {
                  if (retailer.upcs[j].status == 'AVAILABLE') {
                    numAvailableB++;
                    if (selectedRetailerId == retailer.id) {
                      hasSelectedStoreB = true;
                    }
                  }
                }
              }
            }
          }

          let numAvailableSansVendorA = a.vendorItemId ? Math.max(0, numAvailableA - 1) : numAvailableA;
          let numAvailableSansVendorB = b.vendorItemId ? Math.max(0, numAvailableB - 1) : numAvailableB;

          numAvailableA = a.vendorItemId && numAvailableA == 1 ? 0.5 : numAvailableA;
          numAvailableB = b.vendorItemId && numAvailableB == 1 ? 0.5 : numAvailableB;

          if (!!a.imageUrl != !!b.imageUrl) {
            return !!a.imageUrl ? -1 : 1;
          }

          if (UPCSAndOffer.offer.productSortType == 'STORE_LOCATOR_GENERATED') {
            if (!!numAvailableSansVendorA != !!numAvailableSansVendorB) {
              return !!numAvailableSansVendorA ? -1 : 1;
            }

            if (numAvailableA > 0 != numAvailableB > 0) {
              return numAvailableA > 0 ? -1 : 1;
            }
            if (Math.min(3, numAvailableA) != Math.min(3, numAvailableB)) {
              return Math.min(3, numAvailableB) - Math.min(3, numAvailableA);
            }
          }

          if (UPCSAndOffer.offer.productSortType == 'MANUAL') {
            if (numAvailableA > 0 && numAvailableB == 0) {
              return -1;
            }
            if (numAvailableA == 0 && numAvailableB > 0) {
              return 1;
            }
          }

          if ((a.sortOrder || b.sortOrder) && a.sortOrder != b.sortOrder) {
            return a.sortOrder - b.sortOrder;
          }
          if (a.sortOrder == b.sortOrder) {
            if (hasSelectedStoreA != hasSelectedStoreB) {
              return hasSelectedStoreA ? -1 : 1;
            }
            return a.pearLogicalUPCId - b.pearLogicalUPCId;
          }
          return a.sortOrder - b.sortOrder;
        })
        .map((upc) => {
          if (
            window.resizeImages &&
            upc.imageUrl &&
            (upc.imageUrl.indexOf('assets.pearcommerce.com') != -1 ||
              upc.imageUrl.indexOf('demos.pearcommerce.com') != -1 ||
              upc.imageUrl.indexOf('assets-cf.pearcommerce.com') != -1 ||
              upc.imageUrl.indexOf('demos-cf-1.pearcommerce.com') != -1)
          ) {
            upc.imageUrl = upc.imageUrl
              .replace('s3.amazonaws.com/', '')
              .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
          }
          return upc;
        });

      if ($scope.pinUPCIdsToTop) {
        for (var i = 0; i < $scope.pinUPCIdsToTop.length; i++) {
          let grabIndex = $scope.pearLogicalUPCsByAvailability.findIndex((upc) => upc.id == $scope.pinUPCIdsToTop[i]);

          let element = $scope.pearLogicalUPCsByAvailability[grabIndex];
          //pin upcs on top of buy online tab
          $scope.pearLogicalUPCsByAvailability.splice(grabIndex, 1);
          $scope.pearLogicalUPCsByAvailability.splice(i, 0, element);
          //pin upcs on top of filter list
          grabIndex = $scope.pearLogicalUPCsForDisplay.findIndex((upc) => upc.id == $scope.pinUPCIdsToTop[i]);
          element = $scope.pearLogicalUPCsForDisplay[grabIndex];
          $scope.pearLogicalUPCsForDisplay.splice(grabIndex, 1);
          $scope.pearLogicalUPCsForDisplay.splice(i, 0, element);
        }
      }
      if ($scope.preSelectedUPCIds && $scope.preSelectedUPCIds.length > 0 && !$scope.setPreselected) {
        $scope.selectedUPCs = [...$scope.preSelectedUPCIds];
        $scope.selectedUPCsForBuyOnline = [...$scope.preSelectedUPCIds];
        $scope.setPreselected = true;
      }

      if ($scope.pearLogicalUPCs.length > 0) {
        $scope.selectedPearLogicalUPC = $scope.pearLogicalUPCs[0];
      }
    };

    if ($scope.upcs) {
      for (let i = 0; i < $scope.upcs.length; i++) {
        const upc = $scope.upcs[i];
        if (typeof upc.sortOrder == 'undefined') {
          upc.sortOrder = 1000 + i;
        }
      }
      $scope.setPearLogicalUPCs($scope.upcs);
    }

    if (PixelConfig && injectWidgetConfig) {
      injectWidgetConfig(PixelConfig.widgetConfig);
    }

    if (Util.getCookiePreferences().functional || $stateParams.zip) {
      $timeout(
        $async(async () => {
          const domInsertions = $api.get(
            '/v1/offer_dom_insertions?timeout=2000&offerId=' +
              ($scope.offer ? $scope.offer.id : 0) +
              '&upcIds=' +
              encodeURIComponent('')
          );
          await initRetailerList(RetailerListInit, false, null, $scope.selectedUPCs, false);
          $scope.$apply();

          let upcIds = '';
          let upcIdArr = [];
          for (let i = 0; i < $scope.pickerList.length; i++) {
            let retailer = $scope.pickerList[i];
            for (let j = 0; j < retailer.upcs.length; j++) {
              let upc = retailer.upcs[j];
              if (upc.status == 'AVAILABLE' && upcIdArr.indexOf(upc.id) < 0) {
                upcIdArr.push(upc.id);
                upcIds += upc.id + ',';
              }
            }
          }

          if (upcIds.length > 0) {
            upcIds = upcIds.substring(0, upcIds.length - 1);
          }

          let response = await domInsertions;
          $scope.$apply();

          try {
            if (Util.getCookiePreferences().targeting && response && response.pageLoad) {
              await addTagsToBody($api, response.pageLoad, true, (PageLoad && PageLoad.id) || 0, EVENT_PAGE_LOAD);
              $api.post('/v1/conversion_api?timeout=2000', {
                eventType: 'PageLoad',
                uniqueEventId: window.capiUniqueEventId,
                offerId: $scope.offer.id,
                url: window.location.href,
              });
            }
          } finally {
            completeAddPixelsPromise();
            $scope.$apply();
          }
        }),
        0
      );
    } else {
      completeAddPixelsPromise();
      $scope.noUserEntryAndFunctionalCookiesDisabled = true;
      if (window.pear_debug) {
        console.log('Not installing pixels because functional cookies have been rejected.');
      }
    }

    if ($scope.offer && $scope.offer.pickerCustomStyles) {
      const customStyles = $scope.offer.pickerCustomStyles;
      for (const key in customStyles) {
        if (!customStyles[key]) {
          delete customStyles[key];
          //remove empty styles
        }
      }
      $scope.pickerCustomStyleOverride = customStyles;
    }

    let rootPicker = document.getElementById('picker-container');

    //PICKER Custom Styles

    let customStyleTextA = 'style="';
    let customStyleTextB = 'style="';
    if ($scope.pickerCustomStyleOverride && rootPicker) {
      if ($scope.pickerCustomStyleOverride.logoBorderRadius) {
        rootPicker.style.setProperty('--retail-logo-border-radius', $scope.pickerCustomStyleOverride.logoBorderRadius);
      }
      if ($scope.pickerCustomStyleOverride.buttonBorderRadius) {
        rootPicker.style.setProperty(
          '--retail-button-border-radius',
          $scope.pickerCustomStyleOverride.buttonBorderRadius
        );
      }
      if ($scope.pickerCustomStyleOverride.carouselBorderradius) {
        rootPicker.style.setProperty(
          '--carousel-container-border-radius',
          $scope.pickerCustomStyleOverride.carouselBorderradius
        );
      }
      if ($scope.pickerCustomStyleOverride.carouselBackgroundColor) {
        rootPicker.style.setProperty(
          '--carousel-container-background-color',
          $scope.pickerCustomStyleOverride.carouselBackgroundColor
        );
      }
      if ($scope.pickerCustomStyleOverride.carouselProductSelectColor) {
        rootPicker.style.setProperty(
          '--carousel-container-product-select-color',
          $scope.pickerCustomStyleOverride.carouselProductSelectColor
        );
      }
      if ($scope.pickerCustomStyleOverride.pickerFontFamily) {
        rootPicker.style.setProperty('--picker-font-family', $scope.pickerCustomStyleOverride.pickerFontFamily);
      }
      if ($scope.pickerCustomStyleOverride.pickerTextTransform) {
        rootPicker.style.setProperty('--picker-text-transform', $scope.pickerCustomStyleOverride.pickerTextTransform);
      }
      if ($scope.pickerCustomStyleOverride.customTextAColor) {
        customStyleTextA = customStyleTextA + 'color:' + $scope.pickerCustomStyleOverride.customTextAColor + ';';
      }
      if ($scope.pickerCustomStyleOverride.customTextASize) {
        customStyleTextA = customStyleTextA + 'font-size:' + $scope.pickerCustomStyleOverride.customTextASize + ';';
      }
      if ($scope.pickerCustomStyleOverride.customTextBColor) {
        customStyleTextB = customStyleTextB + 'color:' + $scope.pickerCustomStyleOverride.customTextBColor + ';';
      }
      if ($scope.pickerCustomStyleOverride.customTextBSize) {
        customStyleTextB = customStyleTextB + 'font-size:' + $scope.pickerCustomStyleOverride.customTextBSize + ';';
      }
    }
    customStyleTextA += '"';
    customStyleTextB += '"';
    // END OF CONFIG

    if ($scope.offer.customTextBelow) {
      $scope.offer.customTextBelow = '<span ' + customStyleTextB + '>' + $scope.offer.customTextBelow + '<span>';
    }
    if ($scope.offer.customText) {
      $scope.offer.customText = '<span ' + customStyleTextA + '>' + $scope.offer.customText + '<span>';
    }

    $scope.pickerRetailerLogo = (retailer) => {
      if ($scope.pickerCustomStyleOverride) {
        if (
          $scope.pickerCustomStyleOverride.bwButtonColor == 'BLACK' ||
          $scope.pickerCustomStyleOverride.bwButtonColor == 'WHITE'
        ) {
          rootPicker.style.setProperty('--retailer-button-background', 'rgb(0,0,0)');
          return retailer.style.whiteOnBlackLogo
            ? Util.patchImageUrl(retailer.style.whiteOnBlackLogo)
            : 'https://assets-cf.pearcommerce.com/bw-default.png';
        } else {
          return Util.patchImageUrl(retailer.style.logo);
        }
      } else {
        return Util.patchImageUrl(retailer.style.logo);
      }
    };

    $scope.pickerRetailerBackgroundButton = (retailer) => {
      if ($scope.pickerCustomStyleOverride && $scope.pickerCustomStyleOverride.bwButtonColor) {
        if ($scope.pickerCustomStyleOverride.bwButtonColor == 'BLACK') {
          rootPicker.style.setProperty('--retail-button-border', '2px solid #ffffff');
          return '#000000';
        } else if ($scope.pickerCustomStyleOverride.bwButtonColor == 'WHITE') {
          rootPicker.style.setProperty('--retail-button-shadow', 'none');
          rootPicker.style.setProperty('--retail-button-border', '2px solid #000000');
          return '#ffffff';
        }
      }
      return (retailer.style && retailer.style.backgroundColor) || '#FFFFFF';
    };

    $scope.selectTextColor = (retailer) => {
      if ($scope.pickerCustomStyleOverride && $scope.pickerCustomStyleOverride.bwButtonColor) {
        if ($scope.pickerCustomStyleOverride.bwButtonColor == 'BLACK') {
          return '#ffffff';
        } else if ($scope.pickerCustomStyleOverride.bwButtonColor == 'WHITE') {
          return '#000000';
        }
      } else if (retailer.style && retailer.style.backgroundColor) {
        const buttonColor = retailer.style.backgroundColor;
        let rgb;
        if (buttonColor.charAt(0) == '#') {
          rgb = Util.hexToRgb(buttonColor);
        } else {
          rgb = buttonColor
            .substring(4, buttonColor.length - 1)
            .replace(/ /g, '')
            .split(',');
        }
        if (rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114 > 143) {
          return '#000000';
        } else {
          return '#ffffff';
        }
      }
      return '#ffffff';
    };

    if ($scope.pickerCustomStyleOverride && $scope.pickerCustomStyleOverride.assetUrls) {
      const pickerAssetStyleElem = window.document.querySelector('style#picker-pick-stylesheet');
      const pickerSheet =
        [...window.document.styleSheets].filter((ss) => ss.ownerNode == pickerAssetStyleElem)[0] || null;
      if (pickerSheet) {
        ($scope.pickerCustomStyleOverride.assetUrls || [])
          .filter(
            (asset) =>
              asset.indexOf('.woff') == asset.length - 4 - 1 ||
              asset.indexOf('.ttf') == asset.length - 3 - 1 ||
              asset.indexOf('.eot') == asset.length - 3 - 1
          )
          .forEach((asset) => {
            if (asset && asset.indexOf('https://s3.amazonaws.com/assets.pearcommerce.com/') != -1) {
              // better for CORS
              asset = asset.replace(
                'https://s3.amazonaws.com/assets.pearcommerce.com/',
                'https://assets-cf.pearcommerce.com/'
              );
            }
            const parts = new URL(asset).pathname.split('/');
            const assetFilename = parts[parts.length - 1] || parts[parts.length - 2];
            const assetName = assetFilename.substring(0, assetFilename.length - 4);

            const fontFaceName =
              ($scope.pickerCustomStyleOverride.pickerFontFamily || '')
                .split(',')
                .filter((fontFamilyName) => asset.indexOf(fontFamilyName) != -1)[0] || assetName;

            if (pickerSheet && pickerSheet.insertRule) {
              pickerSheet.insertRule(
                `
              @font-face {
                font-family: '${fontFaceName}';
                src:url('${asset}');
              }
            `,

                pickerSheet.cssRules.length
              );
            }
          });
      }
    }

    $scope.getRetailerMuliselectPrice = (retailer) => {
      let ret = 0;
      for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
        if ($scope.pearLogicalUPCs[i].multiSelected) {
          for (let j = 0; j < retailer.upcs.length; j++) {
            if (retailer.upcs[j].pearLogicalUPCId == $scope.pearLogicalUPCs[i].pearLogicalUPCId) {
              ret += retailer.upcs[j].price;
            }
          }
        }
      }
      return ret;
    };

    $scope.getRetailerDescription = (retailerId) => {
      return $scope.WIDGET_CONFIG.retailerDescription[retailerId] || '';
    };

    $scope.shouldShowMultiSelectItem = (logicalUPC) => {
      for (let i = 0; i < $scope.pickerList.length; i++) {
        const retailer = $scope.pickerList[i];
        let requireInstore =
          retailer.nameEnum == 'walmart' && $scope.offer && !$scope.offer.allowOnlineOnlyForWalmart && false;
        for (let j = 0; j < retailer.upcs.length; j++) {
          if (logicalUPC.pearLogicalUPCId == retailer.upcs[j].pearLogicalUPCId) {
            if (
              (!requireInstore && retailer.upcs[j].status == 'AVAILABLE') ||
              retailer.upcs[j].inStoreStatus == 'AVAILABLE'
            ) {
              logicalUPC.grayOutMultiSelectItem = false;
              return true;
            }
          }
        }
      }
      // Kind of weird for a viewer method, but if the item isn't available anywhere, unselect
      if ($scope.pickerList.length > 0) {
        logicalUPC.multiSelected = false;
      }
      if ($scope.offer.alwaysShouldShowMultiSelectItem) {
        logicalUPC.grayOutMultiSelectItem = true;
        return true;
      }

      return false;
    };
    $scope.pearLogicalUPCs.sort((a, b) => {
      return a.grayOutMultiSelectItem - b.grayOutMultiSelectItem;
    });
    $scope.shouldDisplayRetailer = (retailer) => {
      let requireInstore =
        retailer.nameEnum == 'walmart' && $scope.offer && !$scope.offer.allowOnlineOnlyForWalmart && false;

      if ($scope.offer && $scope.offer.multiSelect) {
        if (!retailer.supportsMultipleItemATC) {
          let count = 0;
          for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
            if ($scope.pearLogicalUPCs[i].multiSelected) {
              count++;
            }
          }
          if (count > 1) {
            return false;
          }
        }

        for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
          if ($scope.pearLogicalUPCs[i].multiSelected) {
            let found = false;
            for (let j = 0; j < retailer.upcs.length; j++) {
              if (retailer.upcs[j].pearLogicalUPCId == $scope.pearLogicalUPCs[i].pearLogicalUPCId) {
                if (
                  retailer.upcs[j].status == 'AVAILABLE' &&
                  (!requireInstore || retailer.upcs[j].inStoreStatus == 'AVAILABLE')
                ) {
                  found = true;
                }
              }
            }
            if (!found) {
              return false;
            }
          }
        }
        return true;
      }
      if (!$scope.selectedPearLogicalUPC || !(retailer && retailer.upcs)) {
        return false;
      }
      for (let i = 0; i < retailer.upcs.length; i++) {
        if (
          retailer.upcs[i].pearLogicalUPCId == $scope.selectedPearLogicalUPC.pearLogicalUPCId &&
          retailer.upcs[i].status == 'AVAILABLE' &&
          (!requireInstore || retailer.upcs[i].inStoreStatus == 'AVAILABLE')
        ) {
          return true;
        }
      }
      return false;
    };
    $scope.snowdaysRetailerListEmpty = (retailers) => {
      for (let i = 0; i < retailers.length; i++) {
        if ($scope.retailerHasAvailableUPC(retailers[i]) && retailers[i].searchPath) {
          return false;
        }
      }
      return true;
    };
    $scope.retailerHasAvailableUPC = (retailer) => {
      let requireInstore =
        retailer.nameEnum == 'walmart' && $scope.offer && !$scope.offer.allowOnlineOnlyForWalmart && false;

      let ret = false;
      for (let i = 0; i < retailer.upcs.length; i++) {
        if (
          ((retailer.upcs[i].status == 'AVAILABLE' && !requireInstore) ||
            retailer.upcs[i].inStoreStatus == 'AVAILABLE') &&
          (!ret ||
            retailer.upcs[i].UPC == '860000023931' ||
            retailer.upcs[i].UPC == '860000023917' ||
            retailer.upcs[i].UPC == '850031700055' ||
            retailer.upcs[i].UPC == '850031700048' ||
            retailer.upcs[i].UPC == '850031700031')
        ) {
          ret = retailer.upcs[i];
        }
      }
      return ret;
    };

    $scope.showRetailerBorderColorPDP = (retailer) => {
      if ($scope.retailerBorderColorPDP == null) {
        return 'border: 2px solid ' + retailer.style.backgroundColor;
      } else if ($scope.retailerBorderColorPDP) {
        return 'border: 2px solid ' + retailer.style.backgroundColor;
      }
    };

    $scope.snowDaysText = (retailer) => {
      let ret = '';

      for (let i = 0; i < retailer.upcs.length; i++) {
        if (retailer.upcs[i].status == 'AVAILABLE') {
          if (retailer.upcs[i].id + '' == '1988700420836832' || retailer.upcs[i].id + '' == '2120578558377088') {
            ret += 'Buffalo Chicken, ';
          }
          if (retailer.upcs[i].id + '' == '1988700420402656') {
            ret += 'Cheese, ';
          }
          if (retailer.upcs[i].id + '' == '2032659065655264') {
            ret += 'Sausage, ';
          }
          if (retailer.upcs[i].id + '' == '2032658600218560') {
            ret += 'Veggie White, ';
          }
        }
      }
      if (ret.length >= 2) {
        ret = ret.substring(0, ret.length - 2);
      }
      return ret;
    };

    $scope.snowDaysTextSingleItem = (upc) => {
      let ret = '';

      if (upc.id + '' == '1988700420836832' || upc.id + '' == '2120578558377088') {
        ret = 'Buffalo Chicken';
      }
      if (upc.id + '' == '1988700420402656') {
        ret = 'Cheese';
      }
      if (upc.id + '' == '2032659065655264') {
        ret = 'Sausage';
      }
      if (upc.id + '' == '2032658600218560') {
        ret = 'Veggie White';
      }

      return ret;
    };

    $scope.snowdaysShouldShowComma = (pearLogicalUPCs, retailer, upc) => {
      let lastMatch = null;
      for (let i = 0; i < pearLogicalUPCs.length; i++) {
        for (let j = 0; j < retailer.upcs.length; j++) {
          if (pearLogicalUPCs[i].UPC == retailer.upcs[j].UPC && retailer.upcs[j].status == 'AVAILABLE') {
            lastMatch = retailer.upcs[j];
          }
        }
      }
      return lastMatch && !(lastMatch.UPC == upc.UPC);
    };

    $scope.snowDaysPriceText = (retailer) => {
      let min = Number.MAX_VALUE;
      let max = -1;
      let ret = '';
      let realPrice = false;
      for (let i = 0; i < retailer.upcs.length; i++) {
        if (retailer.upcs[i].inStoreStatus == 'AVAILABLE' && retailer.upcs[i].price) {
          realPrice = true;
          let price = retailer.upcs[i].price;
          if (price && price < min) {
            min = price;
          }
          if (price && price > max) {
            max = price;
          }
        }
      }
      if (realPrice) {
        if (min == max) {
          ret = '$' + min.toFixed(2) + '/6oz Bag';
        } else {
          ret = '$' + min.toFixed(2) + ' - ' + max.toFixed(2) + '/6oz Bag';
        }
      } else {
        ret = 'Check Link For Price';
      }
      return ret;
    };

    $scope.snowdaysPdpClick = (retailer, logicalUPC, $event) => {
      if (retailer.id == 19 && logicalUPC && $event) {
        $scope.clickRetailer(retailer, logicalUPC, $event);
        return;
      }
      $api
        .post('/v1/custom_event', {
          offerId: $scope.offer.id,
          vendorId: $scope.offer.vendorId,
          retailer: retailer.nameEnum,
        })
        .then(() => {
          let redirectUrl =
            retailer.ecommerceUrl +
            retailer.searchPath +
            encodeURIComponent(retailer.name == 'goPuff' ? 'Snow Days Pizza Bites' : 'Snow Days');

          const href = window.location.href;
          if ($rootScope.inIframe) {
            let redirected = false;
            $rootScope.pymChild.onMessage('redirected', () => {
              redirected = true;
            });
            $rootScope.pymChild.sendMessage(
              'buy-now-clicked',
              JSON.stringify({ url: redirectUrl, source: 'liquiddeath et al.' })
            );
            setTimeout(() => {
              if (!redirected) {
                top.window.location.href = redirectUrl;
              }
            }, 50);
          } else if ($rootScope.inIframe) {
            top.window.location.href = redirectUrl;
          } else {
            const open = window.open(redirectUrl, '_blank');
            if (open == null || typeof open == 'undefined') {
              window.location = redirectUrl;
            }
          }
        });
    };
    $scope.getPromoTextForRetailer = (retailer) => {
      for (let i = 0; i < retailer.upcs.length; i++) {
        if (retailer.upcs[i].promoText) {
          return retailer.upcs[i].promoText;
        }
      }
      return false;
    };

    const scrollToOldDutchRetailer = (el) => {
      const scrollLocation = el.offsetLeft - 250;
      let carousel = document.getElementsByClassName('pear-carousel-container');
      if (carousel && carousel[0]) {
        carousel[0].scroll({
          top: 0,
          left: scrollLocation,
          behavior: 'smooth',
        });
      }
    };

    const scrollToProductElement = (el) => {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    };

    if ($state.current.name == 'old-dutch-wtb') {
      $scope.selectedPearLogicalUPC = null;
    } else {
      $scope.selectedPearLogicalUPC = $scope.pearLogicalUPCs[0];
    }

    let scrollHandler;
    if ($state.current.name == 'old-dutch-wtb') {
      scrollHandler = (elem) => {
        scrollToOldDutchRetailer(elem);
      };
    } else {
      scrollHandler = (elem) => {
        if (elem) {
          elem.click();
        }
      };
    }

    $scope.pristine = true;
    $scope.selectedCarouselIndex = 0;
    $scope.scrollCarousel = (num) => {
      $scope.pristine = false;

      let carousel = document.getElementsByClassName('pear-carousel-container');
      const elems = (carousel && carousel[0] && carousel[0].getElementsByClassName('pear-carousel-item')) || [];
      let cur = null;
      for (let i = 0; i < elems.length; i++) {
        cur = elems[i];
        if (cur.className.indexOf('selected') >= 0) {
          try {
            const newElem = elems[i + num];
            if (newElem) {
              $scope.selectedCarouselIndex = i + num;
              scrollHandler(newElem);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    };

    $scope.checkIfOfferOrUpcs = function () {
      return window.location.href.indexOf('/upcs/') != 1;
    };
    $scope.searchTimeExpired = { value: false };
    $timeout(() => {
      $scope.searchTimeExpired.value = true;
    }, 7500);
    $scope.millsOfferIdPresent = (id) => {
      return millsFontCSS.includes(id);
    };

    $scope.setLogicalUPC = ($event, logicalUPC) => {
      $scope.selectedPearLogicalUPC = logicalUPC;
      scrollToProductElement($event.currentTarget);
      if (!$scope.offer) {
        $scope.heroImage = Util.patchImageUrl(logicalUPC.imageUrl);
      }
    };

    if ($scope.offer && $scope.offer.multiSelect) {
      //TODO: I can't explain exactly the behavior im seeing on setting up product groups on admin, but for now, we're going to disable groups.  -Eric
      $scope.offer.multiSelectGroupings = false;
      if ($scope.offer.multiSelectGroupings) {
        for (let i = 0; i < $scope.offer.multiSelectGroupings.length; i++) {
          if ($scope.offer.multiSelectGroupings[i].preselected) {
            for (let j = 0; j < $scope.pearLogicalUPCs.length; j++) {
              for (let k = 0; k < $scope.offer.multiSelectGroupings[i].logicalUPCIds.length; k++) {
                if (
                  $scope.offer.multiSelectGroupings[i].logicalUPCIds[k] == $scope.pearLogicalUPCs[j].pearLogicalUPCId
                ) {
                  $scope.pearLogicalUPCs[j].multiSelected = true;
                }
              }
            }
          }
        }
      } else {
        for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
          $scope.pearLogicalUPCs[i].multiSelected = true;
          break; // TODO: select all or select first, but for now we're selecting first'
        }
      }
    }

    $scope.toggleLogicalUPCMultiSelect = function (logicalUPC) {
      if ($scope.offer.alwaysShouldShowMultiSelectItem && logicalUPC.grayOutMultiSelectItem) return;
      let selectedCount = 0;
      $scope.changeSelectedUPC = true;
      for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
        if ($scope.pearLogicalUPCs[i].multiSelected) {
          selectedCount++;
        }
      }
      logicalUPC.multiSelected = !logicalUPC.multiSelected;
    };

    $scope.toggleAllRecipeProducts = (i) => {
      const logicalUPC = $scope.pearLogicalUPCs[i];
      if (logicalUPC) {
        if (!logicalUPC.multiSelected) {
          $scope.toggleLogicalUPCMultiSelect(logicalUPC);
        }
        setTimeout(() => {
          setTimeout(() => {
            $scope.toggleAllRecipeProducts(i + 1);
          }, 0);
        }, 0);
      } else {
        $scope.$apply();
      }
    };

    $scope.toggleLogicalUPCMultiSelectWithGroup = function (logicalUPC, group) {
      let selectedCount = 0;
      for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
        for (let j = 0; j < group.logicalUPCIds.length; j++) {
          if (
            $scope.pearLogicalUPCs[i].multiSelected &&
            group.logicalUPCIds[j] == $scope.pearLogicalUPCs[i].pearLogicalUPCId
          ) {
            selectedCount++;
          }
        }
      }
      logicalUPC.multiSelected = !logicalUPC.multiSelected;
    };

    $scope.showRetailerList = function () {
      if (!$scope.offer || !$scope.offer.multiSelect) {
        return true;
      }
      for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
        if ($scope.pearLogicalUPCs[i].multiSelected) {
          return true;
        }
      }
      return false;
    };

    $scope.pickerLength = () => {
      let ret = 0;
      for (let i = 0; i < $scope.pickerList.length; i++) {
        if ($scope.shouldDisplayRetailer($scope.pickerList[i])) {
          ret++;
        }
      }
      return ret;
    };

    const retailerUPCToAvailableTime = {};
    $scope.resolveTime = new Date().getTime();

    $scope.pickerListDisplayCached = (pickerUPC, buyOnline) => {
      return (
        (cachedValue = (pickerListDisplayCache[!!buyOnline] = pickerListDisplayCache[!!buyOnline] || {})[
          (pickerUPC && pickerUPC.id) || 0
        ]) || $scope.pickerListDisplay(pickerUPC, buyOnline)
      );
    };

    $scope.pickerListDisplay = (pickerUPC, buyOnline) => {
      if (
        (cachedValue = (pickerListDisplayCache[!!buyOnline] = pickerListDisplayCache[!!buyOnline] || {})[
          (pickerUPC && pickerUPC.id) || 0
        ]) &&
        !buyOnline
      ) {
        if (inProductLocator || ($scope.offer.multiSelect && $scope.changeSelectedUPC == false)) {
          return cachedValue;
        }
      }

      let ret = [];
      if ($scope.offer && $scope.offer.multiSelect && $scope.pickerList.length > 0) {
        let selectedCount = 0;
        for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
          if ($scope.pearLogicalUPCs[i].multiSelected) {
            selectedCount++;
          }
        }
        if (selectedCount == 0) {
          return [];
        }
        for (let i = 0; i < $scope.pickerList.length; i++) {
          if ($scope.shouldDisplayRetailer($scope.pickerList[i])) {
            ret.push($scope.pickerList[i]);
          }
        }
        $scope.changeSelectedUPC = false;
      } else {
        if (!pickerUPC) {
          pickerUPC = $scope.selectedPearLogicalUPC;
        }
        if (pickerUPC) {
          for (let i = 0; i < $scope.pickerList.length; i++) {
            const retailer = $scope.pickerList[i];
            if (retailer) {
              let requireInstore =
                retailer.nameEnum == 'walmart' && (!$scope.offer || !$scope.offer.allowOnlineOnlyForWalmart) && false;
              for (let j = 0; j < retailer.upcs.length; j++) {
                const upc = retailer.upcs[j];
                if (
                  (upc.pearLogicalUPCId == pickerUPC.pearLogicalUPCId ||
                    (inProductLocator && upc.UPC == pickerUPC.UPC)) &&
                  (((!requireInstore || buyOnline) && upc.status == 'AVAILABLE') || upc.inStoreStatus == 'AVAILABLE')
                ) {
                  if ($scope.offer && $scope.offer.upcSortDefinesRetailerOrder) {
                    retailer.style.sortOrder = upc.retailerSortOrder;
                  }

                  if(retailer.style) {
                    retailer.style.whiteOnBlackLogo = Util.patchImageUrl(retailer.style.whiteOnBlackLogo);
                    retailer.style.logo = Util.patchImageUrl(retailer.style.logo);
                  }

                  ret.push(retailer);
                  if (!retailerUPCToAvailableTime[retailer.nameEnum + ',' + pickerUPC.pearLogicalUPCId]) {
                    retailerUPCToAvailableTime[retailer.nameEnum + ',' + pickerUPC.pearLogicalUPCId] =
                      $scope.resolveTime;
                  }
                  break;
                }
              }
            }
          }
        }

        let shouldSort =
          !!!$stateParams.key &&
          window.location.href.indexOf('/demo/') == -1 &&
          (!$scope.offer ||
            ($scope.offer.id + '' != '1699976141042688' &&
              $scope.offer.id + '' != '1699976141042689' &&
              $scope.offer.id + '' != '1826617134374081') ||
            $scope.offer.id + '' == '1833240034027009' ||
            $scope.offer.id + '' == '1833240034027010' ||
            $scope.offer.id + '' == '1833240034027011');

        if (shouldSort) {
          const plSelectedRetailerId = $scope.selectedStore && $scope.selectedStore.retailerId;

          ret = ret.sort((a, b) => {
            if (!!a.imageUrl != !!b.imageUrl) {
              return !!a.imageUrl ? -1 : 1;
            }
            if (!!a.isVendor != !!b.isVendor) {
              //if a retailer is a vendor retailer button then ask the sort question first
              if (b && b.style && b.style.sortOrder == 1) {
                //if the vendor retailer is not 1 then skip
                return ((a && a.style && a.style.sortOrder) || 0) - ((b && b.style && b.style.sortOrder) || 0);
              }
            }
            if (a.id == plSelectedRetailerId) {
              return -1;
            } else if (b.id == plSelectedRetailerId) {
              return 1;
            }

            if (
              retailerUPCToAvailableTime[a.nameEnum + ',' + pickerUPC.id] !=
              retailerUPCToAvailableTime[b.nameEnum + ',' + pickerUPC.id]
            ) {
              return (
                retailerUPCToAvailableTime[a.nameEnum + ',' + pickerUPC.id] -
                retailerUPCToAvailableTime[b.nameEnum + ',' + pickerUPC.id]
              );
            } else if ((a && a.style && a.style.sortOrder) != (b && b.style && b.style.sortOrder)) {
              return (
                ((a && a.style && a.style.sortOrder) || Number.MAX_SAFE_INTEGER) -
                ((b && b.style && b.style.sortOrder) || Number.MAX_SAFE_INTEGER)
              );
            } else {
              if (a.name < b.name) {
                return -1;
              } else if (b.name < a.name) {
                return 1;
              } else {
                return 0;
              }
            }
          });
        }
      }

      return (pickerListDisplayCache[!!buyOnline][(pickerUPC && pickerUPC.id) || 0] = ret);
    };

    $scope.setCameFromAddress = function () {
      $scope.cameFromAddress = true;
    };

    $scope.unsetCameFromAddress = function () {
      $scope.cameFromAddress = false;
    };

    $scope.setOpenPanelFocus = async function () {
      if ($scope.productsOpen && $scope.visitedLastProductTile) {
        $scope.visitedLastProductTile = false;
        document.querySelector('.overlay-widgets__combobox-input')?.focus();
      } else if ($scope.productsOpen && !$scope.cameFromAddress) {
        await Util.timeout(50);
        if (document.querySelector('#reset-retailer-button')) {
          document.querySelector('#reset-retailer-button')?.focus();
        } else if (document.querySelector('#reset-product-button')) {
          document.querySelector('#reset-product-button')?.focus();
        } else if (document.querySelector('.retailer-filter-card:nth-child(1)') != null) {
          document.querySelector('.retailer-filter-card:nth-child(1)')?.focus();
        } else if (document.querySelector('.categories.ng-scope > fieldset > div:nth-child(2) > button') != null) {
          document.querySelector('.categories.ng-scope > fieldset > div:nth-child(2) > button')?.focus();
        } else {
          document.querySelector('.product-card  > div ')?.focus();
        }
      } else if ($scope.productsOpen && $scope.cameFromAddress) {
        document.querySelector('.back-to-products')?.focus();
        $scope.cameFromAddress = false;
      }
    };
    $scope.buttonClicked = $async(async function (upcId, selectedUPCs) {
      await Util.timeout(10);

      let queryString = '#focusedBtn-' + upcId + '-';
      let count = 2;

      if (document.querySelector(queryString + count) != null && selectedUPCs.length == 0) {
        document.querySelector(queryString + count).focus();
      } else if (document.querySelector(queryString + (count - 1)) != null && selectedUPCs.length > 2) {
        document.querySelector(queryString + (count - 1)).focus();
      } else {
        document.querySelector(queryString + (count - 2)).focus();
      }
    });

    $scope.pdpButtonPress = $async(async function (id) {
      await Util.timeout(50);
      let queryString = `#focusedBtn-${id !== undefined ? id : 3}`;
      if (document.querySelector(queryString) != null) {
        document.querySelector(queryString).focus();
      }
    });

    $scope.seeMorePlacesClicked = $async(async function (id) {
      await Util.timeout(50);
      let queryString = `.focusedBtn-${id !== undefined ? id : 3}`;
      if (document.querySelector(queryString) != null) {
        document.querySelector(queryString).focus();
      }
    });

    $scope.isInstacartLinkInLogicalUPCs = (allRetailerUPCs, logicalUPCToMatch) => {
      const upc = logicalUPCToMatch.UPC;
      const matchingRetailerUPCs = allRetailerUPCs.filter((aUPC) => aUPC.UPC === upc);

      // TODO: We'll need to re-factor this when this length can viably be more than
      // one.
      if (matchingRetailerUPCs.length === 1) {
        return $scope.isInstacartLink(matchingRetailerUPCs[0].url);
      }

      return false;
    };

    $scope.isDoorDashLinkInLogicalUPCs = (allRetailerUPCs, logicalUPCToMatch) => {
      const upc = logicalUPCToMatch.UPC;
      const matchingRetailerUPCs = allRetailerUPCs.filter((aUPC) => aUPC.UPC === upc);

      // TODO: We'll need to re-factor this when this length can viably be more than
      // one.
      if (matchingRetailerUPCs.length === 1) {
        return $scope.isDoorDashLink(matchingRetailerUPCs[0].url);
      }

      return false;
    };

    $scope.isInstacartLink = (retailerLink) => {
      return String(retailerLink).indexOf('instacart') != -1;
    };

    $scope.isDoorDashLink = (retailerLink) => {
      return String(retailerLink).indexOf('doordash') != -1;
    };

    $scope.memoizedInstacartLinksByRetailer = {};
    $scope.memoizedDoorDashLinksByRetailer = {};

    $scope.doAllLinksForARetailerPassTest = (retailerName, retailerUPCs, testFunction, memoizer) => {
      const allLinksPassTest = retailerUPCs.reduce((prev, next) => {
        prev = prev && testFunction(next.url);
        return prev;
      }, true);

      memoizer[retailerName] = allLinksPassTest;

      return allLinksPassTest;

    }

    $scope.areAllLinksForARetailerInstacartLinks = (retailerName, retailerUPCs) => {
      return $scope.doAllLinksForARetailerPassTest(retailerName, retailerUPCs, $scope.isInstacartLink, $scope.memoizedInstacartLinksByRetailer);
    };

    $scope.areAllLinksForARetailerDoordashLinks = (retailerName, retailerUPCs) => {
      return $scope.doAllLinksForARetailerPassTest(retailerName, retailerUPCs, $scope.isDoorDashLink, $scope.memoizedDoorDashLinksByRetailer);
    };

    $scope.shouldShowIndividualInstacartLink = (retailerName, upcURL) => {
      const memoizedRetailerAllICLinks = $scope.memoizedInstacartLinksByRetailer[retailerName];

      // If we've memoized a value of true, we do not need to check the link
      // If we've memoized false or not at all, we check the link.
      if (memoizedRetailerAllICLinks === true) {
        return false;
      }

      return $scope.isInstacartLink(upcURL);
    };

    $scope.shouldShowIndividualDDLink = (retailerName, upcURL) => {
      const memoizedRetailerAllDDLinks = $scope.memoizedDoorDashLinksByRetailer[retailerName];

      // If we've memoized a value of true, we do not need to check the link
      // If we've memoized false or not at all, we check the link.
      if (memoizedRetailerAllDDLinks === true) {
        return false;
      }

      return $scope.isDoorDashLink(upcURL);
    };

    $rootScope.WIDGET_CONFIG = $rootScope.WIDGET_CONFIG || {};
    $scope.productFilterTitle = 'Filters';
    $scope.hierarchy = 'IN_STORE_VS_ONLINE';

    function injectWidgetConfig(config) {
      window.PEAR_WIDGET_CONFIG = window.PEAR_WIDGET_CONFIG || {};
      Object.assign(window.PEAR_WIDGET_CONFIG, Util.keepDefined(config || {}));

      $rootScope.WIDGET_CONFIG = window.PEAR_WIDGET_CONFIG;

      $scope.showStoreTypes = $rootScope.WIDGET_CONFIG.showStoreTypes || false;
      $scope.filterMapExcludeCategories = $rootScope.WIDGET_CONFIG.filterMapExcludeCategories || [];
      $scope.showSyntheticStoreProducts = $rootScope.WIDGET_CONFIG.showSyntheticStoreProducts || false;
      $scope.showMobileLocatorTitle = $rootScope.WIDGET_CONFIG.titledHeader || false;
      $scope.showProductLine = $rootScope.WIDGET_CONFIG.showProductLine || false;
      $scope.startWithProductFilterOpen = $rootScope.WIDGET_CONFIG.startProductFilterOpen || false;
      $scope.singleItemSelect = $rootScope.WIDGET_CONFIG.singleItemSelect || false;
      $scope.hideSyntheticStoresOnProductFilter = $rootScope.WIDGET_CONFIG.hideSyntheticStoresOnProductFilter || false;

      // removeRestaurantRetailerFilter possibly depricated
      // $scope.removeRestaurantRetailerFilter = $rootScope.WIDGET_CONFIG.removeRestaurantRetailerFilter || false;
      $scope.ignoreCategories = $rootScope.WIDGET_CONFIG.ignoreCategory || [];
      $scope.pinUPCIdsToTop = $rootScope.WIDGET_CONFIG.pinUPCIdsToTop || [];
      $scope.preSelectedUPCIds = $rootScope.WIDGET_CONFIG.preSelectedUPCIds || [];
      let preSelectedUPCIdsRaw = new URLSearchParams(window.location.search).get("preselectedUPCIds");
      if (preSelectedUPCIdsRaw) {
        $scope.preSelectedUPCIds = preSelectedUPCIdsRaw
            .split(",")
            .map(id => id.trim())
            .filter(id => /^\d+$/.test(id))
            .map(Number);
      }
      $scope.mapTheme = $rootScope.WIDGET_CONFIG.theme || 'light';
      $scope.bwLogoImage = $rootScope.WIDGET_CONFIG.bwLogoImage || false;

      $scope.injectPagination = $rootScope.WIDGET_CONFIG.injectPagination || false;
      $scope.productFilterTitle = $rootScope.WIDGET_CONFIG.filterTitle || 'Filters';
      $scope.retailerBuyOnlineBtnCTA = $rootScope.WIDGET_CONFIG.retailerBuyOnlineBtnCTA || 'Add to Cart';
      $scope.enableRetailerFilter = $rootScope.WIDGET_CONFIG.enableRetailerFilter || false;
      $scope.resetFilterOnInStoreTab = $rootScope.WIDGET_CONFIG.resetFilterOnInStoreTab || false;
      $scope.showBuyOnlineTab = $rootScope.WIDGET_CONFIG.showBuyOnlineTab || false;
      // for some reason the "hide buy online tab" is called "show buy online tab" in the config. So setting it to hideOnlineTab here so it's not confusing in the code.
      $scope.hideBuyOnlineTab = $scope.showBuyOnlineTab;
      $scope.buyOnlineTabActive = $rootScope.WIDGET_CONFIG.buyOnlineTabActive || false;
      $scope.buyOnlineTabText = $rootScope.WIDGET_CONFIG.buyOnlineTabText || "Buy Online";
      $scope.inStoreTabText = $rootScope.WIDGET_CONFIG.inStoreTabText || "In-Store";
      $scope.showPhoneNumInStoreLst = $rootScope.WIDGET_CONFIG.showPhoneNumInStoreLst || false;
      $scope.showProductSearch = $rootScope.WIDGET_CONFIG.showProductSearch || false;

      $scope.defaultZoom = $rootScope.WIDGET_CONFIG.defaultZoom || 12;

      $scope.hasExitSelector = !!$rootScope.WIDGET_CONFIG.exitSelector;
      $scope.hasImportedStore = !!$rootScope.WIDGET_CONFIG.importedStores;

      $scope.vendorProvidedPin = Util.patchImageUrl($rootScope.WIDGET_CONFIG.vendorProvidedPin);
      // $scope.vendorProvidedPinStyleHeight = $rootScope.WIDGET_CONFIG.vendorProvidedPinHeight || '100%';
      // $scope.vendorProvidedPinStyleLeft = $rootScope.WIDGET_CONFIG.vendorProvidedPinLeft || '0px';
      // $scope.vendorProvidedPinTop = $rootScope.WIDGET_CONFIG.vendorProvidedPinTop || '-2px'

      $scope.googleMapCountryRestriction = $rootScope.WIDGET_CONFIG.googleMapCountryRestriction || '';
      $scope.filterOutVendor = $rootScope.WIDGET_CONFIG.filterOutVendorAsRetailer || false;
      const addressInputConfig =
        $rootScope.WIDGET_CONFIG &&
        $rootScope.WIDGET_CONFIG.widgetConfig &&
        $rootScope.WIDGET_CONFIG.widgetConfig.addressInputConfig;
      $scope.addressInputTextBehavior = (addressInputConfig && addressInputConfig.textValue) || 'EDITABLE';
      $scope.addressInputFocusBehavior = (addressInputConfig && addressInputConfig.filterFocusBehavior) || 'KEEP_TEXT';
      $scope.outOfStockMessageContent =
        $rootScope.WIDGET_CONFIG?.pdpConfig?.outOfStockMessageStyle?.content ||
        'Item is not currently in stock. Check back soon!';
      const configPromptText = $rootScope.WIDGET_CONFIG?.pdpConfig?.bundleProductPromptText?.trim();
      $scope.widgetProductBundlePromptText = (configPromptText || "Buy:") + " ";
      
      if ($rootScope.WIDGET_CONFIG?.pdpConfig?.clearBundleProductPromptText === true) {
        $scope.widgetProductBundlePromptText = "";
      }

      const assetStyleElem = window.document.querySelector('style.asset-stylesheet');
      const sheet = [...window.document.styleSheets].filter((ss) => ss.ownerNode == assetStyleElem)[0] || null;
      if (sheet) {
        let fontNameArray = [
          $rootScope.WIDGET_CONFIG.fontFamily,
          $rootScope.WIDGET_CONFIG.smallFontFamily,
          $rootScope.WIDGET_CONFIG.seeMoreFontName,
        ].filter(item=>item);

        //sort array so longer names are seen first. Prevents indexOf match incorrectly
        //ext ["TimesBold", "Times"]  If "Times" was first we would never match "TimesBold"
        if (fontNameArray.length >= 1) {
          fontNameArray.sort((a, b) => b.length - a.length);
        }
        ($rootScope.WIDGET_CONFIG.assetUrls || [])
          .filter(
            (asset) =>
              asset.indexOf('.woff') == asset.length - 4 - 1 ||
              asset.indexOf('.ttf') == asset.length - 3 - 1 ||
              asset.indexOf('.eot') == asset.length - 3 - 1
          )
          .forEach((asset) => {
            if (asset && asset.indexOf('https://s3.amazonaws.com/assets.pearcommerce.com/') != -1) {
              // better for CORS
              asset = asset.replace(
                'https://s3.amazonaws.com/assets.pearcommerce.com/',
                'https://assets-cf.pearcommerce.com/'
              );
            }
            const parts = new URL(asset).pathname.split('/');
            const assetFilename = parts[parts.length - 1] || parts[parts.length - 2];
            let assetName = assetFilename.substring(0, assetFilename.length - 4);
            if (asset.indexOf('.woff') != -1) {
              assetName = assetFilename.substring(0, assetFilename.length - 5);
            }

            let fontFaceName =
              ($rootScope.WIDGET_CONFIG.fontFamily || '')
                .split(',')
                .filter((fontFamilyName) => asset.indexOf(fontFamilyName) != -1)[0] ||
              fontNameArray.filter((fontFamilyName) => asset.indexOf(fontFamilyName) != -1)[0] ||
              assetName;

            if (sheet && sheet.insertRule) {
              sheet.insertRule(
                `
                @font-face {
                  font-family: '${fontFaceName}';
                  src:url('${asset}');
                }
              `,
                sheet.cssRules.length
              );
            }
          });
      }

      if (
        $scope.vendor &&
        $scope.vendor.id == '1904492982680032' &&
        $rootScope.WIDGET_CONFIG.filterTitle == 'default'
      ) {
        $scope.productFilterTitle = '';
      }

      let root = document.getElementsByClassName('where-to-buy')[0];
      if (!root) {
        return;
      }
      if ($rootScope.WIDGET_CONFIG.theme) {
        if (root.className.indexOf($rootScope.WIDGET_CONFIG.theme) == -1) {
          root.className += ' ' + $rootScope.WIDGET_CONFIG.theme;
        }
      }

      root.style.setProperty(
        '--font-family-sans-serif',
        $rootScope.WIDGET_CONFIG.fontFamily || '"Helvetica Neue", Helvetica, Arial, sans-serif'
      );
      root.style.setProperty(
        '--font-family-sans-serif-small',
        $rootScope.WIDGET_CONFIG.smallFontFamily || '"Helvetica Neue", Helvetica, Arial, sans-serif'
      );
      root.style.setProperty('--fg-color-1', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1 || '#595959');
      if ($rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2) {
        root.style.setProperty('--fg-color-2', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2);
      }
      if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_3) {
        root.style.setProperty('--fg-color-3', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_3);
      }

      if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1) {
        root.style.setProperty('--accent-color-1', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1 || '#2F2F2F');
      }
      if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2) {
        root.style.setProperty('--accent-color-2', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2 || '#2F2F2F');
      }
      if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_3) {
        root.style.setProperty('--accent-color-3', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_3);
      }

      $scope.blockPearFooter = $rootScope.WIDGET_CONFIG.blockPearFooter || false;

      if ($rootScope.WIDGET_CONFIG.fullScreen) {
        $rootScope.WIDGET_CONFIG.height = '100vh';
        $rootScope.WIDGET_CONFIG.mobileHeight = '100vh';
      }

      if ($scope.isMobile) {
        $rootScope.WIDGET_CONFIG.height = $rootScope.WIDGET_CONFIG.mobileHeight || '500px';
      }

      root.style.setProperty('--height', $rootScope.WIDGET_CONFIG.height || '800px');
      root.style.height = $rootScope.WIDGET_CONFIG.height || '800px';
      if ($rootScope.WIDGET_CONFIG.version == 3) {
        root.parentElement.style.minHeight = $rootScope.WIDGET_CONFIG.height || '800px';
        root.parentElement.parentElement.style.minHeight = $rootScope.WIDGET_CONFIG.height || '800px';
        root.parentElement.parentElement.parentElement.style.minHeight = $rootScope.WIDGET_CONFIG.height || '800px';
      }
      if ($rootScope.WIDGET_CONFIG.height) {
        root.style.height = $rootScope.WIDGET_CONFIG.minHeight;
      } else {
        root.style.height = $rootScope.WIDGET_CONFIG.version == 2 ? '100%' : '800px';
      }
      $scope.height = $rootScope.WIDGET_CONFIG.height || '800px';

      $scope.WIDGET_CONFIG.retailerDescription = $rootScope.WIDGET_CONFIG.retailerDescriptionsForStore || {};

      $scope.accentBg1 = {
        'background-color': $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1,
      };
      $scope.accentBg2 = {
        'background-color': $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1,
      };
      $scope.accentFg1 = {
        color: $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1 || '#595959',
      };
      $scope.accentFg2 = {
        color: $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
      };

      $scope.accentBtn = {
        'background-color': $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
        'border-color': $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
      };

      if (
        !$rootScope.WIDGET_CONFIG.pdpConfig &&
        $rootScope.WIDGET_CONFIG.customStylesConfig &&
        $rootScope.WIDGET_CONFIG.customStylesConfig.pdpConfig
      ) {
        $rootScope.WIDGET_CONFIG.pdpConfig = $rootScope.WIDGET_CONFIG.customStylesConfig.pdpConfig;
      }

      $scope.retailerBorderColorPDP = false;
      // CUSTOM STYLE CONFIG
      if ($rootScope.WIDGET_CONFIG.customStylesConfig) {
        //START of PDP Specific Configs

        if (
          ($rootScope.WIDGET_CONFIG.pdpConfig && $rootScope.WIDGET_CONFIG.type == null) ||
          ($rootScope.WIDGET_CONFIG.type != null && $rootScope.WIDGET_CONFIG.type == 'PDP_PLUS')
        ) {
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressPdpColor) {
            root.style.setProperty('--address-pdp-color', $rootScope.WIDGET_CONFIG.pdpConfig.addressPdpColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderColor) {
            root.style.setProperty('--button-border-color', $rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderHoverColor) {
            root.style.setProperty(
              '--button-border-hover-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderHoverColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBackgroundColor) {
            root.style.setProperty(
              '--button-background-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.buttonBackgroundColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonTextAlign) {
            root.style.setProperty(
              '--retailer-button-text-align',
              $rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonTextAlign
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonLogoAlign) {
            root.style.setProperty(
              '--retailer-button-logo-align',
              $rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonLogoAlign
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerImgBackgroundBorderRadius) {
            root.style.setProperty(
              '--retailer-img-background-border-radius',
              $rootScope.WIDGET_CONFIG.pdpConfig.retailerImgBackgroundBorderRadius
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerImgBackgroundColor) {
            root.style.setProperty(
              '--retailer-img-background-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.retailerImgBackgroundColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderRadius) {
            root.style.setProperty('--button-border-radius', $rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderRadius);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderThickness) {
            root.style.setProperty(
              '--button-border-thickness',
              $rootScope.WIDGET_CONFIG.pdpConfig.buttonBorderThickness
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.textColor) {
            root.style.setProperty('--text-color', $rootScope.WIDGET_CONFIG.pdpConfig.textColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.textHoverColor) {
            root.style.setProperty('--text-hover-color', $rootScope.WIDGET_CONFIG.pdpConfig.textHoverColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonBackgroundHoverColor) {
            root.style.setProperty(
              '--button-background-hover-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.buttonBackgroundHoverColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.minHeightContainer) {
            root.style.setProperty('--min-height-container', $rootScope.WIDGET_CONFIG.pdpConfig.minHeightContainer);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.accentColor) {
            root.style.setProperty('--accent-color', $rootScope.WIDGET_CONFIG.pdpConfig.accentColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreTextColor) {
            root.style.setProperty('--see-more-text-color', $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreTextColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreHoverTextColor) {
            root.style.setProperty(
              '--see-more-hover-text-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreHoverTextColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderColor) {
            root.style.setProperty('--see-more-border-color', $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderColor);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderHoverColor) {
            root.style.setProperty(
              '--see-more-hover-border-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderHoverColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBackgroundColor) {
            root.style.setProperty(
              '--see-more-background-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBackgroundColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBackgroundHoverColor) {
            root.style.setProperty(
              '--see-more-hover-background-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBackgroundHoverColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderRadius) {
            root.style.setProperty('--see-more-border-radius', $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderRadius);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderThickness) {
            root.style.setProperty(
              '--see-more-border-thickness',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreBorderThickness
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreFontName) {
            root.style.setProperty('--see-more-font-family', $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreFontName);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreLetterSpacing) {
            root.style.setProperty(
              '--see-more-font-letter-spacing',
              $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreLetterSpacing
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.seeMoreFontSize) {
            root.style.setProperty('--see-more-font-size', $rootScope.WIDGET_CONFIG.pdpConfig.seeMoreFontSize);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonsTextTrans) {
            root.style.setProperty(
              '--retailer-button-text-transformation',
              $rootScope.WIDGET_CONFIG.pdpConfig.retailerButtonsTextTrans
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.promptTextTrans) {
            root.style.setProperty('--prompt-text-transformation', $rootScope.WIDGET_CONFIG.pdpConfig.promptTextTrans);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.promptSelectAndRetailerTextTrans) {
            root.style.setProperty(
              '--prompt-select-avaiable-text-transformation',
              $rootScope.WIDGET_CONFIG.pdpConfig.promptSelectAndRetailerTextTrans
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptFontWeight) {
            root.style.setProperty(
              '--enter-location-prompt-font-weight',
              $rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptFontWeight
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptFontSize) {
            root.style.setProperty(
              '--enter-location-prompt-font-size',
              $rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptFontSize
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptMargin) {
            root.style.setProperty(
              '--enter-location-prompt-margin',
              $rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptMargin
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelFontSize) {
            root.style.setProperty(
              '--address-tip-label-font-size',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelFontSize
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelFontWeight) {
            root.style.setProperty(
              '--address-tip-label-font-weight',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelFontWeight
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelPadding) {
            root.style.setProperty(
              '--address-tip-label-padding',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelPadding
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelTextTrans) {
            root.style.setProperty(
              '--address-tip-label-text-transformation',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressTipLabelTextTrans
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptCenterElements) {
            root.style.setProperty(
              '--enter-location-prompt-center-elements',
              $rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptCenterElements
            );
            if ($rootScope.WIDGET_CONFIG.pdpConfig.enterLocationPromptCenterElements == 'center') {
              root.style.setProperty('--enter-location-prompt-center-margin', '0 auto');
              root.style.setProperty('--enter-location-prompt-center-display', 'table');
            }
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptFontWeight) {
            root.style.setProperty(
              '--available-retailers-prompt-font-weight',
              $rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptFontWeight
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptFontSize) {
            root.style.setProperty(
              '--available-retailers-prompt-font-size',
              $rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptFontSize
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonFontWeight) {
            root.style.setProperty('--button-font-weight', $rootScope.WIDGET_CONFIG.pdpConfig.buttonFontWeight);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptCenterElements) {
            root.style.setProperty(
              '--available-retailers-prompt-center-elements',
              $rootScope.WIDGET_CONFIG.pdpConfig.availableRetailersPromptCenterElements
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonFontSize) {
            root.style.setProperty('--button-font-size', $rootScope.WIDGET_CONFIG.pdpConfig.buttonFontSize);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.primaryFontSize) {
            root.style.setProperty('--primary-text-font-size', $rootScope.WIDGET_CONFIG.pdpConfig.primaryFontSize);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.buttonSecondaryFontSize) {
            root.style.setProperty(
              '--button-secondary-font-size',
              $rootScope.WIDGET_CONFIG.pdpConfig.buttonSecondaryFontSize
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.primaryFontLetterSpacing) {
            root.style.setProperty(
              '--primary-font-letter-spacing',
              $rootScope.WIDGET_CONFIG.pdpConfig.primaryFontLetterSpacing
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.secondaryFontLetterSpacing) {
            root.style.setProperty(
              '--secondary-font-letter-spacing',
              $rootScope.WIDGET_CONFIG.pdpConfig.secondaryFontLetterSpacing
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.underTextOnHover) {
            root.style.setProperty('--underline-text-hover', 'underline');
          }
          if (
            $rootScope.WIDGET_CONFIG.pdpConfig.removeFieldSetBorder &&
            $rootScope.WIDGET_CONFIG.pdpConfig.removeFieldSetBorder == true
          ) {
            root.style.setProperty('--remove-field-set-border', 'none');
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressBorderEntry) {
            root.style.setProperty('--address-border-entry', $rootScope.WIDGET_CONFIG.pdpConfig.addressBorderEntry);
            root.style.setProperty(
              '--address-border-bottom-entry',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressBorderEntry
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressBottomBorderEntry) {
            root.style.setProperty(
              '--address--bottom-border-entry',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressBottomBorderEntry
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.addressBorderRadiusEntry) {
            root.style.setProperty(
              '--address-border-radius-entry',
              $rootScope.WIDGET_CONFIG.pdpConfig.addressBorderRadiusEntry
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.productTileBorderRadius) {
            root.style.setProperty(
              '--product-tile-border-radius',
              $rootScope.WIDGET_CONFIG.pdpConfig.productTileBorderRadius
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.paddingTop) {
            root.style.setProperty('--container-padding-top', $rootScope.WIDGET_CONFIG.pdpConfig.paddingTop);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.paddingBottom) {
            root.style.setProperty('--container-padding-bottom', $rootScope.WIDGET_CONFIG.pdpConfig.paddingBottom);
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.productTileFontColor) {
            root.style.setProperty(
              '--product-tile-font-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.productTileFontColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.productTileAccentColor) {
            root.style.setProperty(
              '--product-tile-accent-color',
              $rootScope.WIDGET_CONFIG.pdpConfig.productTileAccentColor
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.productTileFontFamily) {
            root.style.setProperty(
              '--product-tile-font-family',
              $rootScope.WIDGET_CONFIG.pdpConfig.productTileFontFamily
            );
          }
          if ($rootScope.WIDGET_CONFIG.pdpConfig.productTileLetterSpacing) {
            root.style.setProperty(
              '--product-tile-letter-spacing',
              $rootScope.WIDGET_CONFIG.pdpConfig.productTileLetterSpacing
            );
          }

          if ($rootScope.WIDGET_CONFIG.pdpConfig.removeFieldSetPrompt) {
            $scope.removeFieldSetPromptFromPDP = $rootScope.WIDGET_CONFIG.pdpConfig.removeFieldSetPrompt || false;
          }
          
          if ($rootScope.WIDGET_CONFIG.pdpConfig.singleBtnMultiRetailer) {
            $scope.singleBtnMultiRetailer = $rootScope.WIDGET_CONFIG.pdpConfig.singleBtnMultiRetailer || false;
          }
          
          if ($rootScope.WIDGET_CONFIG.pdpConfig.disableRetailerBtnActionForBundlePDP) {
            $scope.disableRetailerBtnActionForBundlePDP =
              $rootScope.WIDGET_CONFIG.pdpConfig.disableRetailerBtnActionForBundlePDP || false;
          }
          
          if ($rootScope.WIDGET_CONFIG.pdpConfig.retailerBorderColorPDP) {
            $scope.retailerBorderColorPDP = $rootScope.WIDGET_CONFIG.pdpConfig.retailerBorderColorPDP || false;
          }

          if($rootScope.WIDGET_CONFIG.pdpConfig.showPdpShortNameAsDropdown) {
            $scope.showPdpShortNameAsDropdown = $rootScope.WIDGET_CONFIG.pdpConfig.showPdpShortNameAsDropdown || false;
          }

          if (typeof $rootScope.WIDGET_CONFIG?.pdpConfig?.outOfStockMessageStyle === 'object') {
            const {
              fontColor: outOfStockTextFontColor,
              fontFamily: outOfStockTextFontFamily,
              fontSize: outOfStockFontSize,
              fontWeight: outOfStockTextFontWeight,
              fontLetterSpacing: outOfStockFontLetterSpacing,
            } = $rootScope.WIDGET_CONFIG.pdpConfig.outOfStockMessageStyle;
            if (outOfStockTextFontColor) {
              root.style.setProperty('--out-of-stock-message-fontColor', outOfStockTextFontColor);
            }
            if (outOfStockTextFontFamily) {
              root.style.setProperty('--out-of-stock-message-fontFamily', outOfStockTextFontFamily);
            }
            if (outOfStockFontSize) {
              root.style.setProperty('--out-of-stock-message-fontSize', outOfStockFontSize);
            }
            if (outOfStockTextFontWeight) {
              root.style.setProperty('--out-of-stock-message-fontWeight', outOfStockTextFontWeight);
            }
            if (outOfStockFontLetterSpacing) {
              root.style.setProperty('--out-of-stock-message-fontLetterSpacing', outOfStockFontLetterSpacing);
            }
          }
          root.style.setProperty('--height', '100%');
          root.style.height = '100%';
          $scope.height = '100%';
        }
        //END of PDP Specific Configs
        //START of General Text Configs
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig) {
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColor) {
            root.style.setProperty('--text-color', $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColor);
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorRetailerName) {
            root.style.setProperty(
              '--text-color-retailer-name',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorRetailerName
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightRetailerName) {
            root.style.setProperty(
              '--text-weight-retailer-name',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightRetailerName
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeRetailerName) {
            root.style.setProperty(
              '--text-size-retailer-name',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeRetailerName
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductLine) {
            root.style.setProperty(
              '--text-color-product-line',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductLine
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductTitle) {
            root.style.setProperty(
              '--text-color-product-title',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductTitle
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductFilter) {
            root.style.setProperty(
              '--text-color-product-filter-border-override',
              '1px solid ' + $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductFilter
            );
            root.style.setProperty(
              '--text-color-product-filter',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductFilter
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorActiveTabFilter) {
            root.style.setProperty(
              '--text-color-active-tab-filter',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorActiveTabFilter
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorMinorText) {
            root.style.setProperty(
              '--text-color-minor-text',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorMinorText
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeProductLine) {
            root.style.setProperty(
              '--text-size-product-line',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeProductLine
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeProductTitle) {
            root.style.setProperty(
              '--text-size-product-title',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeProductTitle
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textAlignmentProductTitle) {
            // Map alignment values: top -> flex-start, middle -> center, bottom -> flex-end
            let alignValue = $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textAlignmentProductTitle.toLowerCase() || 'top';
            if (alignValue === 'top') {
              alignValue = 'flex-start';
            } else if (alignValue === 'middle') {
              alignValue = 'center';
            } else if (alignValue === 'bottom') {
              alignValue = 'flex-end';
            }
            root.style.setProperty(
              '--text-alignment-product-title',
              alignValue
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeFilterButton) {
            root.style.setProperty(
              '--text-size-filter-button',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeFilterButton
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeBuyOnlineCTA) {
            root.style.setProperty(
              '--text-size-buy-online-cta',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeBuyOnlineCTA
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorBuyOnlineCTA) {
            root.style.setProperty(
              '--text-color-buy-online-cta',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorBuyOnlineCTA
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeTab) {
            root.style.setProperty(
              '--text-size-tabs',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textSizeTab
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightProductLine) {
            root.style.setProperty(
              '--text-weight-product-line',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightProductLine
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightProductCategory) {
            root.style.setProperty(
              '--text-weight-product-category',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textWeightProductCategory
            );
          }
          if ($rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductsFound) {
            root.style.setProperty(
              '--text-color-products-found',
              $rootScope.WIDGET_CONFIG.customStylesConfig.textConfig.textColorProductsFound
            );
          }
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.restingPanelOpacity) {
          root.style.setProperty(
            '--resting-panel-opacity',
            $rootScope.WIDGET_CONFIG.customStylesConfig.restingPanelOpacity
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorBuyOnlineCTA) {
          root.style.setProperty(
            '--button-color-buy-online-cta',
            $rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorBuyOnlineCTA
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorSearchBackground) {
          root.style.setProperty(
            '--button-color-search-background',
            $rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorSearchBackground
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorTabAndFilter) {
          root.style.setProperty(
            '--button-color-tab-and-filter',
            $rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorTabAndFilter
          );
          root.style.setProperty('--border-bottom-nav-tabs-override', '0px');
          root.style.setProperty(
            '--button-color-border-tab-and-filter-override',
            '1px solid ' + $rootScope.WIDGET_CONFIG.customStylesConfig.buttonColorTabAndFilter
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorNonActiveTabAndFilter) {
          root.style.setProperty(
            '--background-color-noactive-tab-and-filter',
            $rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorNonActiveTabAndFilter
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorInStoreSelectedStore) {
          root.style.setProperty(
            '--background-color-in-store-selected-store',
            $rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorInStoreSelectedStore
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorBuyOnlineLineBreak) {
          root.style.setProperty(
            '--background-color-buy-online-line-break',
            $rootScope.WIDGET_CONFIG.customStylesConfig.backgroundColorBuyOnlineLineBreak
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.buttonBorderRadius) {
          root.style.setProperty(
            '--button-border-radius',
            $rootScope.WIDGET_CONFIG.customStylesConfig.buttonBorderRadius
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.floatingMenuBorderRadius) {
          root.style.setProperty(
            '--floating-menu-border-radius',
            $rootScope.WIDGET_CONFIG.customStylesConfig.floatingMenuBorderRadius
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.floatingMenuBorderShadowColor) {
          root.style.setProperty(
            '--floating-menu-border-shadow-color',
            '1px solid ' + $rootScope.WIDGET_CONFIG.customStylesConfig.floatingMenuBorderShadowColor
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.searchIconBW) {
          root.style.setProperty(
            '--search-icon-bw',
            $rootScope.WIDGET_CONFIG.customStylesConfig.searchIconBW == true ? 1 : 0
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.searchBoxBorderColor) {
          root.style.setProperty(
            '--search-box-border-color',
            $rootScope.WIDGET_CONFIG.customStylesConfig.searchBoxBorderColor
          );
          root.style.setProperty(
            '--search-box-border-color-border-override',
            '1px solid ' + $rootScope.WIDGET_CONFIG.customStylesConfig.searchBoxBorderColor
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.pinColorBackgroundColor) {
          root.style.setProperty(
            '--background-color-pin',
            $rootScope.WIDGET_CONFIG.customStylesConfig.pinColorBackgroundColor
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.pinColorBackgroundImageColor) {
          root.style.setProperty(
            '--background-image-color-pin',
            $rootScope.WIDGET_CONFIG.customStylesConfig.pinColorBackgroundImageColor
          );
        }
        if ($rootScope.WIDGET_CONFIG.customStylesConfig.colorMixBorder) {
          root.style.setProperty(
            '--color-mix-pallet-for-border',
            $rootScope.WIDGET_CONFIG.customStylesConfig.colorMixBorder
          );
        }
        $scope.customPLZoom = $rootScope.WIDGET_CONFIG.customStylesConfig.zoomInBuyNowProductImg || false;
      } else {
        $scope.customPLZoom = false;
      }

      $scope.hideOutOfStockItems = $rootScope.WIDGET_CONFIG.hideOutOfStockItems || false;
      $scope.hideProduct = (logicalUPC) => {
        if (
          $scope.hideOutOfStockItems &&
          $scope.pickerListDisplay(logicalUPC, true).length == 0 &&
          $scope.searchTimeExpired.value
        ) {
          return false;
        }
        return true;
      };

      const setShortName = (pickerList) => {
        const prefix = ($scope.vendor && $scope.vendor.name) || $rootScope.WIDGET_CONFIG.vendorName;

        for (let i = 0; i < $scope.pickerList.length; i++) {
          const retailer = $scope.pickerList[i];
          if (retailer && retailer.upcs) {
            for (let k = 0; k < retailer.upcs.length; k++) {
              const upc = retailer.upcs[k];
              if (upc) {
                if (prefix && upc.name && upc.name.indexOf(prefix) == 0) {
                  upc.shortName = upc.name.substring(prefix.length);
                } else {
                  upc.shortName = upc.name;
                }
                if ($scope.showProductLine && upc && upc.productLine && upc.name.indexOf(upc.productLine) == 0) {
                  upc.shortName = upc.name.substring(upc.productLine.length);
                  upc.name = upc.name.substring(upc.productLine.length);
                }
              }
            }
          }
        }

        if ($scope.pearLogicalUPCs) {
          for (let i = 0; i < $scope.pearLogicalUPCs.length; i++) {
            const upc = $scope.pearLogicalUPCs[i];
            if (prefix && upc && upc.name && upc.name.indexOf(prefix) == 0) {
              upc.shortName = upc.name.substring(prefix.length);
            } else {
              upc.shortName = upc.name;
            }
            if ($scope.showProductLine && upc && upc.productLine && upc.name.indexOf(upc.productLine) == 0) {
              upc.shortName = upc.name.substring(upc.productLine.length);
              upc.name = upc.name.substring(upc.productLine.length);
            }
          }
        }
      };

      if ($rootScope.WIDGET_CONFIG.stylesheetPath) {
        let vendorOverride = document.querySelector('link.vendor-override');
        if (!vendorOverride) {
          const productLocatorStylesArray = document.querySelectorAll('link[href*="/css/product-locator"]');
          const productLocatorStyles = productLocatorStylesArray[productLocatorStylesArray.length - 1];
          if (productLocatorStyles) {
            vendorOverride = document.createElement('link');
            vendorOverride.rel = 'stylesheet';
            vendorOverride.href = $rootScope.WIDGET_CONFIG.stylesheetPath;
            vendorOverride.className = 'vendor-override';
            productLocatorStyles.parentNode.insertBefore(vendorOverride, productLocatorStyles.nextSibling);
          }
        }
      }

      $scope.hierarchy = $rootScope.WIDGET_CONFIG.hierarchyType || 'IN_STORE_VS_ONLINE';

      setShortName($scope.pickerList);
    }

    const PIN_SCALE_ZOOM_MAX = 14;
    const PIN_SCALE_ZOOM_MIN = 7;
    const PIN_SCALE_PIN_COUNT_MIN = 35;
    const PIN_SCALE_PIN_COUNT_MAX = 150;
    const PIN_SCALE_PIN_COUNT_ZOOM_CONTRIBUTION = 8;

    const updatePinScale = (countVisible, zoom) => {
      if (!(AppConfig['client-store-locator'] || {})['progressive-pin-icons-enabled']) {
        return;
      }
      const pinCountBounded = Math.min(Math.max(countVisible, PIN_SCALE_PIN_COUNT_MIN), PIN_SCALE_PIN_COUNT_MAX);
      const pinCountScale =
        (pinCountBounded - PIN_SCALE_PIN_COUNT_MIN) / (PIN_SCALE_PIN_COUNT_MAX - PIN_SCALE_PIN_COUNT_MIN);
      const pinCountZoomContribution =
        PIN_SCALE_PIN_COUNT_ZOOM_CONTRIBUTION * pinCountScale - PIN_SCALE_PIN_COUNT_ZOOM_CONTRIBUTION / 2;

      const zoomBounded = Math.min(Math.max(zoom - pinCountZoomContribution, PIN_SCALE_ZOOM_MIN), PIN_SCALE_ZOOM_MAX);
      const zoomScale = 1 - (zoomBounded - PIN_SCALE_ZOOM_MIN) / (PIN_SCALE_ZOOM_MAX - PIN_SCALE_ZOOM_MIN);

      let pinScale = 1 - 0.55 * zoomScale;
      let pinTransform = 1 - zoomScale;

      let root = document.getElementsByClassName('where-to-buy')[0];
      if (root) {
        root.style.setProperty('--pin-scale', pinScale);
        root.style.setProperty('--pin-transform', pinTransform);
      }
    };


    if ($stateParams.config || $stateParams.zip) {
      try {
        injectWidgetConfig(JSON.parse($stateParams.config || '{}'));
      } catch (err) {
        console.error(err);
      }

      if (
        ($rootScope.WIDGET_CONFIG.defaultToCategory ||
          !($rootScope.WIDGET_CONFIG.upcIds && $rootScope.WIDGET_CONFIG.upcIds.length)) &&
        $rootScope.WIDGET_CONFIG.preSelectCategory
      ) {
        $scope.selectCategory($rootScope.WIDGET_CONFIG.preSelectCategory);
      } else if ($rootScope.WIDGET_CONFIG.upcIds && $rootScope.WIDGET_CONFIG.upcIds.length) {
        $scope.selectedUPCs = [...$rootScope.WIDGET_CONFIG.upcIds];
        $scope.findOnline = true;
      }
    }

    let ADD_PINS_ONE_BY_ONE = false;

    const markersToAdd = [];

    if (ADD_PINS_ONE_BY_ONE) {
      const addMarkersWithTimeout = () => {
        const store = markersToAdd.pop();
        let marker = store && store.marker;
        if (marker && $scope.map) {
          if (!store.addedMarker) {
            store.addedMarker = marker.addTo($scope.map);
          }
        }
        $timeout(addMarkersWithTimeout, Math.max(1, 20 / (markersToAdd.length + 1)));
      };
      addMarkersWithTimeout();
    }

    $scope.shownStores = [];
    let firstMarker = true;
    let setInitial = false;
    const showPinsByUPC = function (fromStoreUpdate) {
      const storesLogosLast = [...$scope.stores].sort((a, b) => {
        if (!a) {
          return 1;
        }
        if (!b) {
          return -1;
        }
        return +a.logoUrl - +b.logoUrl;
      });

      const bounds = maplibregl.LngLatBounds.convert($scope.map.getBounds());
      // we want to remove stores slower than we add them, so the interface isn't so jumpy
      const lat1 = bounds.getSouthWest().lat;
      const lng1 = bounds.getSouthWest().lng;
      const lat2 = bounds.getNorthEast().lat;
      const lng2 = bounds.getNorthEast().lng;

      let countVisible = 0;
      for (let i = 0; i < storesLogosLast.length; i++) {
        const store = storesLogosLast[i];
        if (!store || !store.marker) {
          continue;
        }

        let shown = true;
        if (store.distanceMiles > 50) {
          shown = false;
        } else {
          if($scope.enableRetailerFilter == true && $scope.filterSelectedRetailerIds.length > 0 && store.synthetic){
            shown = false;
          } else if (
            $scope.enableRetailerFilter &&
            $scope.filterSelectedRetailerIds.length > 0 &&
            store.retailerId &&
            $scope.filterSelectedRetailerIds.indexOf(store.retailerId) == -1
          ) {
            shown = false;
          } else if ($scope.storeCategories && store.category && !$scope.storeCategories[store.category]) {
            shown = false;
          } else if (
            Object.entries($scope.storeCategories).length &&
            !$scope.storeCategories['Retailer'] &&
            store.category == null
          ) {
            shown = false;
          } else if (
            store.synthetic &&
            store.availableUPCIds != null &&
            store.availableUPCIds.length == 0 &&
            !store.noUPCLevelData && !$scope.hideSyntheticStoresOnProductFilter
          ) {
            shown = false;
          } else if (store.synthetic && store.noUPCLevelData && !$scope.hideSyntheticStoresOnProductFilter) {
            shown = true;
          } else if (
            !$scope.selectedUPCs ||
            !$scope.selectedUPCs.length ||
            store.availableUPCIds == null ||
            (!store.availableUPCIds.length && store.noUPCLevelData)
          ) {
            shown = true;
          } else {
            if(store.synthetic && store.noUPCLevelData && $scope.hideSyntheticStoresOnProductFilter) {
              shown = false;
            }else{
              shown = false;
              for (let j = 0; j < $scope.selectedUPCs.length; j++) {
                const selectedUPCId = $scope.selectedUPCs[j];

                for (let k = 0; k < store.availableUPCIds.length; k++) {
                  const storesUPCId = store.availableUPCIds[k];
                  if (selectedUPCId == $scope.upcIdsToLogicalUPC[storesUPCId].id) {
                    shown = true;
                    break;
                  }
                }
                if (shown) {
                  break;
                }
              }
            }
          
          }
          
        }

        if ($scope.filterMapExcludeCategories.length > 0) {
          $scope.filterMapExcludeCategories.filter((cat) => {
            if (cat == 'Retailer' && store.category == null) {
              shown = false;
            } else if (store.category == cat) {
              shown = false;
            }
          });
        }
        const alreadyShown = !!store.addedMarker;
        store.shown = shown;

        if (store.shown) {
          markersToAdd.push(store);
        } else {
          if (store.flyout && openFlyout && store.flyout == openFlyout) {
            openFlyout.remove();
            openFlyout = null;
          }
          if ($scope.selectedStore == store) {
            $scope.selectedStore = null;
          }

          if (store.addedMarker) {
            store.addedMarker.remove();
            store.addedMarker = null;
            for (let j = 0; j < markers.length; j++) {
              let marker = markers[j];
              if (marker.storeId == store.id) {
                marker.remove();
              }
            }
          }
        }
        if (shown) {
          store.visible = bounds.contains(store.marker.getLngLat());
          countVisible += +store.visible;
        }

        if (store && store.marker && (el = store.marker.getElement())) {
          if (shown && $scope.selectedStore == store) {
            el.classList.add('selected-store');
          } else {
            el.classList.remove('selected-store');
          }
        }
      }

      $scope.countVisible = countVisible;
      updatePinScale($scope.countVisible, $scope.map.getZoom());

      $scope.shownStores = $scope.stores.filter((s) => s.shown);
      $scope.shownStoresCurrentPage = 0;
      $scope.shownStoresPageSize = 5;
      $scope.shownStoresQ = '';

      $scope.numberOfPages = function () {
        return Math.ceil($scope.shownStores.length / $scope.shownStoresPageSize);
      };

      $scope.setFocusOnFirstStore = async function () {
        await Util.timeout(50);
        document.querySelector('.store-list-nav ul > li').focus();
      };

      $scope.incrementPage = function (currentPage) {
        $scope.shownStoresCurrentPage = currentPage + 1;
        $scope.selectedStore = null;
        $scope.setFocusOnFirstStore();
      };

      $scope.decrementPage = function (currentPage) {
        $scope.shownStoresCurrentPage = currentPage - 1;
        $scope.selectedStore = null;
        $scope.setFocusOnFirstStore();
      };

      $scope.shownRetailers = [...new Map($scope.shownStores.map((store) => [store['retailerId'], store])).values()];
      $scope.shownRetailers = $scope.shownRetailers
        .filter(retailer => !retailer.synthetic)
        .map(retailer => {
          return {
            ...retailer,
            logoUrl: Util.patchImageUrl(retailer.logoUrl)
          };
        })

      if ((fromStoreUpdate && $scope.storesDoneLoading) || $scope.firstFullStoresFetchComplete) {
        $scope.noStores = $scope.shownStores.length == 0;
      }

      if (!ADD_PINS_ONE_BY_ONE) {
        markersToAdd.forEach((store) => {
          let marker = store && store.marker;
          if (marker && $scope.map) {
            if (!store.addedMarker) {
              store.addedMarker = marker.addTo($scope.map);
            }
          }
        });
        markersToAdd.splice(0, markersToAdd.length);
      }
    };
    $scope.showRetailerLogo = (retailer) => {
      const isBlackAndWhiteLogo = ($rootScope.WIDGET_CONFIG && $rootScope.WIDGET_CONFIG.theme) || 'light';
      // let img = isBlackAndWhiteLogo == 'dark' ? store.bwLogoUrl : store.logoUrl;
      let img;
      if (
        retailer.style &&
        retailer.style.logo &&
        (typeof isBlackAndWhiteLogo == 'undefined' || isBlackAndWhiteLogo == 'light')
      ) {
        img = retailer.style.logo;
      }
      if (retailer.style && retailer.style.whiteOnBlackLogo && isBlackAndWhiteLogo == 'dark') {
        img = retailer.style.whiteOnBlackLogo;
      }
      if (!img) {
        img = '../img/defaultStore_opac-trans.png';
      }

      if (
        window.resizeImages &&
        img &&
        (img.indexOf('assets.pearcommerce.com') != -1 || img.indexOf('demos.pearcommerce.com') != -1 || img.indexOf('assets-cf.pearcommerce.com') != -1 || img.indexOf('demos-cf-1.pearcommerce.com') != -1)
      ) {
        img =
          img
            .replace('s3.amazonaws.com/', '')
            .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
            .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
            .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
            .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com') + '?width=64&format=webp';
      }
      return img;
    };

    $scope.showLogo = (store) => {
      let img = null;
      if (store) {
        const theme = $rootScope.WIDGET_CONFIG.theme || 'light';
        if ((theme == 'light' && store.logoUrl) || store.storeId == '1904492982680032') {
          img = store.logoUrl;
        }
        if (theme == 'dark' && store.bwLogoUrl && store.storeId != '1904492982680032') {
          img = store.bwLogoUrl;
        }
        if ($scope.bwLogoImage) {
          img = store.bwLogoUrl;
        }

        if (!img) {
          if (store && store.category) {
            const overrideKey = {
              Retailer: '3rdParty-retailer',
              Restaurant: '3rdParty-restaurant',
              Bar: '3rdParty-bar',
            }[store.category];

            if (typeof overrideKey != 'undefined' && overrideKey) {
              const overrideImg = ($rootScope.WIDGET_CONFIG.logoMap || {})[overrideKey];
              if (typeof overrideImg != 'undefined' && overrideImg) {
                img = overrideImg;
              }
            }
          }
        }
        if (
          window.resizeImages &&
          img &&
          (img.indexOf('assets.pearcommerce.com') != -1 || img.indexOf('demos.pearcommerce.com') != -1 || img.indexOf('assets-cf.pearcommerce.com') != -1 || img.indexOf('demos-cf-1.pearcommerce.com') != -1)
        ) {
          img =
            img
              .replace('s3.amazonaws.com/', '')
              .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
              .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com') + '?width=64&format=webp';
        }
      }

      if (!img) {
        if ($rootScope.WIDGET_CONFIG.defaultBrandPinImg) {
          img = $rootScope.WIDGET_CONFIG.defaultBrandPinImg;
        } else {
          img = '../img/defaultStore_opac-trans.png';
        }
      }

      return img;
    };

    $scope.selectedStore = null;
    $scope.hoveredStore = null;
    let openFlyout = null;
    const buildFlyoutHtml = function (store) {
      const mobileView = $scope.isMobileLayout;
      const retailer = $scope.pickerList.filter((r) => r.id == store.retailerId)[0];
      const upcIds = store.availableUPCIds;
      const noLogo = !store.logoUrl;
      const retLogo = $scope.showLogo(store);
      const is818 = ($scope.vendor || {}).id == 2012254479241504 ? true : false;
      const showSyntheticStoreProducts = $scope.showSyntheticStoreProducts;
      const standardRetailer = `
        <div class="image-wrap">
          <img loading="lazy" class="logo lazyload" alt="store logo" cf-image cf-image-width="80" data-src="${retLogo}" />
        </div>
        `;

      let insertSvg = `
          <div class="image-wrap" style="background-color: rgb(242,193,151)">
            <svg loading="lazy" width="60" height="90" viewBox="15 10 15 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_2408)">
            <path d="M31.9643 62.1254C31.8387 62.1254 31.8591 62.2414 31.8201 62.3154C31.686 62.571 31.7029 62.8754 31.557 63.1226C31.4927 63.2228 31.4577 63.3388 31.4559 63.4575C31.4541 63.5762 31.4856 63.6932 31.5468 63.7953C31.7488 64.1316 31.6673 64.3754 31.428 64.6209C31.376 64.6609 31.34 64.7178 31.3264 64.7815C31.3127 64.8452 31.3222 64.9116 31.3533 64.9691C31.3959 65.0485 31.4109 65.1398 31.3959 65.2286C31.3808 65.3174 31.3366 65.3988 31.2701 65.4601C31.0817 65.6888 30.9951 65.9343 31.1632 66.2219C31.2549 66.4085 31.276 66.6215 31.2226 66.8222C31.2005 67.1939 31.3261 67.6025 31.3244 68.0196C31.3244 68.1289 31.3363 68.2584 31.4704 68.2802C31.6045 68.3021 31.6741 68.1777 31.7012 68.0599C31.7607 67.8077 31.8184 67.5554 31.8591 67.3032C31.9813 66.5212 32.1731 65.7493 32.0866 64.9489C32.0594 64.6899 31.9813 64.4091 32.0509 64.1551C32.1596 63.7583 32.1358 63.3479 32.2207 62.9494C32.2715 62.7353 32.2598 62.5113 32.1867 62.3036C32.174 62.2542 32.1454 62.2101 32.1054 62.178C32.0653 62.1458 32.0158 62.1274 31.9643 62.1254V62.1254Z" fill="#0E1111"/>
            <path d="M31.9585 61.2114C32.017 61.1586 32.0541 61.0864 32.0629 61.0084C32.0716 60.9304 32.0514 60.8519 32.006 60.7876C31.9856 60.754 31.9398 60.7187 31.9093 60.7574C31.8735 60.8163 31.8546 60.8837 31.8546 60.9524C31.8546 61.0212 31.8735 61.0886 31.9093 61.1475C31.9126 61.1643 31.9262 61.1761 31.9585 61.2114Z" fill="#0E1111"/>
            <path d="M33.2113 40.4436C33.1518 40.4302 33.0772 40.4336 33.0806 40.5143C33.0847 40.5575 33.1039 40.5979 33.1349 40.6286C33.1659 40.6593 33.2067 40.6783 33.2503 40.6824C33.3369 40.6707 33.42 40.6353 33.42 40.5479C33.4166 40.4302 33.2927 40.4605 33.2113 40.4436Z" fill="#0E1111"/>
            <path d="M20.6634 52.1162C20.7143 52.1111 20.7614 52.0875 20.7957 52.0499C20.8299 52.0122 20.8487 51.9633 20.8484 51.9127C20.8688 51.7159 20.8705 51.5175 20.8807 51.2804C20.8688 51.1021 20.862 50.8852 20.8383 50.6699C20.8388 50.6191 20.8199 50.5699 20.7852 50.5325C20.7505 50.495 20.7027 50.472 20.6515 50.4681C20.6261 50.4672 20.6007 50.4714 20.5768 50.4803C20.553 50.4893 20.5312 50.5028 20.5127 50.5202C20.4942 50.5376 20.4794 50.5584 20.4692 50.5815C20.4589 50.6046 20.4534 50.6296 20.4529 50.6548C20.3912 51.0763 20.3975 51.5049 20.4716 51.9244C20.492 52.0237 20.5395 52.1313 20.6634 52.1162Z" fill="#0E1111"/>
            <path d="M32.4915 27.5938C31.8295 27.0086 31.12 26.5327 30.1983 26.3713C28.8879 26.1443 28.1206 25.1454 28.0188 23.8488C27.9492 22.9659 27.9746 22.0831 27.9322 21.2002C27.8643 19.7641 27.8524 18.3246 27.7947 16.8868C27.7557 15.8778 27.7506 14.8822 27.7285 13.88C27.7285 13.7808 27.7014 13.6832 27.698 13.584C27.6776 12.9937 27.5707 12.4068 27.8932 11.8384C28.0249 11.5898 28.0909 11.3121 28.085 11.0313C28.0935 10.2375 28.1359 9.44209 27.9916 8.6534C27.9633 8.56788 27.9529 8.47753 27.9611 8.38788C27.9692 8.29824 27.9958 8.2112 28.0391 8.13209C28.4652 7.5536 28.3786 6.89271 28.3786 6.23687C28.3786 5.50703 28.0171 5.07316 27.3602 4.83437C26.5573 4.54681 25.7493 4.2912 24.8802 4.30633C24.4593 4.31474 24.0315 4.30633 23.6156 4.30633C23.1064 4.30633 22.5972 4.28615 22.0879 4.30633C21.2945 4.33943 20.5088 4.47453 19.7506 4.70825C19.5345 4.76528 19.3416 4.88727 19.1984 5.05743C19.0552 5.22759 18.9688 5.43755 18.9511 5.65838C18.9002 6.13092 18.8764 6.60851 18.8713 7.08442C18.8595 7.24469 18.8944 7.40495 18.9717 7.54622C19.049 7.68749 19.1656 7.80385 19.3076 7.88152C19.3439 7.89917 19.3762 7.92385 19.4028 7.95412C19.4293 7.98439 19.4494 8.01963 19.4619 8.05774C19.4744 8.09585 19.479 8.13606 19.4756 8.17598C19.4721 8.21591 19.4606 8.25473 19.4416 8.29016C19.3633 8.53683 19.3299 8.79537 19.3432 9.05363C19.3432 9.60017 19.3432 10.1467 19.3432 10.6932C19.319 11.1737 19.437 11.6506 19.6827 12.0655C19.8759 12.4073 19.9391 12.8064 19.8609 13.1905C19.7387 14.1558 19.6335 15.1227 19.5214 16.0897C19.3517 17.6586 19.1684 19.2276 19.0122 20.7983C18.8951 21.9334 18.6965 23.0618 18.6914 24.2053C18.6914 24.9587 18.34 25.4901 17.7272 25.887C17.162 26.2485 16.5051 26.3915 15.8838 26.605C15.0985 26.855 14.3702 27.2549 13.74 27.7822C12.7215 28.6936 12.2123 29.8826 11.9594 31.1858C11.5231 33.4611 11.479 35.7583 11.569 38.0655C11.6301 39.5924 11.6589 41.121 11.6963 42.6497C11.7336 44.2069 11.7732 45.7641 11.8151 47.3213C11.8592 49.059 11.8994 50.7967 11.9356 52.5344C11.9763 54.2161 12.0165 55.9028 12.0561 57.5945C12.0986 59.3501 12.1172 61.1058 12.1817 62.8631C12.2259 64.0924 12.2259 65.3234 12.2479 66.5543C12.2479 66.625 12.2564 66.6939 12.2598 66.7629C12.2938 67.8038 12.3837 68.8464 12.3481 69.8857C12.3175 70.7601 12.2955 71.6329 12.3158 72.5057C12.3362 73.3785 12.3803 74.2361 12.7028 75.0551C13.2121 76.3315 13.9929 77.2412 15.4748 77.4817C17.0568 77.7323 18.6456 77.7592 20.2276 77.8365C21.5074 77.8987 22.7924 77.8853 24.0739 77.9072C24.1843 77.9072 24.2946 77.929 24.4032 77.9341C25.033 77.9627 25.6644 78.0249 26.2942 78.0081C27.3738 77.9795 28.4516 77.8685 29.5329 77.8517C31.3542 77.8231 32.831 76.1128 32.9125 74.8247C32.9447 74.3 33.0024 73.777 33.0415 73.254C33.1184 72.2652 33.1926 71.2758 33.2638 70.2859C33.3317 69.3363 33.3974 68.3862 33.4607 67.4355C33.5354 66.3273 33.6135 65.2191 33.6848 64.1109C33.734 63.3592 33.7731 62.6058 33.8189 61.8541C33.8936 60.6265 33.9717 59.3989 34.0464 58.1713C34.0922 57.4095 34.1346 56.646 34.1805 55.8843C34.2551 54.6365 34.3349 53.3904 34.4079 52.1426C34.4554 51.3303 34.4911 50.5181 34.5403 49.7059C34.6133 48.4581 34.6931 47.2103 34.7695 45.9642C34.8153 45.2007 34.8543 44.4389 34.9019 43.6755C34.9749 42.5286 35.0614 41.38 35.1276 40.2331C35.1989 38.9938 35.2329 37.7544 35.3228 36.5184C35.4264 35.0621 35.3958 33.6209 35.058 32.1948C34.6422 30.414 33.8834 28.8265 32.4915 27.5938ZM30.8942 56.9101C30.8569 57.0227 30.7449 56.9756 30.66 56.979H30.4699C30.3785 56.9662 30.2853 56.9738 30.1972 57.0011C30.1092 57.0285 30.0283 57.0749 29.9606 57.1371C29.9091 57.178 29.8451 57.2003 29.779 57.2003C29.713 57.2003 29.6489 57.178 29.5974 57.1371C29.2579 56.9504 28.9592 56.8293 28.5552 57.1102C28.2802 57.3019 27.8558 57.1842 27.4994 57.1522C27.4787 57.1516 27.4584 57.1466 27.4399 57.1374C27.4214 57.1283 27.4051 57.1153 27.3922 57.0993C27.3793 57.0833 27.37 57.0647 27.3651 57.0448C27.3601 57.0249 27.3596 57.0042 27.3636 56.9841C27.3771 56.8613 27.4654 56.752 27.574 56.7722C27.9458 56.8411 28.3022 56.72 28.6655 56.7116C29.2138 56.7015 29.7586 56.646 30.3052 56.6023C30.4648 56.5905 30.6243 56.5485 30.7669 56.6578C30.8416 56.7268 30.9316 56.7974 30.8942 56.9101ZM30.7856 55.0602C30.7702 55.103 30.7416 55.1399 30.7038 55.1656C30.666 55.1912 30.6209 55.2044 30.5751 55.2032C30.4359 55.2032 30.295 55.2032 30.1558 55.2032C30.0371 55.1854 29.9164 55.1854 29.7977 55.2032C29.4916 55.3336 29.1479 55.3479 28.8318 55.2435C28.7841 55.2267 28.7319 55.2267 28.6842 55.2435C28.0052 55.516 27.294 55.2873 26.6048 55.3697C26.5549 55.3798 26.503 55.3742 26.4565 55.3537C26.4099 55.3332 26.371 55.2988 26.3451 55.2553C26.2365 55.067 26.43 54.401 26.6218 54.3035C26.6762 54.2724 26.7364 54.2526 26.7987 54.2452C26.8611 54.2378 26.9243 54.2429 26.9845 54.2604C27.0448 54.2778 27.1009 54.3072 27.1494 54.3467C27.1979 54.3862 27.2379 54.435 27.2668 54.4902C27.3194 54.5742 27.367 54.6583 27.423 54.7441C27.4395 54.7697 27.4641 54.7892 27.4929 54.7996C27.5218 54.8099 27.5533 54.8105 27.5825 54.8013C27.6606 54.776 27.6776 54.7105 27.6793 54.6331C27.6793 54.1589 27.6793 54.1589 28.1885 54.1606C28.472 54.2497 28.8675 54.1101 29.1968 54.3287C29.2355 54.3542 29.2825 54.3641 29.3283 54.3563C29.3741 54.3485 29.4151 54.3236 29.4429 54.2867C29.5872 54.1185 29.7739 54.1185 29.9674 54.1185C30.3748 54.1 30.3935 54.1068 30.4767 54.5137C30.5106 54.6383 30.589 54.7464 30.6973 54.8181C30.7377 54.8424 30.7685 54.8797 30.7846 54.9237C30.8006 54.9678 30.801 55.016 30.7856 55.0602V55.0602ZM29.6364 39.5891C30.0421 40.1827 30.4172 40.8368 29.9759 41.607C29.8787 41.8243 29.8004 42.0493 29.7417 42.2797C29.5719 42.7506 29.7009 43.1474 30.0184 43.5191C30.2516 43.7724 30.4301 44.0703 30.5428 44.3945C30.6555 44.7187 30.7 45.0623 30.6736 45.4042C30.6362 45.8751 30.699 46.3543 30.4563 46.8017C29.8893 47.8426 29.1357 48.522 27.9441 48.5338H27.8134C26.0124 48.5926 24.612 47.0051 24.8649 45.194C24.9637 44.5839 25.2251 44.0109 25.622 43.5342C26.0039 43.0465 26.0498 42.7018 25.7205 42.1738C25.0585 41.1076 25.532 39.9002 26.2416 39.2258C27.3059 38.2185 28.9371 38.5666 29.6364 39.5907V39.5891ZM25.4421 5.05467C25.656 5.03617 25.7816 5.18752 25.7697 5.50703C25.7527 5.60625 25.7306 5.76432 25.695 5.91735C25.6783 5.96931 25.6445 6.01417 25.5989 6.04469C25.5533 6.07521 25.4986 6.08959 25.4438 6.08552C25.325 6.09561 25.2978 6.0048 25.274 5.91735C25.2248 5.76731 25.1868 5.61386 25.1603 5.45826C25.1399 5.26151 25.1875 5.07653 25.4421 5.05467ZM24.6833 6.91457C24.9973 6.79854 25.3334 6.81872 25.6593 6.77668C25.8121 6.7565 25.8987 6.90616 25.9988 7.00034C26.2025 7.19205 26.4079 7.28117 26.6557 7.06592C26.7142 7.01772 26.7865 6.98901 26.8624 6.98387C26.9383 6.97874 27.0139 6.99745 27.0784 7.03733C27.2227 7.1046 27.3771 7.14664 27.5231 7.2055C27.7064 7.2879 27.7336 7.47624 27.5588 7.57042C27.2875 7.7196 26.9933 7.82357 26.688 7.87816C26.3655 7.59228 25.9089 7.74531 25.4998 7.63096C25.2214 7.5536 24.9464 7.46279 24.6731 7.36862C24.5594 7.32826 24.444 7.26436 24.4559 7.11805C24.4677 6.97175 24.5798 6.95325 24.6833 6.91457ZM24.3523 12.0621C24.41 12.4253 24.3252 12.7734 24.2793 13.1266C24.2539 13.325 24.1367 13.3973 23.9398 13.3587C23.8267 13.3385 23.718 13.32 23.6139 13.3032C23.3882 13.2679 23.2931 13.1518 23.3746 12.9282C23.4177 12.8266 23.4266 12.714 23.4001 12.607C23.3373 12.3917 23.344 12.2336 23.6445 12.2437C23.782 12.2437 23.7939 12.1008 23.7005 12.0756C23.2066 11.9074 23.4849 11.4601 23.3423 11.1708C23.3303 11.1126 23.3303 11.0525 23.3423 10.9943C23.3423 10.5856 23.3576 10.5772 23.8821 10.589C24.0179 10.6209 24.2725 10.5015 24.3184 10.6882C24.3778 10.9253 24.5628 11.1624 24.4321 11.4281C24.3396 11.6261 24.3118 11.8477 24.3523 12.0621V12.0621ZM23.8261 46.1374C23.855 46.5713 23.8669 47.0085 23.9008 47.4424C23.9517 48.0965 23.49 48.5422 22.8314 48.5287C22.553 48.5287 22.2713 48.5489 22.0082 48.411C21.8398 48.3397 21.6992 48.2163 21.6074 48.0593C21.5157 47.9023 21.4776 47.7201 21.4989 47.5399C21.6076 46.4334 21.6296 45.3218 21.6347 44.2119C21.6347 43.2029 21.7603 42.1939 21.7841 41.1849C21.7787 40.6698 21.8116 40.1549 21.8826 39.6445C21.9606 39.1989 22.2492 38.9181 22.6226 38.9164C22.9961 38.9147 23.2829 39.1754 23.339 39.653C23.4018 40.2045 23.4323 40.7595 23.4697 41.3127C23.5477 42.4395 23.619 43.5662 23.692 44.6761C23.6038 45.1839 23.7956 45.6531 23.8261 46.1374ZM23.5426 15.94C23.4922 15.9164 23.4511 15.8767 23.4259 15.8274C23.4007 15.7781 23.3928 15.7218 23.4035 15.6676C23.4196 15.1942 23.4077 14.7203 23.3678 14.2483C23.3678 14.1625 23.3678 14.0448 23.4883 14.0532C23.6088 14.0616 23.5817 14.1692 23.5783 14.2432C23.5664 14.5005 23.6649 14.5795 23.9178 14.5089C24.2046 14.4332 24.3252 14.551 24.3167 14.8452C24.3167 14.9545 24.3048 15.0622 24.2997 15.1715H24.3099C24.3099 15.2606 24.3252 15.3497 24.3235 15.4389C24.3269 15.94 24.001 16.1435 23.5426 15.94ZM24.2776 9.54972C24.314 9.60395 24.3352 9.66676 24.3391 9.73175C24.3429 9.79674 24.3294 9.86159 24.2997 9.91968C24.2742 9.97442 24.2303 10.0187 24.1755 10.0447C24.1206 10.0708 24.0583 10.0772 23.9993 10.0626C23.8601 10.0441 23.7192 10.0307 23.5834 10.0021C23.5324 9.99781 23.4849 9.97434 23.4508 9.93649C23.4168 9.89865 23.3986 9.84931 23.4001 9.7986C23.4021 9.75247 23.4201 9.70844 23.451 9.67385C23.4819 9.63927 23.5238 9.61623 23.5698 9.60858C23.7056 9.57158 23.8448 9.5514 23.9789 9.51777C24.113 9.48414 24.1962 9.44041 24.2742 9.54972H24.2776ZM19.625 7.3518C19.5814 7.3106 19.5486 7.25954 19.5294 7.203C19.5102 7.14647 19.5051 7.08615 19.5146 7.02724C19.5693 6.65439 19.6027 6.27879 19.6148 5.90222C19.6148 5.62306 19.8032 5.45826 20.0391 5.3355C20.3668 5.16734 21.078 5.04121 21.7994 5.0513C22.306 4.98877 22.8168 4.96515 23.3271 4.98067C23.7005 4.98067 23.7548 5.04626 23.8007 5.40109C23.8533 5.90465 23.943 6.40374 24.0688 6.89439C24.1571 7.2055 24.0773 7.30135 23.7667 7.30808C23.0691 7.3249 22.3714 7.2879 21.6738 7.34171C21.4844 7.35396 21.3009 7.41168 21.1391 7.50988C20.9093 7.66728 20.6302 7.73788 20.3525 7.70888C20.0747 7.67988 19.8166 7.55319 19.625 7.3518V7.3518ZM14.8111 45.0477C14.9189 44.5222 15.1357 44.0246 15.4476 43.5863C15.5699 43.4101 15.6505 43.2088 15.6834 42.9974C15.7163 42.786 15.7007 42.57 15.6377 42.3655C15.6069 42.1898 15.5497 42.0198 15.468 41.861C15.2609 41.5246 15.2762 41.1547 15.3152 40.7931C15.4544 39.5117 16.2861 38.7886 17.5948 38.7869C18.5539 38.7869 19.3483 39.4764 19.6182 40.3929C19.827 41.1025 19.6742 41.7382 19.4722 42.3924C19.3823 42.6307 19.3617 42.8893 19.4127 43.1387C19.4637 43.3881 19.5843 43.6184 19.7608 43.8033C20.4873 44.597 20.6248 45.5286 20.3837 46.5494C20.1834 47.402 19.6352 47.9839 18.9053 48.3992C18.0056 48.9037 16.6579 48.7826 15.9212 48.0713C15.0877 47.254 14.5649 46.2635 14.8111 45.0477ZM13.1798 33.4645C13.224 33.266 13.3818 33.2055 13.5617 33.1887C13.7417 33.1719 13.8028 33.2946 13.8571 33.4325C13.9689 33.6901 13.9798 33.9797 13.8877 34.2448C13.8265 34.4129 13.7637 34.5693 13.5482 34.5374C13.3326 34.5054 13.1289 34.4466 13.1187 34.1725C13.1187 34.1119 13.1187 34.0531 13.1187 33.9942H13.1C13.1221 33.8126 13.1425 33.6326 13.1798 33.4645ZM14.0285 62.7874C13.9817 62.7924 13.9384 62.8145 13.9071 62.8493C13.8757 62.884 13.8585 62.9291 13.8588 62.9758C13.8617 63.0551 13.8404 63.1335 13.7977 63.2007C13.7551 63.2679 13.6929 63.3208 13.6195 63.3525C13.4497 63.4416 13.521 63.5307 13.6653 63.5929C13.9623 63.7207 14.0048 63.8654 13.7654 64.0974C13.7107 64.1484 13.668 64.2107 13.6404 64.2799C13.6128 64.349 13.601 64.4234 13.6059 64.4977C13.6094 64.5822 13.595 64.6666 13.5637 64.7453C13.5325 64.8241 13.485 64.8955 13.4243 64.9551C13.4057 64.9792 13.3824 64.9993 13.3558 65.0143C13.3292 65.0293 13.2999 65.0389 13.2695 65.0425C13.2392 65.0461 13.2084 65.0437 13.179 65.0353C13.1496 65.0269 13.1221 65.0128 13.0983 64.9938C13.0714 64.979 13.0482 64.9584 13.0304 64.9336C13.0126 64.9088 13.0007 64.8803 12.9955 64.8503C12.9903 64.8203 12.9919 64.7895 13.0003 64.7601C13.0087 64.7308 13.0237 64.7038 13.044 64.681C13.2138 64.4825 13.173 64.3346 12.9948 64.1765C12.898 64.089 12.9184 63.9562 12.9167 63.8401C12.8862 62.4948 12.7894 61.1495 12.7741 59.7958C12.7741 58.9634 12.7741 58.1276 12.7317 57.2952C12.6621 55.6404 12.6434 53.9823 12.6044 52.3259C12.567 50.7199 12.5229 49.1139 12.4856 47.5063C12.4465 45.7708 12.4075 44.0353 12.3566 42.2931C12.3362 41.5684 12.3379 40.8436 12.3124 40.1205C12.2904 39.4865 12.2513 38.8525 12.2462 38.2168C12.2462 37.8166 12.416 37.4248 12.2564 37.0128C12.1953 36.8446 12.5331 36.6125 12.8013 36.5991C12.8565 36.589 12.9132 36.5917 12.9672 36.607C13.0211 36.6222 13.0708 36.6497 13.1122 36.6872C13.1536 36.7246 13.1857 36.7711 13.206 36.8229C13.2263 36.8747 13.2342 36.9305 13.229 36.9859C13.2197 37.4115 13.2384 37.8373 13.2851 38.2606C13.2833 38.4604 13.3425 38.6562 13.4548 38.8222C13.5154 38.9029 13.5482 39.0008 13.5482 39.1014C13.5482 39.6765 13.6144 40.2466 13.6296 40.82C13.6602 41.9888 13.594 43.1575 13.6789 44.3246C13.7756 45.6699 13.7162 47.0253 13.8147 48.369C13.9046 49.5747 13.8147 50.7922 14.071 51.9862C14.1253 52.2418 14.0591 52.4991 14.0608 52.7564C14.0608 53.8175 14.2203 54.8719 14.2136 55.933C14.2136 56.5973 14.2933 57.2582 14.3409 57.9207C14.3409 58.8036 14.3409 59.6865 14.3409 60.5693C14.3409 61.126 14.4359 61.6775 14.4037 62.2342C14.3952 62.4931 14.3494 62.7252 14.0319 62.7841L14.0285 62.7874ZM14.5072 67.417C14.4071 67.4069 14.3375 67.3498 14.3527 67.2489C14.368 67.148 14.4257 67.1395 14.5038 67.153C14.543 67.1563 14.5795 67.1741 14.6062 67.2027C14.6329 67.2313 14.6478 67.2688 14.6481 67.3077C14.6467 67.3238 14.6419 67.3395 14.6341 67.3537C14.6263 67.368 14.6156 67.3804 14.6027 67.3904C14.5898 67.4003 14.5749 67.4075 14.5591 67.4115C14.5433 67.4155 14.5267 67.4163 14.5106 67.4137L14.5072 67.417ZM14.7415 49.9447C14.7635 49.7025 14.9265 49.6386 15.1421 49.6403H17.0092C17.5898 49.6403 18.172 49.6403 18.7525 49.6403C19.002 49.6403 19.1989 49.6756 19.2906 49.9564C19.3721 50.2036 19.518 50.0758 19.6301 49.9648C20.0341 49.5562 20.5365 49.5226 21.0559 49.6167C21.2238 49.6516 21.3822 49.7218 21.5204 49.8224C21.6586 49.9231 21.7734 50.0519 21.8571 50.2003C21.8978 50.2659 21.9352 50.355 22.0268 50.3331C22.1185 50.3113 22.1185 50.2154 22.1287 50.1381C22.1932 49.684 22.5717 49.4873 23.0063 49.679C23.176 49.753 23.1913 49.8993 23.1913 50.0523C23.1913 50.619 23.1913 51.184 23.1913 51.7508C23.1862 51.8499 23.1862 51.9493 23.1913 52.0484C23.2049 52.1863 23.1404 52.4066 23.3474 52.4032C23.5545 52.3999 23.507 52.1846 23.5087 52.0434C23.5087 51.4077 23.5087 50.772 23.5087 50.1364C23.5087 49.7294 23.6021 49.6319 24.0043 49.647C24.8412 49.6874 25.678 49.647 26.5149 49.647C26.8917 49.647 26.9664 49.7059 26.9782 50.0708C26.9969 50.6442 26.9884 51.221 27.002 51.7962C27.0156 52.3713 27.2566 52.5697 27.8507 52.4369C28.0476 52.3915 28.0935 52.2468 28.124 52.0871C28.2513 51.4228 28.3752 50.7586 28.5008 50.096C28.5755 49.6991 28.6315 49.6504 29.0321 49.647C29.2817 49.647 29.5329 49.647 29.7841 49.647C29.8701 49.6416 29.955 49.6688 30.0216 49.7232C30.0881 49.7775 30.1312 49.8549 30.1423 49.9396C30.329 50.9251 30.5134 51.9105 30.6956 52.896C30.7381 53.1331 30.6311 53.2542 30.3867 53.2558L30.0251 53.2642C29.9751 53.2718 29.9241 53.2692 29.8752 53.2566C29.8262 53.2441 29.7803 53.2218 29.7403 53.1911C29.7003 53.1604 29.667 53.122 29.6425 53.0782C29.6179 53.0344 29.6026 52.9862 29.5974 52.9363C29.5702 52.785 29.538 52.6303 29.336 52.6336C29.134 52.637 29.1034 52.7715 29.0763 52.9145C29.027 53.1802 28.859 53.2659 28.601 53.2508C27.72 53.2272 26.8374 53.2895 25.9564 53.2239C25.7391 53.2071 25.5185 53.276 25.2995 53.2777C25.0245 53.2777 24.7427 53.2777 24.7003 52.8993C24.6816 52.7312 24.5662 52.7312 24.4762 52.8506C24.0451 53.4459 23.4272 53.355 22.8314 53.2743C22.458 53.2256 22.183 52.8724 22.127 52.4789C22.1151 52.3931 22.1389 52.2771 22.0353 52.2468C21.9046 52.2098 21.8656 52.3393 21.8299 52.415C21.6874 52.6824 21.3767 52.8808 21.4786 53.2558C21.4955 53.3197 21.4158 53.3702 21.3462 53.3988C21.1879 53.4432 21.0211 53.4495 20.8599 53.417C20.6986 53.3845 20.5476 53.3143 20.4194 53.2121C20.2914 53.0721 20.1337 52.9618 19.9577 52.8892C19.8207 52.8371 19.6984 52.753 19.6012 52.6441C19.504 52.5352 19.4347 52.4047 19.3992 52.2637C19.2974 51.8954 19.1955 51.5288 19.277 51.1269C19.3992 50.5232 19.0207 50.2423 18.4283 50.4643C18.376 50.4816 18.331 50.5156 18.3003 50.5609C18.2696 50.6063 18.2549 50.6604 18.2585 50.7149C18.2519 50.7751 18.2686 50.8356 18.3051 50.8843C18.3416 50.9329 18.3953 50.9661 18.4554 50.9772C18.5522 50.9974 18.654 50.9957 18.7525 51.0108C18.8544 51.0197 18.9493 51.066 19.0184 51.1407C19.0875 51.2154 19.1259 51.3131 19.1259 51.4144C19.1395 51.6398 18.9816 51.7508 18.7746 51.7928C18.7056 51.8046 18.6358 51.8113 18.5658 51.813C18.5228 51.8082 18.4794 51.8132 18.4387 51.8276C18.398 51.8421 18.3612 51.8655 18.3311 51.8962C18.301 51.9268 18.2783 51.9639 18.2648 52.0046C18.2514 52.0452 18.2475 52.0884 18.2534 52.1308C18.2534 52.3393 18.3366 52.4755 18.5658 52.4856C18.6761 52.4856 18.7864 52.4856 18.8968 52.494C18.9472 52.488 18.9984 52.4933 19.0465 52.5095C19.0946 52.5256 19.1384 52.5523 19.1747 52.5875C19.2111 52.6226 19.239 52.6654 19.2564 52.7127C19.2738 52.76 19.2802 52.8106 19.2753 52.8606C19.2872 53.1078 19.1701 53.2525 18.9358 53.2542C18.4266 53.2542 17.9343 53.2542 17.4353 53.2272C17.1535 53.2087 17.1484 52.9565 17.145 52.748C17.145 52.1123 17.145 51.4766 17.145 50.841C17.145 50.5366 16.9396 50.4054 16.668 50.5047C16.4983 50.5686 16.4661 50.7115 16.4661 50.8662C16.4661 51.4817 16.4661 52.0972 16.4661 52.716C16.4661 52.8926 16.5085 53.1112 16.2963 53.1919C16.1754 53.2409 16.0458 53.2654 15.9152 53.264C15.7846 53.2625 15.6556 53.2352 15.5359 53.1835C15.3848 53.1196 15.4018 52.9531 15.4018 52.8152C15.4018 52.2183 15.3916 51.623 15.4018 51.0276C15.4018 50.7334 15.3339 50.5231 15.0114 50.4576C14.7194 50.3987 14.7211 50.1666 14.7415 49.9447ZM19.1276 55.4067C18.9901 55.479 18.413 55.2923 18.3672 55.146C18.2823 54.8753 18.1618 54.9661 18.0277 55.1023C17.9802 55.1511 17.9479 55.2166 17.9021 55.2705C17.8168 55.382 17.6934 55.4589 17.5549 55.4868C17.4165 55.5146 17.2726 55.4915 17.1501 55.4218C17.0481 55.3576 16.9313 55.32 16.8106 55.3125C16.7526 55.3264 16.6959 55.345 16.6409 55.368C16.3778 55.4992 16.1181 55.5698 15.8499 55.3764C15.7989 55.346 15.7394 55.3324 15.6801 55.3377C15.546 55.3377 15.3831 55.4386 15.2897 55.2957C15.1282 55.0711 14.9964 54.827 14.8976 54.5692C14.8331 54.3691 15.2371 54.1437 15.4849 54.243C15.6601 54.3163 15.8561 54.324 16.0366 54.2648C16.1285 54.2371 16.226 54.2324 16.3202 54.2512C16.4144 54.27 16.5024 54.3116 16.5764 54.3724C16.6395 54.4294 16.7208 54.4626 16.8061 54.4663C16.8914 54.4699 16.9753 54.4439 17.0432 54.3926C17.1224 54.3316 17.2213 54.3011 17.3216 54.3069C17.7408 54.4313 18.1839 54.3186 18.598 54.4565C18.9171 54.5625 18.985 54.6247 19.1225 54.9408C19.1548 55.0148 19.1989 55.0821 19.2244 55.1561C19.2422 55.2016 19.2421 55.252 19.2242 55.2975C19.2063 55.3429 19.1718 55.3801 19.1276 55.4016V55.4067ZM14.8094 55.965C14.884 55.6656 15.1064 55.7043 15.3508 55.6909C15.9993 55.6539 16.6426 55.8187 17.2893 55.7295C17.3577 55.7118 17.4296 55.7118 17.4981 55.7295C17.9326 55.9078 18.3808 55.8035 18.8238 55.7918C18.9336 55.7822 19.0441 55.8007 19.1446 55.8456C19.2851 55.8883 19.4332 55.9015 19.5791 55.8843C20.0884 55.928 20.5687 55.8086 21.061 55.7665C21.1662 55.7665 21.3241 55.7901 21.3292 55.6471C21.3343 55.5042 21.1595 55.479 21.0559 55.4958C20.6621 55.5681 20.287 55.3495 19.8932 55.4336C19.7964 55.4538 19.7234 55.3865 19.6912 55.2923C19.608 55.0771 19.72 54.5423 19.8983 54.4296C20.0082 54.3574 20.1399 54.3251 20.2712 54.3383C20.4024 54.3515 20.5249 54.4093 20.618 54.5019C20.6848 54.563 20.7723 54.597 20.8632 54.597C20.9542 54.597 21.0417 54.563 21.1085 54.5019C21.6008 54.1656 21.908 54.2194 22.2492 54.7054C22.3392 54.8332 22.4461 54.8332 22.5055 54.7054C22.6939 54.3085 22.9825 54.2968 23.3763 54.3691C23.8957 54.4666 24.4287 54.3809 24.9515 54.3069C25.0302 54.2938 25.1095 54.2848 25.1892 54.28C25.7917 54.2463 25.8223 54.28 25.7765 54.8568C25.7765 54.8769 25.7765 54.8971 25.7765 54.9173C25.7578 55.072 25.8885 55.2654 25.6831 55.3764C25.5902 55.4278 25.4861 55.4562 25.3797 55.4591C25.2733 55.462 25.1677 55.4394 25.072 55.3932C24.9605 55.3403 24.8377 55.315 24.7141 55.3194C24.5906 55.3238 24.4699 55.3578 24.3625 55.4184C23.9942 55.5866 23.5919 55.4723 23.2099 55.4487C22.8823 55.4285 22.5785 55.5362 22.2594 55.5328C22.2336 55.5322 22.2085 55.5412 22.189 55.558C22.1695 55.5748 22.1571 55.5982 22.1541 55.6236C22.1541 55.6976 22.2017 55.7295 22.2611 55.743C22.3205 55.7565 22.4206 55.7598 22.4987 55.7733C22.62 55.7857 22.7339 55.8366 22.8235 55.9185C22.9131 56.0003 22.9737 56.1086 22.9961 56.2273C23.0192 56.4236 23.0671 56.6163 23.1387 56.8008C23.1964 56.9235 23.1387 57.0244 22.9808 56.9908C22.7858 56.979 22.5902 56.979 22.3952 56.9908C22.0353 57.0614 21.6466 56.9336 21.2494 56.8916C21.1788 56.8834 21.1124 56.8543 21.0588 56.8081C21.0052 56.7618 20.9669 56.7007 20.949 56.6326C20.9167 56.5502 20.893 56.4527 20.7792 56.4527C20.7277 56.4518 20.6773 56.4678 20.6358 56.4982C20.5944 56.5286 20.5643 56.5717 20.5501 56.6208C20.4516 57.0009 20.1851 56.942 19.8711 56.9572C19.3619 56.9941 18.8526 56.9403 18.3434 56.937C17.8342 56.9336 17.291 57.0395 16.7699 56.9134C16.4745 56.853 16.1708 56.8428 15.8719 56.8832C15.611 56.898 15.3501 56.8549 15.1081 56.757C14.8178 56.6713 14.7109 56.3686 14.8094 55.965ZM15.5528 57.0715C15.7684 57.1152 16.0621 57.2397 16.3744 57.2968C16.4983 57.317 16.5238 57.465 16.5441 57.5878C16.5951 57.8972 16.6341 57.909 16.8955 57.7559C17.0694 57.6842 17.2211 57.5682 17.3351 57.4196C17.3603 57.375 17.4015 57.3413 17.4506 57.3254C17.4997 57.3095 17.553 57.3125 17.5999 57.3338C17.6929 57.3713 17.7938 57.3854 17.8936 57.3749C17.9935 57.3643 18.0891 57.3294 18.172 57.2733C18.2311 57.2437 18.2983 57.2336 18.3636 57.2445C18.429 57.2554 18.4891 57.2867 18.5352 57.3338C18.6031 57.3922 18.6876 57.4282 18.7771 57.4366C18.8666 57.4451 18.9565 57.4256 19.0343 57.3809C19.2583 57.275 19.3856 57.3658 19.423 57.6214C19.423 57.6803 19.423 57.7408 19.44 57.798C19.4569 57.8921 19.4994 57.9762 19.6097 57.9796C19.72 57.983 19.7472 57.8905 19.7659 57.7963C19.8609 57.3322 19.8643 57.349 20.326 57.3153C20.6655 57.2901 20.9778 57.2481 21.2935 57.4028C21.3606 57.4264 21.4326 57.433 21.5029 57.4218C21.5732 57.4106 21.6396 57.3821 21.6958 57.3389C21.7966 57.2721 21.9154 57.2371 22.0366 57.2386C22.1579 57.2401 22.2758 57.278 22.3748 57.3473C22.4495 57.4005 22.5398 57.428 22.6317 57.4255C22.7237 57.4231 22.8123 57.3909 22.884 57.3338C22.9648 57.2785 23.0578 57.2431 23.1552 57.2305C23.2526 57.2179 23.3516 57.2285 23.444 57.2614C23.5364 57.2943 23.6196 57.3485 23.6866 57.4196C23.7537 57.4907 23.8027 57.5766 23.8295 57.6702C23.8838 57.8787 23.9348 58.0687 24.1384 58.1864C24.1584 58.1971 24.176 58.2117 24.1902 58.2292C24.2044 58.2468 24.2149 58.267 24.221 58.2886C24.2272 58.3103 24.2289 58.3329 24.2261 58.3552C24.2233 58.3775 24.216 58.399 24.2046 58.4185C24.1844 58.4597 24.1491 58.4916 24.1059 58.5079C24.0626 58.5241 24.0148 58.5234 23.9721 58.5059C23.5477 58.3613 23.0691 58.6035 22.66 58.3378C22.6362 58.3306 22.6111 58.3287 22.5864 58.3321C22.5618 58.3356 22.5382 58.3444 22.5174 58.358C22.2305 58.5766 21.9301 58.4875 21.6279 58.405C21.5535 58.3689 21.4714 58.3511 21.3886 58.3529C20.5603 58.5396 19.7217 58.4034 18.8917 58.4084C18.3672 58.4084 17.841 58.3731 17.3148 58.4168C17.224 58.4263 17.1323 58.4091 17.0514 58.3672C16.9705 58.3253 16.9038 58.2607 16.8599 58.1814C16.7478 57.9981 16.629 57.9661 16.4949 58.1511C16.3608 58.3361 16.2114 58.3479 15.9959 58.3109C15.7289 58.2797 15.4599 58.2696 15.1913 58.2806C15.1102 58.2869 15.0299 58.2621 14.9667 58.2115C14.9035 58.1608 14.8624 58.088 14.8518 58.0082C14.8382 57.9493 14.8229 57.8921 14.8144 57.84C14.7415 57.3069 14.9197 57.095 15.5528 57.0715V57.0715ZM15.4561 58.7532C15.9161 58.7532 16.3795 58.7229 16.814 58.9112C16.8804 58.9347 16.953 58.9347 17.0194 58.9112C17.3436 58.7885 17.6746 58.9112 17.9819 58.8877C18.4233 58.8813 18.8647 58.8987 19.3042 58.9398C19.5197 58.9398 19.7421 58.9516 19.9611 58.9398C20.2659 58.9054 20.5725 58.888 20.8794 58.8877C21.3765 58.923 21.8755 58.9264 22.3731 58.8978C22.8942 58.8776 23.4238 58.8759 23.9449 58.8877C24.466 58.8995 24.9634 58.8171 25.4641 58.8978C25.6492 58.928 25.9157 59.0172 25.9734 58.7094C26.0226 58.4706 25.8562 58.3731 25.4743 58.3596C25.274 58.3596 25.0737 58.3596 24.8734 58.3479C24.8278 58.3479 24.7827 58.3388 24.7407 58.3212C24.6987 58.3036 24.6608 58.2777 24.6291 58.2452C24.5974 58.2128 24.5726 58.1743 24.5563 58.1321C24.54 58.0899 24.5324 58.0449 24.5339 57.9998C24.5263 57.871 24.5263 57.7418 24.5339 57.613C24.5628 57.3237 24.7495 57.1758 25.033 57.2598C25.3165 57.3439 25.605 57.243 25.8817 57.1808C25.953 57.164 26.0311 57.1354 26.0277 57.053C26.0243 56.9706 25.9309 56.937 25.8579 56.937C25.5277 56.9187 25.1966 56.9216 24.8666 56.9454C24.5482 56.974 24.2278 56.974 23.9093 56.9454C23.8566 56.9493 23.8036 56.942 23.7539 56.924C23.7043 56.9059 23.6591 56.8775 23.6214 56.8407C23.5838 56.8039 23.5546 56.7595 23.5357 56.7106C23.5168 56.6616 23.5088 56.6092 23.5121 56.5569C23.5121 56.488 23.4934 56.419 23.4849 56.3501C23.4306 55.9498 23.5393 55.8288 23.9551 55.8254H24.5543C24.9838 55.8826 25.4709 55.7195 25.9615 55.8405C26.1143 55.8792 26.2517 55.8859 26.323 56.0507C26.3943 56.2155 26.4758 56.1651 26.5556 56.0507C26.6082 55.9767 26.6659 55.8943 26.7712 55.9213C26.8764 55.9482 26.8849 56.0709 26.8849 56.1685C26.8848 56.2776 26.9067 56.3857 26.9494 56.4863C27.0343 56.6746 27.0003 56.8125 26.7949 56.8932C26.7219 56.9218 26.6252 56.9538 26.6456 57.0614C26.6543 57.1066 26.6799 57.1469 26.7174 57.174C26.7549 57.2012 26.8014 57.2132 26.8475 57.2077C27.1242 57.2077 27.2278 57.3456 27.2787 57.5979C27.3381 57.8888 27.4909 57.9426 27.8524 57.9022C28.3617 57.8434 28.8709 57.6887 29.3801 57.7341C29.7642 57.7622 30.15 57.7549 30.5327 57.7122C30.7347 57.6937 30.8925 57.7442 30.8722 57.9998C30.862 58.1679 31.0657 58.3277 30.9316 58.4774C30.7975 58.627 30.6447 58.4101 30.4851 58.432C30.1755 58.4865 29.8605 58.5051 29.5465 58.4874C29.0491 58.4303 28.5823 58.5413 28.102 58.5514C27.6216 58.5614 27.1412 58.59 26.6642 58.6455C26.2382 58.696 26.1126 58.9398 26.2517 59.3417C26.2819 59.4461 26.3052 59.5522 26.3213 59.6596C26.3366 59.7302 26.3638 59.8277 26.4283 59.8277C26.8 59.8731 26.7084 60.0699 26.6659 60.3322C26.6129 60.6097 26.6623 60.8967 26.8051 61.1411C26.9375 61.358 26.8289 61.4572 26.6048 61.4623C26.3146 61.4623 26.0243 61.4623 25.734 61.4623C25.6936 61.4655 25.6528 61.4605 25.6144 61.4476C25.5759 61.4347 25.5405 61.4142 25.5103 61.3873C25.4801 61.3603 25.4558 61.3276 25.4388 61.2911C25.4218 61.2545 25.4125 61.2149 25.4115 61.1747C25.3928 61.0183 25.3793 60.8603 25.3674 60.7022C25.3504 60.4701 25.4319 60.3188 25.6882 60.2885C25.8579 60.27 25.9768 60.1758 25.9479 59.9908C25.9191 59.8059 25.7782 59.8496 25.6441 59.8227C25.3046 59.7504 24.9464 59.8395 24.6018 59.7739C24.4909 59.7649 24.3798 59.7889 24.2827 59.8429C24.1643 59.9002 24.0314 59.9212 23.9008 59.9034C23.3763 59.8059 22.8552 59.9034 22.3358 59.9034C21.8775 59.9034 21.4175 59.7773 20.9524 59.9337C20.876 59.9606 20.7606 59.8916 20.6706 59.8479C20.5681 59.7942 20.4535 59.7675 20.3376 59.7701C20.2217 59.7728 20.1085 59.8047 20.0086 59.863C19.9523 59.9059 19.8844 59.931 19.8136 59.9352C19.7428 59.9394 19.6724 59.9224 19.6114 59.8866C19.5162 59.8214 19.406 59.7809 19.291 59.7688C19.1759 59.7568 19.0596 59.7736 18.9528 59.8176C18.8667 59.8445 18.7765 59.8565 18.6863 59.853C17.8376 59.8361 16.9889 59.816 16.1401 59.7924C16.0602 59.798 15.9804 59.7799 15.911 59.7403C15.8408 59.6798 15.7515 59.6455 15.6585 59.6434C15.5655 59.6412 15.4747 59.6713 15.4018 59.7285C15.3445 59.7533 15.2822 59.7642 15.2199 59.7604C15.1575 59.7566 15.097 59.7382 15.0433 59.7067C14.9896 59.6751 14.9442 59.6314 14.9109 59.579C14.8776 59.5267 14.8573 59.4673 14.8518 59.4056C14.7924 58.8894 14.9129 58.7565 15.4561 58.7565V58.7532ZM30.9027 60.8518C30.8972 60.9618 30.8498 61.0656 30.7701 61.1424C30.6904 61.2191 30.5844 61.2631 30.4733 61.2655L29.4259 61.3446C29.3767 61.3446 29.3071 61.353 29.28 61.3261C28.9524 60.9897 28.6214 61.247 28.3056 61.3261C28.0622 61.382 27.8137 61.4141 27.5639 61.4219C27.5167 61.4326 27.4677 61.4318 27.4209 61.4197C27.3741 61.4076 27.3309 61.3844 27.2951 61.3522C27.2593 61.32 27.2318 61.2798 27.2151 61.2348C27.1983 61.1898 27.1928 61.1415 27.1989 61.094C27.1989 60.7661 27.1989 60.4382 27.1989 60.1102C27.1989 59.9084 27.3059 59.826 27.5028 59.8328C27.6521 59.8328 27.8015 59.8328 28.012 59.8328C28.8963 59.7151 29.8639 59.8328 30.8026 59.5856C30.9231 59.5536 30.9995 59.6209 30.9604 59.7235C30.8195 60.1035 30.9672 60.4836 30.8942 60.8552L30.9027 60.8518ZM25.0313 61.1798C25.2112 61.3849 25.0975 61.4892 24.887 61.5161C24.6886 61.5441 24.488 61.5536 24.2878 61.5447C23.5494 61.5094 22.8128 61.5262 22.0812 61.5245C21.684 61.5245 21.4803 61.2504 21.4871 60.8518C21.4938 60.4533 21.6093 60.3474 22.0099 60.3474C22.2492 60.3474 22.4851 60.2734 22.7279 60.3171C22.9384 60.3541 23.1183 60.4129 23.159 60.6534C23.1709 60.7308 23.2066 60.8115 23.3067 60.8216C23.4069 60.8317 23.4459 60.7425 23.4612 60.6652C23.5206 60.3524 23.709 60.2868 23.9908 60.3726C24.196 60.4243 24.4121 60.4149 24.612 60.3457C24.8938 60.2683 25.0211 60.3877 24.9617 60.6702C24.9278 60.7542 24.916 60.8452 24.9273 60.9349C24.9385 61.0246 24.9726 61.11 25.0262 61.1831L25.0313 61.1798ZM21.1662 61.321C21.2952 61.4757 21.1544 61.5548 21.0067 61.5649C20.7869 61.5797 20.5665 61.5837 20.3464 61.5766C20.0408 61.5682 19.9763 61.469 19.978 61.0503C19.978 61.0015 19.978 60.9511 19.978 60.9023C19.9933 60.3423 20.3413 60.1304 20.8726 60.349C20.9458 60.3712 21.0073 60.421 21.0438 60.4877C21.0803 60.5544 21.0889 60.6326 21.0678 60.7055C21.0299 60.8082 21.0186 60.9186 21.0349 61.0267C21.0512 61.1349 21.0946 61.2372 21.1611 61.3244L21.1662 61.321ZM15.2015 61.3463C14.9418 61.2975 14.862 60.9527 14.9536 60.3844C15.0012 60.1119 15.2371 60.154 15.3491 60.1371C15.9789 60.1641 16.5238 60.2448 17.0754 60.2179C17.1416 60.2147 17.2069 60.234 17.2606 60.2725C17.3143 60.311 17.3531 60.3665 17.3708 60.4298C17.409 60.5401 17.4412 60.6524 17.4675 60.7661C17.4896 60.8468 17.4675 60.9797 17.5796 60.9797C17.6916 60.9797 17.6865 60.8384 17.6933 60.7476C17.6925 60.6426 17.7248 60.5401 17.7857 60.4542C17.8465 60.3683 17.9329 60.3033 18.0328 60.2683C18.1301 60.2232 18.2409 60.2153 18.3438 60.2464C18.4466 60.2775 18.5342 60.3452 18.5895 60.4365C18.6693 60.5576 18.7491 60.5441 18.8594 60.455C19.2159 60.1691 19.4603 60.2599 19.552 60.7039C19.578 60.9173 19.6388 61.1252 19.7319 61.3194C19.8558 61.543 19.5944 61.5413 19.4688 61.5195C19.1017 61.4674 18.7296 61.4589 18.3604 61.4942C18.1323 61.5353 17.897 61.4998 17.6916 61.3933C17.64 61.3644 17.5791 61.3566 17.5219 61.3715C16.7427 61.6103 15.9687 61.4909 15.1964 61.3496L15.2015 61.3463ZM25.2927 69.9008C24.8191 69.8403 24.3642 70.1228 23.9059 69.963C23.2795 69.7461 22.6362 70.106 22.0133 69.879C21.8537 69.8218 21.684 69.8066 21.5906 69.6334C21.5581 69.5881 21.5137 69.5524 21.4623 69.5302C21.4109 69.508 21.3543 69.5001 21.2986 69.5073C20.9592 69.5073 20.6197 69.4367 20.2581 69.5073C19.9407 69.5678 19.5927 69.4249 19.2397 69.4417C19.0299 69.4414 18.8202 69.4301 18.6116 69.4081C18.5912 69.4081 18.5675 69.4081 18.5522 69.4081C18.0209 69.1373 17.364 69.2282 16.8683 68.8716C16.7529 68.7892 16.6663 68.7035 16.7173 68.5505C16.7682 68.3974 16.9074 68.3941 17.0856 68.3941C17.1416 68.4075 17.2723 68.3941 17.33 68.4613C17.5456 68.6867 17.8664 68.6177 18.1126 68.7556C18.2823 68.8498 18.4758 68.7691 18.6405 68.7287C19.3958 68.5488 20.1563 68.5891 20.9184 68.6261C20.9971 68.6387 21.0774 68.6387 21.1561 68.6261C21.8978 68.3941 22.6651 68.4311 23.417 68.458C24.0043 68.4798 24.6188 68.4882 25.1671 68.7943C25.308 68.8716 25.42 68.9524 25.4098 69.1306C25.4181 69.2294 25.46 69.3225 25.5286 69.3946C25.7103 69.6385 25.5864 69.9395 25.2927 69.9008ZM26.1771 69.2736C26.1058 69.2736 26.0226 69.2618 26.0311 69.1693C26.0396 69.0768 26.1295 69.0533 26.211 69.0549C26.2925 69.0566 26.3519 69.0751 26.3655 69.1659C26.3383 69.2635 26.2534 69.2702 26.1754 69.2736H26.1771ZM31.6088 72.7277C31.6088 72.8471 31.5953 72.9984 31.4391 73.0001C31.2829 73.0018 31.2252 72.8319 31.2456 72.7159C31.3067 72.3426 31.2456 71.9659 31.2948 71.5926C31.3067 71.4883 31.3237 71.3487 31.4646 71.3454C31.6055 71.342 31.6343 71.4866 31.6615 71.6026C31.6704 71.6707 31.675 71.7392 31.675 71.8078C31.6266 72.112 31.6061 72.4199 31.6139 72.7277H31.6088ZM34.2891 42.0274C34.2681 42.215 34.259 42.4038 34.2619 42.5925C34.2772 42.7004 34.2702 42.8102 34.2416 42.9154C34.1755 43.028 34.136 43.1539 34.126 43.2838C34.116 43.4137 34.1358 43.5441 34.1839 43.6654C34.2348 43.8083 34.2042 44.0017 33.9394 43.9361C33.9255 43.93 33.9104 43.927 33.8952 43.9273C33.8799 43.9275 33.8649 43.931 33.8512 43.9376C33.8375 43.9442 33.8254 43.9536 33.8157 43.9652C33.806 43.9769 33.799 43.9905 33.7951 44.0051C33.7839 44.0442 33.7873 44.086 33.8048 44.1228C33.8223 44.1596 33.8526 44.1889 33.8902 44.2052C34.155 44.3111 34.1533 44.5314 34.1397 44.7534C34.0888 45.6346 34.0277 46.5158 33.97 47.397C33.9207 48.2092 33.8817 49.0214 33.8342 49.8337C33.7612 51.0899 33.6814 52.3562 33.6067 53.6039C33.5609 54.3674 33.5202 55.1292 33.4743 55.8927C33.3974 57.1382 33.321 58.3854 33.2452 59.6343C33.1993 60.4062 33.1603 61.1798 33.1111 61.9517C33.0398 63.08 32.9617 64.2084 32.887 65.3351C32.8412 66.0179 32.7665 66.7023 32.7648 67.3851C32.7478 67.7903 32.6688 68.1906 32.5306 68.5723C32.5076 68.661 32.466 68.744 32.4086 68.8158C32.3511 68.8875 32.2791 68.9465 32.1971 68.9889C32.1151 69.0312 32.0251 69.056 31.9328 69.0616C31.8405 69.0672 31.748 69.0535 31.6615 69.0213C31.5729 68.9968 31.4798 68.9934 31.3897 69.0114C31.2995 69.0294 31.215 69.0683 31.143 69.1249C31.071 69.1815 31.0135 69.2542 30.9753 69.337C30.937 69.4199 30.9192 69.5105 30.9231 69.6015C30.9231 69.7041 30.9231 69.8151 30.8195 69.8638C30.716 69.9126 30.6634 69.81 30.5955 69.7562C30.5051 69.6949 30.421 69.6251 30.3443 69.5477C30.1134 69.2769 30.0981 69.2618 29.9131 69.5477C29.5278 70.1312 28.9609 70.0774 28.3854 70.0118C28.2972 70.0017 28.2157 69.9714 28.1206 69.9546C27.6114 69.8487 27.4247 69.509 27.6538 69.0499C27.7489 68.8616 27.9271 68.8397 28.1206 68.8817C28.5908 68.9776 29.0593 69.0734 29.5312 69.1592C30.0829 69.2584 30.5038 68.8969 30.4529 68.3402C30.3884 67.6306 30.5479 66.9445 30.6226 66.25C30.6239 66.1997 30.6417 66.1512 30.6736 66.1121C30.957 65.8699 30.7839 65.7488 30.5785 65.5655C30.3731 65.3822 30.2832 65.1031 29.9946 65.0038C29.8045 64.9399 29.6212 64.8592 29.4344 64.7886C29.3173 64.7432 29.2528 64.8205 29.1832 64.8996C28.949 65.1653 28.8437 65.1653 28.6044 64.9248C28.4754 64.7903 28.4109 64.5263 28.2377 64.5263C28.0646 64.5263 27.922 64.7079 27.7726 64.8222C27.4739 65.0526 27.0835 65.1939 27.0003 65.6412C26.9782 65.7555 26.8662 65.9187 26.7067 65.8985C26.5471 65.8783 26.4266 65.7169 26.3485 65.5622C26.3049 65.4403 26.248 65.3236 26.1788 65.2141C26.0515 65.061 25.9343 64.9046 25.7171 65.0963C25.6891 65.1184 25.6544 65.1305 25.6186 65.1305C25.5828 65.1305 25.5481 65.1184 25.5202 65.0963C25.0551 64.8189 24.5475 64.8256 24.04 64.8929C23.8009 64.9187 23.5594 64.9125 23.322 64.8744C23.1816 64.8578 23.0531 64.7879 22.9638 64.6793C22.6787 64.343 22.3595 64.3329 22.0268 64.6255C21.9643 64.6744 21.8875 64.7021 21.8079 64.7045C21.4888 64.7415 21.1696 64.7751 20.8539 64.829C20.6366 64.866 20.3973 64.797 20.2191 64.829C19.7811 64.9147 19.3143 64.7331 18.9036 64.9769C18.8662 65.0013 18.8237 65.017 18.7793 65.0228C18.7349 65.0287 18.6898 65.0245 18.6473 65.0106C18.503 64.9683 18.3512 64.9576 18.2023 64.9791C18.0535 65.0005 17.9111 65.0538 17.785 65.135C17.5965 65.251 17.4132 65.3234 17.2061 65.1569C17.0907 65.0627 16.9362 65.1367 16.797 65.1115C16.208 65.0089 16.0536 64.5296 15.8652 64.084C15.7769 63.8738 15.726 63.6484 15.6479 63.4332C15.5698 63.2179 15.6241 63.0817 15.8584 63.0447C16.0057 63.014 16.1559 62.9982 16.3065 62.9976C17.8562 63.0733 19.4111 63.0666 20.9625 63.1238C22.3205 63.1725 23.6784 63.0985 25.0466 63.0952C26.8357 63.0952 28.6265 63.0784 30.4088 62.8766C30.4885 62.8715 30.5684 62.8715 30.6481 62.8766C30.8586 62.8766 30.9876 62.9522 30.9044 63.1893C30.8637 63.3138 30.862 63.4483 31.0249 63.4668C31.1879 63.4853 31.2184 63.3474 31.2116 63.223C31.2056 63.1443 31.2207 63.0654 31.2556 62.9945C31.2906 62.9235 31.3439 62.8631 31.4102 62.8194C31.6054 62.668 31.5987 62.6512 31.58 61.8911C31.6784 60.6282 31.58 59.2341 31.7124 57.8552C31.8091 56.8916 31.8719 55.9246 31.9195 54.961C31.9585 54.174 31.984 53.3786 31.9704 52.5849C31.9602 51.892 31.9144 51.184 32.0451 50.4811C32.1223 49.911 32.1535 49.3358 32.1384 48.7608C32.1333 48.5825 32.1435 48.4042 32.169 48.2277C32.2009 47.9875 32.2133 47.7451 32.2063 47.5029C32.2084 47.185 32.2408 46.868 32.3031 46.5561C32.39 46.2904 32.3977 46.0054 32.3252 45.7355C32.3011 45.6856 32.2877 45.6313 32.2859 45.576C32.2842 45.5207 32.2941 45.4656 32.315 45.4143C32.6018 44.9737 32.3557 44.5163 32.3625 44.069C32.3744 43.3257 32.3455 42.5874 32.5085 41.8509C32.5628 41.6087 32.4813 41.3464 32.7258 41.1597C32.7381 41.1451 32.7447 41.1266 32.7444 41.1076C32.4881 40.9546 32.6918 40.6973 32.6137 40.5241C32.4168 40.0851 32.5136 39.6748 32.6426 39.2544C32.6837 39.1522 32.6909 39.0397 32.663 38.9332C32.573 38.6927 32.6477 38.5733 32.904 38.5565C32.9439 38.5516 32.9828 38.5408 33.0194 38.5246C33.1467 38.4708 33.3589 38.496 33.325 38.2757C33.291 38.0554 33.1094 38.0907 32.943 38.1227C32.8225 38.1445 32.6799 38.1428 32.6545 37.9881C32.629 37.8334 32.7614 37.8519 32.8565 37.82C32.9673 37.7759 33.074 37.7224 33.1756 37.6602C33.2337 37.6361 33.2852 37.5986 33.3257 37.5508C33.3663 37.503 33.3947 37.4463 33.4086 37.3855C33.4226 37.3246 33.4216 37.2613 33.4059 37.2009C33.3902 37.1404 33.3601 37.0846 33.3182 37.038C33.2706 36.969 33.1484 36.9068 33.2146 36.8177C33.3097 36.7017 33.4692 36.7202 33.6084 36.7387C33.7476 36.7572 33.7663 36.8496 33.7629 36.959C33.7402 37.0861 33.7367 37.2159 33.7527 37.3441C33.8562 37.6804 33.9564 37.9982 33.8121 38.353C33.7799 38.4321 33.8681 38.5565 33.897 38.6625C33.9738 38.8971 33.9814 39.1485 33.9191 39.3873C33.8678 39.5371 33.8475 39.6956 33.8595 39.8534C33.8714 40.0111 33.9154 40.1649 33.9886 40.3054C34.2736 40.8323 34.379 41.4364 34.2891 42.0274Z" fill="#0E1111"/>
            <path d="M27.6931 46.6667C28.4586 46.6314 29.0103 46.1706 28.9356 45.4425C28.8762 44.8556 28.535 44.4856 27.7474 44.4856C27.1516 44.4856 26.7052 44.9565 26.6933 45.5871C26.6797 46.1084 27.1278 46.6936 27.6931 46.6667Z" fill="#0E1111"/>
            <path d="M27.668 41.8723C28.1891 41.8723 28.6678 41.4603 28.6762 41.0012C28.6864 40.4816 28.2485 40.078 27.6748 40.0763C27.2029 40.0763 26.8838 40.4328 26.8821 40.9692C26.8804 41.5057 27.1859 41.8723 27.668 41.8723Z" fill="#0E1111"/>
            <path d="M17.6532 46.7919C18.2286 46.7919 18.7684 46.2352 18.7565 45.6399C18.738 45.3439 18.6061 45.0659 18.3878 44.8628C18.1696 44.6597 17.8814 44.5467 17.5819 44.5469C17.0829 44.5469 16.5855 45.0884 16.5821 45.6282C16.5753 46.2033 17.1117 46.7851 17.6532 46.7919Z" fill="#0E1111"/>
            <path d="M17.626 41.94C18.0843 41.94 18.4391 41.5684 18.4526 41.0673C18.4415 40.8449 18.3494 40.6341 18.1933 40.4739C18.0373 40.3137 17.8278 40.215 17.6039 40.1962C17.0947 40.1962 16.7959 40.5325 16.7874 41.0908C16.7828 41.202 16.8012 41.313 16.8414 41.4168C16.8817 41.5207 16.9429 41.6154 17.0215 41.6949C17.1 41.7745 17.1942 41.8373 17.2982 41.8794C17.4021 41.9216 17.5137 41.9422 17.626 41.94V41.94Z" fill="#0E1111"/>
            <path d="M21.7503 5.5756C21.9073 5.56916 22.0593 5.5184 22.1882 5.42929C22.1958 5.42271 22.2018 5.41445 22.2056 5.40517C22.2094 5.3959 22.211 5.38586 22.2101 5.37588C22.2093 5.36589 22.2061 5.35624 22.2008 5.3477C22.1956 5.33916 22.1883 5.33197 22.1797 5.32671C22.0388 5.20731 21.881 5.24767 21.7231 5.28299H21.6943C21.6111 5.3183 21.4617 5.29644 21.494 5.44275C21.5177 5.55878 21.6348 5.57391 21.7503 5.5756Z" fill="#0E1111"/>
            </svg>
          </div>
         `;
      const restaurant818Html = `
        <div class="image-wrap" style="background-color: rgb(191,182,119)">
          <svg width="60" height="90" viewBox="15 8 15 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 23.3157C0 10.4388 10.2975 0 23 0C35.7025 0 46 10.4388 46 23.3157C46 41.4436 31.625 41.2978 28.29 51.819L26.8238 56.3073C26.4126 57.547 25.2372 58.3573 23.9487 58.2891H22.3388C21.0503 58.3573 19.8749 57.547 19.4638 56.3073L17.9975 51.819C14.5188 41.2978 0 41.4436 0 23.3157Z" fill="#DCB5DF"></path>
            <path d="M0 23.3156C0 10.4388 10.2975 0 23 0C35.7025 0 46 10.4388 46 23.3156C46 41.4436 31.625 41.2978 28.29 51.819L26.8238 56.3073C26.4126 57.547 25.2372 58.3573 23.9487 58.2891H22.3388C21.0503 58.3573 19.8749 57.547 19.4638 56.3073L17.9975 51.819C14.5188 41.2978 0 41.4436 0 23.3156Z" fill="#C1B76E"/>
            <g clip-path="url(#clip0_1_2406)">
            <path d="M13.3462 22.8363V14.8755C13.3462 14.5677 13.3627 14.2598 13.3462 13.952C13.3363 13.7847 13.38 13.6184 13.4713 13.476C13.5627 13.3335 13.6973 13.2217 13.8568 13.1559C14.119 13.0392 14.3958 12.9562 14.6804 12.9092C15.3996 12.803 16.1206 12.7146 16.8435 12.6438C17.7219 12.5562 18.6004 12.4846 19.4816 12.4235C20.0306 12.3864 20.5577 12.3705 21.0984 12.3625C22.1773 12.3466 23.2561 12.3227 24.3322 12.3386C25.3451 12.3545 26.3581 12.4076 27.371 12.466C28.1534 12.5111 28.933 12.5748 29.7126 12.6677C30.1875 12.7234 30.6569 12.8508 31.1264 12.9463C31.3103 12.9861 31.4942 13.0259 31.6754 13.0763C31.8001 13.1108 31.9214 13.1561 32.0377 13.2117C32.2257 13.295 32.3836 13.4307 32.4912 13.6014C32.5988 13.7721 32.6512 13.9699 32.6417 14.1696C32.6417 15.4964 32.6417 16.8232 32.6197 18.15C32.6197 18.6808 32.606 19.1929 32.6005 19.713C32.5785 22.5011 32.5575 25.2909 32.5373 28.0825C32.5373 28.7061 32.5373 29.3297 32.5373 29.9533C32.5507 30.5613 32.5214 31.1695 32.4495 31.7737C32.4223 31.9937 32.3726 32.2106 32.3013 32.4212C32.2474 32.5749 32.1578 32.7147 32.0393 32.8297C31.9208 32.9447 31.7766 33.0319 31.6177 33.0846C31.2806 33.2065 30.9278 33.2833 30.5691 33.3128C29.6605 33.403 28.7491 33.4906 27.824 33.5463C27.0746 33.5941 26.3224 33.61 25.5702 33.6153C23.8463 33.6312 22.1196 33.6445 20.3957 33.6365C19.5474 33.6365 18.6965 33.5914 17.8482 33.549C17.1784 33.5154 16.5104 33.4658 15.8443 33.4004C15.4298 33.3606 15.0207 33.2942 14.609 33.2173C14.4017 33.1741 14.2007 33.1063 14.0105 33.0156C13.8544 32.9433 13.7189 32.8351 13.6161 32.7005C13.5132 32.5658 13.446 32.4089 13.4203 32.2434C13.3903 32.0679 13.3747 31.8905 13.3737 31.7127C13.3737 30.8051 13.3737 29.8949 13.36 28.9874L13.3654 25.1609C13.3654 24.386 13.3654 23.6112 13.3654 22.8363H13.3462ZM13.5329 22.9159H13.5686C13.5686 24.5081 13.5686 26.1003 13.5686 27.6792C13.5686 29.006 13.5466 30.3328 13.5411 31.6596C13.5435 31.8253 13.561 31.9904 13.5933 32.1532C13.614 32.3276 13.6888 32.4919 13.8078 32.6245C13.9269 32.7571 14.0846 32.8518 14.2604 32.8962C14.6029 32.9997 14.9536 33.076 15.309 33.1244C15.891 33.196 16.4784 33.2491 17.0631 33.2783C18.1914 33.3314 19.3169 33.3871 20.4451 33.4004C21.8506 33.4163 23.2561 33.4004 24.6616 33.3791C25.6828 33.3659 26.704 33.3552 27.7224 33.2969C28.7409 33.2385 29.7401 33.127 30.742 33.0315C30.9693 33.0034 31.1935 32.9554 31.4119 32.8882C31.5931 32.8498 31.7582 32.7597 31.8859 32.6296C32.0136 32.4995 32.0981 32.3354 32.1283 32.1585C32.1899 31.8729 32.2339 31.584 32.2601 31.2934C32.3013 30.5371 32.3287 29.7782 32.3424 29.0219C32.3672 27.4483 32.3781 25.8774 32.3946 24.3038C32.3946 23.1043 32.4385 21.9022 32.4385 20.7028C32.4385 18.9647 32.4248 17.2266 32.4111 15.4885C32.4111 15.0161 32.4111 14.5411 32.3726 14.0688C32.3728 13.8969 32.3126 13.7301 32.2019 13.5956C32.0912 13.4611 31.9365 13.3669 31.7632 13.3284C31.4722 13.2462 31.1785 13.1798 30.882 13.1214C30.4066 13.0093 29.9256 12.9207 29.4409 12.8561C28.5597 12.7552 27.6703 12.6756 26.7836 12.6226C25.8969 12.5695 24.9389 12.5456 24.0138 12.5297C23.4263 12.5297 22.8388 12.5297 22.2514 12.5589C21.049 12.5907 19.8485 12.6287 18.6498 12.673C18.1996 12.6916 17.7521 12.726 17.3047 12.7712C16.5745 12.8481 15.847 12.9383 15.1086 13.0365C14.759 13.0725 14.4152 13.1491 14.0847 13.2647C13.9183 13.3124 13.7734 13.413 13.6738 13.5503C13.5741 13.6877 13.5254 13.8536 13.5356 14.021C13.5356 14.3739 13.5356 14.7295 13.5356 15.0825L13.5329 22.9159Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M21.299 19.1978C21.3676 19.3278 21.4417 19.4632 21.5021 19.5852C21.5625 19.7073 21.6229 19.8771 21.6833 20.0231C21.7657 20.2301 21.7657 20.2274 22.0045 20.2301C22.2433 20.2327 22.4272 20.2301 22.6386 20.2513C22.7233 20.2632 22.8069 20.2819 22.8884 20.307V20.3707C22.8383 20.3958 22.7847 20.4137 22.7292 20.4238C22.5261 20.4397 22.3229 20.445 22.1198 20.4556L21.8837 20.4769C21.9441 20.7104 21.9743 20.92 22.2543 21.0076C22.4667 21.0917 22.6691 21.1976 22.8582 21.3234C23.1038 21.4764 23.3896 21.5584 23.6818 21.5595C23.8776 21.5572 24.073 21.5777 24.2637 21.6206C24.3896 21.6655 24.508 21.7281 24.6151 21.8063L24.7139 21.7214C24.7789 21.6688 24.8576 21.6346 24.9413 21.6224C25.0251 21.6103 25.1107 21.6206 25.1888 21.6524C25.4277 21.7692 25.4276 21.7692 25.6994 21.6524C25.5429 20.9465 25.3041 20.2513 25.1092 19.5295L24.7167 20.2619L24.6563 20.246C24.6622 20.1651 24.6769 20.0851 24.7002 20.0072C24.7935 19.779 24.9006 19.5587 24.9967 19.3331C25.0302 19.2721 25.0454 19.2031 25.0406 19.1341C24.928 18.6963 24.8073 18.2637 24.6837 17.8312C24.6628 17.7701 24.6371 17.7107 24.6069 17.6534C24.3323 17.5897 24.088 17.8153 23.8135 17.6534L24.53 17.4252L24.4312 16.8653C24.5959 16.9476 24.6014 17.0935 24.6563 17.205C24.7414 17.3721 24.7524 17.3881 24.9308 17.3297L25.7159 17.0643C25.7596 17.0409 25.81 17.0319 25.8596 17.0386C25.9091 17.0453 25.955 17.0673 25.9904 17.1015C25.9304 17.1411 25.8671 17.1758 25.801 17.205L25.0351 17.4703C24.961 17.4942 24.8896 17.5287 24.8265 17.5552C24.8799 18.0149 25.0106 18.4631 25.2135 18.882L25.3645 18.6697C25.4364 18.5638 25.533 18.4755 25.6464 18.4119C25.7598 18.3484 25.887 18.3113 26.0178 18.3035C26.3521 18.2694 26.69 18.2954 27.0143 18.3805C27.0391 18.3916 27.0621 18.4059 27.083 18.423C27.0562 18.4573 27.0194 18.4832 26.9774 18.4974C26.9354 18.5115 26.89 18.5133 26.8469 18.5026C26.6437 18.4893 26.4406 18.4654 26.2347 18.4548C26.0129 18.4443 25.7943 18.5095 25.6172 18.6391C25.44 18.7686 25.3156 18.9541 25.2657 19.1633C25.2493 19.2323 25.2493 19.304 25.2657 19.373C25.4377 20.0629 25.6143 20.7519 25.7955 21.4401C25.8202 21.5159 25.8514 21.5896 25.8888 21.6604H28.4308C28.4282 21.6158 28.4227 21.5715 28.4143 21.5277C28.1234 20.5512 27.8269 19.5746 27.5414 18.5954C27.4535 18.2903 27.4041 17.9771 27.3218 17.672C27.2532 17.4225 27.1708 17.1731 27.083 16.929C27.0207 16.7512 26.9032 16.5964 26.7464 16.4857C26.5897 16.375 26.4014 16.3139 26.2073 16.3107C25.9877 16.2895 25.7653 16.2948 25.5457 16.2815L24.4696 16.2152C24.3543 16.2152 24.239 16.2019 24.2088 16.3664L24.0194 16.2762C23.8819 16.1971 23.7286 16.1471 23.5697 16.1292C23.4107 16.1114 23.2497 16.1262 23.097 16.1727C22.548 16.3478 21.999 16.5415 21.4335 16.7353C20.4068 17.0961 19.3829 17.4677 18.3535 17.8286C17.7298 18.0418 17.1301 18.3156 16.5637 18.6459C16.4425 18.7042 16.339 18.7918 16.263 18.9001C16.187 19.0084 16.1412 19.1338 16.1299 19.2642C16.1197 19.2922 16.1058 19.319 16.0888 19.3438C16.0429 19.3105 16.0091 19.2642 15.9918 19.2114C15.9746 19.1586 15.9749 19.1019 15.9927 19.0492C16.0156 18.94 16.0635 18.837 16.1328 18.748C16.2022 18.6589 16.2912 18.5859 16.3935 18.5344C16.7731 18.3195 17.1654 18.1264 17.5684 17.9559C18.326 17.6614 19.0974 17.404 19.8633 17.1307C20.5358 16.8892 21.2084 16.645 21.8837 16.4062C22.2653 16.2735 22.6523 16.1408 23.0367 16.0161C23.3191 15.932 23.6178 15.9121 23.9096 15.9577C24.6425 16.0347 25.3755 16.0878 26.1057 16.109C26.3911 16.1086 26.6681 16.2018 26.8915 16.3734C27.1149 16.545 27.2715 16.7849 27.3355 17.0537C27.4645 17.4438 27.5743 17.8498 27.6896 18.2346C27.7637 18.4999 27.7747 18.4999 28.052 18.5371C29.334 18.6777 30.3195 19.3331 31.1293 20.254C31.2489 20.4023 31.3265 20.5782 31.3544 20.7643C31.3823 20.9504 31.3596 21.1403 31.2885 21.3154C31.2638 21.3977 31.2336 21.4799 31.2006 21.5808C31.3675 21.6505 31.5549 21.659 31.7277 21.6046C31.8402 21.5808 31.8155 21.4693 31.8155 21.3844C31.8155 20.9174 31.8155 20.453 31.832 19.9859C31.832 19.4552 31.8567 18.9457 31.9116 18.423C31.9335 18.5716 31.9473 18.7213 31.9528 18.8714C31.9528 20.4636 31.9528 22.0345 31.9363 23.6134C31.9363 24.6245 31.9363 25.6355 31.9144 26.6492C31.9283 27.0594 31.9008 27.47 31.832 27.8751C31.7661 28.183 31.7524 28.4961 31.6728 28.8012C31.6175 29.0007 31.5118 29.1836 31.3652 29.3337C31.2185 29.4838 31.0356 29.5963 30.8328 29.661C30.4264 29.8064 29.995 29.8757 29.5618 29.8653C28.5159 29.8813 27.47 29.8653 26.4241 29.8653C25.1971 29.8653 23.9727 29.8972 22.7457 29.9105C22.5178 29.9105 22.2872 29.9105 22.0594 29.9105C21.8976 29.9046 21.7384 29.8695 21.59 29.807C21.4256 29.7664 21.254 29.7619 21.0876 29.7937C20.8872 29.807 20.6868 29.868 20.4864 29.868C20.0774 29.868 19.6629 29.8335 19.2621 29.8308C18.7707 29.8308 18.2821 29.8494 17.7907 29.8574C17.0961 29.876 16.4012 29.8307 15.7154 29.722C15.417 29.674 15.1292 29.5771 14.8644 29.4355C14.7226 29.3558 14.5984 29.2499 14.499 29.1237C14.3996 28.9976 14.327 28.8537 14.2852 28.7004C14.1063 28.0909 14.033 27.457 14.0684 26.8243C14.0684 26.5085 14.0985 26.1927 14.1013 25.8796C14.1013 25.2534 14.1342 24.6271 14.1013 24.0062C14.0134 22.4989 14.0546 20.989 14.0299 19.495C14.0281 19.1075 14.051 18.7202 14.0985 18.3354L14.2276 21.8143H16.775C16.6378 21.1164 16.2974 20.514 16.1299 19.8108C16.1966 19.8445 16.2553 19.8912 16.3025 19.9478C16.3498 20.0044 16.3845 20.0697 16.4044 20.1398C16.5801 20.6095 16.7448 21.0792 16.9123 21.5489C16.9397 21.6206 16.9699 21.6896 17.0001 21.7612C17.1758 21.7612 17.1758 21.6471 17.1813 21.5436C17.2005 21.3074 17.2197 21.0713 17.2417 20.8351C17.2503 20.7884 17.2622 20.7423 17.2774 20.6971C17.4009 20.8245 17.346 20.9625 17.368 21.0819C17.3899 21.2013 17.4037 21.3472 17.4229 21.4879C18.046 21.2676 18.5209 20.8218 19.177 20.6679C19.1441 20.8829 18.9656 20.8802 18.8586 20.9519C18.7515 21.0235 18.6088 21.0952 18.4688 21.1774C18.5072 21.196 18.5264 21.2119 18.5484 21.2119C19.0041 21.2438 19.4598 21.2756 19.9209 21.2995C20.2161 21.3118 20.5104 21.2611 20.7829 21.1509C21.0789 21.0368 21.3889 20.9601 21.7053 20.9227C21.7484 20.9149 21.7906 20.9033 21.8315 20.8882L21.697 20.4928C21.3323 20.4553 20.965 20.4482 20.599 20.4716C20.2567 20.5153 19.912 20.5392 19.5668 20.5432C19.7519 20.3994 19.9801 20.3175 20.2174 20.3097C20.577 20.2964 20.9366 20.3097 21.2962 20.2911C21.3841 20.2911 21.4692 20.2778 21.5708 20.2699C21.4966 19.8984 21.2468 19.6012 21.2441 19.2403L21.299 19.1978ZM25.7186 22.7643L25.7351 22.7457C25.6866 22.6731 25.6444 22.5968 25.6088 22.5175C25.5877 22.4449 25.5417 22.3815 25.4784 22.3376C25.415 22.2937 25.338 22.272 25.2602 22.276C25.0248 22.258 24.7881 22.2842 24.5629 22.353C24.3475 22.4013 24.1559 22.5202 24.0208 22.6894C23.8857 22.8587 23.8154 23.068 23.8218 23.2817C23.8273 23.3989 23.7904 23.5144 23.7174 23.6081C23.5511 23.7695 23.4187 23.9606 23.3276 24.1707C23.2019 24.3856 23.1618 24.6377 23.2151 24.8792C23.2618 25.0464 23.3002 25.0782 23.4704 25.0676C23.6332 25.068 23.7954 25.0493 23.9535 25.0119C24.3104 24.9057 24.659 24.7757 25.0076 24.6483C25.0571 24.6324 25.0927 24.5793 25.1394 24.5528C25.2712 24.4785 25.3727 24.3379 25.5237 24.3777C25.5317 24.3236 25.5474 24.2709 25.5704 24.2211C25.6921 24.0442 25.7702 23.8426 25.7988 23.6319C25.8273 23.4212 25.8055 23.207 25.7351 23.0057C25.7226 22.9258 25.7171 22.8451 25.7186 22.7643V22.7643ZM21.159 22.613H20.7774L19.9731 22.6422L18.65 22.6661C18.6091 22.666 18.5685 22.6713 18.5292 22.682C18.5046 22.6851 18.481 22.6934 18.4602 22.7063C18.4393 22.7192 18.4217 22.7365 18.4086 22.7568C18.3954 22.7771 18.3871 22.7999 18.3843 22.8237C18.3814 22.8475 18.384 22.8716 18.3919 22.8943C18.4633 23.1146 18.4194 23.3666 18.5978 23.5577C18.6198 23.5816 18.5978 23.6347 18.6198 23.6718C18.6403 23.7542 18.6698 23.8342 18.7076 23.9106C18.7745 24.0276 18.8507 24.1394 18.9354 24.245C19.0261 24.3817 19.1507 24.4944 19.2979 24.5727C19.4451 24.6511 19.6102 24.6926 19.7782 24.6935C20.0527 24.6935 20.0857 24.6457 20.0994 24.3856C20.1131 24.1256 20.1241 23.8974 20.1488 23.6559C20.164 23.5655 20.1879 23.4766 20.2202 23.3905C20.4123 23.7222 20.2394 24.0805 20.3629 24.4122C20.6813 24.1627 21.0904 23.2313 21.1562 22.613H21.159ZM25.5512 24.9721C25.4776 24.9601 25.4024 24.9601 25.3288 24.9721C25.0071 25.0857 24.6691 25.1502 24.3269 25.1631C24.1741 25.1616 24.024 25.2011 23.8931 25.2772C23.7794 25.3643 23.6525 25.4341 23.517 25.4842C23.1876 25.6169 22.8555 25.7496 22.5233 25.8823C22.4774 25.8989 22.4362 25.9258 22.4033 25.9609C22.3704 25.996 22.3466 26.0382 22.3339 26.0839C22.2978 26.2266 22.3194 26.3773 22.3945 26.5051C22.4695 26.6328 22.5922 26.728 22.7374 26.7712C23.0841 26.8217 23.4366 26.8217 23.7833 26.7712C23.816 26.7654 23.8475 26.7546 23.8767 26.7394C24.0386 26.6677 24.2061 26.6041 24.3625 26.5191C24.7823 26.3112 25.1354 25.9965 25.3837 25.6089C25.4639 25.5056 25.5251 25.3899 25.5649 25.2666C25.5697 25.1678 25.5614 25.0688 25.5402 24.9721H25.5512ZM27.8406 18.6644C28.1151 19.6967 28.3759 20.6732 28.6641 21.6312C28.9387 21.6312 28.9249 21.6312 28.9936 21.456C29.1336 21.0872 29.2681 20.721 29.4218 20.3521C29.4932 20.1611 29.57 19.97 29.6277 19.7736C29.6467 19.6862 29.6467 19.5958 29.6277 19.5083C29.597 19.3852 29.5342 19.2718 29.4453 19.1789C29.3564 19.086 29.2444 19.0167 29.1198 18.9776C28.7035 18.826 28.2706 18.721 27.8296 18.6644H27.8406ZM29.0924 21.602C29.1265 21.6181 29.1624 21.6306 29.1994 21.6391L30.8465 21.6046C30.8915 21.6058 30.9358 21.5934 30.9732 21.5692C31.0106 21.5449 31.0392 21.51 31.0551 21.4693C31.1776 21.2795 31.2318 21.056 31.2095 20.8334C31.1872 20.6108 31.0895 20.4015 30.9316 20.238C30.633 19.9244 30.2966 19.6465 29.9296 19.4101C29.8827 19.3931 29.8339 19.3816 29.7842 19.3756C29.8323 19.7528 29.7544 20.1349 29.5618 20.4662C29.3834 20.8431 29.2379 21.2119 29.0814 21.602H29.0924ZM26.2539 22.6634C26.5284 22.82 26.7426 23.0986 27.1132 23.0482C27.1653 23.0482 27.223 23.0774 27.2779 23.088L27.8543 23.2154C27.8416 23.14 27.836 23.0636 27.8379 22.9872C27.851 22.8929 27.8435 22.7971 27.8156 22.7059C27.7877 22.6147 27.7402 22.5302 27.6762 22.458C27.6121 22.3859 27.533 22.3276 27.444 22.2871C27.355 22.2466 27.2582 22.2247 27.1598 22.2229C26.9806 22.2135 26.802 22.249 26.6413 22.3263C26.4806 22.4035 26.3433 22.5196 26.243 22.6634H26.2539ZM30.5006 23.6293L30.443 23.6108C30.3242 23.7064 30.1995 23.795 30.0696 23.8761C29.9351 23.9504 29.7951 24.0009 29.5947 24.0831L30.1438 24.2636C30.3414 24.3273 30.4595 24.2636 30.4896 24.0752C30.501 23.9268 30.501 23.7777 30.4896 23.6293H30.5006ZM19.63 26.7128C19.6972 26.8195 19.8013 26.8999 19.9238 26.9397C20.0464 26.9795 20.1795 26.9762 20.2998 26.9304C20.5606 26.8615 20.7115 26.7155 20.7143 26.5244L19.7315 26.6598C19.6915 26.672 19.6536 26.6899 19.619 26.7128H19.63Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M26.6847 31.5955C26.7413 31.5756 26.8004 31.5631 26.8604 31.5583C27.2585 31.5583 27.6565 31.5769 28.0546 31.5928C28.4526 31.6088 28.804 31.63 29.1773 31.6565C29.3887 31.6725 29.6001 31.6937 29.8087 31.7255C29.9161 31.7492 30.0216 31.7802 30.1244 31.8184V31.8715C30.0584 31.8847 29.9913 31.8926 29.924 31.8954C29.6801 31.895 29.4364 31.8826 29.1938 31.8582C28.4499 31.7574 27.6977 31.7627 26.951 31.7202C26.8586 31.7109 26.7669 31.6958 26.6765 31.6751L26.6847 31.5955Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M17.8947 31.7229C17.9441 31.6778 17.9578 31.6512 17.977 31.6486C18.2049 31.6221 18.43 31.5849 18.6578 31.5796C19.5061 31.5584 20.3543 31.5504 21.2025 31.5398C21.23 31.5398 21.2574 31.5663 21.3288 31.6061C21.2625 31.6337 21.1935 31.6551 21.1229 31.6698C20.1841 31.7043 19.2453 31.7388 18.3064 31.7654C18.1683 31.7614 18.0306 31.7472 17.8947 31.7229V31.7229Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M31.9145 17.6004C31.758 17.5712 31.7772 17.4704 31.7772 17.3881C31.7772 17.1227 31.7772 16.8574 31.7772 16.592C31.7772 16.2603 31.7772 15.9286 31.7772 15.5996C31.7904 15.4383 31.8134 15.2779 31.8458 15.1193H31.909C31.9284 15.1897 31.9413 15.2616 31.9474 15.3342C31.9474 16.0188 31.9474 16.7035 31.9474 17.3881C31.9439 17.4598 31.9328 17.5309 31.9145 17.6004V17.6004Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M29.8772 32.6172L30.116 32.5589C30.3905 32.5005 30.6651 32.4633 30.9396 32.3811C31.1094 32.3347 31.2656 32.2505 31.3957 32.1353C31.5258 32.0201 31.6263 31.8771 31.689 31.7177C31.7165 31.6674 31.7497 31.6203 31.7878 31.577C31.824 31.611 31.8466 31.6563 31.8516 31.7049C31.8567 31.7534 31.8438 31.8021 31.8153 31.8424C31.6989 32.0964 31.4992 32.3062 31.247 32.4395C30.9146 32.6299 30.5354 32.7307 30.149 32.7313C30.0566 32.7274 29.9648 32.7159 29.8745 32.6969L29.8772 32.6172Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M13.9693 15.0636C14.134 15.39 14.2109 17.1865 14.0818 17.4519C14.0486 17.4186 14.0216 17.38 14.0022 17.3377C13.9781 17.2511 13.9643 17.1621 13.9611 17.0724C13.9611 16.5045 13.9391 15.934 13.9336 15.3661C13.9386 15.2646 13.9505 15.1636 13.9693 15.0636V15.0636Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
            <path d="M16.2531 31.7468C16.2064 31.9087 16.0966 31.8875 16.0033 31.8875C15.6444 31.8993 15.2881 31.95 14.9409 32.0387C14.8372 32.0552 14.7384 32.0931 14.6512 32.1499C14.564 32.2067 14.4906 32.281 14.4358 32.3678C14.3178 32.3678 14.2876 32.3041 14.3398 32.2324C14.3949 32.1547 14.4695 32.0917 14.5566 32.0493C14.7312 31.9649 14.9155 31.9008 15.1056 31.8583C15.4076 31.7946 15.7178 31.7601 16.0225 31.7229C16.1001 31.7222 16.1775 31.7303 16.2531 31.7468Z" fill="#0E1111" stroke="#0E1111" stroke-width="0.176044" stroke-miterlimit="10"/>
          </svg> 
        </div>
        `;

      if (is818) {
        insertSvg = store.category == 'Bar' || store.category == 'Restaurant' ? restaurant818Html : insertSvg;
      }
      const infoHtml = `
            <span tabindex="${mobileView ? 0 : -1}" id="flyout-block-span"></span>
            <div class="m-2">
              <div class="container px-0">
                
                <!-- Store Name Row -->
                <div class="row store-name-row mx-0" 
                    style="display: ${retailer || store.name ? 'block' : 'none'};">
                  <div class="store-name ${noLogo && 'no-logo'}">
                    <div class="retailer-logo-container">
                      <div class="retailer-logo">
                        <div class="border-outer">
                          <div class="border-inner">
                            <div class="image-wrap" style="background-color: rgb(242,193,151)">
                              ${is818 ? insertSvg : standardRetailer}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span id="fly-over-retailer-name" tabindex="${mobileView ? 0 : -1}"
                          aria-label="${(retailer && retailer.name) || store.name} ${' '} ${store.shortName}">
                      ${(retailer && retailer.name) || store.name}
                    </span>
                  </div>
                </div>
            
                <!-- Retailer Short Name -->
                <div class="row popout-retailername test" 
                    style="display: ${retailer && retailer.name && store.shortName ? 'block' : 'none'};">
                  <div class="col ng-binding">${store.shortName}</div>
                </div>
            
                <!-- Store Address -->
                <div class="row popout-address" 
                    style="display: ${store.shortAddress || store.address ? 'block' : 'none'};">
                  <span class="col grey-text ng-binding">
                    <a class="grey-text" 
                      aria-hidden="${mobileView ? false : true}" 
                      tabindex="${mobileView ? 0 : -1}" 
                      style="cursor: pointer;" href="#"
                      onclick="googleMapsDirectWindow(event, ${store.id})">
                      ${store.shortAddress || store.address}
                    </a>
                  </span>
                </div>
            
                <!-- Store Phone -->
                <div class="row popout-phone" 
                    style="display: ${store.phone && nonBlankStr(store.phone) ? 'block' : 'none'};">
                  <a tabindex="${mobileView ? 0 : -1}" 
                    class="col ng-binding" 
                    type="tel" 
                    id="fly-over-retailer-phone" 
                    href="${phoneLink(store)}"
                    aria-label="${(retailer && retailer.name) || store.name}. 
                                ${store.shortAddress || store.address}. 
                                Call us at ${Util.formatPhoneAria(store.phone)}">
                    <span>${Util.formatPhone(store.phone)}</span>
                  </a>
                </div>
            
                <!-- Products Section -->
                <div class="row popout-products" 
                    style="display: ${upcIds && upcIds.length && !store.noUPCLevelData ? 'block' : 'none'};">
                  <div class="col">
                    ${
                      store.synthetic && !showSyntheticStoreProducts
                        ? `<span class="grey-text">
                            ${
                              is818 || $scope.singleItemSelect
                                ? 'Buy Online'
                                : 'Call for Availability'
                            }
                          </span>`
                        : `<button class="products-found-count pl-0" 
                                  aria-hidden="${mobileView ? false : true}"  
                                  tabindex="${mobileView ? 0 : -1}"  
                                  href="#" 
                                  onclick="selectFoundProducts(${store.id}, true)" 
                                  onkeydown="selectFoundProducts(${store.id}, true)" 
                                  class="ng-binding">
                            ${
                              is818 || $scope.singleItemSelect
                                ? 'Buy Online'
                                : upcIds.length > 1
                                ? upcIds.length + ' products found'
                                : upcIds.length + ' product found'
                            } 
                          </button>`
                    }
                  </div>
                </div>
            
                <!-- Call for Product Availability -->
                <div class="row" 
                    style="display: ${store.noUPCLevelData ? 'block' : 'none'};">
                  <div class="col">
                    <a href="tel:${store.phone}" class="ng-binding">Call for product availability</a>
                  </div>
                </div>
            
                <span tabindex="${mobileView ? 0 : -1}" id="flyout-cycle-to-map"></span>
                
              </div>
            </div>
          `;
      return infoHtml;
    };

    $scope.showStr = nonBlankStr;
    $scope.phoneLink = phoneLink;

    $scope.mobileFocusSearch = () => {
      document.querySelector('#search-button').focus();
    };

    $scope.selectMapButtonForMobile = () => {
      $scope.mapOnly = true;
      document.querySelector('#map-tab').focus();
    };

    $scope.mobileFocusNav = async () => {
      const activeMap = document.querySelector('#map-tab.active');
      const activeBuyOnlineTab = document.querySelector('#buy-online-tab.active');
      const activeInStoreTab = document.querySelector('#in-store-tab.active');
      if (activeMap) {
        let flyoverFocus = document.querySelector('#fly-over-retailer-name');
        if (flyoverFocus) {
          flyoverFocus.focus();
        } else {
          document.querySelector('#off-map-focus').focus();
        }
      } else if (activeBuyOnlineTab) {
        document.querySelector('div.buy-now>button').focus();
      } else if (activeInStoreTab) {
        document.querySelector('.store-list-nav ul > li.selected').focus();
      }
    };

    $scope.mobileFocuBackNav = async () => {
      const activeMap = document.querySelector('#map-tab.active');
      const activeBuyOnlineTab = document.querySelector('#buy-online-tab.active');
      const activeInStoreTab = document.querySelector('#in-store-tab.active');
      if (activeMap) {
        activeMap.focus();
      } else if (activeBuyOnlineTab) {
        activeBuyOnlineTab.focus();
      } else if (activeInStoreTab) {
        activeInStoreTab.focus();
      }
    };

    $scope.mobileFocusUpAndOff = () => {
      let mobileFocusElementSelector = '.maplibregl-ctrl-zoom-out';

      if ($scope.mapOnly !== true) {
        mobileFocusElementSelector = '#mobile-exit-up';
      }

      document.querySelector(mobileFocusElementSelector).focus();
    };

    $scope.mobileFocusDownAndOff = () => {
      document.querySelector('#off-map-focus').focus();
    };

    $scope.mobileFocusToFilter = () => {
      document.querySelector('.back-to-products').focus();
    };

    $scope.mobileFlyOverFocusOffMap = () => {
      document.querySelector('#off-map-focus').focus();
    };

    $scope.filterPanelFocus = () => {
      if ($scope.productsOpen == true) {
        $scope.visitedLastProductTile = true;
        document.querySelector('.back-to-products').focus();
      }
    };

    $scope.searchButtonDirectFocus = async () => {
      if ($scope.isMobileLayout === true) {
        document.querySelector('#in-store-tab').click();
        await Util.timeout(200);
        document.querySelector('#in-store-tab').focus();
      } else if ($scope.focuseInStoreTab === true) {
        $scope.focuseInStoreTab = false;
        document.querySelector('#in-store-tab').focus();
      } else {
        document.querySelector('#off-map-focus').focus();
      }
    };

    $scope.skipNavToInStoreRes = async () => {
      document.querySelector('#in-store-tab').click();
      await Util.timeout(200);
      document.querySelector('#in-store-tab').focus();
    };

    $scope.formatPhone = (phone) => {
      return Util.formatPhone(phone);
    };

    $scope.checkCatigories = (logicalUPC) => {
      if (logicalUPC.categories && $scope.ignoreCategories) {
        return $scope.ignoreCategories.filter((ignored) => logicalUPC.categories.indexOf(ignored) == -1).length == 0;
      }
      return true;
    };

    $scope.checkProductBrand = (logicalUPC) => {
      if (logicalUPC.subBrand && $scope.ignoreCategories) {
        return $scope.ignoreCategories.indexOf(logicalUPC.subBrand) == -1;
      }
      return true;
    };

    $scope.saveAddressMessage = '';
    $scope.getAddressErrorMessageFunk = () => {
      if ($scope.getAddressErrorMessage) {
        $scope.saveAddressMessage = $scope.getAddressErrorMessage;
      }
      return $scope.saveAddressMessage;
    };

    const scrollToStoreInList = (store, smooth) => {
      const parent = document.querySelector('div.stores-over-map .scrolling-container');
      var storeDiv = store ? document.querySelector(`.physical-store[id='store_${store.id}']`) : null;
      if (parent) {
        if (storeDiv) {
          const yOffset = -240;
          const y = parent.scrollTop + storeDiv.getBoundingClientRect().top + yOffset;
          parent.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
        } else {
          parent.scrollTo({ top: 0, behavior: 'auto' });
        }
      }
    };

    let recentlyScrolledTimerID = null;
    document.querySelectorAll('.scrolling-container').forEach((el) => {
      el.addEventListener('scroll', (event) => {
        if (recentlyScrolledTimerID) {
          clearTimeout(recentlyScrolledTimerID);
        }
        recentlyScrolledTimerID = $timeout(() => {
          recentlyScrolledTimerID = null;
        }, 2000);
        $scope.cancelHoverStore(null);
      });
    });

    const hoverStoreTimerID = {};
    $scope.hoverStore = function (storeId) {
      if ($scope.isMobile || true) {
        return;
      }
      // don't create new timeouts for the same hover
      const storeIsCurrentlySelected = ($scope.selectedStore && $scope.selectedStore.id) == storeId;
      if (hoverStoreTimerID[storeId] || storeIsCurrentlySelected) {
        return;
      }
      var delay;
      // delay during scrolls or if we are switching selection
      if ($scope.selectedStore) {
        delay = 1000 + (!!recentlyScrolledTimerID ? 1400 : 0);
      } else {
        delay = 200;
      }

      hoverStoreTimerID[storeId] = setTimeout($scope.selectStore.bind(this, storeId, true), delay);
    };

    $scope.cancelHoverStore = function (storeId) {
      if (storeId == null) {
        storeId = Object.entries(hoverStoreTimerID).filter(
          ([_storeId]) => ($scope.selectedStore && $scope.selectedStore.id) != _storeId
        )[0];
      }
      if (!storeId) {
        return;
      }

      if (hoverStoreTimerID[storeId]) {
        clearTimeout(hoverStoreTimerID[storeId]);
        delete hoverStoreTimerID[storeId];
      }
    };

    let flyToTimerID = null;
    $scope.selectStore = function (storeId, hover, clickStore, skipFlyTo, skipFocusFlyTo) {
      if (hover) {
        if (!$scope.firstFullStoresFetchComplete) {
          return;
        }
      } else {
        $scope.cancelHoverStore(storeId);
      }

      const store = $scope.stores.filter((s) => s.id == storeId)[0];
      const marker = store && store.marker;
      if (marker) {
        if ($scope.map) {
          marker.remove();
          marker.addTo($scope.map);
        }
        marker.getElement().classList.add('selected-store');
        if ($scope.selectedStore && $scope.selectedStore.marker && (oldEl = $scope.selectedStore.marker.getElement())) {
          oldEl.classList.remove('selected-store');
        }

        store.flyout =
          store.flyout ||
          new maplibregl.Popup({
            focusAfterOpen: false,
            anchor: 'bottom',
            className: 'flyout',
            closeOnMove: false,
            closeButton: true,
          })
            .setLngLat(marker.getLngLat())
            .setOffset([0, -22])
            .setHTML(buildFlyoutHtml(store));

        if ($scope.isMobileLayout) {
          setTimeout(() => {
            const blockSpan = document.querySelector('#flyout-block-span');
            let focusStart = document.querySelector('#fly-over-retailer-phone');
            let spanElement = focusStart.querySelector('span');
            let spanTextContent = spanElement.textContent;
            if (!spanTextContent) {
              focusStart = document.querySelector('#fly-over-retailer-name');
            }
            const focusEnd = document.querySelector('#flyout-cycle-to-map');

            const mapEl = '#map-tab';
            if (blockSpan)
              blockSpan.addEventListener('focus', (event) => {
                document.querySelector('.back-to-products').focus();
              });

            if (focusStart)
              focusStart.addEventListener('focus', (event) => {
                focusStart.addEventListener('keydown', async (keyboardEvent) => {
                  if (keyboardEvent.key === 'Tab' && keyboardEvent.shiftKey) {
                    document.querySelector(mapEl).click();
                    await Util.timeout(100);
                    document.querySelector(mapEl).focus();
                  }
                });
              });
            if (focusEnd)
              focusEnd.addEventListener('focus', async (event) => {
                const offMapFocusSpanEl = document.querySelector('#off-map-focus').focus();
              });
          }, 500);
        }

        // move us a little bit inward when navigating to a pin. Hardly noticeable but nice. Don't do it when re-selecting the same store.
        // Also if we have a ton of stores, hurry up and zoom in faster!
        const curZoom = $scope.map.getZoom();
        const estimatedNumShownStores = $scope.firstFullStoresFetchComplete
          ? $scope.shownStores.length
          : $scope.shownStores.length * 3;

        const ZOOM_IN_ON_STORE = false;

        storeSelectRetailerListPromise = initRetailerList(
          null,
          false,
          store.zip || $scope.location.zip,
          null,
          false,
          store
        );
        let nextZoom = null;
        if (hover) {
          nextZoom = curZoom;
        } else {
          if (ZOOM_IN_ON_STORE) {
            const ZOOM_STORE_COUNT_CEILING = 75;
            const zoomMultiplier =
              Math.min(ZOOM_STORE_COUNT_CEILING, estimatedNumShownStores) / ZOOM_STORE_COUNT_CEILING;

            const zoomFloor = 12.5 + 2 * zoomMultiplier;
            const zoomCeiling = ($scope.isMobile ? 12.5 : 16) + 2 * zoomMultiplier;
            const weightedAvg_CurAndMax = curZoom * (1 - zoomMultiplier) + zoomCeiling * zoomMultiplier;

            nextZoom =
              $scope.isMobile || $scope.selectedStore == store
                ? curZoom
                : Math.max(curZoom, Math.min(zoomFloor, weightedAvg_CurAndMax));
          } else {
            nextZoom = curZoom;
          }
        }

        if (flyToTimerID) {
          clearTimeout(flyToTimerID);
        }

        if (openFlyout !== store.flyout) {
          openFlyout && openFlyout.remove();
          openFlyout = store.flyout;
        }
        store.flyout.addTo($scope.map);

        const flyToMarker = () => {
          try {
            var lat1, lng1, lat2, lng2;
            [lng1, lat1] = $scope.map.getCenter().toArray();
            [lng2, lat2] = store.flyout.getLngLat().toArray();
            const flyDistance = Util.distanceMiles(lat1, lng1, lat2, lng2);

            const duration = Math.max(400, (hover ? 2500 : 1000) * Math.min(1, flyDistance / 0.5));

            if ($scope.mapOnly || clickStore || !$scope.isMobile) {
              $timeout(
                () => {
                  $scope.map.fire('flystart');
                  $scope.map.flyTo({
                    center: store.flyout.getLngLat(),
                    offset: $scope.isMobile ? [0, 90] : [20, 80],
                    zoom: nextZoom,
                    duration: duration,
                    essential: !hover,
                  });
                },
                $scope.isMobile ? 100 : 0
              );
            }
          } catch (err) {
            console.error(err);
          }
        };

        if (!skipFlyTo) {
          $timeout(flyToMarker, !$scope.mapOnly && $scope.isMobile ? 100 : 0);
        }

        if (clickStore && $scope.isMobileLayout && !skipFocusFlyTo) {
          $scope.mapOnly = true;
        }

        $scope.hoveredStore = (hover || clickStore) && store;

        if ($scope.selectedStore !== store) {
          $scope.selectedStore = store;
          if (!$scope.singleItemSelect || true) {
            // we want to re-store selected store's upcs to the top
            $timeout(() => $scope.setPearLogicalUPCs($scope.upcs), 0);
          }
        }
      }
    };

    //$scope.numPLRetailersToShow = () => ($scope.selectedStore && $scope.selectedUPCs.length) ? 1 : 2;

    $scope.showLoadingRetailerList = { showLoadingRetailerList: false };

    window.googleMapsDirectWindow = $scope.googleMapsDirectWindow = $async(async function ($event, storePearId) {
      if (!$event.isTrusted) {
        return;
      }
      const store = $scope.stores.filter((s) => s.id == storePearId)[0];
      window.open(
        'https://maps.google.com/?q=' + (store.retailerName || store.name) + (store.shortAddress || store.address)
      );
    });

    window.closeiframe = $scope.closeiframe = ($event) => {
      if (!$event.isTrusted) {
        return;
      }

      $rootScope.pymChild.sendMessage('picker-closed', true);
    };

    const BUY_ONLINE_ZIP_LOCK = true;

    let usedRetailerListInit = false;
    //Drives n number of Products found selection
    window.selectFoundProducts = $scope.selectFoundProducts = $async(async function (
      storePearId,
      cameFromProductCount
    ) {
      try {
        const store = $scope.stores.filter((s) => s.id == storePearId)[0];
        document.activeElement?.blur();
        // Prevent map clicks from interfering
        $scope.preventMapClick = true;
        
        if (store) {
          $scope.mapOnly = false;

          if(cameFromProductCount == false){
            $scope.filterSelectedRetailerId(store.retailerId);
            //When retailer filter is selected show store list.
            $scope.findOnline = false;
            return
          }
          $scope.findOnline = true;

          $scope.showLoadingRetailerList.showLoadingRetailerList = true;
          const _RetailerListInit = usedRetailerListInit ? null : RetailerListInit;
          usedRetailerListInit = true;
          if (!BUY_ONLINE_ZIP_LOCK) {
            await initRetailerList(
              _RetailerListInit,
              true,
              store.nearbyZip ? store.nearbyZip : store.zip,
              $scope.selectedUPCs,
              false,
              store
            );
          } else {
            await initRetailerList(_RetailerListInit, true, store.zip || $scope.location.zip, null, false, store);
          }
          $scope.showLoadingRetailerList.showLoadingRetailerList = false;

          let retailerWithResults = null;
          for (let j = 0; j < $scope.pickerList.length; j++) {
            const _retailerWithResults = $scope.pickerList[j];
            if (
              _retailerWithResults &&
              (_retailerWithResults.id == store.retailerId ||
                _retailerWithResults.name == store.retailerName) /* Don't fully understand why this happens. */
            ) {
              retailerWithResults = _retailerWithResults;
            }
          }
          if (!retailerWithResults && store.synthetic) {
            retailerWithResults = {
              retailerId: store.id,
              name: store.name,
              synthetic: true,
              upcs: store.availableUPCIds.map((upcId) => {
                return {
                  pearLogicalUPCId: $scope.upcs.filter((upc) => upc.id == upcId).map((upc) => upc.pearLogicalUPCId)[0],
                  status: 'AVAILABLE',
                };
              }),
            };
            store.retailerWithResults = retailerWithResults;
            $scope.pickerList.push(retailerWithResults);
          }
          $timeout(() => $scope.$apply(), 0);
        }

        if ($scope.singleItemSelect) {
          $scope.findOnline = 0;
          $scope.showDesktopInStoreListing = false;
          $scope.productsOpen = false;

          // Toggle the Buy Online setting
          $scope.showDesktopBuyOnlineTab = !$scope.showDesktopBuyOnlineTab;
          $scope.selectStore(store.id);
          return;
        } else if ($scope.isMobile) {
          $scope.productsOpen = false;
        }

        if (cameFromProductCount == true || $scope.enableRetailerFilter == false) {
          try {
            document.querySelector('ul > li.nav-item:nth-child(2)')?.focus();
          } catch (e) {
            console.warn(e);
          }
          // if($scope.selectedStore != null){
          //TODO P decouple
          $scope.selectedUPCsForBuyOnline = [];
          $scope.selectedUPCs = [];
          $scope.availableRetailersForMultiSelect = [];

          store.availableUPCIds.forEach(upcId => {
            const foundProduct = $scope.getProductsToDisplay().find(product => product.id == upcId || (product.upcIds && product.upcIds.includes(upcId)));
            if (foundProduct) {
              $scope.toggleProductFilter(foundProduct);
            }
          })

          // Open products panel
          if (!$scope.singleItemSelect) {
            $scope.onProductFilterClickV2({ stopPropagation: () => {}, preventDefault: () => {} });
          }
          // }
        } else {
          if ($scope.selectedUPCsForBuyOnline.length == 0) {
            const retailerStores = $scope.stores.filter((s) => s.retailerId == store.retailerId);
            $scope.selectedUPCsForBuyOnline = [];
            $scope.selectedUPCs = [];
            $scope.availableRetailersForMultiSelect = [];

            retailerStores.forEach(retailerStore => {
              retailerStore.availableUPCIds.forEach(upcId => {
                const foundProduct = $scope.getProductsToDisplay().find(product => product.id == upcId || (product.upcIds && product.upcIds.includes(upcId)));
                if (foundProduct) {
                  $scope.toggleProductFilter(foundProduct);
                }
              })
            })

            if (!$scope.singleItemSelect) {
              $scope.onProductFilterClickV2({ stopPropagation: () => {}, preventDefault: () => {} });
            }
          }
        }
        $scope.filterSelectedRetailerId(store.retailerId);
        $scope.selectStore(store.id);
        $scope.pearLogicalUPCs.forEach((u) => (u.expanded = false));
        if ($scope.isMobile && $scope.pymChild) {
          $scope.pymChild.scrollParentToChildEl('where-to-buy');
        }
              } finally {
          // Re-enable map clicks after a delay
          $timeout(() => {
            $scope.preventMapClick = false;
          }, 500);
          
          $timeout(() => $scope.$apply(), 0);
        }
    });

    const markers = [];
    let updateMapPins = null;
    let started = false;
    const startMapAndStores = () => {
      if (started) {
        return;
      }
      started = true;
      if (document.getElementById('map')) {
        if (!MapLibrariesPreInject) {
          try {
            const src = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.js';
            let script = document.querySelector(`script[src="${src}"]`);
            if (!script) {
              script = document.createElement('script');
              script.src = src;
              document.head.appendChild(script);
            }
          } catch (e) {
            console.error(e);
          }

          let bootstrapLoaded = false;
          try {
            const href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css';
            let stylesheet = document.querySelector(`link[href="${href}"]`);
            if (!stylesheet) {
              stylesheet = document.createElement('link');
              stylesheet.href = href;
              stylesheet.rel = 'stylesheet';
              stylesheet.onload = function () {
                bootstrapLoaded = true;
              };
              document.head.appendChild(stylesheet);
            } else {
              bootstrapLoaded = true;
            }
          } catch (e) {
            console.error(e);
          }

          let maplibreCssLoaded = false;
          try {
            const href = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.css';
            let stylesheet = document.querySelector(`link[href="${href}"]`);
            if (!stylesheet) {
              stylesheet = document.createElement('link');
              stylesheet.href = href;
              stylesheet.rel = 'stylesheet';
              stylesheet.onload = function () {
                maplibreCssLoaded = true;
              };
              document.head.appendChild(stylesheet);
            } else {
              maplibreCssLoaded = true;
            }
          } catch (e) {
            console.error(e);
          }

          let locatorStylesLoaded = false;
          try {
            let templateCss = {
              1: null,
              2: '/css/product-locator-22-07.css',
              3: '/css/product-locator-12-11.css'
            }[getTemplateVersion($stateParams, $rootScope.WIDGET_CONFIG)];
            if (templateCss) {
              const href = templateCss + "?rev=" + $config['revision'];
              let stylesheet = document.querySelector(`link[href="${href}"]`);
              if (!stylesheet) {
                stylesheet = document.createElement('link');
                stylesheet.href = href;
                stylesheet.rel = 'stylesheet';
                stylesheet.onload = function () {
                  locatorStylesLoaded = true;
                };
                document.head.appendChild(stylesheet);
              } else {
                locatorStylesLoaded = true;
              }
            } else {
              locatorStylesLoaded = true;
            }
          } catch (e) {
            console.error(e);
          }
          MapLibrariesPreInject = {
            bootstrapLoaded: () => bootstrapLoaded,
            locatorStylesLoaded: () => locatorStylesLoaded,
            maplibreCssLoaded: () => maplibreCssLoaded,
          };
        }

        $timeout(
          $async(async function () {
            // Get container size to make map tab default when on desktop but container size is small
            // e.g. https://fourthandheart.com/pages/costco
            const isSmallSizeScreen = window && window.innerWidth > 992 ? false : true;

            $scope.storesDoneLoading = false;
            $scope.firstFullStoresFetchComplete = false;
            $scope.noStores = false;
            $scope.mapOnly = false;
            $scope.productsOpen = $scope.startWithProductFilterOpen;
            $scope.storeTypeCheck = true;

            // make map tab default if it is mobile, or if the container size is small on desktop
            // unless buyOnlineTabActive is set to true
            if (($scope.isMobileLayout || isSmallSizeScreen) && !$scope.singleItemSelect) {
              $scope.productsOpen = false;
              // Check if buyOnlineTabActive is set and buy online tab is not hidden
              if ($scope.buyOnlineTabActive && !$scope.hideBuyOnlineTab) {
                $scope.findOnline = 1;
                $scope.mapOnly = false;
              } else {
                $scope.findOnline = 0;
                $scope.mapOnly = true;
              }
            }

            const vendorId = $scope.vendor.id;

            if (
              $scope.productsOpen &&
              typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.default !== 'undefined'
            ) {
              $scope.selectCategory(ENRICHED_CATEGORY_CONFIG[vendorId].default);
            }

            $scope.toggleStoreCategory = (category) => {
              const is818 = ($scope.vendor || {}).id == 2012254479241504 ? true : false;
              if (is818 && $scope.storeCategories['Bar'] != null && category == 'Restaurant') {
                $scope.storeCategories['Bar'] = !$scope.storeCategories['Bar'];
              }
              $scope.storeCategories[category] = !$scope.storeCategories[category];

              updateMapPins(false);
            };

            const allProductsFetchedZips = [];
            let nextMaxZips = null;

            const PASS_FULL_AVAILABILTIES_IN_BODY = false;
            const FETCH_ALL_STORES_IN_PARALLEL = true;
            if ($scope.location && $scope.location.longitude && $scope.location.latitude) {
              const updateMapStores = async function (
                zipsNeedToFetchMore,
                selectedUPCs,
                first,
                lastOfZips,
                forceSingleFetch
              ) {
                const bounds = maplibregl.LngLatBounds.convert($scope.map.getBounds());
                const lat1 = bounds.getSouthWest().lat;
                const lng1 = bounds.getSouthWest().lng;
                const lat2 = bounds.getNorthEast().lat;
                const lng2 = bounds.getNorthEast().lng;

                var cLat1, cLng1;
                [cLng1, cLat1] = $scope.map.getCenter().toArray();

                //            selectedUPCs = (selectedUPCs && selectedUPCs.length) ? selectedUPCs : null;
                selectedUPCs = null;

                const retailerListByZipMin = Object.fromEntries(
                  Object.entries(retailerListsByZipAndSelectedUPCs).map(([zip, retailerListsBySelectedUPCs]) => {
                    retailerListsBySelectedUPCs = retailerListsBySelectedUPCs || {};
                    let rs = null;

                    if (retailerListsBySelectedUPCs['null']) {
                      rs = retailerListsBySelectedUPCs['null'];
                    }

                    if (rs != null) {
                      rs = rs.map((r) => {
                        r = Object.assign({}, r);
                        r.upcs = PASS_FULL_AVAILABILTIES_IN_BODY
                          ? (r.upcs || [])
                              .filter((upc) => upc.status == 'AVAILABLE' || upc.inStoreStatus == 'AVAILABLE')
                              .map((upc) => Util.keepTruthy(Util.keepKeys(upc, ['id'])))
                          : null;
                        return Util.keepKeys(r, ['id', 'upcs']);
                      });
                    }

                    return [zip, rs];
                  })
                );

                let curStores = [...$scope.stores];
                let curStoreIds = curStores.map((s) => s.id);

                const numUPCs = UPCSAndOffer.UPCs.length;
                const baseZips = Math.min(
                  +(AppConfig['client-store-locator'] || {})['zip-batch-size-max'] || 16,
                  Math.max(1, Math.round(25 - numUPCs / 75))
                );

                const maxZipsByUPCSize = Math.max(
                  2,
                  Math.min(
                    +(AppConfig['client-store-locator'] || {})['zip-batch-size-max'] || 16,
                    30 - Math.floor(numUPCs / 60)
                  )
                );

                if (nextMaxZips == null) {
                  nextMaxZips = Math.min(baseZips, maxZipsByUPCSize);
                }
                const maxZips = nextMaxZips;
                if (first) {
                  nextMaxZips += 1;
                } else if (nextMaxZips < maxZipsByUPCSize) {
                  nextMaxZips += Math.min(maxZipsByUPCSize - nextMaxZips, baseZips);
                }

                const promise =
                  (lat1 &&
                    lng1 &&
                    lat2 &&
                    lng2 &&
                    first &&
                    FirstStoresForLocationPromiseWrapper &&
                    (UPCSAndOffer.offer || {}).id == (UPCSAndOffer.vendor || {}).id &&
                    FirstStoresForLocationPromiseWrapper.promise) ||
                  (forceSingleFetch &&
                    ParallelStoresForLocationPromiseWrapper &&
                    ParallelStoresForLocationPromiseWrapper[JSON.stringify(zipsNeedToFetchMore)]) ||
                  $api.getStoresForLocation(
                    lat1,
                    lng1,
                    lat2,
                    lng2,
                    $stateParams.vendorId,
                    first,
                    zipsNeedToFetchMore || !first ? null : $scope.location.zip || $stateParams.zip,
                    first ? null : retailerListByZipMin,
                    curStoreIds,
                    forceSingleFetch ? zipsNeedToFetchMore.length : maxZips,
                    selectedUPCs,
                    zipsNeedToFetchMore,
                    (UPCSAndOffer.offer || {}).id,
                    $stateParams.countryCode
                  );
                const resp = (promise && (await promise)) || {};
                $scope.$apply();

                // Need to take from $scope.stores again because during the await, we may have had other endpoints complete
                curStores = [...$scope.stores];
                curStoreIds = curStores.map((s) => s.id);

                let needToFetchMoreZips = [];

                const storesToAdd = resp.stores || [];
                const potentialZips = resp.potentialZips || [];
                const skippedZips = resp.skippedZips || [];
                const fetchedZips = resp.fetchedZips || [];

                if (!selectedUPCs) {
                  fetchedZips.forEach((fetchedZip) => {
                    if (allProductsFetchedZips.indexOf(fetchedZip) == -1) {
                      allProductsFetchedZips.push(fetchedZip);
                    }
                  });
                }

                const zipToPickerRetailers = expandCondensedZipRetailerList(resp.availabilities || {});

                const postProcessMapTriggers = (first, lastOfZips, allowSelectStore) => {
                  if (!first && lastOfZips) {
                    $scope.storesDoneLoading = true;
                    $scope.firstFullStoresFetchComplete = true;
                  }

                  if ($scope.storesDoneLoading && $scope.shownStores.length) {
                    $scope.firstFullStoresFetchComplete = true;
                    if (!setInitial) {
                      if ($scope.shownStores.length == 0) {
                        $scope.findOnline = true;
                        $scope.mapOnly = false;
                      } else if ($scope.pinUPCIdsToTop.length >= 1) {
                        $scope.findOnline = true;
                      }

                      setInitial = true;
                    }
                  }
                  $scope.storesDoneLoading = true;

                  if ($scope.firstFullStoresFetchComplete) {
                    $timeout(() => {
                      $timeout(() => {
                        $scope.renderImages = true;
                      }, 1000);
                      if (
                        firstMarker &&
                        $scope.shownStores.length &&
                        (lastOfZips || $scope.shownStores[0].distanceMiles < 0.15)
                      ) {
                        $scope.selectStore(
                          $scope.shownStores[0].id,
                          null,
                          null,
                          $scope.shownStores[0].distanceMiles > 0.5
                        );
                        firstMarker = false;
                      }
                    }, 1);
                  } else if (lastOfZips && !$scope.firstFullStoresFetchComplete) {
                    initRetailerList(null, false, $scope.location.zip, null, false, false);
                  }
                };

                if (Array.isArray(storesToAdd)) {
                  const toAddStoreIds = storesToAdd.map((s) => s.id);

                  const newStoresToAdd = [];
                  storesToAdd
                    .forEach((s) => {
                      var idNew = curStoreIds.indexOf(s.id) == -1;
                      var storeIdNew = curStores.find(cs => cs.retailerId == s.retailerId && cs.storeId == s.storeId) == null;
                      var storeIdNotDuped = newStoresToAdd.find(cs => cs.retailerId == s.retailerId && cs.storeId == s.storeId) == null;

                      if (idNew && storeIdNew && storeIdNotDuped) {
                        newStoresToAdd.push(s);
                      }
                    });

                  // Check that available upcIds per store matches what we have on buy online
                  newStoresToAdd.forEach((nextStore) => {
                    if (nextStore.synthetic || !nextStore.availableUPCIds) {
                      return;
                    }

                    let retailerList = (zipToPickerRetailers || {})[nextStore.zip] || [];
                    retailer = retailerList.filter((r) => r.id == nextStore.retailerId)[0];
                    if (retailer) {
                      let actualAvailableUPCS = retailer.upcs
                        .filter(
                          (upc) =>
                            upc.inStoreStatus == 'AVAILABLE' ||
                            (upc.status == 'AVAILABLE' && upc.shipToHomeStatus != 'AVAILABLE')
                        )
                        .map((upc) => upc.id);

                      let newStoreavailableUPCIds = nextStore.availableUPCIds.filter(
                        (upcId) => actualAvailableUPCS.indexOf(upcId) != -1
                      );

                      nextStore.availableUPCIds = newStoreavailableUPCIds;
                    }
                  });

                  // NOTE: since we are limiting results by zip code, we need to add any new available upcIds that we get
                  // from stores that come back down
                  curStores.forEach((curStore) => {
                    let replacementStore = storesToAdd.filter((storeToAdd) => {
                      if (storeToAdd.id == curStore.id && storeToAdd.storeId == curStore.storeId) {
                        if (storeToAdd.nearbyZip) {
                          return storeToAdd.nearbyZip == curStore.nearbyZip;
                        } else if (!storeToAdd.nearbyZip && !curStore.nearbyZip) {
                          return storeToAdd.zip == curStore.zip;
                        } else {
                          return storeToAdd.zip == curStore.zip;
                        }
                      }
                      return false;
                    })[0];

                    if (typeof replacementStore != 'undefined') {
                      let newAvailUPCIds = [...curStore.availableUPCIds];
                      replacementStore.availableUPCIds.forEach((upcId) => {
                        if (curStore.availableUPCIds.indexOf(upcId) == -1) {
                          newAvailUPCIds.push(upcId);
                        }
                      });
                      if (newAvailUPCIds.length != curStore.availableUPCIds.length) {
                        curStore.availableUPCIds = newAvailUPCIds;
                      }
                    }
                  });

                  const next = [...curStores, ...newStoresToAdd];

                  const NUM_TO_KEEP_UNSORTED = $scope.firstFullStoresFetchComplete ? 0 : 4;
                  const unsortedNext = [...next.splice(0, NUM_TO_KEEP_UNSORTED)];
                  const sortedNext = [...next.splice(0)];

                  const getUPCQtyScore = (a) =>
                    ((a.noUPCLevelData && 1) || a.availableUPCIds.length) - toAddStoreIds.indexOf(a.id) / 100;
                  //const getNameAndCount = s => s.id + "/" + getUPCQtyScore(s) + " (" + s.noUPCLevelData + ")"

                  newStoresToAdd.forEach((store) => {
                    if (typeof store.shortName == 'undefined') {
                      store.shortName = store.name;
                      if (store.shortName && store.retailerName) {
                        if (store.shortName == store.retailerName) {
                          store.shortName = null;
                        } else if (store.shortName.indexOf(store.retailerName) == 0) {
                          store.shortName = store.shortName.substring(store.retailerName.length + 1);
                        }
                      }
                    }

                    if (typeof store.shortAddress == 'undefined') {
                      let address = store.address || '';
                      const unitedStatesIdx = address.indexOf(', United States');
                      if (unitedStatesIdx != -1) {
                        address = address.substring(0, unitedStatesIdx);
                      }
                      store.shortAddress = address;

                      const lastCommaIdx = address.indexOf(',');
                      if (lastCommaIdx != -1) {
                        store.shortAddress1 = address.substring(0, lastCommaIdx);
                        store.shortAddress2 = address.substring(lastCommaIdx + 2);
                      } else {
                        store.shortAddress1 = address;
                        store.shortAddress2 = null;
                      }
                    }

                    const BAD_LOGO_URLS = [
                      'https://www.sendiks.com/wp-content/themes/sendiks/resources/images/logo/logo.png',
                    ];

                    if (BAD_LOGO_URLS.indexOf(store.logoUrl) != -1) {
                      store.logoUrl = null;
                    }
                  });

                  sortedNext.forEach((store) => {
                    const distanceMiles = Util.distanceMiles(cLat1, cLng1, store.latitude, store.longitude);
                    if (
                      typeof store.distanceMiles == 'undefined' ||
                      Math.abs(store.distanceMiles - distanceMiles) > 0.15
                    ) {
                      store.distanceMiles = distanceMiles;
                      store.distanceMilesRounded = Math.round(store.distanceMiles * 10) / 10;
                    }
                  });

                  sortedNext.sort((a, b) => {
                    const milesApart = a.distanceMilesRounded - b.distanceMilesRounded;
                    if (milesApart != 0) {
                      return milesApart;
                    }
                    return getUPCQtyScore(b) - getUPCQtyScore(a);
                  });
                  // now we're ready to set $scope.stores
                  $scope.stores = [...unsortedNext, ...sortedNext];

                  $scope.storeCategories = $scope.storeCategories || {};
                  for (let i = 0; i < $scope.stores.length; i++) {
                    let store = $scope.stores[i];
                    if (store.id > 0 && !store.category) {
                      store.category = 'Retailer';
                    }
                  }
                  new Set($scope.stores.filter((store) => store.category).map((store) => store.category)).forEach(
                    (category) => {
                      if (typeof $scope.storeCategories[category] == 'undefined') {
                        $scope.storeCategories[category] = true;
                      }
                    }
                  );
                  $scope.storeCategoryNames = Object.keys($scope.storeCategories);
                  if ($scope.vendorId == 2012254479241504) {
                    $scope.storeCategoryNames = ['Restaurant', 'Retailer'];
                  }
                  updateMapPins(true, first);

                  postProcessMapTriggers(first, lastOfZips, true);
                  $scope.$apply();
                }

                // needToFetchMoreZips = zipsForRegion.filter(zip => {
                //   return Object.entries(retailerListsByZipAndSelectedUPCs).filter(([_zip, retailerList]) => {
                //     if (_zip != zip) {
                //       return false;
                //     }
                //     const retailerListsBySelectedUPCs = retailerListsByZipAndSelectedUPCs[zip];
                //     let cachedRetailerList = null;
                //     if (retailerListsBySelectedUPCs[`${null}`]) {
                //       cachedRetailerList = retailerListsBySelectedUPCs[`${null}`];
                //     } else if (selectedUPCs) {
                //       Object.entries(retailerListsBySelectedUPCs).forEach(([upcs, retailerList]) => {
                //         if (selectedUPCs.filter(selectedUPC => upcs.indexOf(selectedUPC) == -1).length == 0) {
                //           cachedRetailerList = retailerList;
                //         }
                //       })
                //     }
                //     return cachedRetailerList && cachedRetailerList.length;
                //   }).length == 0;
                // });
                if (first) {
                  needToFetchMoreZips =
                    FETCH_ALL_STORES_IN_PARALLEL && PotentialStoreZipsForLocation
                      ? PotentialStoreZipsForLocation.zips
                      : potentialZips;
                } else {
                  needToFetchMoreZips = skippedZips;

                  const potentialNeedToFetchMoreZips = potentialZips;
                  if (!selectedUPCs) {
                    allProductsFetchedZips.forEach((fetchedZip) => {
                      const idx = needToFetchMoreZips.indexOf(fetchedZip);
                      if (idx != -1) {
                        needToFetchMoreZips.splice(idx, 1);
                      }
                      const potentialIdx = potentialNeedToFetchMoreZips.indexOf(fetchedZip);
                      if (potentialIdx != -1) {
                        potentialNeedToFetchMoreZips.splice(potentialIdx, 1);
                      }
                    });
                  }
                }

                needToFetchMoreZips = needToFetchMoreZips.filter((_zip) => !!_zip && _zip != 'null');

                if (!forceSingleFetch) {
                  if (FETCH_ALL_STORES_IN_PARALLEL) {
                    if (needToFetchMoreZips.length) {
                      let boundUpdateMapStores = updateMapStores.bind(this);
                      setTimeout(async function () {
                        const zipBatches =
                          (first &&
                            FETCH_ALL_STORES_IN_PARALLEL &&
                            PotentialStoreZipsForLocation &&
                            PotentialStoreZipsForLocation.zipBatches) ||
                          Util.partition(
                            needToFetchMoreZips,
                            Math.min(16, Math.max(7, Math.floor(needToFetchMoreZips.length / 2)))
                          );
                        const promises = zipBatches.map((zipsBatch) => {
                          return boundUpdateMapStores(zipsBatch, selectedUPCs, false, zipBatches.length == 1, true);
                        });

                        if (promises.length) {
                          ret = await Promise.race(promises);
                          $scope.$apply();
                        }
                        ret = await Promise.all(promises);
                        $scope.$apply();
                        postProcessMapTriggers(false, true, true);
                        $scope.$apply();
                      }, 0);
                    }
                  } else {
                    if (needToFetchMoreZips.length) {
                      $timeout(
                        updateMapStores.bind(
                          this,
                          first ? null : needToFetchMoreZips,
                          selectedUPCs,
                          false,
                          !first || needToFetchMoreZips.length <= nextMaxZips
                        ),
                        0
                      );
                      if (selectedUPCs) {
                        $timeout(
                          updateMapStores.bind(
                            this,
                            first ? null : needToFetchMoreZips,
                            null,
                            false,
                            !first || needToFetchMoreZips.length <= nextMaxZips
                          ),
                          10
                        );
                      }
                    } else if (!$scope.firstFullStoresFetchComplete) {
                      $scope.firstFullStoresFetchComplete = true;
                      $timeout(updateMapStores.bind(this, null, selectedUPCs, false, !selectedUPCs), 0);
                      if (selectedUPCs) {
                        $timeout(updateMapStores.bind(this, null, null, false, true), 10);
                      }
                    }
                  }
                }
              };

              const cfg   = $rootScope.WIDGET_CONFIG || {};
              const theme = cfg.theme === 'dark' ? 'dark' : 'light';
              
              // Checkserver style (to see if it's named "Monochrome")
              const serverStyle = await getServerStyleObject(MapStylesJson);
              const wantGrayscale = !!(serverStyle && serverStyle.name === 'Monochrome');
              
              // Pick a usable style: server vector if valid, else Stadia vector by theme
              const styleToUse = await resolveVectorStyle({
                MapStylesJson,
                theme,
                apiKey: STADIA_MAPS_CONFIG.API_KEY
              });
              
              const injectMap = $async(async () => {
                while (
                  !window.maplibregl ||
                  !MapLibrariesPreInject.locatorStylesLoaded() ||
                  !MapLibrariesPreInject.bootstrapLoaded()
                ) {
                  await Util.timeout(10);
                }
                maplibregl = window.maplibregl;

                $scope.showMapContent = true;
                const map = ($scope.map = new maplibregl.Map({
                  container: 'map',
                  style: styleToUse,
                  center: { 
                    lng: $scope.location.longitude,
                    lat: $scope.location.latitude,
                  },
                  pixelRatio: 1,
                  renderWorldCopies: false,
                  prefetchZoomDelta: 0,
                  transformRequest: (url) => {
                    try {
                      const u = new URL(url, window.location.origin);
                      if (u.hostname.endsWith('tiles.stadiamaps.com') && !u.searchParams.has('api_key')) {
                        u.searchParams.set('api_key', STADIA_MAPS_CONFIG.API_KEY);
                        return { url: u.toString() };
                      }
                    } catch (e) {}
                    return { url };
                  },
                  zoom: ($scope.isMobile ? ($scope.defaultZoom || 13) + 0.5 : ($scope.defaultZoom || 13.5) + 1) || 13.5,
                  attributionControl: { compact: true, customAttribution: '© Stadia Maps' }
                }));

                applyMapCanvasFilter(map, wantGrayscale ? 'grayscale(100%)' : '');
                applyGranularityTweaks(map, {
                  minorRoadsMinZoom: 14,
                  tertiaryMinZoom:   14,
                  streetNamesMinZoom:14,   // push most road names later
                  parksMinZoom:      13,   // small ranked parks appear a bit later
                  smallParkRankMin:  2,
                  landuseMinZoom:    15,   // hide beige “houses” until ~15
                });
                if (theme === 'light') {
                  applyLightModeMapTweaks(map);
                }
                
                // Store map instance globally for autocomplete directive access
                window.currentMap = map;

                updateMapStores(null, $scope.selectedUPCs,true, null);
                updateMapStores(null, $scope.selectedUPCs,false, null, false);
                const nav = new maplibregl.NavigationControl({
                  showCompass: false,
                  showZoom: true,
                  visualizePitch: false,
                });
                map.addControl(nav, 'bottom-right');
                map.dragRotate.disable();
                map.touchZoomRotate.disableRotation();
                // disable map zoom when using scroll
                if ($rootScope.inIframe) {
                  map.scrollZoom.disable();
                }

                if ($scope.map.loaded()) {
                  initializeMapLibre();
                  $scope.addressChange = false;
                } else {
                  $scope.map.on('load', initializeMapLibre);
                }
              });

              updateMapPins = function (fromStoreUpdate, first) {
                const buildMarker = (lnglat, store) => {
                  let markerClone = document.querySelector('.map-container>.store-marker').cloneNode(true);
                  const is818 = ($scope.vendor || {}).id == 2012254479241504 ? true : false;
                  markerClone.style.display = 'block';
                  markerClone.setAttribute('aria-hidden', 'true');
                  markerClone.removeAttribute('aria-label');
                  if ($scope.vendorProvidedPin == null) {
                    if (!is818) {
                      const markerImg = markerClone.querySelector('.retailer-logo img.logo-color');
                      let img = $scope.showLogo(store);
                      markerImg.src = img;
                    } else {
                      if (store.category != 'Bar' && store.category != 'Restaurant') {
                        const svgClone = markerClone.querySelector('.svg-retailer');
                        markerClone = markerClone.querySelector('.svg-retailer') || markerClone;
                      }
                      if (store.category == 'Bar' || store.category == 'Restaurant') {
                        const svgClone = markerClone.querySelector('.svg-restaurant');
                        markerClone = markerClone.querySelector('.svg-restaurant') || markerClone;
                      }
                    }
                  }
                  var marker = new maplibregl.Marker({ element: markerClone }).setLngLat(lnglat);

                  markerClone.addEventListener('click', (e) => {
                    $scope.selectStore(store.id);
                    e.stopPropagation();
                  });

                  marker.storeId = store.id;
                  markers.push(marker);
                  return marker;
                };

                const buildMarkersAndShowPins = function () {
                  // create/updates $scope.shownStores  *** SHOULD I BE WORRIED ABOUT GLOBAL VAR in SCOPE AND THREDS
                  for (let i = 0; i < $scope.stores.length; i++) {
                    const store = $scope.stores[i];
                    try {
                      if (store && typeof store.marker == 'undefined') {
                        store.marker = buildMarker(new maplibregl.LngLat(store.longitude, store.latitude), store);
                      }
                    } catch (e) {
                      console.error(`Error building marker for store ${store.id} ${store.name}`, store, e);
                    }
                  }
                  showPinsByUPC(fromStoreUpdate);
                };

                if (first) {
                  $timeout(buildMarkersAndShowPins, 0);
                } else {
                  buildMarkersAndShowPins();
                }
              };

              const initializeMapLibre = async () => {
                $timeout(() => {
                  $scope.map.resize();
                  $scope.mapLoaded = true;
                  
                  // Force attribution to stay closed
                  setTimeout(() => {
                    const attribControl = document.querySelector('.maplibregl-ctrl-attrib');
                    if (attribControl) {
                      attribControl.classList.add('maplibregl-compact');
                      attribControl.classList.remove('maplibregl-compact-show');
                      
                      // Force the details element to be closed
                      const detailsElement = attribControl.querySelector('details');
                      if (detailsElement) {
                        detailsElement.removeAttribute('open');
                        detailsElement.style.display = 'none';
                      }
                      
                      // Hide any expanded content
                      const innerContent = attribControl.querySelector('.maplibregl-ctrl-attrib-inner');
                      if (innerContent) {
                        innerContent.style.display = 'none';
                      }
                      
                      // Force only the specific styles you want
                      attribControl.style.setProperty('background-color', 'inherit', 'important');
                      attribControl.style.setProperty('min-height', '0', 'important');
                      attribControl.style.setProperty('margin', '0 10px', 'important');
                    }
                    const attribButton = document.querySelector('.maplibregl-ctrl-attrib-button');
                    if (attribButton) {
                      attribButton.style.display = 'none';
                    }
                  }, 0);

                  const debouncedUpdateMapStores = Util.debounce(updateMapStores, 1200, true);

                  // Change the cursor to a pointer when the mouse is over the places layer.
                  $scope.map.on('mouseenter', 'places', () => {
                    $scope.map.getCanvas().style.cursor = 'pointer';
                  });

                  // Change it back to a pointer when it leaves.
                  $scope.map.on('mouseleave', 'places', () => {
                    $scope.map.getCanvas().style.cursor = '';
                  });

                  let flying = false;
                  const onChange = () => {
                    if (!flying) {
                      if ($scope.firstFullStoresFetchComplete) {
                        debouncedUpdateMapStores(null, $scope.selectedUPCs);
                      }
                    }
                  };

                  $scope.map.on('dragend', onChange);

                  $scope.map.on('moveend', function () {
                    if (flying) {
                      $scope.map.fire('flyend');
                    }
                  });
                  $scope.map.on('flystart', function () {
                    flying = true;
                  });

                  $scope.map.on('flyend', function () {
                    flying = false;
                  });

                  let startZoom = 0;
                  $scope.map.on('zoomstart', function (e) {
                    startZoom = $scope.map.getZoom();
                  });

                  $scope.map.on('zoomend', function (e) {
                    // Make a guess at the change in pin scale
                    updatePinScale($scope.countVisible, $scope.map.getZoom());
                    onChange();
                  });
                }, 0);
                // Safely set tabindex on map elements if they exist
                const mapCanvas = document.querySelector('.map-container canvas');
                if (mapCanvas) {
                  mapCanvas.setAttribute('tabindex', -1);
                }
                
                const mapLogo = document.querySelector('.maplibregl-ctrl-logo');
                if (mapLogo) {
                  mapLogo.setAttribute('tabindex', -1);
                }
                
                const mapAttribButton = document.querySelector('.maplibregl-ctrl-attrib-button');
                if (mapAttribButton) {
                  mapAttribButton.setAttribute('tabindex', -1);
                }
              };

              injectMap();
              $scope.vistedMapElements = false;
              $scope.focuseInStoreTab = false;
              $scope.visitedLastProductTile = false;
              $scope.cameFromAddress = false;

              $scope.$watch('addressChange', function () {
                $timeout(() => {
                  if ($scope.addressChange == true) {
                    $scope.addressChange = false;
                  }
                }, 1000);
              });

              $rootScope.$on('$locationChangeSuccess', function () {
                document.querySelector('#floatingInput').focus();
              });

              $scope.$watch('selectedUPCs', function (newVal, oldVal) {
                if (showPinsByUPC && $scope.storesDoneLoading) {
                  showPinsByUPC();
                }
              }, true);

              $scope.$watch('filterSelectedRetailerIds.length', function (newVal, oldVal) {
                if (showPinsByUPC && $scope.storesDoneLoading) {
                  showPinsByUPC();
                }
              });

              $scope.$watch('shownStores.length', function () {
                $timeout(() => {
                  scrollToStoreInList($scope.selectedStore, false);
                }, 0);
                $timeout(() => {
                  $scope.storeLengthAnnouncment = $scope.shownStores.length;
                }, 4000);
              });

              $scope.$watch('shownStores', function () {
                if ($scope.selectedStore) {
                  // id property is unique in shownStores array
                  const storeIds = $scope.shownStores.map((x) => x.id);
                  const findIndexOfStore = (element) => element === $scope.selectedStore.id;
                  const selectedStoreIndex = storeIds.findIndex(findIndexOfStore);
                  const selectedStorePageNumber = Math.floor(selectedStoreIndex / $scope.shownStoresPageSize);
                  if ($scope.shownStoresCurrentPage != selectedStorePageNumber) {
                    $scope.shownStoresCurrentPage = selectedStorePageNumber;
                  }
                }
              });

              $scope.$watch('selectedStore', function () {
                if ($scope.selectedStore) {
                  // id property is unique in shownStores array
                  const storeIds = $scope.shownStores.map((x) => x.id);
                  const findIndexOfStore = (element) => element === $scope.selectedStore.id;
                  const selectedStoreIndex = storeIds.findIndex(findIndexOfStore);
                  const selectedStorePageNumber = Math.floor(selectedStoreIndex / $scope.shownStoresPageSize);
                  if ($scope.shownStoresCurrentPage != selectedStorePageNumber) {
                    $scope.shownStoresCurrentPage = selectedStorePageNumber;
                  }
                  if (!$scope.isMobileLayout) {
                    const popupCloseButton = document.querySelector('.maplibregl-popup-close-button');
                    if (popupCloseButton) {
                      popupCloseButton.setAttribute('tabindex', '-1');
                    }
                  } else if ($scope.isMobile) {
                    const popupCloseButton = document.querySelector('.maplibregl-popup-close-button');
                    if (popupCloseButton) {
                      popupCloseButton.style.display = 'none';
                    }
                  }
                  $scope.hoverStore($scope.selectedStore.id);
                }
              });

              $scope.$watch('selectedStore', function () {
                if ($scope.selectedStore !== $scope.hoveredStore) {
                  $timeout(() => {
                    scrollToStoreInList($scope.selectedStore, true);
                  }, 0);
                }
              });
            }
          }),
          0
        );
      }
    };
    // NOTE: non-preload avoids injecting the iframe altogether, so we don't need to wait for the start event
    if (false && $rootScope.inIframe && !isSafari) {
      $rootScope.pymChild.onMessage('start-map-and-stores', (json) => {
        startMapAndStores();
      });
    } else {
      startMapAndStores();
    }

    // Map Pan Controls - Functions to move map up down left and right
    $scope.moveMap = function (direction) {
      function easing(t) {
        return t * (2 - t);
      }

      if (direction === 'up') {
        $scope.map.panBy([0, -100], {
          easing: easing,
        });
      } else if (direction === 'down') {
        $scope.map.panBy([0, 100], {
          easing: easing,
        });
      } else if (direction === 'left') {
        $scope.map.panBy([-100, 0], {
          easing: easing,
        });
      } else if (direction === 'right') {
        $scope.map.panBy([100, 0], {
          easing: easing,
        });
      }
    };

    $scope.myLocation = function () {
      const options = { enableHighAccuracy: true, maximumAge: 0 };
      if (navigator.geolocation && false) {
        navigator.geolocation.getCurrentPosition(
          async function (position) {
            const {
              latitude,
              longitude,
            } = position.coords;

            let zip;
            let address;

            try {
              // Use Stadia Maps geocoding
              // Check cache first
              const cacheParams = {
                point_lat: latitude,
                point_lon: longitude
              };
              
              const cached = geocodingCache.get('/reverse', cacheParams);
              if (cached) {
                return cached;
              }
              
              const rsp = await fetchWithFallback(getReverseGeocodingUrls, STADIA_MAPS_CONFIG, latitude, longitude);

              if (rsp.features && rsp.features[0]?.properties?.postcode) {
                zip = rsp.features[0].properties.postcode;
                address = rsp.features[0].properties.display_name || rsp.features[0].properties.name;
                
                // Cache the result
                const result = { zip, address };
                geocodingCache.set('/reverse', cacheParams, result);
              }
            } catch (error) {
              console.error('Geocoding error:', error);
            }

            $state.go(
              $state.current,
              {
                zip: zip,
                latitude: $scope.location.latitude,
                longitude: $scope.location.longitude,
                address: address,
              },
              {
                location: true,
                reload: false,
              }
            );
            return;
          },
          function (error) {
            console.error(error);
          },
          options
        );
      }
    };

    let geocoder = null;
    $scope.submitLocation = $async(async function () {
      if ($scope.addressChange) return;

      // Check if we have location data
      if (!$scope.location.location && !$scope.location.zip && !$scope.location.latitude) {
        // Try to get location data from session if local scope is empty
        if ($rootScope.session && $rootScope.session.location) {
          $scope.location = {
            location: $rootScope.session.location,
            latitude: $rootScope.session.latitude,
            longitude: $rootScope.session.longitude,
            zip: $rootScope.session.zip,
            coordinatesLocation: $rootScope.session.coordinatesLocation,
            countryCode: $rootScope.session.countryCode
          };
        } else {
          return;
        }
      }

      $scope.addressChange = true;

      // If we already have a zip code, use it directly
      if ($scope.location.zip) {
        const params = Object.assign({}, $stateParams, {
          zip: ($scope.location.countryCode && $scope.location.countryCode == 'AU' ? 'AU' : '') + $scope.location.zip,
          latitude: $scope.location.latitude,
          longitude: $scope.location.longitude,
          address: $scope.location.location,
          countryCode: $scope.location.countryCode,
        });
        $state.go($state.current, params, {
          location: true,
          reload: false,
        });
        return;
      }
      
      // If we have coordinates, try to get zip from them
      if ($scope.location.latitude && $scope.location.longitude) {
        const zip = await getZipFromCoordinates(
          $scope.location,
          (text) => getZipFromForwardGeocoding(text, STADIA_MAPS_CONFIG, geocodingCache),
          (text) => getZipFromLocationSearch(
            text,
            STADIA_MAPS_CONFIG,
            geocodingCache,
            (lat, lng) => getZipFromReverseGeocoding(lat, lng, STADIA_MAPS_CONFIG, geocodingCache)
          )
        );
        if (zip) {
          updateLocationWithZip(zip, $scope, $state);
          return;
        }
      }
      
      // If we get here, we couldn't resolve a location
      console.warn('Unable to resolve location from available data');
    });

    if ($rootScope.inIframe) {
      $rootScope.pymChild.sendMessage('picker-loaded', 'pear');

      $rootScope.pymChild.onMessage('inject-widget-config', (json) => {
        const config = JSON.parse(json);
        injectWidgetConfig(config);
      });

      $scope.productsOpen = false;
    }

    const larabarCategories = {
      Lemon: [
        { units: '6', upcId: 2073683659213440 },
        { units: '16', upcId: 2073683687459456 },
      ],
      'Chocolate Chip Cookie Dough': [
        { units: '6', upcId: 2073684096248448 },
        { units: '8', upcId: 2073683718777472 },
        { units: '12', upcId: 2073683717401216 },
        { units: '16', upcId: 2073683701836416 },
        { units: '18', upcId: 1740605436627808 },
      ],
      'Double Chocolate Truffle': [
        { units: '6', upcId: 2073684094388868 },
        { units: '8', upcId: 2073684094626436 },
      ],
      'Peanut Butter Chocolate Chip': [{ units: '6', upcId: 2073683655830144 }],
    };
    const larabarCategoryKeys = Object.keys(larabarCategories);
    let larabarCache = {};

    $scope.larabarMultiDisplay = function (retailer) {
      if (larabarCache[retailer.nameEnum]) {
        return larabarCache[retailer.nameEnum];
      }
      let itemToSizeMap = {};
      for (let k = 0; k < larabarCategoryKeys.length; k++) {
        let category = larabarCategoryKeys[k];
        for (let j = 0; j < larabarCategories[category].length; j++) {
          for (let i = 0; i < retailer.upcs.length; i++) {
            let categoryEntry = larabarCategories[category][j];
            if (categoryEntry.upcId == retailer.upcs[i].id) {
              if (!itemToSizeMap[category]) {
                itemToSizeMap[category] = [];
              }
              itemToSizeMap[category].push({
                units: categoryEntry.units,
                upc: retailer.upcs[i],
                category: category,
              });
              break;
            }
          }
        }
      }
      let ret = [];
      for (let category of Object.keys(larabarCategories)) {
        if (itemToSizeMap[category]) {
          ret.push(itemToSizeMap[category]);
        }
      }
      if (ret.length > 0) {
        larabarCache[retailer.nameEnum] = ret;
      }
      return ret;
    };
  };

  const modificationController = function (
    $scope,
    UPCS,
    UPCSAndOffer,
    $stateParams,
    RetailerListInit,
    $timeout,
    $api,
    $rootScope,
    LocationData,
    $state,
    isMobile,
    PageLoad,
    $interval,
    $sce,
    $q
  ) {
    pickerController(
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      null,
      null,
      $sce,
      null,
      null,
      $q
    );
    if ($rootScope.pymChild) {
      $rootScope.pymChild.onMessage('reload', $state.reload);
    }
  };

  const getRetailerListInitPromise = function (
    $scope,
    $api,
    $stateParams,
    SetSession,
    zip,
    selectedUPCs,
    asyncResolveFalse,
    pearclid,
    UPCSAndOffer
  ) {
    async function failureRetailerList() {
      try {
        let LocationData = await $api.getZipLocationData(zip);
        return await (
          await fetch(
            'https://assets-cf.pearcommerce.com/retailer-list/' +
              UPCSAndOffer.offer.id +
              '/' +
              LocationData.region_code +
              '?' +
              new Date().getTime()
          )
        ).json();
      } catch (e) {
        return [];
      }
    }
    asyncResolveFalse = !!asyncResolveFalse;
    const t = new Date().getTime();
    let offerIdVar = null;
    if (UPCSAndOffer.offer) {
      offerIdVar = UPCSAndOffer.offer.id;
    }

    const includePrice = $scope.shouldShowPrice();
    let retailerListUrl = offerIdVar
      ? '/v1/retailer-list/' +
        offerIdVar +
        '?asyncResolveDeep=' +
        !asyncResolveFalse +
        '&t=' +
        t +
        ($stateParams.pb || $stateParams.mode
          ? '&zip=55408'
          : zip
          ? '&zip=' + zip
          : $stateParams.zip
          ? '&zip=' + $stateParams.zip
          : '') +
        ($stateParams.cold ? '&cold=' + $stateParams.cold : '') +
        ($stateParams.include ? '&include=' + $stateParams.include : '') +
        ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
        ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
        ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
        ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
        ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : '') +
        ($stateParams.promo_text ? '&promo_text=true' : '') +
        (pearclid ? '&pearclid=' + pearclid : '') +
        ('&selectedUPCs=' + encodeURIComponent(JSON.stringify(selectedUPCs || null))) +
        (includePrice ? '&include_price=true' : '') +
        ''
      : '/v1/retailer-list-by-vendor/' +
        $stateParams.vendorId +
        '?asyncResolveDeep=' +
        !asyncResolveFalse +
        '&t=' +
        t +
        ($stateParams.pb || $stateParams.mode
          ? '&zip=55408'
          : zip
          ? '&zip=' + zip
          : $stateParams.zip
          ? '&zip=' + $stateParams.zip
          : '') +
        ($stateParams.cold ? '&cold=' + $stateParams.cold : '') +
        ($stateParams.include ? '&include=' + $stateParams.include : '') +
        ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
        ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
        ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
        ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
        ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : '') +
        ($stateParams.promo_text ? '&promo_text=true' : '') +
        (pearclid ? '&pearclid=' + pearclid : '') +
        ('&selectedUPCs=' + encodeURIComponent(JSON.stringify(selectedUPCs || null))) +
        '';
    return $api
      .get(retailerListUrl, { credentials: 'include', withCredentials: true, failure: failureRetailerList })
      .then((response) => {
        if (!response || response.error || response.stack) {
          return [];
        } else {
          if (window.location.href.indexOf('liquiddeath') > -1) {
            const magicRetailers = ['whole foods', '7now', 'publix', 'gopuff', '7-eleven'];
            response.sort((a, b) => {
              let magicRetailerA = false;
              let magicRetailerB = false;
              magicRetailers.forEach((magicRetailer) => {
                if (a.name && a.name.toLowerCase().indexOf(magicRetailer) > -1) {
                  magicRetailerA = true;
                }
                if (b.name && b.name.toLowerCase().indexOf(magicRetailer) > -1) {
                  magicRetailerB = true;
                }
              });
              let aCount = 0;
              a.upcs.forEach((upc) => {
                if (upc.status == 'AVAILABLE') {
                  aCount++;
                }
              });

              let bCount = 0;
              b.upcs.forEach((upc) => {
                if (upc.status == 'AVAILABLE') {
                  bCount++;
                }
              });

              if (magicRetailerA && !magicRetailerB) {
                return -1;
              } else if (!magicRetailerA && magicRetailerB) {
                return 1;
              } else {
                return bCount - aCount;
              }
            });
          }
          response.forEach((r) => {
            if (r.style && r.style.logo) {
              r.style.logo = r.style.logo
                .replace('https://assets.pearcommerce.com', 'https://image-processor.pearcommerce.com')
                .replace('https://demos.pearcommerce.com', 'https://image-processor.pearcommerce.com');
            }
          });
          return response;
        }
      });
  };

  const memoizedGetRetailerListPromise = Util.memoize(getRetailerListInitPromise);

  const pickerResolves = {
    // Just need this as a placeholder to ensure a single request is used to set the session.
    // In this case, OfferDomInsertions is a fast endpoint so it's used. UPCSAndOffer is another option.
    SetSession: function (PageLoad) {
      return true;
    },
    AppConfig: async function ($api) {
      const params = parseUri(window.location.href).queryKey;
      const configs = (await $api.get('/v1/client-app-configs?timeout=10000')) || {};
      Object.entries(configs).forEach(([feature, properties]) => {
        Object.keys(properties).forEach((property) => {
          if (typeof params[property] != 'undefined') {
            properties[property] = params[property];
          }
        });
      });
      return configs;
    },
    OfferDomInsertions: function ($api, $stateParams, SetSession) {
      //We get this in the controller now
      return false;
    },
    ReimbursementInfo: function ($api, PageLoad) {
      return $api
        .get('/v1/reimbusement?timeout=2000&id=0' + (PageLoad ? '&pearclid=' + PageLoad.id : ''))
        .then(function (response) {
          return response;
        });
    },
    PageLoad: function ($api, $stateParams) {
      if (window.pearPageLoad) {
        return window.pearPageLoad;
      }
      const offerId = ($stateParams.offerId || '0').replace(/\D/g, '');
      return $api
        .post(
          '/v1/page_load?timeout=2000',
          {
            admin: !!window.PEAR_COMMERCE_ADMIN,
            offerId: offerId,
            params: window.location.search,
            bundleId: $stateParams.bundleId,
            cookie: document.cookie,
            hostname: window.location.hostname,
            notAsync: true,
          },
          { failure: { id: -1, sessionId: -1 } }
        )
        .then(function (response) {
          return response;
        });
    },
    UPCSAndOffer: function ($api, $stateParams) {
      return $stateParams.offerId && $api.getUpcsAndOffer($stateParams.offerId);
    },
    RetailerListInit: function () {
      // this is done inside pickerController
      return null;
    },
    LocationData: function () {
      return false;
    },
    UPCS: function (UPCSAndOffer, $stateParams) {
      if (UPCSAndOffer && UPCSAndOffer.offer && UPCSAndOffer.offer.productSortType == 'STORE_LOCATOR_GENERATED') {
        UPCSAndOffer.UPCs = UPCSAndOffer.UPCs.filter((item) => item.status != 'FAILED');
      }
      let UPCs = (UPCSAndOffer || {}).UPCs || [];
      if (UPCs && UPCs.length > 0 && $stateParams.force_single == '1') {
        UPCs = [UPCs[0]];
      }
      UPCs.map((u) => {
        if (u.imageUrl) {
          u.imageUrl = u.imageUrl
            ? u.imageUrl
                .replace('https://assets.pearcommerce.com', 'https://image-processor.pearcommerce.com')
                .replace('https://demos.pearcommerce.com', 'https://image-processor.pearcommerce.com')
            : null;
        }
        return u;
      });

      return { UPCs: UPCs };
    },
    OfferValidation: function (UPCSAndOffer, $state) {
      if (!(UPCSAndOffer || {}).offer) {
        $state.go(
          '404',
          { message: 'Landing page does not exist or is disabled.' },
          {
            location: false,
            reload: false,
          }
        );
      }
    },
    MapStylesJson: function () {
      return null;
    },
    PixelConfig: function () {
      return null;
    },
    FirstStoresForLocationPromiseWrapper: function () {
      return null;
    },
    MapStylesJsonPrefetch: function () {
      return null;
    },
    MapStylesJson: function () {
      return null;
    },
    MapLibrariesPreInject: function () {
      return null;
    },
    PotentialStoreZipsForLocation: function () {
      return null;
    },
    ParallelStoresForLocationPromiseWrapper: function () {
      return null;
    },
  };

  const pickerResolvesForModification = {
    OfferDomInsertions: function () {
      return false;
    },
    ReimbursementInfo: function () {
      return false;
    },
    PageLoad: function ($api, $stateParams) {
      return { id: 0 };
    },
    UPCSAndOffer: function ($api, $stateParams, PageLoad) {
      return $api
        .get(
          '/v1/upcs_and_offer_for_modification/' +
            $stateParams.offerId +
            '?modificationId=' +
            $stateParams.modificationId
        )
        .then(function (response) {
          return response;
        });
    },
    RetailerListInit: function ($api, $stateParams, PageLoad) {
      return $api
        .get(
          '/v1/retailer-list-for-modification/' +
            $stateParams.offerId +
            '?modificationId=' +
            $stateParams.modificationId
        )
        .then(function (response) {
          return response;
        });
    },
    LocationData: function () {
      return false;
    },
    UPCS: function (UPCSAndOffer, $stateParams) {
      if (UPCSAndOffer && UPCSAndOffer.offer && UPCSAndOffer.offer.productSortType == 'STORE_LOCATOR_GENERATED') {
        UPCSAndOffer.UPCs = UPCSAndOffer.UPCs.filter((item) => item.status != 'FAILED');
      }
      let UPCs = (UPCSAndOffer || {}).UPCs;
      if (UPCs && UPCs.length > 0 && $stateParams.force_single == '1') {
        UPCs = [UPCs[0]];
      }

      return { UPCs: UPCs };
    },
    MapStylesJson: function () {
      return null;
    },
    PixelConfig: function () {
      return null;
    },
  };

  const demoResolves = {
    OfferDomInsertions: function () {
      return false;
    },
    PageLoad: function ($api, $stateParams) {
      return $api
        .post('/v1/page_load?timeout=2000', {
          admin: !!window.PEAR_COMMERCE_ADMIN,
          offerId: 0,
          notAsync: true,
          params: window.location.search,
        })
        .then(function (response) {
          return response;
        });
    },
    ReimbursementInfo: function () {
      return false;
    },
    UPCSAndOffer: function ($api, $stateParams, PageLoad) {
      return $api.get('/v1/upcs_and_offer_for_demo/' + $stateParams.demoId);
    },
    RetailerListInit: function ($api, $stateParams, PageLoad) {
      const t = new Date().getTime();
      return $api.get('/v1/demo-retailer-list/' + $stateParams.demoId, {
        credentials: 'include',
        withCredentials: true,
      });
    },
    LocationData: function () {
      return false;
    },
    UPCS: function (UPCSAndOffer, $stateParams) {
      if (UPCSAndOffer && UPCSAndOffer.offer && UPCSAndOffer.offer.productSortType == 'STORE_LOCATOR_GENERATED') {
        UPCSAndOffer.UPCs = UPCSAndOffer.UPCs.filter((item) => item.status != 'FAILED');
      }
      let UPCs = UPCSAndOffer.UPCs;
      if (UPCs.length > 0 && $stateParams.force_single == '1') {
        UPCs = [UPCs[0]];
      }

      return { UPCs: UPCs };
    },
    MapStylesJson: function () {
      return null;
    },
    PixelConfig: function () {
      return null;
    },
  };

  $stateProvider.state({
    name: 'demo',
    url: '/demo/{demoId}',
    templateUrl: '/html/pickerv2-mobile.html',
    controller: pickerController,
    resolve: demoResolves,
  });

  const pickerUPCsResolves = Object.assign({}, pickerResolves, {
    OfferDomInsertions: function () {
      return false;
    },
    ReimbursementInfo: function () {
      return false;
    },
    PageLoad: function ($api, $stateParams) {
      return true;
    },
    OfferValidation: function () {
      return null;
    },
    UPCSAndOffer: function ($api, $stateParams) {
      return false;
    },
    AppConfig: async function ($api) {
      const params = parseUri(window.location.href).queryKey;
      const configs = (await $api.get('/v1/client-app-configs?timeout=10000')) || {};
      Object.entries(configs).forEach(([feature, properties]) => {
        Object.keys(properties).forEach((property) => {
          if (typeof params[property] != 'undefined') {
            properties[property] = params[property];
          }
        });
      });
      return configs;
    },
    RetailerListInit: function ($api, $stateParams) {
      const t = new Date().getTime();
      return $api.get(
        '/v1/retailer-list-by-upc/' +
          $stateParams.upcs +
          '?asyncResolveDeep=true&t=' +
          t +
          ($stateParams.pb || $stateParams.mode ? '&zip=55408' : $stateParams.zip ? '&zip=' + $stateParams.zip : '') +
          ($stateParams.cold ? '&cold=' + $stateParams.cold : '') +
          ($stateParams.include ? '&include=' + $stateParams.include : '') +
          ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
          ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
          ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
          ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
          ($stateParams.countryCode ? '&countryCode=' + $stateParams.countryCode : ''),
        { credentials: 'include', withCredentials: true }
      );
    },
    LocationDataLowResolution: function ($api, $stateParams) {
      return false;
    },
    LocationData: function ($api, $stateParams, PixelConfig, LocationDataLowResolution) {
      if (!Util.getCookiePreferences().functional) {
        return false;
      }
      if (!$stateParams.zip) {
        let pixelConfigMoreAccurateGeo =
          (PixelConfig && PixelConfig.widgetConfig ? !!PixelConfig.widgetConfig.moreAccurateGeo : false) ||
          (PixelConfig ? !!PixelConfig.moreAccurateGeo : false);
        if (!!$stateParams.moreAccurateGeo || (!pixelConfigMoreAccurateGeo && LocationDataLowResolution)) {
          return LocationDataLowResolution;
        } else {
          return $api.getIpLocationData({
            moreAccurateGeo: !!$stateParams.moreAccurateGeo || pixelConfigMoreAccurateGeo,
          });
        }
      } else {
        return LocationDataLowResolution ? LocationDataLowResolution : $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
      }
    },
    UPCS: function ($api, $stateParams) {
      return $api.get('/v1/upcs/' + $stateParams.upcs);
    },
    MapStylesJson: function () {
      return null;
    },
    PixelConfig: function () {
      return null;
    },
  });

  $stateProvider.state({
    name: 'picker-with-brand',
    url: '/picker/{offerId}/{brandName}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&countryCode&stylesheet&&open_products&hideCreative&hideCarousel&hideAddress&inWidget&delay_redirect&debug',
    templateProvider: function ($http, $config, $stateParams, $api, UPCSAndOffer) {
      return pickerTemplateProvider($http, $config.revision, UPCSAndOffer.offer, parseUri);
    },
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'picker',
    url: '/picker/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&countryCode&stylesheet&&open_products&hideCreative&hideCarousel&hideAddress&inWidget&delay_redirect&debug',
    templateProvider: function ($http, $config, $stateParams, $api, UPCSAndOffer) {
      return pickerTemplateProvider($http, $config.revision, UPCSAndOffer.offer, parseUri);
    },
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'picker-slash',
    url: '/picker/{offerId}/?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&&open_products&hideCreative&hideCarousel&hideAddress&inWidget&delay_redirect&debug',
    templateProvider: function ($http, $config, $stateParams, $api, UPCSAndOffer) {
      const offer = UPCSAndOffer.offer;
      let template = offer && offer.pickerTemplate;
      if (!template) {
        if (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) > 736) {
          template = '/html/pickerv2.html';
        } else {
          template = '/html/pickerv2-mobile.html';
        }
      }

      let rev = $config['revision'];
      if (!rev) {
        rev = new Date().getTime();
      }
      return $http.get(template + '?rev=' + rev).then(function (data) {
        return data.data;
      });
    },
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'picker-monster',
    url: '/picker-monster/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&&open_products&hideCreative&hideCarousel&hideAddress&inWidget&delay_redirect&debug',
    templateProvider: function ($http, $config, $stateParams, $api, UPCSAndOffer) {
      const offer = UPCSAndOffer.offer;
      let template = offer && offer.pickerTemplate;
      if (!template) {
        template = '/html/pickerv2-monster.html';
      }

      let rev = $config['revision'];
      if (!rev) {
        rev = new Date().getTime();
      }
      return $http.get(template + '?rev=' + rev).then(function (data) {
        return data.data;
      });
    },
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'LiquidDeathOld',
    url: '/liquiddeath/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    template: '<div ui-view></div>',
    controller: function ($state, $stateParams, $location) {
      $location.url('/1904492982680032/liquiddeath/' + $stateParams.offerId + window.location.search);
    },
  });

  $stateProvider.state({
    name: 'LiquidDeath',
    url: '/1904492982680032/liquiddeath/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/liquid-death.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'LiquidDeathWhite',
    url: '/liquiddeath-white/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/liquid-death-white.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'LarabarMulti',
    url: '/larabar_multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/larabar_multi.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'FiberOneMulti',
    url: '/fiber_one_multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/fiber_one_multi.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SnowDays',
    url: '/snowdays/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy&parentUrl',
    template: '<div ui-view></div>',
    controller: function ($stateParams, $state) {
      let parentUrl = $stateParams.parentUrl;
      let singlePDP = false;
      if (parentUrl.indexOf('40201132146879') > -1) {
        //veggie
        $stateParams.offerId = 2032658600218560;
        singlePDP = true;
      } else if (parentUrl.indexOf('38018443411647') > -1) {
        //cheese
        $stateParams.offerId = 1988700420402656;
        singlePDP = true;
      } else if (parentUrl.indexOf('41244585722047') > -1) {
        //buffalo
        $stateParams.offerId = 2120578558377088;
        singlePDP = true;
      } else if (parentUrl.indexOf('40867352051903') > -1) {
        //sausage
        $stateParams.offerId = 2032659065655264;
        singlePDP = true;
      }
      if (singlePDP) {
        $state.go('SnowDaysPDP', $stateParams);
      } else {
        $state.go('SnowDaysMultiPDP', $stateParams);
      }
    },
  });

  $stateProvider.state({
    name: 'SnowDaysMultiPDP',
    url: '/snowdays_multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/snow-days.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SnowDaysPDP',
    url: '/snowdays_single/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/snow-days-single.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Marzetti',
    url: '/marzetti/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/marzetti.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $config
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce,
        $config,
        null,
        $q
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'RatioFood',
    url: '/ratiofood/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/ratiofood.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'CinnamonToastCrunch',
    url: '/cinnamon-toast-crunch/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/annies.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          element.setAttribute('id', 'ex-list-box');
          element.setAttribute('role', 'listbox');
          let count = 0;
          document.querySelectorAll('.pac-item').forEach((element) => {
            element.setAttribute('id', 'ex-list-item-' + count);
            count = count + 1;
            element.setAttribute('aria-selected', 'false');
            element.setAttribute('role', 'option');
          });
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        document.querySelectorAll('.pac-item.pac-item-selected').forEach((element) => {
          element.setAttribute('aria-selected', 'true');
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Annies',
    url: '/annies/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/annies.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        const cleanUp = document.querySelectorAll('.pac-container.pac-logo.hdpi');
        if (cleanUp.length > 1) {
          cleanUp[0].parentNode.removeChild(cleanUp[0]);
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          element.setAttribute('id', 'ex-list-box');
          element.setAttribute('role', 'listbox');
          let count = 0;
          document.querySelectorAll('.pac-item').forEach((element) => {
            element.setAttribute('id', 'ex-list-item-' + count);
            count = count + 1;
            element.setAttribute('aria-selected', 'false');
            element.setAttribute('role', 'listitem');
          });
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        document.querySelectorAll('.pac-item.pac-item-selected').forEach((element) => {
          element.setAttribute('aria-selected', 'true');
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'AnniesMulti',
    url: '/annies_multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/annies_multi.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SteMichelle',
    url: '/ste-michelle-multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/ste-michelle-multi.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SparklingIcePDP',
    url: '/sparkling_ice_pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/sparklingIce_pdp.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'AQAWaterPDP',
    url: '/aqa-water-pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/aqa_water.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SietePDP',
    url: '/siete_pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/siete_pdp.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'OhzaPDP',
    url: '/ohza_pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/ohza_pdp.html',
    controller: pickerController,
    resolve: pickerResolves,
  });
  $stateProvider.state({
    name: 'OhzaRedPDP',
    url: '/ohza_red_pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/ohza_red_pdp.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'AgnosticPDPLabel',
    url: '/agnostic-pdp-label/{offerId}/{label}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy&config',
    templateUrl: '/html/agnostic-pdp.html',
    controller: pickerController,
    resolve: Object.assign({}, pickerResolves, {
      PixelConfigFromState: async function ($stateParams, $api) {
        let ret = null;
        if ($stateParams.vendorId) {
          let VendorWidgets = await $api.get(`/v1/vendor-widgets?vendorId=${$stateParams.vendorId}&timeout=2000`);
          if (VendorWidgets && VendorWidgets.widgetConfigs && VendorWidgets.widgetConfigs.length >= 1) {
            Object.entries(VendorWidgets.widgetConfigs).forEach((e) => {
              if (e[1] && e[1].id == $stateParams.label) {
                ret = e[1];
              }
            });
          }
        }
        return ret;
      },

      PixelConfigFromOffer: async function ($stateParams, $api, UPCSAndOffer, PixelConfigFromState) {
        let ret = null;
        if (!PixelConfigFromState && UPCSAndOffer.offer && UPCSAndOffer.offer.vendorId) {
          let VendorWidgets = await $api.get(`/v1/vendor-widgets?vendorId=${UPCSAndOffer.offer.vendorId}&timeout=2000`);
          if (VendorWidgets && VendorWidgets.widgetConfigs && VendorWidgets.widgetConfigs.length >= 1) {
            Object.entries(VendorWidgets.widgetConfigs).forEach((e) => {
              if (e[1] && e[1].id == $stateParams.label) {
                ret = e[1];
              }
            });
          }
        }
        return ret;
      },

      PixelConfig: function ($stateParams, $api, UPCSAndVendor, PixelConfigFromState, PixelConfigFromOffer) {
        let ret = null;
        if (PixelConfigFromState) {
          ret = PixelConfigFromState;
        } else if (PixelConfigFromOffer) {
          ret = PixelConfigFromOffer;
        } else if ($stateParams.label) {
          ret =
            (UPCSAndVendor?.vendor?.pixelMapping?.widgetConfigsByLabel &&
              UPCSAndVendor.vendor.pixelMapping.widgetConfigsByLabel[$stateParams.label]) ||
            {};
        }

        return ret;
      },

      UPCSAndVendor: function ($api, $stateParams, UPCSAndOffer) {
        const vendorId = $stateParams.vendorId || (UPCSAndOffer?.offer?.vendor && UPCSAndOffer?.offer?.vendorId) || (UPCSAndOffer?.vendor?.id);
        const ret = $api.getUpcsAndVendor(vendorId);
        return ret;
      },

      LocationDataLowResolution: function ($api, $stateParams) {
        if (!Util.getCookiePreferences().functional) {
          return false;
        }
        if (!$stateParams.zip) {
          return $api.getIpLocationData({
            moreAccurateGeo: !!$stateParams.moreAccurateGeo,
          });
        } else {
          return $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
        }
      },
      
      LocationData: function ($api, $stateParams, PixelConfig, LocationDataLowResolution) {
        if (!Util.getCookiePreferences().functional) {
          return false;
        }
        if (!$stateParams.zip) {
          let pixelConfigMoreAccurateGeo =
            (PixelConfig && PixelConfig.widgetConfig ? !!PixelConfig.widgetConfig.moreAccurateGeo : false) ||
            (PixelConfig ? !!PixelConfig.moreAccurateGeo : false);
          if (!!$stateParams.moreAccurateGeo || (!pixelConfigMoreAccurateGeo && LocationDataLowResolution)) {
            return LocationDataLowResolution;
          } else {
            return $api.getIpLocationData({
              moreAccurateGeo: !!$stateParams.moreAccurateGeo || pixelConfigMoreAccurateGeo,
            });
          }
        } else {
          return LocationDataLowResolution ? LocationDataLowResolution : $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
        }
      },
    }),
  });

  $stateProvider.state({
    name: 'AgnosticPDP',
    url: '/agnostic-pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/agnostic-pdp.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'ArkNaturalsMulti',
    url: '/ark_naturals_multi/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/ark_naturals_multi.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'ArkNaturals',
    url: '/ark-naturals-pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/ark-naturals-pdp.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Windex',
    url: '/windex/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/windex.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SnowDays_landing-page',
    url: '/snow-days-landing-page/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/snow-days-landing-page.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SnowDays_single_landing-page',
    url: '/snow-days-single-pdp/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/snow-days-single.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Bombpop',
    url: '/bombpop-v3/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&promo_text&cookiePolicy',
    templateUrl: '/html/bombpop.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'TruRoots',
    url: '/tru-roots-v4/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/tru-roots.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'SantaCruze',
    url: '/santa-cruz-v6/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/santa-cruz.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'RWKnudsen',
    url: '/rw-knudsen-v4/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/rw-knudsen.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'LaraBarSingle',
    url: '/larabar_single/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/larabar_single.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Wildeterra',
    url: '/wildeterra/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/wildeterra.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'EpicProvisions',
    url: '/epicprovisions/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/epicprovisions.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce,
        $q
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height == 0) {
          container.style.height = 'auto';
        } else if (height > 0 && height > container.offsetHeight) {
          container.style.height = 300 + height + 'px';
        }
        if ($rootScope.pymChild) {
          $rootScope.pymChild.sendHeight();
        }
      }, 500);
    },
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'Gushers',
    url: '/gushers/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&force_single&pb&mode&show_more&claim_on_page&bundleId&print&address&stylesheet&',
    templateUrl: '/html/gushers.html',
    controller: function (
      $scope,
      UPCS,
      UPCSAndOffer,
      $stateParams,
      RetailerListInit,
      $timeout,
      $api,
      $rootScope,
      LocationData,
      $state,
      isMobile,
      PageLoad,
      $interval,
      OfferDomInsertions,
      ReimbursementInfo,
      $sce,
      $q
    ) {
      pickerController(
        $scope,
        UPCS,
        UPCSAndOffer,
        $stateParams,
        RetailerListInit,
        $timeout,
        $api,
        $rootScope,
        LocationData,
        $state,
        isMobile,
        PageLoad,
        $interval,
        OfferDomInsertions,
        ReimbursementInfo,
        $sce
      );

      setInterval(() => {
        let container = document.querySelector('#container');
        if (!container) {
          return;
        }
        let height = 0;
        document.querySelectorAll('.pac-container.pac-logo.hdpi').forEach((element) => {
          if (element.offsetHeight > 0) {
            height += element.offsetHeight;
          }
        });
        if (height > 0) {
          container.style.height = 100 + height + 'px';
        } else if (container.style.height != 'auto') {
          container.style.height = 'auto';
        }
      }, 500);
    },
    resolve: pickerResolves,
  });
  
  $stateProvider.state({
    name: 'FireTikTokPixel',
    url: '/fire_tiktok_pixel?pixelId',
    template: '<div ui-view></div>',
    controller: function ($stateParams, $api) {
      let script =
        `<script>
        !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
    
      ttq.load('` +
        $stateParams.pixelId +
        `');
      ttq.page();
      ttq.track('ViewContent');
      }(window, document, 'ttq');
      </script>
      `;
      addTagsToBody($api, script, false, 0, EVENT_PAGE_LOAD);
    },
  });

  $stateProvider.state({
    name: 'PageLoadState',
    url: '/{vendorId}/picker/{offerId}/page_load?redirect&pearclid&product_name&product_names&retailer_name&fireEvents',
    template: '<div ui-view></div>',
    controller: function ($stateParams, $state, OfferDomInsertions, $timeout, $api, $stateParams) {
      window.PRODUCT_NAME = $stateParams.product_name;
      window.RETAILER_NAME = $stateParams.retailer_name;
      window.PRODUCT_NAMES = $stateParams.product_names;
      window.PEARCLID = $stateParams.pearclid;
      // addFB();

      if (
        (Util.getCookiePreferences().targeting && OfferDomInsertions && OfferDomInsertions.pageLoad) ||
        $stateParams.delay_redirect
      ) {
        addTagsToBody($api, OfferDomInsertions.pageLoad, true, $stateParams.pearclid, EVENT_PAGE_LOAD).then(function () {
          $api.post('/v1/conversion_api?timeout=2000', {
            eventType: 'PageLoad',
            uniqueEventId: window.capiUniqueEventId,
            offerId: $stateParams.offerId,
            url: window.location.href,
          });
        });

        setTimeout(
          function () {
            $api
              .post('/v1/page_load?timeout=2000', {
                admin: !!window.PEAR_COMMERCE_ADMIN,
                offerId: $stateParams.offerId,
                cookie: document.cookie,
                hostname: window.location.hostname,
                notAsync: true,
              })
              .then(() => {
                $timeout(() => {
                  $state.go('AddToCartState', $stateParams);
                }, 0);
              });
          },
          $stateParams.delay_redirect ? 15 * 1000 : 1000
        );
      } else {
        $state.go('AddToCartState', $stateParams);
      }
    },
    resolve: {
      OfferDomInsertions: function ($api, $stateParams) {
        return $api
          .get('/v1/offer_dom_insertions?timeout=2000&offerId=' + ($stateParams.offerId || 0))
          .then(function (response) {
            return response;
          });
      },
    },
  });

  $stateProvider.state({
    name: 'CatalogShortlink',
    url: '/{vendorId}/shortlink?shortlink_id',
    template: `<div ui-view></div>`,
    controller: function (Shortlink, $location, $stateParams) {
      let path = Shortlink.url.substring(Shortlink.url.indexOf("/" + $stateParams.vendorId + "/")) + window.location.search.replace('?', '&');
      $location.url(path);
    },
    resolve: {
      Shortlink: function ($api, $stateParams) {
        return $api.get('/v1/catalog_shortlink?id=' + $stateParams.shortlink_id);
      },
    },
  });

  $stateProvider.state({
    name: 'CatalogRetailerVisitState',
    url: '/{vendorId}/catalog_retailer_visit?redirect&pearclid&product_name&retailer_name&delay_redirect&d&upcId&retailerId',
    template: `
    <div ui-view style="height: 100vh">
      <div style="height: 100%; padding: 0; margin: 0; display: flex; align-items: center; justify-content: center; font-family: Lato, Open Sans, helvetica neue, sans-serif;">
        <div style="border-radius: 10px; padding: 25px; height: 25vh; width: 30vw; box-shadow: 1px 1px 10px 1px #ccc; min-height: 200px; min-width: 200px;">
          <div style="display: flex; flex-direction: column; align-items: center; width: 94%; height: 100%; margin: 0 auto;">
            <div style="flex-grow: 0.3; text-align: center; align-content: center">Checking out at {{retailerName}}!</div>
            <div style="flex-grow: 0.7; display: flex; align-items: center"><img style="height: 5vh" src="https://offers.pearcommerce.com/img/spinner.gif" /></div>
          </div>
        </div>
    </div>`,
    controller: function ($stateParams, $state, $timeout, $stateParams, $scope, $api, $location) {
      let delay = 4000;
      if ($stateParams.d) {
        delay = parseInt($stateParams.d + '');
      } else if ($stateParams.delay_redirect) {
        delay = 15 * 1000;
      }
      window.PRODUCT_NAME = $stateParams.product_name;
      window.RETAILER_NAME = $stateParams.retailer_name;
      window.PEARCLID = $stateParams.pearclid;
      $scope.productName = $stateParams.product_name;
      $scope.retailerName = $stateParams.retailer_name;
      if (!$scope.retailerName) {
        $scope.retailerName = 'the retailer';
      }
      if (Util.getCookiePreferences().targeting) {
        addFB();
      }
      let rawSearch = window.location.search.replace('%C2%AC', '&not').replaceAll('&amp;', '&');
      if (rawSearch.charAt(0) == '?') {
        rawSearch = window.location.search
          .substring(1, window.location.search.length)
          .replace('%C2%AC', '&not')
          .replaceAll('&amp;', '&');
      }
      let params = Object.fromEntries(new URLSearchParams(rawSearch).entries());
      params.params = window.location.search.replace('%C2%AC', '&not').replaceAll('&amp;', '&');
      params.cookie = document.cookie;
      delete params.calculateUrl;
      let retailerId = params.retailerId;
      if (!retailerId) {
        retailerId = '';
      }
      $api.post('/v1/catalog_retailer_visit', params, { failure: { pearclid: 0 } }).then(function (response) {
        $api
          .get(
            '/v1/offer_dom_insertions?timeout=2000&pear_connect_retailer_visit=true&offerId=' +
              response.offerId +
              '&upcIds=' +
              params.upcId +
              '&retailerId=' +
              retailerId
          )
          .then(function (OfferDomInsertions) {
            if (
              (Util.getCookiePreferences().targeting &&
                OfferDomInsertions &&
                (OfferDomInsertions.addToCart || OfferDomInsertions.retailerVisit)) ||
              $stateParams.delay_redirect
            ) {
              addTagsToBody($api, OfferDomInsertions.retailerVisit, true, $stateParams.pearclid, EVENT_RETAILER_VISIT).then(
                function () {
                  $api.post('/v1/conversion_api?timeout=2000', {
                    eventType: 'AddToCart',
                    uniqueEventId: window.capiUniqueEventId,
                    offerId: response.offerId,
                    url: window.location.href,
                  });
                  addTagsToBody($api, OfferDomInsertions.addToCart, true, $stateParams.pearclid, EVENT_ADD_TO_CART).then(
                    function () {}
                  );
                }
              );

              setTimeout(function () {
                let params = {
                  admin: false,
                  offerId: response.offerId,
                  id: response.pearclid,
                  params: window.location.search,
                  bundleId: 0,
                  cookie: document.cookie,
                  hostname: window.location.hostname,
                  notAsync: true,
                };
                if ($scope.pearclid) {
                  params.id = $scope.pearclid;
                }
                
                // Replace __PEAR_CLID__ or pearclidplaceholder in params.params before sending to /v1/page_load
                params.params = params.params?.replace(/__PEAR_CLID__/g, response.pearclid + '').replace(/pearclidplaceholder/g, response.pearclid + '') ?? params.params;

                $api.post('/v1/page_load?timeout=2000', params).then(
                  function () {
                    if ($stateParams.redirect) {
                      const redirectUrl = $stateParams.redirect.replace(/__PEAR_CLID__/g, response.pearclid + '').replace(/pearclidplaceholder/g, response.pearclid + '');
                        if ($stateParams.redirect.indexOf('https://') > -1) {
                        window.location = redirectUrl;

                      } else {
                        window.location = decodeURIComponent(redirectUrl);
                      }
                    }
                  },
                  { failure: { id: -1, sessionId: -1 } }
                );
              }, delay);
            } else {
              if ($stateParams.redirect) {
                if ($stateParams.redirect.indexOf('https://') > -1) {
                  window.location = $stateParams.redirect.replace(/__PEAR_CLID__/g, response.pearclid + '');
                } else {
                  window.location = decodeURIComponent(
                    $stateParams.redirect.replace(/__PEAR_CLID__/g, response.pearclid + '')
                  );
                }
              }
            }
          });
      });
    },
  });

  $stateProvider.state({
    name: 'AddToCartState',
    url: '/{vendorId}/picker/{offerId}/add_to_cart?redirect&pearclid&product_name&product_names&retailer_name&delay_redirect&d&upcId&retailerId&fireEvents&preview&previewLogoUrl&previewAccentColor&previewInterstitial',
    template: `
    <div ui-view style="height: 100vh; background-color: #f5f5f5; display: flex; align-items: center; justify-content: center;">
      <div style="width: 500px; background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
        <!-- Top colored bar -->
        <div ng-style="{{getHeaderStyles()}}" style="height: 8px; width: 100%;"></div>
        
        <div style="padding: 30px; text-align: center;">
          <!-- Vendor logo -->
          <img ng-if="vendor.customInterstitial && vendor.interstitialLogoUrl" 
               ng-src="{{vendor.interstitialLogoUrl}}" 
               style="height: 40px; margin-bottom: 24px;"
               alt="Vendor logo">
          
          <!-- Content -->
          <div style="font-family: Lato, Open Sans, helvetica neue, sans-serif;">
            <div style="font-size: 16px; color: #666; margin-bottom: 12px;">Thanks for checking out</div>
            <div style="font-size: 20px; font-weight: 500; margin-bottom: 12px;">{{productName || ''}}</div>
            <div style="font-size: 16px; color: #666; margin-bottom: 24px;">{{productDetails}}</div>
            
            <!-- Loader -->
            <img ng-src="https://offers.pearcommerce.com/img/spinner.gif" style="height: 30px;">
          </div>
        </div>
      </div>
    </div>`,
    controller: function (
      $stateParams,
      $state,
      OfferDomInsertions,
      $timeout,
      $stateParams,
      $scope,
      Redirect,
      UPCSAndOffer,
      $api
    ) {
      UPCSAndOffer = UPCSAndOffer || {};
      const offer = UPCSAndOffer.offer;

      if ($stateParams.preview === 'true') {
        $scope.vendor = {
          customInterstitial: $stateParams.previewInterstitial,
          interstitialLogoUrl: Util.patchImageUrl($stateParams.previewLogoUrl || ''),
          interstitialAccentColor: $stateParams.previewAccentColor || ''
        };
      } else {
        $scope.vendor = UPCSAndOffer.offer?.vendor || {};
      }

      $scope.productName = $stateParams.product_name;
      $scope.productDetails = `at ${$stateParams.retailer_name}`;


      $scope.getHeaderStyles = function() {
        if ($scope.vendor && $scope.vendor.customInterstitial) {
          return {
            backgroundColor: $scope.vendor.interstitialAccentColor || 'white',
          };
        }
        return {
          backgroundColor: 'white',
        };
      };

      let languageTranslation = offer.languageTranslation;
      let hideLanguageSwitcher = offer.hideLanguageSwitcher;
      if (Weglot && languageTranslation) {
        Weglot.initialize({
          api_key: 'wg_1ecf050fb94882e0b6607643b16501899',
          hide_switcher: !!hideLanguageSwitcher,
          auto_switch: true,
          auto_switch_fallback: languageTranslation,
        });
        Weglot.on('initialized', () => {
          if (languageTranslation === 'auto') {
            const deviceLanguage = window.navigator.language || '';
            if (deviceLanguage.startsWith('en')) {
              languageTranslation = 'en';
            } else if (deviceLanguage.startsWith('fr')) {
              languageTranslation = 'fr';
            } else if (deviceLanguage.startsWith('es')) {
              languageTranslation = 'es';
            } else {
              languageTranslation = 'en';
            }
          }
          Weglot.switchTo(languageTranslation);
        });
      }

      const UTM_SOURCE_VALUE = 'pearcommerce';
      const EXCLUDED_PART_DOMAINS = [
        'giantfood',
        'stopandshop.com',
        '7now',
        'walmart.c',
        'heb.com',
        'doordash.com'
      ];

      // Replace PEAR_CLID placeholder BEFORE creating URL object to avoid URL encoding
      // Replaces all occurrences of the placeholder with the actual pearclid using the global replace method
      // Supports multiple formats (in order of preference):
      // 1. __PEAR_CLID__ (underscores - safest, won't be encoded)
      // 3. {{PEAR_CLID}} (curly braces - legacy support, will be encoded if not replaced)
      let redirectUrl = Redirect.toString();
      if ($stateParams.pearclid) {
        if (redirectUrl.includes('__PEAR_CLID__')) {
          redirectUrl = redirectUrl.replace(/__PEAR_CLID__/g, $stateParams.pearclid);
        } else if (redirectUrl.includes('{{PEAR_CLID}}')) {
          redirectUrl = redirectUrl.replace(/\{\{PEAR_CLID\}\}/g, $stateParams.pearclid);
        }
      }

      const url = new URL(redirectUrl);
      const urlHostName = url.hostname;
      const rootHostName = urlHostName.split('.').slice(-2).join('.');
      if (!EXCLUDED_PART_DOMAINS.includes(rootHostName)) {
        const params = new Map();
        params.set("pearclid", $stateParams.pearclid);
        params.set("utm_source", UTM_SOURCE_VALUE);

        if (!urlHostName.includes('samsclub') && !urlHostName.includes('walmart')) {
          params.set("offerId", $stateParams.offerId);
        }
        
        if (!urlHostName.includes('minibardelivery')) {
          params.set('ref', UTM_SOURCE_VALUE);
        }
        for (const [key, value] of params) {
          url.searchParams.set(key, value);
        }
      }
      
      const parsedURL = url.toString();


      if (!$stateParams.preview) {
        let delay = 4000;
        if ($stateParams.d) {
          delay = parseInt($stateParams.d + '');
        } else if ($stateParams.delay_redirect) {
          delay = 15 * 1000;
        }
        window.PRODUCT_NAME = $stateParams.product_name;
        window.PRODUCT_NAMES = $stateParams.product_names;
        window.RETAILER_NAME = $stateParams.retailer_name;
        window.PEARCLID = $stateParams.pearclid;
        $scope.productName = $stateParams.product_name;
        $scope.retailerName = $stateParams.retailer_name;
        if (Util.getCookiePreferences().targeting && $stateParams.fireEvents) {
          addFB();
        }
        if (
          Util.getCookiePreferences().targeting &&
          $stateParams.fireEvents &&
          OfferDomInsertions &&
          (OfferDomInsertions.addToCart || OfferDomInsertions.retailerVisit)
        ) {
          addTagsToBody($api, OfferDomInsertions.retailerVisit, true, $stateParams.pearclid, EVENT_RETAILER_VISIT).then(
            function () {
              $api.post('/v1/conversion_api?timeout=2000', {
                eventType: 'AddToCart',
                uniqueEventId: window.capiUniqueEventId,
                offerId: offer.id,
                url: window.location.href,
              });
              addTagsToBody($api, OfferDomInsertions.addToCart, true, $stateParams.pearclid, EVENT_ADD_TO_CART).then(
                function () {}
              );
            }
          );

          setTimeout(function () {
            window.location = parsedURL;
          }, delay);
        } else {
          setTimeout(function () {
            window.location = parsedURL;
          }, delay);
        }
      }
    },
    resolve: {
      OfferDomInsertions: function ($api, $stateParams) {
        if ($stateParams.preview) {
          return {};
        }
        let retailerId = $stateParams.retailerId;
        if (!retailerId) {
          retailerId = '';
        }
        return $api
          .get(
            '/v1/offer_dom_insertions?timeout=2000&offerId=' +
              ($stateParams.offerId || 0) +
              '&upcIds=' +
              $stateParams.upcId +
              '&retailerId=' +
              retailerId
          )
          .then(function (response) {
            return response;
          });
      },
      Redirect: function ($api, $stateParams) {
        if ($stateParams.preview) {
          return '';
        }
        return $api
          .get('/v1/decode_redirect?url=' + encodeURIComponent($stateParams.redirect), {
            failure: { decodedUrl: $stateParams.redirect },
          })
          .then(function (rsp) {
            return rsp.decodedUrl;
          });
      },
      UPCSAndOffer: function ($api, $stateParams) {
        if ($stateParams.preview) {
          return {
            offer: {
              vendor: {}
            }
          };
        }
        return $stateParams.offerId && $api.getUpcsAndOffer($stateParams.offerId);
      },
    },
  });

  $stateProvider.state({
    name: 'AddToCartStateOld',
    url: '/picker/{offerId}/add_to_cart?redirect&pearclid&product_name&retailer_name&delay_redirect&d&upcId&retailerId&fireEvents',
    template: `<div ui-view></div>`,
    controller: function ($stateParams, $state, UPCSAndOffer, $location) {
      $stateParams.vendorId = UPCSAndOffer.offer.vendor.id;
      $location.url(
        '/' +
          UPCSAndOffer.offer.vendor.id +
          '/picker/' +
          UPCSAndOffer.offer.id +
          '/add_to_cart' +
          window.location.search
      );
    },
    resolve: {
      UPCSAndOffer: function ($api, $stateParams) {
        return $stateParams.offerId && $api.getUpcsAndOffer($stateParams.offerId);
      },
    },
  });

  $stateProvider.state({
    name: 'PurchaseState',
    url: '/picker/{offerId}/purchase/{pearclid}?&product_name&product_names&retailer_name&upcId&retailerId&zip&moreAccurateGeo&pear_connect_retailer_visit',
    template: '<div ui-view></div>',
    controller: function ($stateParams, OfferDomInsertions, Cookie, $api) {
      window.PEARCLID = $stateParams.pearclid;
      window.PRODUCT_NAME = $stateParams.product_name;
      window.RETAILER_NAME = $stateParams.retailer_name;
      window.PRODUCT_NAMES = $stateParams.product_names;
      let hostnameParts = window.location.hostname.split('.');
      let hostname = '.' + hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1];
      if (Cookie.cookie) {
        let cookies = Cookie.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          document.cookie = cookies[i] + ';path=/;domain=' + hostname;
        }
      }
      if (Util.getCookiePreferences().targeting) {
        addFB();
      }

      if (Util.getCookiePreferences().targeting && OfferDomInsertions && OfferDomInsertions.purchase) {
        addTagsToBody($api, OfferDomInsertions.purchase, true, $stateParams.pearclid, EVENT_PURCHASE).then(function () {
          $api.post('/v1/conversion_api?timeout=2000', {
            eventType: 'Purchase',
            uniqueEventId: window.capiUniqueEventId,
            offerId: $stateParams.offerId,
            url: window.location.href,
          });
        });
      }
      $api.post('/v1/purchase_event_fired', { pearclid: $stateParams.pearclid, cookie: document.cookie });
    },
    resolve: {
      OfferDomInsertions: function ($api, $stateParams) {
        return $api
          .get(
            '/v1/offer_dom_insertions?timeout=2000&offerId=' +
              ($stateParams.offerId || 0) +
              '&upcIds=' +
              $stateParams.upcId +
              '&retailerId=' +
              $stateParams.retailerId +
              '&zip=' +
              $stateParams.zip +
              '&pear_connect_retailer_visit=' +
              !!$stateParams.pear_connect_retailer_visit
          )
          .then(function (response) {
            return response;
          });
      },
      Cookie: function ($api, $stateParams) {
        return $api.get('/v1/cookie?pearclid=' + $stateParams.pearclid).then(function (response) {
          return response;
        });
      },
    },
  });

  $stateProvider.state({
    name: 'PickerForModification',
    url: '/picker-for-modification/{offerId}?modificationId',
    templateProvider: async function ($http, $config, $stateParams, $api, UPCSAndOffer) {

      let offer = UPCSAndOffer.offer;
      if ($stateParams.offerId) {
        const response = await $api.getUpcsAndOffer($stateParams.offerId);
        offer = response.offer;
      }

      return pickerTemplateProvider($http, $config.revision, offer, parseUri);
    },
    controller: modificationController,
    resolve: pickerResolvesForModification,
  });

  $stateProvider.state({
    name: 'picker-upcs',
    url: '/upcs/{upcs}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&pb&mode',
    templateUrl: '/html/pickerv2-mobile.html',
    controller: pickerController,
    resolve: pickerUPCsResolves,
  });

  $stateProvider.state({
    name: 'connector',
    url: '/connector/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&pb&mode',
    templateUrl: '/html/pickerv2-mobile.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  $stateProvider.state({
    name: 'click',
    url: '/click/{bundleId}?not_sticky',
    template: '<div></div>',
    controller: function ($state, Bundle, $stateParams, $location) {
      if (Bundle) {
        if (Bundle.url) {
          let url = Bundle.url;
          url +=
            (url.indexOf('?') >= 0 ? '&' : '?') +
            'bundleId=' +
            $stateParams.bundleId +
            '&' +
            window.location.search.replace('?', '&');
          window.location = url;
        } else if (Bundle.offerId) {
          let redirect =
            '/picker/' +
            Bundle.offerId +
            '?bundleId=' +
            $stateParams.bundleId +
            '&' +
            window.location.search.replace('?', '&');
          $location.url(redirect);
        }
      }
    },
    resolve: {
      Bundle: function ($stateParams, $api) {
        let bundleForwards = {};
        try {
          if (!storage.local.getItem('bundleForwards')) {
            storage.local.setItem('bundleForwards', '{}');
          }

          bundleForwards = JSON.parse(storage.local.getItem('bundleForwards'));
        } catch (e) {
          console.error(e);
        }
        if (bundleForwards[$stateParams.bundleId] && !$stateParams.not_sticky) {
          return bundleForwards[$stateParams.bundleId];
        } else {
          return $api.get('/v1/click_bundle?bundleId=' + $stateParams.bundleId).then(function (response) {
            if (!$stateParams.not_sticky) {
              bundleForwards[$stateParams.bundleId] = response;
              storage.local.setItem('bundleForwards', JSON.stringify(bundleForwards));
            }
            return response;
          });
        }
      },
    },
  });

  $stateProvider.state({
    name: 'picker-onsite',
    url: '/picker-onsite/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&sold_at&pb&mode&debug',
    templateUrl: '/html/picker-onsite.html',
    controller: pickerController,
    resolve: pickerResolves,
  });

  const whereToBuyResolves = {
    OfferDomInsertions: function ($api, UPCSAndOffer) {
      //We get this in the controller now
      return false;
    },
    ReimbursementInfo: function () {
      return false;
    },
    AppConfig: async function ($api) {
      const params = parseUri(window.location.href).queryKey;
      const configs = (await $api.get('/v1/client-app-configs?timeout=10000')) || {};
      Object.entries(configs).forEach(([feature, properties]) => {
        Object.keys(properties).forEach((property) => {
          if (typeof params[property] != 'undefined') {
            properties[property] = params[property];
          }
        });
      });
      return configs;
    },
    PageLoad: function ($api, $stateParams, UPCSAndOffer) {
      if (window.pearPageLoad) {
        return window.pearPageLoad;
      }
      const offerId = UPCSAndOffer.offer.id;
      return $api
        .post('/v1/page_load?timeout=2000', {
          admin: !!window.PEAR_COMMERCE_ADMIN,
          offerId: offerId,
          params: window.location.search,
          bundleId: $stateParams.bundleId,
          cookie: document.cookie,
          hostname: window.location.hostname,
          notAsync: true,
        })
        .then(function (response) {
          return response;
        });
    },
    UPCSAndOffer: function ($api, $stateParams) {
      return $api.getUpcsAndVendor($stateParams.vendorId);
    },
    RetailerListInit: function () {
      return null;
    },
    LocationDataLowResolution: function ($api, $stateParams) {
      if (!Util.getCookiePreferences().functional) {
        return false;
      }
      if (!$stateParams.zip) {
        return $api.getIpLocationData({
          moreAccurateGeo: !!$stateParams.moreAccurateGeo,
        });
      } else {
        return $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
      }
    },
    LocationData: function ($api, $stateParams, PixelConfig, LocationDataLowResolution) {
      if (!Util.getCookiePreferences().functional) {
        return false;
      }
      if (!$stateParams.zip) {
        let pixelConfigMoreAccurateGeo =
          (PixelConfig && PixelConfig.widgetConfig ? !!PixelConfig.widgetConfig.moreAccurateGeo : false) ||
          (PixelConfig ? !!PixelConfig.moreAccurateGeo : false);
        if (!!$stateParams.moreAccurateGeo || (!pixelConfigMoreAccurateGeo && LocationDataLowResolution)) {
          return LocationDataLowResolution;
        } else {
          return $api.getIpLocationData({
            moreAccurateGeo: !!$stateParams.moreAccurateGeo || pixelConfigMoreAccurateGeo,
          });
        }
      } else {
        return LocationDataLowResolution ? LocationDataLowResolution : $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
      }
    },
    UPCS: function (UPCSAndOffer) {
      if (UPCSAndOffer && UPCSAndOffer.offer && UPCSAndOffer.offer.productSortType == 'STORE_LOCATOR_GENERATED') {
        UPCSAndOffer.UPCs = UPCSAndOffer.UPCs.filter((item) => item.status != 'FAILED');
      }
      return { UPCs: UPCSAndOffer.UPCs };
    },
    MapStylesJson: function () {
      return null;
    },
    PixelConfig: function () {
      return null;
    },
  };

  $stateProvider.state({
    name: 'where-to-buy',
    url: '/where-to-buy/{vendorId}?path&zip&moreAccurateGeo&cold&include&exclude&key&latitude&longitude&address&stylesheet&&sold_at&pb&mode',
    templateUrl: '/html/onsite.html',
    controller: pickerController,
    resolve: whereToBuyResolves,
  });

  const PARALLEL_PREFETCH_STORES = true;
  const DEFAULT_TEMPLATE_VERSION = 2;
  const TEMPLATE_VERSIONS = {
    1: '/html/product-locator.html',
    2: '/html/product-locator-22-07.html',
    3: '/html/product-locator-12-11.html',
  };

  function getTemplateVersion(stateParamsVersion, widgetConfiguration) {
    let ret = stateParamsVersion.v || widgetConfiguration.version || DEFAULT_TEMPLATE_VERSION;
    
    return ret;
  }

  $stateProvider.state({
    name: 'product-locator',
    url: '/product-locator/{vendorId}?path&zip&moreAccurateGeo&cold&include&exclude&key&latitude&longitude&address&countryCode&stylesheet&sold_at&pb&mode&productLocatorTemplate&v&config&label&offerId&widgetId&singleItemSelect',
    templateProvider: function ($http, $stateParams, $config, PixelConfig) {
      const widgetConfig = PixelConfig.widgetConfig || {};
      const version = getTemplateVersion($stateParams, widgetConfig);

      let templatePath =
        ($stateParams.productLocatorTemplate && decodeURIComponent($stateParams.productLocatorTemplate)) ||
        widgetConfig.templateHtml ||
        (version && TEMPLATE_VERSIONS[+version]) ||
        TEMPLATE_VERSIONS[1];

      const templateUrl = `${templatePath}` + '?t=' + Date.now();
      return $http.get(templateUrl).then(function (data) {
        return data.data;
      });
    },
    controller: pickerController,
    resolve: Object.assign({}, whereToBuyResolves, {
      PageLoad: function ($api, $stateParams, UPCSAndOffer, WeglotInit) {
        if (window.pearPageLoad) {
          return window.pearPageLoad;
        }
        
        return $api.post('/v1/page_load?timeout=2000', {
            admin: !!window.admin,
            offerId: (UPCSAndOffer.offer || {}).id || $stateParams.offerId || vendorId,
            params: window.location.search,
            cookie: document.cookie,
            hostname: window.location.hostname,
            notAsync: true,
          },
          { failure: { id: -1, sessionId: -1 } }
        );
      },
      PixelConfigFromState: async function ($stateParams, $api) {
        let ret = null;
        if ($stateParams.vendorId && $stateParams.widgetId) {
          let VendorWidgets = await $api.get(`/v1/vendor-widgets?vendorId=${$stateParams.vendorId}&timeout=3000`);
          if (VendorWidgets && VendorWidgets.widgetConfigs && VendorWidgets.widgetConfigs.length >= 1) {
            Object.entries(VendorWidgets.widgetConfigs).forEach((e) => {
              if (e[1] && e[1].id == $stateParams.widgetId) {
                ret = e[1];
              }
            });
          }
        }
        return ret;
      },

      PixelConfig: function ($stateParams, $api, UPCSAndVendor, StateParamsWidgetConfig, PixelConfigFromState) {
        let pixelConfigBase = (UPCSAndVendor && UPCSAndVendor.vendor && UPCSAndVendor.vendor.pixelMapping) || {};
        let widgetConfig = null;

        if (StateParamsWidgetConfig) {
          widgetConfig = StateParamsWidgetConfig;
        } else if (pixelConfigBase.widgetConfigsByLabel && $stateParams.label && $stateParams.label) {
          widgetConfig = pixelConfigBase.widgetConfigsByLabel[$stateParams.label] || {};
        } else if (PixelConfigFromState) {
          widgetConfig = PixelConfigFromState;
        } else {
          widgetConfig =
            (pixelConfigBase.widgetConfigsByLabel && pixelConfigBase.widgetConfigsByLabel.default) ||
            pixelConfigBase.widgetConfig ||
            (pixelConfigBase.widgetConfigsByLabel && Object.entries(pixelConfigBase.widgetConfigsByLabel)[0][1]) ||
            {};
        }
        return Object.assign({}, pixelConfigBase, {
          widgetConfig: widgetConfig || {},
        });
      },
      StateParamsWidgetConfig: function ($stateParams) {
        return $stateParams.config && JSON.parse($stateParams.config);
      },
      UPCSAndVendor: function (UPCSAndOfferPrefetch) {
        if (UPCSAndOfferPrefetch) {
          return {
            UPCs: UPCSAndOfferPrefetch.UPCs,
            offer: UPCSAndOfferPrefetch.offer,
            vendor: (UPCSAndOfferPrefetch.offer || {}).vendor,
          };
        } else {
          return {};
        }
      },
      UPCSAndOfferPrefetch: function ($api, $stateParams, StateParamsWidgetConfig) {
        if (!$stateParams.offerId) {
          let venorId = $stateParams.vendorId || (StateParamsWidgetConfig && StateParamsWidgetConfig.vendorId);
          if (venorId) {
            return $api.get(
              '/v1/upcs_and_offer_store_locator/' +
                ($stateParams.vendorId ||
                  (StateParamsWidgetConfig && StateParamsWidgetConfig.vendorId) + '?timeout=3000')
            );
          }
        }
      },
      UPCSAndOfferFromState: function ($stateParams, $api) {
        if ($stateParams.offerId) {
          return $api
            .get('/v1/upcs_and_offer_store_locator/' + $stateParams.offerId + '?timeout=3000')
            .then((UPCSAndOffer) => {
              UPCSAndOffer.vendor = UPCSAndOffer.offer.vendor;
              return UPCSAndOffer;
            });
        }
        return null;
      },
      UPCSAndOffer: function ($stateParams, UPCSAndOfferPrefetch, PixelConfig, $api, UPCSAndOfferFromState) {
        if (UPCSAndOfferFromState) {
          return UPCSAndOfferFromState;
        }
        let offerId = PixelConfig.widgetConfig.offerId || $stateParams.vendorId;
        if (offerId && (!UPCSAndOfferPrefetch || PixelConfig.widgetConfig.offerId != $stateParams.vendorId)) {
          return $api.get('/v1/upcs_and_offer_store_locator/' + offerId + '?timeout=3000').then((UPCSAndOffer) => {
            UPCSAndOffer.vendor = UPCSAndOfferPrefetch ? UPCSAndOfferPrefetch.offer.vendor : UPCSAndOffer.offer.vendor;
            return UPCSAndOffer;
          });
        } else {
          let UPCSAndOffer = UPCSAndOfferPrefetch;
          UPCSAndOffer.vendor = UPCSAndOfferPrefetch.offer.vendor;
          return UPCSAndOffer;
        }
      },
      FirstStoresForLocationPromiseWrapper: function ($api, $stateParams, LocationData, UPCSAndOffer) {
        const wrapper = {};
        let latitude = $stateParams.latitide || (LocationData && LocationData.latitude);
        let longitude = $stateParams.longitude || (LocationData && LocationData.longitude);
        let zip = $stateParams.zip || (LocationData && LocationData.zip);
        if (latitude && longitude && zip) {
          wrapper.promise = $api.getStoresForLocation(
            latitude,
            longitude,
            latitude,
            longitude,
            $stateParams.vendorId,
            true,
            zip,
            null,
            null,
            5,
            null,
            null,
            UPCSAndOffer.offer.id,
            $stateParams.countryCode
          );
        }
        return wrapper;
      },
      MapStylesJsonPrefetch: function ($http, StateParamsWidgetConfig) {
        if (StateParamsWidgetConfig && StateParamsWidgetConfig.mapStylesPath) {
          // Check cache first
          const cachedStyle = geocodingCache.getMapStyle(StateParamsWidgetConfig.mapStylesPath);
          if (cachedStyle) {
            return Promise.resolve(cachedStyle);
          }
          
          // If not cached, fetch and cache
          return $http.get(StateParamsWidgetConfig.mapStylesPath).then(function (data) {
            geocodingCache.cacheMapStyle(StateParamsWidgetConfig.mapStylesPath, data.data);
            return data.data;
          });
        }
      },
      MapStylesJson: function ($http, PixelConfig, StateParamsWidgetConfig, MapStylesJsonPrefetch) {
        if (
          (StateParamsWidgetConfig && StateParamsWidgetConfig.mapStylesPath) != PixelConfig.widgetConfig.mapStylesPath
        ) {
          // Check cache first
          const cachedStyle = geocodingCache.getMapStyle(PixelConfig.widgetConfig.mapStylesPath);
          if (cachedStyle) {
            return Promise.resolve(cachedStyle);
          }
          
          // If not cached, fetch and cache
          return $http.get(PixelConfig.widgetConfig.mapStylesPath).then(function (data) {
            geocodingCache.cacheMapStyle(PixelConfig.widgetConfig.mapStylesPath, data.data);
            return data.data;
          });
        } else {
          return MapStylesJsonPrefetch;
        }
      },
      MapLibrariesPreInject: function () {
        return window.MapLibrariesPreInject;
      },
      PotentialStoreZipsForLocation: function ($api, $q, $stateParams, LocationDataLowResolution, LocationData, $config, AppConfig) {
        if (!PARALLEL_PREFETCH_STORES) {
          return null;
        }

        let latitude = $stateParams.latitide || (LocationDataLowResolution && LocationDataLowResolution.latitude);
        let longitude = $stateParams.longitude || (LocationDataLowResolution && LocationDataLowResolution.longitude);
        let zip = $stateParams.zip || (LocationDataLowResolution && LocationDataLowResolution.zip);
        
        // Get countryCode from $stateParams, LocationData, or LocationDataLowResolution
        const countryCode = $stateParams.countryCode || 
                            (LocationData && LocationData.country_code) || 
                            (LocationDataLowResolution && LocationDataLowResolution.country_code);
        
        if (latitude && longitude && zip) {
          return $api
            .get(
              '/v1/potential-store-zips-for-location' +
                '?lat1=' +
                latitude +
                '&lng1=' +
                longitude +
                '&lat2=' +
                latitude +
                '&lng2=' +
                longitude +
                '&vendorId=' +
                $stateParams.vendorId +
                ($stateParams.offerId ? '&offerId=' + $stateParams.offerId : '') +
                '&zip=' +
                zip +
                (countryCode ? '&countryCode=' + countryCode : '') +
                '' +
                '&timeout=3000',
              { credentials: 'include', withCredentials: true },
              $config.STORES_URL
            )
            .then((resp) => {
              const zipBatchSize = (AppConfig['client-store-locator'] || {})['zip-batch-size-base'] || 8;
              return {
                zips: (resp && resp.zips) || [],
                zipBatches: Util.partition((resp && resp.zips) || [], zipBatchSize),
              };
            });
        } else {
          return {
            zips: [],
            zipBatches: [],
          };
        }
      },
      WeglotInit: function (UPCSAndOffer, $timeout, $rootScope) {
        let offer = UPCSAndOffer.offer;
        let hideLanguageSwitcher = offer.hideLanguageSwitcher;
        let languageTranslation = offer.languageTranslation;

        /*
          We want auto detect and switch to default browser or device language on some offers, e.g., minis canada.
          In this case, we use 'auto' for languageTranslation value.
          'auto', 'en', 'fr', ...
          */
        if (languageTranslation === 'auto') {
          const deviceLanguage = window.navigator.language || '';
          if (deviceLanguage.startsWith('en')) {
            languageTranslation = 'en';
          } else if (deviceLanguage.startsWith('fr')) {
            languageTranslation = 'fr';
          } else if (deviceLanguage.startsWith('es')) {
            languageTranslation = 'es';
          } else {
            languageTranslation = 'en';
          }
        }

        if (!!languageTranslation) {
          Weglot.initialize({
            api_key: 'wg_1ecf050fb94882e0b6607643b16501899',
            hide_switcher: !!hideLanguageSwitcher,
            auto_switch: true,
            auto_switch_fallback: languageTranslation,
            cache: true,
            wait_transition: true,
          });
          let resolve = null;

          // Don't progress into the controller until weglot is initialized and the language is switched
          const weglotInitPromise = new Promise(function (_resolve, reject) {
            resolve = () => {
              $timeout(() => {
                _resolve(Weglot);
              }, 0);
            };
          });

          const switchToLang = () => {
            $timeout(() => {
              Weglot.switchTo(languageTranslation);
            }, 0);
          };
          // resolve the promise, allowing the controller to start, only *after* Weglot
          // is done switching languages
          Weglot.on('languageChanged', resolve);
          if (Weglot.initialized) {
            const currentLang = Weglot.getCurrentLang();
            if (currentLang == languageTranslation) {
              resolve();
            } else {
              switchToLang();
            }
          } else {
            Weglot.on('initialized', () => {
              switchToLang();
            });
          }
          return weglotInitPromise;
        } else {
          return null;
        }
      },
      ParallelStoresForLocationPromiseWrapper: function (
        $api,
        $stateParams,
        LocationData,
        PotentialStoreZipsForLocation,
        UPCSAndOffer
      ) {
        if (!PARALLEL_PREFETCH_STORES) {
          return null;
        }

        if (!PotentialStoreZipsForLocation || !PotentialStoreZipsForLocation.zipBatches) {
          return null;
        }
        let latitude = $stateParams.latitide || (LocationData && LocationData.latitude);
        let longitude = $stateParams.longitude || (LocationData && LocationData.longitude);
        let zip = $stateParams.zip || (LocationData && LocationData.zip);
        if (!latitude || !longitude || !zip) {
          return;
        }

        return Object.fromEntries(
          PotentialStoreZipsForLocation.zipBatches.map((zipsBatch, idx) => {
            return [
              JSON.stringify(zipsBatch),
              Util.delay(Math.floor(idx / 4) * 25).then(() =>
                $api.getStoresForLocation(
                  latitude,
                  longitude,
                  latitude,
                  longitude,
                  $stateParams.vendorId,
                  false,
                  null,
                  null,
                  null,
                  zipsBatch.length,
                  null,
                  zipsBatch,
                  UPCSAndOffer.offer.id,
                  $stateParams.countryCode
                )
              ),
            ];
          })
        );
      },
    }),
  });

  $stateProvider.state({
    name: 'react-product-locator',
    url: '/react-product-locator/{vendorId}?path&zip&moreAccurateGeo&cold&include&exclude&key&latitude&longitude&address&stylesheet&sold_at&pb&mode&productLocatorTemplate&v&config&label&offerId&widgetId&singleItemSelect',
    templateUrl: '/html/react-product-locator.html',
    controller:  'ProductLocatorController',
    resolve: Object.assign({}, whereToBuyResolves, {
      PageLoad: function ($api, $stateParams, UPCSAndOffer, WeglotInit) {
        if (window.pearPageLoad) {
          return window.pearPageLoad;
        }
        
        return $api.post('/v1/page_load?timeout=2000', {
            admin: !!window.admin,
            offerId: (UPCSAndOffer.offer || {}).id || $stateParams.offerId || vendorId,
            params: window.location.search,
            cookie: document.cookie,
            hostname: window.location.hostname,
            notAsync: true,
          },
          { failure: { id: -1, sessionId: -1 } }
        );
      },
      PixelConfigFromState: async function ($stateParams, $api) {
        let ret = null;
        if ($stateParams.vendorId && $stateParams.widgetId) {
          let VendorWidgets = await $api.get(`/v1/vendor-widgets?vendorId=${$stateParams.vendorId}&timeout=3000`);
          if (VendorWidgets && VendorWidgets.widgetConfigs && VendorWidgets.widgetConfigs.length >= 1) {
            Object.entries(VendorWidgets.widgetConfigs).forEach((e) => {
              if (e[1] && e[1].id == $stateParams.widgetId) {
                ret = e[1];
              }
            });
          }
        }
        return ret;
      },

      PixelConfig: function ($stateParams, $api, UPCSAndVendor, StateParamsWidgetConfig, PixelConfigFromState) {
        let pixelConfigBase = (UPCSAndVendor && UPCSAndVendor.vendor && UPCSAndVendor.vendor.pixelMapping) || {};
        let widgetConfig = null;

        if (StateParamsWidgetConfig) {
          widgetConfig = StateParamsWidgetConfig;
        } else if (pixelConfigBase.widgetConfigsByLabel && $stateParams.label && $stateParams.label) {
          widgetConfig = pixelConfigBase.widgetConfigsByLabel[$stateParams.label] || {};
        } else if (PixelConfigFromState) {
          widgetConfig = PixelConfigFromState;
        } else {
          widgetConfig =
            (pixelConfigBase.widgetConfigsByLabel && pixelConfigBase.widgetConfigsByLabel.default) ||
            pixelConfigBase.widgetConfig ||
            (pixelConfigBase.widgetConfigsByLabel && Object.entries(pixelConfigBase.widgetConfigsByLabel)[0][1]) ||
            {};
        }
        return Object.assign({}, pixelConfigBase, {
          widgetConfig: widgetConfig || {},
        });
      },
      StateParamsWidgetConfig: function ($stateParams) {
        return $stateParams.config && JSON.parse($stateParams.config);
      },
      UPCSAndVendor: function (UPCSAndOfferPrefetch) {
        if (UPCSAndOfferPrefetch) {
          return {
            UPCs: UPCSAndOfferPrefetch.UPCs,
            offer: UPCSAndOfferPrefetch.offer,
            vendor: (UPCSAndOfferPrefetch.offer || {}).vendor,
          };
        } else {
          return {};
        }
      },
      UPCSAndOfferPrefetch: function ($api, $stateParams, StateParamsWidgetConfig) {
        if (!$stateParams.offerId) {
          let venorId = $stateParams.vendorId || (StateParamsWidgetConfig && StateParamsWidgetConfig.vendorId);
          if (venorId) {
            return $api.get(
              '/v1/upcs_and_offer_store_locator/' +
                ($stateParams.vendorId ||
                  (StateParamsWidgetConfig && StateParamsWidgetConfig.vendorId) + '?timeout=3000')
            );
          }
        }
      },
      UPCSAndOfferFromState: function ($stateParams, $api) {
        if ($stateParams.offerId) {
          return $api
            .get('/v1/upcs_and_offer_store_locator/' + $stateParams.offerId + '?timeout=3000')
            .then((UPCSAndOffer) => {
              UPCSAndOffer.vendor = UPCSAndOffer.offer.vendor;
              return UPCSAndOffer;
            });
        }
        return null;
      },
      UPCSAndOffer: function ($stateParams, UPCSAndOfferPrefetch, PixelConfig, $api, UPCSAndOfferFromState) {
        if (UPCSAndOfferFromState) {
          return UPCSAndOfferFromState;
        }
        let offerId = PixelConfig.widgetConfig.offerId || $stateParams.vendorId;
        if (offerId && (!UPCSAndOfferPrefetch || PixelConfig.widgetConfig.offerId != $stateParams.vendorId)) {
          return $api.get('/v1/upcs_and_offer_store_locator/' + offerId + '?timeout=3000').then((UPCSAndOffer) => {
            UPCSAndOffer.vendor = UPCSAndOfferPrefetch ? UPCSAndOfferPrefetch.offer.vendor : UPCSAndOffer.offer.vendor;
            return UPCSAndOffer;
          });
        } else {
          let UPCSAndOffer = UPCSAndOfferPrefetch;
          UPCSAndOffer.vendor = UPCSAndOfferPrefetch.offer.vendor;
          return UPCSAndOffer;
        }
      },
      FirstStoresForLocationPromiseWrapper: function ($api, $stateParams, LocationData, UPCSAndOffer) {
        const wrapper = {};
        let latitude = $stateParams.latitide || (LocationData && LocationData.latitude);
        let longitude = $stateParams.longitude || (LocationData && LocationData.longitude);
        let zip = $stateParams.zip || (LocationData && LocationData.zip);
        if (latitude && longitude && zip) {
          wrapper.promise = $api.getStoresForLocation(
            latitude,
            longitude,
            latitude,
            longitude,
            $stateParams.vendorId,
            true,
            zip,
            null,
            null,
            5,
            null,
            null,
            UPCSAndOffer.offer.id
          );
        }
        return wrapper;
      },
      MapStylesJsonPrefetch: function ($http, StateParamsWidgetConfig) {
        if (StateParamsWidgetConfig && StateParamsWidgetConfig.mapStylesPath) {
          // Check cache first
          const cachedStyle = geocodingCache.getMapStyle(StateParamsWidgetConfig.mapStylesPath);
          if (cachedStyle) {
            return Promise.resolve(cachedStyle);
          }
          
          // If not cached, fetch and cache
          return $http.get(StateParamsWidgetConfig.mapStylesPath).then(function (data) {
            geocodingCache.cacheMapStyle(StateParamsWidgetConfig.mapStylesPath, data.data);
            return data.data;
          });
        }
      },
      MapStylesJson: function ($http, PixelConfig, StateParamsWidgetConfig, MapStylesJsonPrefetch) {
        if (
          (StateParamsWidgetConfig && StateParamsWidgetConfig.mapStylesPath) != PixelConfig.widgetConfig.mapStylesPath
        ) {
          // Check cache first
          const cachedStyle = geocodingCache.getMapStyle(PixelConfig.widgetConfig.mapStylesPath);
          if (cachedStyle) {
            return Promise.resolve(cachedStyle);
          }
          
          // If not cached, fetch and cache
          return $http.get(PixelConfig.widgetConfig.mapStylesPath).then(function (data) {
            geocodingCache.cacheMapStyle(PixelConfig.widgetConfig.mapStylesPath, data.data);
            return data.data;
          });
        } else {
          return MapStylesJsonPrefetch;
        }
      },
      MapLibrariesPreInject: function () {
        return window.MapLibrariesPreInject;
      },
      PotentialStoreZipsForLocation: function ($api, $q, $stateParams, LocationDataLowResolution, $config, AppConfig) {
        if (!PARALLEL_PREFETCH_STORES) {
          return null;
        }

        let latitude = $stateParams.latitide || (LocationDataLowResolution && LocationDataLowResolution.latitude);
        let longitude = $stateParams.longitude || (LocationDataLowResolution && LocationDataLowResolution.longitude);
        let zip = $stateParams.zip || (LocationDataLowResolution && LocationDataLowResolution.zip);
        if (latitude && longitude && zip) {
          return $api
            .get(
              '/v1/potential-store-zips-for-location' +
                '?lat1=' +
                latitude +
                '&lng1=' +
                longitude +
                '&lat2=' +
                latitude +
                '&lng2=' +
                longitude +
                '&vendorId=' +
                $stateParams.vendorId +
                ($stateParams.offerId ? '&offerId=' + $stateParams.offerId : '') +
                '&zip=' +
                zip +
                '' +
                '&timeout=3000',
              { credentials: 'include', withCredentials: true },
              $config.STORES_URL
            )
            .then((resp) => {
              const zipBatchSize = (AppConfig['client-store-locator'] || {})['zip-batch-size-base'] || 8;
              return {
                zips: (resp && resp.zips) || [],
                zipBatches: Util.partition((resp && resp.zips) || [], zipBatchSize),
              };
            });
        } else {
          return {
            zips: [],
            zipBatches: [],
          };
        }
      },
      WeglotInit: function (UPCSAndOffer, $timeout, $rootScope) {
        let offer = UPCSAndOffer.offer;
        let hideLanguageSwitcher = offer.hideLanguageSwitcher;
        let languageTranslation = offer.languageTranslation;

        /*
          We want auto detect and switch to default browser or device language on some offers, e.g., minis canada.
          In this case, we use 'auto' for languageTranslation value.
          'auto', 'en', 'fr', ...
          */
        if (languageTranslation === 'auto') {
          const deviceLanguage = window.navigator.language || '';
          if (deviceLanguage.startsWith('en')) {
            languageTranslation = 'en';
          } else if (deviceLanguage.startsWith('fr')) {
            languageTranslation = 'fr';
          } else if (deviceLanguage.startsWith('es')) {
            languageTranslation = 'es';
          } else {
            languageTranslation = 'en';
          }
        }

        if (!!languageTranslation) {
          Weglot.initialize({
            api_key: 'wg_1ecf050fb94882e0b6607643b16501899',
            hide_switcher: !!hideLanguageSwitcher,
            auto_switch: true,
            auto_switch_fallback: languageTranslation,
            cache: true,
            wait_transition: true,
          });
          let resolve = null;

          // Don't progress into the controller until weglot is initialized and the language is switched
          const weglotInitPromise = new Promise(function (_resolve, reject) {
            resolve = () => {
              $timeout(() => {
                _resolve(Weglot);
              }, 0);
            };
          });

          const switchToLang = () => {
            $timeout(() => {
              Weglot.switchTo(languageTranslation);
            }, 0);
          };
          // resolve the promise, allowing the controller to start, only *after* Weglot
          // is done switching languages
          Weglot.on('languageChanged', resolve);
          if (Weglot.initialized) {
            const currentLang = Weglot.getCurrentLang();
            if (currentLang == languageTranslation) {
              resolve();
            } else {
              switchToLang();
            }
          } else {
            Weglot.on('initialized', () => {
              switchToLang();
            });
          }
          return weglotInitPromise;
        } else {
          return null;
        }
      },
      ParallelStoresForLocationPromiseWrapper: function (
        $api,
        $stateParams,
        LocationData,
        PotentialStoreZipsForLocation,
        UPCSAndOffer
      ) {
        if (!PARALLEL_PREFETCH_STORES) {
          return null;
        }

        if (!PotentialStoreZipsForLocation || !PotentialStoreZipsForLocation.zipBatches) {
          return null;
        }
        let latitude = $stateParams.latitide || (LocationData && LocationData.latitude);
        let longitude = $stateParams.longitude || (LocationData && LocationData.longitude);
        let zip = $stateParams.zip || (LocationData && LocationData.zip);
        if (!latitude || !longitude || !zip) {
          return;
        }

        return Object.fromEntries(
          PotentialStoreZipsForLocation.zipBatches.map((zipsBatch, idx) => {
            return [
              JSON.stringify(zipsBatch),
              Util.delay(Math.floor(idx / 4) * 25).then(() =>
                $api.getStoresForLocation(
                  latitude,
                  longitude,
                  latitude,
                  longitude,
                  $stateParams.vendorId,
                  false,
                  null,
                  null,
                  null,
                  zipsBatch.length,
                  null,
                  zipsBatch,
                  UPCSAndOffer.offer.id
                )
              ),
            ];
          })
        );
      },
    }),
  });

  $stateProvider.state({
    name: 'RedirectState',
    parent: 'Base',
    url: '/redirect?redirect',
    template: '<div ui-view></div>',
    controller: function ($stateParams) {
      window.location = $stateParams.redirect;
    },
  });

  $stateProvider.state({
    name: 'old-dutch-wtb',
    url: '/old-dutch-wtb/{offerId}?path&zip&moreAccurateGeo&cold&include&exclude&key&latitude&longitude&stylesheetHref&address&stylesheet&&sold_at&pb&mode',
    templateUrl: '/html/old-dutch-wtb.html',
    controller: pickerController,
    resolve: Object.assign(pickerResolves, {
      LocationData: function ($api, $stateParams, PixelConfig) {
        if (!Util.getCookiePreferences().functional) {
          return false;
        }
        if (!$stateParams.zip) {
          return $api.getIpLocationData({
            moreAccurateGeo:
              !!$stateParams.moreAccurateGeo ||
              (PixelConfig && PixelConfig.widgetConfig ? !!PixelConfig.widgetConfig.moreAccurateGeo : false) ||
              (PixelConfig ? !!PixelConfig.moreAccurateGeo : false),
          });
        } else {
          return $api.getZipLocationData($stateParams.zip, $stateParams.countryCode);
        }
      },
    }),
  });

  // TODO: Temp redirect stuff for Siete
  $stateProvider.state({
    name: 'RedirectPuffSnacks',
    url: '/PuffSnacks',
    template: '<div ui-view></div>',
    controller: function ($state) {
      $state.go(
        'picker',
        { offerId: 2271819443031264 },
        {
          location: false,
        }
      );
    },
  });

  $stateProvider.state({
    name: 'out-of-stock',
    url: '/out-of-stock',
    templateUrl: '/html/out-of-stock.html',
    parent: 'CenterBox',
  });
});

const expandCondensedZipRetailerList = (condensedZipRetailerListData) => {
  if (
    !condensedZipRetailerListData ||
    !condensedZipRetailerListData.retailers ||
    !condensedZipRetailerListData.upcs ||
    !condensedZipRetailerListData.zipToRetailerIdToAvailableUPCIds
  ) {
    return null;
  }
  let zipToPickerRetailers = null;
  const idsToRetailers = Object.fromEntries(condensedZipRetailerListData.retailers.map((r) => [r.id, r]));
  const idsToUPCs = Object.fromEntries(condensedZipRetailerListData.upcs.map((u) => [u.id, u]));
  Object.entries(condensedZipRetailerListData.zipToRetailerIdToAvailableUPCIds).forEach(
    ([zip, retailerIdsToUPCIds]) => {
      zipToPickerRetailers = zipToPickerRetailers || {};
      const pickerRetailers = [];
      Object.entries(retailerIdsToUPCIds).forEach(([rid, upcIds]) => {
        const retailer = Object.assign({}, idsToRetailers[rid]);
        pickerRetailers.push(retailer);
        const upcs = (retailer.upcs = retailer.upcs || []);
        upcIds.forEach((upcId) => {
          const upc = Object.assign({}, idsToUPCs[upcId]);
          upc.status = 'AVAILABLE';
          upc.url = upc.urlsByRetailerId[retailer.id];
          upc.urlsByRetailerId = null;
          upcs.push(upc);
        });
        zipToPickerRetailers[zip] = pickerRetailers;
      });
    }
  );

  // zip -> array of retailer w/ upcs
  return zipToPickerRetailers;
};

},{"../../js/offers/brand/enriched_category.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/enriched_category.js","../parseuri.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js","../pear-console.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js","../storage.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js","../utilities":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","../utilities.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","./geocoding-cache.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/geocoding-cache.js","./map-utils.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/map-utils.js","./molson.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/molson.js","./ng-async.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/ng-async.js","./stadia-maps-config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/stadia-maps-config.js","./templateProvider/pickerTemplateProvider.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/templateProvider/pickerTemplateProvider.js","lazysizes":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/lazysizes/lazysizes.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/product-locator-utils.js":[function(_dereq_,module,exports){
// -- strings / links --

/** Truthy, non-blank string guard */
const isNonBlankString = (value) => !!(value && String(value).trim().length);

/** Build a tel: link or '#' if not present */
const toPhoneHref = (store) =>
  store && store.phone ? `tel:${String(store.phone).replace(/\D/g, '')}` : '#';


// -- images / CDN --

/** Replace old Pear asset hosts with the image processor, optionally appending query */
const patchCdnImageUrl = (url, query = '') => {
  if (!url) return url;
  if (!/(assets|demos|assets-cf|demos-cf-1)\.pearcommerce\.com/.test(url)) return url;
  const patched = url
    .replace('s3.amazonaws.com/', '')
    .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
    .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
    .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
    .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
  return query ? `${patched}${patched.includes('?') ? '&' : '?'}${query.replace(/^\?/, '')}` : patched;
};


// -- data shaping --

/**
 * Expand the condensed zip→retailer→upc list into:
 *   { [zip]: Array<{...retailer, upcs: Array<{...upc, status:'AVAILABLE', url:string}> }> }
 */
const expandCondensedZipRetailerList = (data) => {
  if (!data || !data.retailers || !data.upcs || !data.zipToRetailerIdToAvailableUPCIds) {
    return null;
  }

  const idToRetailer = Object.fromEntries(data.retailers.map((retailer) => [retailer.id, retailer]));
  const idToUpc = Object.fromEntries(data.upcs.map((upc) => [upc.id, upc]));

  const resultByZip = {};
  Object.entries(data.zipToRetailerIdToAvailableUPCIds).forEach(([zip, retailerIdToUpcIds]) => {
    const pickerRetailers = [];
    Object.entries(retailerIdToUpcIds).forEach(([retailerId, upcIds]) => {
      const retailerCopy = { ...idToRetailer[retailerId] };
      const upcList = (retailerCopy.upcs = retailerCopy.upcs || []);
      upcIds.forEach((upcId) => {
        const upcCopy = { ...idToUpc[upcId] };
        upcCopy.status = 'AVAILABLE';
        upcCopy.url = upcCopy.urlsByRetailerId?.[retailerCopy.id];
        upcCopy.urlsByRetailerId = null;
        upcList.push(upcCopy);
      });
      pickerRetailers.push(retailerCopy);
    });
    resultByZip[zip] = pickerRetailers;
  });

  return resultByZip; // zip -> array of retailers w/ upcs
};

/** Map array of retailer objects to a map keyed by nameEnum; also attach a UPC lookup per retailer */
const mapListByRetailer = (pickerList) =>
  Object.fromEntries(
    Object.values(pickerList || []).map((retailer) => {
      retailer.upcMap = Object.fromEntries((retailer.upcs || []).map((upc) => [upc.UPC, upc]));
      return [retailer.nameEnum, retailer];
    })
  );

/** Remove retailers that have zero AVAILABLE (or in-store AVAILABLE) UPCs */
const removeUnavailableRetailers = (retailerList) => {
  if (!Array.isArray(retailerList)) return;
  for (let index = 0; index < retailerList.length; index++) {
    const retailer = retailerList[index];
    let allUnavailable = true;
    if (retailer && Array.isArray(retailer.upcs)) {
      for (let j = 0; j < retailer.upcs.length; j++) {
        const hasAvailability =
          retailer.upcs[j].status === 'AVAILABLE' || retailer.upcs[j].inStoreStatus === 'AVAILABLE';
        if (hasAvailability) {
          allUnavailable = false;
          break;
        }
      }
    }
    if (allUnavailable) {
      retailerList.splice(index, 1);
      index--;
    }
  }
};

/** Given lat/lng, build a small bounding box, used before a map instance exists */
const getInitialBoundsFromCoords = (latitude, longitude, delta = 0.12) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!isFinite(lat) || !isFinite(lng)) return null;
  return {
    southWest: { lat: lat - delta, lng: lng - delta },
    northEast: { lat: lat + delta, lng: lng + delta },
    center: { lat, lng },
  };
};


// -- “link family” predicates / memoization --

const isInstacartLink = (url = '') => /(?:^|\.)instacart\.com\//i.test(url);
const isDoorDashLink = (url = '') => /(doordash\.com|drd\.sh)\//i.test(url);

/**
 * Given a retailer name and upc array, check if ALL links match a predicate.
 * Results memoized by retailer name in `memo`.
 */
const doAllLinksForRetailerPass = (retailerName, retailerUPCs, predicate, memo) => {
  const key = retailerName || 'UNKNOWN';
  if (memo[key] === true || memo[key] === false) return memo[key];

  const links = (retailerUPCs || []).reduce((acc, upc) => {
    if (!upc) return acc;
    if (typeof upc === 'string') acc.push(upc);
    else if (upc.url) acc.push(upc.url);
    else if (upc.link) acc.push(upc.link);
    else if (Array.isArray(upc.urls)) acc.push(...upc.urls);
    return acc;
  }, []);

  if (!links.length) return (memo[key] = false);
  const allPass = links.every((href) => predicate(href));
  memo[key] = allPass;
  return allPass;
};

// -- array utilities --

/** Shuffle an array using Fisher-Yates algorithm */
const shuffleArray = (array) => {
  const shuffled = [...array];
  let currentIndex = shuffled.length;
  let randomIndex;

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [shuffled[currentIndex], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[currentIndex]];
  }

  return shuffled;
};

// -- parameter utilities --

/** Get vendor ID safely from state params */
const getVendorIdSafe = (stateParams) => (stateParams && stateParams.vendorId) || null;

/** Get postal code from various sources with fallback */
const getPostalCodeSafe = (location, zip, stateParams) => {
  if (location && location.zip) return location.zip;
  if (zip) return zip;
  if (stateParams && stateParams.zip) return stateParams.zip;
  return null;
};

/** Get UPC count safely with fallback to resolved data */
const getUpcCountSafe = (upcs, upcsAndOffer) => {
  if (Array.isArray(upcs) && upcs.length > 0) return upcs.length;
  const fromResolves = (upcsAndOffer && (upcsAndOffer.UPCs || upcsAndOffer.upcs)) || [];
  return Array.isArray(fromResolves) ? fromResolves.length : 0;
};

/** Get initial bounds from scope data */
const getInitialBoundsFromScope = (latitude, longitude) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  if (!isFinite(lat) || !isFinite(lng)) return null;

  const delta = 0.12; // ~zoom 13.5
  return {
    southWest: { lat: lat - delta, lng: lng - delta },
    northEast: { lat: lat + delta, lng: lng + delta },
    center: { lat, lng },
  };
};

// -- status utilities --

/** Get list of retailers that have pending UPCs */
const getPendingList = (pickerList) => {
  const pendingList = [];
  for (let i = 0; i < pickerList.length; i++) {
    for (let j = 0; j < pickerList[i].upcs.length; j++) {
      if (pickerList[i].upcs[j].status == 'PENDING') {
        pendingList.push(pickerList[i]);
        break;
      }
    }
  }
  return pendingList;
};

/** Check if any retailers have pending status */
const containsPendingStatus = (pickerList) => {
  const pendingList = getPendingList(pickerList);
  return pendingList.length > 0;
};

// -- upc processing utilities --

/** Process UPC image URL for CDN optimization */
const processUpcImageUrl = (upc, resizeImages) => {
  if (
    resizeImages &&
    upc.imageUrl &&
    (upc.imageUrl.indexOf('assets.pearcommerce.com') != -1 ||
      upc.imageUrl.indexOf('demos.pearcommerce.com') != -1 ||
      upc.imageUrl.indexOf('assets-cf.pearcommerce.com') != -1 ||
      upc.imageUrl.indexOf('demos-cf-1.pearcommerce.com') != -1)
  ) {
    upc.imageUrl = upc.imageUrl
      .replace('s3.amazonaws.com/', '')
      .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
  }
  return upc;
};

// -- retailer display utilities --

/** Check if retailer should be displayed based on filter settings */
const shouldDisplayRetailer = (retailer, filterOutVendor) => {
  if (filterOutVendor && retailer?.isVendor) return false;
  return true;
};

/** Get retailer status for a specific UPC */
const getRetailerStatus = (retailer, upc, offer, inProductLocator) => {
  if (typeof retailer == 'undefined' || !retailer) {
    return 'UNAVAILABLE';
  }
  
  let requireInstore = retailer.nameEnum == 'walmart' && offer && !offer.allowOnlineOnlyForWalmart && false;
  let foundPending = false;
  
  for (let i = 0; i < retailer.upcs.length; i++) {
    if (
      retailer.upcs[i].pearLogicalUPCId == upc.pearLogicalUPCId ||
      (inProductLocator && retailer.upcs[i].UPC == upc.UPC)
    ) {
      if (
        (!requireInstore && retailer.upcs[i].status == 'AVAILABLE') ||
        retailer.upcs[i].inStoreStatus == 'AVAILABLE'
      ) {
        return 'AVAILABLE';
      } else if (retailer.upcs[i].status == 'PENDING') {
        foundPending = true;
      }
    }
  }
  
  upc.multiSelected = false;
  return foundPending ? 'PENDING' : 'UNAVAILABLE';
};

/** Check if individual Instacart link should be shown */
const shouldShowIndividualInstacartLink = (retailerName, upcURL, memoizedInstacartLinksByRetailer) => {
  const memoizedRetailerAllICLinks = memoizedInstacartLinksByRetailer[retailerName];
  if (memoizedRetailerAllICLinks === true) return false;
  return isInstacartLink(upcURL);
};

/** Check if individual DoorDash link should be shown */
const shouldShowIndividualDDLink = (retailerName, upcURL, memoizedDoorDashLinksByRetailer) => {
  const memoizedRetailerAllDDLinks = memoizedDoorDashLinksByRetailer[retailerName];
  if (memoizedRetailerAllDDLinks === true) return false;
  return isDoorDashLink(upcURL);
};

/** Trim UPC name based on prefix and product line */
const trimUpcName = (upc, prefix, showProductLine) => {
  if (!upc) return;
  if (prefix && upc.name && upc.name.indexOf(prefix) === 0) upc.shortName = upc.name.substring(prefix.length);
  else upc.shortName = upc.name;
  if (showProductLine && upc.productLine && upc.name.indexOf(upc.productLine) === 0) {
    upc.shortName = upc.name.substring(upc.productLine.length);
    upc.name = upc.name.substring(upc.productLine.length);
  }
};

// -- map utilities --

/** Calculate next zoom level for store selection */
const calculateNextZoom = (curZoom, estimatedNumShownStores, isMobile, selectedStore, store, hover, ZOOM_IN_ON_STORE) => {
  if (!hover && ZOOM_IN_ON_STORE && curZoom != null) {
    const ZOOM_STORE_COUNT_CEILING = 75;
    const zoomMultiplier = Math.min(ZOOM_STORE_COUNT_CEILING, estimatedNumShownStores) / ZOOM_STORE_COUNT_CEILING;
    const zoomFloor = 12.5 + 2 * zoomMultiplier;
    const zoomCeiling = (isMobile ? 12.5 : 16) + 2 * zoomMultiplier;
    const weightedAvg = curZoom * (1 - zoomMultiplier) + zoomCeiling * zoomMultiplier;
    return isMobile || selectedStore === store
      ? curZoom
      : Math.max(curZoom, Math.min(zoomFloor, weightedAvg));
  }
  return curZoom;
};

/** Fly to marker on map */
const flyToMarker = (map, store, nextZoom, mapOnly, clickStore, isMobile, hover) => {
  try {
    if (map && (mapOnly || clickStore || !isMobile)) {
      const duration = 800;
      map.fire && map.fire('flystart');
      map.flyTo &&
        map.flyTo({
          center: store.flyout.getLngLat(),
          offset: isMobile ? [0, 90] : [20, 80],
          zoom: nextZoom,
          duration,
          essential: !hover,
        });
    }
  } catch (err) {
    /* no-op */
  }
};

// -- resource loading utilities --

/** Load MapLibre script if not already loaded */
const loadMapLibreScript = () => {
  try {
    const src = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.js';
    let script = document.querySelector(`script[src="${src}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = src;
      document.head.appendChild(script);
    }
  } catch (e) {
    console.error(e);
  }
};

/** Load Bootstrap CSS if not already loaded */
const loadBootstrapCSS = () => {
  return new Promise((resolve) => {
    try {
      const href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css';
      let stylesheet = document.querySelector(`link[href="${href}"]`);
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.href = href;
        stylesheet.rel = 'stylesheet';
        stylesheet.onload = () => resolve(true);
        document.head.appendChild(stylesheet);
      } else {
        resolve(true);
      }
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });
};

/** Load MapLibre CSS if not already loaded */
const loadMapLibreCSS = () => {
  return new Promise((resolve) => {
    try {
      const href = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.css';
      let stylesheet = document.querySelector(`link[href="${href}"]`);
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.href = href;
        stylesheet.rel = 'stylesheet';
        stylesheet.onload = () => resolve(true);
        document.head.appendChild(stylesheet);
      } else {
        resolve(true);
      }
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });
};


/** Process buy online map for React */
const processBuyOnlineMap = (list, pickerListDisplayCached, isInstacartLinkInLogicalUPCs, isDoorDashLinkInLogicalUPCs) => {
  if (!list || !list.length) return {};

  var map = {};

  list.forEach(function (logicalUPC) {
    var rows = (pickerListDisplayCached && pickerListDisplayCached(logicalUPC, true)) || [];
    var offers = [];

    rows.forEach(function (r) {
      // pick the first UPC link (legacy renders from r.upcs[0])
      var upc = r.upcs && r.upcs.length ? r.upcs[0] : null;
      var url = upc && upc.url ? upc.url : '';
      if (!url) return;

      var offerObj = {
        name: r.name,
        url: url,
        logo: (r.style && (r.style.logo || r.style.whiteOnBlackLogo)) || undefined,
        priceText: r.priceText || undefined,
        via:
          isInstacartLinkInLogicalUPCs && isInstacartLinkInLogicalUPCs(r.upcs, logicalUPC)
            ? 'Instacart'
            : isDoorDashLinkInLogicalUPCs && isDoorDashLinkInLogicalUPCs(r.upcs, logicalUPC)
            ? 'DoorDash'
            : undefined,
        // Include additional fields needed for add_to_cart API - ensure these are always included
        nameEnum: r.nameEnum,
        retailerId: r.id,
        // Add UPC-related fields if UPC exists
        upcId: upc ? upc.id : undefined,
        availabilityId: upc ? upc.availabilityId : undefined,
        UPC: upc ? upc.UPC : undefined,
        pearLogicalUPCId: upc ? upc.pearLogicalUPCId : undefined,
        directAtc: upc ? upc.directAtc : undefined,
      };
      
      offers.push(offerObj);
    });

    var pid = logicalUPC.pearLogicalUPCId || logicalUPC.id || logicalUPC.logicalUPCId;
    if (pid) map[pid] = offers;
  });

  return map;
};

/** Check if logical UPC categories should be displayed */
const checkCategories = (logicalUPC, ignoreCategories) => {
  if (!logicalUPC?.categories?.length || !ignoreCategories?.length) return true;
  return !ignoreCategories.some((ignored) => logicalUPC.categories.includes(ignored));
};

/** Check if logical UPC product brand should be displayed */
const checkProductBrand = (logicalUPC, ignoreCategories) => {
  if (logicalUPC?.subBrand && ignoreCategories) return !ignoreCategories.includes(logicalUPC.subBrand);
  return true;
};

/** Check if retailer should be displayed for multi-select */
const getMultiSelectRetailers = (offer, pickerList, pearLogicalUPCs, shouldDisplayRetailer) => {
  if (!offer?.multiSelect || pickerList.length === 0) return [];
  
  const selectedCount = pearLogicalUPCs.filter(upc => upc.multiSelected).length;
  if (selectedCount === 0) return [];
  
  return pickerList.filter(retailer => shouldDisplayRetailer(retailer));
};

/** Check if UPC matches retailer requirements */
const isUpcAvailableForRetailer = (upc, pickerUPC, inProductLocator, requireInstore, buyOnline) => {
  const upcMatches = upc.pearLogicalUPCId === pickerUPC.pearLogicalUPCId || 
                    (inProductLocator && upc.UPC === pickerUPC.UPC);
  const isAvailable = ((!requireInstore || buyOnline) && upc.status === 'AVAILABLE') || 
                     upc.inStoreStatus === 'AVAILABLE';
  return upcMatches && isAvailable;
};

/** Process retailer for single UPC display */
const processRetailerForSingleUPC = (retailer, pickerUPC, offer, buyOnline, inProductLocator, shouldDisplayRetailer) => {
  if (!retailer) return null;
  
  const requireInstore = retailer.nameEnum === 'walmart' && 
                        (!offer || !offer.allowOnlineOnlyForWalmart) && false;
  
  for (let j = 0; j < retailer.upcs.length; j++) {
    const upc = retailer.upcs[j];
    if (isUpcAvailableForRetailer(upc, pickerUPC, inProductLocator, requireInstore, buyOnline)) {
      if (offer?.upcSortDefinesRetailerOrder) {
        retailer.style.sortOrder = upc.retailerSortOrder;
      }
      return retailer;
    }
  }
  return null;
};

/** Get single UPC retailers */
const getSingleUPCRetailers = (pickerUPC, pickerList, offer, buyOnline, inProductLocator, shouldDisplayRetailer, selectedPearLogicalUPC) => {
  if (!pickerUPC) pickerUPC = selectedPearLogicalUPC;
  if (!pickerUPC) return [];
  
  return pickerList
    .map(retailer => processRetailerForSingleUPC(retailer, pickerUPC, offer, buyOnline, inProductLocator, shouldDisplayRetailer))
    .filter(retailer => retailer !== null);
};

/** Build UPC ID to logical UPC mapping */
const buildUpcIdMapping = (pickerUPCs) => {
  const upcIdsToLogicalUPC = {};
  for (let i = 0; i < pickerUPCs.length; i++) {
    for (let j = 0; j < pickerUPCs[i].upcIds.length; j++) {
      upcIdsToLogicalUPC[pickerUPCs[i].upcIds[j]] = pickerUPCs[i];
    }
  }
  return upcIdsToLogicalUPC;
};

/** Preserve multi-selected state */
const preserveMultiSelectedState = (currentUPCs) => {
  const currentMultiSelectedState = {};
  if (currentUPCs) {
    currentUPCs.forEach((logicalUPC) => {
      currentMultiSelectedState[logicalUPC.pearLogicalUPCId] = logicalUPC.multiSelected;
    });
  }
  return currentMultiSelectedState;
};

/** Sort UPCs by various criteria */
const sortUPCs = (a, b, offer) => {
  if (offer?.productSortType === 'MANUAL' && a.sortOrder !== b.sortOrder) {
    return a.sortOrder - b.sortOrder;
  }

  if (!!a.name !== !!b.name) {
    return !!a.name ? -1 : 1;
  }

  if (!!a.imageUrl !== !!b.imageUrl) {
    return !!a.imageUrl ? -1 : 1;
  }

  if (a.name !== b.name) {
    return a.name.localeCompare(b.name);
  }

  if (a.UPC !== b.UPC) {
    return a.UPC.localeCompare(b.UPC);
  }

  return a.id - b.id;
};

/** Process UPC categories for display */
const processUPCCategories = (upc, upcsByName) => {
  const upcs = (upcsByName[upc.name] = upcsByName[upc.name] || []);
  upc.categories = upc.categories || [];
  
  upcs.forEach((otherUPC) => {
    otherUPC.categories = otherUPC.categories || [];
    otherUPC.categories.forEach((otherCategory) => {
      if (otherCategory && upc.categories.indexOf(otherCategory) === -1) {
        upc.categories.push(otherCategory);
      }
    });

    upc.categories.forEach((category) => {
      if (category && otherUPC.categories.indexOf(category) === -1) {
        otherUPC.categories.push(category);
      }
    });
  });
  
  upcs.push(upc);
  return upcs.length === 1;
};

/** Process image URL for resizing */
const processImageUrlForResizing = (upc) => {
  if (
    window.resizeImages &&
    upc.imageUrl &&
    (upc.imageUrl.indexOf('assets.pearcommerce.com') !== -1 ||
      upc.imageUrl.indexOf('demos.pearcommerce.com') !== -1 ||
      upc.imageUrl.indexOf('assets-cf.pearcommerce.com') !== -1 ||
      upc.imageUrl.indexOf('demos-cf-1.pearcommerce.com') !== -1)
  ) {
    upc.imageUrl = upc.imageUrl
      .replace('s3.amazonaws.com/', '')
      .replace('assets.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('demos.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('assets-cf.pearcommerce.com', 'image-processor.pearcommerce.com')
      .replace('demos-cf-1.pearcommerce.com', 'image-processor.pearcommerce.com');
  }
  return upc;
};

/** Initialize scope variables for map and stores */
const initializeMapAndStoresScope = ($scope, isSmallSizeScreen) => {
  $scope.storesDoneLoading = false;
  $scope.firstFullStoresFetchComplete = false;
  $scope.noStores = false;
  $scope.mapOnly = false;
  $scope.productsOpen = $scope.startWithProductFilterOpen;
  $scope.storeTypeCheck = true;

  // Make map tab default if mobile or small screen
  if (($scope.isMobileLayout || isSmallSizeScreen) && !$scope.singleItemSelect) {
    $scope.productsOpen = false;
    $scope.mapOnly = true;
  }
};

/** Setup store category toggle function */
const setupStoreCategoryToggle = ($scope) => {
  $scope.toggleStoreCategory = (category) => {
    const is818 = ($scope.vendor || {}).id === 2012254479241504;
    if (is818 && $scope.storeCategories['Bar'] != null && category === 'Restaurant') {
      $scope.storeCategories['Bar'] = !$scope.storeCategories['Bar'];
    }
    $scope.storeCategories[category] = !$scope.storeCategories[category];
  };
};

/** Calculate zip batch size based on UPC count */
const calculateZipBatchSize = (numUPCs, AppConfig) => {
  const baseZips = Math.min(
    +(AppConfig['client-store-locator'] || {})['zip-batch-size-max'] || 16,
    Math.max(1, Math.round(25 - numUPCs / 75))
  );

  const maxZipsByUPCSize = Math.max(
    2,
    Math.min(
      +(AppConfig['client-store-locator'] || {})['zip-batch-size-max'] || 16,
      30 - Math.floor(numUPCs / 60)
    )
  );

  return { baseZips, maxZipsByUPCSize };
};

/** Get map bounds and coordinates */
const getMapBoundsAndCoords = ($scope, getInitialBoundsFromScope) => {
  let lat1, lng1, lat2, lng2, cLat1, cLng1;
  let bounds = null;
  
  if ($scope.map && typeof $scope.map.getBounds === 'function') {
    try {
      bounds = typeof maplibregl !== 'undefined' && maplibregl.LngLatBounds
        ? maplibregl.LngLatBounds.convert($scope.map.getBounds())
        : null;
    } catch (_) {
      /* ignore */
    }
  }
  
  if (bounds) {
    lat1 = bounds.getSouthWest().lat;
    lng1 = bounds.getSouthWest().lng;
    lat2 = bounds.getNorthEast().lat;
    lng2 = bounds.getNorthEast().lng;
    if ($scope.map && typeof $scope.map.getCenter === 'function') {
      const centerArr = $scope.map.getCenter().toArray();
      cLng1 = centerArr[0];
      cLat1 = centerArr[1];
    } else {
      cLat1 = (lat1 + lat2) / 2;
      cLng1 = (lng1 + lng2) / 2;
    }
  } else {
    const fb = getInitialBoundsFromScope();
    if (!fb) {
      console.warn('[PL] updateMapStores: no map and no usable coords; aborting fetch.');
      return null;
    }
    lat1 = fb.southWest.lat;
    lng1 = fb.southWest.lng;
    lat2 = fb.northEast.lat;
    lng2 = fb.northEast.lng;
    cLat1 = fb.center.lat;
    cLng1 = fb.center.lng;
  }
  
  return { lat1, lng1, lat2, lng2, cLat1, cLng1 };
};

/** Build retailer list by zip mapping */
const buildRetailerListByZip = (retailerListsByZipAndSelectedUPCs, PASS_FULL_AVAILABILTIES_IN_BODY, Util) => {
  return Object.fromEntries(
    Object.entries(retailerListsByZipAndSelectedUPCs).map(([zip, retailerListsBySelectedUPCs]) => {
      retailerListsBySelectedUPCs = retailerListsBySelectedUPCs || {};
      let rs = null;

      if (retailerListsBySelectedUPCs['null']) {
        rs = retailerListsBySelectedUPCs['null'];
      }

      if (rs != null) {
        rs = rs.map((r) => {
          r = Object.assign({}, r);
          r.upcs = PASS_FULL_AVAILABILTIES_IN_BODY
            ? (r.upcs || [])
                .filter((upc) => upc.status == 'AVAILABLE' || upc.inStoreStatus == 'AVAILABLE')
                .map((upc) => Util.keepTruthy(Util.keepKeys(upc, ['id'])))
            : null;
          return Util.keepKeys(r, ['id', 'upcs']);
        });
      }

      return [zip, rs];
    })
  );
};

/** Process map store response */
const processMapStoreResponse = (resp, allProductsFetchedZips, selectedUPCs) => {
  const storesToAdd = resp.stores || [];
  const potentialZips = resp.potentialZips || [];
  const skippedZips = resp.skippedZips || [];
  const fetchedZips = resp.fetchedZips || [];

  if (!selectedUPCs) {
    fetchedZips.forEach((fetchedZip) => {
      if (allProductsFetchedZips.indexOf(fetchedZip) == -1) {
        allProductsFetchedZips.push(fetchedZip);
      }
    });
  }

  const zipToPickerRetailers = expandCondensedZipRetailerList(resp.availabilities || {});
  
  return { storesToAdd, potentialZips, skippedZips, fetchedZips, zipToPickerRetailers };
};

/** Mobile focus search button */
const mobileFocusSearch = () => {
  const n = document.querySelector('#search-button');
  n && n.focus();
};

/** Select map button for mobile */
const selectMapButtonForMobile = ($scope) => {
  $scope.mapOnly = true;
  const n = document.querySelector('#map-tab');
  n && n.focus();
};

/** Mobile focus navigation */
const mobileFocusNav = async () => {
  const activeMap = document.querySelector('#map-tab.active');
  const activeBuyOnlineTab = document.querySelector('#buy-online-tab.active');
  const activeInStoreTab = document.querySelector('#in-store-tab.active');
  if (activeMap) {
    (document.querySelector('#fly-over-retailer-name') || document.querySelector('#off-map-focus'))?.focus();
  } else if (activeBuyOnlineTab) {
    document.querySelector('div.buy-now>button')?.focus();
  } else if (activeInStoreTab) {
    document.querySelector('.store-list-nav ul > li.selected')?.focus();
  }
};

/** Mobile focus back navigation */
const mobileFocusBackNav = async () => {
  const activeMap = document.querySelector('#map-tab.active');
  const activeBuyOnlineTab = document.querySelector('#buy-online-tab.active');
  const activeInStoreTab = document.querySelector('#in-store-tab.active');
  if (activeMap) activeMap.focus();
  else if (activeBuyOnlineTab) activeBuyOnlineTab.focus();
  else if (activeInStoreTab) activeInStoreTab.focus();
};

/** Mobile focus up and off */
const mobileFocusUpAndOff = (mapOnly) => {
  const sel = mapOnly === true ? '.maplibregl-ctrl-zoom-out' : '#mobile-exit-up';
  document.querySelector(sel)?.focus();
};

/** Mobile focus down and off */
const mobileFocusDownAndOff = () => {
  document.querySelector('#off-map-focus')?.focus();
};

/** Mobile focus to filter */
const mobileFocusToFilter = () => {
  document.querySelector('.back-to-products')?.focus();
};

/** Mobile fly over focus off map */
const mobileFlyOverFocusOffMap = () => {
  document.querySelector('#off-map-focus')?.focus();
};

/** Setup scrolling listeners */
const setupScrollingListeners = ($scope, $timeout, disposers) => {
  let recentlyScrolledTimerID = null;
  
  document.querySelectorAll('.scrolling-container').forEach((el) => {
    const onScroll = () => {
      if (recentlyScrolledTimerID) clearTimeout(recentlyScrolledTimerID);
      recentlyScrolledTimerID = $timeout(() => {
        recentlyScrolledTimerID = null;
      }, 2000);
      $scope.cancelHoverStore(null);
    };
    el.addEventListener('scroll', onScroll);
    disposers.push(() => el.removeEventListener('scroll', onScroll));
  });
  
  return { recentlyScrolledTimerID };
};

/** Filter panel focus */
const filterPanelFocus = ($scope) => {
  if ($scope.productsOpen === true) {
    $scope.visitedLastProductTile = true;
    document.querySelector('.back-to-products')?.focus();
  }
};

/** Search button direct focus */
const searchButtonDirectFocus = async ($scope, Util) => {
  if ($scope.isMobileLayout === true) {
    const tab = document.querySelector('#in-store-tab');
    tab && tab.click();
    await Util.timeout(200);
    tab && tab.focus();
  } else if ($scope.focuseInStoreTab === true) {
    $scope.focuseInStoreTab = false;
    document.querySelector('#in-store-tab')?.focus();
  } else {
    document.querySelector('#off-map-focus')?.focus();
  }
};

/** Skip nav to in store results */
const skipNavToInStoreRes = async (Util) => {
  const t = document.querySelector('#in-store-tab');
  if (t) {
    t.click();
    await Util.timeout(200);
    t.focus();
  }
};

/** Load vendor override stylesheet */
const loadVendorOverrideStylesheet = ($rootScope) => {
  if ($rootScope.WIDGET_CONFIG.stylesheetPath) {
    let vendorOverride = document.querySelector('link.vendor-override');
    if (!vendorOverride) {
      const productLocatorStylesArray = document.querySelectorAll('link[href*="/css/product-locator"]');
      const productLocatorStyles = productLocatorStylesArray[productLocatorStylesArray.length - 1];
      if (productLocatorStyles) {
        vendorOverride = document.createElement('link');
        vendorOverride.rel = 'stylesheet';
        vendorOverride.href = $rootScope.WIDGET_CONFIG.stylesheetPath;
        vendorOverride.className = 'vendor-override';
        productLocatorStyles.parentNode.insertBefore(vendorOverride, productLocatorStyles.nextSibling);
      }
    }
  }
};

/** Set short names for UPCs and retailers */
const setShortName = (list, $scope, $rootScope, trimUpcName) => {
  const picker = list || $scope.pickerList;
  const prefix = ($scope.vendor && $scope.vendor.name) || $rootScope.WIDGET_CONFIG.vendorName;

  const trim = (upc) => trimUpcName(upc, prefix, $scope.showProductLine);

  if (!picker) return;
  picker.forEach((retailer) => {
    if (!retailer || !retailer.upcs) return;
    retailer.upcs.forEach(trim);
  });

  ($scope.pearLogicalUPCs || []).forEach(trim);
};

/** Apply CSS configuration to root element */
const applyCssConfiguration = (root, $rootScope, $scope) => {
  // Set basic font and color properties
  root.style.setProperty(
    '--font-family-sans-serif',
    $rootScope.WIDGET_CONFIG.fontFamily || '"Helvetica Neue", Helvetica, Arial, sans-serif'
  );
  root.style.setProperty(
    '--font-family-sans-serif-small',
    $rootScope.WIDGET_CONFIG.smallFontFamily || '"Helvetica Neue", Helvetica, Arial, sans-serif'
  );
  root.style.setProperty('--fg-color-1', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1 || '#595959');
  if ($rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2)
    root.style.setProperty('--fg-color-2', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2);
  if ($rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_3)
    root.style.setProperty('--fg-color-3', $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_3);

  if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1)
    root.style.setProperty('--accent-color-1', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1);
  if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2)
    root.style.setProperty('--accent-color-2', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2);
  if ($rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_3)
    root.style.setProperty('--accent-color-3', $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_3);

  // Handle height configuration
  $scope.blockPearFooter = !!$rootScope.WIDGET_CONFIG.blockPearFooter;
  if ($rootScope.WIDGET_CONFIG.fullScreen) {
    $rootScope.WIDGET_CONFIG.height = '100vh';
    $rootScope.WIDGET_CONFIG.mobileHeight = '100vh';
  }
  if ($scope.isMobile) {
    $rootScope.WIDGET_CONFIG.height = $rootScope.WIDGET_CONFIG.mobileHeight || '500px';
  }

  root.style.setProperty('--height', $rootScope.WIDGET_CONFIG.height || '800px');
  root.style.height = $rootScope.WIDGET_CONFIG.height || '800px';
  if ($rootScope.WIDGET_CONFIG.version === 3 && root.parentElement) {
    let p = root.parentElement;
    for (let i = 0; i < 3 && p; i++) {
      p.style.minHeight = $rootScope.WIDGET_CONFIG.height || '800px';
      p = p.parentElement;
    }
  }
  if ($rootScope.WIDGET_CONFIG.minHeight) {
    root.style.minHeight = $rootScope.WIDGET_CONFIG.minHeight;
  }
  $scope.height = $rootScope.WIDGET_CONFIG.height || '800px';

  // Set scope properties
  $scope.WIDGET_CONFIG = Object.assign({}, $rootScope.WIDGET_CONFIG);
  $scope.WIDGET_CONFIG.retailerDescription = $rootScope.WIDGET_CONFIG.retailerDescriptionsForStore || {};

  $scope.accentBg1 = { 'background-color': $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1 };
  $scope.accentBg2 = {
    'background-color': $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_BG_COLOR_1,
  };
  $scope.accentFg1 = { color: $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1 || '#595959' };
  $scope.accentFg2 = {
    color: $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
  };
  $scope.accentBtn = {
    'background-color': $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
    'border-color': $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_2 || $rootScope.WIDGET_CONFIG.ACCENT_FG_COLOR_1,
  };

  // Apply custom styles configuration
  if ($rootScope.WIDGET_CONFIG.customStylesConfig) {
    const g = $rootScope.WIDGET_CONFIG.customStylesConfig;
    
    // Text configuration
    if (g.textConfig) {
      const t = g.textConfig;
      if (t.textColor) root.style.setProperty('--text-color', t.textColor);
      if (t.textColorRetailerName) root.style.setProperty('--text-color-retailer-name', t.textColorRetailerName);
      if (t.textWeightRetailerName) root.style.setProperty('--text-weight-retailer-name', t.textWeightRetailerName);
      if (t.textSizeRetailerName) root.style.setProperty('--text-size-retailer-name', t.textSizeRetailerName);
      if (t.textColorProductLine) root.style.setProperty('--text-color-product-line', t.textColorProductLine);
      if (t.textColorProductTitle) root.style.setProperty('--text-color-product-title', t.textColorProductTitle);
      if (t.textColorProductFilter) {
        root.style.setProperty(
          '--text-color-product-filter-border-override',
          '1px solid ' + t.textColorProductFilter
        );
        root.style.setProperty('--text-color-product-filter', t.textColorProductFilter);
      }
      if (t.textColorActiveTabFilter)
        root.style.setProperty('--text-color-active-tab-filter', t.textColorActiveTabFilter);
      if (t.textColorMinorText) root.style.setProperty('--text-color-minor-text', t.textColorMinorText);
      if (t.textSizeProductLine) root.style.setProperty('--text-size-product-line', t.textSizeProductLine);
      if (t.textSizeProductTitle) root.style.setProperty('--text-size-product-title', t.textSizeProductTitle);
      if (t.textSizeFilterButton) root.style.setProperty('--text-size-filter-button', t.textSizeFilterButton);
      if (t.textSizeBuyOnlineCTA) root.style.setProperty('--text-size-buy-online-cta', t.textSizeBuyOnlineCTA);
      if (t.textColorBuyOnlineCTA) root.style.setProperty('--text-color-buy-online-cta', t.textColorBuyOnlineCTA);
      if (t.textSizeTab) root.style.setProperty('--text-size-tabs', t.textSizeTab);
      if (t.textWeightProductLine) root.style.setProperty('--text-weight-product-line', t.textWeightProductLine);
      if (t.textWeightProductCategory)
        root.style.setProperty('--text-weight-product-category', t.textWeightProductCategory);
      if (t.textColorProductsFound) root.style.setProperty('--text-color-products-found', t.textColorProductsFound);
    }
    
    // Button and UI configuration
    if (g.buttonColorBuyOnlineCTA) root.style.setProperty('--button-color-buy-online-cta', g.buttonColorBuyOnlineCTA);
    if (g.buttonColorSearchBackground)
      root.style.setProperty('--button-color-search-background', g.buttonColorSearchBackground);
    if (g.buttonColorTabAndFilter) {
      root.style.setProperty('--button-color-tab-and-filter', g.buttonColorTabAndFilter);
      root.style.setProperty('--border-bottom-nav-tabs-override', '0px');
      root.style.setProperty(
        '--button-color-border-tab-and-filter-override',
        '1px solid ' + g.buttonColorTabAndFilter
      );
    }
    if (g.backgroundColorNonActiveTabAndFilter)
      root.style.setProperty('--background-color-nonactive-tab-and-filter', g.backgroundColorNonActiveTabAndFilter);
    if (g.backgroundColorInStoreSelectedStore)
      root.style.setProperty('--background-color-in-store-selected-store', g.backgroundColorInStoreSelectedStore);
    if (g.backgroundColorBuyOnlineLineBreak)
      root.style.setProperty('--background-color-buy-online-line-break', g.backgroundColorBuyOnlineLineBreak);
    if (g.buttonBorderRadius) root.style.setProperty('--button-border-radius', g.buttonBorderRadius);
    if (g.floatingMenuBorderRadius)
      root.style.setProperty('--floating-menu-border-radius', g.floatingMenuBorderRadius);
    if (g.floatingMenuBorderShadowColor)
      root.style.setProperty('--floating-menu-border-shadow-color', '1px solid ' + g.floatingMenuBorderShadowColor);
    if (g.searchIconBW !== undefined) root.style.setProperty('--search-icon-bw', g.searchIconBW === true ? 1 : 0);
    if (g.searchBoxBorderColor) {
      root.style.setProperty('--search-box-border-color', g.searchBoxBorderColor);
      root.style.setProperty('--search-box-border-color-border-override', '1px solid ' + g.searchBoxBorderColor);
    }
    if (g.pinColorBackgroundColor) root.style.setProperty('--background-color-pin', g.pinColorBackgroundColor);
    if (g.pinColorBackgroundImageColor)
      root.style.setProperty('--background-image-color-pin', g.pinColorBackgroundImageColor);
    if (g.colorMixBorder) root.style.setProperty('--color-mix-palette-for-border', g.colorMixBorder);
  }
};


/** Handle select found products functionality */
const selectFoundProducts = async (storePearId, cameFromProductCount, $scope, $window, $timeout, usedRetailerListInit, RetailerListInit, initRetailerList) => {
  const BUY_ONLINE_ZIP_LOCK = true; // kept for compatibility (unused here)
  
  try {
    const store = ($scope.stores || []).find((s) => s.id == storePearId);
    document.activeElement?.blur();
    $scope.preventMapClick = true;

    if (store) {
      $scope.mapOnly = false;
      $scope.findOnline = true;

      $scope.showLoadingRetailerList = { showLoadingRetailerList: true };
      const _RetailerListInit = usedRetailerListInit ? null : RetailerListInit;
      usedRetailerListInit = true;

      if (!BUY_ONLINE_ZIP_LOCK) {
        await initRetailerList(
          _RetailerListInit,
          true,
          store.nearbyZip || store.zip,
          $scope.selectedUPCs,
          false,
          store
        );
      } else {
        await initRetailerList(_RetailerListInit, true, store.zip || $scope.location?.zip, null, false, store);
      }
      $scope.showLoadingRetailerList.showLoadingRetailerList = false;

      let retailerWithResults = null;
      for (let j = 0; j < $scope.pickerList.length; j++) {
        const rr = $scope.pickerList[j];
        if (rr && (rr.id == store.retailerId || rr.name == store.retailerName)) retailerWithResults = rr;
      }
      if (!retailerWithResults && store.synthetic) {
        retailerWithResults = {
          retailerId: store.id,
          name: store.name,
          synthetic: true,
          upcs: (store.availableUPCIds || []).map((upcId) => ({
            pearLogicalUPCId: ($scope.upcs || []).filter((u) => u.id == upcId).map((u) => u.pearLogicalUPCId)[0],
            status: 'AVAILABLE',
          })),
        };
        store.retailerWithResults = retailerWithResults;
        $scope.pickerList.push(retailerWithResults);
      }
      $timeout(() => $scope.$apply && $scope.$apply(), 0);
    }

    if ($scope.singleItemSelect) {
      $scope.findOnline = 0;
      $scope.showDesktopInStoreListing = false;
      $scope.productsOpen = false;
      $scope.showDesktopBuyOnlineTab = !$scope.showDesktopBuyOnlineTab;
      if (store) $scope.selectStore(store.id);
      return;
    }

    if (cameFromProductCount === true || $scope.enableRetailerFilter === false) {
      $scope.selectedUPCsForBuyOnline = [];
      $scope.selectedUPCs = [];
      $scope.availableRetailersForMultiSelect = [];

      (store?.availableUPCIds || []).forEach((upcId) => {
        const foundProduct = ($scope.getProductsToDisplay ? $scope.getProductsToDisplay() : $scope.upcs || []).find(
          (p) => p.id == upcId
        );
        if (foundProduct && $scope.toggleProductFilter) {
          $scope.toggleProductFilter(foundProduct);
        }
      });

      if (!$scope.singleItemSelect && $scope.onProductFilterClickV2) {
        $scope.onProductFilterClickV2({ stopPropagation() {}, preventDefault() {} });
      }
    } else {
      if (($scope.selectedUPCsForBuyOnline || []).length === 0) {
        const retailerStores = ($scope.stores || []).filter((s) => s.retailerId == store.retailerId);
        $scope.selectedUPCsForBuyOnline = [];
        $scope.selectedUPCs = [];
        $scope.availableRetailersForMultiSelect = [];

        retailerStores.forEach((retailerStore) => {
          (retailerStore.availableUPCIds || []).forEach((upcId) => {
            const foundProduct = (
              $scope.getProductsToDisplay ? $scope.getProductsToDisplay() : $scope.upcs || []
            ).find((p) => p.id == upcId);
            if (foundProduct && $scope.toggleProductFilter) {
              $scope.toggleProductFilter(foundProduct);
            }
          });
        });

        if (!$scope.singleItemSelect && $scope.onProductFilterClickV2) {
          $scope.onProductFilterClickV2({ stopPropagation() {}, preventDefault() {} });
        }
      }

      if ($scope.filterSelectedRetailerId) $scope.filterSelectedRetailerId(store.retailerId);
      if (store) $scope.selectStore(store.id);
      ($scope.pearLogicalUPCs || []).forEach((u) => (u.expanded = false));
      if ($scope.isMobile && $scope.pymChild?.scrollParentToChildEl) {
        $scope.pymChild.scrollParentToChildEl('where-to-buy');
      }
    }
  } catch (e) {
    console.error(e);
  } finally {
    $timeout(() => {
      $scope.preventMapClick = false;
    }, 500);
    $timeout(() => $scope.$apply && $scope.$apply(), 0);
  }
};





// -- image helpers --

/** Show retailer logo with theme support */
const showRetailerLogo = (retailer, theme, resizeImages) => {
  let img;
  if (retailer?.style?.logo && (theme === 'light' || theme === undefined)) img = retailer.style.logo;
  if (retailer?.style?.whiteOnBlackLogo && theme === 'dark') img = retailer.style.whiteOnBlackLogo;
  if (!img) img = '../img/defaultStore_opac-trans.png';

  if (resizeImages && /(assets|demos|assets-cf|demos-cf-1)\.pearcommerce\.com/.test(img)) {
    img = patchCdnImageUrl(img, 'width=64&format=webp');
  }
  return img;
};

/** Show store logo with theme and override support */
const showLogo = (store, theme, bwLogoImage, widgetConfig, resizeImages) => {
  let img = null;
  if (store) {
    if ((theme === 'light' && store.logoUrl) || store.storeId === '1904492982680032') img = store.logoUrl;
    if (theme === 'dark' && store.bwLogoUrl && store.storeId !== '1904492982680032') img = store.bwLogoUrl;
    if (bwLogoImage) img = store.bwLogoUrl;

    if (!img && store.category) {
      const overrideKey = { Retailer: '3rdParty-retailer', Restaurant: '3rdParty-restaurant', Bar: '3rdParty-bar' }[
        store.category
      ];
      if (overrideKey) {
        const overrideImg = (widgetConfig && widgetConfig.logoMap && widgetConfig.logoMap[overrideKey]) || null;
        if (overrideImg) img = overrideImg;
      }
    }

    if (resizeImages && img && /(assets|demos|assets-cf|demos-cf-1)\.pearcommerce\.com/.test(img)) {
      img = patchCdnImageUrl(img, 'width=64&format=webp');
    }
  }
  return img;
};

// -- DOM helpers --

/** Scroll the store list to a given store element (within .stores-over-map .scrolling-container) */
const scrollToStoreInList = (store, smooth) => {
  const parent = document.querySelector('div.stores-over-map .scrolling-container');
  const storeDiv = store ? document.querySelector(`.physical-store[id='store_${store.id}']`) : null;
  if (!parent) return;
  if (storeDiv) {
    const yOffset = -240;
    const targetTop = parent.scrollTop + storeDiv.getBoundingClientRect().top + yOffset;
    parent.scrollTo({ top: targetTop, behavior: smooth ? 'smooth' : 'auto' });
  } else {
    parent.scrollTo({ top: 0, behavior: 'auto' });
  }
};


module.exports = {
  isNonBlankString,
  toPhoneHref,
  patchCdnImageUrl,
  expandCondensedZipRetailerList,
  mapListByRetailer,
  removeUnavailableRetailers,
  getInitialBoundsFromCoords,
  isInstacartLink,
  isDoorDashLink,
  doAllLinksForRetailerPass,
  scrollToStoreInList,
  shuffleArray,
  getVendorIdSafe,
  getPostalCodeSafe,
  getUpcCountSafe,
  getInitialBoundsFromScope,
  getPendingList,
  containsPendingStatus,
  processUpcImageUrl,
  shouldDisplayRetailer,
  getRetailerStatus,
  shouldShowIndividualInstacartLink,
  shouldShowIndividualDDLink,
  trimUpcName,
  applyCssConfiguration,
  calculateNextZoom,
  flyToMarker,
  loadMapLibreScript,
  loadBootstrapCSS,
  loadMapLibreCSS,
  processBuyOnlineMap,
  checkCategories,
  checkProductBrand,
  getMultiSelectRetailers,
  isUpcAvailableForRetailer,
  processRetailerForSingleUPC,
  getSingleUPCRetailers,
  buildUpcIdMapping,
  preserveMultiSelectedState,
  sortUPCs,
  processUPCCategories,
  processImageUrlForResizing,
  initializeMapAndStoresScope,
  setupStoreCategoryToggle,
  calculateZipBatchSize,
  getMapBoundsAndCoords,
  buildRetailerListByZip,
  processMapStoreResponse,
  mobileFocusSearch,
  selectMapButtonForMobile,
  mobileFocusNav,
  mobileFocusBackNav,
  mobileFocusUpAndOff,
  mobileFocusDownAndOff,
  mobileFocusToFilter,
  mobileFlyOverFocusOffMap,
  setupScrollingListeners,
  filterPanelFocus,
  searchButtonDirectFocus,
  skipNavToInStoreRes,
  loadVendorOverrideStylesheet,
  setShortName,
  selectFoundProducts,
  showRetailerLogo,
  showLogo,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/productLocatorController.js":[function(_dereq_,module,exports){
/**
 * PRODUCT LOCATOR CONTROLLER
 * ==========================
 *
 * Purpose
 * -------
 * Orchestrates the "Where to Buy" experience. Handles config ingestion, UPC
 * normalization/sorting, retailer-list fetch/merge, store retrieval by map
 * bounds/zip batches, link normalization (Instacart/DoorDash), and produces the
 * Buy-Online map consumed by the React UI. Map visualization is handled in React;
 * this controller manages state & data only.
 *
 * Major Dependencies
 * ------------------
 * - map-utils.js: geocoding, vector style resolve, fetchWithFallback
 * - product-locator-utils.js: UPC sorting/filtering, retailer/store helpers, link utils, CSS config
 * - utilities.js (Util): common helpers (distance, memoize, image proxying, etc.)
 * - ng-async.js: $async wrapper for async $scope methods
 * - $api: server endpoints for retailer lists & stores
 *
 * Lifecycle (happy path)
 * ----------------------
 * 1) injectWidgetConfig(PixelConfig) → theme, CSS vars, toggles, labels
 * 2) setPearLogicalUPCs(initialUPCs) → normalize, categorize, sort, pin/preselect
 * 3) initRetailerList(zip, selectedUPCs) → memoized fetch, merge sortOrder, prune UNAVAILABLE
 * 4) startMapAndStores() → updateMapStores() batches zips, merges stores, distances, categories
 * 5) $watch(pearLogicalUPCsByAvailability) → build buyOnlineMap for React
 *
 * Key $scope Fields
 * -----------------
 * - Products: pearLogicalUPCs, pearLogicalUPCsForDisplay, pearLogicalUPCsByAvailability,
 *             selectedUPCs, selectedPearLogicalUPC, upcIdsToLogicalUPC
 * - Retailers: pickerList, pickerMapByRetailer
 * - Stores: stores, shownStores, selectedStore, hoveredStore, storeCategories,
 *           firstFullStoresFetchComplete, storesDoneLoading
 * - Location: location { latitude, longitude, zip, location }, freezeLocation
 * - UI: findOnline, mapOnly, isMobile/isMobileLayout, renderImages, theme/grayscale, widget toggles
 *
 * Important Contracts
 * -------------------
 * - setPearLogicalUPCs() may be re-invoked after retailer updates to re-sort by availability.
 * - pickerListDisplay(pickerUPC, buyOnline) is cached per (UPC, mode).
 *
 * Performance Notes
 * -----------------
 * - Retailer lists memoized per (zip, selectedUPCs).
 * - Store fetches batched by zips; merging avoids duplicates and recomputes distances.
 * - Image URLs patched/proxied once; avoid heavy work inside $watches.
 *
 * Cleanup
 * -------
 * - All timers and listeners are cleared on $scope.$on('$destroy').
 *
 * Debugging
 * ---------
 * - Add `?debug=true` to reveal pending/compute states in retailer rows.
 * - Use `retailerListDebugURL` for quick per-zip inspection.
 *
 * Owner Notes
 * -----------
 * - Pending availability polling is scaffolded but currently disabled.
 * - Map marker/flyout behavior was intentionally removed (owned by React).
 */


const console = _dereq_('../pear-console.js').PearConsole;
const ENRICHED_CATEGORY_CONFIG = _dereq_('../../js/offers/brand/enriched_category.js');
const STADIA_MAPS_CONFIG = _dereq_('./stadia-maps-config.js');
const geocodingCache = _dereq_('./geocoding-cache.js');
const {
  updateLocationWithZip,
  getZipFromCoordinates,
  getZipFromForwardGeocoding,
  getZipFromLocationSearch,
  getZipFromReverseGeocoding,
  getCurrentLocation,
  getServerStyleObject,
} = _dereq_('./map-utils.js');

const Util = _dereq_('../utilities.js');
const $async = _dereq_('./ng-async.js');
const { 
  shuffleArray, 
  isNonBlankString, 
  toPhoneHref,
  mapListByRetailer,
  scrollToStoreInList,
  getVendorIdSafe,
  getPostalCodeSafe,
  getUpcCountSafe,
  getInitialBoundsFromScope,
  getPendingList,
  containsPendingStatus,
  processUpcImageUrl,
  shouldDisplayRetailer,
  getRetailerStatus,
  shouldShowIndividualInstacartLink,
  shouldShowIndividualDDLink,
  trimUpcName,
  applyCssConfiguration,
  checkCategories,
  checkProductBrand,
  getMultiSelectRetailers,
  getSingleUPCRetailers,
  buildUpcIdMapping,
  preserveMultiSelectedState,
  sortUPCs,
  processUPCCategories,
  processImageUrlForResizing,
  initializeMapAndStoresScope,
  setupStoreCategoryToggle,
  calculateZipBatchSize,
  getMapBoundsAndCoords,
  buildRetailerListByZip,
  processMapStoreResponse,
  mobileFocusSearch,
  selectMapButtonForMobile,
  mobileFocusNav,
  mobileFocusBackNav,
  mobileFocusUpAndOff,
  mobileFocusDownAndOff,
  mobileFocusToFilter,
  mobileFlyOverFocusOffMap,
  setupScrollingListeners,
  filterPanelFocus,
  searchButtonDirectFocus,
  skipNavToInStoreRes,
  loadVendorOverrideStylesheet,
  setShortName,
  selectFoundProducts,
  isInstacartLink,
  isDoorDashLink,
  doAllLinksForRetailerPass,
  showRetailerLogo,
  showLogo
} = _dereq_('./product-locator-utils.js');
const USE_FIRST_UPC_ON_BIG_LIST = false;


const productLocatorController = function ProductLocatorController(
  $scope,
  $rootScope,
  $stateParams,
  $timeout,
  $window,
  UPCSAndOffer,
  PixelConfig,
  LocationData,
  MapStylesJson,
  $api,
  MapLibrariesPreInject,
  $config,
  FirstStoresForLocationPromiseWrapper,
  ParallelStoresForLocationPromiseWrapper,
  PotentialStoreZipsForLocation
) {
  const AppConfig = window.AppConfig || {};

  const nonBlankStr = isNonBlankString;
  const phoneLink = toPhoneHref;

  $rootScope.WIDGET_CONFIG = $rootScope.WIDGET_CONFIG || {};
  $scope.memoizedInstacartLinksByRetailer = {};
  $scope.memoizedDoorDashLinksByRetailer = {};

  $scope.productFilterTitle = 'Filters';
  $scope.hierarchy = 'IN_STORE_VS_ONLINE';
  $scope.isMobile = /Mobi|Android/i.test($window.navigator.userAgent);
  $scope.isMobileLayout = $scope.isMobile; // can be toggled by layout code
  $scope.apiKey = '';
  $scope.grayscale = '0';
  $scope.pearLogicalUPCsByAvailability = []; // React reads this

  const injectWidgetConfig = async (config) => {
    $window.PEAR_WIDGET_CONFIG = $window.PEAR_WIDGET_CONFIG || {};
    Object.assign($window.PEAR_WIDGET_CONFIG, Util.keepDefined(config || {}));
    $rootScope.WIDGET_CONFIG = $window.PEAR_WIDGET_CONFIG;

    // top-level toggles / labels
    $scope.showStoreTypes = !!$rootScope.WIDGET_CONFIG.showStoreTypes;
    $scope.filterMapExcludeCategories = $rootScope.WIDGET_CONFIG.filterMapExcludeCategories || [];
    $scope.showSyntheticStoreProducts = !!$rootScope.WIDGET_CONFIG.showSyntheticStoreProducts;
    $scope.showMobileLocatorTitle = !!$rootScope.WIDGET_CONFIG.titledHeader;
    // add showMobileLocatorTitle to the config object for React
    if ($rootScope.WIDGET_CONFIG.titledHeader && !$rootScope.WIDGET_CONFIG.showMobileLocatorTitle) {
      $rootScope.WIDGET_CONFIG.showMobileLocatorTitle = true;
    }
    $scope.showProductLine = !!$rootScope.WIDGET_CONFIG.showProductLine;
    $scope.startWithProductFilterOpen = !!$rootScope.WIDGET_CONFIG.startProductFilterOpen;
    $scope.singleItemSelect = !!$rootScope.WIDGET_CONFIG.singleItemSelect;
    $scope.ignoreCategories = $rootScope.WIDGET_CONFIG.ignoreCategory || [];
    $scope.pinUPCIdsToTop = $rootScope.WIDGET_CONFIG.pinUPCIdsToTop || [];
    $scope.preSelectedUPCIds = $rootScope.WIDGET_CONFIG.preSelectedUPCIds || [];
    $scope.mapTheme = $rootScope.WIDGET_CONFIG.theme || 'light';
    $scope.bwLogoImage = !!$rootScope.WIDGET_CONFIG.bwLogoImage;
    $scope.injectPagination = !!$rootScope.WIDGET_CONFIG.injectPagination;
    $scope.productFilterTitle = $rootScope.WIDGET_CONFIG.filterTitle || 'Filters';
    $scope.retailerBuyOnlineBtnCTA = $rootScope.WIDGET_CONFIG.retailerBuyOnlineBtnCTA || 'Add to Cart';
    $scope.enableRetailerFilter = !!$rootScope.WIDGET_CONFIG.enableRetailerFilter;
    $scope.resetFilterOnInStoreTab = !!$rootScope.WIDGET_CONFIG.resetFilterOnInStoreTab;
    $scope.showBuyOnlineTab = !!$rootScope.WIDGET_CONFIG.showBuyOnlineTab;
    $scope.hideBuyOnlineTab = $scope.showBuyOnlineTab; // inverted flag kept for compatibility
    $scope.buyOnlineTabActive = !!$rootScope.WIDGET_CONFIG.buyOnlineTabActive;
    $scope.buyOnlineTabText = $rootScope.WIDGET_CONFIG.buyOnlineTabText || 'Buy Online';
    $scope.inStoreTabText = $rootScope.WIDGET_CONFIG.inStoreTabText || 'In-Store';
    $scope.showPhoneNumInStoreLst = !!$rootScope.WIDGET_CONFIG.showPhoneNumInStoreLst;
    $scope.showProductSearch = !!$rootScope.WIDGET_CONFIG.showProductSearch;
    $scope.defaultZoom = $rootScope.WIDGET_CONFIG.defaultZoom || 12;
    $scope.hasExitSelector = !!$rootScope.WIDGET_CONFIG.exitSelector;
    $scope.hasImportedStore = !!$rootScope.WIDGET_CONFIG.importedStores;
    $scope.vendorProvidedPin = Util.patchImageUrl($rootScope.WIDGET_CONFIG.vendorProvidedPin);
    $scope.googleMapCountryRestriction = $rootScope.WIDGET_CONFIG.googleMapCountryRestriction || '';
    $scope.filterOutVendor = !!$rootScope.WIDGET_CONFIG.filterOutVendorAsRetailer;

    const addressInputConfig = $rootScope.WIDGET_CONFIG?.widgetConfig?.addressInputConfig;
    $scope.addressInputTextBehavior = (addressInputConfig && addressInputConfig.textValue) || 'EDITABLE';
    $scope.addressInputFocusBehavior = (addressInputConfig && addressInputConfig.filterFocusBehavior) || 'KEEP_TEXT';

    $scope.outOfStockMessageContent =
      $rootScope.WIDGET_CONFIG?.pdpConfig?.outOfStockMessageStyle?.content ||
      'Item is not currently in stock. Check back soon!';

    const configPromptText = $rootScope.WIDGET_CONFIG?.pdpConfig?.bundleProductPromptText?.trim();
    $scope.widgetProductBundlePromptText = (configPromptText || 'Buy:') + ' ';
    if ($rootScope.WIDGET_CONFIG?.pdpConfig?.clearBundleProductPromptText === true) {
      $scope.widgetProductBundlePromptText = '';
    }

    // Checkserver style (to see if it's named "Monochrome")
    const serverStyle = await getServerStyleObject(MapStylesJson);
    const wantGrayscale = !!(serverStyle && serverStyle.name === 'Monochrome');

    $scope.grayscale = wantGrayscale ? '1' : '0';

    // CSS variables on root
    let root = document.getElementsByClassName('where-to-buy')[0];
    if (!root) return;

    if ($rootScope.WIDGET_CONFIG.theme) {
      if (!root.className.includes($rootScope.WIDGET_CONFIG.theme)) {
        root.className += ' ' + $rootScope.WIDGET_CONFIG.theme;
      }
    }

    // Apply CSS configuration
    applyCssConfiguration(root, $rootScope, $scope);
    
    // Handle custom zoom setting
    if ($rootScope.WIDGET_CONFIG.customStylesConfig) {
      $scope.customPLZoom = !!$rootScope.WIDGET_CONFIG.customStylesConfig.zoomInBuyNowProductImg;
    } else {
      $scope.customPLZoom = false;
    }

    $scope.hideOutOfStockItems = !!$rootScope.WIDGET_CONFIG.hideOutOfStockItems;

    // Load vendor override stylesheet
    loadVendorOverrideStylesheet($rootScope);

    $scope.hierarchy = $rootScope.WIDGET_CONFIG.hierarchyType || 'IN_STORE_VS_ONLINE';
    setShortName($scope.pickerList, $scope, $rootScope, trimUpcName);
  };

  $scope.injectWidgetConfig = injectWidgetConfig;

  try {
    injectWidgetConfig(PixelConfig);
  } catch (e) {
    /* no-op */
  }

  $scope.upcsByName = {};

  $scope.setPearLogicalUPCs = (pickerUPCs) => {
    // Process image URLs
    pickerUPCs = pickerUPCs.map((upc) => processUpcImageUrl(upc, window.resizeImages));
    
    // Build UPC ID mapping
    $scope.upcIdsToLogicalUPC = buildUpcIdMapping(pickerUPCs);
    let upcsByName = ($scope.upcsByName = {});

    // Preserve multi-selected state
    const currentMultiSelectedState = preserveMultiSelectedState($scope.pearLogicalUPCs);

    $scope.pearLogicalUPCs = (pickerUPCs || [])
      .map((pickerUPCs) => {
        const newLogicalUPC = {
          ...pickerUPCs,
          imageUrl: Util.patchImageUrl(pickerUPCs.imageUrl),
        };
        // Restore the multiSelected state if it existed
        if (currentMultiSelectedState?.hasOwnProperty(newLogicalUPC.pearLogicalUPCId)) {
          newLogicalUPC.multiSelected = currentMultiSelectedState?.[newLogicalUPC.pearLogicalUPCId];
        }

        return newLogicalUPC;
      })
      .filter((upc) => !upc.hidden)
      .sort((a, b) => sortUPCs(a, b, $scope.offer));


    // Process UPCs for display
    $scope.pearLogicalUPCsForDisplay = $scope.pearLogicalUPCs
      .filter((upc) => upc.name)
      .filter((upc) => processUPCCategories(upc, upcsByName))
      .map((upc) => processImageUrlForResizing(upc));
    if ($scope.singleItemSelect && $scope.selectedUPCs.length != 1) {
      $scope.toggleProduct($scope.selectedUPCs, $scope.pearLogicalUPCsForDisplay[0]);
      $scope.toggleProduct($scope.selectedUPCsForBuyOnline, $scope.pearLogicalUPCsForDisplay[0]);
    }

    // Sort by availability (simplified but preserves core logic)
    const selectedRetailerId = $scope.selectedStore && $scope.selectedStore.retailerId;
    $scope.pearLogicalUPCsByAvailability = [...$scope.pearLogicalUPCs]
      .sort((a, b) => {
        let numAvailableA = 0, numAvailableB = 0;
        let hasSelectedStoreA = false, hasSelectedStoreB = false;

        if ($scope.pickerList?.length && $scope.pickerListDisplay) {
          const pickerListDisplayA = $scope.pickerListDisplay(a);
          const pickerListDisplayB = $scope.pickerListDisplay(b);
          
          pickerListDisplayA.forEach(retailer => {
            retailer.upcs.forEach(upc => {
              if (upc.pearLogicalUPCId === a.pearLogicalUPCId && upc.status === 'AVAILABLE') {
                numAvailableA++;
                if (selectedRetailerId === retailer.id) hasSelectedStoreA = true;
              }
            });
          });

          pickerListDisplayB.forEach(retailer => {
            retailer.upcs.forEach(upc => {
              if (upc.pearLogicalUPCId === b.pearLogicalUPCId && upc.status === 'AVAILABLE') {
                  numAvailableB++;
                if (selectedRetailerId === retailer.id) hasSelectedStoreB = true;
              }
            });
          });
        }

        const numAvailableSansVendorA = a.vendorItemId ? Math.max(0, numAvailableA - 1) : numAvailableA;
        const numAvailableSansVendorB = b.vendorItemId ? Math.max(0, numAvailableB - 1) : numAvailableB;

        if (a.vendorItemId && numAvailableA === 1) numAvailableA = 0.5;
        if (b.vendorItemId && numAvailableB === 1) numAvailableB = 0.5;

        if (!!a.imageUrl !== !!b.imageUrl) return !!a.imageUrl ? -1 : 1;

        if (UPCSAndOffer.offer.productSortType === 'STORE_LOCATOR_GENERATED') {
          if (!!numAvailableSansVendorA !== !!numAvailableSansVendorB) return !!numAvailableSansVendorA ? -1 : 1;
          if (numAvailableA > 0 !== numAvailableB > 0) return numAvailableA > 0 ? -1 : 1;
          if (Math.min(3, numAvailableA) !== Math.min(3, numAvailableB)) return Math.min(3, numAvailableB) - Math.min(3, numAvailableA);
        }

        if (UPCSAndOffer.offer.productSortType === 'MANUAL') {
          if (numAvailableA > 0 && numAvailableB === 0) return -1;
          if (numAvailableA === 0 && numAvailableB > 0) return 1;
        }

        if ((a.sortOrder || b.sortOrder) && a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
        if (a.sortOrder === b.sortOrder) {
          if (hasSelectedStoreA !== hasSelectedStoreB) return hasSelectedStoreA ? -1 : 1;
          return a.pearLogicalUPCId - b.pearLogicalUPCId;
        }
        return a.sortOrder - b.sortOrder;
      })
      .map((upc) => processImageUrlForResizing(upc));


    if ($scope.pinUPCIdsToTop) {
      for (var i = 0; i < $scope.pinUPCIdsToTop.length; i++) {
        let grabIndex = $scope.pearLogicalUPCsByAvailability.findIndex((upc) => upc.id == $scope.pinUPCIdsToTop[i]);

        let element = $scope.pearLogicalUPCsByAvailability[grabIndex];
        //pin upcs on top of buy online tab
        $scope.pearLogicalUPCsByAvailability.splice(grabIndex, 1);
        $scope.pearLogicalUPCsByAvailability.splice(i, 0, element);
        //pin upcs on top of filter list
        grabIndex = $scope.pearLogicalUPCsForDisplay.findIndex((upc) => upc.id == $scope.pinUPCIdsToTop[i]);
        element = $scope.pearLogicalUPCsForDisplay[grabIndex];
        $scope.pearLogicalUPCsForDisplay.splice(grabIndex, 1);
        $scope.pearLogicalUPCsForDisplay.splice(i, 0, element);
      }
    }
    if ($scope.preSelectedUPCIds && $scope.preSelectedUPCIds.length > 0) {
      $scope.selectedUPCs = [...$scope.preSelectedUPCIds];
      $scope.selectedUPCsForBuyOnline = [...$scope.preSelectedUPCIds];
    }

    if ($scope.pearLogicalUPCs.length > 0) {
      $scope.selectedPearLogicalUPC = $scope.pearLogicalUPCs[0];
    }
  };

  if ($scope.upcs) {
    for (let i = 0; i < $scope.upcs.length; i++) {
      const upc = $scope.upcs[i];
      if (typeof upc.sortOrder == 'undefined') {
        upc.sortOrder = 1000 + i;
      }
    }
    $scope.setPearLogicalUPCs($scope.upcs);
  }

  // Vendor / offer / products
  $scope.UPCSAndOffer = UPCSAndOffer || {};
  $scope.offer = (UPCSAndOffer && UPCSAndOffer.offer) || null;
  $scope.vendor = UPCSAndOffer.offer?.vendor || {};

  if (PixelConfig && PixelConfig.widgetConfig) {
    $scope.injectWidgetConfig(PixelConfig);
  }

  // Pre-selected UPCs via config/URL (keep legacy behavior)
  if ($rootScope.WIDGET_CONFIG?.upcIds?.length) {
    $scope.selectedUPCs = [...$rootScope.WIDGET_CONFIG.upcIds];
  } else if ($scope.preSelectedUPCIds?.length) {
    $scope.selectedUPCs = [...$scope.preSelectedUPCIds];
  }

  // Data containers (expected to be filled by upstream services)
  $scope.stores = $scope.stores || [];
  $scope.location = $scope.location || {};
  if ($stateParams.address) {
    $scope.location.location = $stateParams.address;
    $scope.freezeLocation = $scope.location.location;
  } else if (!$stateParams.zip && !$stateParams.latitude && !$stateParams.longitude) {
    // No location in URL, get current location
    getCurrentLocation(STADIA_MAPS_CONFIG)
      .then((locationData) => {
        $scope.location.location = locationData.locationString;
        $scope.location.latitude = locationData.latitude;
        $scope.location.longitude = locationData.longitude;
        $scope.location.zip = locationData.zip;
        $scope.freezeLocation = locationData.locationString;
        $scope.$apply();
      })
      .catch((error) => {
        console.error('Error getting current location:', error);
      });
  }

  if (LocationData) {
    if (LocationData.success == false && LocationData.error) {
      LocationData.city = 'Milwaukee';
      LocationData.zip = '53202';
      LocationData.country_name = 'USA';
      LocationData.latitude = 43.05;
      LocationData.longitude = -87.9;
    }

    if (!$scope.location.location || $scope.location.location.indexOf('undefined') != -1) {
      $scope.location.location =
        (LocationData.city || '') +
        ', ' +
        (LocationData.region_code ? LocationData.region_code + ' ' : '') +
        (LocationData.zip || '') +
        ', ' +
        (LocationData.country_name || '');
      $scope.freezeLocation = $scope.location.location;
    }
    if ($stateParams.latitude) {
      $scope.location.latitude = parseFloat($stateParams.latitude + '');
      $scope.location.longitude = parseFloat($stateParams.longitude + '');
    } else {
      $scope.location.latitude = LocationData.latitude;
      $scope.location.longitude = LocationData.longitude;
    }

    $scope.location.zip = LocationData.zip;
  } else if (!$scope.freezeLocation) {
    $scope.location.freezeLocation = 'Please enter your address.';
  }

  $scope.pickerList = $scope.pickerList || [];
  $scope.pearLogicalUPCs = $scope.pearLogicalUPCs || [];
  const initialUPCs = (UPCSAndOffer && (UPCSAndOffer.UPCs || UPCSAndOffer.upcs)) || [];
  $scope.upcs = initialUPCs;
  $scope.upcIdsToLogicalUPC = $scope.upcIdsToLogicalUPC || {};
  $scope.selectedUPCs = $scope.selectedUPCs || [];
  $scope.storeCategories = $scope.storeCategories || {};

  $scope.lastLocation = null;
  $scope.editingLocation = false;

  $scope.activelyEditingLocation = ($event) => {
    if ($event.keyCode === 9) {
      // 9 is the keyCode for Tab
      return;
    }
    if ($scope.editingLocation === false) {
      $scope.editingLocation = true;
      $scope.lastLocation = Object.assign({}, $scope.location);
      $scope.location.location = '';
    }
  };

  $scope.doneEditingLocation = () => {
    $scope.editingLocation = false;
    if ($scope.location.location === '') {
      $scope.location = $scope.lastLocation;
    }
  };

  $scope.submitLocation = $async(async function () {
    if ($scope.addressChange) return;

    // Check if we have location data
    if (!$scope.location.location && !$scope.location.zip && !$scope.location.latitude) {
      // Try to get location data from session if local scope is empty
      if ($rootScope.session && $rootScope.session.location) {
        $scope.location = {
          location: $rootScope.session.location,
          latitude: $rootScope.session.latitude,
          longitude: $rootScope.session.longitude,
          zip: $rootScope.session.zip,
          coordinatesLocation: $rootScope.session.coordinatesLocation,
          countryCode: $rootScope.session.countryCode,
        };
      } else {
        return;
      }
    }

    $scope.addressChange = true;

    // If we already have a zip code, use it directly
    if ($scope.location.zip) {
      const params = Object.assign({}, $stateParams, {
        zip: ($scope.location.countryCode && $scope.location.countryCode == 'AU' ? 'AU' : '') + $scope.location.zip,
        latitude: $scope.location.latitude,
        longitude: $scope.location.longitude,
        address: $scope.location.location,
      });
      $state.go($state.current, params, {
        location: true,
        reload: false,
      });
      return;
    }

    // If we have coordinates, try to get zip from them
    if ($scope.location.latitude && $scope.location.longitude) {
      const zip = await getZipFromCoordinates(
        $scope.location,
        (text) => getZipFromForwardGeocoding(text, STADIA_MAPS_CONFIG, geocodingCache),
        (text) =>
          getZipFromLocationSearch(text, STADIA_MAPS_CONFIG, geocodingCache, (lat, lng) =>
            getZipFromReverseGeocoding(lat, lng, STADIA_MAPS_CONFIG, geocodingCache)
          )
      );
      if (zip) {
        updateLocationWithZip(zip, $scope, $state);
        return;
      }
    }

    // If we get here, we couldn't resolve a location
    console.warn('Unable to resolve location from available data');
  });

  let pickerListDisplayCache = { true: {}, false: {} };
  let retailerUPCToAvailableTime = {};
  let cachedValue;
  const inProductLocator = true; // we are in the PL
  let usedRetailerListInit = false;
  let RetailerListInit = null;
  let injectedAfterRetailerList = false;
  const retailerListsByZipAndSelectedUPCs = {};
  let storeSelectRetailerListPromise = null;

  $scope.getRetailerStatus = (retailer, upc) => {
    return getRetailerStatus(retailer, upc, $scope.offer, inProductLocator);
  };

  const removeUnavailableRetailers = (retailerList, logicalUPC) => {
    if (!retailerList) {
      return;
    }
    for (let i = 0; i < retailerList.length; i++) {
      const retailer = retailerList[i];

      let allFailed = true;
      if (retailer && retailer.upcs != null) {
        for (let j = 0; j < retailer.upcs.length; j++) {
          if ($scope.getRetailerStatus(retailer, retailer.upcs[j]) != 'UNAVAILABLE') {
            allFailed = false;
            break;
          }
        }
      }
      if (allFailed) {
        retailerList.splice(i, 1);
        i--;
      }
    }
  };

  const mapListByRetailerForScope = (pickerList) => {
    return mapListByRetailer(pickerList);
  };

  let elapsedPollTime = 0;
  const basePollTime = 1500;
  let pollTimeout = basePollTime;
  const resolvePendingStatusesIfNeeded = (pickerList) => {
    const getPendingListForScope = getPendingList;

    const ENABLE_PENDING_POLL = false;
    const checkPendingsAndPollStatus = (pickerList) => {
      if (!ENABLE_PENDING_POLL) {
        return;
      }
      const pendingList = getPendingListForScope(pickerList);
      if (pendingList.length > 0) {
        const constrainRetailerEnums = pendingList.map((item) => item.nameEnum).join(',');
        $timeout(() => {
          elapsedPollTime += pollTimeout;
          pollTimeout = Math.min(
            Math.trunc(
              elapsedPollTime > 30 * 1000
                ? // after 30s mark, decay polling to [10 + # minutes on-site] seconds
                  10000 + elapsedPollTime / 60
                : // minor decay up to the 30s mark
                  basePollTime + (10000 - basePollTime) * (elapsedPollTime / (30 * 1000))
            ),
            // up to a max of 10 minutes
            10 * 60 * 1000
          );
          const t = new Date().getTime();
          let resolve;
          if ($scope.offer) {
            resolve = $api.get(
              '/v1/retailer-list/' +
                $scope.offer.id +
                '?asyncResolveDeep=false&t=' +
                t +
                ($stateParams.pb || $stateParams.mode
                  ? '&zip=55408'
                  : $stateParams.zip
                  ? '&zip=' + $stateParams.zip
                  : '') +
                ('&constrain=' + constrainRetailerEnums) +
                ($stateParams.include ? '&include=' + $stateParams.include : '') +
                ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                `&pollTimeout=${pollTimeout}`,
              { credentials: 'include', withCredentials: true, failure: failureRetailerList }
            );
          } else if ($scope.vendor) {
            resolve = $api.get(
              '/v1/retailer-list-by-vendor/' +
                $stateParams.vendorId +
                '?asyncResolveDeep=false&t=' +
                t +
                ($stateParams.pb || $stateParams.mode
                  ? '&zip=55408'
                  : $stateParams.zip
                  ? '&zip=' + $stateParams.zip
                  : '') +
                ('&constrain=' + constrainRetailerEnums) +
                ($stateParams.include ? '&include=' + $stateParams.include : '') +
                ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                `&pollTimeout=${pollTimeout}`,
              { credentials: 'include', withCredentials: true, failure: failureRetailerList }
            );
          } else {
            resolve = $api.get(
              '/v1/retailer-list-by-upc/' +
                $stateParams.upcs +
                '?asyncResolveDeep=false&t=' +
                t +
                ($stateParams.pb || $stateParams.mode
                  ? '&zip=55408'
                  : $stateParams.zip
                  ? '&zip=' + $stateParams.zip
                  : '') +
                ('&constrain=' + constrainRetailerEnums) +
                ($stateParams.include ? '&include=' + $stateParams.include : '') +
                ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
                ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
                ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
                ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
                ($stateParams.promo_text ? '&promo_text&cookiePolicy=true' : '') +
                ($scope.pearclid ? '&pearclid=' + $scope.pearclid : '') +
                `&pollTimeout=${pollTimeout}`,
              { credentials: 'include', withCredentials: true }
            );
          }

          resolve.then((newPickerList) => {
            newPickerList = newPickerList || [];
            $scope.resolveTime = new Date().getTime();
            const newPickerMap = mapListByRetailerForScope(newPickerList);
            mergePickerMapData($scope.pickerMapByRetailer, newPickerMap);
            resolvePendingStatusesIfNeeded($scope.pickerList);
          });
        }, pollTimeout);
      }
    };
    if ($scope.offer) {
      checkPendingsAndPollStatus(pickerList);
    }
  };

  const initRetailerList = $async(async function (
    ResolveRetailerListInit,
    storeFinderListUpdate,
    zip,
    selectedUPCs,
    asyncResolveFalse,
    store
  ) {
    const triggerRenderImages = () => {
      $scope.renderImages = true;
      $timeout(() => {
        $scope.renderLowPriImages = true;
      }, 2500);
    };

    // wait for any async retailer list calls that have been triggered
    if (storeSelectRetailerListPromise) {
      await storeSelectRetailerListPromise;
    }

    let RetailerListInit = null;
    if (!zip && $scope.location && $scope.location.zip) {
      zip = $scope.location.zip;
    }

    $scope.retailerListDebugURL = `https://admin.pearcommerce.com/availability-inspector?vendorId=${
      ($scope.vendor && $scope.vendor.id) || ''
    }&offerId=${($scope.offer && $scope.offer.id) || ''}&postalCode=${zip}`;
    selectedUPCs = selectedUPCs && selectedUPCs.length ? selectedUPCs : null;
    const retailerListsBySelectedUPCs = (retailerListsByZipAndSelectedUPCs[zip] =
      retailerListsByZipAndSelectedUPCs[zip] || {});
    let cachedRetailerList = null;
    if (retailerListsBySelectedUPCs['null']) {
      cachedRetailerList = retailerListsBySelectedUPCs['null'];
    } else if (selectedUPCs) {
      Object.entries(retailerListsBySelectedUPCs).forEach(([upcs, retailerList]) => {
        if (selectedUPCs.filter((selectedUPC) => upcs.indexOf(selectedUPC) == -1).length == 0) {
          cachedRetailerList = retailerList;
        }
      });
    }

    const getRetailerListInitPromise = function (
      $scope,
      $api,
      $stateParams,
      SetSession,
      zip,
      selectedUPCs,
      asyncResolveFalse,
      pearclid,
      UPCSAndOffer
    ) {
      async function failureRetailerList() {
        try {
          let LocationData = await $api.getZipLocationData(zip);
          return await (
            await fetch(
              'https://assets-cf.pearcommerce.com/retailer-list/' +
                UPCSAndOffer.offer.id +
                '/' +
                LocationData.region_code +
                '?' +
                new Date().getTime()
            )
          ).json();
        } catch (e) {
          return [];
        }
      }
      asyncResolveFalse = !!asyncResolveFalse;
      const t = new Date().getTime();
      let offerIdVar = null;
      if (UPCSAndOffer.offer) {
        offerIdVar = UPCSAndOffer.offer.id;
      }

      let retailerListUrl = offerIdVar
        ? '/v1/retailer-list/' +
          offerIdVar +
          '?asyncResolveDeep=' +
          !asyncResolveFalse +
          '&t=' +
          t +
          ($stateParams.pb || $stateParams.mode
            ? '&zip=55408'
            : zip
            ? '&zip=' + zip
            : $stateParams.zip
            ? '&zip=' + $stateParams.zip
            : '') +
          ($stateParams.cold ? '&cold=' + $stateParams.cold : '') +
          ($stateParams.include ? '&include=' + $stateParams.include : '') +
          ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
          ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
          ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
          ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
          ($stateParams.promo_text ? '&promo_text=true' : '') +
          (pearclid ? '&pearclid=' + pearclid : '') +
          ('&selectedUPCs=' + encodeURIComponent(JSON.stringify(selectedUPCs || null))) +
          ''
        : '/v1/retailer-list-by-vendor/' +
          $stateParams.vendorId +
          '?asyncResolveDeep=' +
          !asyncResolveFalse +
          '&t=' +
          t +
          ($stateParams.pb || $stateParams.mode
            ? '&zip=55408'
            : zip
            ? '&zip=' + zip
            : $stateParams.zip
            ? '&zip=' + $stateParams.zip
            : '') +
          ($stateParams.cold ? '&cold=' + $stateParams.cold : '') +
          ($stateParams.include ? '&include=' + $stateParams.include : '') +
          ($stateParams.exclude ? '&exclude=' + $stateParams.exclude : '') +
          ($stateParams.debug ? '&debug=' + $stateParams.debug : '') +
          ($stateParams.key ? '&key=' + encodeURIComponent($stateParams.key) : '') +
          ($stateParams.sold_at ? '&sold_at=' + encodeURIComponent($stateParams.sold_at) : '') +
          ($stateParams.promo_text ? '&promo_text=true' : '') +
          (pearclid ? '&pearclid=' + pearclid : '') +
          ('&selectedUPCs=' + encodeURIComponent(JSON.stringify(selectedUPCs || null))) +
          '';
      return $api
        .get(retailerListUrl, { credentials: 'include', withCredentials: true, failure: failureRetailerList })
        .then((response) => {
          if (!response || response.error || response.stack) {
            return [];
          } else {
            if (window.location.href.indexOf('liquiddeath') > -1) {
              const magicRetailers = ['whole foods', '7now', 'publix', 'gopuff', '7-eleven'];
              response.sort((a, b) => {
                let magicRetailerA = false;
                let magicRetailerB = false;
                magicRetailers.forEach((magicRetailer) => {
                  if (a.name && a.name.toLowerCase().indexOf(magicRetailer) > -1) {
                    magicRetailerA = true;
                  }
                  if (b.name && b.name.toLowerCase().indexOf(magicRetailer) > -1) {
                    magicRetailerB = true;
                  }
                });
                let aCount = 0;
                a.upcs.forEach((upc) => {
                  if (upc.status == 'AVAILABLE') {
                    aCount++;
                  }
                });

                let bCount = 0;
                b.upcs.forEach((upc) => {
                  if (upc.status == 'AVAILABLE') {
                    bCount++;
                  }
                });

                if (magicRetailerA && !magicRetailerB) {
                  return -1;
                } else if (!magicRetailerA && magicRetailerB) {
                  return 1;
                } else {
                  return bCount - aCount;
                }
              });
            }
            response.forEach((r) => {
              if (r.style && r.style.logo) {
                r.style.logo = r.style.logo
                  .replace('https://assets.pearcommerce.com', 'https://image-processor.pearcommerce.com')
                  .replace('https://demos.pearcommerce.com', 'https://image-processor.pearcommerce.com');
              }
            });
            return response;
          }
        });
    };

    const memoizedGetRetailerListPromise = Util.memoize(getRetailerListInitPromise);

    let selectedUPCsForRetailerListInit = selectedUPCs;
    let retailerListFullFetchPromise = storeFinderListUpdate
      ? memoizedGetRetailerListPromise(
          $scope,
          $api,
          $stateParams,
          null,
          zip,
          selectedUPCsForRetailerListInit,
          asyncResolveFalse,
          $scope.pearclid,
          UPCSAndOffer
        )
      : null;

    $scope.renderImages = true;
    if (cachedRetailerList) {
      RetailerListInit = cachedRetailerList;

      if (
        USE_FIRST_UPC_ON_BIG_LIST &&
        selectedUPCsForRetailerListInit == null &&
        $state.current.name == 'product-locator' &&
        UPCS.UPCs.length > 30
      ) {
        selectedUPCsForRetailerListInit = [UPCS.UPCs[0].id];
      }
    } else if (ResolveRetailerListInit) {
      RetailerListInit = ResolveRetailerListInit;
    } else {
      if (
        USE_FIRST_UPC_ON_BIG_LIST &&
        selectedUPCsForRetailerListInit == null &&
        $state.current.name == 'product-locator' &&
        UPCS.UPCs.length > 30
      ) {
        selectedUPCsForRetailerListInit = [UPCS.UPCs[0].id];
      }

      $timeout(triggerRenderImages, 1000);
      RetailerListInit = await (retailerListFullFetchPromise ||
        memoizedGetRetailerListPromise(
          $scope,
          $api,
          $stateParams,
          null,
          zip,
          selectedUPCsForRetailerListInit,
          asyncResolveFalse,
          $scope.pearclid,
          UPCSAndOffer
        ));
    }
    try {
      let toMerge = await (retailerListFullFetchPromise ||
        memoizedGetRetailerListPromise(
          $scope,
          $api,
          $stateParams,
          null,
          zip,
          selectedUPCsForRetailerListInit,
          asyncResolveFalse,
          $scope.pearclid,
          UPCSAndOffer
        ));
      for (let i = 0; i < toMerge.length; i++) {
        let foundRetailerEnum = false;
        for (let j = 0; j < RetailerListInit.length; j++) {
          if (RetailerListInit[j].nameEnum == toMerge[i].nameEnum) {
            if (!RetailerListInit[j].style) {
              RetailerListInit[j].style = {};
            }
            RetailerListInit[j].style.sortOrder = toMerge[i].style.sortOrder;
            foundRetailerEnum = true;
          }
          if (!RetailerListInit[j].style) {
            RetailerListInit[j].style = {};
          }
          if (!RetailerListInit[j].style.sortOrder) {
            let maxSort = 0;
            for (let k = 0; k < toMerge.length; k++) {
              if (toMerge[k].style.sortOrder > maxSort) {
                maxSort = toMerge[k].style.sortOrder;
              }
            }
            RetailerListInit[j].style.sortOrder = maxSort + 1;
          }
        }
        if (!foundRetailerEnum) {
          RetailerListInit.push(toMerge[i]);
        }
      }
    } catch (e) {
      console.error(e);
    }

    triggerRenderImages();

    if (zip) {
      retailerListsBySelectedUPCs[`${selectedUPCsForRetailerListInit}`] = RetailerListInit;
    }
    let retailerList = RetailerListInit;

    if ($scope.offer.offerType == 'RECIPE') {
      $scope.toggleAllRecipeProducts(0);
    } else {
      setTimeout(() => $scope.$apply(), 0);
    }


    if (
      $scope.offer &&
      ($scope.offer.id + '' == '1826617134374081' ||
        $scope.offer.id + '' == '1699976141042688' ||
        $scope.offer.id + '' == '1699976141042689' ||
        (parseInt($scope.offer.id) >= 1699976141042690 && parseInt($scope.offer.id) <= 1699976141042696) ||
        $scope.offer.id + '' == '1833240034027009' ||
        $scope.offer.id + '' == '1833240034027010' ||
        $scope.offer.id + '' == '1833240034027011' ||
        $scope.offer.id + '' == '1699976141042698')
    ) {
      $scope.littmannMessage = true;
      try {
        retailerList.sort((a, b) => {
          return ((a && a.style && a.style.sortOrder) || 0) - ((b && b.style && b.style.sortOrder) || 0);
        });

        let firstRetailer = retailerList[0];
        retailerList.splice(0, 1);
        retailerList = shuffleArray(retailerList);
        retailerList.splice(0, 0, firstRetailer);
      } catch (e) {}
    }
    removeUnavailableRetailers(retailerList, $scope.selectedPearLogicalUPC);
    $scope.pickerList = retailerList || [];
    if ($scope.filterOutVendor) {
      $scope.pickerList = $scope.pickerList.filter((retailer) => !retailer.isVendor);
    }
    pickerListDisplayCache = {};
    $scope.pickerMapByRetailer = mapListByRetailerForScope($scope.pickerList);

    resolvePendingStatusesIfNeeded($scope.pickerList);

    if ($stateParams.debug || window.location.href.indexOf('debug') != -1) {
      window.pear_debug = true;
      for (let i = 0; i < $scope.pickerList.length; i++) {
        for (let j = 0; j < $scope.pickerList[i].upcs.length; j++) {
          if (
            $scope.pickerList[i].upcs[j].computing ||
            $scope.pickerList[i].upcs[j].replacedId ||
            $scope.pickerList[i].upcs[j].status == 'PENDING'
          ) {
            $scope.showDebug = true;
            $scope.pickerList[i].showDebug = true;
          }
        }
      }
    }

    // re-sort the list now that availabilities have come in
    $scope.setPearLogicalUPCs($scope.upcs);

    if (!injectedAfterRetailerList && PixelConfig && injectWidgetConfig) {
      injectedAfterRetailerList = true;
      injectWidgetConfig(PixelConfig.widgetConfig);
    }
  });


  // If React hasn't provided bounds yet, create a small box around current location
  const getInitialBoundsFromScopeForScope = () => {
    const latitude = Number($scope.latitude ?? $scope.location?.latitude);
    const longitude = Number($scope.longitude ?? $scope.location?.longitude);
    return getInitialBoundsFromScope(latitude, longitude);
  };

  // ===== FETCH STORES ONLY (no map, no pins) =====

  (async () => {
    try {
      const zip = $stateParams.zip || $scope.zip || (LocationData && LocationData.zip);
      if (zip) {
        await initRetailerList(
          null /*ResolveRetailerListInit*/,
          false /*storeFinderListUpdate*/,
          zip,
          $scope.selectedUPCs,
          false,
          null
        );
        $timeout(() => $scope.$apply(), 0);
      }
    } catch (e) {
      console.warn('Initial retailer list fetch failed:', e);
    }
  })();

  if (Util.getCookiePreferences().functional || $stateParams.zip) {
    $timeout(
      $async(async () => {
        const domInsertions = $api.get(
          '/v1/offer_dom_insertions?timeout=2000&offerId=' +
            ($scope.offer ? $scope.offer.id : 0) +
            '&upcIds=' +
            encodeURIComponent('')
        );
        await initRetailerList(RetailerListInit, false, null, $scope.selectedUPCs, false);
        $scope.$apply();

        let upcIds = '';
        let upcIdArr = [];
        for (let i = 0; i < $scope.pickerList.length; i++) {
          let retailer = $scope.pickerList[i];
          for (let j = 0; j < retailer.upcs.length; j++) {
            let upc = retailer.upcs[j];
            if (upc.status == 'AVAILABLE' && upcIdArr.indexOf(upc.id) < 0) {
              upcIdArr.push(upc.id);
              upcIds += upc.id + ',';
            }
          }
        }

        if (upcIds.length > 0) {
          upcIds = upcIds.substring(0, upcIds.length - 1);
          // upcIds is built but not currently used - kept for potential future use
        }

        let response = await domInsertions;
        $scope.$apply();

        try {
          if (Util.getCookiePreferences().targeting && response && response.pageLoad) {
            await addTagsToBody($api, response.pageLoad, true, (PageLoad && PageLoad.id) || 0, EVENT_PAGE_LOAD);
            $api.post('/v1/conversion_api?timeout=2000', {
              eventType: 'PageLoad',
              uniqueEventId: window.capiUniqueEventId,
              offerId: $scope.offer.id,
              url: window.location.href,
            });
          }
        } finally {
          completeAddPixelsPromise();
          $scope.$apply();
        }
      }),
      0
    );
  } else {
    completeAddPixelsPromise();
    $scope.noUserEntryAndFunctionalCookiesDisabled = true;
    if (window.pear_debug) {
      console.log('Not installing pixels because functional cookies have been rejected.');
    }
  }

  if ($scope.offer && $scope.offer.pickerCustomStyles) {
    const customStyles = $scope.offer.pickerCustomStyles;
    for (const key in customStyles) {
      if (!customStyles[key]) {
        delete customStyles[key];
        //remove empty styles
      }
    }
    $scope.pickerCustomStyleOverride = customStyles;
  }

  // ============================================================================
  // LINK UTILITY FUNCTIONS
  // ============================================================================
  // Functions for handling Instacart, DoorDash, and other external links
  $scope.isInstacartLink = isInstacartLink;
  $scope.isDoorDashLink = isDoorDashLink;
  $scope.doAllLinksForARetailerPassTest = doAllLinksForRetailerPass;
  $scope.areAllLinksForARetailerInstacartLinks = (retailerName, retailerUPCs) =>
    $scope.doAllLinksForARetailerPassTest(retailerName, retailerUPCs, $scope.isInstacartLink, $scope.memoizedInstacartLinksByRetailer);
  $scope.areAllLinksForARetailerDoordashLinks = (retailerName, retailerUPCs) =>
    $scope.doAllLinksForARetailerPassTest(retailerName, retailerUPCs, $scope.isDoorDashLink, $scope.memoizedDoorDashLinksByRetailer);
  $scope.shouldShowIndividualInstacartLink = (retailerName, upcURL) =>
    shouldShowIndividualInstacartLink(retailerName, upcURL, $scope.memoizedInstacartLinksByRetailer);
  $scope.shouldShowIndividualDDLink = (retailerName, upcURL) =>
    shouldShowIndividualDDLink(retailerName, upcURL, $scope.memoizedDoorDashLinksByRetailer);
  $scope.showRetailerLogo = (retailer) => {
    const theme = ($rootScope.WIDGET_CONFIG && $rootScope.WIDGET_CONFIG.theme) || 'light';
    return showRetailerLogo(retailer, theme, $window.resizeImages);
  };
  $scope.showLogo = (store) => {
      const theme = $rootScope.WIDGET_CONFIG.theme || 'light';
    let img = showLogo(store, theme, $scope.bwLogoImage, $rootScope.WIDGET_CONFIG, $window.resizeImages);
    if (!img) img = $rootScope.WIDGET_CONFIG.defaultBrandPinImg || '../img/defaultStore_opac-trans.png';
    return img;
  };


  // ============================================================================
  // STORE DATA PROCESSING
  // ============================================================================
  // Main function for fetching and processing store data (map initialization removed)
  let firstMarker = true;
  const startMapAndStores = () => {
    $timeout(
      $async(async function () {
        try {
          // Get container size to make map tab default when on desktop but container size is small
          const isSmallSizeScreen = window && window.innerWidth > 992 ? false : true;

          // Initialize scope variables
          initializeMapAndStoresScope($scope, isSmallSizeScreen);

          // Setup category selection
          const vendorId = $scope.vendor?.id;
          if ($scope.productsOpen && typeof ENRICHED_CATEGORY_CONFIG[vendorId]?.default !== 'undefined') {
            $scope.selectCategory(ENRICHED_CATEGORY_CONFIG[vendorId].default);
          }

          // Setup store category toggle
          setupStoreCategoryToggle($scope);

          // Only proceed if we have location data
          if ($scope.location && $scope.location?.longitude && $scope.location?.latitude) {

            // Map initialization removed - handled by React app
            // Map initialization removed - handled by React app
            $scope.vistedMapElements = false;
            $scope.focuseInStoreTab = false;
            $scope.visitedLastProductTile = false;
            $scope.cameFromAddress = false;

            $scope.$watch('addressChange', function () {
              $timeout(() => {
                if ($scope.addressChange == true) {
                  $scope.addressChange = false;
                }
              }, 1000);
            });
          }
        } catch (error) {
          console.error('Error in startMapAndStores async function:', error);
          console.error('Error stack:', error.stack);
        }
      }),
      0
    );
  };

  startMapAndStores();

  $scope.shownStores = [];
  $scope.countVisible = 0;
  $scope.firstFullStoresFetchComplete = false; // flip when initial data done
  $scope.storesDoneLoading = false;

  $scope.selectedStore = null;
  $scope.hoveredStore = null;
  let openFlyout = null;

  $scope.showStr = nonBlankStr;
  $scope.phoneLink = phoneLink;

  // ============================================================================
  // MOBILE FOCUS FUNCTIONS
  // ============================================================================
  // Functions for managing mobile navigation and focus behavior
  $scope.mobileFocusSearch = mobileFocusSearch;
  $scope.selectMapButtonForMobile = () => selectMapButtonForMobile($scope);
  $scope.mobileFocusNav = mobileFocusNav;
  $scope.mobileFocuBackNav = mobileFocusBackNav;
  $scope.mobileFocusUpAndOff = () => mobileFocusUpAndOff($scope.mapOnly);
  $scope.mobileFocusDownAndOff = mobileFocusDownAndOff;
  $scope.mobileFocusToFilter = mobileFocusToFilter;
  $scope.mobileFlyOverFocusOffMap = mobileFlyOverFocusOffMap;

  // ============================================================================
  // ADDITIONAL FOCUS FUNCTIONS
  // ============================================================================
  // Functions for filter panel, search, and navigation focus
  $scope.filterPanelFocus = () => filterPanelFocus($scope);
  $scope.searchButtonDirectFocus = async () => searchButtonDirectFocus($scope, Util);
  $scope.skipNavToInStoreRes = async () => skipNavToInStoreRes(Util);

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================
  // Helper functions for formatting, validation, and data processing
  $scope.formatPhone = (phone) => Util.formatPhone(phone);
  $scope.checkCategories = (logicalUPC) => checkCategories(logicalUPC, $scope.ignoreCategories);
  $scope.checkProductBrand = (logicalUPC) => checkProductBrand(logicalUPC, $scope.ignoreCategories);
  $scope.saveAddressMessage = '';
  $scope.getAddressErrorMessageFunk = () => {
    if ($scope.getAddressErrorMessage) $scope.saveAddressMessage = $scope.getAddressErrorMessage;
    return $scope.saveAddressMessage;
  };
  const scrollToStoreInListForScope = (store, smooth) => scrollToStoreInList(store, smooth);

  // Setup scrolling listeners
  const disposers = [];
  const { recentlyScrolledTimerID } = setupScrollingListeners($scope, $timeout, disposers);

  const hoverStoreTimerID = {};
  $scope.hoverStore = function (storeId) {
    if ($scope.isMobile) return; // fixed: no unconditional return
    const storeIsCurrentlySelected = ($scope.selectedStore && $scope.selectedStore.id) === storeId;
    if (hoverStoreTimerID[storeId] || storeIsCurrentlySelected) return;
    const delay = $scope.selectedStore ? 1000 + (recentlyScrolledTimerID ? 1400 : 0) : 200;
    hoverStoreTimerID[storeId] = setTimeout($scope.selectStore.bind(this, storeId, true), delay);
  };

  $scope.cancelHoverStore = function (storeId) {
    if (storeId == null) {
      const kv = Object.entries(hoverStoreTimerID).find(
        ([_id]) => ($scope.selectedStore && $scope.selectedStore.id) !== _id
      );
      if (kv) storeId = kv[0];
    }
    if (!storeId) return;
    if (hoverStoreTimerID[storeId]) {
      clearTimeout(hoverStoreTimerID[storeId]);
      delete hoverStoreTimerID[storeId];
    }
  };

  let flyToTimerID = null;
  $scope.selectStore = function (storeId, hover, clickStore, skipFlyTo, skipFocusFlyTo) {
    if (hover && !$scope.firstFullStoresFetchComplete) return;
    else $scope.cancelHoverStore(storeId);
    const store = ($scope.stores || []).find((s) => s.id === storeId);
    const marker = store && store.marker;
    if (!marker) return;
    // Map marker management removed - handled by React app
    const el = marker.getElement && marker.getElement();
    if (el) el.classList.add('selected-store');
    if ($scope.selectedStore?.marker?.getElement)
      $scope.selectedStore.marker.getElement().classList.remove('selected-store');

    // Map zoom/center functionality removed - handled by React app

    storeSelectRetailerListPromise = initRetailerList(
      null,
      false,
      store.zip || $scope.location.zip,
      null,
      false,
      store
    );

    // Map zoom/center functionality removed - handled by React app

    if (flyToTimerID) clearTimeout(flyToTimerID);

    if (openFlyout !== store.flyout) {
      openFlyout && openFlyout.remove();
      openFlyout = store.flyout;
    }
    // Map flyout functionality removed - handled by React app

    // Map flyTo functionality removed - handled by React app
    if (clickStore && $scope.isMobileLayout && !skipFocusFlyTo) $scope.mapOnly = true;

    $scope.hoveredStore = ((hover || clickStore) && store) || null;
    if ($scope.selectedStore !== store) {
      $scope.selectedStore = store;
      $timeout(() => $scope.setPearLogicalUPCs && $scope.setPearLogicalUPCs($scope.upcs), 0);
      scrollToStoreInListForScope(store, true);
    }
  };

  $window.googleMapsDirectWindow = $scope.googleMapsDirectWindow = async function ($event, storePearId) {
    if (!$event || !$event.isTrusted) return;
    const store = ($scope.stores || []).find((s) => s.id === storePearId);
    if (!store) return;
    const q = `${store.retailerName || store.name || ''} ${store.shortAddress || store.address || ''}`.trim();
    $window.open('https://maps.google.com/?q=' + encodeURIComponent(q));
  };

  $window.closeiframe = $scope.closeiframe = ($event) => {
    if (!$event || !$event.isTrusted) return;
    $rootScope.pymChild && $rootScope.pymChild.sendMessage && $rootScope.pymChild.sendMessage('picker-closed', true);
  };

  if (!MapLibrariesPreInject) {
    try {
      const src = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.js';
      let script = document.querySelector(`script[src="${src}"]`);
      if (!script) {
        script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);
      }
    } catch (e) {
      console.error(e);
    }

    let bootstrapLoaded = false;
    try {
      const href = 'https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css';
      let stylesheet = document.querySelector(`link[href="${href}"]`);
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.href = href;
        stylesheet.rel = 'stylesheet';
        stylesheet.onload = function () {
          bootstrapLoaded = true;
        };
        document.head.appendChild(stylesheet);
      } else {
        bootstrapLoaded = true;
      }
    } catch (e) {
      console.error(e);
    }

    let maplibreCssLoaded = false;
    try {
      const href = 'https://unpkg.com/maplibre-gl@5.12.0/dist/maplibre-gl.css';
      let stylesheet = document.querySelector(`link[href="${href}"]`);
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.href = href;
        stylesheet.rel = 'stylesheet';
        stylesheet.onload = function () {
          maplibreCssLoaded = true;
        };
        document.head.appendChild(stylesheet);
      } else {
        maplibreCssLoaded = true;
      }
    } catch (e) {
      console.error(e);
    }

    let locatorStylesLoaded = false;
    try {
      const href = '/css/product-locator-22-07.css?rev=' + $config['revision'];
        let stylesheet = document.querySelector(`link[href="${href}"]`);
        if (!stylesheet) {
          stylesheet = document.createElement('link');
          stylesheet.href = href;
          stylesheet.rel = 'stylesheet';
          stylesheet.onload = function () {
            locatorStylesLoaded = true;
          };
          document.head.appendChild(stylesheet);
      } else {
        locatorStylesLoaded = true;
      }
    } catch (e) {
      console.error(e);
    }
    // MapLibrariesPreInject assignment removed - no longer used after React migration
  }

  $scope.pickerListDisplayCached = (pickerUPC, buyOnline) => {
    return (
      (cachedValue = (pickerListDisplayCache[!!buyOnline] = pickerListDisplayCache[!!buyOnline] || {})[
        (pickerUPC && pickerUPC.id) || 0
      ]) || $scope.pickerListDisplay(pickerUPC, buyOnline)
    );
  };


  $window.selectFoundProducts = $scope.selectFoundProducts = async function (storePearId, cameFromProductCount) {
    return selectFoundProducts(storePearId, cameFromProductCount, $scope, $window, $timeout, usedRetailerListInit, RetailerListInit, initRetailerList);
  };

  // Some apps hide vendor tiles in PL
  $scope.shouldDisplayRetailer = function (retailer) {
    return shouldDisplayRetailer(retailer, $scope.filterOutVendor);
  };

  $scope.pickerListDisplay = (pickerUPC, buyOnline) => {
    // Check cache first
    if (
      (cachedValue = (pickerListDisplayCache[!!buyOnline] = pickerListDisplayCache[!!buyOnline] || {})[
        (pickerUPC && pickerUPC.id) || 0
      ]) &&
      !buyOnline
    ) {
      if (inProductLocator || ($scope.offer?.multiSelect && $scope.changeSelectedUPC == false)) {
        return cachedValue;
      }
    }

    let ret = [];
    
    // Handle multi-select case
    if ($scope.offer?.multiSelect && $scope.pickerList.length > 0) {
      ret = getMultiSelectRetailers($scope.offer, $scope.pickerList, $scope.pearLogicalUPCs, $scope.shouldDisplayRetailer);
      $scope.changeSelectedUPC = false;
    } else {
      // Handle single UPC case
      ret = getSingleUPCRetailers(
        pickerUPC, 
        $scope.pickerList, 
        $scope.offer, 
        buyOnline, 
        inProductLocator, 
        $scope.shouldDisplayRetailer, 
        $scope.selectedPearLogicalUPC
      );
      
      // Process retailer styles and timing
      ret.forEach(retailer => {
                if (retailer.style) {
                  retailer.style.whiteOnBlackLogo = Util.patchImageUrl(retailer.style.whiteOnBlackLogo);
                  retailer.style.logo = Util.patchImageUrl(retailer.style.logo);
                }
                if (!retailerUPCToAvailableTime[retailer.nameEnum + ',' + pickerUPC.pearLogicalUPCId]) {
                  retailerUPCToAvailableTime[retailer.nameEnum + ',' + pickerUPC.pearLogicalUPCId] = $scope.resolveTime;
          }
        });
      }

    // Cache result
    pickerListDisplayCache[!!buyOnline][(pickerUPC && pickerUPC.id) || 0] = ret;
    return ret;
  };

  if ($stateParams && ($stateParams.config || $stateParams.zip)) {
    try {
      injectWidgetConfig(JSON.parse($stateParams.config || '{}'));
    } catch (err) {
      console.error(err);
    }
    if (
      ($rootScope.WIDGET_CONFIG.defaultToCategory ||
        !($rootScope.WIDGET_CONFIG.upcIds && $rootScope.WIDGET_CONFIG.upcIds.length)) &&
      $rootScope.WIDGET_CONFIG.preSelectCategory
    ) {
      $scope.selectCategory && $scope.selectCategory($rootScope.WIDGET_CONFIG.preSelectCategory);
    } else if ($rootScope.WIDGET_CONFIG.upcIds && $rootScope.WIDGET_CONFIG.upcIds.length) {
      $scope.selectedUPCs = [...$rootScope.WIDGET_CONFIG.upcIds];
      $scope.findOnline = true;
    }
  }
  $scope.$on &&
    $scope.$on('$destroy', function () {
      disposers.forEach((d) => {
        try {
          d();
        } catch (e) {}
      });
      Object.values(hoverStoreTimerID).forEach((id) => clearTimeout(id));
      if (recentlyScrolledTimerID) clearTimeout(recentlyScrolledTimerID);
      if (flyToTimerID) clearTimeout(flyToTimerID);
    });

  // Add toggleProduct function (copied from picker.js)
  $scope.toggleProduct = function (array, product) {
    $scope.selectedCategories = [];
    const idx = array.indexOf(product.id);

    const remove = idx >= 0;
    if ($scope.singleItemSelect && remove) {
      return;
    }

    if (remove) {
      array.splice(idx, 1);
    } else {
      if ($scope.singleItemSelect) {
        array.splice(0, array.length);
      }
      array.push(product.id);
    }

    (($scope.upcsByName || {})[product.name] || [])
      .filter((upc) => upc.id != product.id)
      .forEach((otherUPC) => {
        let otherIdx = array.indexOf(otherUPC.id);
        if (remove && otherIdx >= 0) {
          array.splice(otherIdx, 1);
        } else if (!remove && otherIdx == -1) {
          array.push(otherUPC.id);
        }
      });
  };
};

angular.module('pearApp').controller('ProductLocatorController', productLocatorController);

},{"../../js/offers/brand/enriched_category.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/brand/enriched_category.js","../pear-console.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js","../utilities.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","./geocoding-cache.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/geocoding-cache.js","./map-utils.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/map-utils.js","./ng-async.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/ng-async.js","./product-locator-utils.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/product-locator-utils.js","./stadia-maps-config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/stadia-maps-config.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/reset_css.js":[function(_dereq_,module,exports){
const getDepth = function(element) {
  let depth = 1;
  let ancestor = element.parentElement;
  while (ancestor.closest('*[css-reset]') != null) {
    depth++;
    ancestor = ancestor.closest('*[css-reset]').parentElement;
  }
  return depth;
};

const label = function(element, depth, crossBoundary) {
  element.id = 'css-reset' + depth;
  const addClassName = (element, className) => {
    const existing = (element.getAttribute('class') || '');
    element.setAttribute('class', (existing ? existing + ' ' : '') + className);
  };

  if (getClassNames(element).indexOf('css-reset') < 0) {
    addClassName(element, 'css-reset');
  }

  const labelInner = function(element, depth, crossBoundary) {
    if (!depth) {
      depth = 0;
    }
    const className = 'css-reset' + depth;
    if (getClassNames(element).indexOf(className) < 0) {
      addClassName(element, className);
    }
    for (let i = 0; i < element.children.length; i++) {
      const child = element.children[i];
      if (getClassNames(child).indexOf('css-reset') < 0 && !child.hasAttribute('css-reset')) {
        labelInner(child, depth, crossBoundary);
      } else if (crossBoundary) {
        label(child, depth + 1, crossBoundary);
      }
    }
  };
  labelInner(element, depth, crossBoundary);
};

const getClassNames = function(element) {
  try {
    return ('' + element.getAttribute('class')).split(' ');
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getRule = function(rule, selectorToAdd) {
  if (!rule.selectorText) {
    return;
  }
  const selectors = rule.selectorText.split(',');
  for (let i = 0; i < selectors.length; i++) {
    let selector = selectors[i].trim();

    if ((' ' + selector).endsWith(' body')) {
      selector = (' ' + selector).replace(new RegExp(' body', 'g'), ' .css-reset');
    }
    if ((' ' + selector).endsWith(' html')) {
      selector = (' ' + selector).replace(new RegExp(' html', 'g'), ' .css-reset');
    }
    if (selector.indexOf(':') > -1) {
      selector = selector.substring(0, selector.indexOf(':')) + selectorToAdd + selector.substring(selector.indexOf(':'));
    } else {
      if (selector.endsWith('*')) {
        selector = selector.substring(0, selector.length - 1);
      }
      selector += selectorToAdd;
    }
    selectors[i] = selector;
  }
  let newSelector = '';
  for (let i = 0; i < selectors.length; i++) {
    newSelector += selectors[i];
    if (i < selectors.length - 1) {
      newSelector += ',';
    }
  }
  if (rule && rule.style && rule.style.cssText) {
    const cssText = rule.style.cssText;
    return newSelector + ' { ' + cssText + ' }';
  } else {
    return newSelector + ' { }';
  }
};

const modifyStyle = function(style, selectorToAdd, document) {
  if (!style || !style.sheet || (!style.sheet.cssRules && style.sheet.rules)) {
    return;
  }


  let rules = style.sheet.cssRules;
  if (!rules) {
    rules = style.sheet.rules;
  }

  const newRules = [];
  for (let j = 0; j < rules.length; j++) {
    const rule = rules[j];
    if (rule.cssText.indexOf('font-face') > -1) {
      newRules[newRules.length] = rule.cssText;
    } else if (rule.selectorText) {
      newRules[newRules.length] = getRule(rule, selectorToAdd);
    } else if ((rule.cssRules || rule.rules) && rule.media) {
      let innerRules = rule.cssRules;
      if (!innerRules) {
        innerRules = rule.rules;
      }
      let innerRulesString = '';
      for (let k = 0; k < innerRules.length; k++) {
        if (innerRules[k].selectorText) {
          const ruleString = getRule(innerRules[k], selectorToAdd);
          if (ruleString) {
            innerRulesString += ruleString;
          }
        }
      }
      if (innerRulesString != '') {
        newRules[newRules.length] = rule.cssText.split('{')[0] + ' {' + innerRulesString + '}';
      }
    }
  }

  const parent = style.parentNode;


  let css = '';
  for (let i = 0; i < newRules.length; i++) {
    css += newRules[i];
  }

  const newStyle = document.createElement('style');
  newStyle.type = 'text/css';

  newStyle.appendChild(document.createTextNode(css));
  parent.insertBefore(newStyle, style);
  parent.removeChild(style);
};

const modifyStyles = async function(selector, document) {
  const links = document.querySelectorAll('link[rel=stylesheet]' + selector + ':not([no-reset-css])');
  if (typeof angular != 'undefined') {
    for (let i = 0; i < links.length; i++) {
      const link = angular.element(links[i]);
      link.on('load', function(event, el) {
        modifyStyle(this, selector, document);
      });
    }
  } else {
    for (let i = 0; i < links.length; i++) {
      const link = links[i];
      if (link.href.indexOf("http") == 0) {
        let response = await fetch(link.href);
        let text = await response.text();
        let style = document.createElement("style");
        style.type= "text/css";
        style.innerHTML = text;
        link.parentElement.appendChild(style);
      }
    }
  }

  const styles = document.querySelectorAll('style' + selector + ':not([no-reset-css])');
  for (let i = 0; i < styles.length; i++) {
    const style = styles[i];
    modifyStyle(style, selector, document);
  }
};

module.exports = {
  getDepth: getDepth,
  label: label,
  getRule: getRule,
  modifyStyles: modifyStyles,
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/retailer/retailer-shared.js":[function(_dereq_,module,exports){
const Config = _dereq_('../../config.js');
const storage = _dereq_('../../storage.js');

module.exports.saveAuthInfoToSession = function(authInfo, sendMessageToParent) {
  const authInfoStr = JSON.stringify(authInfo);
  const encodedAuthInfoString = Buffer.from(authInfoStr, 'utf8').toString('base64');

  storage.session.setItem('auth', encodedAuthInfoString);
  if (Config.env == 'development') {
    storage.session.setItem('auth:debug', authInfoStr);
  }
};
module.exports.exportAuthInfo = function(pym) {
  pym.sendMessage('pear_save_auth_data', storage.session.getItem('auth'));
};
module.exports.messageLoginSuccess = function(pym, auth) {
  pym.sendMessage('pear_login_success', auth);
};

},{"../../config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","../../storage.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/stadia-maps-config.js":[function(_dereq_,module,exports){
// Stadia Maps API configuration
const Config = _dereq_('../config.js');

const STADIA_MAPS_CONFIG = {
  API_KEY: Config.STADIA_MAPS_API_KEY,
  BASE_URL: 'https://api.stadiamaps.com/geocoding/v1',
  DEFAULT_COUNTRIES: 'US,CA,GB,AU,IE,NZ,PR,FR,DE',
  DEFAULT_LIMIT: 10,
  PEAR_GEOCODING_URL: 'https://qpb5zii2fi.us-east-1.awsapprunner.com/v1',
  // Mapbox fallback configuration
  MAPBOX_API_KEY: Config.MAPBOX_API_KEY,
  MAPBOX_GEOCODING_URL: 'https://api.mapbox.com/geocoding/v5'
};

module.exports = STADIA_MAPS_CONFIG; 

},{"../config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/telephone.js":[function(_dereq_,module,exports){
module.exports.applyMaskToAllInputsOfTypeTel = function() {
  const allInputs = document.getElementsByTagName('input');
  if (!allInputs || !allInputs.length) {
    return;
  }

  const inputArray = Array.prototype.slice.call(allInputs);

  const telephoneInputs = inputArray.filter(function(inputElement) {
    return inputElement.getAttribute('type') === 'tel';
  });
  if (!telephoneInputs || !telephoneInputs.length) {
    return;
  }

  telephoneInputs.forEach(function(inputElement) {
    let lastValue = null;
    inputElement.addEventListener('keydown', function() {
      setTimeout(function() {
        const originalValue = inputElement.value;
        if (originalValue === lastValue) {
          return;
        }

        let selectionStart = inputElement.selectionStart;
        let selectionEnd = inputElement.selectionEnd;
        const beforeCursor = originalValue.substring(0, selectionStart);
        const nonDigits = beforeCursor.replace(/\d/g, '');
        selectionStart -= nonDigits.length;
        selectionEnd -= nonDigits.length;

        const digitsOnly = originalValue.replace(/\D/g, '');
        const digits = digitsOnly.split('');


        if (digits.length > 3) {
          digits.splice(3, 0, '-');

          if (selectionStart > 3) {
            selectionStart++;
          }

          if (selectionEnd > 3) {
            selectionEnd++;
          }
        }


        if (digits.length > 7) {
          digits.splice(7, 0, '-');

          if (selectionStart > 7) {
            selectionStart++;
          }

          if (selectionEnd > 7) {
            selectionEnd++;
          }
        }


        lastValue = digits.join('');
        inputElement.value = lastValue;

        inputElement.selectionStart = selectionStart;
        inputElement.selectionEnd = selectionEnd;
      });
    });
  });
};

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/templateProvider/pickerTemplateProvider.js":[function(_dereq_,module,exports){
module.exports = function pickerTemplateProvider(httpRequester, revision, offer, parseUri) {
    const MOBILE_WIDTH = 736; 
    let template = offer?.pickerTemplate;

    if (offer.videoUrl) {
        template = '/html/picker-video.html';
    } else if (!template) {
        const params = parseUri(window.location.href).queryKey;
        const { m, mobile } = params || { m: false, mobile: false };
        const elementWidth = document?.documentElement?.clientWidth || 0;
        const windowWidth = window?.innerWidth || 0;
        const maxWindowWidth = Math.max(elementWidth, windowWidth);

        template = '/html/pickerv2.html';
        if (m || mobile || maxWindowWidth < MOBILE_WIDTH) {
            template = '/html/pickerv2-mobile.html';
        }
    }

    const rev = revision || new Date().getTime();

    return httpRequester.get(`${template}?rev=${rev}`).then(({data}) => data);
}
},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js":[function(_dereq_,module,exports){
// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License

const parseUri = function (str) {
  const o = parseUri.options;
  const m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
  const uri = {};
  let i = 14;

  while (i--) uri[o.key[i]] = m[i] || '';

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });

  uri.toUrl = () => {
    return `${uri.protocol}:\\${uri.host}${uri.port && uri.port != 80 ? `:${uri.port}` : ''}${uri.path}${uri.queryKey ? `?${new URLSearchParams(uri.queryKey)}` : ''}${uri.anchor ? `#${uri.anchor}` : ''}`;
  }

  return uri;
};

parseUri.options = {
  strictMode: false,
  key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
  q: {
    name: 'queryKey',
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
  },
  parser: {
    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
    /* eslint-disable max-len */
    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
  },
};

module.exports = parseUri;

},{}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js":[function(_dereq_,module,exports){
const Config = _dereq_('./config.js');
const parseUri = _dereq_('./parseuri.js');

const safeWrapLogger = (module.exports.safeWrapLogger = (logger) => {

  const params = parseUri(window.location).queryKey;
  const urlDebug = params['pear_debug'] || params['debug'];
  return (...args) => {

    if (Config.env !== 'production' || urlDebug) {
      args.unshift(`[Pear - ${Config.env}]`);
      logger.apply(this, args);
    }
  };
});

/**
 * PearConsole is a production-safe wrapper around window.console that will not spam logs unless we're in production
 * or the pear_debug url parameter is present.
 */
const PearConsole = (module.exports.PearConsole = {
  log: safeWrapLogger(window.console.log),
  error: safeWrapLogger(window.console.error),
  debug: safeWrapLogger(window.console.debug),
  info: safeWrapLogger(window.console.info),
  warn: safeWrapLogger(window.console.warn),
  trace: safeWrapLogger(window.console.trace),
});
// eslint-disable-next-line  no-unused-vars
const console = PearConsole;

},{"./config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","./parseuri.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/sdk/sentry-client.js":[function(_dereq_,module,exports){
const Config = _dereq_('../config.js');
const parseUri = _dereq_('../parseuri.js');
const Util = _dereq_('../utilities.js');
const console = Util.PearConsole;

let Sentry;
let ExtraErrorDataIntegration;

let error = false;

const blacklistedDomains = ["riteaid.com"]
try {
  let blacklist = false;
  blacklistedDomains.forEach((blacklistedDomain) => {
    if (window.location.href.indexOf(blacklistedDomain) > -1) {
      blacklist = true;
    }
  })
  if (blacklist) {
    throw new Error("Known Namespace conflict on " + window.location.href);
  }
  Sentry = _dereq_('@sentry/browser/dist/index');
  //ExtraErrorDataIntegration = require('@sentry/integrations').ExtraErrorData;
} catch (ex) {
  error = true;
  module.exports = {
    captureException: function (e) {
      if (!(e instanceof Error)) {
        e = new Error(e);
      }
      console.log(e);
    },
    setContext: function () {

    },
    setTag: function () {

    }
  }
}
if (!error) {

  const urlDebug = parseUri(window.location).queryKey['pear_debug'];

  const params = {
    dsn: 'https://43ab018f4059466a9b7c3db0bfe5bceb@sentry.io/1470754',

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Config.env == 'production' ? 0.2 : 1.0,
    debug: Config.env != 'production' || urlDebug,
    sendDefaultPii: true,
  };

  if (Config['revisionShort'] && Config['env'] != 'development') {
    params['release'] = Config['env'] + '-' + Config['revisionShort'];
  }

  params['environment'] = Config['env'];

  const client = new Sentry.BrowserClient(params);
  const hub = new Sentry.Hub(client);
  hub.bindClient(client);

  try {
    const context = {
      url: window.location.href,
      userAgent: navigator.userAgent,
    };

    hub.setContext("client", context);
  } catch (e) {
    if (!(e instanceof Error)) {
      e = new Error(e);
    }
    hub.captureException(e);
  }

  module.exports = hub;
}

},{"../config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","../parseuri.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js","../utilities.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js","@sentry/browser/dist/index":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/@sentry/browser/dist/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js":[function(_dereq_,module,exports){
const Config = _dereq_('./config.js');
const suffix = Config.env != 'production' ? Config.env : '';

_dereq_('webstorage-polyfill');
const storageFactory = _dereq_('storage-factory').storageFactory;

const base64 = _dereq_('./base64.js');
const pearConsole = _dereq_('./pear-console.js');
/**
 * PearConsole is a production-safe wrapper around window.console that will not spam logs unless we're in production
 * or the pear_debug url parameter is present.
 */
const PearConsole = (module.exports.PearConsole = pearConsole.PearConsole);

// eslint-disable-next-line  no-unused-vars
const console = PearConsole;


let client = null;
const setSentryClient = (module.exports.setSentryClient = (_client) => {
  client = _client;
});

const storageAvailable = (module.exports.storageAvailable = (storage) => {
  try {
    if (!storage) {
      return false;
    }
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    try {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    } catch (e2) {
      return false;
    }
  }
});

const localStorageAvailable = (module.exports.localStorageAvailable = () => {
  return storageAvailable(localStorage);
});

const sessionStorageAvailable = (module.exports.sessionStorageAvailable = () => {
  return storageAvailable(sessionStorage);
});

class MemoryStorage {
  constructor() {
    this._data = {};
  }

  getItem(key) {
    return this._data.hasOwnProperty(key) ? this._data[key] : null;
  }

  setItem(key, value) {
    return (this._data[key] = String(value));
  }

  removeItem(key) {
    return delete this._data[key];
  }

  clear() {
    return (this._data = {});
  }
}
module.exports.MemoryStorage = MemoryStorage;

const memstorage = module.exports.memory = (window.__pMemStore = window.__pMemStore || new MemoryStorage());
const localStorageOrBest = (() => {
  try {
    if (storageAvailable(localStorage)) {
      return localStorage;
    } else if (storageAvailable(sessionStorage)) {
      return sessionStorage;
    } else {
      return memstorage;
    }
  } catch (e) {
    return memstorage;
  }
})();

const local = (module.exports.local = storageFactory(() => localStorage));
const session = (module.exports.session = storageFactory(() => sessionStorage));
const localOrBest = (module.exports.localOrBest = storageFactory(() => localStorageOrBest));

const localClidStore = (module.exports.localClidStore = storageFactory(() =>
  singleKeyEncodedDelegateStore(`_pclid_${suffix}`, local)
));

const sessionClidStore = (module.exports.sessionClidStore = storageFactory(() =>
  singleKeyEncodedDelegateStore(`_pclid_${suffix}`, session)
));
const localOrBestClidStore = (module.exports.localOrBestClidStore = storageFactory(() =>
  singleKeyEncodedDelegateStore(`_pclid_${suffix}`, localOrBest)
));

const memoize = (module.exports.memoize = function (f) {
  const mem = {};
  return (...args) =>
    args in mem ? mem[args] : (mem[args] = f.apply(this, args));
});

/**
 * When you don't want to use a ton of keys, and you don't need it to be human readable
 */
const singleKeyEncodedDelegateStore =
  /* prettier-ignore */
  memoize((key, store) => {
    const e = base64.base64Encode;

    const d = base64.base64Decode;

    let data = null;
    const getData = () => {
      const dataStr = store.getItem(key);
      if (dataStr) {
        try {
          data = d(dataStr);
        } catch (e) {
          console.error(e);
          data = {};
        }
        if (typeof data == "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {
            console.error(e);
            data = {};
          }
        }
        if (!data) {
          data = {};
        }
      } else {
        data = {};
      }

      if (data == null) {
        data = {};
      }
      return Object.assign({}, data);
    };

    const setData = (_data) => {
      if (_data && Object.keys(_data).some((k) => !!k) && Object.values(_data).some((v) => !!v)) {
        data = _data;
        store.setItem(key, e(data));
      } else {
        data = {};
        store.removeItem(key);
      }

      try {
        if (client != null) {
          client.setContext("storage", _data);
        }
      } catch (e) {
        //
      }
    };

    return {
      setItem: function (_key, val) {
        if (_key == '__some_random_key_you_are_not_going_to_use__') {
          return;
        }
        let _data = null;
        if (data == null) {
          _data = getData();
        } else {
          _data = Object.assign({}, data);
        }
        if (_data[_key] != val) {
          _data[_key] = val;
          setData(_data);
        }
      },
      getItem: function (_key) {
        if (_key == '__some_random_key_you_are_not_going_to_use__') {
          return _key;
        }
        let _data = null;
        if (data == null) {
          _data = getData();
        } else {
          _data = Object.assign({}, data);
        }
        if (typeof _key == 'undefined') {
          return _data;
        }
        return _data[_key];
      },
      isSupported: function () {
        return true;
      },
      removeItem: function (_key) {
        if (_key == '__some_random_key_you_are_not_going_to_use__') {
          return;
        }
        let _data = null;
        if (data == null) {
          _data = getData();
        } else {
          _data = Object.assign({}, data);
        }
        if (_data[_key]) {
          delete _data[_key];
          setData(_data);
        }
      },
      clear: function () {
        if (data) {
          setData({});
        }
      },
    };
  });

},{"./base64.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/base64.js","./config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","./pear-console.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js","storage-factory":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/storage-factory/lib/index.js","webstorage-polyfill":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/node_modules/webstorage-polyfill/index.js"}],"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/utilities.js":[function(_dereq_,module,exports){
/*
 * Utility functions that could conceivably be used in any app (Offers, SDK, or chrome extensions)
 */
const parseUri = _dereq_('./parseuri.js');
const Config = _dereq_('./config.js');
const storage = _dereq_('./storage.js');
const pearConsole = _dereq_('./pear-console.js');

const memoize = (module.exports.memoize = function (f) {
  const mem = {};
  return (...args) => (args in mem ? mem[args] : (mem[args] = f.apply(this, args)));
});

const partition = (module.exports.partition = function (arr, length) {
  var result = [];
  for (var i = 0; i < arr.length; i++) {
    if (i % length === 0) result.push([]);
    result[result.length - 1].push(arr[i]);
  }
  return result;
});

const keepTruthy = (module.exports.keepTruthy = (obj) => {
  obj = Object.assign({}, obj);
  for (var propName in obj) {
    if (!obj[propName]) {
      delete obj[propName];
    }
  }
  return obj;
});

const delay = (module.exports.delay = (t) => new Promise((resolve) => setTimeout(resolve, t)));

const keepDefined = (module.exports.keepDefined = (obj) => {
  obj = Object.assign({}, obj);
  for (var propName in obj) {
    if (typeof obj[propName] == 'undefined') {
      delete obj[propName];
    }
  }
  return obj;
});

const keepKeys = (module.exports.keepKeys = (obj, keys, inPlace) => {
  obj = Object.assign({}, obj);
  for (var propName in obj) {
    if (keys.indexOf(propName) == -1) {
      delete obj[propName];
    }
  }
  return obj;
});

const safeWrapLogger = pearConsole.safeWrapLogger;

const splitKeep = function (string, delimiter) {
  const res = [];
  let start = 0;
  let index;

  while ((index = string.slice(start).search(delimiter)) != -1) {
    // account for the slice
    index = index + start;

    const val = string.substr(start, index - start);
    if (val != '') {
      res.push(val);
    }
    res.push(string[index]);
    start = index + 1;
  }
  res.push(string.substr(start));
  return res;
};
module.exports.nonBlankStr = (value) => {
      if (value === null) {
        return false;
      } else if (!/\S/.test(value)) {
        // string does not have any non-whitespace characters
        return false;
      }
      return true;
    }

module.exports.phoneLink =  (store) => {
  //TODO: there was discussion around making this link to the google maps location on desktop
  //which we can reevaluate later OF-21 https://pearcommerce.atlassian.net/browse/OF-21
  if (store.phone) {
    return `tel:${store.phone}`;
  } else {
    return "";
  }
}
const FN_ARG = ',';
const FIELD = '.';
/**
 * Access into object using a string of the form 'store_product.name.0.slice(0, 4).length'
 * Where '.' delimiters indicate field accessors and '(' and ',' and ')' together indicate function calls
 */
module.exports.applyAccessorsAndFnCalls = (json, accessorStr, dontLog) => {
  let next = null;
  let uncalledFn = false;
  let result = splitKeep(accessorStr, /\./).reduce(function (o, k) {
    let val;
    if ('.,'.indexOf(k) == 0 && k.length == 1) {
      next = k;
      val = o;
    } else {
      let params = null;
      if (k.indexOf('(') >= 0 && k.indexOf(')') >= 0) {
        [k, params] = k.split('(');
        params = params.split(')')[0].split(',');
      } else {
        [k, ...params] = k.split(',');
      }
      params = params.map((param) => {
        if (param.indexOf('"') == 0 || param.indexOf("'") == 0) {
          param = param.slice(1, -1);
        }
        return param;
      });
      if (!dontLog) {
        console.log(o, k, next, params);
      }
      uncalledFn = false;
      if (next == FN_ARG) {
        val = o && o(k);
      } else if (next == FIELD || next == null) {
        val = o && o[k];

        if (typeof val === 'function') {
          val = val.apply(o, params);
        }
      }
      next = null;
    }
    return val;
  }, json);

  if (uncalledFn) {
    result = result();
  }
  return result;
};

const hexToRgb = (module.exports.hexToRgb = (hex) =>
  hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1)
    .match(/.{2}/g)
    .map((x) => parseInt(x, 16)));

// eslint-disable-next-line  no-unused-vars
const reload = (module.exports.reload = () => {
  window.location.reload();
});

const distanceMiles = (module.exports.distanceMiles = (lat1, lon1, lat2, lon2) => {
  var p = 0.017453292519943295; // Math.PI / 180
  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;

  return 12742 * Math.asin(Math.sqrt(a)) * 0.621371; // 2 * R; R = 6371 km
});

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after N milliseconds. If `immediate`
// is passed, trigger the function on the leading edge, instead of the trailing.
// eslint-disable-next-line  no-unused-vars
const debounce = (module.exports.debounce = _dereq_('./debounce'));

module.exports.wait = (ms) => new Promise((r, j) => setTimeout(r, ms));

/**
 * PearConsole is a production-safe wrapper around window.console that will not spam logs unless we're in production
 * or the pear_debug url parameter is present.
 */
const PearConsole = (module.exports.PearConsole = pearConsole.PearConsole);

// eslint-disable-next-line  no-unused-vars
const console = PearConsole;

/**
 * Takes a json map and returns a url query string a la a=b&c=d&e=f (no leading '?').
 */
module.exports.jsonToQueryString = (json) => {
  return Object.keys(json)
    .filter((key) => json[key])
    .map((key) => {
      return [key, json[key]].map(encodeURIComponent).join('=');
    })
    .join('&');
};

// A function to format text to look like a phone number
module.exports.formatPhone = (input) => {
  input = input || '';
  // Strip all characters from the input except digits
  input = input.replace(/\D/g, '');

  // Take the last ten characters, in case we get country codes prepended
  input = input.slice(-10);

  // Based upon the length of the string, we add formatting as necessary
  var size = input.length;
  if (size == 0) {
    input = input;
  } else if (size < 4) {
    input = '(' + input;
  } else if (size < 7) {
    input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
  } else {
    input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + '-' + input.substring(6, 10);
  }
  return input;
};

module.exports.formatPhoneAria = (input) => {
  input = input || '';
  // Strip all characters from the input except digits
  input = input.replace(/\D/g, '');

  // Take the last ten characters, in case we get country codes prepended
  input = input.slice(-10);

  // Based upon the length of the string, we add formatting as necessary
  input = input.split('').join(' ');
  return input;
};

const getCookiePreferences = (module.exports.getCookiePreferences = function () {
  var ret = null;
  try {
    ret = JSON.parse(storage.local.getItem('pear-privacy-v2'));
  } catch (e) {
    console.error(e);
  }

  return ret || {};
});

const getPearSession = (module.exports.getPearSession = function () {
  let datastore = (getCookiePreferences() || {}).analytics ? storage.local : storage.memory;
  return datastore.getItem('pear-session');
});

const setPearSession = function (pearSession) {
  let datastore = (getCookiePreferences() || {}).analytics ? storage.local : storage.memory;
  datastore.setItem('pear-session', pearSession);
};

const addPearSession = (module.exports.addPearSession = function (neaPearSession) {
  const pearSession = getPearSession();
  let pearSessions;
  if (typeof pearSession == 'undefined' || !pearSession) {
    pearSessions = [];
  } else {
    pearSessions = pearSession.split(',');
  }

  if (pearSessions.length > 4) {
    pearSessions = pearSessions.slice(pearSessions.length - 1 - 3);
  }
  if (pearSessions.indexOf(neaPearSession) == -1) {
    pearSessions.push(neaPearSession);
  }

  const finalPearSession = pearSessions.join(',');
  setPearSession(finalPearSession);
});

/**
 * A wrapper around fetch that is simpler in the common case. Most values of the config object are defaulted, but anything
 * passed in will override the defaults. The response body is also awaited, so you don't need to do that after getting
 * a response.
 */
const fetchJson = (module.exports.fetchJson = async (url, overrides) => {
  const headers = {
    'Content-Type': 'application/json',
    // 'Content-Type': 'application/x-www-form-urlencoded',
  };

  const pearSession = getPearSession();
  if (pearSession) {
    headers['pear-session'] = pearSession;
  }

  const response = await fetch(
    url,
    Object.assign(
      {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'omit', // include, *same-origin, omit
        headers: headers,
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer-when-downgrade', // no-referrer, *client
      },
      overrides || {}
    )
  );

  for (const pair of response.headers.entries()) {
    if (pair[0].toLowerCase() == 'pear-session') {
      addPearSession(pair[1]);
      break;
    }
  }

  // response.json() throws on empty response bodies, and I'd prefer that to be modeled as a null
  const body = await response.text();
  if (!response.ok) {
    handleError(`${response.statusText} -- ${body}`);
  }

  return jsonParseQuietly(body);
});

module.exports.postJson = async (url, data) => {
  return await fetchJson(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

module.exports.capitalizeFirst = (string) => {
  if (!string) {
    return string;
  }
  return string[0].toUpperCase() + string.slice(1);
};

// eslint-disable-next-line  no-unused-vars
const getJson = (module.exports.getJson = async (url) => {
  return await fetchJson(url, { method: 'GET' });
});

const makeRejectionError = function (arg) {
  try {
    // eslint-disable-next-line new-cap
    handleError(arg);
    return arg;
  } catch (newError) {
    return newError;
  }
};
/**
 * Takes a function that returns a truthy value to poll for.  Returns a promise that resolves to that value when it
 * becomes truthy.
 *
 * Note, if your check condition is not the same thing as your return value, you can do something like: () => {
 *   return <condition> && <return value>
 * }
 * Because in javascript, the value of an entire && or || expression is the last sub expression to have been evaluated.
 */
const pollFor = (module.exports.pollFor = (fn, maxAttempts, errorMsg, timeoutIncrease, expectedError) =>
  new Promise((resolve, reject) => {
    timeoutIncrease = timeoutIncrease || 0;
    let timeout = 120;
    maxAttempts = maxAttempts || 200;
    let attempts = 0;
    const checkForValOrRecurse = function () {
      (async () => {
        try {
          attempts++;
          const val = await fn();
          if (val) {
            resolve(val);
          } else if (maxAttempts < 0 || attempts < maxAttempts) {
            timeout = timeout + timeoutIncrease;
            setTimeout(checkForValOrRecurse, timeout);
          } else {
            if (expectedError) {
              resolve(null);
            } else {
              reject(makeRejectionError(`waitFor exceeded ${maxAttempts} iterations!${'  ' + (errorMsg || fn || '')}`));
            }
          }
        } catch (e) {
          reject(makeRejectionError(`Error occurred: ${e}`));
        }
      })();
    };

    checkForValOrRecurse();
  }));

module.exports.pollForElementByClassName = (className, maxAttempts) =>
  pollFor(
    () => {
      const elems = document.getElementsByClassName(className);
      return elems.length && elems;
    },
    maxAttempts || 200,
    `Classname: ${className}`
  );

module.exports.pollForElementBySelector = (selector, maxAttempts, iframeSelector, expectedError) =>
  pollFor(
    () => {
      let document = window.document;
      if (iframeSelector) {
        const iframe = window.document.querySelector(iframeSelector);
        if (!iframe) {
          return null;
        }
        document = iframe.contentDocument;
      }
      const elems = document.querySelectorAll(selector);
      return elems && elems.length && elems;
    },
    maxAttempts || 200,
    `Selector: ${selector}`,
    null,
    expectedError
  );

const objectEquals = (module.exports.objectEquals = (oldData, newData) => {
  if (typeof oldData == 'undefined') {
    return typeof newData == 'undefined';
  }
  if (typeof newData == 'undefined') {
    return typeof oldData == 'undefined';
  }
  if (oldData == null) {
    return newData == null;
  }
  if (newData == null) {
    return oldData == null;
  }
  if (typeof oldData != 'object' || typeof newData != 'object') {
    return oldData == newData;
  }
  if (oldData.length != newData.length) {
    return false;
  }
  let equals = true;
  for (const k of Object.keys(oldData)) {
    if (typeof oldData[k] !== 'object') {
      if (typeof oldData[k] === 'function' && typeof newData[k] === 'function') {
        equals = equals && oldData[k].toString() === newData[k].toString();
      } else if (oldData[k] !== newData[k]) return false;
    } else {
      equals = equals && objectEquals(oldData[k], newData[k]);
    }
  }
  return equals;
});

// map of observer to list of domQueries
module.exports.monitorDomForChanges = async (domMonitorQuery, onChange) => {
  console.log('MONITOR DOM FOR CHANGES ', domMonitorQuery, onChange);

  module.exports
    .pollForElementBySelector(domMonitorQuery.domChangeMonitorParent, 25, domMonitorQuery.iframeSelector, true)
    .then(
      (parents) => {
        const parent = parents && parents.length && parents[0];
        if (parent) {
          let registeredOnChange = false;

          // memoized, so we can call this multiple times
          const observer = new MutationObserver(async function (mutationsList, observer) {
            if (!registeredOnChange) {
              const elem = document.querySelector(domMonitorQuery.accessors[0]);
              if (elem) {
                registeredOnChange = true;
                console.log('REGISTERING ONCHANGE ON ', elem);
                elem.addEventListener('change', onChange, false);
              }
            }

            console.log(mutationsList);
            try {
              await onChange.apply();
            } catch (e) {
              handleError(e);
            }
          });

          domMonitorQuery.parent = parent;
          observer.observe(parent, { attributes: true, childList: true, attributeOldValue: false, subtree: true });

          onChange.apply();
        } else {
          console.log('NO PARENT DETECTED!', domMonitorQuery.domChangeMonitorParent, parents);
        }
      },
      (err) => {
        handleError(err);
      }
    );
};

const toNumber = (module.exports.toNumber = function (value) {
  value = typeof value == 'undefined' || value == null ? this : value;
  if (!value) {
    return 0;
  }
  return Number(`${value}`.replace(/[^0-9\.]+/g, ''));
});

// eslint-disable-next-line no-extend-native
String.prototype.__pToNumber = function () {
  return toNumber(this);
};

const stripNonNumeric = (module.exports.stripNonNumeric = function (value) {
  value = typeof value == 'undefined' || value == null ? this : value;
  if (!value) {
    return 0;
  }
  return `${value}`.replace(/\D/g, '');
});

// eslint-disable-next-line no-extend-native
String.prototype.__pStripNonNumeric = function () {
  return stripNonNumeric(this);
};

const getInjector = (angular) => {
  let $injector = null;

  if (angular && angular.element) {
    try {
      $injector = angular.element(document.body).injector();
      if (!$injector) {
        $injector = angular.element(document.querySelector('*[class^="ng-"]')).injector();
      }

      if (!$injector) {
        const ngXpathResult = document.evaluate(
          '//@*[contains(local-name(), "ng-")]',
          document,
          Function,
          XPathResult.ANY_TYPE,
          null
        );
        let ngXpath = null;
        while (!$injector && (ngXpath = ngXpathResult.iterateNext())) {
          $injector = angular.element(ngXpath.ownerElement).injector();
        }
      }
    } catch (e) {
      handleError(e);
    }
  }
  return $injector;
};

/**
 * Note: since we don't want to be using timeouts to always check for angular when this module is imported, we export
 * a function which instantiates an effectively-singleton Promise when called.
 *
 * Note: window.angular && window.angular.element(document.body).injector() && window.angular is not a mistake
 */
const getAngularPromise = (module.exports.getAngularPromise = memoize((timeout) => {
  return pollFor(() => {
    const angular = window.angular;

    return angular && getInjector(angular) && angular;
  }, timeout || 100);
}));

module.exports.getAngularService = async (serviceName, timeout) => {
  try {
    const angular = await getAngularPromise(timeout);
    const $injector = getInjector(angular);
    return $injector.get(serviceName);
  } catch (e) {
    handleError(e);
  }
};

module.exports.ancestorWithClass = (el, className) => {
  while ((el = el.parentElement) && !elementHasClass(el, className));
  return el;
};

const elementHasClass = (module.exports.elementHasClass = (element, className) => {
  return (' ' + element.className + ' ').indexOf(' ' + className + ' ') >= 0;
});

module.exports.addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else if (!elementHasClass(el, className)) {
    el.className += ' ' + className;
  }
};

module.exports.removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else if (elementHasClass(el, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * This function allow you to modify a JS Promise by adding some status properties.
 * Based on: http://stackoverflow.com/questions/21485545/is-there-a-way-to-tell-if-an-es6-promise-is-fulfilled-rejected-resolved
 * But modified according to the specs of promises : https://promisesaplus.com/
 */
module.exports.makeTrackable = (promise) => {
  // Don't modify any promise that has been already modified.
  if (promise.isFulfilled) return promise;

  // Set initial state
  let isPending = true;
  let isRejected = false;
  let isFulfilled = false;

  // Observe the promise, saving the fulfillment in a closure scope.
  const result = promise.then(
    function (v) {
      isFulfilled = true;
      isPending = false;
      return v;
    },
    function (e) {
      isRejected = true;
      isPending = false;
      handleError(e);
    }
  );

  result.isFulfilled = function () {
    return isFulfilled;
  };
  result.isPending = function () {
    return isPending;
  };
  result.isRejected = function () {
    return isRejected;
  };
  return result;
};

module.exports.hashString = (str) => {
  let hash = 0;
  if (str) {
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; 
    }
  }
  return hash;
}

/**
 * Converts a string array into map of string key to boolean
 */
module.exports.toSet = (stringArray) => {
  return stringArray.reduce((map, val) => {
    map[val] = true;
    return map;
  }, {});
};

/**
 * A promise that resolves when the document is ready. It first checks if document status is ready and waits for
 * DOMContentLoaded event if it isn't.
 */
// eslint-disable-next-line  no-unused-vars
const domReadyPromise = (module.exports.domReadyPromise = new Promise(function (resolve) {
  if (document.readyState == 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        resolve(document);
      },
      false
    );
  } else {
    // document is already ready
    resolve(document);
  }
}));

// eslint-disable-next-line  no-unused-vars
const getUrlVars = (module.exports.getUrlVars = memoize(function (url) {
  return parseUri(url || window.location).queryKey;
}));

// eslint-disable-next-line  no-unused-vars
const isMobile = (module.exports.isMobile = memoize(function () {
  let check = false;
  (function (a) {
    // eslint-disable-next-line  max-len
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    ) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}));

module.exports.inIframe = memoize(function () {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
});

module.exports.timeout = async (millis) => {
  return new Promise((r) => setTimeout(r, millis));
};

const asyncExceptionBoundaryWrapper = function (defaultHandler) {
  return function (f, handler) {
    if (f.constructor.name != 'AsyncFunction') {
      return function (...args) {
        try {
          return f.apply(this, args);
        } catch (e) {
          (handler || defaultHandler).bind(this)(e);
        }
      };
    }

    return async function (...args) {
      try {
        return await f.apply(this, args);
      } catch (e) {
        return await (handler || defaultHandler).bind(this)(e);
      }
    };
  };
};

// you can just await a regular function!
module.exports.exceptionBoundaryWrapperFactory = asyncExceptionBoundaryWrapper;

module.exports.asyncExceptionBoundaryWrapperFactory = asyncExceptionBoundaryWrapper;

const ignoreOnProd = (e) => {
  if (Config.env != 'production') {
    // log just in case the surrounding code doesnt
    if (!(e instanceof Error)) {
      e = new Error(e);
    }
    console.error(e);
    throw e;
  }
};

const rethrow = function (e) {
  if (!(e instanceof Error)) {
    e = new Error(e);
  }
  // log just in case the surrounding code doesnt
  //console.error(e);
  throw e;
};
let PEAR_ERROR_HANDLER = rethrow;

const handleError = (module.exports.handleError = (e) => {
  // eslint-disable-next-line new-cap
  PEAR_ERROR_HANDLER(e);
});

const tryCatch = (module.exports.tryCatch = asyncExceptionBoundaryWrapper(handleError));

module.exports.setErrorHandler = (handler) => {
  PEAR_ERROR_HANDLER = handler;
};

module.exports.rethrowErrors = () => {
  PEAR_ERROR_HANDLER = rethrow;
};

module.exports.ignoreProdErrors = () => {
  PEAR_ERROR_HANDLER = ignoreOnProd;
};

const nop = (module.exports.nop = (_) => null);

const jsonParseQuietly = (module.exports.JSONParseQuietly = tryCatch(JSON.parse, nop));
module.exports.JSONStringifyQuietly = tryCatch(JSON.stringify, nop);

function toJSON(node) {
  const propFix = { for: 'htmlFor', class: 'className' };
  const specialGetters = {
    style: (node) => node && node.style && node.style.cssText,
  };
  const attrDefaultValues = { style: '' };
  const obj = {
    nodeType: node.nodeType,
  };
  if (node.tagName) {
    obj.tagName = node.tagName.toLowerCase();
  } else if (node.nodeName) {
    obj.nodeName = node.nodeName;
  }
  if (node.nodeValue) {
    obj.nodeValue = node.nodeValue;
  }
  const attrs = node.attributes;
  if (attrs) {
    const defaultValues = new Map();
    for (let i = 0; i < attrs.length; i++) {
      const name = attrs[i].nodeName;
      defaultValues.set(name, attrDefaultValues[name]);
    }
    // Add some special cases that might not be included by enumerating
    // attributes above. Note: this list is probably not exhaustive.
    switch (obj.tagName) {
      case 'input': {
        if (node.type === 'checkbox' || node.type === 'radio') {
          defaultValues.set('checked', false);
        } else if (node.type !== 'file') {
          // Don't store the value for a file input.
          defaultValues.set('value', '');
        }
        break;
      }
      case 'option': {
        defaultValues.set('selected', false);
        break;
      }
      case 'textarea': {
        defaultValues.set('value', '');
        break;
      }
    }
    const arr = [];
    for (const [name, defaultValue] of defaultValues) {
      const propName = propFix[name] || name;
      const specialGetter = specialGetters[propName];
      const value = specialGetter ? specialGetter(node) : node[propName];
      if (value !== defaultValue) {
        arr.push([name, value]);
      }
    }
    if (arr.length) {
      obj.attributes = arr;
    }
  }
  const childNodes = node.childNodes;
  // Don't process children for a textarea since we used `value` above.
  if (obj.tagName !== 'textarea' && childNodes && childNodes.length) {
    const arr = (obj.childNodes = []);
    for (let i = 0; i < childNodes.length; i++) {
      arr[i] = toJSON(childNodes[i]);
    }
  }
  return obj;
}

module.exports.elementFromHtml = function elementFromHtml(html) {
  var div = document.createElement('div');
  div.innerHTML = html.trim();

  return div.firstChild;
};

module.exports.nodeToDom = function nodeToDom(input) {
  const obj = typeof input === 'string' ? JSON.parse(input) : input;
  const propFix = { for: 'htmlFor', class: 'className' };
  let node;
  const nodeType = obj.nodeType;
  switch (nodeType) {
    // ELEMENT_NODE
    case 1: {
      node = document.createElement(obj.tagName);
      if (obj.attributes) {
        for (const [attrName, value] of obj.attributes) {
          const propName = propFix[attrName] || attrName;
          // Note: this will throw if setting the value of an input[type=file]
          node[propName] = value;
        }
      }
      break;
    }
    // TEXT_NODE
    case 3: {
      return document.createTextNode(obj.nodeValue);
    }
    // COMMENT_NODE
    case 8: {
      return document.createComment(obj.nodeValue);
    }
    // DOCUMENT_FRAGMENT_NODE
    case 11: {
      node = document.createDocumentFragment();
      break;
    }
    default: {
      // Default to an empty fragment node.
      return document.createDocumentFragment();
    }
  }
  if (obj.childNodes && obj.childNodes.length) {
    for (const childNode of obj.childNodes) {
      node.appendChild(toDOM(childNode));
    }
  }
  return node;
};

module.exports.zip = function zip(arrays) {
  // eslint-disable-next-line prefer-spread
  return Array.apply(null, Array(arrays[0].length)).map(function (_, i) {
    return arrays.map(function (array) {
      return array[i];
    });
  });
};

let cookiePolicyConfig = {
  onetrust: {
    gmi: {
      analytics: 'C0002',
      functional: 'C0003',
      targeting: 'C0004'
    },
    'allow-all': {
      analytics: 'C0002', 
      functional: 'C0003',
      targeting: 'C0004'
    }
  },
  trustarc: {
    molsoncoors: {
      analytics: '2',
      functional: '2',
      targeting: '3',
    },
    standard: {
      analytics: '2',
      functional: '2',
      targeting: '3',
    },
  },
};
module.exports.getCookie = function (name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
};

module.exports.getCookiePolicy = function (cookieManager, cookiePolicy) {
  if (cookieManager == 'onetrust') {
    let policy = cookiePolicyConfig.onetrust[cookiePolicy];
    if (policy) {
      let cookie = module.exports.getCookie('OptanonConsent');
      if (!cookie) {
        //In us we default to true for everything.
        return {
          analytics: true,
          functional: true,
          targeting: true,
        };
      } else {
        let groups = decodeURIComponent(cookie.split('groups=')[1].split('&')[0]).split(',');
        
        // Special handling for allow-all single toggle
        if (cookiePolicy === 'allow-all') {
          const group = groups.find(g => g.split(':')[0] === policy.analytics);
          const isEnabled = group ? group.split(':')[1] === '1' : false;
          return {
            analytics: isEnabled,
            functional: isEnabled,
            targeting: isEnabled
          };
        }

        let ret = {};
        let keys = ['analytics', 'functional', 'targeting'];
        for (let i = 0; i < keys.length; i++) {
          let targetGroupName = policy[keys[i]];
          for (let j = 0; j < groups.length; j++) {
            let groupName = groups[j].split(':')[0];
            if (targetGroupName == groupName) {
              ret[keys[i]] = groups[j].split(':')[1] == '1';
              break;
            }
          }
        }

        return ret;
      }
    }
  } else if (cookieManager == 'trustarc') {
    let policy = cookiePolicyConfig.trustarc[cookiePolicy];
    if (policy) {
      let cookie = module.exports.getCookie('cmapi_cookie_privacy');
      if (!cookie) {
        //In us we default to true for everything.
        return {
          analytics: true,
          functional: true,
          targeting: true,
        };
      } else {
        let groups = cookie.split('permit ')[1].split(" ")[0].split(',');

        let ret = {};
        let keys = ['analytics', 'functional', 'targeting'];
        for (let i = 0; i < keys.length; i++) {
          let targetGroupName = policy[keys[i]];
          for (let j = 0; j < groups.length; j++) {
            let groupName = groups[j];
            if (targetGroupName == groupName) {
              ret[keys[i]] = true;
              break;
            }
          }
        }

        return ret;
      }
    }
  }
  return null;
};

module.exports.syncCookieManager = function (cookieManager, cookiePolicy, pymIframe) {
  function getOneTrustConsent() {
    try {
      let activeGroups = '';

      // First try to get OneTrust from parent if we're in an iframe
      if (window !== window.top) {
        try {
          activeGroups = window.parent.OnetrustActiveGroups || '';
        } catch (e) {
          console.log('Could not access parent OneTrust, using iframe OneTrust');
          activeGroups = window.OnetrustActiveGroups || '';
        }
      } else {
        activeGroups = window.OnetrustActiveGroups || '';
      }

      if (!activeGroups) {
        return null;
      }
      
      // Check for specific group IDs
      const groups = activeGroups.split(',').map(g => g.trim());
      
      return {
        analytics: groups.includes('C0002'),
        functional: groups.includes('C0003'),
        targeting: groups.includes('C0004')
      };
    } catch (e) {
      console.error('Error checking OneTrust consent:', e);
      return null;
    }
  }

  let oldPolicy = module.exports.getCookiePolicy(cookieManager, cookiePolicy);
  let storedPolicy = storage.local.getItem('pear-privacy-v2');
  try {
    storedPolicy = JSON.parse(storedPolicy);
  } catch (e) {
    storedPolicy = null;
  }
  
  function hasPolicyChanged(newPolicy, comparePolicy) {
    return newPolicy.analytics !== comparePolicy.analytics ||
           newPolicy.functional !== comparePolicy.functional ||
           newPolicy.targeting !== comparePolicy.targeting;
  }

  // Helper function to handle policy updates
  function handlePolicyUpdate(newPolicy) {
    if (!newPolicy) return;
    
    oldPolicy = oldPolicy || {};
    if (hasPolicyChanged(newPolicy, oldPolicy)) {
      oldPolicy = newPolicy;
      if (pymIframe) {
        pymIframe.sendMessage('cookie-policy', JSON.stringify(newPolicy));
      } else {
        const shouldReload = !storedPolicy || hasPolicyChanged(newPolicy, storedPolicy);
        storage.local.setItem('pear-privacy-v2', JSON.stringify(newPolicy));
        
        if (shouldReload) {
          console.log('Policy changed, reloading...');
          window.location.reload();
        } else {
          console.log('Policy unchanged, skipping reload');
        }
      }
    }
  }

  function setupOneTrustListener() {
    console.log('Setting up OneTrust listener');
    
    const onConsentChanged = function() {
      console.log('OneTrust consent changed!');
      const newPolicy = getOneTrustConsent();
      console.log('New consent policy:', newPolicy);
      handlePolicyUpdate(newPolicy);
    };

    // Try to set up listener in parent window if we're in an iframe
    if (window !== window.top) {
      try {
        if (window.parent.OneTrust) {
          console.log('Setting up OneTrust listener in parent');
          window.parent.OneTrust.OnConsentChanged(onConsentChanged);
          return; // Exit if we successfully set up parent listener
        }
      } catch (e) {
        console.log('Could not set up parent OneTrust listener:', e);
      }
    }

    // Fall back to iframe's OneTrust if parent isn't available
    if (window.OneTrust) {
      console.log('Setting up OneTrust listener in iframe');
      window.OneTrust.OnConsentChanged(onConsentChanged);
    }
  }

  // Set up polling for non-OneTrust cookie managers
  if (cookieManager !== 'onetrust') {
    setInterval(function () {
      let newPolicy = module.exports.getCookiePolicy(cookieManager, cookiePolicy);
      handlePolicyUpdate(newPolicy);
    }, 100);
  }

  if (window.OneTrust || (window !== window.top && window.parent.OneTrust)) {
    setupOneTrustListener();
  }

  window.addEventListener('OneTrustGroupsUpdated', function() {
    setupOneTrustListener();
  });
};

module.exports.deleteCookie = function delete_cookie(name, path, domain) {
  document.cookie =
    name +
    '=' +
    (path ? ';path=' + path : '') +
    (domain ? ';domain=' + domain : '') +
    ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
};

module.exports.fetchWithTimeoutAndFallback = async function() {
  try {
    if (!arguments[1]) {
      arguments[1] = {};
    }
    let ret = await fetch.apply(null, arguments);
    if (ret.status != 200) {
      throw new Error("non 200");
    }
    return ret;
  } catch (e) {
    let url = arguments[0];
    let path = url.split("v1/")[1].split("?")[0];
    let params = {};
    if (url.indexOf("?") > -1) {
      const urlParams = new URLSearchParams(url.split("?")[1]);
      params = Object.fromEntries(urlParams);
    }

    let paramsList = [];
    for (const [key, value] of Object.entries(params)) {
      if (key != "_nocache" && key != "timeout" && (url.indexOf("/v1/loaded") < 0 || key == 'vendorId')) {
        paramsList.push([key, value]);
      }
    }


    paramsList.sort(function (a,b) {
      return a[0].localeCompare(b[0]);
    });

    let fallbackUrl = "https://assets.pearcommerce.com/" + path;
    if (paramsList.length > 0) {
      fallbackUrl += "/";
    }
    for (let i = 0; i < paramsList.length; i++) {
      fallbackUrl += encodeURIComponent(paramsList[i][0]) + "/" + encodeURIComponent(paramsList[i][1]);
      if (i != paramsList.length - 1) {
        fallbackUrl += "/";
      }
    }
    fallbackUrl += "?" + new Date().getTime();
    arguments[0] = fallbackUrl;
    try {
      let ret = await fetch.apply(null, arguments);
      if (ret.status != 200) {
        throw new Error("non 200");
      }
      return ret;
    } catch (e) {
      return {json : function() {
          return null;
        }};
    }
  }

}

module.exports.patchImageUrl = function(imageUrl) {
  if (!imageUrl) {
     return imageUrl;
  }
  
  try {
    const { host, hash, pathname, search } = new URL(imageUrl);
    const pathWithQuery = `${pathname}${search}${hash}`;
    
    const urlMappings = {
      'demos.pearcommerce.com': 'demos-cf-1.pearcommerce.com',
      'assets.pearcommerce.com': 'assets-cf.pearcommerce.com'
    };
    
    if (host in urlMappings) {
       return `https://${urlMappings[host]}${pathWithQuery}`;
    }
  } catch (error) {
    console.error('Error when patching images:', error);
  }
  
  return imageUrl;
}
},{"./config.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/config.js","./debounce":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/debounce.js","./parseuri.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/parseuri.js","./pear-console.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/pear-console.js","./storage.js":"/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/storage.js"}]},{},["/home/runner/work/offers.pearcommerce.com/offers.pearcommerce.com/static/js/offers/index.js"]);
